var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a2, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a2, prop, b[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b) => __defProps(a2, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var step = (x2) => x2.done ? resolve(x2.value) : Promise.resolve(x2.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import * as React from "react";
import React__default, { useEffect, useState, useCallback, forwardRef, useContext, useRef, createContext, useLayoutEffect, useInsertionEffect as useInsertionEffect$1, useMemo, createElement, useId as useId$1, memo as memo$2, Component, Fragment as Fragment$1 } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default from "react-dom";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var f = n2.default;
  if (typeof f == "function") {
    var a2 = function a3() {
      if (this instanceof a3) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a2.prototype = f.prototype;
  } else
    a2 = {};
  Object.defineProperty(a2, "__esModule", {
    value: true
  });
  Object.keys(n2).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n2, k);
    Object.defineProperty(a2, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n2[k];
      }
    });
  });
  return a2;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React__default, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n2 = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c2, a2, g) {
    var b, d = {}, e2 = null, h = null;
    void 0 !== g && (e2 = "" + g);
    void 0 !== a2.key && (e2 = "" + a2.key);
    void 0 !== a2.ref && (h = a2.ref);
    for (b in a2)
      m.call(a2, b) && !p.hasOwnProperty(b) && (d[b] = a2[b]);
    if (c2 && c2.defaultProps)
      for (b in a2 = c2.defaultProps, a2)
        void 0 === d[b] && (d[b] = a2[b]);
    return { $$typeof: k, type: c2, key: e2, ref: h, props: d, _owner: n2.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development)
    return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React2 = React__default;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName2(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName2(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init2 = lazyComponent._init;
              try {
                return getComponentNameFromType(init2(payload));
              } catch (x2) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign2 = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign2({}, props, {
                value: prevLog
              }),
              info: assign2({}, props, {
                value: prevInfo
              }),
              warn: assign2({}, props, {
                value: prevWarn
              }),
              error: assign2({}, props, {
                value: prevError
              }),
              group: assign2({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign2({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign2({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix2;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix2 === void 0) {
            try {
              throw Error();
            } catch (x2) {
              var match2 = x2.stack.trim().match(/\n( *(at )?)/);
              prefix2 = match2 && match2[1] || "";
            }
          }
          return "\n" + prefix2 + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn2, construct) {
        if (!fn2 || reentry) {
          return "";
        }
        {
          var frame2 = componentFrameCache.get(fn2);
          if (frame2 !== void 0) {
            return frame2;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x2) {
                control = x2;
              }
              Reflect.construct(fn2, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x2) {
                control = x2;
              }
              fn2.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x2) {
              control = x2;
            }
            fn2();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s2 = sampleLines.length - 1;
            var c2 = controlLines.length - 1;
            while (s2 >= 1 && c2 >= 0 && sampleLines[s2] !== controlLines[c2]) {
              c2--;
            }
            for (; s2 >= 1 && c2 >= 0; s2--, c2--) {
              if (sampleLines[s2] !== controlLines[c2]) {
                if (s2 !== 1 || c2 !== 1) {
                  do {
                    s2--;
                    c2--;
                    if (c2 < 0 || sampleLines[s2] !== controlLines[c2]) {
                      var _frame = "\n" + sampleLines[s2].replace(" at new ", " at ");
                      if (fn2.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn2.displayName);
                      }
                      {
                        if (typeof fn2 === "function") {
                          componentFrameCache.set(fn2, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s2 >= 1 && c2 >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name = fn2 ? fn2.displayName || fn2.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn2 === "function") {
            componentFrameCache.set(fn2, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn2, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn2, false);
        }
      }
      function shouldConstruct(Component2) {
        var prototype = Component2.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init2 = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init2(payload), source, ownerFn);
              } catch (x2) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty2 = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values2, location, componentName, element) {
        {
          var has2 = Function.call.bind(hasOwnProperty2);
          for (var typeSpecName in typeSpecs) {
            if (has2(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray(a2) {
        return isArrayImpl(a2);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e2) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }
      function hasValidRef(config2) {
        {
          if (hasOwnProperty2.call(config2, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config2, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config2.ref !== void 0;
      }
      function hasValidKey(config2) {
        {
          if (hasOwnProperty2.call(config2, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config2.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config2, self2) {
        {
          if (typeof config2.ref === "string" && ReactCurrentOwner.current && self2 && ReactCurrentOwner.current.stateNode !== self2) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config2.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self2, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self2
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config2, maybeKey, source, self2) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config2)) {
            {
              checkKeyStringCoercion(config2.key);
            }
            key = "" + config2.key;
          }
          if (hasValidRef(config2)) {
            ref = config2.ref;
            warnIfStringRefCannotBeAutoConverted(config2, self2);
          }
          for (propName in config2) {
            if (hasOwnProperty2.call(config2, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config2[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self2, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== void 0) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
          }
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node2, parentType) {
        {
          if (typeof node2 !== "object") {
            return;
          }
          if (isArray(node2)) {
            for (var i = 0; i < node2.length; i++) {
              var child = node2[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node2)) {
            if (node2._store) {
              node2._store.validated = true;
            }
          } else if (node2) {
            var iteratorFn = getIteratorFn(node2);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node2.entries) {
                var iterator = iteratorFn.call(node2);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes2;
          if (typeof type === "function") {
            propTypes2 = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes2 = type.propTypes;
          } else {
            return;
          }
          if (propTypes2) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes2, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      var didWarnAboutKeySpread = {};
      function jsxWithValidation(type, props, key, isStaticChildren, source, self2) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self2);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          {
            if (hasOwnProperty2.call(props, "key")) {
              var componentName = getComponentNameFromType(type);
              var keys = Object.keys(props).filter(function(k) {
                return k !== "key";
              });
              var beforeExample = keys.length > 0 ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
              if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? "{" + keys.join(": ..., ") + ": ...}" : "{}";
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx2 = jsxWithValidationDynamic;
      var jsxs2 = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx2;
      reactJsxRuntime_development.jsxs = jsxs2;
    })();
  }
  return reactJsxRuntime_development;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
const Fragment = jsxRuntimeExports.Fragment;
const jsx = jsxRuntimeExports.jsx;
const jsxs = jsxRuntimeExports.jsxs;
const useComponentValidation = ({
  props,
  schema
}) => {
  useEffect(() => {
    if (window.location.origin.includes("localhost")) {
      try {
        schema.parse(props);
      } catch (e2) {
        console.error(e2);
      }
    }
  }, []);
};
const useMutation = ({
  onError,
  onSuccess,
  queryFn
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const fetchData = useCallback(() => __async(void 0, null, function* () {
    try {
      setIsError(false);
      setIsLoading(true);
      setIsSuccess(false);
      const data = yield queryFn();
      setIsLoading(false);
      setIsSuccess(true);
      onSuccess == null ? void 0 : onSuccess(data);
      return data;
    } catch (e2) {
      setIsError(true);
      setIsLoading(false);
      setIsSuccess(false);
      onError == null ? void 0 : onError();
    }
  }), [onError, onSuccess]);
  return {
    isError,
    isSuccess,
    isLoading,
    mutate: fetchData
  };
};
const useQuery = ({
  queryFn,
  isEnabled = true,
  onError,
  queryKey
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [data, setData] = useState();
  const fetchData = useCallback(() => __async(void 0, null, function* () {
    try {
      setIsLoading(true);
      const data2 = yield queryFn();
      setIsLoading(false);
      setData(data2);
    } catch (e2) {
      setIsError(true);
      setIsLoading(false);
      onError == null ? void 0 : onError();
    }
  }), [onError, queryKey]);
  const refetch = useCallback(() => {
    isEnabled && fetchData();
  }, [isEnabled, fetchData]);
  useEffect(() => {
    refetch();
  }, [isEnabled, queryKey, refetch]);
  return {
    isError,
    isLoading,
    data,
    refetch
  };
};
function t(t2) {
  var e2 = /* @__PURE__ */ Object.create(null);
  return t2 && Object.keys(t2).forEach(function(i) {
    if ("default" !== i) {
      var n2 = Object.getOwnPropertyDescriptor(t2, i);
      Object.defineProperty(e2, i, n2.get ? n2 : { enumerable: true, get: function() {
        return t2[i];
      } });
    }
  }), e2.default = t2, Object.freeze(e2);
}
var e = t(React__default), i$1 = function(t2, e2) {
  return i$1 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t3, e3) {
    t3.__proto__ = e3;
  } || function(t3, e3) {
    for (var i in e3)
      Object.prototype.hasOwnProperty.call(e3, i) && (t3[i] = e3[i]);
  }, i$1(t2, e2);
};
var n = function() {
  return n = Object.assign || function(t2) {
    for (var e2, i = 1, n2 = arguments.length; i < n2; i++)
      for (var o2 in e2 = arguments[i])
        Object.prototype.hasOwnProperty.call(e2, o2) && (t2[o2] = e2[o2]);
    return t2;
  }, n.apply(this, arguments);
};
function o(t2) {
  return t2.endsWith("-v2") ? 2 : 1;
}
"function" == typeof SuppressedError && SuppressedError;
var r$1 = function() {
  function t2(t3, e2, i, n2) {
    var o2 = this;
    this.iframe = null, this.iframeId = null, this.sessionId = "", this.$container = null, this.initialized = false, this.onMessage = function(t4) {
      o2.onSdkMessage(t4);
    }, this.baseUrl = t3 || this.getCurrentBaseUrl("https://api.sumsub.com", e2.accessToken), this.config = e2, this.config.packageVersion = this.getVersion(), this.callbacks = i, this.options = n2;
  }
  return t2.prototype.getVersion = function() {
    return "[VI]{version}[/VI]";
  }, t2.prototype.getCurrentBaseUrl = function(t3, e2) {
    var i = ["_act-sbx-jwt-", "_act-jwt-"].find(function(t4) {
      return e2.startsWith(t4);
    });
    if (i)
      for (var n2 = 0, o2 = e2.replace(i, "").replace("-v2", "").split(".").map(function(t4) {
        try {
          return atob(t4);
        } catch (e3) {
          return t4;
        }
      }).map(function(t4) {
        try {
          return JSON.parse(t4);
        } catch (e3) {
          return t4;
        }
      }); n2 < o2.length; n2++) {
        var r2 = o2[n2];
        if (null == r2 ? void 0 : r2.url)
          return r2.url;
      }
    return t3;
  }, t2.prototype.getIframeId = function() {
    if (2 === this.config.version)
      try {
        return btoa(this.config.accessToken);
      } catch (t3) {
        return this.config.accessToken;
      }
    return String(Math.floor(1e8 * Math.random()));
  }, t2.prototype.launch = function(t3) {
    this.options.addViewportTag && this.addViewportTag(), this.iframe = this.createIframe(t3), this.sessionId = "", this.iframeId = "id_" + this.getIframeId(), this.iframe && this.config ? (this.registerEventListener(), this.iframe.src = this.getIframeSrc()) : console.error("Idensic was not initialized since either provided element was not found in the DOM or invalid config");
  }, t2.prototype.addViewportTag = function() {
    var t3 = document.getElementsByName("viewport");
    if (!t3 || 0 === t3.length) {
      var e2 = document.createElement("meta");
      e2.setAttribute("name", "viewport"), e2.setAttribute("content", "width=device-width,user-scalable=yes"), document.head.appendChild(e2);
    }
  }, t2.prototype.createIframe = function(t3) {
    var e2 = "string" == typeof t3 ? document.querySelector(t3) : t3;
    if (!e2)
      return console.error("Provide a valid selector for the iframe container"), null;
    this.$container = e2;
    var i = document.createElement("iframe");
    for (i.width = "100%", i.scrolling = "no", i.allow = "camera; microphone; geolocation; clipboard-write", i.setAttribute("frameborder", "0"); e2.firstChild; )
      e2.removeChild(e2.firstChild);
    return e2.appendChild(i), i;
  }, t2.prototype.getIframeSrc = function() {
    var t3 = "?_=" + this.iframeId, e2 = 2 === this.config.version ? "/websdk" : "/idensic", i = this.baseUrl + e2 + "/websdk.html";
    return 2 === this.config.version && this.config.theme && (t3 += "&theme=" + this.config.theme), 2 === this.config.version && this.config.customizationName && (t3 += "&customizationName=" + encodeURIComponent(this.config.customizationName)), i + t3;
  }, t2.prototype.registerEventListener = function() {
    window.addEventListener("message", this.onMessage);
  }, t2.prototype.onSdkMessage = function(t3) {
    var e2;
    if (this.baseUrl === t3.origin) {
      var i = t3.data;
      if (i.method && ~i.method.indexOf("idCheck") && (!this.sessionId || this.sessionId === i.sessionId) && (null === (e2 = this.iframe) || void 0 === e2 ? void 0 : e2.contentWindow)) {
        if ("idCheck.onReady" == i.method && i.frameId === this.iframeId) {
          this.sessionId = i.sessionId;
          var o2 = { options: { adaptIframeHeight: this.options.adaptIframeHeight } };
          this.iframe.contentWindow.postMessage(n(n({ method: "idCheck.init" }, this.config), o2), "*");
        }
        if ("idCheck.onInitialized" == i.method && (this.initialized = true), "idCheck.onResize" == i.method && this.options.adaptIframeHeight && (this.iframe.style.height = i.height + "px"), "idCheck.scrollTo" == i.method && this.options.adaptIframeHeight)
          this.scrollTo(i.top);
        else {
          var r2 = i.method;
          delete i.method, delete i.frameId, delete i.sessionId, "idCheck.onError" === r2 && "invalid-token" === i.code ? this.callExpirationHandler() : "idCheck.onError" === r2 && "function" == typeof this.callbacks.onError ? this.callbacks.onError(i) : "function" == typeof this.callbacks.onMessage && this.callbacks.onMessage(r2, i);
        }
      }
    }
  }, t2.prototype.callExpirationHandler = function() {
    var t3 = this, e2 = this.callbacks.expirationHandler;
    e2.legacy ? e2.handler(function(e3) {
      return t3.updateAccessTokenOrReinitialize(e3);
    }) : e2.handler().then(function(e3) {
      return t3.updateAccessTokenOrReinitialize(e3);
    }, function(e3) {
      null != e3 || (e3 = "Failed to update access token"), e3.message && (e3 = e3.message), "string" != typeof e3 && (e3 = String(e3)), t3.updateAccessToken(null, e3);
    });
  }, t2.prototype.updateAccessTokenOrReinitialize = function(t3) {
    var e2 = o(t3);
    if (this.iframe && !this.initialized && this.config.version != e2)
      return this.sessionId = "", this.config.accessToken = t3, this.config.version = e2, this.baseUrl = this.getCurrentBaseUrl(this.baseUrl, t3), this.iframeId = "id_" + this.getIframeId(), void (this.iframe.src = this.getIframeSrc());
    this.updateAccessToken(t3);
  }, t2.prototype.scrollTo = function(t3) {
    for (var e2, i, n2 = null === (e2 = this.iframe) || void 0 === e2 ? void 0 : e2.parentElement; 0 === (null == n2 ? void 0 : n2.scrollTop) && "BODY" !== (null == n2 ? void 0 : n2.tagName); )
      n2 = null == n2 ? void 0 : n2.parentElement;
    if (0 === (null == n2 ? void 0 : n2.scrollTop) && "BODY" === (null == n2 ? void 0 : n2.tagName)) {
      var o2 = (null === (i = this.iframe) || void 0 === i ? void 0 : i.getBoundingClientRect().top) || 0;
      window.scrollTo({ top: o2 + t3, behavior: "smooth" });
    } else
      null == n2 || n2.scrollTo({ top: t3, behavior: "smooth" });
  }, t2.prototype.updateAccessToken = function(t3, e2) {
    var i, n2;
    null === (n2 = null === (i = this.iframe) || void 0 === i ? void 0 : i.contentWindow) || void 0 === n2 || n2.postMessage({ method: "idCheck.updateAccessToken", accessToken: t3, error: e2 }, "*");
  }, t2.prototype.destroy = function() {
    for (window.removeEventListener("message", this.onMessage); this.$container && this.$container.firstChild; )
      this.$container.removeChild(this.$container.firstChild);
    this.$container = null;
  }, t2.prototype.navigateBack = function() {
    var t3, e2;
    null === (e2 = null === (t3 = this.iframe) || void 0 === t3 ? void 0 : t3.contentWindow) || void 0 === e2 || e2.postMessage({ method: "idCheck.callNavigationBack" }, "*");
  }, t2;
}(), s = function() {
  function t2(t3, e2) {
    if (this.config = null, this.reusableConfig = null, this.eventHandlers = {}, this.anyEventHandler = null, this.options = { adaptIframeHeight: true, addViewportTag: true }, "string" != typeof t3)
      throw new Error("Access token must be a string");
    if ("function" != typeof e2)
      throw new Error("updateAccessToken callback is required");
    this.accessToken = t3, this.updateAccessToken = e2;
  }
  return t2.prototype.onTestEnv = function() {
    return this;
  }, t2.prototype.withBaseUrl = function(t3) {
    return this.baseUrl = t3, this;
  }, t2.prototype.withConf = function(t3) {
    return this.config = t3, this;
  }, t2.prototype.withReusableKycConf = function(t3) {
    return this.reusableConfig = t3, this;
  }, t2.prototype.withOptions = function(t3) {
    return t3.hasOwnProperty("adaptIframeHeight") && (this.options.adaptIframeHeight = t3.adaptIframeHeight), t3.hasOwnProperty("addViewportTag") && (this.options.addViewportTag = t3.addViewportTag), this;
  }, t2.prototype.on = function(t3, e2) {
    return this.eventHandlers[t3] = e2, this;
  }, t2.prototype.onMessage = function(t3) {
    return this.anyEventHandler = t3, this;
  }, t2.prototype.onNavigationUiControlsStateChanged = function(t3) {
    return this.eventHandlers["idCheck.onNavigationUiControlsStateChanged"] = t3, this;
  }, t2.prototype.build = function() {
    var t3, e2, i, n2, s2, a2, c2, l, d, h, u, f, p = this, g = o(this.accessToken);
    return new r$1(this.baseUrl, { version: g, theme: null === (t3 = this.config) || void 0 === t3 ? void 0 : t3.theme, customizationName: null === (e2 = this.config) || void 0 === e2 ? void 0 : e2.customizationName, accessToken: this.accessToken, lang: null === (i = this.config) || void 0 === i ? void 0 : i.lang, email: null === (n2 = this.config) || void 0 === n2 ? void 0 : n2.email, phone: null === (s2 = this.config) || void 0 === s2 ? void 0 : s2.phone, country: null === (a2 = this.config) || void 0 === a2 ? void 0 : a2.country, uiConf: null === (c2 = this.config) || void 0 === c2 ? void 0 : c2.uiConf, i18n: null === (l = this.config) || void 0 === l ? void 0 : l.i18n, documentsByCountries: null === (d = this.config) || void 0 === d ? void 0 : d.documentsByCountries, documentDefinitions: null === (h = this.config) || void 0 === h ? void 0 : h.documentDefinitions, autoSelectDocumentDefinitions: null === (u = this.config) || void 0 === u ? void 0 : u.autoSelectDocumentDefinitions, controlledNavigationBack: null === (f = this.config) || void 0 === f ? void 0 : f.controlledNavigationBack, reusableConfig: this.reusableConfig }, { expirationHandler: { legacy: false, handler: this.updateAccessToken }, onMessage: function(t4, e3) {
      var i2, n3 = p.eventHandlers[t4];
      n3 ? n3(e3) : null === (i2 = p.anyEventHandler) || void 0 === i2 || i2.call(p, t4, e3);
    } }, this.options);
  }, t2;
}(), a = function(t2, e2) {
  return new s(t2, e2);
}, c = function(t2) {
  function n2(i) {
    var n3 = t2.call(this, i) || this;
    return n3.div = e.createRef(), n3;
  }
  return function(t3, e2) {
    if ("function" != typeof e2 && null !== e2)
      throw new TypeError("Class extends value " + String(e2) + " is not a constructor or null");
    function n3() {
      this.constructor = t3;
    }
    i$1(t3, e2), t3.prototype = null === e2 ? Object.create(e2) : (n3.prototype = e2.prototype, new n3());
  }(n2, t2), n2.prototype.shouldComponentUpdate = function(t3) {
    return !!t3.force;
  }, n2.prototype.componentDidMount = function() {
    this.renderSDK();
  }, n2.prototype.renderSDK = function() {
    var t3 = function(t4) {
      var e3 = t4.expirationHandler, i = t4.accessToken, n3 = t4.config, o2 = void 0 === n3 ? null : n3, r2 = t4.options, s2 = void 0 === r2 ? null : r2, c2 = t4.onError, l = void 0 === c2 ? null : c2, d = t4.onMessage, h = void 0 === d ? null : d, u = t4.testEnv, f = void 0 !== u && u, p = t4.baseUrl, g = void 0 === p ? null : p, v = t4.onNavigationUiControlsStateChanged, m = void 0 === v ? null : v, y = t4.reusableKycConfig, b = void 0 === y ? null : y, w = a(i, e3);
      return o2 && w.withConf(o2), s2 && w.withOptions(s2), f && w.onTestEnv(), g && w.withBaseUrl(g), b && w.withReusableKycConf(b), l && w.on("idCheck.onError", l), h && w.onMessage(h), m && w.onNavigationUiControlsStateChanged(m), w;
    }(this.props), e2 = this.div.current;
    this.snsWebSdk = t3.build(), this.snsWebSdk.launch(e2);
  }, n2.prototype.navigateBack = function() {
    this.snsWebSdk && this.snsWebSdk.navigateBack();
  }, n2.prototype.render = function() {
    var t3 = this.props, i = t3.style, n3 = void 0 === i ? {} : i, o2 = t3.className, r2 = void 0 === o2 ? "" : o2;
    return e.createElement("div", { style: n3, className: r2, ref: this.div });
  }, n2;
}(e.Component);
var index_esm = c;
const SumsubWebSdk = /* @__PURE__ */ getDefaultExportFromCjs(index_esm);
/*! js-cookie v3.0.5 | MIT */
function assign$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
var defaultConverter = {
  read: function(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function init(converter, defaultAttributes) {
  function set(name, value, attributes) {
    if (typeof document === "undefined") {
      return;
    }
    attributes = assign$1({}, defaultAttributes, attributes);
    if (typeof attributes.expires === "number") {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = "";
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += "; " + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }
      stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
    }
    return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
  }
  function get(name) {
    if (typeof document === "undefined" || arguments.length && !name) {
      return;
    }
    var cookies = document.cookie ? document.cookie.split("; ") : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split("=");
      var value = parts.slice(1).join("=");
      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);
        if (name === found) {
          break;
        }
      } catch (e2) {
      }
    }
    return name ? jar[name] : jar;
  }
  return Object.create(
    {
      set,
      get,
      remove: function(name, attributes) {
        set(
          name,
          "",
          assign$1({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function(attributes) {
        return init(this.converter, assign$1({}, this.attributes, attributes));
      },
      withConverter: function(converter2) {
        return init(assign$1({}, this.converter, converter2), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  );
}
var api = init(defaultConverter, { path: "/" });
var util$2;
(function(util2) {
  util2.assertEqual = (val) => val;
  function assertIs(_arg) {
  }
  util2.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error();
  }
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item of items) {
      obj[item] = item;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
    const filtered = {};
    for (const k of validKeys) {
      filtered[k] = obj[k];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e2) {
      return obj[e2];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
    const keys = [];
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }
    return keys;
  };
  util2.find = (arr, checker) => {
    for (const item of arr) {
      if (checker(item))
        return item;
    }
    return void 0;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
  function joinValues(array, separator = " | ") {
    return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
  }
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_, value) => {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util$2 || (util$2 = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first, second) => {
    return __spreadValues(__spreadValues({}, first), second);
  };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util$2.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
const getParsedType = (data) => {
  const t2 = typeof data;
  switch (t2) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType.null;
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};
const ZodIssueCode = util$2.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
const quotelessJson = (obj) => {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  get errors() {
    return this.issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue) {
      return issue.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = (error) => {
      for (const issue of error.issues) {
        if (issue.code === "invalid_union") {
          issue.unionErrors.map(processError);
        } else if (issue.code === "invalid_return_type") {
          processError(issue.returnTypeError);
        } else if (issue.code === "invalid_arguments") {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i = 0;
          while (i < issue.path.length) {
            const el = issue.path[i];
            const terminal = i === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  static assert(value) {
    if (!(value instanceof ZodError)) {
      throw new Error(`Not a ZodError: ${value}`);
    }
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util$2.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
}
ZodError.create = (issues) => {
  const error = new ZodError(issues);
  return error;
};
const errorMap = (issue, _ctx) => {
  let message;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util$2.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message = `Unrecognized key(s) in object: ${util$2.joinValues(issue.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = `Invalid discriminator value. Expected ${util$2.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message = `Invalid enum value. Expected ${util$2.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === "number") {
            message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ("startsWith" in issue.validation) {
          message = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ("endsWith" in issue.validation) {
          message = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util$2.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message = `Invalid ${issue.validation}`;
      } else {
        message = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "bigint")
        message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message = "Number must be finite";
      break;
    default:
      message = _ctx.defaultError;
      util$2.assertNever(issue);
  }
  return { message };
};
let overrideErrorMap = errorMap;
function setErrorMap(map) {
  overrideErrorMap = map;
}
function getErrorMap() {
  return overrideErrorMap;
}
const makeIssue = (params) => {
  const { data, path, errorMaps, issueData } = params;
  const fullPath = [...path, ...issueData.path || []];
  const fullIssue = __spreadProps(__spreadValues({}, issueData), {
    path: fullPath
  });
  if (issueData.message !== void 0) {
    return __spreadProps(__spreadValues({}, issueData), {
      path: fullPath,
      message: issueData.message
    });
  }
  let errorMessage = "";
  const maps = errorMaps.filter((m) => !!m).slice().reverse();
  for (const map of maps) {
    errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
  }
  return __spreadProps(__spreadValues({}, issueData), {
    path: fullPath,
    message: errorMessage
  });
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  const overrideMap = getErrorMap();
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      ctx.schemaErrorMap,
      overrideMap,
      overrideMap === errorMap ? void 0 : errorMap
      // then global default map
    ].filter((x2) => !!x2)
  });
  ctx.common.issues.push(issue);
}
class ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s2 of results) {
      if (s2.status === "aborted")
        return INVALID;
      if (s2.status === "dirty")
        status.dirty();
      arrayValue.push(s2.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static mergeObjectAsync(status, pairs) {
    return __async(this, null, function* () {
      const syncPairs = [];
      for (const pair of pairs) {
        const key = yield pair.key;
        const value = yield pair.value;
        syncPairs.push({
          key,
          value
        });
      }
      return ParseStatus.mergeObjectSync(status, syncPairs);
    });
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key, value } = pair;
      if (key.status === "aborted")
        return INVALID;
      if (value.status === "aborted")
        return INVALID;
      if (key.status === "dirty")
        status.dirty();
      if (value.status === "dirty")
        status.dirty();
      if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key.value] = value.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
}
const INVALID = Object.freeze({
  status: "aborted"
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x2) => x2.status === "aborted";
const isDirty = (x2) => x2.status === "dirty";
const isValid = (x2) => x2.status === "valid";
const isAsync = (x2) => typeof Promise !== "undefined" && x2 instanceof Promise;
function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e2 = new Error(message);
  return e2.name = "SuppressedError", e2.error = error, e2.suppressed = suppressed, e2;
};
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
  errorUtil2.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));
var _ZodEnum_cache, _ZodNativeEnum_cache;
class ParseInputLazyPath {
  constructor(parent, value, path, key) {
    this._cachedPath = [];
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (this._key instanceof Array) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
}
const handleResult = (ctx, result) => {
  if (isValid(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error = new ZodError(ctx.common.issues);
        this._error = error;
        return this._error;
      }
    };
  }
};
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (errorMap2)
    return { errorMap: errorMap2, description };
  const customMap = (iss, ctx) => {
    var _a, _b;
    const { message } = params;
    if (iss.code === "invalid_enum_value") {
      return { message: message !== null && message !== void 0 ? message : ctx.defaultError };
    }
    if (typeof ctx.data === "undefined") {
      return { message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError };
    }
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    return { message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError };
  };
  return { errorMap: customMap, description };
}
class ZodType {
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data, params) {
    const result = this.safeParse(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  safeParse(data, params) {
    var _a;
    const ctx = {
      common: {
        issues: [],
        async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const result = this._parseSync({ data, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  parseAsync(data, params) {
    return __async(this, null, function* () {
      const result = yield this.safeParseAsync(data, params);
      if (result.success)
        return result.data;
      throw result.error;
    });
  }
  safeParseAsync(data, params) {
    return __async(this, null, function* () {
      const ctx = {
        common: {
          issues: [],
          contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
          async: true
        },
        path: (params === null || params === void 0 ? void 0 : params.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data,
        parsedType: getParsedType(data)
      };
      const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
      const result = yield isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult);
      return handleResult(ctx, result);
    });
  }
  refine(check, message) {
    const getIssueProperties = (val) => {
      if (typeof message === "string" || typeof message === "undefined") {
        return { message };
      } else if (typeof message === "function") {
        return message(val);
      } else {
        return message;
      }
    };
    return this._refinement((val, ctx) => {
      const result = check(val);
      const setError = () => ctx.addIssue(__spreadValues({
        code: ZodIssueCode.custom
      }, getIssueProperties(val)));
      if (typeof Promise !== "undefined" && result instanceof Promise) {
        return result.then((data) => {
          if (!data) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects(__spreadProps(__spreadValues({}, processCreateParams(this._def)), {
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform }
    }));
  }
  default(def) {
    const defaultValueFunc = typeof def === "function" ? def : () => def;
    return new ZodDefault(__spreadProps(__spreadValues({}, processCreateParams(this._def)), {
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    }));
  }
  brand() {
    return new ZodBranded(__spreadValues({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this
    }, processCreateParams(this._def)));
  }
  catch(def) {
    const catchValueFunc = typeof def === "function" ? def : () => def;
    return new ZodCatch(__spreadProps(__spreadValues({}, processCreateParams(this._def)), {
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    }));
  }
  describe(description) {
    const This = this.constructor;
    return new This(__spreadProps(__spreadValues({}, this._def), {
      description
    }));
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
  let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
  if (args.precision) {
    regex = `${regex}\\.\\d{${args.precision}}`;
  } else if (args.precision == null) {
    regex = `${regex}(\\.\\d+)?`;
  }
  return regex;
}
function timeRegex(args) {
  return new RegExp(`^${timeRegexSource(args)}$`);
}
function datetimeRegex(args) {
  let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
  const opts = [];
  opts.push(args.local ? `Z?` : `Z`);
  if (args.offset)
    opts.push(`([+-]\\d{2}:?\\d{2})`);
  regex = `${regex}(${opts.join("|")})`;
  return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
  if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
class ZodString extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.string,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "length") {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          }
          status.dirty();
        }
      } else if (check.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "emoji") {
        if (!emojiRegex) {
          emojiRegex = new RegExp(_emojiRegex, "u");
        }
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "nanoid") {
        if (!nanoidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "nanoid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "url") {
        try {
          new URL(input.data);
        } catch (_a) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "regex") {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "trim") {
        input.data = input.data.trim();
      } else if (check.kind === "includes") {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check.kind === "startsWith") {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "endsWith") {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "datetime") {
        const regex = datetimeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "datetime",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "date") {
        const regex = dateRegex;
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "date",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "time") {
        const regex = timeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "time",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "duration") {
        if (!durationRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "duration",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ip") {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "base64") {
        if (!base64Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "base64",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util$2.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _regex(regex, validation, message) {
    return this.refinement((data) => regex.test(data), __spreadValues({
      validation,
      code: ZodIssueCode.invalid_string
    }, errorUtil.errToObj(message)));
  }
  _addCheck(check) {
    return new ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  email(message) {
    return this._addCheck(__spreadValues({ kind: "email" }, errorUtil.errToObj(message)));
  }
  url(message) {
    return this._addCheck(__spreadValues({ kind: "url" }, errorUtil.errToObj(message)));
  }
  emoji(message) {
    return this._addCheck(__spreadValues({ kind: "emoji" }, errorUtil.errToObj(message)));
  }
  uuid(message) {
    return this._addCheck(__spreadValues({ kind: "uuid" }, errorUtil.errToObj(message)));
  }
  nanoid(message) {
    return this._addCheck(__spreadValues({ kind: "nanoid" }, errorUtil.errToObj(message)));
  }
  cuid(message) {
    return this._addCheck(__spreadValues({ kind: "cuid" }, errorUtil.errToObj(message)));
  }
  cuid2(message) {
    return this._addCheck(__spreadValues({ kind: "cuid2" }, errorUtil.errToObj(message)));
  }
  ulid(message) {
    return this._addCheck(__spreadValues({ kind: "ulid" }, errorUtil.errToObj(message)));
  }
  base64(message) {
    return this._addCheck(__spreadValues({ kind: "base64" }, errorUtil.errToObj(message)));
  }
  ip(options) {
    return this._addCheck(__spreadValues({ kind: "ip" }, errorUtil.errToObj(options)));
  }
  datetime(options) {
    var _a, _b;
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        local: false,
        message: options
      });
    }
    return this._addCheck(__spreadValues({
      kind: "datetime",
      precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
      offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
      local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false
    }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
  }
  date(message) {
    return this._addCheck({ kind: "date", message });
  }
  time(options) {
    if (typeof options === "string") {
      return this._addCheck({
        kind: "time",
        precision: null,
        message: options
      });
    }
    return this._addCheck(__spreadValues({
      kind: "time",
      precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision
    }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
  }
  duration(message) {
    return this._addCheck(__spreadValues({ kind: "duration" }, errorUtil.errToObj(message)));
  }
  regex(regex, message) {
    return this._addCheck(__spreadValues({
      kind: "regex",
      regex
    }, errorUtil.errToObj(message)));
  }
  includes(value, options) {
    return this._addCheck(__spreadValues({
      kind: "includes",
      value,
      position: options === null || options === void 0 ? void 0 : options.position
    }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
  }
  startsWith(value, message) {
    return this._addCheck(__spreadValues({
      kind: "startsWith",
      value
    }, errorUtil.errToObj(message)));
  }
  endsWith(value, message) {
    return this._addCheck(__spreadValues({
      kind: "endsWith",
      value
    }, errorUtil.errToObj(message)));
  }
  min(minLength, message) {
    return this._addCheck(__spreadValues({
      kind: "min",
      value: minLength
    }, errorUtil.errToObj(message)));
  }
  max(maxLength, message) {
    return this._addCheck(__spreadValues({
      kind: "max",
      value: maxLength
    }, errorUtil.errToObj(message)));
  }
  length(len, message) {
    return this._addCheck(__spreadValues({
      kind: "length",
      value: len
    }, errorUtil.errToObj(message)));
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(message) {
    return this.min(1, errorUtil.errToObj(message));
  }
  trim() {
    return new ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, { kind: "trim" }]
    }));
  }
  toLowerCase() {
    return new ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    }));
  }
  toUpperCase() {
    return new ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    }));
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((ch) => ch.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((ch) => ch.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((ch) => ch.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((ch) => ch.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((ch) => ch.kind === "base64");
  }
  get minLength() {
    let min2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min2 === null || ch.value > min2)
          min2 = ch.value;
      }
    }
    return min2;
  }
  get maxLength() {
    let max2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max2 === null || ch.value < max2)
          max2 = ch.value;
      }
    }
    return max2;
  }
}
ZodString.create = (params) => {
  var _a;
  return new ZodString(__spreadValues({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
  }, processCreateParams(params)));
};
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "int") {
        if (!util$2.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util$2.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new ZodNumber(__spreadProps(__spreadValues({}, this._def), {
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    }));
  }
  _addCheck(check) {
    return new ZodNumber(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  int(message) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message)
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  finite(message) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message)
    });
  }
  safe(message) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min2 === null || ch.value > min2)
          min2 = ch.value;
      }
    }
    return min2;
  }
  get maxValue() {
    let max2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max2 === null || ch.value < max2)
          max2 = ch.value;
      }
    }
    return max2;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util$2.isInteger(ch.value));
  }
  get isFinite() {
    let max2 = null, min2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min2 === null || ch.value > min2)
          min2 = ch.value;
      } else if (ch.kind === "max") {
        if (max2 === null || ch.value < max2)
          max2 = ch.value;
      }
    }
    return Number.isFinite(min2) && Number.isFinite(max2);
  }
}
ZodNumber.create = (params) => {
  return new ZodNumber(__spreadValues({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
  }, processCreateParams(params)));
};
class ZodBigInt extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = BigInt(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: "bigint",
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: "bigint",
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util$2.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new ZodBigInt(__spreadProps(__spreadValues({}, this._def), {
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    }));
  }
  _addCheck(check) {
    return new ZodBigInt(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min2 === null || ch.value > min2)
          min2 = ch.value;
      }
    }
    return min2;
  }
  get maxValue() {
    let max2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max2 === null || ch.value < max2)
          max2 = ch.value;
      }
    }
    return max2;
  }
}
ZodBigInt.create = (params) => {
  var _a;
  return new ZodBigInt(__spreadValues({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
  }, processCreateParams(params)));
};
class ZodBoolean extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodBoolean.create = (params) => {
  return new ZodBoolean(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
  }, processCreateParams(params)));
};
class ZodDate extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else {
        util$2.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check) {
    return new ZodDate(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  min(minDate, message) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  max(maxDate, message) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  get minDate() {
    let min2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min2 === null || ch.value > min2)
          min2 = ch.value;
      }
    }
    return min2 != null ? new Date(min2) : null;
  }
  get maxDate() {
    let max2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max2 === null || ch.value < max2)
          max2 = ch.value;
      }
    }
    return max2 != null ? new Date(max2) : null;
  }
}
ZodDate.create = (params) => {
  return new ZodDate(__spreadValues({
    checks: [],
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    typeName: ZodFirstPartyTypeKind.ZodDate
  }, processCreateParams(params)));
};
class ZodSymbol extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodSymbol.create = (params) => {
  return new ZodSymbol(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodSymbol
  }, processCreateParams(params)));
};
class ZodUndefined extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodUndefined.create = (params) => {
  return new ZodUndefined(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodUndefined
  }, processCreateParams(params)));
};
class ZodNull extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodNull.create = (params) => {
  return new ZodNull(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodNull
  }, processCreateParams(params)));
};
class ZodAny extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
}
ZodAny.create = (params) => {
  return new ZodAny(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodAny
  }, processCreateParams(params)));
};
class ZodUnknown extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
}
ZodUnknown.create = (params) => {
  return new ZodUnknown(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodUnknown
  }, processCreateParams(params)));
};
class ZodNever extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
}
ZodNever.create = (params) => {
  return new ZodNever(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodNever
  }, processCreateParams(params)));
};
class ZodVoid extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodVoid.create = (params) => {
  return new ZodVoid(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodVoid
  }, processCreateParams(params)));
};
class ZodArray extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def.exactLength.value : void 0,
          maximum: tooBig ? def.exactLength.value : void 0,
          type: "array",
          inclusive: true,
          exact: true,
          message: def.exactLength.message
        });
        status.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.minLength.message
        });
        status.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.maxLength.message
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item, i) => {
        return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      })).then((result2) => {
        return ParseStatus.mergeArray(status, result2);
      });
    }
    const result = [...ctx.data].map((item, i) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
    });
    return ParseStatus.mergeArray(status, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message) {
    return new ZodArray(__spreadProps(__spreadValues({}, this._def), {
      minLength: { value: minLength, message: errorUtil.toString(message) }
    }));
  }
  max(maxLength, message) {
    return new ZodArray(__spreadProps(__spreadValues({}, this._def), {
      maxLength: { value: maxLength, message: errorUtil.toString(message) }
    }));
  }
  length(len, message) {
    return new ZodArray(__spreadProps(__spreadValues({}, this._def), {
      exactLength: { value: len, message: errorUtil.toString(message) }
    }));
  }
  nonempty(message) {
    return this.min(1, message);
  }
}
ZodArray.create = (schema, params) => {
  return new ZodArray(__spreadValues({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray
  }, processCreateParams(params)));
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key in schema.shape) {
      const fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject(__spreadProps(__spreadValues({}, schema._def), {
      shape: () => newShape
    }));
  } else if (schema instanceof ZodArray) {
    return new ZodArray(__spreadProps(__spreadValues({}, schema._def), {
      type: deepPartialify(schema.element)
    }));
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
  } else {
    return schema;
  }
}
class ZodObject extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape2 = this._def.shape();
    const keys = util$2.objectKeys(shape2);
    return this._cached = { shape: shape2, keys };
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape: shape2, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
      for (const key in ctx.data) {
        if (!shapeKeys.includes(key)) {
          extraKeys.push(key);
        }
      }
    }
    const pairs = [];
    for (const key of shapeKeys) {
      const keyValidator = shape2[key];
      const value = ctx.data[key];
      pairs.push({
        key: { status: "valid", value: key },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key },
            value: { status: "valid", value: ctx.data[key] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys
          });
          status.dirty();
        }
      } else if (unknownKeys === "strip")
        ;
      else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key of extraKeys) {
        const value = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value, ctx.path, key)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(() => __async(this, null, function* () {
        const syncPairs = [];
        for (const pair of pairs) {
          const key = yield pair.key;
          const value = yield pair.value;
          syncPairs.push({
            key,
            value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      })).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message) {
    errorUtil.errToObj;
    return new ZodObject(__spreadValues(__spreadProps(__spreadValues({}, this._def), {
      unknownKeys: "strict"
    }), message !== void 0 ? {
      errorMap: (issue, ctx) => {
        var _a, _b, _c, _d;
        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
        if (issue.code === "unrecognized_keys")
          return {
            message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
          };
        return {
          message: defaultError
        };
      }
    } : {}));
  }
  strip() {
    return new ZodObject(__spreadProps(__spreadValues({}, this._def), {
      unknownKeys: "strip"
    }));
  }
  passthrough() {
    return new ZodObject(__spreadProps(__spreadValues({}, this._def), {
      unknownKeys: "passthrough"
    }));
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => __spreadValues(__spreadValues({}, this._def.shape()), augmentation)
    }));
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => __spreadValues(__spreadValues({}, this._def.shape()), merging._def.shape()),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key, schema) {
    return this.augment({ [key]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index2) {
    return new ZodObject(__spreadProps(__spreadValues({}, this._def), {
      catchall: index2
    }));
  }
  pick(mask) {
    const shape2 = {};
    util$2.objectKeys(mask).forEach((key) => {
      if (mask[key] && this.shape[key]) {
        shape2[key] = this.shape[key];
      }
    });
    return new ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => shape2
    }));
  }
  omit(mask) {
    const shape2 = {};
    util$2.objectKeys(this.shape).forEach((key) => {
      if (!mask[key]) {
        shape2[key] = this.shape[key];
      }
    });
    return new ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => shape2
    }));
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    util$2.objectKeys(this.shape).forEach((key) => {
      const fieldSchema = this.shape[key];
      if (mask && !mask[key]) {
        newShape[key] = fieldSchema;
      } else {
        newShape[key] = fieldSchema.optional();
      }
    });
    return new ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => newShape
    }));
  }
  required(mask) {
    const newShape = {};
    util$2.objectKeys(this.shape).forEach((key) => {
      if (mask && !mask[key]) {
        newShape[key] = this.shape[key];
      } else {
        const fieldSchema = this.shape[key];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key] = newField;
      }
    });
    return new ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => newShape
    }));
  }
  keyof() {
    return createZodEnum(util$2.objectKeys(this.shape));
  }
}
ZodObject.create = (shape2, params) => {
  return new ZodObject(__spreadValues({
    shape: () => shape2,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
ZodObject.strictCreate = (shape2, params) => {
  return new ZodObject(__spreadValues({
    shape: () => shape2,
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
ZodObject.lazycreate = (shape2, params) => {
  return new ZodObject(__spreadValues({
    shape: shape2,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
class ZodUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === "valid") {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === "dirty") {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(options.map((option) => __async(this, null, function* () {
        const childCtx = __spreadProps(__spreadValues({}, ctx), {
          common: __spreadProps(__spreadValues({}, ctx.common), {
            issues: []
          }),
          parent: null
        });
        return {
          result: yield option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      }))).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = __spreadProps(__spreadValues({}, ctx), {
          common: __spreadProps(__spreadValues({}, ctx.common), {
            issues: []
          }),
          parent: null
        });
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result.status === "valid") {
          return result;
        } else if (result.status === "dirty" && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
}
ZodUnion.create = (types2, params) => {
  return new ZodUnion(__spreadValues({
    options: types2,
    typeName: ZodFirstPartyTypeKind.ZodUnion
  }, processCreateParams(params)));
};
const getDiscriminator = (type) => {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return util$2.objectValues(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [void 0];
  } else if (type instanceof ZodNull) {
    return [null];
  } else if (type instanceof ZodOptional) {
    return [void 0, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodNullable) {
    return [null, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodBranded) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodReadonly) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodCatch) {
    return getDiscriminator(type._def.innerType);
  } else {
    return [];
  }
};
class ZodDiscriminatedUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues.length) {
        throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
        }
        optionsMap.set(value, type);
      }
    }
    return new ZodDiscriminatedUnion(__spreadValues({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap
    }, processCreateParams(params)));
  }
}
function mergeValues(a2, b) {
  const aType = getParsedType(a2);
  const bType = getParsedType(b);
  if (a2 === b) {
    return { valid: true, data: a2 };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util$2.objectKeys(b);
    const sharedKeys = util$2.objectKeys(a2).filter((key) => bKeys.indexOf(key) !== -1);
    const newObj = __spreadValues(__spreadValues({}, a2), b);
    for (const key of sharedKeys) {
      const sharedValue = mergeValues(a2[key], b[key]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a2.length !== b.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index2 = 0; index2 < a2.length; index2++) {
      const itemA = a2[index2];
      const itemB = b[index2];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a2 === +b) {
    return { valid: true, data: a2 };
  } else {
    return { valid: false };
  }
}
class ZodIntersection extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left2, right2]) => handleParsed(left2, right2));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
}
ZodIntersection.create = (left2, right2, params) => {
  return new ZodIntersection(__spreadValues({
    left: left2,
    right: right2,
    typeName: ZodFirstPartyTypeKind.ZodIntersection
  }, processCreateParams(params)));
};
class ZodTuple extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status.dirty();
    }
    const items = [...ctx.data].map((item, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
    }).filter((x2) => !!x2);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new ZodTuple(__spreadProps(__spreadValues({}, this._def), {
      rest
    }));
  }
}
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple(__spreadValues({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null
  }, processCreateParams(params)));
};
class ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first, second, third) {
    if (second instanceof ZodType) {
      return new ZodRecord(__spreadValues({
        keyType: first,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord
      }, processCreateParams(third)));
    }
    return new ZodRecord(__spreadValues({
      keyType: ZodString.create(),
      valueType: first,
      typeName: ZodFirstPartyTypeKind.ZodRecord
    }, processCreateParams(second)));
  }
}
class ZodMap extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key, value], index2) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index2, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index2, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(() => __async(this, null, function* () {
        for (const pair of pairs) {
          const key = yield pair.key;
          const value = yield pair.value;
          if (key.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      }));
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key = pair.key;
        const value = pair.value;
        if (key.status === "aborted" || value.status === "aborted") {
          return INVALID;
        }
        if (key.status === "dirty" || value.status === "dirty") {
          status.dirty();
        }
        finalMap.set(key.value, value.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
}
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap(__spreadValues({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap
  }, processCreateParams(params)));
};
class ZodSet extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.minSize.message
        });
        status.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.maxSize.message
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element of elements2) {
        if (element.status === "aborted")
          return INVALID;
        if (element.status === "dirty")
          status.dirty();
        parsedSet.add(element.value);
      }
      return { status: status.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message) {
    return new ZodSet(__spreadProps(__spreadValues({}, this._def), {
      minSize: { value: minSize, message: errorUtil.toString(message) }
    }));
  }
  max(maxSize, message) {
    return new ZodSet(__spreadProps(__spreadValues({}, this._def), {
      maxSize: { value: maxSize, message: errorUtil.toString(message) }
    }));
  }
  size(size, message) {
    return this.min(size, message).max(size, message);
  }
  nonempty(message) {
    return this.min(1, message);
  }
}
ZodSet.create = (valueType, params) => {
  return new ZodSet(__spreadValues({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet
  }, processCreateParams(params)));
};
class ZodFunction extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x2) => !!x2),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error
        }
      });
    }
    function makeReturnsIssue(returns, error) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x2) => !!x2),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error
        }
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn2 = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(function(...args) {
        return __async(this, null, function* () {
          const error = new ZodError([]);
          const parsedArgs = yield me._def.args.parseAsync(args, params).catch((e2) => {
            error.addIssue(makeArgsIssue(args, e2));
            throw error;
          });
          const result = yield Reflect.apply(fn2, this, parsedArgs);
          const parsedReturns = yield me._def.returns._def.type.parseAsync(result, params).catch((e2) => {
            error.addIssue(makeReturnsIssue(result, e2));
            throw error;
          });
          return parsedReturns;
        });
      });
    } else {
      const me = this;
      return OK(function(...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn2, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new ZodFunction(__spreadProps(__spreadValues({}, this._def), {
      args: ZodTuple.create(items).rest(ZodUnknown.create())
    }));
  }
  returns(returnType) {
    return new ZodFunction(__spreadProps(__spreadValues({}, this._def), {
      returns: returnType
    }));
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new ZodFunction(__spreadValues({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction
    }, processCreateParams(params)));
  }
}
class ZodLazy extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
}
ZodLazy.create = (getter, params) => {
  return new ZodLazy(__spreadValues({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy
  }, processCreateParams(params)));
};
class ZodLiteral extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
}
ZodLiteral.create = (value, params) => {
  return new ZodLiteral(__spreadValues({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral
  }, processCreateParams(params)));
};
function createZodEnum(values2, params) {
  return new ZodEnum(__spreadValues({
    values: values2,
    typeName: ZodFirstPartyTypeKind.ZodEnum
  }, processCreateParams(params)));
}
class ZodEnum extends ZodType {
  constructor() {
    super(...arguments);
    _ZodEnum_cache.set(this, void 0);
  }
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util$2.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f")) {
      __classPrivateFieldSet(this, _ZodEnum_cache, new Set(this._def.values), "f");
    }
    if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f").has(input.data)) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values2, newDef = this._def) {
    return ZodEnum.create(values2, __spreadValues(__spreadValues({}, this._def), newDef));
  }
  exclude(values2, newDef = this._def) {
    return ZodEnum.create(this.options.filter((opt) => !values2.includes(opt)), __spreadValues(__spreadValues({}, this._def), newDef));
  }
}
_ZodEnum_cache = /* @__PURE__ */ new WeakMap();
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
  constructor() {
    super(...arguments);
    _ZodNativeEnum_cache.set(this, void 0);
  }
  _parse(input) {
    const nativeEnumValues = util$2.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util$2.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util$2.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f")) {
      __classPrivateFieldSet(this, _ZodNativeEnum_cache, new Set(util$2.getValidEnumValues(this._def.values)), "f");
    }
    if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f").has(input.data)) {
      const expectedValues = util$2.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
}
_ZodNativeEnum_cache = /* @__PURE__ */ new WeakMap();
ZodNativeEnum.create = (values2, params) => {
  return new ZodNativeEnum(__spreadValues({
    values: values2,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum
  }, processCreateParams(params)));
};
class ZodPromise extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data) => {
      return this._def.type.parseAsync(data, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
}
ZodPromise.create = (schema, params) => {
  return new ZodPromise(__spreadValues({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise
  }, processCreateParams(params)));
};
class ZodEffects extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect2 = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      },
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect2.type === "preprocess") {
      const processed = effect2.transform(ctx.data, checkCtx);
      if (ctx.common.async) {
        return Promise.resolve(processed).then((processed2) => __async(this, null, function* () {
          if (status.value === "aborted")
            return INVALID;
          const result = yield this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
          if (result.status === "aborted")
            return INVALID;
          if (result.status === "dirty")
            return DIRTY(result.value);
          if (status.value === "dirty")
            return DIRTY(result.value);
          return result;
        }));
      } else {
        if (status.value === "aborted")
          return INVALID;
        const result = this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
        if (result.status === "aborted")
          return INVALID;
        if (result.status === "dirty")
          return DIRTY(result.value);
        if (status.value === "dirty")
          return DIRTY(result.value);
        return result;
      }
    }
    if (effect2.type === "refinement") {
      const executeRefinement = (acc) => {
        const result = effect2.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner.status === "aborted")
          return INVALID;
        if (inner.status === "dirty")
          status.dirty();
        executeRefinement(inner.value);
        return { status: status.value, value: inner.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          return executeRefinement(inner.value).then(() => {
            return { status: status.value, value: inner.value };
          });
        });
      }
    }
    if (effect2.type === "transform") {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid(base))
          return base;
        const result = effect2.transform(base.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return { status: status.value, value: result };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
          if (!isValid(base))
            return base;
          return Promise.resolve(effect2.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
        });
      }
    }
    util$2.assertNever(effect2);
  }
}
ZodEffects.create = (schema, effect2, params) => {
  return new ZodEffects(__spreadValues({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect: effect2
  }, processCreateParams(params)));
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
  return new ZodEffects(__spreadValues({
    schema,
    effect: { type: "preprocess", transform: preprocess },
    typeName: ZodFirstPartyTypeKind.ZodEffects
  }, processCreateParams(params)));
};
class ZodOptional extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodOptional.create = (type, params) => {
  return new ZodOptional(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional
  }, processCreateParams(params)));
};
class ZodNullable extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodNullable.create = (type, params) => {
  return new ZodNullable(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable
  }, processCreateParams(params)));
};
class ZodDefault extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ZodDefault.create = (type, params) => {
  return new ZodDefault(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default
  }, processCreateParams(params)));
};
class ZodCatch extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = __spreadProps(__spreadValues({}, ctx), {
      common: __spreadProps(__spreadValues({}, ctx.common), {
        issues: []
      })
    });
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: __spreadValues({}, newCtx)
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: "valid",
          value: result2.status === "valid" ? result2.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result.status === "valid" ? result.value : this._def.catchValue({
          get error() {
            return new ZodError(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ZodCatch.create = (type, params) => {
  return new ZodCatch(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch
  }, processCreateParams(params)));
};
class ZodNaN extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
}
ZodNaN.create = (params) => {
  return new ZodNaN(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodNaN
  }, processCreateParams(params)));
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data = ctx.data;
    return this._def.type._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class ZodPipeline extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = () => __async(this, null, function* () {
        const inResult = yield this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      });
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a2, b) {
    return new ZodPipeline({
      in: a2,
      out: b,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
}
class ZodReadonly extends ZodType {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    const freeze = (data) => {
      if (isValid(data)) {
        data.value = Object.freeze(data.value);
      }
      return data;
    };
    return isAsync(result) ? result.then((data) => freeze(data)) : freeze(result);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodReadonly.create = (type, params) => {
  return new ZodReadonly(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly
  }, processCreateParams(params)));
};
function custom(check, params = {}, fatal) {
  if (check)
    return ZodAny.create().superRefine((data, ctx) => {
      var _a, _b;
      if (!check(data)) {
        const p = typeof params === "function" ? params(data) : typeof params === "string" ? { message: params } : params;
        const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
        const p2 = typeof p === "string" ? { message: p } : p;
        ctx.addIssue(__spreadProps(__spreadValues({ code: "custom" }, p2), { fatal: _fatal }));
      }
    });
  return ZodAny.create();
}
const late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (cls, params = {
  message: `Input not instance of ${cls.name}`
}) => custom((data) => data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const coerce = {
  string: (arg) => ZodString.create(__spreadProps(__spreadValues({}, arg), { coerce: true })),
  number: (arg) => ZodNumber.create(__spreadProps(__spreadValues({}, arg), { coerce: true })),
  boolean: (arg) => ZodBoolean.create(__spreadProps(__spreadValues({}, arg), {
    coerce: true
  })),
  bigint: (arg) => ZodBigInt.create(__spreadProps(__spreadValues({}, arg), { coerce: true })),
  date: (arg) => ZodDate.create(__spreadProps(__spreadValues({}, arg), { coerce: true }))
};
const NEVER = INVALID;
var z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: errorMap,
  setErrorMap,
  getErrorMap,
  makeIssue,
  EMPTY_PATH,
  addIssueToContext,
  ParseStatus,
  INVALID,
  DIRTY,
  OK,
  isAborted,
  isDirty,
  isValid,
  isAsync,
  get util() {
    return util$2;
  },
  get objectUtil() {
    return objectUtil;
  },
  ZodParsedType,
  getParsedType,
  ZodType,
  datetimeRegex,
  ZodString,
  ZodNumber,
  ZodBigInt,
  ZodBoolean,
  ZodDate,
  ZodSymbol,
  ZodUndefined,
  ZodNull,
  ZodAny,
  ZodUnknown,
  ZodNever,
  ZodVoid,
  ZodArray,
  ZodObject,
  ZodUnion,
  ZodDiscriminatedUnion,
  ZodIntersection,
  ZodTuple,
  ZodRecord,
  ZodMap,
  ZodSet,
  ZodFunction,
  ZodLazy,
  ZodLiteral,
  ZodEnum,
  ZodNativeEnum,
  ZodPromise,
  ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodCatch,
  ZodNaN,
  BRAND,
  ZodBranded,
  ZodPipeline,
  ZodReadonly,
  custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  coerce,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  "enum": enumType,
  "function": functionType,
  "instanceof": instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  "null": nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  "undefined": undefinedType,
  union: unionType,
  unknown: unknownType,
  "void": voidType,
  NEVER,
  ZodIssueCode,
  quotelessJson,
  ZodError
});
const tagRe = /<([a-zA-Z0-9]+)>(.*?)<\/\1>|<([a-zA-Z0-9]+)\/>/;
const nlRe = /(?:\r\n|\r|\n)/g;
const voidElementTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
  menuitem: true
};
function formatElements(value, elements = {}) {
  const uniqueId = makeCounter(0, "$lingui$");
  const parts = value.replace(nlRe, "").split(tagRe);
  if (parts.length === 1)
    return value;
  const tree = [];
  const before = parts.shift();
  if (before)
    tree.push(before);
  for (const [index2, children, after] of getElements(parts)) {
    let element = typeof index2 !== "undefined" ? elements[index2] : void 0;
    if (!element || voidElementTags[element.type] && children) {
      if (!element) {
        console.error(
          `Can't use element at index '${index2}' as it is not declared in the original translation`
        );
      } else {
        console.error(
          `${element.type} is a void element tag therefore it must have no children`
        );
      }
      element = React__default.createElement(React__default.Fragment);
    }
    if (Array.isArray(element)) {
      element = React__default.createElement(React__default.Fragment, {}, element);
    }
    tree.push(
      React__default.cloneElement(
        element,
        { key: uniqueId() },
        // format children for pair tags
        // unpaired tags might have children if it's a component passed as a variable
        children ? formatElements(children, elements) : element.props.children
      )
    );
    if (after)
      tree.push(after);
  }
  return tree;
}
function getElements(parts) {
  if (!parts.length)
    return [];
  const [paired, children, unpaired, after] = parts.slice(0, 4);
  const triple = [paired || unpaired, children || "", after];
  return [triple].concat(getElements(parts.slice(4, parts.length)));
}
const makeCounter = (count = 0, prefix2 = "") => () => `${prefix2}_${count++}`;
function TransNoContext(props) {
  const {
    render,
    component,
    id: id2,
    message,
    formats,
    lingui: { i18n: i18n2, defaultComponent }
  } = props;
  const values2 = __spreadValues({}, props.values);
  const components = __spreadValues({}, props.components);
  if (values2) {
    Object.keys(values2).forEach((key) => {
      const value = values2[key];
      const valueIsReactEl = React__default.isValidElement(value) || Array.isArray(value) && value.every(React__default.isValidElement);
      if (!valueIsReactEl)
        return;
      const index2 = Object.keys(components).length;
      components[index2] = value;
      values2[key] = `<${index2}/>`;
    });
  }
  const _translation = i18n2 && typeof i18n2._ === "function" ? i18n2._(id2, values2, { message, formats }) : id2;
  const translation = _translation ? formatElements(_translation, components) : null;
  if (render === null || component === null) {
    return translation;
  }
  const FallbackComponent = defaultComponent || RenderFragment;
  const i18nProps = {
    id: id2,
    message,
    translation,
    // TODO vonovak - remove isTranslated prop in v5 release
    isTranslated: id2 !== translation && message !== translation,
    children: translation
    // for type-compatibility with `component` prop
  };
  if (render && component) {
    console.error(
      "You can't use both `component` and `render` prop at the same time. `component` is ignored."
    );
  } else if (render && typeof render !== "function") {
    console.error(
      `Invalid value supplied to prop \`render\`. It must be a function, provided ${render}`
    );
  } else if (component && typeof component !== "function") {
    console.error(
      `Invalid value supplied to prop \`component\`. It must be a React component, provided ${component}`
    );
    return React__default.createElement(FallbackComponent, i18nProps, translation);
  }
  if (typeof render === "function") {
    return render(i18nProps);
  }
  const Component2 = component || FallbackComponent;
  return React__default.createElement(Component2, i18nProps, translation);
}
const RenderFragment = ({ children }) => {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children);
};
const LinguiContext = React__default.createContext(null);
const useLinguiInternal = (devErrorMessage) => {
  const context = React__default.useContext(LinguiContext);
  if (process.env.NODE_ENV !== "production") {
    if (context == null) {
      throw new Error(
        devErrorMessage != null ? devErrorMessage : "useLingui hook was used without I18nProvider."
      );
    }
  }
  return context;
};
function useLingui() {
  return useLinguiInternal();
}
const I18nProvider = ({
  i18n: i18n2,
  defaultComponent,
  children
}) => {
  const latestKnownLocale = React__default.useRef(i18n2.locale);
  const makeContext = React__default.useCallback(
    () => ({
      i18n: i18n2,
      defaultComponent,
      _: i18n2.t.bind(i18n2)
    }),
    [i18n2, defaultComponent]
  );
  const [context, setContext] = React__default.useState(makeContext());
  React__default.useEffect(() => {
    const updateContext = () => {
      latestKnownLocale.current = i18n2.locale;
      setContext(makeContext());
    };
    const unsubscribe = i18n2.on("change", updateContext);
    if (latestKnownLocale.current !== i18n2.locale) {
      updateContext();
    }
    return unsubscribe;
  }, [i18n2, makeContext]);
  if (!latestKnownLocale.current) {
    process.env.NODE_ENV === "development" && console.log(
      "I18nProvider rendered `null`. A call to `i18n.activate` needs to happen in order for translations to be activated and for the I18nProvider to render.This is not an error but an informational message logged only in development."
    );
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(LinguiContext.Provider, { value: context }, children);
};
function Trans(props) {
  let errMessage = void 0;
  if (process.env.NODE_ENV !== "production") {
    errMessage = `Trans component was rendered without I18nProvider.
Attempted to render message: ${props.message} id: ${props.id}. Make sure this component is rendered inside a I18nProvider.`;
  }
  const lingui = useLinguiInternal(errMessage);
  return React__default.createElement(TransNoContext, __spreadProps(__spreadValues({}, props), { lingui }));
}
var dist = {};
var errors = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.errorMessages = exports.ErrorType = void 0;
  var ErrorType;
  (function(ErrorType2) {
    ErrorType2["MalformedUnicode"] = "MALFORMED_UNICODE";
    ErrorType2["MalformedHexadecimal"] = "MALFORMED_HEXADECIMAL";
    ErrorType2["CodePointLimit"] = "CODE_POINT_LIMIT";
    ErrorType2["OctalDeprecation"] = "OCTAL_DEPRECATION";
    ErrorType2["EndOfString"] = "END_OF_STRING";
  })(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
  exports.errorMessages = /* @__PURE__ */ new Map([
    [ErrorType.MalformedUnicode, "malformed Unicode character escape sequence"],
    [
      ErrorType.MalformedHexadecimal,
      "malformed hexadecimal character escape sequence"
    ],
    [
      ErrorType.CodePointLimit,
      "Unicode codepoint must not be greater than 0x10FFFF in escape sequence"
    ],
    [
      ErrorType.OctalDeprecation,
      '"0"-prefixed octal literals and octal escape sequences are deprecated; for octal literals use the "0o" prefix instead'
    ],
    [ErrorType.EndOfString, "malformed escape sequence at end of string"]
  ]);
})(errors);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.unraw = exports.errorMessages = exports.ErrorType = void 0;
  const errors_1 = errors;
  Object.defineProperty(exports, "ErrorType", { enumerable: true, get: function() {
    return errors_1.ErrorType;
  } });
  Object.defineProperty(exports, "errorMessages", { enumerable: true, get: function() {
    return errors_1.errorMessages;
  } });
  function parseHexToInt(hex2) {
    const isOnlyHexChars = !hex2.match(/[^a-f0-9]/i);
    return isOnlyHexChars ? parseInt(hex2, 16) : NaN;
  }
  function validateAndParseHex(hex2, errorName, enforcedLength) {
    const parsedHex = parseHexToInt(hex2);
    if (Number.isNaN(parsedHex) || enforcedLength !== void 0 && enforcedLength !== hex2.length) {
      throw new SyntaxError(errors_1.errorMessages.get(errorName));
    }
    return parsedHex;
  }
  function parseHexadecimalCode(code) {
    const parsedCode = validateAndParseHex(code, errors_1.ErrorType.MalformedHexadecimal, 2);
    return String.fromCharCode(parsedCode);
  }
  function parseUnicodeCode(code, surrogateCode) {
    const parsedCode = validateAndParseHex(code, errors_1.ErrorType.MalformedUnicode, 4);
    if (surrogateCode !== void 0) {
      const parsedSurrogateCode = validateAndParseHex(surrogateCode, errors_1.ErrorType.MalformedUnicode, 4);
      return String.fromCharCode(parsedCode, parsedSurrogateCode);
    }
    return String.fromCharCode(parsedCode);
  }
  function isCurlyBraced(text) {
    return text.charAt(0) === "{" && text.charAt(text.length - 1) === "}";
  }
  function parseUnicodeCodePointCode(codePoint) {
    if (!isCurlyBraced(codePoint)) {
      throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.MalformedUnicode));
    }
    const withoutBraces = codePoint.slice(1, -1);
    const parsedCode = validateAndParseHex(withoutBraces, errors_1.ErrorType.MalformedUnicode);
    try {
      return String.fromCodePoint(parsedCode);
    } catch (err) {
      throw err instanceof RangeError ? new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.CodePointLimit)) : err;
    }
  }
  function parseOctalCode(code, error = false) {
    if (error) {
      throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.OctalDeprecation));
    }
    const parsedCode = parseInt(code, 8);
    return String.fromCharCode(parsedCode);
  }
  const singleCharacterEscapes = /* @__PURE__ */ new Map([
    ["b", "\b"],
    ["f", "\f"],
    ["n", "\n"],
    ["r", "\r"],
    ["t", "	"],
    ["v", "\v"],
    ["0", "\0"]
  ]);
  function parseSingleCharacterCode(code) {
    return singleCharacterEscapes.get(code) || code;
  }
  const escapeMatch = /\\(?:(\\)|x([\s\S]{0,2})|u(\{[^}]*\}?)|u([\s\S]{4})\\u([^{][\s\S]{0,3})|u([\s\S]{0,4})|([0-3]?[0-7]{1,2})|([\s\S])|$)/g;
  function unraw(raw, allowOctals = false) {
    return raw.replace(escapeMatch, function(_, backslash, hex2, codePoint, unicodeWithSurrogate, surrogate, unicode, octal, singleCharacter) {
      if (backslash !== void 0) {
        return "\\";
      }
      if (hex2 !== void 0) {
        return parseHexadecimalCode(hex2);
      }
      if (codePoint !== void 0) {
        return parseUnicodeCodePointCode(codePoint);
      }
      if (unicodeWithSurrogate !== void 0) {
        return parseUnicodeCode(unicodeWithSurrogate, surrogate);
      }
      if (unicode !== void 0) {
        return parseUnicodeCode(unicode);
      }
      if (octal === "0") {
        return "\0";
      }
      if (octal !== void 0) {
        return parseOctalCode(octal, !allowOctals);
      }
      if (singleCharacter !== void 0) {
        return parseSingleCharacterCode(singleCharacter);
      }
      throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.EndOfString));
    });
  }
  exports.unraw = unraw;
  exports.default = unraw;
})(dist);
var parser = {};
var lexer = {};
var moo = { exports: {} };
(function(module) {
  (function(root2, factory) {
    if (module.exports) {
      module.exports = factory();
    } else {
      root2.moo = factory();
    }
  })(commonjsGlobal, function() {
    var hasOwnProperty2 = Object.prototype.hasOwnProperty;
    var toString = Object.prototype.toString;
    var hasSticky = typeof new RegExp().sticky === "boolean";
    function isRegExp(o2) {
      return o2 && toString.call(o2) === "[object RegExp]";
    }
    function isObject2(o2) {
      return o2 && typeof o2 === "object" && !isRegExp(o2) && !Array.isArray(o2);
    }
    function reEscape(s2) {
      return s2.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function reGroups(s2) {
      var re = new RegExp("|" + s2);
      return re.exec("").length - 1;
    }
    function reCapture(s2) {
      return "(" + s2 + ")";
    }
    function reUnion(regexps) {
      if (!regexps.length)
        return "(?!)";
      var source = regexps.map(function(s2) {
        return "(?:" + s2 + ")";
      }).join("|");
      return "(?:" + source + ")";
    }
    function regexpOrLiteral(obj) {
      if (typeof obj === "string") {
        return "(?:" + reEscape(obj) + ")";
      } else if (isRegExp(obj)) {
        if (obj.ignoreCase)
          throw new Error("RegExp /i flag not allowed");
        if (obj.global)
          throw new Error("RegExp /g flag is implied");
        if (obj.sticky)
          throw new Error("RegExp /y flag is implied");
        if (obj.multiline)
          throw new Error("RegExp /m flag is implied");
        return obj.source;
      } else {
        throw new Error("Not a pattern: " + obj);
      }
    }
    function pad(s2, length2) {
      if (s2.length > length2) {
        return s2;
      }
      return Array(length2 - s2.length + 1).join(" ") + s2;
    }
    function lastNLines(string, numLines) {
      var position2 = string.length;
      var lineBreaks = 0;
      while (true) {
        var idx = string.lastIndexOf("\n", position2 - 1);
        if (idx === -1) {
          break;
        } else {
          lineBreaks++;
        }
        position2 = idx;
        if (lineBreaks === numLines) {
          break;
        }
        if (position2 === 0) {
          break;
        }
      }
      var startPosition = lineBreaks < numLines ? 0 : position2 + 1;
      return string.substring(startPosition).split("\n");
    }
    function objectToRules(object) {
      var keys = Object.getOwnPropertyNames(object);
      var result = [];
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var thing = object[key];
        var rules = [].concat(thing);
        if (key === "include") {
          for (var j = 0; j < rules.length; j++) {
            result.push({ include: rules[j] });
          }
          continue;
        }
        var match2 = [];
        rules.forEach(function(rule) {
          if (isObject2(rule)) {
            if (match2.length)
              result.push(ruleOptions(key, match2));
            result.push(ruleOptions(key, rule));
            match2 = [];
          } else {
            match2.push(rule);
          }
        });
        if (match2.length)
          result.push(ruleOptions(key, match2));
      }
      return result;
    }
    function arrayToRules(array) {
      var result = [];
      for (var i = 0; i < array.length; i++) {
        var obj = array[i];
        if (obj.include) {
          var include = [].concat(obj.include);
          for (var j = 0; j < include.length; j++) {
            result.push({ include: include[j] });
          }
          continue;
        }
        if (!obj.type) {
          throw new Error("Rule has no type: " + JSON.stringify(obj));
        }
        result.push(ruleOptions(obj.type, obj));
      }
      return result;
    }
    function ruleOptions(type, obj) {
      if (!isObject2(obj)) {
        obj = { match: obj };
      }
      if (obj.include) {
        throw new Error("Matching rules cannot also include states");
      }
      var options = {
        defaultType: type,
        lineBreaks: !!obj.error || !!obj.fallback,
        pop: false,
        next: null,
        push: null,
        error: false,
        fallback: false,
        value: null,
        type: null,
        shouldThrow: false
      };
      for (var key in obj) {
        if (hasOwnProperty2.call(obj, key)) {
          options[key] = obj[key];
        }
      }
      if (typeof options.type === "string" && type !== options.type) {
        throw new Error("Type transform cannot be a string (type '" + options.type + "' for token '" + type + "')");
      }
      var match2 = options.match;
      options.match = Array.isArray(match2) ? match2 : match2 ? [match2] : [];
      options.match.sort(function(a2, b) {
        return isRegExp(a2) && isRegExp(b) ? 0 : isRegExp(b) ? -1 : isRegExp(a2) ? 1 : b.length - a2.length;
      });
      return options;
    }
    function toRules3(spec) {
      return Array.isArray(spec) ? arrayToRules(spec) : objectToRules(spec);
    }
    var defaultErrorRule = ruleOptions("error", { lineBreaks: true, shouldThrow: true });
    function compileRules(rules, hasStates) {
      var errorRule = null;
      var fast = /* @__PURE__ */ Object.create(null);
      var fastAllowed = true;
      var unicodeFlag = null;
      var groups = [];
      var parts = [];
      for (var i = 0; i < rules.length; i++) {
        if (rules[i].fallback) {
          fastAllowed = false;
        }
      }
      for (var i = 0; i < rules.length; i++) {
        var options = rules[i];
        if (options.include) {
          throw new Error("Inheritance is not allowed in stateless lexers");
        }
        if (options.error || options.fallback) {
          if (errorRule) {
            if (!options.fallback === !errorRule.fallback) {
              throw new Error("Multiple " + (options.fallback ? "fallback" : "error") + " rules not allowed (for token '" + options.defaultType + "')");
            } else {
              throw new Error("fallback and error are mutually exclusive (for token '" + options.defaultType + "')");
            }
          }
          errorRule = options;
        }
        var match2 = options.match.slice();
        if (fastAllowed) {
          while (match2.length && typeof match2[0] === "string" && match2[0].length === 1) {
            var word = match2.shift();
            fast[word.charCodeAt(0)] = options;
          }
        }
        if (options.pop || options.push || options.next) {
          if (!hasStates) {
            throw new Error("State-switching options are not allowed in stateless lexers (for token '" + options.defaultType + "')");
          }
          if (options.fallback) {
            throw new Error("State-switching options are not allowed on fallback tokens (for token '" + options.defaultType + "')");
          }
        }
        if (match2.length === 0) {
          continue;
        }
        fastAllowed = false;
        groups.push(options);
        for (var j = 0; j < match2.length; j++) {
          var obj = match2[j];
          if (!isRegExp(obj)) {
            continue;
          }
          if (unicodeFlag === null) {
            unicodeFlag = obj.unicode;
          } else if (unicodeFlag !== obj.unicode && options.fallback === false) {
            throw new Error("If one rule is /u then all must be");
          }
        }
        var pat = reUnion(match2.map(regexpOrLiteral));
        var regexp = new RegExp(pat);
        if (regexp.test("")) {
          throw new Error("RegExp matches empty string: " + regexp);
        }
        var groupCount = reGroups(pat);
        if (groupCount > 0) {
          throw new Error("RegExp has capture groups: " + regexp + "\nUse (?: … ) instead");
        }
        if (!options.lineBreaks && regexp.test("\n")) {
          throw new Error("Rule should declare lineBreaks: " + regexp);
        }
        parts.push(reCapture(pat));
      }
      var fallbackRule = errorRule && errorRule.fallback;
      var flags = hasSticky && !fallbackRule ? "ym" : "gm";
      var suffix = hasSticky || fallbackRule ? "" : "|";
      if (unicodeFlag === true)
        flags += "u";
      var combined = new RegExp(reUnion(parts) + suffix, flags);
      return { regexp: combined, groups, fast, error: errorRule || defaultErrorRule };
    }
    function compile2(rules) {
      var result = compileRules(toRules3(rules));
      return new Lexer({ start: result }, "start");
    }
    function checkStateGroup(g, name, map) {
      var state = g && (g.push || g.next);
      if (state && !map[state]) {
        throw new Error("Missing state '" + state + "' (in token '" + g.defaultType + "' of state '" + name + "')");
      }
      if (g && g.pop && +g.pop !== 1) {
        throw new Error("pop must be 1 (in token '" + g.defaultType + "' of state '" + name + "')");
      }
    }
    function compileStates(states, start2) {
      var all = states.$all ? toRules3(states.$all) : [];
      delete states.$all;
      var keys = Object.getOwnPropertyNames(states);
      if (!start2)
        start2 = keys[0];
      var ruleMap = /* @__PURE__ */ Object.create(null);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        ruleMap[key] = toRules3(states[key]).concat(all);
      }
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var rules = ruleMap[key];
        var included = /* @__PURE__ */ Object.create(null);
        for (var j = 0; j < rules.length; j++) {
          var rule = rules[j];
          if (!rule.include)
            continue;
          var splice = [j, 1];
          if (rule.include !== key && !included[rule.include]) {
            included[rule.include] = true;
            var newRules = ruleMap[rule.include];
            if (!newRules) {
              throw new Error("Cannot include nonexistent state '" + rule.include + "' (in state '" + key + "')");
            }
            for (var k = 0; k < newRules.length; k++) {
              var newRule = newRules[k];
              if (rules.indexOf(newRule) !== -1)
                continue;
              splice.push(newRule);
            }
          }
          rules.splice.apply(rules, splice);
          j--;
        }
      }
      var map = /* @__PURE__ */ Object.create(null);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        map[key] = compileRules(ruleMap[key], true);
      }
      for (var i = 0; i < keys.length; i++) {
        var name = keys[i];
        var state = map[name];
        var groups = state.groups;
        for (var j = 0; j < groups.length; j++) {
          checkStateGroup(groups[j], name, map);
        }
        var fastKeys = Object.getOwnPropertyNames(state.fast);
        for (var j = 0; j < fastKeys.length; j++) {
          checkStateGroup(state.fast[fastKeys[j]], name, map);
        }
      }
      return new Lexer(map, start2);
    }
    function keywordTransform(map) {
      var isMap = typeof Map !== "undefined";
      var reverseMap = isMap ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
      var types2 = Object.getOwnPropertyNames(map);
      for (var i = 0; i < types2.length; i++) {
        var tokenType = types2[i];
        var item = map[tokenType];
        var keywordList = Array.isArray(item) ? item : [item];
        keywordList.forEach(function(keyword) {
          if (typeof keyword !== "string") {
            throw new Error("keyword must be string (in keyword '" + tokenType + "')");
          }
          if (isMap) {
            reverseMap.set(keyword, tokenType);
          } else {
            reverseMap[keyword] = tokenType;
          }
        });
      }
      return function(k) {
        return isMap ? reverseMap.get(k) : reverseMap[k];
      };
    }
    var Lexer = function(states, state) {
      this.startState = state;
      this.states = states;
      this.buffer = "";
      this.stack = [];
      this.reset();
    };
    Lexer.prototype.reset = function(data, info) {
      this.buffer = data || "";
      this.index = 0;
      this.line = info ? info.line : 1;
      this.col = info ? info.col : 1;
      this.queuedToken = info ? info.queuedToken : null;
      this.queuedText = info ? info.queuedText : "";
      this.queuedThrow = info ? info.queuedThrow : null;
      this.setState(info ? info.state : this.startState);
      this.stack = info && info.stack ? info.stack.slice() : [];
      return this;
    };
    Lexer.prototype.save = function() {
      return {
        line: this.line,
        col: this.col,
        state: this.state,
        stack: this.stack.slice(),
        queuedToken: this.queuedToken,
        queuedText: this.queuedText,
        queuedThrow: this.queuedThrow
      };
    };
    Lexer.prototype.setState = function(state) {
      if (!state || this.state === state)
        return;
      this.state = state;
      var info = this.states[state];
      this.groups = info.groups;
      this.error = info.error;
      this.re = info.regexp;
      this.fast = info.fast;
    };
    Lexer.prototype.popState = function() {
      this.setState(this.stack.pop());
    };
    Lexer.prototype.pushState = function(state) {
      this.stack.push(this.state);
      this.setState(state);
    };
    var eat = hasSticky ? function(re, buffer) {
      return re.exec(buffer);
    } : function(re, buffer) {
      var match2 = re.exec(buffer);
      if (match2[0].length === 0) {
        return null;
      }
      return match2;
    };
    Lexer.prototype._getGroup = function(match2) {
      var groupCount = this.groups.length;
      for (var i = 0; i < groupCount; i++) {
        if (match2[i + 1] !== void 0) {
          return this.groups[i];
        }
      }
      throw new Error("Cannot find token type for matched text");
    };
    function tokenToString() {
      return this.value;
    }
    Lexer.prototype.next = function() {
      var index2 = this.index;
      if (this.queuedGroup) {
        var token2 = this._token(this.queuedGroup, this.queuedText, index2);
        this.queuedGroup = null;
        this.queuedText = "";
        return token2;
      }
      var buffer = this.buffer;
      if (index2 === buffer.length) {
        return;
      }
      var group = this.fast[buffer.charCodeAt(index2)];
      if (group) {
        return this._token(group, buffer.charAt(index2), index2);
      }
      var re = this.re;
      re.lastIndex = index2;
      var match2 = eat(re, buffer);
      var error = this.error;
      if (match2 == null) {
        return this._token(error, buffer.slice(index2, buffer.length), index2);
      }
      var group = this._getGroup(match2);
      var text = match2[0];
      if (error.fallback && match2.index !== index2) {
        this.queuedGroup = group;
        this.queuedText = text;
        return this._token(error, buffer.slice(index2, match2.index), index2);
      }
      return this._token(group, text, index2);
    };
    Lexer.prototype._token = function(group, text, offset2) {
      var lineBreaks = 0;
      if (group.lineBreaks) {
        var matchNL = /\n/g;
        var nl = 1;
        if (text === "\n") {
          lineBreaks = 1;
        } else {
          while (matchNL.exec(text)) {
            lineBreaks++;
            nl = matchNL.lastIndex;
          }
        }
      }
      var token2 = {
        type: typeof group.type === "function" && group.type(text) || group.defaultType,
        value: typeof group.value === "function" ? group.value(text) : text,
        text,
        toString: tokenToString,
        offset: offset2,
        lineBreaks,
        line: this.line,
        col: this.col
      };
      var size = text.length;
      this.index += size;
      this.line += lineBreaks;
      if (lineBreaks !== 0) {
        this.col = size - nl + 1;
      } else {
        this.col += size;
      }
      if (group.shouldThrow) {
        var err = new Error(this.formatError(token2, "invalid syntax"));
        throw err;
      }
      if (group.pop)
        this.popState();
      else if (group.push)
        this.pushState(group.push);
      else if (group.next)
        this.setState(group.next);
      return token2;
    };
    if (typeof Symbol !== "undefined" && Symbol.iterator) {
      var LexerIterator = function(lexer2) {
        this.lexer = lexer2;
      };
      LexerIterator.prototype.next = function() {
        var token2 = this.lexer.next();
        return { value: token2, done: !token2 };
      };
      LexerIterator.prototype[Symbol.iterator] = function() {
        return this;
      };
      Lexer.prototype[Symbol.iterator] = function() {
        return new LexerIterator(this);
      };
    }
    Lexer.prototype.formatError = function(token2, message) {
      if (token2 == null) {
        var text = this.buffer.slice(this.index);
        var token2 = {
          text,
          offset: this.index,
          lineBreaks: text.indexOf("\n") === -1 ? 0 : 1,
          line: this.line,
          col: this.col
        };
      }
      var numLinesAround = 2;
      var firstDisplayedLine = Math.max(token2.line - numLinesAround, 1);
      var lastDisplayedLine = token2.line + numLinesAround;
      var lastLineDigits = String(lastDisplayedLine).length;
      var displayedLines = lastNLines(
        this.buffer,
        this.line - token2.line + numLinesAround + 1
      ).slice(0, 5);
      var errorLines = [];
      errorLines.push(message + " at line " + token2.line + " col " + token2.col + ":");
      errorLines.push("");
      for (var i = 0; i < displayedLines.length; i++) {
        var line2 = displayedLines[i];
        var lineNo = firstDisplayedLine + i;
        errorLines.push(pad(String(lineNo), lastLineDigits) + "  " + line2);
        if (lineNo === token2.line) {
          errorLines.push(pad("", lastLineDigits + token2.col + 1) + "^");
        }
      }
      return errorLines.join("\n");
    };
    Lexer.prototype.clone = function() {
      return new Lexer(this.states, this.state);
    };
    Lexer.prototype.has = function(tokenType) {
      return true;
    };
    return {
      compile: compile2,
      states: compileStates,
      error: Object.freeze({ error: true }),
      fallback: Object.freeze({ fallback: true }),
      keywords: keywordTransform
    };
  });
})(moo);
var mooExports = moo.exports;
(function(exports) {
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.lexer = exports.states = void 0;
  const moo_1 = __importDefault(mooExports);
  exports.states = {
    body: {
      doubleapos: { match: "''", value: () => "'" },
      quoted: {
        lineBreaks: true,
        match: /'[{}#](?:[^]*?[^'])?'(?!')/u,
        value: (src) => src.slice(1, -1).replace(/''/g, "'")
      },
      argument: {
        lineBreaks: true,
        match: /\{\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u,
        push: "arg",
        value: (src) => src.substring(1).trim()
      },
      octothorpe: "#",
      end: { match: "}", pop: 1 },
      content: { lineBreaks: true, match: /[^][^{}#']*/u }
    },
    arg: {
      select: {
        lineBreaks: true,
        match: /,\s*(?:plural|select|selectordinal)\s*,\s*/u,
        next: "select",
        value: (src) => src.split(",")[1].trim()
      },
      "func-args": {
        lineBreaks: true,
        match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*,/u,
        next: "body",
        value: (src) => src.split(",")[1].trim()
      },
      "func-simple": {
        lineBreaks: true,
        match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u,
        value: (src) => src.substring(1).trim()
      },
      end: { match: "}", pop: 1 }
    },
    select: {
      offset: {
        lineBreaks: true,
        match: /\s*offset\s*:\s*\d+\s*/u,
        value: (src) => src.split(":")[1].trim()
      },
      case: {
        lineBreaks: true,
        match: /\s*(?:=\d+|[^\p{Pat_Syn}\p{Pat_WS}]+)\s*\{/u,
        push: "body",
        value: (src) => src.substring(0, src.indexOf("{")).trim()
      },
      end: { match: /\s*\}/u, pop: 1 }
    }
  };
  exports.lexer = moo_1.default.states(exports.states);
})(lexer);
Object.defineProperty(parser, "__esModule", { value: true });
var parse_1 = parser.parse = parser.ParseError = void 0;
const lexer_js_1 = lexer;
const getContext = (lt) => ({
  offset: lt.offset,
  line: lt.line,
  col: lt.col,
  text: lt.text,
  lineBreaks: lt.lineBreaks
});
const isSelectType = (type) => type === "plural" || type === "select" || type === "selectordinal";
function strictArgStyleParam(lt, param) {
  let value = "";
  let text = "";
  for (const p of param) {
    const pText = p.ctx.text;
    text += pText;
    switch (p.type) {
      case "content":
        value += p.value;
        break;
      case "argument":
      case "function":
      case "octothorpe":
        value += pText;
        break;
      default:
        throw new ParseError(lt, `Unsupported part in strict mode function arg style: ${pText}`);
    }
  }
  const c2 = {
    type: "content",
    value: value.trim(),
    ctx: Object.assign({}, param[0].ctx, { text })
  };
  return [c2];
}
const strictArgTypes = [
  "number",
  "date",
  "time",
  "spellout",
  "ordinal",
  "duration"
];
const defaultPluralKeys = ["zero", "one", "two", "few", "many", "other"];
class ParseError extends Error {
  /** @internal */
  constructor(lt, msg) {
    super(lexer_js_1.lexer.formatError(lt, msg));
  }
}
parser.ParseError = ParseError;
class Parser {
  constructor(src, opt) {
    var _a, _b, _c, _d;
    this.lexer = lexer_js_1.lexer.reset(src);
    this.cardinalKeys = (_a = opt === null || opt === void 0 ? void 0 : opt.cardinal) !== null && _a !== void 0 ? _a : defaultPluralKeys;
    this.ordinalKeys = (_b = opt === null || opt === void 0 ? void 0 : opt.ordinal) !== null && _b !== void 0 ? _b : defaultPluralKeys;
    this.strict = (_c = opt === null || opt === void 0 ? void 0 : opt.strict) !== null && _c !== void 0 ? _c : false;
    this.strictPluralKeys = (_d = opt === null || opt === void 0 ? void 0 : opt.strictPluralKeys) !== null && _d !== void 0 ? _d : true;
  }
  parse() {
    return this.parseBody(false, true);
  }
  checkSelectKey(lt, type, key) {
    if (key[0] === "=") {
      if (type === "select")
        throw new ParseError(lt, `The case ${key} is not valid with select`);
    } else if (type !== "select") {
      const keys = type === "plural" ? this.cardinalKeys : this.ordinalKeys;
      if (this.strictPluralKeys && keys.length > 0 && !keys.includes(key)) {
        const msg = `The ${type} case ${key} is not valid in this locale`;
        throw new ParseError(lt, msg);
      }
    }
  }
  parseSelect({ value: arg }, inPlural, ctx, type) {
    const sel = { type, arg, cases: [], ctx };
    if (type === "plural" || type === "selectordinal")
      inPlural = true;
    else if (this.strict)
      inPlural = false;
    for (const lt of this.lexer) {
      switch (lt.type) {
        case "offset":
          if (type === "select")
            throw new ParseError(lt, "Unexpected plural offset for select");
          if (sel.cases.length > 0)
            throw new ParseError(lt, "Plural offset must be set before cases");
          sel.pluralOffset = Number(lt.value);
          ctx.text += lt.text;
          ctx.lineBreaks += lt.lineBreaks;
          break;
        case "case": {
          this.checkSelectKey(lt, type, lt.value);
          sel.cases.push({
            key: lt.value,
            tokens: this.parseBody(inPlural),
            ctx: getContext(lt)
          });
          break;
        }
        case "end":
          return sel;
        default:
          throw new ParseError(lt, `Unexpected lexer token: ${lt.type}`);
      }
    }
    throw new ParseError(null, "Unexpected message end");
  }
  parseArgToken(lt, inPlural) {
    const ctx = getContext(lt);
    const argType = this.lexer.next();
    if (!argType)
      throw new ParseError(null, "Unexpected message end");
    ctx.text += argType.text;
    ctx.lineBreaks += argType.lineBreaks;
    if (this.strict && (argType.type === "func-simple" || argType.type === "func-args") && !strictArgTypes.includes(argType.value)) {
      const msg = `Invalid strict mode function arg type: ${argType.value}`;
      throw new ParseError(lt, msg);
    }
    switch (argType.type) {
      case "end":
        return { type: "argument", arg: lt.value, ctx };
      case "func-simple": {
        const end2 = this.lexer.next();
        if (!end2)
          throw new ParseError(null, "Unexpected message end");
        if (end2.type !== "end")
          throw new ParseError(end2, `Unexpected lexer token: ${end2.type}`);
        ctx.text += end2.text;
        if (isSelectType(argType.value.toLowerCase()))
          throw new ParseError(argType, `Invalid type identifier: ${argType.value}`);
        return {
          type: "function",
          arg: lt.value,
          key: argType.value,
          ctx
        };
      }
      case "func-args": {
        if (isSelectType(argType.value.toLowerCase())) {
          const msg = `Invalid type identifier: ${argType.value}`;
          throw new ParseError(argType, msg);
        }
        let param = this.parseBody(this.strict ? false : inPlural);
        if (this.strict && param.length > 0)
          param = strictArgStyleParam(lt, param);
        return {
          type: "function",
          arg: lt.value,
          key: argType.value,
          param,
          ctx
        };
      }
      case "select":
        if (isSelectType(argType.value))
          return this.parseSelect(lt, inPlural, ctx, argType.value);
        else
          throw new ParseError(argType, `Unexpected select type ${argType.value}`);
      default:
        throw new ParseError(argType, `Unexpected lexer token: ${argType.type}`);
    }
  }
  parseBody(inPlural, atRoot) {
    const tokens = [];
    let content = null;
    for (const lt of this.lexer) {
      if (lt.type === "argument") {
        if (content)
          content = null;
        tokens.push(this.parseArgToken(lt, inPlural));
      } else if (lt.type === "octothorpe" && inPlural) {
        if (content)
          content = null;
        tokens.push({ type: "octothorpe", ctx: getContext(lt) });
      } else if (lt.type === "end" && !atRoot) {
        return tokens;
      } else {
        let value = lt.value;
        if (!inPlural && lt.type === "quoted" && value[0] === "#") {
          if (value.includes("{")) {
            const errMsg = `Unsupported escape pattern: ${value}`;
            throw new ParseError(lt, errMsg);
          }
          value = lt.text;
        }
        if (content) {
          content.value += value;
          content.ctx.text += lt.text;
          content.ctx.lineBreaks += lt.lineBreaks;
        } else {
          content = { type: "content", value, ctx: getContext(lt) };
          tokens.push(content);
        }
      }
    }
    if (atRoot)
      return tokens;
    throw new ParseError(null, "Unexpected message end");
  }
}
function parse$1(src, options = {}) {
  const parser2 = new Parser(src, options);
  return parser2.parse();
}
parse_1 = parser.parse = parse$1;
function processTokens(tokens, mapText) {
  if (!tokens.filter((token2) => token2.type !== "content").length) {
    return tokens.map((token2) => mapText(token2.value)).join("");
  }
  return tokens.map((token2) => {
    var _a;
    if (token2.type === "content") {
      return mapText(token2.value);
    } else if (token2.type === "octothorpe") {
      return "#";
    } else if (token2.type === "argument") {
      return [token2.arg];
    } else if (token2.type === "function") {
      const _param = (_a = token2 == null ? void 0 : token2.param) == null ? void 0 : _a[0];
      if (_param) {
        return [token2.arg, token2.key, _param.value.trim()];
      } else {
        return [token2.arg, token2.key];
      }
    }
    const offset2 = token2.pluralOffset;
    const formatProps = {};
    token2.cases.forEach(({ key, tokens: tokens2 }) => {
      const prop = key[0] === "=" ? key.slice(1) : key;
      formatProps[prop] = processTokens(tokens2, mapText);
    });
    return [
      token2.arg,
      token2.type,
      __spreadValues({
        offset: offset2
      }, formatProps)
    ];
  });
}
function compileMessage(message, mapText = (v) => v) {
  try {
    return processTokens(parse_1(message), mapText);
  } catch (e2) {
    console.error(`${e2.message} 

Message: ${message}`);
    return message;
  }
}
const isString$2 = (s2) => typeof s2 === "string";
const isFunction = (f) => typeof f === "function";
const cache = /* @__PURE__ */ new Map();
const defaultLocale = "en";
function normalizeLocales(locales) {
  const out = Array.isArray(locales) ? locales : [locales];
  return [...out, defaultLocale];
}
function date(locales, value, format) {
  const _locales = normalizeLocales(locales);
  const formatter = getMemoized(
    () => cacheKey("date", _locales, format),
    () => new Intl.DateTimeFormat(_locales, format)
  );
  return formatter.format(isString$2(value) ? new Date(value) : value);
}
function number$2(locales, value, format) {
  const _locales = normalizeLocales(locales);
  const formatter = getMemoized(
    () => cacheKey("number", _locales, format),
    () => new Intl.NumberFormat(_locales, format)
  );
  return formatter.format(value);
}
function plural(locales, ordinal, value, _a) {
  var _b = _a, { offset: offset2 = 0 } = _b, rules = __objRest(_b, ["offset"]);
  var _a2, _b2;
  const _locales = normalizeLocales(locales);
  const plurals = ordinal ? getMemoized(
    () => cacheKey("plural-ordinal", _locales),
    () => new Intl.PluralRules(_locales, { type: "ordinal" })
  ) : getMemoized(
    () => cacheKey("plural-cardinal", _locales),
    () => new Intl.PluralRules(_locales, { type: "cardinal" })
  );
  return (_b2 = (_a2 = rules[value]) != null ? _a2 : rules[plurals.select(value - offset2)]) != null ? _b2 : rules.other;
}
function getMemoized(getKey, construct) {
  const key = getKey();
  let formatter = cache.get(key);
  if (!formatter) {
    formatter = construct();
    cache.set(key, formatter);
  }
  return formatter;
}
function cacheKey(type, locales, options) {
  const localeKey = locales.join("-");
  return `${type}-${localeKey}-${JSON.stringify(options)}`;
}
const UNICODE_REGEX = /\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/g;
const OCTOTHORPE_PH = "%__lingui_octothorpe__%";
const getDefaultFormats = (locale, passedLocales, formats = {}) => {
  const locales = passedLocales || locale;
  const style2 = (format) => {
    return typeof format === "object" ? format : formats[format] || { style: format };
  };
  const replaceOctothorpe = (value, message) => {
    const numberFormat = Object.keys(formats).length ? style2("number") : void 0;
    const valueStr = number$2(locales, value, numberFormat);
    return message.replace(new RegExp(OCTOTHORPE_PH, "g"), valueStr);
  };
  return {
    plural: (value, cases) => {
      const { offset: offset2 = 0 } = cases;
      const message = plural(locales, false, value, cases);
      return replaceOctothorpe(value - offset2, message);
    },
    selectordinal: (value, cases) => {
      const { offset: offset2 = 0 } = cases;
      const message = plural(locales, true, value, cases);
      return replaceOctothorpe(value - offset2, message);
    },
    select: selectFormatter,
    number: (value, format) => number$2(locales, value, style2(format)),
    date: (value, format) => date(locales, value, style2(format))
  };
};
const selectFormatter = (value, rules) => {
  var _a;
  return (_a = rules[value]) != null ? _a : rules.other;
};
function interpolate$2(translation, locale, locales) {
  return (values2 = {}, formats) => {
    const formatters = getDefaultFormats(locale, locales, formats);
    const formatMessage = (tokens, replaceOctothorpe = false) => {
      if (!Array.isArray(tokens))
        return tokens;
      return tokens.reduce((message, token2) => {
        if (token2 === "#" && replaceOctothorpe) {
          return message + OCTOTHORPE_PH;
        }
        if (isString$2(token2)) {
          return message + token2;
        }
        const [name, type, format] = token2;
        let interpolatedFormat = {};
        if (type === "plural" || type === "selectordinal" || type === "select") {
          Object.entries(format).forEach(
            ([key, value2]) => {
              interpolatedFormat[key] = formatMessage(
                value2,
                type === "plural" || type === "selectordinal"
              );
            }
          );
        } else {
          interpolatedFormat = format;
        }
        let value;
        if (type) {
          const formatter = formatters[type];
          value = formatter(values2[name], interpolatedFormat);
        } else {
          value = values2[name];
        }
        if (value == null) {
          return message;
        }
        return message + value;
      }, "");
    };
    const result = formatMessage(translation);
    if (isString$2(result) && UNICODE_REGEX.test(result)) {
      return dist.unraw(result.trim());
    }
    if (isString$2(result))
      return result.trim();
    return result ? String(result) : "";
  };
}
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class EventEmitter {
  constructor() {
    __publicField$1(this, "_events", {});
  }
  on(event, listener) {
    var _a2;
    var _a;
    (_a2 = (_a = this._events)[event]) != null ? _a2 : _a[event] = [];
    this._events[event].push(listener);
    return () => this.removeListener(event, listener);
  }
  removeListener(event, listener) {
    const maybeListeners = this._getListeners(event);
    if (!maybeListeners)
      return;
    const index2 = maybeListeners.indexOf(listener);
    if (~index2)
      maybeListeners.splice(index2, 1);
  }
  emit(event, ...args) {
    const maybeListeners = this._getListeners(event);
    if (!maybeListeners)
      return;
    maybeListeners.map((listener) => listener.apply(this, args));
  }
  _getListeners(event) {
    const maybeListeners = this._events[event];
    return Array.isArray(maybeListeners) ? maybeListeners : false;
  }
}
var __defProp2 = Object.defineProperty;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class I18n extends EventEmitter {
  constructor(params) {
    var _a;
    super();
    __publicField(this, "_locale", "");
    __publicField(this, "_locales");
    __publicField(this, "_localeData", {});
    __publicField(this, "_messages", {});
    __publicField(this, "_missing");
    __publicField(this, "t", this._.bind(this));
    if (params.missing != null)
      this._missing = params.missing;
    if (params.messages != null)
      this.load(params.messages);
    if (params.localeData != null)
      this.loadLocaleData(params.localeData);
    if (typeof params.locale === "string" || params.locales) {
      this.activate((_a = params.locale) != null ? _a : defaultLocale, params.locales);
    }
  }
  get locale() {
    return this._locale;
  }
  get locales() {
    return this._locales;
  }
  get messages() {
    var _a;
    return (_a = this._messages[this._locale]) != null ? _a : {};
  }
  /**
   * @deprecated this has no effect. Please remove this from the code. Deprecated in v4
   */
  get localeData() {
    var _a;
    return (_a = this._localeData[this._locale]) != null ? _a : {};
  }
  _loadLocaleData(locale, localeData) {
    const maybeLocaleData = this._localeData[locale];
    if (!maybeLocaleData) {
      this._localeData[locale] = localeData;
    } else {
      Object.assign(maybeLocaleData, localeData);
    }
  }
  /**
   * @deprecated Plurals automatically used from Intl.PluralRules you can safely remove this call. Deprecated in v4
   */
  // @ts-ignore deprecated, so ignore the reported error
  loadLocaleData(localeOrAllData, localeData) {
    if (localeData != null) {
      this._loadLocaleData(localeOrAllData, localeData);
    } else {
      Object.keys(localeOrAllData).forEach(
        (locale) => this._loadLocaleData(locale, localeOrAllData[locale])
      );
    }
    this.emit("change");
  }
  _load(locale, messages2) {
    const maybeMessages = this._messages[locale];
    if (!maybeMessages) {
      this._messages[locale] = messages2;
    } else {
      Object.assign(maybeMessages, messages2);
    }
  }
  load(localeOrMessages, messages2) {
    if (typeof localeOrMessages == "string" && typeof messages2 === "object") {
      this._load(localeOrMessages, messages2);
    } else {
      Object.entries(localeOrMessages).forEach(
        ([locale, messages22]) => this._load(locale, messages22)
      );
    }
    this.emit("change");
  }
  /**
   * @param options {@link LoadAndActivateOptions}
   */
  loadAndActivate({ locale, locales, messages: messages2 }) {
    this._locale = locale;
    this._locales = locales || void 0;
    this._messages[this._locale] = messages2;
    this.emit("change");
  }
  activate(locale, locales) {
    if (process.env.NODE_ENV !== "production") {
      if (!this._messages[locale]) {
        console.warn(`Messages for locale "${locale}" not loaded.`);
      }
    }
    this._locale = locale;
    this._locales = locales;
    this.emit("change");
  }
  _(id2, values2, options) {
    let message = options == null ? void 0 : options.message;
    if (!id2) {
      id2 = "";
    }
    if (!isString$2(id2)) {
      values2 = id2.values || values2;
      message = id2.message;
      id2 = id2.id;
    }
    const messageForId = this.messages[id2];
    const messageMissing = messageForId === void 0;
    const missing = this._missing;
    if (missing && messageMissing) {
      return isFunction(missing) ? missing(this._locale, id2) : missing;
    }
    if (messageMissing) {
      this.emit("missing", { id: id2, locale: this._locale });
    }
    let translation = messageForId || message || id2;
    if (process.env.NODE_ENV !== "production") {
      translation = isString$2(translation) ? compileMessage(translation) : translation;
    }
    if (isString$2(translation) && UNICODE_REGEX.test(translation))
      return JSON.parse(`"${translation}"`);
    if (isString$2(translation))
      return translation;
    return interpolate$2(
      translation,
      this._locale,
      this._locales
    )(values2, options == null ? void 0 : options.formats);
  }
  date(value, format) {
    return date(this._locales || this._locale, value, format);
  }
  number(value, format) {
    return number$2(this._locales || this._locale, value, format);
  }
}
function setupI18n(params = {}) {
  return new I18n(params);
}
const i18n = setupI18n();
const messages$1 = JSON.parse(`{"NmTvB0":[["0"],"% unlocked"],"pRV3nZ":[["diffDays"]," days"],"A0Ugqv":"<0>Learn more about our identity verification</0>","5qvhUJ":"<0>Log out</0>","TaFX2+":"10 characters minimum","AeXO77":"Account","QcyjR1":["Account ",["0"]],"JgquTG":"Accreditation status in review","fAZ5ZQ":"Accreditation verified","5K91US":"Add an account","XZQxVd":"Add Cash","BSj/hz":"Add funds","rI7mWy":"Agree and continue","EP1J4F":"Agree to the terms below to start verifying your identity. You can continue to CoinList once we have verified your identity.","+G7dyH":"Agree to the terms below to start your identity verification. You can continue to CoinList once we have verified your identity.","DaolRP":"Allocation","FnEjg1":["An email has been sent to ",["emailInput"]],"Z9mCS6":"Authentication code","Mw7gxi":"Back to CoinList","QIc67y":"BACK TO COINLIST","KW2Pmm":"Buy, custody, and trade crypto under an organization.","dEgA5A":"Cancel","feCRNv":"Change email","Xl7vxL":"Change your email","4+5GhB":"Click the “+” icon in your authentication app to add a new account and scan the QR code or enter the setup key. Once added, enter the code generated by your authentication app.","EWPtMO":"Code","dCdZS6":"CoinList is unavailable in your country or region","QBkNUx":"Complete your identity verification to add a new account. You may always switch to a different account at any time using the account selector in the top right.","xnWESi":"Confirm password","p2/GCq":"Confirm Password","t0qQZE":"Confirm your password","xGVfLh":"Continue","BXa05P":"Continue to CoinList","7uKeXr":"Continue to Wallet","6V3Ea3":"Copied","S9/u59":"Copy codes","PeJVpn":"Copy setup key","X1eXLH":"Create a CoinList account","/rRuUa":"Create a CoinList Business account","1hMWR6":"Create account","TCHTjf":"Current email","S56gjX":"Decline and log out","kj3M8S":"Deposit","Rvnj6+":"Don’t miss out on the next Token Launch","UsYcv3":"Don’t miss out on the next Token Sale","DPfwMq":"Done","i99UAx":"Download an authentication app of your choice on your mobile device before you continue.","41bm2z":"Earn Karma","XnWHON":"Earn Karma to increase your chance of joining the next Token Launch","qDgiqn":"Ecosystem Launches","O3oNi5":"Email","AcnTuz":"Email already in use","nenSSa":"Email succesfuly updated.","ELlD6h":"Enter a new email address","dDyAXD":"Enter a new password","IxYE8T":"Enter a new password for your CoinList account.","lPgKS3":"Enter code","vZ2jsw":"Enter confirm password","6p1fc7":"Enter the code generated by your authentication app to continue.","oIFqPS":"Enter the code generated by your authentication app to verify your login.","kDuqo+":"Enter the email for the account you forgot your password for and we’ll send you a link to reset your password.","V7whZu":"Enter the email of the account you are logging into and we’ll send you a link to reset your password.","f/GGcY":"Enter your authentication code","C3nD/1":"Enter your email","1e4Srk":"Enter your email.","NgaR6B":"Enter your password","whludS":"Enter your work email","EncOi3":"Exit and view my Wallet","tS8BaO":"Exit to dashboard","8tjQCz":"Explore","Xdajro":"Explore past sales","h5orlC":"Explore token launches from our ecosystem partners","fgFYgz":"Final step","AunxeR":"Financial regulations require us to confirm your information is still accurate. Once completed, you can continue to invest on CoinList.","X79s1a":"Financial regulations require us to confirm your information is still accurate. Once completed, you can continue to invest on CoinList. You can access your Wallet if you choose not to re-verify at this time.","gAEgnt":"Financial regulations require us to confirm your information is still accurate. Once completed, you can continue to invest on CoinList. You may continue to your Wallet if you choose not to re-verify at this time.","HXJqy3":"Financial regulations require us to confirm your information is still accurate. Re-verify your identity to continue using CoinList.","1Ye+/r":"Follow the instructions in the email we’ve sent to","I7Exsw":"Follow us on X","eqRNG5":"Get started by investing in Token Sales. Access to wallet and trading are not supported by your state at this time.","1IScCi":"Get tokens before they list anywhere else","/Q8XNq":"Get tokens before they list on other exchanges","C1DCFO":"Having trouble?","c3XJ18":"Help","puIMZD":"https://coinlist.co/help/set-up-two-factor-authentication","jcBGHt":"I agree not to fund this account from a <0>private banking account</0>","bTmKqi":"I agree that I am not – nor is anyone in my immediate household – associated with FINRA, a FINRA-member broker-dealer, or the SEC","Ip9uRS":"I agree that I am not a <0>politically exposed person</0> (PEP) or immediate family or close associate of a politically exposed person","6DJL5w":"I agree that this account is not a <0>foreign financial institution</0> or <1>foreign shell bank</1>","Su17Hs":"I agree to the <0>Terms of Service</0> and the <1>Privacy Policy</1>","QNg/2A":"I agree to the <0>Terms of Service</0>and the <1>Privacy Policy</1>","nass+x":"Identity in review","qt4J8t":"Identity rejected","eMvjNv":"Identity verified","hyXak8":"If there are any remaining funds in your Wallet, continue to withdraw them. You will no longer have access to CoinList's products and services once your account balance reaches zero.","c0xDoX":"Individuals in the U.S. must verify that they're an accredited investor to invest in Token Sales.","XILg0L":"Invalid email address","TXHuXK":"It looks like this link has already been used or has expired. Please return to CoinList and try again.","5Ehy8S":"Join the next big Token Launch.","gbW0ta":"Learn more about our identity verification","N0AaQl":"Learn more about setting up 2FA","sQia9P":"Log in","6UbQ3u":"Log in to CoinList","FgAxTj":"Log out","VJIXn+":"Lost your 2FA?","/IfJQv":"Make sure you have access to your email. You must verify your email before continuing.","2FYpfJ":"More","PYf+ML":"Need a Business Account? <0>Sign up <1/></0>","tC1RSd":"Need a Business Account? <0>Sign up<1/></0>","k/YP30":"Need a Personal Account? <0>Sign up <1/></0>","xqAzrN":"New email","7vhWI8":"New Password","Eolc0F":"Next distribution","19db8o":"No, I do not qualify","LLAa/9":"Optional","8ZsakT":"Password","VCL2z1":"Password don't match","m/25r1":"Password saved","2BlKXa":"Passwords don't match","io0enF":"Please enter a valid email","MqA4qt":"Portfolio","VWStic":"Re-verify your identity","zjEFCa":"Remember me","MyjAbr":"Resend","GD9Rsj":"Resent","slOprG":"Reset your password","eTg71g":"Retry accreditation","tfDRzk":"Save","txnnFL":"Save your backup codes","JlFcis":"Send","T65b7l":"Set up two-factor authentication","Tz0i8g":"Settings","tXkhj/":"Start","hQRttt":"Submit","VApyUg":"There was an error","qsWho/":"There was an error creating the entity","axWtcV":"This email is associated with an account. <0>Log in?</0>","2V8vJF":"This email is not associated with an account. <0>Sign up?</0>","7mDP6a":"to be announced","TP9/K5":"Token","M9b4Fq":"Token Launch","xB/9hv":"Token Launches","MLuGvV":"Token Sales","tygisN":"Unable to verify your accreditation status","1vq5nf":"Unable to verify your identity","AULyh4":"Use a security key to log in »","uSMfoN":"Verify","/IBv6X":"Verify your email","+yVK40":"Verify your identity","NhbQd/":"Verify your login","jpctdh":"View","N6Pxr9":"View all","oarJCB":"View assets","rhJPjn":"View less","TZsuwl":"View my Wallet","VBu2zJ":"Visit our blog","VCXqZD":"We are reviewing your accreditation status. We'll send you an email with an update on your status.","X53EwO":"We are reviewing your accreditation status. You may continue to use CoinList while this is being reviewed.","g1ZEHz":"We are reviewing your identity. We’ll send you an email with an update on your status. You may safely close this browser.","iP2KH3":"We were unable to verify your identity after reviewing the information submitted. Learn about our identity verification.","cbRW54":"We were unable to verify your identity after reviewing the information submitted. You will not be able to access CoinList at this time.","Hq8OI1":"We'll send you an email with an update on your verification after our review is complete.","3Iqf7D":"We'll send you an email with an update on your verification after our review is complete. Your account is restricted to withdrawals at this time.","jwpy5i":"We’ll send you an email with an update on your verification after our review is complete. Your account is restricted to withdrawals at this time.","1ZF9KQ":"When","UWHEkW":"Work email","KGzdyA":"Would you like to invest in Token Sales?","EK6YGK":"Wrong code","havey5":"Wrong code <0>Lost your 2FA?</0>","fV2Bu6":"Wrong password","G9V/if":"Wrong password <0>Forgot your password?</0>","API151":"Yes, I qualify","VC36G0":"You are approved to invest in Token Sales","ZOWGZ9":"You did not meet the requirements to be an accredited investor. We'll let you know when CoinList becomes available in your state.","Otc1oj":"You did not meet the requirements to be an accredited investor. You will not be able to invest in Token Sales at this time.","WXVVKP":"You no longer have access to CoinList.","2A9Wbg":"You no longer have access to CoinList. If there are any remaining funds in your Wallet, continue to withdraw them.","VSzHtP":"You will have access to CoinList wallet and trading but will not be able to invest in Token Sales at this time.","48SoOT":"You will not be able to access CoinList at this time because you live in one of our <0>unsupported countries & states</0>. If there are any remaining funds in your Wallet, continue to withdraw them.","kwH6Rr":"You will not be able to access CoinList at this time because you live in one of our <0>unsupported countries & states</0>. We'll let you know when CoinList becomes available in your region.","7iOV3m":"You will not be able to access CoinList at this time because you live in one of our <0>unsupported countries & states</0>. We’ll let you know when CoinList becomes available in your region.","SHtFF4":"You will not be able to access CoinList at this time because you live in one of our <0>unsupported states</0> and did not meet the requirements to be an accredited investor. We'll let you know when CoinList becomes available in your state.","8vxXyH":"You will not be able to access CoinList. <0>Learn more about our identity verification.</0>","7TVyuz":"You will not be able to access CoinList. If there are any remaining funds in your Wallet, continue to withdraw them.","Xarf4G":"Your access to CoinList has been restricted","OMniYn":"Your accreditation status has been successfully verified and you can now invest in Token Sales.","6OPNcL":"Your backup codes can help you log into your account if you lose your authentication device. Each code can be used only once. Copy your codes and store them somewhere safe to continue.","+OSLTm":"Your identity has been successfully verified and you can now continue to CoinList.","Ubswu3":"Your identity has been successfully verified.","sCHNLH":"Your security is important to us at CoinList. We require all accounts to set up two-factor authentication to protect you and your funds.","zX7Mg4":"Your tokens that have been listed and are available to trade"}`);
const translationsEN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  messages: messages$1
}, Symbol.toStringTag, { value: "Module" }));
const messages = JSON.parse(`{"NmTvB0":[["0"],"% kilidi açıldı"],"pRV3nZ":[["diffDays"]," gün"],"A0Ugqv":"<0>Learn more about our identity verification</0>","5qvhUJ":"<0>Log out</0>","TaFX2+":"minimum 10 karakter","AeXO77":"Hesap","QcyjR1":["Hesap ",["0"]],"JgquTG":"Accreditation status in review","fAZ5ZQ":"Accreditation verified","5K91US":"Bir hesap ekleyin","XZQxVd":"Add Cash","BSj/hz":"Add funds","rI7mWy":"Kabul edin ve devam edin","EP1J4F":"Agree to the terms below to start verifying your identity. You can continue to CoinList once we have verified your identity.","+G7dyH":"Kimlik doğrulamanızı başlatmak için aşağıdaki şartları kabul edin. Kimliğinizi doğruladıktan sonra CoinList'e devam edebilirsiniz.","DaolRP":"Allocation","FnEjg1":[["emailInput"],"] adresine bir e-posta gönderildi"],"Z9mCS6":"Çift faktörlü doğrulama kodu\\n","Mw7gxi":"Back to CoinList","QIc67y":"COINLIST'E GERİ DÖNÜN","KW2Pmm":"Bir organizasyon olarak kripto satın alın, saklayın ve alım satım yapın.","dEgA5A":"İptal\\n","feCRNv":"E-posta değiştir","Xl7vxL":"E-posta adresinizi değiştirin","4+5GhB":"Yeni bir hesap eklemek için çift faktörlü doğrulama uygulamanızdaki \\"+\\" simgesine tıklayın ve QR kodunu tarayın veya kurulum anahtarını girin. Eklendikten sonra, çift faktörlü doğrulama uygulamanız tarafından oluşturulan kodu girin.\\n","EWPtMO":"Kod","dCdZS6":"CoinList ülkenizde veya bölgenizde kullanılamıyor","QBkNUx":"Yeni bir hesap eklemek için kimlik doğrulamanızı tamamlayın. Sağ üstteki hesap seçme eklentisini kullanarak istediğiniz zaman farklı bir hesaba geçebilirsiniz.","xnWESi":"Şifreyi onayla","p2/GCq":"Confirm Password","t0qQZE":"Şifrenizi onaylayın","xGVfLh":"Devam et","BXa05P":"Continue to CoinList","7uKeXr":"Continue to Wallet","6V3Ea3":"Kopyalandı","S9/u59":"Kodları kopyala","PeJVpn":"Kurulum anahtarını kopyala\\n","X1eXLH":"Bir CoinList hesabı oluşturun","/rRuUa":"Kurumsal bir CoinList hesabı oluşturun","1hMWR6":"Hesap oluştur","TCHTjf":"Güncel e-posta","S56gjX":"Reddet ve oturumu kapat","kj3M8S":"Deposit","Rvnj6+":"Don’t miss out on the next Token Launch","UsYcv3":"Don’t miss out on the next Token Sale","DPfwMq":"Tamamlandı","i99UAx":"Devam etmeden önce mobil cihazınıza seçtiğiniz bir çift faktörlü doğrulama uygulamasını indirin.","41bm2z":"Earn Karma","XnWHON":"Earn Karma to increase your chance of joining the next Token Launch","qDgiqn":"Ecosystem Launches","O3oNi5":"E-posta","AcnTuz":"E-posta adresi zaten kullanımda\\n","nenSSa":"E-posta başarıyla güncellendi.","ELlD6h":"Yeni bir e-posta adresi girin","dDyAXD":"Yeni bir şifre girin","IxYE8T":"CoinList hesabınız için yeni bir şifre girin.","lPgKS3":"Kodu girin","vZ2jsw":"Enter confirm password","6p1fc7":"Enter the code generated by your authentication app to continue.","oIFqPS":"Girişinizi doğrulamak için çift faktörlü doğrulama uygulamanız tarafından oluşturulan kodu girin.","kDuqo+":"Enter the email for the account you forgot your password for and we’ll send you a link to reset your password.","V7whZu":"Giriş yaptığınız hesabın e-postasını girin ve size şifrenizi sıfırlamanız için bir bağlantı gönderelim.","f/GGcY":"Çift faktörlü doğrulama kodunuzu girin","C3nD/1":"E-posta adresinizi girin","1e4Srk":"Enter your email.","NgaR6B":"Şifrenizi girin","whludS":"İş e-postanızı girin","EncOi3":"Exit and view my Wallet","tS8BaO":"Anasayfaya dön","8tjQCz":"Explore","Xdajro":"Explore past sales","h5orlC":"Explore token launches from our ecosystem partners","fgFYgz":"Final step","AunxeR":"Financial regulations require us to confirm your information is still accurate. Once completed, you can continue to invest on CoinList.","X79s1a":"Financial regulations require us to confirm your information is still accurate. Once completed, you can continue to invest on CoinList. You can access your Wallet if you choose not to re-verify at this time.","gAEgnt":"Financial regulations require us to confirm your information is still accurate. Once completed, you can continue to invest on CoinList. You may continue to your Wallet if you choose not to re-verify at this time.","HXJqy3":"Financial regulations require us to confirm your information is still accurate. Re-verify your identity to continue using CoinList.","1Ye+/r":"Gönderdiğimiz e-postadaki talimatları uygulayın","I7Exsw":"Follow us on X","eqRNG5":"Get started by investing in Token Sales. Access to wallet and trading are not supported by your state at this time.","1IScCi":"Get tokens before they list anywhere else","/Q8XNq":"Get tokens before they list on other exchanges","C1DCFO":"Sorun mu yaşıyorsunuz?","c3XJ18":"Yardım","puIMZD":"https://coinlist.co/help/set-up-two-factor-authentication","jcBGHt":"Bu hesaba <0>özel bir bankacılık hesabından</0> para yatırmamayı kabul ediyorum","bTmKqi":"FINRA, FINRA üyesi bir broker-dealer veya SEC ile ilişkili olmadığımı -ve yakın çevremdeki herhangi birinin olmadığını- kabul ediyorum","Ip9uRS":"Ben, <0>Siyasi Nüfuz Sahibi Kişi</0> (PEP) veya siyasi olarak nüfuz sahibi bir kişinin birinci dereceden akrabası veya yakın arkadaşı olmadığımı kabul ediyorum","6DJL5w":"Bu hesabın <0>yabancı bir finans kurumu</0> veya <1>yabancı bir paravan banka</1> olmadığını kabul ediyorum","Su17Hs":"<0>Hizmet Koşullarını</0> ve <1>Gizlilik Politikasını</1> kabul ediyorum","QNg/2A":"I agree to the <0>Terms of Service</0>and the <1>Privacy Policy</1>","nass+x":"Kimliğinizi gözden geçiriyoruz","qt4J8t":"Identity rejected","eMvjNv":"Kimliğiniz doğrulandı","hyXak8":"If there are any remaining funds in your Wallet, continue to withdraw them. You will no longer have access to CoinList's products and services once your account balance reaches zero.","c0xDoX":"Individuals in the U.S. must verify that they're an accredited investor to invest in Token Sales.","XILg0L":"Invalid email address","TXHuXK":"Bu bağlantı zaten kullanılmış veya süresi dolmuş gibi görünüyor. Lütfen CoinList'e geri dönün ve tekrar deneyin.","5Ehy8S":"Sıradaki Büyük Token Lansmanına Katıl","gbW0ta":"Learn more about our identity verification","N0AaQl":"2FA kurulumu hakkında daha fazla bilgi edinin","sQia9P":"Giriş yap","6UbQ3u":"CoinList'e giriş yapın","FgAxTj":"Oturumu kapat","VJIXn+":"2FA'nızı mı kaybettiniz?","/IfJQv":"E-postanıza erişiminiz olduğundan emin olun. Devam etmeden önce e-postanızı doğrulamanız gerekir.","2FYpfJ":"Daha fazla bilgi edinin","PYf+ML":"İşletme Hesabına mı İhtiyacınız Var? <0>Kaydolun <1/></0>","tC1RSd":"Need a Business Account? <0>Sign up<1/></0>","k/YP30":"Kişisel Hesaba mı İhtiyacınız Var? <0>Kaydolun <1/></0>","xqAzrN":"Yeni e-posta","7vhWI8":"Yeni Şifre","Eolc0F":"Sonraki dağıtım","19db8o":"No, I do not qualify","LLAa/9":"Optional","8ZsakT":"Şifre","VCL2z1":"Password don't match","m/25r1":"Şifre kaydedildi","2BlKXa":"Parolalar eşleşmiyor","io0enF":"Lütfen geçerli bir e-posta girin","MqA4qt":"Portföy","VWStic":"Kimliğinizi yeniden doğrulayın","zjEFCa":"Beni hatırla","MyjAbr":"Yeniden Gönder","GD9Rsj":"Yeniden Gönderildi","slOprG":"Şifrenizi sıfırlayın","eTg71g":"Retry accreditation","tfDRzk":"Kaydet","txnnFL":"Yedekleme kodlarınızı kaydedin","JlFcis":"Gönder","T65b7l":"Çift faktörlü doğrulamayı kur","Tz0i8g":"Settings","tXkhj/":"Başlayın","hQRttt":"Gönder","VApyUg":"There was an error","qsWho/":"Hesap oluşturulurken bir hata oluştu","axWtcV":"Bu e-posta bir hesapla ilişkilendirilmiştir. <0>Giriş yap?</0>","2V8vJF":"Bu e-posta bir hesapla ilişkilendirilmemiştir. <0>Kayıt ol?</0>","7mDP6a":"duyurulacak","TP9/K5":"Token","M9b4Fq":"Token Launch","xB/9hv":"Token Launches","MLuGvV":"Token Sales","tygisN":"Unable to verify your accreditation status","1vq5nf":"Unable to verify your identity","AULyh4":"Oturum açmak için bir güvenlik anahtarı kullanın \\"","uSMfoN":"Doğrulama","/IBv6X":"E-postanızı doğrulayın","+yVK40":"Kimliğinizi doğrulayın","NhbQd/":"Verify your login","jpctdh":"Görüntüle","N6Pxr9":"Tümünü Görüntüle","oarJCB":"Varlıkları görüntüle","rhJPjn":"Daha az görüntüle","TZsuwl":"View my Wallet","VBu2zJ":"Visit our blog","VCXqZD":"We are reviewing your accreditation status. We'll send you an email with an update on your status.","X53EwO":"We are reviewing your accreditation status. You may continue to use CoinList while this is being reviewed.","g1ZEHz":"We are reviewing your identity. We’ll send you an email with an update on your status. You may safely close this browser.","iP2KH3":"We were unable to verify your identity after reviewing the information submitted. Learn about our identity verification.","cbRW54":"We were unable to verify your identity after reviewing the information submitted. You will not be able to access CoinList at this time.","Hq8OI1":"We'll send you an email with an update on your verification after our review is complete.","3Iqf7D":"We'll send you an email with an update on your verification after our review is complete. Your account is restricted to withdrawals at this time.","jwpy5i":"We’ll send you an email with an update on your verification after our review is complete. Your account is restricted to withdrawals at this time.","1ZF9KQ":"Ne zaman","UWHEkW":"İş e-postası","KGzdyA":"Would you like to invest in Token Sales?","EK6YGK":"Yanlış kod","havey5":"Yanlış kod <0>2FA'nızı mı kaybettiniz?</0>","fV2Bu6":"Yanlış şifre","G9V/if":"Yanlış şifre <0>Şifrenizi mi unuttunuz?</0>","API151":"Yes, I qualify","VC36G0":"You are approved to invest in Token Sales","ZOWGZ9":"You did not meet the requirements to be an accredited investor. We'll let you know when CoinList becomes available in your state.","Otc1oj":"You did not meet the requirements to be an accredited investor. You will not be able to invest in Token Sales at this time.","WXVVKP":"You no longer have access to CoinList.","2A9Wbg":"You no longer have access to CoinList. If there are any remaining funds in your Wallet, continue to withdraw them.","VSzHtP":"You will have access to CoinList wallet and trading but will not be able to invest in Token Sales at this time.","48SoOT":"You will not be able to access CoinList at this time because you live in one of our <0>unsupported countries & states</0>. If there are any remaining funds in your Wallet, continue to withdraw them.","kwH6Rr":"You will not be able to access CoinList at this time because you live in one of our <0>unsupported countries & states</0>. We'll let you know when CoinList becomes available in your region.","7iOV3m":"You will not be able to access CoinList at this time because you live in one of our <0>unsupported countries & states</0>. We’ll let you know when CoinList becomes available in your region.","SHtFF4":"You will not be able to access CoinList at this time because you live in one of our <0>unsupported states</0> and did not meet the requirements to be an accredited investor. We'll let you know when CoinList becomes available in your state.","8vxXyH":"You will not be able to access CoinList. <0>Learn more about our identity verification.</0>","7TVyuz":"You will not be able to access CoinList. If there are any remaining funds in your Wallet, continue to withdraw them.","Xarf4G":"CoinList'e erişiminiz kısıtlandı","OMniYn":"Your accreditation status has been successfully verified and you can now invest in Token Sales.","6OPNcL":"Yedekleme kodlarınız, kimlik doğrulama cihazınızı kaybetmeniz durumunda hesabınıza giriş yapmanıza yardımcı olabilir. Her kod yalnızca bir kez kullanılabilir. Kodlarınızı kopyalayın ve devam etmek için güvenli bir yerde saklayın.","+OSLTm":"Your identity has been successfully verified and you can now continue to CoinList.","Ubswu3":"Your identity has been successfully verified.","sCHNLH":"CoinList'te güvenliğiniz bizim için önemlidir. Sizi ve fonlarınızı korumak için tüm hesapların çift faktörlü doğrulama ayarını açmasını istiyoruz.","zX7Mg4":"Listelenen ve alıp satılabilen tokenleriniz"}`);
const translationsTR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  messages
}, Symbol.toStringTag, { value: "Module" }));
function dynamicActivate(locale) {
  return __async(this, null, function* () {
    const {
      messages: messages2
    } = locale === "tr" ? translationsTR : translationsEN;
    i18n.load(locale, messages2);
    i18n.activate(locale);
  });
}
const TranslationContext = ({
  locale = "en",
  children
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    dynamicActivate(locale);
    setIsLoaded(true);
  }, []);
  return isLoaded ? /* @__PURE__ */ jsx(I18nProvider, { i18n, children }) : null;
};
const BlueCheck = (_c) => {
  var rest = __objRest(_c, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ width: "26", height: "27", viewBox: "0 0 26 27", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M6.13086 23.7858C5.08268 23.7858 4.30029 23.5275 3.78369 23.0109C3.27458 22.5017 3.02002 21.7193 3.02002 20.6637V18.2828C3.02002 18.0882 2.95264 17.9197 2.81787 17.7775L1.1333 16.0817C0.384603 15.3404 0.0102539 14.6105 0.0102539 13.8917C0.0102539 13.173 0.384603 12.4392 1.1333 11.6905L2.81787 9.99474C2.95264 9.85997 3.02002 9.69526 3.02002 9.5006V7.10851C3.02002 6.04536 3.27458 5.26297 3.78369 4.76134C4.29281 4.25223 5.0752 3.99767 6.13086 3.99767H8.52295C8.71761 3.99767 8.88232 3.93029 9.01709 3.79552L10.7129 2.11095C11.4616 1.36225 12.1953 0.987903 12.9141 0.987903C13.6328 0.980416 14.3628 1.35477 15.104 2.11095L16.7998 3.79552C16.9421 3.93029 17.1105 3.99767 17.3052 3.99767H19.686C20.7417 3.99767 21.5241 4.25597 22.0332 4.77257C22.5498 5.28169 22.8081 6.06033 22.8081 7.10851V9.5006C22.8081 9.69526 22.8755 9.85997 23.0103 9.99474L24.6948 11.6905C25.436 12.4392 25.8066 13.173 25.8066 13.8917C25.8141 14.6105 25.4435 15.3404 24.6948 16.0817L23.0103 17.7775C22.8755 17.9197 22.8081 18.0882 22.8081 18.2828V20.6637C22.8081 21.7193 22.5498 22.5017 22.0332 23.0109C21.5241 23.5275 20.7417 23.7858 19.686 23.7858H17.3052C17.1105 23.7858 16.9421 23.8531 16.7998 23.9879L15.104 25.6725C14.3628 26.4137 13.6328 26.7843 12.9141 26.7843C12.1953 26.7918 11.4616 26.4212 10.7129 25.6725L9.01709 23.9879C8.88232 23.8531 8.71761 23.7858 8.52295 23.7858H6.13086ZM11.6675 19.462C11.8921 19.462 12.098 19.4096 12.2852 19.3048C12.4798 19.1925 12.6445 19.039 12.7793 18.8443L18.0239 10.7359C18.1063 10.6087 18.1737 10.4739 18.2261 10.3317C18.286 10.1894 18.3159 10.0471 18.3159 9.90489C18.3159 9.59044 18.1961 9.33588 17.9565 9.14122C17.7244 8.94656 17.4587 8.84923 17.1592 8.84923C16.7624 8.84923 16.4292 9.06261 16.1597 9.48937L11.6338 16.7218L9.55615 14.1163C9.40641 13.9291 9.25667 13.7981 9.10693 13.7233C8.95719 13.6409 8.78874 13.5997 8.60156 13.5997C8.28711 13.5997 8.02132 13.712 7.8042 13.9366C7.58708 14.1538 7.47852 14.4195 7.47852 14.734C7.47852 14.8837 7.50472 15.0297 7.55713 15.172C7.61702 15.3068 7.69938 15.4453 7.8042 15.5875L10.5107 18.8443C10.6755 19.054 10.8514 19.2112 11.0386 19.316C11.2257 19.4134 11.4354 19.462 11.6675 19.462Z", fill: "#2395E7" }) }));
};
const Building = (_d) => {
  var rest = __objRest(_d, []);
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, rest), { children: [
    /* @__PURE__ */ jsx("g", { "clip-path": "url(#clip0_520_5860)", children: /* @__PURE__ */ jsx("path", { d: "M0.00927734 15.4463C0.00927734 15.2607 0.0751953 15.1021 0.207031 14.9702C0.338867 14.8384 0.495117 14.7725 0.675781 14.7725H15.3096C15.4951 14.7725 15.6538 14.8384 15.7856 14.9702C15.9175 15.1021 15.9834 15.2607 15.9834 15.4463C15.9834 15.627 15.9175 15.7832 15.7856 15.915C15.6538 16.0518 15.4951 16.1201 15.3096 16.1201H0.675781C0.495117 16.1201 0.338867 16.0518 0.207031 15.915C0.0751953 15.7832 0.00927734 15.627 0.00927734 15.4463ZM1.27637 7.104V6.9209C1.27637 6.75977 1.32275 6.63037 1.41553 6.53271C1.51318 6.43018 1.64746 6.37891 1.81836 6.37891H3.63477C3.81055 6.37891 3.94727 6.43018 4.04492 6.53271C4.14258 6.63037 4.19141 6.75977 4.19141 6.9209V7.104C4.19141 7.2749 4.14258 7.40918 4.04492 7.50684C3.94727 7.60449 3.81055 7.65332 3.63477 7.65332H1.81836C1.64746 7.65332 1.51318 7.60449 1.41553 7.50684C1.32275 7.40918 1.27637 7.2749 1.27637 7.104ZM2.09668 13.1831V7.11865H3.36377V13.1831H2.09668ZM1.27637 13.564V13.3809C1.27637 13.2197 1.32275 13.0903 1.41553 12.9927C1.51318 12.895 1.64746 12.8462 1.81836 12.8462H3.63477C3.81055 12.8462 3.94727 12.895 4.04492 12.9927C4.14258 13.0903 4.19141 13.2197 4.19141 13.3809V13.564C4.19141 13.7397 4.14258 13.874 4.04492 13.9668C3.94727 14.0645 3.81055 14.1133 3.63477 14.1133H1.81836C1.64746 14.1133 1.51318 14.0645 1.41553 13.9668C1.32275 13.874 1.27637 13.7397 1.27637 13.564ZM4.79932 7.104V6.9209C4.79932 6.75977 4.84814 6.63037 4.9458 6.53271C5.04346 6.43018 5.17773 6.37891 5.34863 6.37891H7.16504C7.33594 6.37891 7.47021 6.43018 7.56787 6.53271C7.66553 6.63037 7.71436 6.75977 7.71436 6.9209V7.104C7.71436 7.2749 7.66553 7.40918 7.56787 7.50684C7.47021 7.60449 7.33594 7.65332 7.16504 7.65332H5.34863C5.17773 7.65332 5.04346 7.60449 4.9458 7.50684C4.84814 7.40918 4.79932 7.2749 4.79932 7.104ZM5.63428 13.1831V7.11865H6.90137V13.1831H5.63428ZM4.79932 13.564V13.3809C4.79932 13.2197 4.84814 13.0903 4.9458 12.9927C5.04346 12.895 5.17773 12.8462 5.34863 12.8462H7.16504C7.33594 12.8462 7.47021 12.895 7.56787 12.9927C7.66553 13.0903 7.71436 13.2197 7.71436 13.3809V13.564C7.71436 13.7397 7.66553 13.874 7.56787 13.9668C7.47021 14.0645 7.33594 14.1133 7.16504 14.1133H5.34863C5.17773 14.1133 5.04346 14.0645 4.9458 13.9668C4.84814 13.874 4.79932 13.7397 4.79932 13.564ZM8.33691 7.104V6.9209C8.33691 6.75977 8.38574 6.63037 8.4834 6.53271C8.58105 6.43018 8.71533 6.37891 8.88623 6.37891H10.7026C10.8735 6.37891 11.0078 6.43018 11.1055 6.53271C11.2031 6.63037 11.252 6.75977 11.252 6.9209V7.104C11.252 7.2749 11.2031 7.40918 11.1055 7.50684C11.0078 7.60449 10.8735 7.65332 10.7026 7.65332H8.88623C8.71533 7.65332 8.58105 7.60449 8.4834 7.50684C8.38574 7.40918 8.33691 7.2749 8.33691 7.104ZM9.16455 13.1831V7.11865H10.4316V13.1831H9.16455ZM8.33691 13.564V13.3809C8.33691 13.2197 8.38574 13.0903 8.4834 12.9927C8.58105 12.895 8.71533 12.8462 8.88623 12.8462H10.7026C10.8735 12.8462 11.0078 12.895 11.1055 12.9927C11.2031 13.0903 11.252 13.2197 11.252 13.3809V13.564C11.252 13.7397 11.2031 13.874 11.1055 13.9668C11.0078 14.0645 10.8735 14.1133 10.7026 14.1133H8.88623C8.71533 14.1133 8.58105 14.0645 8.4834 13.9668C8.38574 13.874 8.33691 13.7397 8.33691 13.564ZM11.8672 7.104V6.9209C11.8672 6.75977 11.916 6.63037 12.0137 6.53271C12.1113 6.43018 12.2456 6.37891 12.4165 6.37891H14.2329C14.4038 6.37891 14.5381 6.43018 14.6357 6.53271C14.7334 6.63037 14.7822 6.75977 14.7822 6.9209V7.104C14.7822 7.2749 14.7334 7.40918 14.6357 7.50684C14.5381 7.60449 14.4038 7.65332 14.2329 7.65332H12.4165C12.2456 7.65332 12.1113 7.60449 12.0137 7.50684C11.916 7.40918 11.8672 7.2749 11.8672 7.104ZM12.6948 13.1831V7.11865H13.9619V13.1831H12.6948ZM11.8672 13.564V13.3809C11.8672 13.2197 11.916 13.0903 12.0137 12.9927C12.1113 12.895 12.2456 12.8462 12.4165 12.8462H14.2329C14.4038 12.8462 14.5381 12.895 14.6357 12.9927C14.7334 13.0903 14.7822 13.2197 14.7822 13.3809V13.564C14.7822 13.7397 14.7334 13.874 14.6357 13.9668C14.5381 14.0645 14.4038 14.1133 14.2329 14.1133H12.4165C12.2456 14.1133 12.1113 14.0645 12.0137 13.9668C11.916 13.874 11.8672 13.7397 11.8672 13.564ZM1.08594 5.72705C0.861328 5.72705 0.685547 5.66113 0.558594 5.5293C0.431641 5.39258 0.368164 5.23633 0.368164 5.06055C0.368164 4.92871 0.402344 4.80908 0.470703 4.70166C0.543945 4.59424 0.653809 4.49902 0.800293 4.41602L7.05518 0.8125C7.36279 0.631836 7.67529 0.541504 7.99268 0.541504C8.31006 0.541504 8.625 0.631836 8.9375 0.8125L15.1924 4.41602C15.334 4.49902 15.439 4.59424 15.5073 4.70166C15.5806 4.80908 15.6172 4.92871 15.6172 5.06055C15.6172 5.23633 15.5537 5.39258 15.4268 5.5293C15.3047 5.66113 15.1289 5.72705 14.8994 5.72705H1.08594ZM3.60547 4.37939H12.3872L8.2417 2.05762C8.15381 2.00879 8.0708 1.98438 7.99268 1.98438C7.91943 1.98438 7.83887 2.00879 7.75098 2.05762L3.60547 4.37939Z", fill: "black" }) }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_520_5860", children: /* @__PURE__ */ jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
  ] }));
};
const Check = (_e) => {
  var rest = __objRest(_e, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "15", height: "15", viewBox: "0 0 15 15", fill: "#15803D" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M5.66406 14.4453C5.17969 14.4453 4.77604 14.2526 4.45312 13.8672L0.421875 8.98438C0.28125 8.82292 0.182292 8.66667 0.125 8.51562C0.0677083 8.36458 0.0390625 8.20833 0.0390625 8.04688C0.0390625 7.67708 0.161458 7.3724 0.40625 7.13281C0.65625 6.88802 0.96875 6.76562 1.34375 6.76562C1.76042 6.76562 2.10677 6.9349 2.38281 7.27344L5.63281 11.2969L12.0156 1.21094C12.1771 0.966146 12.3438 0.794271 12.5156 0.695312C12.6927 0.591146 12.9089 0.539062 13.1641 0.539062C13.5391 0.539062 13.849 0.658854 14.0938 0.898438C14.3385 1.13802 14.4609 1.4401 14.4609 1.80469C14.4609 1.9401 14.4375 2.08073 14.3906 2.22656C14.3438 2.3724 14.2708 2.52344 14.1719 2.67969L6.89844 13.8125C6.61198 14.2344 6.20052 14.4453 5.66406 14.4453Z" }) }));
};
const Chevron = (_f) => {
  var rest = __objRest(_f, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "9", height: "6", viewBox: "0 0 9 6", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M4.48828 5.07715C4.36458 5.07715 4.25391 5.02995 4.15625 4.93555L0.376953 1.06836C0.334635 1.02604 0.302083 0.978841 0.279297 0.926758C0.25651 0.871419 0.245117 0.812826 0.245117 0.750977C0.245117 0.666341 0.264648 0.589844 0.303711 0.521484C0.342773 0.453125 0.394857 0.399414 0.459961 0.360352C0.52832 0.321289 0.604818 0.301758 0.689453 0.301758C0.813151 0.301758 0.918945 0.344076 1.00684 0.428711L4.74707 4.25195H4.22461L7.96484 0.428711C8.05599 0.344076 8.16178 0.301758 8.28223 0.301758C8.36686 0.301758 8.44173 0.321289 8.50684 0.360352C8.5752 0.399414 8.62891 0.453125 8.66797 0.521484C8.70703 0.589844 8.72656 0.666341 8.72656 0.750977C8.72656 0.871419 8.68262 0.975586 8.59473 1.06348L4.81543 4.93555C4.77311 4.98112 4.72266 5.01693 4.66406 5.04297C4.60872 5.06576 4.55013 5.07715 4.48828 5.07715Z", fill: "black" }) }));
};
const Clock = (_g) => {
  var rest = __objRest(_g, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "15", viewBox: "0 0 16 15", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M4.54102 7.91895C4.38607 7.91895 4.25618 7.86654 4.15137 7.76172C4.04655 7.6569 3.99414 7.52702 3.99414 7.37207C3.99414 7.21712 4.04655 7.08952 4.15137 6.98926C4.25618 6.88444 4.38607 6.83203 4.54102 6.83203H7.44629V2.89453C7.44629 2.74414 7.4987 2.61654 7.60352 2.51172C7.70833 2.4069 7.83594 2.35449 7.98633 2.35449C8.14128 2.35449 8.27116 2.4069 8.37598 2.51172C8.48079 2.61654 8.5332 2.74414 8.5332 2.89453V7.37207C8.5332 7.52702 8.48079 7.6569 8.37598 7.76172C8.27116 7.86654 8.14128 7.91895 7.98633 7.91895H4.54102ZM7.99316 14.126C7.02702 14.126 6.11784 13.9414 5.26562 13.5723C4.41341 13.2077 3.66146 12.6995 3.00977 12.0479C2.36263 11.3962 1.85449 10.6442 1.48535 9.79199C1.11621 8.93978 0.931641 8.0306 0.931641 7.06445C0.931641 6.09831 1.11621 5.18913 1.48535 4.33691C1.85449 3.4847 2.36263 2.73503 3.00977 2.08789C3.66146 1.4362 4.41113 0.925781 5.25879 0.556641C6.111 0.1875 7.02018 0.00292969 7.98633 0.00292969C8.95703 0.00292969 9.86849 0.1875 10.7207 0.556641C11.5729 0.925781 12.3249 1.4362 12.9766 2.08789C13.6283 2.73503 14.1387 3.4847 14.5078 4.33691C14.877 5.18913 15.0615 6.09831 15.0615 7.06445C15.0615 8.0306 14.877 8.93978 14.5078 9.79199C14.1387 10.6442 13.6283 11.3962 12.9766 12.0479C12.3249 12.6995 11.5729 13.2077 10.7207 13.5723C9.86849 13.9414 8.95931 14.126 7.99316 14.126ZM7.99316 12.7314C8.78158 12.7314 9.51758 12.5856 10.2012 12.2939C10.8848 12.0023 11.4863 11.5967 12.0059 11.0771C12.5254 10.5576 12.931 9.95605 13.2227 9.27246C13.5143 8.58887 13.6602 7.85286 13.6602 7.06445C13.6602 6.2806 13.5143 5.54688 13.2227 4.86328C12.931 4.17513 12.5254 3.57129 12.0059 3.05176C11.4863 2.53223 10.8825 2.12663 10.1943 1.83496C9.51074 1.54329 8.77474 1.39746 7.98633 1.39746C7.20247 1.39746 6.46647 1.54329 5.77832 1.83496C5.09473 2.12663 4.49544 2.53223 3.98047 3.05176C3.46549 3.57129 3.06217 4.17513 2.77051 4.86328C2.47884 5.54688 2.33301 6.2806 2.33301 7.06445C2.33301 7.85286 2.47884 8.58887 2.77051 9.27246C3.06217 9.95605 3.46549 10.5576 3.98047 11.0771C4.5 11.5967 5.10156 12.0023 5.78516 12.2939C6.47331 12.5856 7.20931 12.7314 7.99316 12.7314Z", fill: "white" }) }));
};
const Close = (_h) => {
  var rest = __objRest(_h, []);
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "29", height: "30", viewBox: "0 0 29 30", fill: "none" }, rest), { children: [
    /* @__PURE__ */ jsx("circle", { cx: "13.5786", cy: "15.2236", r: "9", fill: "#828285" }),
    /* @__PURE__ */ jsx("path", { d: "M14.5566 29.4434C12.5837 29.4434 10.724 29.0658 8.97754 28.3105C7.24056 27.5553 5.70654 26.5122 4.37549 25.1812C3.04443 23.8501 2.0013 22.3161 1.24609 20.5791C0.490885 18.8327 0.113281 16.973 0.113281 15C0.113281 13.027 0.490885 11.172 1.24609 9.43506C2.0013 7.68864 3.03971 6.1499 4.36133 4.81885C5.69238 3.48779 7.2264 2.44466 8.96338 1.68945C10.7098 0.934245 12.5695 0.556641 14.5425 0.556641C16.5155 0.556641 18.3752 0.934245 20.1216 1.68945C21.868 2.44466 23.4067 3.48779 24.7378 4.81885C26.0688 6.1499 27.112 7.68864 27.8672 9.43506C28.6224 11.172 29 13.027 29 15C29 16.973 28.6224 18.8327 27.8672 20.5791C27.112 22.3161 26.0688 23.8501 24.7378 25.1812C23.4067 26.5122 21.868 27.5553 20.1216 28.3105C18.3846 29.0658 16.5296 29.4434 14.5566 29.4434ZM9.79883 20.9473C10.1387 20.9473 10.4266 20.834 10.6626 20.6074L14.5708 16.6709L18.4932 20.6074C18.7103 20.834 18.9888 20.9473 19.3286 20.9473C19.659 20.9473 19.9375 20.834 20.1641 20.6074C20.3906 20.3714 20.5039 20.0929 20.5039 19.772C20.5039 19.4227 20.3906 19.1442 20.1641 18.9365L16.2275 15.0142L20.1782 11.0776C20.4048 10.8416 20.5181 10.5632 20.5181 10.2422C20.5181 9.92122 20.4048 9.64746 20.1782 9.4209C19.9517 9.19434 19.6779 9.08105 19.3569 9.08105C19.0454 9.08105 18.7764 9.19434 18.5498 9.4209L14.5708 13.3716L10.6201 9.43506C10.3841 9.21794 10.1104 9.10938 9.79883 9.10938C9.47786 9.10938 9.2041 9.22266 8.97754 9.44922C8.75098 9.66634 8.6377 9.9401 8.6377 10.2705C8.6377 10.582 8.75098 10.8558 8.97754 11.0918L12.9141 15.0142L8.97754 18.9507C8.75098 19.1772 8.6377 19.451 8.6377 19.772C8.6377 20.0929 8.75098 20.3714 8.97754 20.6074C9.2041 20.834 9.47786 20.9473 9.79883 20.9473Z", fill: "#E6E6E8" })
  ] }));
};
const Copy = (_i) => {
  var rest = __objRest(_i, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "17", height: "17", viewBox: "0 0 17 17", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M2.59375 13.0312C1.75 13.0312 1.11198 12.8177 0.679688 12.3906C0.247396 11.9635 0.03125 11.3307 0.03125 10.4922V2.53125C0.03125 1.69271 0.247396 1.0599 0.679688 0.632812C1.11198 0.205729 1.75 -0.0078125 2.59375 -0.0078125H10.5078C11.3516 -0.0078125 11.9896 0.208333 12.4219 0.640625C12.8542 1.06771 13.0703 1.69792 13.0703 2.53125V4.36719H11.5312V2.66406C11.5312 2.28385 11.4349 2 11.2422 1.8125C11.0495 1.61979 10.7734 1.52344 10.4141 1.52344H2.6875C2.32292 1.52344 2.04427 1.61979 1.85156 1.8125C1.66406 2 1.57031 2.28385 1.57031 2.66406V10.3594C1.57031 10.7396 1.66406 11.026 1.85156 11.2188C2.04427 11.4062 2.32292 11.5 2.6875 11.5H4.67969V13.0312H2.59375ZM6.48438 16.75C5.64062 16.75 5.0026 16.5365 4.57031 16.1094C4.13802 15.6823 3.92188 15.0495 3.92188 14.2109V6.24219C3.92188 5.40885 4.13802 4.77865 4.57031 4.35156C5.0026 3.91927 5.64062 3.70312 6.48438 3.70312H14.3984C15.2422 3.70312 15.8802 3.91927 16.3125 4.35156C16.7448 4.78385 16.9609 5.41406 16.9609 6.24219V14.2109C16.9609 15.0443 16.7448 15.6745 16.3125 16.1016C15.8802 16.5339 15.2422 16.75 14.3984 16.75H6.48438ZM6.57812 15.2188H14.3047C14.6641 15.2188 14.9401 15.1224 15.1328 14.9297C15.3255 14.7422 15.4219 14.4583 15.4219 14.0781V6.38281C15.4219 6.0026 15.3255 5.71875 15.1328 5.53125C14.9401 5.33854 14.6641 5.24219 14.3047 5.24219H6.57812C6.21354 5.24219 5.9349 5.33854 5.74219 5.53125C5.54948 5.71875 5.45312 6.0026 5.45312 6.38281V14.0781C5.45312 14.4583 5.54948 14.7422 5.74219 14.9297C5.9349 15.1224 6.21354 15.2188 6.57812 15.2188Z", fill: "black" }) }));
};
const ErrorIcon = (_j) => {
  var rest = __objRest(_j, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M0.464844 9.30469C0.378906 9.22266 0.322266 9.125 0.294922 9.01172C0.267578 8.89844 0.267578 8.78516 0.294922 8.67188C0.326172 8.55859 0.382812 8.46289 0.464844 8.38477L4.0625 4.77539L0.464844 1.17188C0.382812 1.09375 0.328125 0.998047 0.300781 0.884766C0.273438 0.771484 0.273438 0.658203 0.300781 0.544922C0.328125 0.431641 0.382812 0.333984 0.464844 0.251953C0.550781 0.166016 0.650391 0.109375 0.763672 0.0820312C0.876953 0.0546875 0.990234 0.0546875 1.10352 0.0820312C1.2168 0.109375 1.31445 0.164062 1.39648 0.246094L5 3.84961L8.59766 0.246094C8.67969 0.160156 8.77734 0.105469 8.89062 0.0820312C9.00391 0.0546875 9.11523 0.0546875 9.22461 0.0820312C9.33789 0.109375 9.43945 0.166016 9.5293 0.251953C9.61133 0.333984 9.66602 0.431641 9.69336 0.544922C9.72461 0.658203 9.72461 0.771484 9.69336 0.884766C9.66602 0.994141 9.61133 1.0918 9.5293 1.17773L5.93164 4.77539L9.5293 8.37891C9.61133 8.46484 9.66602 8.56445 9.69336 8.67773C9.7207 8.78711 9.7207 8.89844 9.69336 9.01172C9.66602 9.125 9.61133 9.22266 9.5293 9.30469C9.44336 9.39062 9.34375 9.44727 9.23047 9.47461C9.11719 9.50195 9.00391 9.50195 8.89062 9.47461C8.77734 9.44727 8.67969 9.39258 8.59766 9.31055L5 5.70703L1.39648 9.31055C1.31445 9.39258 1.2168 9.44727 1.10352 9.47461C0.994141 9.50195 0.880859 9.50195 0.763672 9.47461C0.650391 9.44727 0.550781 9.39062 0.464844 9.30469Z", fill: "#DC2626" }) }));
};
const Eye = (_k) => {
  var rest = __objRest(_k, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "22", height: "15", viewBox: "0 0 22 15", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M11 14.0625C9.95833 14.0625 8.97135 13.9349 8.03906 13.6797C7.11198 13.4297 6.25 13.099 5.45312 12.6875C4.66146 12.2708 3.95052 11.8125 3.32031 11.3125C2.6901 10.8125 2.15104 10.3125 1.70312 9.8125C1.25521 9.30729 0.911458 8.84115 0.671875 8.41406C0.4375 7.98177 0.320312 7.63281 0.320312 7.36719C0.320312 7.10156 0.4375 6.75521 0.671875 6.32812C0.911458 5.89583 1.25521 5.42969 1.70312 4.92969C2.15104 4.42448 2.6901 3.92188 3.32031 3.42188C3.95573 2.92188 4.66927 2.46615 5.46094 2.05469C6.25781 1.63802 7.11979 1.30469 8.04688 1.05469C8.97917 0.799479 9.96354 0.671875 11 0.671875C12.0469 0.671875 13.0365 0.799479 13.9688 1.05469C14.9062 1.30469 15.7708 1.63802 16.5625 2.05469C17.3594 2.46615 18.0703 2.92188 18.6953 3.42188C19.3255 3.92188 19.862 4.42448 20.3047 4.92969C20.7474 5.42969 21.0859 5.89583 21.3203 6.32812C21.5547 6.75521 21.6719 7.10156 21.6719 7.36719C21.6719 7.63281 21.5547 7.98177 21.3203 8.41406C21.0859 8.84115 20.7474 9.30729 20.3047 9.8125C19.862 10.3125 19.3255 10.8125 18.6953 11.3125C18.0703 11.8125 17.362 12.2708 16.5703 12.6875C15.7786 13.099 14.9141 13.4297 13.9766 13.6797C13.0443 13.9349 12.0521 14.0625 11 14.0625ZM11 12.8281C11.8542 12.8281 12.6745 12.7214 13.4609 12.5078C14.2526 12.2943 14.9948 12.013 15.6875 11.6641C16.3802 11.3099 17.0078 10.9245 17.5703 10.5078C18.138 10.0911 18.625 9.67969 19.0312 9.27344C19.4375 8.86198 19.75 8.48698 19.9688 8.14844C20.1927 7.8099 20.3047 7.54948 20.3047 7.36719C20.3047 7.21094 20.1927 6.97135 19.9688 6.64844C19.75 6.32552 19.4375 5.95833 19.0312 5.54688C18.625 5.13021 18.138 4.71094 17.5703 4.28906C17.0078 3.86719 16.3802 3.47656 15.6875 3.11719C14.9948 2.7526 14.2526 2.46094 13.4609 2.24219C12.6745 2.01823 11.8542 1.90625 11 1.90625C10.1406 1.90625 9.3151 2.01823 8.52344 2.24219C7.73177 2.46094 6.98958 2.7526 6.29688 3.11719C5.60417 3.47656 4.97656 3.86719 4.41406 4.28906C3.85156 4.71094 3.36458 5.13021 2.95312 5.54688C2.54688 5.95833 2.23438 6.32552 2.01562 6.64844C1.79688 6.97135 1.6875 7.21094 1.6875 7.36719C1.6875 7.54948 1.79688 7.8099 2.01562 8.14844C2.23438 8.48698 2.54688 8.86198 2.95312 9.27344C3.36458 9.67969 3.85156 10.0911 4.41406 10.5078C4.97656 10.9245 5.60417 11.3099 6.29688 11.6641C6.98958 12.013 7.73177 12.2943 8.52344 12.5078C9.3151 12.7214 10.1406 12.8281 11 12.8281ZM11 11.7422C10.3854 11.7422 9.8125 11.6276 9.28125 11.3984C8.75 11.1693 8.28385 10.8542 7.88281 10.4531C7.48177 10.0469 7.16667 9.58073 6.9375 9.05469C6.71354 8.52344 6.60156 7.96094 6.60156 7.36719C6.60156 6.75781 6.71354 6.1875 6.9375 5.65625C7.16667 5.125 7.48177 4.66146 7.88281 4.26562C8.28385 3.86458 8.75 3.55208 9.28125 3.32812C9.8125 3.10417 10.3854 2.99219 11 2.99219C11.6042 2.99219 12.1719 3.10417 12.7031 3.32812C13.2344 3.55208 13.7005 3.86458 14.1016 4.26562C14.5026 4.66146 14.8151 5.125 15.0391 5.65625C15.2682 6.1875 15.3828 6.75781 15.3828 7.36719C15.3828 7.96094 15.2682 8.52344 15.0391 9.05469C14.8151 9.58073 14.5026 10.0469 14.1016 10.4531C13.7005 10.8542 13.2344 11.1693 12.7031 11.3984C12.1719 11.6276 11.6042 11.7422 11 11.7422ZM11 8.82031C11.401 8.82031 11.7448 8.67708 12.0312 8.39062C12.3177 8.10417 12.4609 7.76302 12.4609 7.36719C12.4609 6.96615 12.3177 6.625 12.0312 6.34375C11.7448 6.05729 11.401 5.91406 11 5.91406C10.5938 5.91406 10.2474 6.05729 9.96094 6.34375C9.67448 6.625 9.53125 6.96615 9.53125 7.36719C9.53125 7.76302 9.67448 8.10417 9.96094 8.39062C10.2474 8.67708 10.5938 8.82031 11 8.82031Z", fill: "#777777" }) }));
};
const Graphic = (_l) => {
  var rest = __objRest(_l, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M6.67664 7.10304C6.11727 7.10304 5.60501 6.96467 5.13984 6.68793C4.68057 6.41119 4.31256 6.04318 4.03582 5.58391C3.75908 5.11874 3.62071 4.60942 3.62071 4.05594C3.62071 3.50245 3.75908 2.99313 4.03582 2.52797C4.31256 2.06281 4.68057 1.69185 5.13984 1.41511C5.60501 1.13837 6.11727 1 6.67664 1C7.23013 1 7.73651 1.13837 8.19578 1.41511C8.66094 1.69185 9.03189 2.06281 9.30864 2.52797C9.58538 2.99313 9.72375 3.50245 9.72375 4.05594C9.72375 4.60942 9.58538 5.11874 9.30864 5.58391C9.03189 6.04318 8.66094 6.41119 8.19578 6.68793C7.73651 6.96467 7.23013 7.10304 6.67664 7.10304ZM6.67664 5.46026C6.92983 5.46026 7.16242 5.39843 7.37439 5.27478C7.59225 5.14524 7.763 4.97448 7.88665 4.76251C8.01619 4.54465 8.08096 4.30913 8.08096 4.05594C8.08096 3.80275 8.01619 3.57017 7.88665 3.35819C7.763 3.14033 7.59225 2.96663 7.37439 2.8371C7.16242 2.70756 6.92983 2.64279 6.67664 2.64279C6.41757 2.64279 6.1791 2.70756 5.96124 2.8371C5.74926 2.96663 5.57851 3.14033 5.44897 3.35819C5.32532 3.57017 5.26349 3.80275 5.26349 4.05594C5.26349 4.30913 5.32532 4.54171 5.44897 4.75368C5.57851 4.96565 5.74926 5.13641 5.96124 5.26595C6.1791 5.39549 6.41757 5.46026 6.67664 5.46026ZM13.3096 7.10304C12.7502 7.10304 12.238 6.96467 11.7728 6.68793C11.3135 6.41119 10.9455 6.04318 10.6688 5.58391C10.3921 5.11874 10.2537 4.60942 10.2537 4.05594C10.2537 3.50245 10.3921 2.99313 10.6688 2.52797C10.9455 2.06281 11.3135 1.69185 11.7728 1.41511C12.238 1.13837 12.7502 1 13.3096 1C13.8631 1 14.3695 1.13837 14.8288 1.41511C15.2939 1.69185 15.6649 2.06281 15.9416 2.52797C16.2184 2.99313 16.3567 3.50245 16.3567 4.05594C16.3567 4.60942 16.2184 5.11874 15.9416 5.58391C15.6649 6.04907 15.2939 6.42002 14.8288 6.69676C14.3695 6.96762 13.8631 7.10304 13.3096 7.10304ZM13.3096 5.46026C13.5628 5.46026 13.7954 5.39843 14.0074 5.27478C14.2252 5.14524 14.396 4.97448 14.5196 4.76251C14.6492 4.54465 14.7139 4.30913 14.7139 4.05594C14.7139 3.80275 14.6492 3.57017 14.5196 3.35819C14.396 3.14033 14.2252 2.96663 14.0074 2.8371C13.7954 2.70756 13.5628 2.64279 13.3096 2.64279C13.0505 2.64279 12.8121 2.70756 12.5942 2.8371C12.3822 2.96663 12.2115 3.14033 12.0819 3.35819C11.9583 3.57017 11.8965 3.80275 11.8965 4.05594C11.8965 4.30913 11.9583 4.54465 12.0819 4.76251C12.2115 4.97448 12.3822 5.14524 12.5942 5.27478C12.8121 5.39843 13.0505 5.46026 13.3096 5.46026ZM3.35574 13.0559C2.79637 13.0559 2.2841 12.9176 1.81894 12.6408C1.35967 12.3582 0.991659 11.9872 0.714918 11.528C0.438176 11.0628 0.299805 10.5535 0.299805 10C0.299805 9.44652 0.438176 8.94014 0.714918 8.48086C0.991659 8.0157 1.35967 7.64475 1.81894 7.36801C2.2841 7.08538 2.79637 6.94406 3.35574 6.94406C3.90923 6.94406 4.4156 7.08538 4.87488 7.36801C5.34004 7.64475 5.71099 8.0157 5.98773 8.48086C6.27036 8.94014 6.41168 9.44652 6.41168 10C6.41168 10.5535 6.27036 11.0628 5.98773 11.528C5.71099 11.9872 5.34004 12.3582 4.87488 12.6408C4.4156 12.9176 3.90923 13.0559 3.35574 13.0559ZM3.35574 11.4132C3.60893 11.4132 3.84151 11.3484 4.05348 11.2188C4.27135 11.0893 4.44505 10.9185 4.57458 10.7066C4.71001 10.4887 4.77772 10.2532 4.77772 10C4.77772 9.74681 4.71001 9.51423 4.57458 9.30226C4.44505 9.0844 4.27135 8.9107 4.05348 8.78116C3.84151 8.65162 3.60893 8.58685 3.35574 8.58685C3.09666 8.58685 2.8582 8.65162 2.64033 8.78116C2.42836 8.9107 2.25761 9.0844 2.12807 9.30226C2.00442 9.51423 1.94259 9.74681 1.94259 10C1.94259 10.2532 2.00442 10.4887 2.12807 10.7066C2.25761 10.9185 2.42836 11.0893 2.64033 11.2188C2.8582 11.3484 3.09666 11.4132 3.35574 11.4132ZM9.99755 13.0559C9.43229 13.0559 8.91708 12.9176 8.45191 12.6408C7.99264 12.3582 7.62463 11.9872 7.34789 11.528C7.07115 11.0628 6.93278 10.5535 6.93278 10C6.93278 9.44652 7.07115 8.94014 7.34789 8.48086C7.62463 8.0157 7.99264 7.64475 8.45191 7.36801C8.91708 7.08538 9.43229 6.94406 9.99755 6.94406C10.551 6.94406 11.0574 7.08538 11.5167 7.36801C11.9818 7.64475 12.3528 8.0157 12.6295 8.48086C12.9063 8.94014 13.0447 9.44652 13.0447 10C13.0447 10.5535 12.9063 11.0628 12.6295 11.528C12.3528 11.9872 11.9818 12.3582 11.5167 12.6408C11.0574 12.9176 10.551 13.0559 9.99755 13.0559ZM9.99755 11.4132C10.2507 11.4132 10.4833 11.3484 10.6953 11.2188C10.9073 11.0893 11.078 10.9185 11.2076 10.7066C11.3371 10.4887 11.4019 10.2532 11.4019 10C11.4019 9.74681 11.3371 9.51423 11.2076 9.30226C11.078 9.0844 10.9073 8.9107 10.6953 8.78116C10.4833 8.65162 10.2507 8.58685 9.99755 8.58685C9.73258 8.58685 9.49411 8.65162 9.28214 8.78116C9.07017 8.9107 8.89941 9.0844 8.76987 9.30226C8.64033 9.51423 8.57557 9.74681 8.57557 10C8.57557 10.2532 8.64033 10.4887 8.76987 10.7066C8.89941 10.9185 9.07017 11.0893 9.28214 11.2188C9.49411 11.3484 9.73258 11.4132 9.99755 11.4132ZM16.6217 13.0559C16.0682 13.0559 15.5589 12.9176 15.0937 12.6408C14.6344 12.3582 14.2635 11.9872 13.9809 11.528C13.7041 11.0628 13.5658 10.5535 13.5658 10C13.5658 9.44652 13.7041 8.94014 13.9809 8.48086C14.2635 8.0157 14.6344 7.64475 15.0937 7.36801C15.5589 7.08538 16.0682 6.94406 16.6217 6.94406C17.1811 6.94406 17.6904 7.08538 18.1497 7.36801C18.6148 7.64475 18.9858 8.0157 19.2625 8.48086C19.5393 8.94014 19.6776 9.44652 19.6776 10C19.6776 10.5535 19.5393 11.0628 19.2625 11.528C18.9858 11.9872 18.6148 12.3582 18.1497 12.6408C17.6904 12.9176 17.1811 13.0559 16.6217 13.0559ZM16.6217 11.4132C16.8808 11.4132 17.1163 11.3484 17.3283 11.2188C17.5461 11.0893 17.7169 10.9185 17.8405 10.7066C17.9701 10.4887 18.0348 10.2532 18.0348 10C18.0348 9.74681 17.9701 9.51423 17.8405 9.30226C17.7169 9.0844 17.5461 8.9107 17.3283 8.78116C17.1163 8.65162 16.8808 8.58685 16.6217 8.58685C16.3685 8.58685 16.133 8.65162 15.9151 8.78116C15.7031 8.9107 15.5324 9.0844 15.4028 9.30226C15.2733 9.51423 15.2085 9.74681 15.2085 10C15.2085 10.2532 15.2733 10.4887 15.4028 10.7066C15.5324 10.9185 15.7031 11.0893 15.9151 11.2188C16.133 11.3484 16.3685 11.4132 16.6217 11.4132ZM6.67664 19C6.11727 19 5.60501 18.8616 5.13984 18.5849C4.68057 18.3081 4.31256 17.9372 4.03582 17.472C3.75908 17.0069 3.62071 16.4975 3.62071 15.9441C3.62071 15.3847 3.75908 14.8754 4.03582 14.4161C4.31256 13.9509 4.68057 13.58 5.13984 13.3032C5.60501 13.0265 6.11727 12.8881 6.67664 12.8881C7.23013 12.8881 7.73651 13.0294 8.19578 13.3121C8.66094 13.5888 9.03189 13.9598 9.30864 14.4249C9.58538 14.8842 9.72375 15.3906 9.72375 15.9441C9.72375 16.4917 9.58538 16.998 9.30864 17.4632C9.03189 17.9284 8.66094 18.2993 8.19578 18.5761C7.73651 18.8587 7.23013 19 6.67664 19ZM6.67664 17.3572C6.92983 17.3572 7.16242 17.2924 7.37439 17.1629C7.59225 17.0334 7.763 16.8597 7.88665 16.6418C8.01619 16.4298 8.08096 16.1973 8.08096 15.9441C8.08096 15.6909 8.01619 15.4583 7.88665 15.2463C7.763 15.0285 7.59225 14.8548 7.37439 14.7252C7.16242 14.5957 6.92983 14.5309 6.67664 14.5309C6.41757 14.5309 6.1791 14.5957 5.96124 14.7252C5.74926 14.8548 5.57851 15.0285 5.44897 15.2463C5.32532 15.4583 5.26349 15.6909 5.26349 15.9441C5.26349 16.1973 5.32532 16.4298 5.44897 16.6418C5.57851 16.8597 5.74926 17.0334 5.96124 17.1629C6.1791 17.2924 6.41757 17.3572 6.67664 17.3572ZM13.3096 19C12.7502 19 12.238 18.8616 11.7728 18.5849C11.3135 18.3081 10.9455 17.9372 10.6688 17.472C10.3921 17.0069 10.2537 16.4975 10.2537 15.9441C10.2537 15.3906 10.3921 14.8842 10.6688 14.4249C10.9455 13.9598 11.3135 13.5888 11.7728 13.3121C12.238 13.0294 12.7502 12.8881 13.3096 12.8881C13.8631 12.8881 14.3695 13.0265 14.8288 13.3032C15.2939 13.58 15.6649 13.9509 15.9416 14.4161C16.2184 14.8754 16.3567 15.3847 16.3567 15.9441C16.3567 16.4975 16.2184 17.0069 15.9416 17.472C15.6649 17.9372 15.2939 18.3081 14.8288 18.5849C14.3695 18.8616 13.8631 19 13.3096 19ZM13.3096 17.3572C13.5628 17.3572 13.7954 17.2924 14.0074 17.1629C14.2252 17.0334 14.396 16.8597 14.5196 16.6418C14.6492 16.4298 14.7139 16.1973 14.7139 15.9441C14.7139 15.6909 14.6492 15.4583 14.5196 15.2463C14.396 15.0285 14.2252 14.8548 14.0074 14.7252C13.7954 14.5957 13.5628 14.5309 13.3096 14.5309C13.0505 14.5309 12.8121 14.5957 12.5942 14.7252C12.3822 14.8548 12.2115 15.0285 12.0819 15.2463C11.9583 15.4583 11.8965 15.6909 11.8965 15.9441C11.8965 16.1973 11.9583 16.4298 12.0819 16.6418C12.2115 16.8597 12.3822 17.0334 12.5942 17.1629C12.8121 17.2924 13.0505 17.3572 13.3096 17.3572Z", fill: "#A1A1A1" }) }));
};
const Help = (_m) => {
  var rest = __objRest(_m, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 18 18", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M8.83594 8.85938C8.35156 8.85938 8.10938 8.63802 8.10938 8.19531C8.10938 8.17969 8.10938 8.16667 8.10938 8.15625C8.10938 8.14062 8.10938 8.125 8.10938 8.10938C8.10938 7.75521 8.19792 7.46615 8.375 7.24219C8.55208 7.01823 8.77865 6.8125 9.05469 6.625C9.38281 6.39583 9.6276 6.20312 9.78906 6.04688C9.95573 5.89062 10.0391 5.6875 10.0391 5.4375C10.0391 5.17708 9.94271 4.96354 9.75 4.79688C9.55729 4.63021 9.30208 4.54688 8.98438 4.54688C8.82812 4.54688 8.68229 4.57292 8.54688 4.625C8.41667 4.67188 8.29688 4.74479 8.1875 4.84375C8.07812 4.9375 7.97917 5.05469 7.89062 5.19531L7.76562 5.35156C7.69271 5.45573 7.60417 5.53646 7.5 5.59375C7.40104 5.65104 7.28385 5.67969 7.14844 5.67969C6.99219 5.67969 6.85156 5.6276 6.72656 5.52344C6.60677 5.41406 6.54688 5.26562 6.54688 5.07812C6.54688 5.00521 6.55208 4.9375 6.5625 4.875C6.57812 4.80729 6.59635 4.74219 6.61719 4.67969C6.73698 4.3151 7.01042 4.0026 7.4375 3.74219C7.86979 3.48177 8.41667 3.35156 9.07812 3.35156C9.53125 3.35156 9.94792 3.42969 10.3281 3.58594C10.7135 3.74219 11.0208 3.97135 11.25 4.27344C11.4844 4.57031 11.6016 4.93229 11.6016 5.35938C11.6016 5.8125 11.487 6.17188 11.2578 6.4375C11.0286 6.69792 10.724 6.95312 10.3438 7.20312C10.0885 7.36979 9.89323 7.52865 9.75781 7.67969C9.6276 7.82552 9.55729 8 9.54688 8.20312C9.54688 8.21875 9.54427 8.23438 9.53906 8.25C9.53906 8.26562 9.53906 8.28125 9.53906 8.29688C9.52865 8.45312 9.46094 8.58594 9.33594 8.69531C9.21094 8.80469 9.04427 8.85938 8.83594 8.85938ZM8.8125 11.2109C8.57292 11.2109 8.36458 11.1302 8.1875 10.9688C8.01042 10.8073 7.92188 10.6068 7.92188 10.3672C7.92188 10.1276 8.00781 9.92969 8.17969 9.77344C8.35677 9.61198 8.56771 9.53125 8.8125 9.53125C9.0625 9.53125 9.27604 9.61198 9.45312 9.77344C9.63021 9.92969 9.71875 10.1276 9.71875 10.3672C9.71875 10.612 9.63021 10.8151 9.45312 10.9766C9.27604 11.1328 9.0625 11.2109 8.8125 11.2109ZM5.27344 17.0703C4.96094 17.0703 4.71615 16.9688 4.53906 16.7656C4.36719 16.5625 4.28125 16.2865 4.28125 15.9375V14.0156H3.85938C3.10417 14.0156 2.45573 13.8698 1.91406 13.5781C1.3776 13.2865 0.963542 12.8698 0.671875 12.3281C0.385417 11.7812 0.242188 11.1198 0.242188 10.3438V4.28125C0.242188 3.50521 0.385417 2.84635 0.671875 2.30469C0.958333 1.75781 1.3724 1.33854 1.91406 1.04688C2.46094 0.755208 3.1276 0.609375 3.91406 0.609375H14.0781C14.8594 0.609375 15.5234 0.755208 16.0703 1.04688C16.6172 1.33854 17.0339 1.75781 17.3203 2.30469C17.6068 2.84635 17.75 3.50521 17.75 4.28125V10.3438C17.75 11.1198 17.6068 11.7812 17.3203 12.3281C17.0339 12.8698 16.6172 13.2865 16.0703 13.5781C15.5234 13.8698 14.8594 14.0156 14.0781 14.0156H9.25L6.57812 16.3828C6.3125 16.6172 6.08333 16.7891 5.89062 16.8984C5.69792 17.013 5.49219 17.0703 5.27344 17.0703ZM5.65625 15.3438L8.13281 12.8906C8.29948 12.724 8.45312 12.6146 8.59375 12.5625C8.73958 12.5052 8.93229 12.4766 9.17188 12.4766H14.0312C14.7708 12.4766 15.3177 12.2943 15.6719 11.9297C16.0312 11.5599 16.2109 11.013 16.2109 10.2891V4.32812C16.2109 3.60938 16.0312 3.06771 15.6719 2.70312C15.3177 2.33333 14.7708 2.14844 14.0312 2.14844H3.95312C3.21875 2.14844 2.67188 2.33333 2.3125 2.70312C1.95833 3.06771 1.78125 3.60938 1.78125 4.32812V10.2891C1.78125 11.013 1.95833 11.5599 2.3125 11.9297C2.67188 12.2943 3.21875 12.4766 3.95312 12.4766H5.02344C5.24219 12.4766 5.40104 12.526 5.5 12.625C5.60417 12.7188 5.65625 12.8828 5.65625 13.1172V15.3438Z", fill: "black" }) }));
};
const Info = (_n) => {
  var rest = __objRest(_n, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "15", height: "15", viewBox: "0 0 15 15", fill: "#777777" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M7.5 14.0371C6.54753 14.0371 5.64974 13.8548 4.80664 13.4902C3.9681 13.1257 3.22754 12.6221 2.58496 11.9795C1.94238 11.3369 1.4388 10.5964 1.07422 9.75781C0.709635 8.91471 0.527344 8.01693 0.527344 7.06445C0.527344 6.11198 0.709635 5.21647 1.07422 4.37793C1.4388 3.53483 1.9401 2.79199 2.57812 2.14941C3.2207 1.50684 3.96126 1.00326 4.7998 0.638672C5.6429 0.274089 6.54069 0.0917969 7.49316 0.0917969C8.44564 0.0917969 9.34342 0.274089 10.1865 0.638672C11.0296 1.00326 11.7725 1.50684 12.415 2.14941C13.0576 2.79199 13.5612 3.53483 13.9258 4.37793C14.2904 5.21647 14.4727 6.11198 14.4727 7.06445C14.4727 8.01693 14.2904 8.91471 13.9258 9.75781C13.5612 10.5964 13.0576 11.3369 12.415 11.9795C11.7725 12.6221 11.0296 13.1257 10.1865 13.4902C9.34798 13.8548 8.45247 14.0371 7.5 14.0371ZM7.5 12.875C8.30664 12.875 9.06087 12.7246 9.7627 12.4238C10.4645 12.123 11.082 11.7083 11.6152 11.1797C12.1484 10.6465 12.5632 10.029 12.8594 9.32715C13.1602 8.62533 13.3105 7.87109 13.3105 7.06445C13.3105 6.25781 13.1602 5.50358 12.8594 4.80176C12.5586 4.09993 12.1416 3.48242 11.6084 2.94922C11.0798 2.41602 10.4622 2.0013 9.75586 1.70508C9.05404 1.4043 8.2998 1.25391 7.49316 1.25391C6.68652 1.25391 5.93229 1.4043 5.23047 1.70508C4.52865 2.0013 3.91341 2.41602 3.38477 2.94922C2.85612 3.48242 2.44141 4.09993 2.14062 4.80176C1.8444 5.50358 1.69629 6.25781 1.69629 7.06445C1.69629 7.87109 1.8444 8.62533 2.14062 9.32715C2.44141 10.029 2.85612 10.6465 3.38477 11.1797C3.91797 11.7083 4.53548 12.123 5.2373 12.4238C5.93913 12.7246 6.69336 12.875 7.5 12.875ZM6.30371 10.8857C6.16243 10.8857 6.04395 10.8402 5.94824 10.749C5.85254 10.6579 5.80469 10.5439 5.80469 10.4072C5.80469 10.2705 5.85254 10.1566 5.94824 10.0654C6.04395 9.97428 6.16243 9.92871 6.30371 9.92871H7.15137V6.79102H6.41992C6.27865 6.79102 6.16016 6.74544 6.06445 6.6543C5.96875 6.56315 5.9209 6.44922 5.9209 6.3125C5.9209 6.17578 5.96875 6.06185 6.06445 5.9707C6.16016 5.87956 6.27865 5.83398 6.41992 5.83398H7.70508C7.87826 5.83398 8.01042 5.89095 8.10156 6.00488C8.19271 6.11426 8.23828 6.26237 8.23828 6.44922V9.92871H9.08594C9.22721 9.92871 9.3457 9.97428 9.44141 10.0654C9.53711 10.1566 9.58496 10.2705 9.58496 10.4072C9.58496 10.5439 9.53711 10.6579 9.44141 10.749C9.3457 10.8402 9.22721 10.8857 9.08594 10.8857H6.30371ZM7.43848 4.69238C7.19238 4.69238 6.98275 4.60579 6.80957 4.43262C6.63639 4.25944 6.5498 4.0498 6.5498 3.80371C6.5498 3.55306 6.63639 3.34115 6.80957 3.16797C6.98275 2.99479 7.19238 2.9082 7.43848 2.9082C7.68913 2.9082 7.89876 2.99479 8.06738 3.16797C8.24056 3.34115 8.32715 3.55306 8.32715 3.80371C8.32715 4.0498 8.24056 4.25944 8.06738 4.43262C7.89876 4.60579 7.68913 4.69238 7.43848 4.69238Z" }) }));
};
const Logo = (_o) => {
  var rest = __objRest(_o, []);
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "254", height: "50", viewBox: "0 0 254 50", fill: "none" }, rest), { children: [
    /* @__PURE__ */ jsx("path", { d: "M27.9124 49.0897C30.3082 49.1712 32.6632 48.9127 34.9365 48.2316C39.2516 46.9375 42.8723 44.5809 45.7991 41.1624C45.7991 41.1624 45.7991 41.1624 45.7856 41.1485C44.9821 40.4678 44.1791 39.8002 43.3895 39.1328L42.5864 38.4654C42.4367 38.3428 42.3005 38.2202 42.1508 38.0976C41.838 37.8252 41.5248 37.5665 41.1981 37.3076C38.4213 39.1465 35.372 40.2088 32.0098 40.345C30.3218 40.4131 28.6475 40.2496 27.014 39.8002C24.2506 39.0511 21.7731 37.689 19.7857 35.5506C16.1648 31.6551 14.8852 26.9968 15.8245 21.7937C16.4098 18.5792 17.88 15.8687 20.126 13.6621C19.6496 13.7575 19.1732 13.8664 18.7103 14.0162C15.1439 15.1331 12.4077 17.2988 10.4339 20.4588C8.86846 22.9787 8.03811 25.7165 7.94283 28.6994C7.88838 30.3747 7.99728 31.9956 8.37842 33.5756C9.58995 38.5063 12.2852 42.3883 16.3962 45.2759H16.437V45.3028C16.5732 45.3983 16.7093 45.5072 16.8454 45.6026C20.1941 47.8364 23.8831 48.9808 27.9124 49.117V49.0897Z", fill: "#111111" }),
    /* @__PURE__ */ jsx("path", { d: "M29.2743 35.2645C27.6816 35.9727 26.0345 36.3813 24.3193 36.5176C26.4157 37.7026 28.7162 38.2882 31.2209 38.3427C32.0376 38.3563 32.8544 38.2746 33.712 38.1384C35.8219 37.8115 37.7821 37.0487 39.6062 35.9319C37.8774 34.4745 36.1622 33.0306 34.4334 31.5732C32.9633 33.1396 31.2481 34.3927 29.2743 35.2645Z", fill: "#111111" }),
    /* @__PURE__ */ jsx("path", { d: "M27.2052 0.0961628C26.9874 0.109784 26.7696 0.137025 26.5654 0.164266C28.6618 0.559268 30.6901 1.2403 32.6094 2.26185C36.3392 4.25048 39.2387 7.09721 41.1853 10.8701L42.2335 9.95755C43.309 9.01771 44.3845 8.07791 45.46 7.13807C42.9142 4.42753 39.9193 2.43893 36.4073 1.21306C34.0659 0.395818 31.6701 -0.0128028 29.2063 0.000817871C28.5529 0.000817871 27.8859 0.0553007 27.2052 0.0961628Z", fill: "#111111" }),
    /* @__PURE__ */ jsx("path", { d: "M10.7474 42.7166C7.60288 38.8073 5.8877 34.3397 5.91494 29.232C5.91494 26.6576 6.44584 24.1787 7.46678 21.8223C8.97776 18.3218 11.3599 15.5159 14.7086 13.5818C17.8531 11.7566 21.2698 11.0483 24.9044 11.5931C28.6343 12.1652 31.7243 13.9495 34.2018 16.7418C34.2018 16.7418 34.2834 16.8507 34.3243 16.8916C34.6918 16.5647 35.073 16.2378 35.4405 15.9109L35.8897 15.5159C36.2709 15.189 36.652 14.8485 37.0332 14.5216C37.9044 13.7588 38.762 13.0097 39.6195 12.2469C37.9452 8.80091 35.4269 6.15847 32.0918 4.29245C28.1578 2.08589 23.9243 1.40485 19.4458 1.99054C17.2133 2.2902 15.0761 2.97123 13.0343 3.97915C6.10553 7.41158 1.10972 14.4671 0.701341 23.1571C0.633279 24.5873 0.728567 26.0311 0.946367 27.4613C1.49087 31.0162 2.79767 34.2444 4.894 37.1592C6.52749 39.4066 8.4741 41.2589 10.7338 42.7166H10.7474Z", fill: "#111111" }),
    /* @__PURE__ */ jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M145.625 23.0337C145.625 18.5389 149.246 14.9158 153.698 14.9158C158.149 14.9158 161.77 18.5389 161.77 23.0337V39.3514H167.283V23.0337C167.283 15.5151 161.212 9.39941 153.698 9.39941C146.184 9.39941 140.112 15.5151 140.112 23.0337V39.3514H145.625V23.0337ZM111.009 15.1065C105.673 15.1065 101.358 19.4242 101.358 24.7636C101.358 30.1029 105.673 34.4207 111.009 34.4207C116.345 34.4207 120.66 30.1029 120.66 24.7636C120.66 19.4242 116.345 15.1065 111.009 15.1065ZM95.8444 24.7636C95.8444 16.3868 102.637 9.59008 111.009 9.59008C119.38 9.59008 126.173 16.3868 126.173 24.7636C126.173 33.1403 119.38 39.9371 111.009 39.9371C102.637 39.9371 95.8444 33.1403 95.8444 24.7636ZM83.1984 15.1337C77.9302 15.0248 73.5609 19.2063 73.4381 24.4775C73.3292 29.7487 77.5085 34.121 82.7763 34.2436C85.8935 34.3117 88.6979 32.8679 90.4949 30.5796L94.837 33.9848C92.0195 37.5806 87.5816 39.8552 82.654 39.7463C74.3366 39.5693 67.7347 32.6772 67.9117 24.3549C68.0887 16.0327 74.9765 9.42666 83.2939 9.6037C87.609 9.69906 91.475 11.6059 94.1566 14.5753L90.0594 18.2665C88.3578 16.3732 85.9074 15.1746 83.1711 15.1065L83.1984 15.1337ZM135.525 9.98508V39.3514H130.012V9.98508H135.525ZM201.954 9.98508H196.441V39.542H201.954V9.98508ZM192.004 39.542H178.418C174.607 39.542 171.53 36.4501 171.53 32.65V9.98508H177.043V32.65C177.043 33.4127 177.656 34.0257 178.418 34.0257H192.004V39.542ZM231.847 9.98508H225.545H215.635C210.816 9.98508 206.964 13.9351 206.964 18.7023C206.964 23.4696 210.816 27.4196 215.635 27.4196H219.433C221.175 27.4196 222.591 28.8361 222.591 30.566V30.8656C222.591 32.6091 221.175 34.012 219.433 34.012H206.773V39.5284H219.433C224.224 39.5284 228.104 35.6465 228.104 30.852V30.5524C228.104 25.7579 224.224 21.876 219.433 21.876H215.635C213.92 21.876 212.477 20.4458 212.477 18.6751C212.477 16.9044 213.92 15.4742 215.635 15.4742H228.104H231.847C234.896 15.4742 237.36 17.9396 237.36 20.9906V39.3241H242.873V20.9906C242.873 14.9022 237.932 9.95784 231.847 9.95784V9.98508ZM252.933 15.5015H241.852V9.98508H252.933V15.5015Z", fill: "#111111" })
  ] }));
};
const Logout = (_p) => {
  var rest = __objRest(_p, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "18", height: "16", viewBox: "0 0 18 16", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M3.12109 15.4678C2.38737 15.4678 1.83366 15.2786 1.45996 14.9004C1.08626 14.5221 0.899414 13.9639 0.899414 13.2256V2.91016C0.899414 2.17643 1.08626 1.62044 1.45996 1.24219C1.83366 0.859375 2.38737 0.667969 3.12109 0.667969H10.4014C11.1351 0.667969 11.6888 0.859375 12.0625 1.24219C12.4362 1.62044 12.623 2.17643 12.623 2.91016V6.10938H11.2832V2.99902C11.2832 2.68001 11.2012 2.4362 11.0371 2.26758C10.873 2.0944 10.6247 2.00781 10.292 2.00781H3.2373C2.90462 2.00781 2.65625 2.0944 2.49219 2.26758C2.32812 2.4362 2.24609 2.68001 2.24609 2.99902V13.1436C2.24609 13.458 2.32812 13.6995 2.49219 13.8682C2.65625 14.0368 2.90462 14.1211 3.2373 14.1211H10.292C10.6247 14.1211 10.873 14.0368 11.0371 13.8682C11.2012 13.6995 11.2832 13.458 11.2832 13.1436V10.0195H12.623V13.2256C12.623 13.9639 12.4362 14.5221 12.0625 14.9004C11.6888 15.2786 11.1351 15.4678 10.4014 15.4678H3.12109ZM7.53027 8.69336C7.36165 8.69336 7.21582 8.63184 7.09277 8.50879C6.96973 8.38574 6.9082 8.23763 6.9082 8.06445C6.9082 7.89128 6.96973 7.74316 7.09277 7.62012C7.21582 7.49251 7.36165 7.42871 7.53027 7.42871H14.4141L15.4326 7.4834L14.9268 7.05957L13.915 6.0957C13.7874 5.98633 13.7236 5.84277 13.7236 5.66504C13.7236 5.51009 13.7738 5.37793 13.874 5.26855C13.9743 5.15918 14.1064 5.10449 14.2705 5.10449C14.4209 5.10449 14.5553 5.16602 14.6738 5.28906L16.8887 7.58594C16.9661 7.66341 17.0208 7.74316 17.0527 7.8252C17.0846 7.90267 17.1006 7.98242 17.1006 8.06445C17.1006 8.14648 17.0846 8.22624 17.0527 8.30371C17.0208 8.38118 16.9661 8.46094 16.8887 8.54297L14.6738 10.8398C14.5553 10.9583 14.4209 11.0176 14.2705 11.0176C14.1064 11.0176 13.9743 10.9629 13.874 10.8535C13.7738 10.7396 13.7236 10.6051 13.7236 10.4502C13.7236 10.2816 13.7874 10.1403 13.915 10.0264L14.9268 9.06934L15.4326 8.64551L14.4141 8.69336H7.53027Z", fill: "#DC2626" }) }));
};
const ModalClose = (_q) => {
  var rest = __objRest(_q, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "14", height: "13", viewBox: "0 0 14 13", fill: "#A1A1A1" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M0.953125 12.4062C0.838542 12.2969 0.763021 12.1667 0.726562 12.0156C0.690104 11.8646 0.690104 11.7135 0.726562 11.5625C0.768229 11.4115 0.84375 11.2839 0.953125 11.1797L5.75 6.36719L0.953125 1.5625C0.84375 1.45833 0.770833 1.33073 0.734375 1.17969C0.697917 1.02865 0.697917 0.877604 0.734375 0.726562C0.770833 0.575521 0.84375 0.445312 0.953125 0.335938C1.06771 0.221354 1.20052 0.145833 1.35156 0.109375C1.5026 0.0729167 1.65365 0.0729167 1.80469 0.109375C1.95573 0.145833 2.08594 0.21875 2.19531 0.328125L7 5.13281L11.7969 0.328125C11.9062 0.213542 12.0365 0.140625 12.1875 0.109375C12.3385 0.0729167 12.487 0.0729167 12.6328 0.109375C12.7839 0.145833 12.9193 0.221354 13.0391 0.335938C13.1484 0.445312 13.2214 0.575521 13.2578 0.726562C13.2995 0.877604 13.2995 1.02865 13.2578 1.17969C13.2214 1.32552 13.1484 1.45573 13.0391 1.57031L8.24219 6.36719L13.0391 11.1719C13.1484 11.2865 13.2214 11.4193 13.2578 11.5703C13.2943 11.7161 13.2943 11.8646 13.2578 12.0156C13.2214 12.1667 13.1484 12.2969 13.0391 12.4062C12.9245 12.5208 12.7917 12.5964 12.6406 12.6328C12.4896 12.6693 12.3385 12.6693 12.1875 12.6328C12.0365 12.5964 11.9062 12.5234 11.7969 12.4141L7 7.60938L2.19531 12.4141C2.08594 12.5234 1.95573 12.5964 1.80469 12.6328C1.65885 12.6693 1.50781 12.6693 1.35156 12.6328C1.20052 12.5964 1.06771 12.5208 0.953125 12.4062Z" }) }));
};
const More = (_r) => {
  var rest = __objRest(_r, []);
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "15", height: "16", viewBox: "0 0 15 16", fill: "none" }, rest), { children: [
    /* @__PURE__ */ jsx("circle", { cx: "3", cy: "3.5", r: "3", fill: "black" }),
    /* @__PURE__ */ jsx("circle", { cx: "12", cy: "3.5", r: "3", fill: "black" }),
    /* @__PURE__ */ jsx("circle", { cx: "3", cy: "12.5", r: "3", fill: "black" }),
    /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12.5", r: "3", fill: "black" })
  ] }));
};
const NoEye = (_s) => {
  var rest = __objRest(_s, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "22", height: "15", viewBox: "0 0 22 15", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M11 14.0625C9.95833 14.0625 8.97135 13.9349 8.03906 13.6797C7.11198 13.4297 6.25 13.099 5.45312 12.6875C4.66146 12.2708 3.95052 11.8125 3.32031 11.3125C2.6901 10.8125 2.15104 10.3125 1.70312 9.8125C1.25521 9.30729 0.911458 8.84115 0.671875 8.41406C0.4375 7.98177 0.320312 7.63281 0.320312 7.36719C0.320312 7.13281 0.414062 6.83333 0.601562 6.46875C0.789062 6.09896 1.0599 5.69531 1.41406 5.25781C1.77344 4.82031 2.20833 4.3776 2.71875 3.92969C3.23438 3.47656 3.81771 3.04948 4.46875 2.64844L5.4375 3.61719C4.85938 3.96094 4.33854 4.32292 3.875 4.70312C3.41667 5.08333 3.02344 5.45052 2.69531 5.80469C2.3724 6.15885 2.1224 6.47396 1.94531 6.75C1.77344 7.02604 1.6875 7.23177 1.6875 7.36719C1.6875 7.54948 1.79688 7.8099 2.01562 8.14844C2.23438 8.48698 2.54688 8.86198 2.95312 9.27344C3.36458 9.67969 3.85156 10.0911 4.41406 10.5078C4.97656 10.9245 5.60417 11.3099 6.29688 11.6641C6.98958 12.013 7.73177 12.2943 8.52344 12.5078C9.3151 12.7214 10.1406 12.8281 11 12.8281C11.526 12.8281 12.0365 12.7865 12.5312 12.7031C13.026 12.6198 13.5052 12.5078 13.9688 12.3672L14.9922 13.3906C14.388 13.599 13.7526 13.763 13.0859 13.8828C12.4193 14.0026 11.724 14.0625 11 14.0625ZM11 0.671875C12.0521 0.671875 13.0443 0.799479 13.9766 1.05469C14.9141 1.30469 15.7786 1.63802 16.5703 2.05469C17.362 2.46615 18.0703 2.92188 18.6953 3.42188C19.3255 3.92188 19.862 4.42448 20.3047 4.92969C20.7474 5.42969 21.0859 5.89583 21.3203 6.32812C21.5547 6.75521 21.6719 7.10156 21.6719 7.36719C21.6719 7.59635 21.5807 7.89062 21.3984 8.25C21.2214 8.60938 20.9635 9.0026 20.625 9.42969C20.2865 9.85156 19.8724 10.2839 19.3828 10.7266C18.8984 11.1693 18.349 11.5911 17.7344 11.9922L16.7734 11.0312C17.3151 10.6979 17.8021 10.3516 18.2344 9.99219C18.6667 9.63281 19.0365 9.28385 19.3438 8.94531C19.6562 8.60156 19.8932 8.29427 20.0547 8.02344C20.2214 7.7474 20.3047 7.52865 20.3047 7.36719C20.3047 7.21094 20.1927 6.97135 19.9688 6.64844C19.75 6.32552 19.4375 5.95833 19.0312 5.54688C18.625 5.13021 18.1406 4.71094 17.5781 4.28906C17.0156 3.86719 16.388 3.47656 15.6953 3.11719C15.0026 2.7526 14.2604 2.46094 13.4688 2.24219C12.6771 2.01823 11.8542 1.90625 11 1.90625C10.5156 1.90625 10.0495 1.94271 9.60156 2.01562C9.15885 2.08854 8.72135 2.1875 8.28906 2.3125L7.25781 1.28906C7.83594 1.09635 8.43229 0.945312 9.04688 0.835938C9.66667 0.726562 10.3177 0.671875 11 0.671875ZM11 11.7422C10.3854 11.7422 9.8125 11.6276 9.28125 11.3984C8.75 11.1693 8.28385 10.8542 7.88281 10.4531C7.48177 10.0469 7.16927 9.58073 6.94531 9.05469C6.72135 8.52344 6.60677 7.96094 6.60156 7.36719C6.60156 7.01823 6.64062 6.68229 6.71875 6.35938C6.79688 6.03125 6.90885 5.72135 7.05469 5.42969L12.9141 11.2891C12.6224 11.4297 12.3151 11.5417 11.9922 11.625C11.6745 11.7031 11.3438 11.7422 11 11.7422ZM15.0078 9.07812L9.28125 3.35156C9.54167 3.23698 9.8151 3.14844 10.1016 3.08594C10.3932 3.02344 10.6927 2.99219 11 2.99219C11.6042 2.99219 12.1719 3.10417 12.7031 3.32812C13.2344 3.55208 13.7005 3.86458 14.1016 4.26562C14.5026 4.66146 14.8151 5.125 15.0391 5.65625C15.2682 6.1875 15.3828 6.75781 15.3828 7.36719C15.3828 7.66927 15.349 7.96615 15.2812 8.25781C15.2188 8.54427 15.1276 8.81771 15.0078 9.07812ZM17.0781 14.1328L4.00781 1.07812C3.89323 0.963542 3.83594 0.822917 3.83594 0.65625C3.83594 0.484375 3.89323 0.341146 4.00781 0.226562C4.1276 0.106771 4.27083 0.0494792 4.4375 0.0546875C4.60938 0.0546875 4.7526 0.111979 4.86719 0.226562L17.9297 13.2812C18.0495 13.401 18.112 13.5391 18.1172 13.6953C18.1224 13.8568 18.0599 14.0026 17.9297 14.1328C17.8099 14.263 17.6667 14.3255 17.5 14.3203C17.3385 14.3151 17.1979 14.2526 17.0781 14.1328Z", fill: "#777777" }) }));
};
const Plus = (_t) => {
  var rest = __objRest(_t, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 12 12", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M0.27832 6.06445C0.27832 5.85482 0.353516 5.6748 0.503906 5.52441C0.654297 5.36947 0.83431 5.29199 1.04395 5.29199H5.23438V1.1084C5.23438 0.898763 5.30957 0.71875 5.45996 0.568359C5.61035 0.417969 5.79036 0.342773 6 0.342773C6.21419 0.342773 6.39648 0.417969 6.54688 0.568359C6.69727 0.71875 6.77246 0.898763 6.77246 1.1084V5.29199H10.9561C11.1657 5.29199 11.3457 5.36947 11.4961 5.52441C11.6465 5.6748 11.7217 5.85482 11.7217 6.06445C11.7217 6.27865 11.6465 6.46094 11.4961 6.61133C11.3457 6.75716 11.1657 6.83008 10.9561 6.83008H6.77246V11.0273C6.77246 11.2324 6.69727 11.4102 6.54688 11.5605C6.39648 11.7109 6.21419 11.7861 6 11.7861C5.79036 11.7861 5.61035 11.7109 5.45996 11.5605C5.30957 11.4102 5.23438 11.2324 5.23438 11.0273V6.83008H1.04395C0.83431 6.83008 0.654297 6.75716 0.503906 6.61133C0.353516 6.46094 0.27832 6.27865 0.27832 6.06445Z", fill: "black", "fill-opacity": "0.5" }) }));
};
const Point = (_u) => {
  var rest = __objRest(_u, []);
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" }, rest), { children: [
    /* @__PURE__ */ jsx("g", { "clip-path": "url(#clip0_2883_1384)", children: /* @__PURE__ */ jsx("path", { d: "M10 20C8.63182 20 7.3443 19.7386 6.13746 19.2159C4.93062 18.6996 3.86576 17.98 2.94288 17.0571C2.02646 16.1342 1.30687 15.0694 0.784124 13.8625C0.261375 12.6557 0 11.3682 0 10C0 8.63182 0.261375 7.3443 0.784124 6.13746C1.30687 4.93062 2.02646 3.86899 2.94288 2.95257C3.86576 2.02969 4.9274 1.30687 6.12778 0.784124C7.33462 0.261375 8.62214 0 9.99032 0C11.365 0 12.6557 0.261375 13.8625 0.784124C15.0694 1.30687 16.1342 2.02969 17.0571 2.95257C17.98 3.86899 18.7028 4.93062 19.2256 6.13746C19.7483 7.3443 20.0097 8.63182 20.0097 10C20.0097 11.3682 19.7483 12.6557 19.2256 13.8625C18.7028 15.0694 17.98 16.1342 17.0571 17.0571C16.1342 17.98 15.0694 18.6996 13.8625 19.2159C12.6557 19.7386 11.3682 20 10 20ZM10 18.0252C11.1165 18.0252 12.1588 17.8187 13.1268 17.4056C14.0949 16.9926 14.9468 16.4182 15.6825 15.6825C16.4182 14.9468 16.9926 14.0949 17.4056 13.1268C17.8187 12.1588 18.0252 11.1165 18.0252 10C18.0252 8.88996 17.8187 7.85092 17.4056 6.88287C16.9926 5.90836 16.4182 5.05324 15.6825 4.31752C14.9468 3.5818 14.0916 3.00742 13.1171 2.59439C12.1491 2.18135 11.1068 1.97483 9.99032 1.97483C8.88028 1.97483 7.83801 2.18135 6.8635 2.59439C5.89545 3.00742 5.04679 3.5818 4.31752 4.31752C3.58825 5.05324 3.0171 5.90836 2.60407 6.88287C2.19103 7.85092 1.98451 8.88996 1.98451 10C1.98451 11.1165 2.19103 12.1588 2.60407 13.1268C3.0171 14.0949 3.58825 14.9468 4.31752 15.6825C5.05324 16.4182 5.90513 16.9926 6.87318 17.4056C7.84769 17.8187 8.88996 18.0252 10 18.0252ZM10 15.121C9.303 15.121 8.64795 14.9855 8.03485 14.7144C7.42175 14.4434 6.87964 14.0723 6.40852 13.6012C5.9374 13.13 5.56631 12.5879 5.29526 11.9748C5.03066 11.3617 4.89835 10.7067 4.89835 10.0097C4.89835 9.31268 5.03066 8.65763 5.29526 8.04453C5.56631 7.43143 5.93417 6.88932 6.39884 6.4182C6.86996 5.94708 7.41207 5.57599 8.02517 5.30494C8.64472 5.03388 9.303 4.89835 10 4.89835C10.697 4.89835 11.352 5.03388 11.9652 5.30494C12.5847 5.57599 13.1268 5.94708 13.5915 6.4182C14.0626 6.88287 14.4305 7.42498 14.6951 8.04453C14.9661 8.65763 15.1016 9.31268 15.1016 10.0097C15.1016 10.7067 14.9693 11.365 14.7047 11.9845C14.4401 12.5976 14.0723 13.1397 13.6012 13.6108C13.13 14.0755 12.5847 14.4434 11.9652 14.7144C11.352 14.9855 10.697 15.121 10 15.121ZM10 13.4076C10.6196 13.4076 11.1843 13.2559 11.6941 12.9526C12.2104 12.6428 12.6234 12.2298 12.9332 11.7135C13.243 11.1972 13.3979 10.6292 13.3979 10.0097C13.3979 9.39658 13.243 8.83188 12.9332 8.31559C12.6234 7.79929 12.2104 7.38625 11.6941 7.07648C11.1843 6.7667 10.6196 6.61181 10 6.61181C9.3869 6.61181 8.8222 6.7667 8.30591 7.07648C7.78961 7.3798 7.37657 7.78961 7.0668 8.30591C6.75702 8.8222 6.60213 9.39013 6.60213 10.0097C6.60213 10.6228 6.75702 11.1875 7.0668 11.7038C7.38303 12.2201 7.79606 12.6331 8.30591 12.9429C8.8222 13.2527 9.3869 13.4076 10 13.4076Z", fill: "#A1A1A1" }) }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_2883_1384", children: /* @__PURE__ */ jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
  ] }));
};
const Profile = (_v) => {
  var rest = __objRest(_v, []);
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, rest), { children: [
    /* @__PURE__ */ jsx("g", { "clip-path": "url(#clip0_281_6454)", children: /* @__PURE__ */ jsx("path", { d: "M2.65535 16.1152H13.3449C14.801 16.1152 15.529 15.6242 15.529 14.642C15.529 14.0596 15.352 13.4486 14.998 12.809C14.6497 12.1695 14.1472 11.5728 13.4905 11.0189C12.8338 10.465 12.0401 10.0167 11.1093 9.67416C10.1843 9.32578 9.15075 9.15167 8.00869 9.15167C6.85523 9.15167 5.81595 9.32578 4.8909 9.67416C3.96585 10.0167 3.17213 10.465 2.50974 11.0189C1.85307 11.5728 1.34771 12.1695 0.993682 12.809C0.645355 13.4486 0.471191 14.0596 0.471191 14.642C0.471191 15.6242 1.19925 16.1152 2.65535 16.1152ZM2.38126 14.6335C2.27848 14.6335 2.20425 14.6163 2.15856 14.5821C2.11859 14.5478 2.0986 14.4907 2.0986 14.4108C2.0986 14.0853 2.22709 13.7084 2.48405 13.2801C2.74672 12.8519 3.1293 12.4379 3.6318 12.0382C4.1343 11.6328 4.751 11.2987 5.48191 11.036C6.21855 10.7676 7.06082 10.6334 8.00869 10.6334C8.95086 10.6334 9.78743 10.7676 10.5183 11.036C11.2492 11.2987 11.866 11.6328 12.3684 12.0382C12.8766 12.4379 13.2592 12.8519 13.5162 13.2801C13.7731 13.7084 13.9016 14.0853 13.9016 14.4108C13.9016 14.4907 13.8788 14.5478 13.8331 14.5821C13.7931 14.6163 13.7246 14.6335 13.6275 14.6335H2.38126ZM8.00869 8.15811C8.69958 8.15811 9.32775 7.97532 9.89303 7.60993C10.4584 7.23874 10.9095 6.74477 11.2464 6.12809C11.5833 5.51139 11.7518 4.82902 11.7518 4.08098C11.7518 3.34436 11.5833 2.67626 11.2464 2.0767C10.9152 1.47713 10.4641 1.00032 9.89303 0.646286C9.32775 0.292249 8.69958 0.115234 8.00869 0.115234C7.31772 0.115234 6.68675 0.295108 6.11574 0.654855C5.55043 1.01459 5.09933 1.49711 4.76242 2.10239C4.42552 2.70196 4.25707 3.3672 4.25707 4.09811C4.25707 4.84044 4.42552 5.51995 4.76242 6.13666C5.09933 6.74766 5.55043 7.23874 6.11574 7.60993C6.68675 7.97532 7.31772 8.15811 8.00869 8.15811ZM8.00869 6.66767C7.6147 6.66767 7.24922 6.55637 6.91233 6.33367C6.58114 6.10525 6.31556 5.7969 6.11574 5.40861C5.91589 5.02031 5.81595 4.58348 5.81595 4.09811C5.81024 3.62416 5.90732 3.19876 6.10718 2.82188C6.31275 2.445 6.58114 2.14807 6.91233 1.93108C7.24352 1.70839 7.609 1.59703 8.00869 1.59703C8.40838 1.59703 8.77387 1.70553 9.10505 1.92252C9.43624 2.1395 9.70174 2.43643 9.90163 2.81331C10.1015 3.18448 10.2014 3.60703 10.2014 4.08098C10.2014 4.56635 10.1015 5.00603 9.90163 5.40004C9.70174 5.78834 9.43624 6.09668 9.10505 6.32508C8.77387 6.55347 8.40838 6.66767 8.00869 6.66767Z", fill: "#111111" }) }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_281_6454", children: /* @__PURE__ */ jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
  ] }));
};
const Redo = (_w) => {
  var rest = __objRest(_w, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "13", height: "16", viewBox: "0 0 13 16", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M0.529297 9.5293C0.529297 8.66797 0.686523 7.86361 1.00098 7.11621C1.31999 6.36426 1.75977 5.70801 2.32031 5.14746C2.88542 4.58236 3.54167 4.1403 4.28906 3.82129C5.03646 3.50228 5.83854 3.34277 6.69531 3.34277C6.81836 3.34277 6.93685 3.34961 7.05078 3.36328C7.16927 3.3724 7.28092 3.38607 7.38574 3.4043L6.02539 2.06445C5.95247 1.98698 5.89323 1.90267 5.84766 1.81152C5.80664 1.72038 5.78613 1.61556 5.78613 1.49707C5.78613 1.25098 5.86816 1.04362 6.03223 0.875C6.20085 0.70638 6.40365 0.62207 6.64062 0.62207C6.8776 0.62207 7.07585 0.70638 7.23535 0.875L10.0244 3.71191C10.2067 3.89421 10.2979 4.10612 10.2979 4.34766C10.2979 4.4707 10.2751 4.58691 10.2295 4.69629C10.1839 4.80111 10.1156 4.89909 10.0244 4.99023L7.23535 7.81348C7.0804 7.97298 6.88216 8.05273 6.64062 8.05273C6.40365 8.05273 6.20085 7.9707 6.03223 7.80664C5.86816 7.63802 5.78613 7.43522 5.78613 7.19824C5.78613 7.0752 5.80892 6.9681 5.85449 6.87695C5.90007 6.78581 5.95931 6.7015 6.03223 6.62402L7.57031 5.10645C7.44271 5.08366 7.30371 5.06543 7.15332 5.05176C7.00749 5.03809 6.85482 5.03125 6.69531 5.03125C6.08008 5.03125 5.50586 5.14746 4.97266 5.37988C4.43945 5.60775 3.97233 5.92676 3.57129 6.33691C3.17025 6.74707 2.85579 7.22559 2.62793 7.77246C2.40462 8.31478 2.29297 8.90039 2.29297 9.5293C2.29297 10.1491 2.4069 10.7301 2.63477 11.2725C2.86719 11.8102 3.1862 12.2842 3.5918 12.6943C4.00195 13.1045 4.47591 13.4258 5.01367 13.6582C5.55599 13.8861 6.13704 14 6.75684 14C7.37207 14 7.94857 13.8861 8.48633 13.6582C9.02865 13.4258 9.5026 13.1045 9.9082 12.6943C10.3184 12.2842 10.6396 11.8102 10.8721 11.2725C11.1045 10.7301 11.2207 10.1491 11.2207 9.5293C11.2207 9.26497 11.3005 9.0485 11.46 8.87988C11.6195 8.71126 11.8268 8.62695 12.082 8.62695C12.3418 8.62695 12.5537 8.71126 12.7178 8.87988C12.8864 9.0485 12.9707 9.26497 12.9707 9.5293C12.9707 10.3952 12.8112 11.2041 12.4922 11.9561C12.1732 12.708 11.7266 13.3711 11.1523 13.9453C10.5827 14.515 9.92188 14.9593 9.16992 15.2783C8.41797 15.6019 7.61361 15.7637 6.75684 15.7637C5.89551 15.7637 5.08659 15.6019 4.33008 15.2783C3.57812 14.9593 2.91732 14.515 2.34766 13.9453C1.78255 13.3711 1.33822 12.708 1.01465 11.9561C0.691081 11.2041 0.529297 10.3952 0.529297 9.5293Z", fill: "black" }) }));
};
const RightArrow = (_x) => {
  var rest = __objRest(_x, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "13", viewBox: "0 0 16 13", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M15.8516 6.33594C15.8516 6.66406 15.737 6.94271 15.5078 7.17188L10.4141 12.25C10.1797 12.4844 9.91667 12.6016 9.625 12.6016C9.29167 12.6016 9.02344 12.4974 8.82031 12.2891C8.61719 12.0859 8.51562 11.8333 8.51562 11.5312C8.51562 11.3594 8.54688 11.2083 8.60938 11.0781C8.67708 10.9427 8.76302 10.8229 8.86719 10.7188L10.6172 8.96875L13.2031 6.59375L13.6797 7.30469L10.6484 7.46875H1.8125C1.46354 7.46875 1.17969 7.36458 0.960938 7.15625C0.747396 6.94792 0.640625 6.67448 0.640625 6.33594C0.640625 5.9974 0.747396 5.72396 0.960938 5.51562C1.17969 5.30729 1.46354 5.20312 1.8125 5.20312H10.6484L13.6797 5.36719L13.2031 6.07812L10.6172 3.70312L8.86719 1.94531C8.76302 1.84115 8.67708 1.72396 8.60938 1.59375C8.54688 1.45833 8.51562 1.30469 8.51562 1.13281C8.51562 0.830729 8.61719 0.578125 8.82031 0.375C9.02344 0.166667 9.29167 0.0625 9.625 0.0625C9.76562 0.0625 9.90365 0.09375 10.0391 0.15625C10.1745 0.213542 10.3021 0.302083 10.4219 0.421875L15.5078 5.5C15.737 5.72396 15.8516 6.0026 15.8516 6.33594Z", fill: "black" }) }));
};
const RightChevron = (_y) => {
  var rest = __objRest(_y, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "8", height: "15", viewBox: "0 0 8 15", fill: "black" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M8.00781 7.85938C8.00781 7.99479 7.98177 8.11979 7.92969 8.23438C7.8776 8.34896 7.79948 8.45833 7.69531 8.5625L1.60938 14.5156C1.4375 14.6927 1.22396 14.7812 0.96875 14.7812C0.802083 14.7812 0.648438 14.7396 0.507812 14.6562C0.367188 14.5781 0.255208 14.4688 0.171875 14.3281C0.09375 14.1927 0.0546875 14.0417 0.0546875 13.875C0.0546875 13.625 0.148438 13.4036 0.335938 13.2109L5.82031 7.85938L0.335938 2.50781C0.148438 2.3151 0.0546875 2.09635 0.0546875 1.85156C0.0546875 1.67969 0.09375 1.52604 0.171875 1.39062C0.255208 1.25521 0.367188 1.14844 0.507812 1.07031C0.648438 0.986979 0.802083 0.945312 0.96875 0.945312C1.22396 0.945312 1.4375 1.03125 1.60938 1.20312L7.69531 7.15625C7.79948 7.26042 7.8776 7.36979 7.92969 7.48438C7.98177 7.59896 8.00781 7.72396 8.00781 7.85938Z" }) }));
};
const Shield = (_z) => {
  var rest = __objRest(_z, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "33", height: "41", viewBox: "0 0 33 41", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M16.6094 40.1523C16.4531 40.1523 16.2578 40.1198 16.0234 40.0547C15.7891 39.9896 15.5482 39.8919 15.3008 39.7617C12.5273 38.1992 10.1836 36.8125 8.26953 35.6016C6.36849 34.3906 4.83854 33.2188 3.67969 32.0859C2.52083 30.9531 1.68099 29.7292 1.16016 28.4141C0.639323 27.099 0.378906 25.5495 0.378906 23.7656V8.82422C0.378906 7.79557 0.59375 7.0599 1.02344 6.61719C1.46615 6.16146 2.09766 5.76432 2.91797 5.42578C3.3737 5.23047 4.00521 4.97656 4.8125 4.66406C5.61979 4.35156 6.51172 4.01302 7.48828 3.64844C8.46484 3.28385 9.4349 2.92578 10.3984 2.57422C11.375 2.20964 12.2669 1.89062 13.0742 1.61719C13.8815 1.33073 14.5195 1.1224 14.9883 0.992188C15.2487 0.927083 15.5156 0.861979 15.7891 0.796875C16.0625 0.731771 16.3359 0.699219 16.6094 0.699219C16.8828 0.699219 17.1562 0.731771 17.4297 0.796875C17.7161 0.848958 17.9896 0.914062 18.25 0.992188C18.7057 1.14844 19.3372 1.36979 20.1445 1.65625C20.9518 1.94271 21.8438 2.26172 22.8203 2.61328C23.7969 2.96484 24.7669 3.32292 25.7305 3.6875C26.707 4.03906 27.599 4.37109 28.4062 4.68359C29.2135 4.98307 29.8451 5.23047 30.3008 5.42578C31.1341 5.77734 31.7656 6.17448 32.1953 6.61719C32.625 7.0599 32.8398 7.79557 32.8398 8.82422V23.7656C32.8398 25.5495 32.5794 27.1055 32.0586 28.4336C31.5508 29.7487 30.7174 30.9727 29.5586 32.1055C28.3997 33.2383 26.8633 34.4036 24.9492 35.6016C23.0482 36.8125 20.7044 38.1992 17.918 39.7617C17.6706 39.8919 17.4297 39.9896 17.1953 40.0547C16.9609 40.1198 16.7656 40.1523 16.6094 40.1523ZM16.6094 36.6172C16.7656 36.6172 16.9349 36.5781 17.1172 36.5C17.2995 36.4349 17.5339 36.3177 17.8203 36.1484C20.0729 34.7812 21.9609 33.6029 23.4844 32.6133C25.0208 31.6237 26.2448 30.6862 27.1562 29.8008C28.0807 28.9154 28.7383 27.9453 29.1289 26.8906C29.5326 25.8359 29.7344 24.5534 29.7344 23.043V9.42969C29.7344 9.10417 29.6888 8.85677 29.5977 8.6875C29.5195 8.51823 29.3503 8.38802 29.0898 8.29688C28.4779 8.08854 27.7747 7.84766 26.9805 7.57422C26.1992 7.28776 25.3724 6.98828 24.5 6.67578C23.6406 6.36328 22.7747 6.05078 21.9023 5.73828C21.043 5.41276 20.2227 5.10677 19.4414 4.82031C18.6602 4.52083 17.9766 4.25391 17.3906 4.01953C17.2344 3.95443 17.0911 3.90885 16.9609 3.88281C16.8307 3.85677 16.7135 3.84375 16.6094 3.84375C16.5052 3.84375 16.388 3.85677 16.2578 3.88281C16.1276 3.90885 15.9844 3.95443 15.8281 4.01953C15.2422 4.25391 14.5586 4.51432 13.7773 4.80078C12.9961 5.08724 12.1693 5.38672 11.2969 5.69922C10.4245 5.9987 9.55208 6.30469 8.67969 6.61719C7.80729 6.92969 6.98047 7.22917 6.19922 7.51562C5.41797 7.80208 4.73438 8.0625 4.14844 8.29688C3.875 8.40104 3.69271 8.53776 3.60156 8.70703C3.52344 8.86328 3.48438 9.10417 3.48438 9.42969V23.043C3.48438 24.5534 3.6862 25.8359 4.08984 26.8906C4.49349 27.9453 5.15104 28.9219 6.0625 29.8203C6.97396 30.7057 8.19141 31.6432 9.71484 32.6328C11.2513 33.6094 13.1458 34.7812 15.3984 36.1484C15.6849 36.3177 15.9193 36.4349 16.1016 36.5C16.2839 36.5781 16.4531 36.6172 16.6094 36.6172ZM9.55859 27.1836V19.4102C9.55859 18.069 10.1315 17.3594 11.2773 17.2812V14.9766C11.2773 13.1797 11.7656 11.7279 12.7422 10.6211C13.7318 9.51432 15.0208 8.96094 16.6094 8.96094C18.1979 8.96094 19.4805 9.51432 20.457 10.6211C21.4466 11.7279 21.9414 13.1797 21.9414 14.9766V17.2812C23.1003 17.3594 23.6797 18.069 23.6797 19.4102V27.1836C23.6797 28.6159 23.0091 29.332 21.668 29.332H11.5508C10.2227 29.332 9.55859 28.6159 9.55859 27.1836ZM13.3086 17.2617H19.9102V14.7617C19.9102 13.6159 19.6042 12.6914 18.9922 11.9883C18.3932 11.2852 17.599 10.9336 16.6094 10.9336C15.6198 10.9336 14.819 11.2852 14.207 11.9883C13.6081 12.6914 13.3086 13.6159 13.3086 14.7617V17.2617Z", fill: "#777777" }) }));
};
const SumSubFail = (_A) => {
  var rest = __objRest(_A, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "140", height: "90", viewBox: "0 0 140 90", fill: "#DB0027" }, rest), { children: /* @__PURE__ */ jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.4138 8.53453H104.383C106.525 8.53453 108.262 10.2714 108.262 12.4139V34.2173C110.809 32.5064 114.17 32.422 116.797 33.9642V12.4139C116.797 5.55788 111.239 0 104.383 0H12.4138C5.55786 0 0 5.55789 0 12.4139V76.7205C0 83.5765 5.55786 89.1344 12.4138 89.1344H79.3647C77.8777 86.7289 77.6424 83.558 79.3151 80.784L79.4262 80.5999H12.4138C10.2714 80.5999 8.53452 78.863 8.53452 76.7205V12.4139C8.53452 10.2714 10.2714 8.53453 12.4138 8.53453ZM69.156 60.3606H91.6307L87.9239 66.5078H69.156C67.4585 66.5078 66.0824 65.1317 66.0824 63.4342C66.0824 61.7367 67.4585 60.3606 69.156 60.3606ZM20.3068 68.2288C18.9029 68.2288 17.7973 67.9129 16.9901 67.2811C16.2004 66.6669 15.8055 65.8158 15.8055 64.7278C15.8055 63.0256 16.3145 61.2444 17.3323 59.3843C18.3501 57.5066 19.8242 55.7517 21.7545 54.1197C23.6849 52.4701 26.0101 51.1364 28.7301 50.1186C31.4677 49.0832 34.5387 48.5656 37.9431 48.5656C41.3651 48.5656 44.4361 49.0832 47.1561 50.1186C49.8937 51.1364 52.2189 52.4701 54.1317 54.1197C56.062 55.7517 57.5361 57.5066 58.554 59.3843C59.5893 61.2444 60.107 63.0256 60.107 64.7278C60.107 65.8158 59.7034 66.6669 58.8961 67.2811C58.1065 67.9129 57.0097 68.2288 55.6058 68.2288H20.3068ZM37.9694 43.8537C36.0917 43.8537 34.3544 43.3448 32.7575 42.327C31.1606 41.2917 29.8708 39.9053 28.888 38.168C27.9229 36.4131 27.4403 34.4477 27.4403 32.2717C27.4403 30.1307 27.9229 28.2004 28.888 26.4806C29.8708 24.7609 31.1606 23.4008 32.7575 22.4006C34.3544 21.4003 36.0917 20.9002 37.9694 20.9002C39.8471 20.9002 41.5844 21.3915 43.1814 22.3743C44.7783 23.357 46.0594 24.7082 47.0245 26.428C48.0072 28.1302 48.4986 30.0605 48.4986 32.219C48.4986 34.4126 48.0072 36.3868 47.0245 38.1417C46.0594 39.8965 44.7783 41.2917 43.1814 42.327C41.5844 43.3448 39.8471 43.8537 37.9694 43.8537ZM69.156 28.0878C67.4585 28.0878 66.0824 26.7118 66.0824 25.0142C66.0824 23.3167 67.4585 21.9406 69.156 21.9406H96.8184C98.5159 21.9406 99.892 23.3167 99.892 25.0142C99.892 26.7118 98.5159 28.0878 96.8185 28.0878H69.156ZM69.156 46.5292C67.4585 46.5292 66.0824 45.1531 66.0824 43.4556C66.0824 41.7581 67.4585 40.382 69.156 40.382H96.8184C98.5159 40.382 99.892 41.7581 99.892 43.4556C99.892 45.1531 98.5159 46.5292 96.8185 46.5292H69.156ZM117.874 46.2021C115.457 42.1941 109.645 42.1941 107.228 46.2021L86.6098 80.3947C84.1117 84.5374 87.095 89.8202 91.9326 89.8202H133.17C138.007 89.8202 140.991 84.5374 138.493 80.3947L117.874 46.2021ZM112.551 56.0221C111.049 56.0221 109.832 57.2396 109.832 58.7415V71.1729C109.832 72.6748 111.049 73.8923 112.551 73.8923C114.053 73.8923 115.271 72.6748 115.271 71.1729V58.7415C115.271 57.2396 114.053 56.0221 112.551 56.0221ZM115.659 79.331C115.659 81.0475 114.268 82.4389 112.551 82.4389C110.835 82.4389 109.444 81.0475 109.444 79.331C109.444 77.6146 110.835 76.2232 112.551 76.2232C114.268 76.2232 115.659 77.6146 115.659 79.331Z" }) }));
};
const SumSubPending = (_B) => {
  var rest = __objRest(_B, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "138", height: "91", viewBox: "0 0 138 91", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.507 8.59855H106.309C108.468 8.59855 110.218 10.3484 110.218 12.507V37.96C111.581 37.7656 112.974 37.665 114.391 37.665C115.895 37.665 117.373 37.7784 118.816 37.9972V12.507C118.816 5.59957 113.217 0 106.309 0H12.507C5.59957 0 0 5.59958 0 12.507V78.1686C0 85.076 5.59955 90.6756 12.507 90.6756H97.1886C94.0165 88.3708 91.3248 85.4451 89.2919 82.077H12.507C10.3484 82.077 8.59855 80.3272 8.59855 78.1686V12.507C8.59855 10.3484 10.3484 8.59855 12.507 8.59855ZM98.4946 40.6471C99.1843 40.6471 99.8219 40.8704 100.339 41.2487C97.6139 42.7412 95.152 44.6542 93.0407 46.9006H70.3539C68.627 46.9006 67.2271 45.5007 67.2271 43.7738C67.2271 42.047 68.627 40.6471 70.3539 40.6471H98.4946ZM70.3539 60.9712H85.7082C85.3065 62.9045 85.0955 64.9077 85.0955 66.9602C85.0955 67.0485 85.0959 67.1366 85.0966 67.2246H70.3539C68.627 67.2246 67.2271 65.8248 67.2271 64.0979C67.2271 62.371 68.627 60.9712 70.3539 60.9712ZM20.8312 69.0179C19.4168 69.0179 18.3029 68.6997 17.4896 68.0632C16.694 67.4444 16.2962 66.5869 16.2962 65.4907C16.2962 63.7757 16.8089 61.9812 17.8344 60.1071C18.8598 58.2153 20.345 56.4473 22.2898 54.803C24.2346 53.141 26.5773 51.7973 29.3177 50.7719C32.0758 49.7288 35.1699 49.2072 38.5998 49.2072C42.0475 49.2072 45.1415 49.7288 47.882 50.7719C50.6401 51.7973 52.9827 53.141 54.9099 54.803C56.8547 56.4473 58.3398 58.2153 59.3653 60.1071C60.4084 61.9812 60.93 63.7757 60.93 65.4907C60.93 66.5869 60.5233 67.4444 59.7101 68.0632C58.9144 68.6997 57.8094 69.0179 56.395 69.0179H20.8312ZM38.6264 44.46C36.7346 44.46 34.9842 43.9473 33.3753 42.9219C31.7664 41.8787 30.4669 40.482 29.4768 38.7316C28.5044 36.9636 28.0182 34.9834 28.0182 32.7911C28.0182 30.6341 28.5044 28.6893 29.4768 26.9566C30.4669 25.2239 31.7664 23.8537 33.3753 22.8459C34.9842 21.8382 36.7346 21.3343 38.6264 21.3343C40.5181 21.3343 42.2685 21.8293 43.8774 22.8194C45.4863 23.8095 46.777 25.1709 47.7494 26.9036C48.7395 28.6185 49.2345 30.5634 49.2345 32.738C49.2345 34.9481 48.7395 36.9371 47.7494 38.7051C46.777 40.4732 45.4863 41.8787 43.8774 42.9219C42.2685 43.9473 40.5181 44.46 38.6264 44.46ZM70.3539 28.1404C68.627 28.1404 67.2271 26.7405 67.2271 25.0136C67.2271 23.2868 68.627 21.8869 70.3539 21.8869H98.4946C100.221 21.8869 101.621 23.2868 101.621 25.0136C101.621 26.7405 100.221 28.1404 98.4946 28.1404H70.3539ZM137.999 66.2089C137.999 78.8915 127.717 89.1727 115.035 89.1727C102.352 89.1727 92.0708 78.8915 92.0708 66.2089C92.0708 53.5263 102.352 43.2451 115.035 43.2451C127.717 43.2451 137.999 53.5263 137.999 66.2089ZM115.73 50.2034C117.267 50.2034 118.513 51.4496 118.513 52.9868V66.3212L127.48 71.3631C128.839 72.1269 129.321 73.8475 128.557 75.2061C127.808 76.5381 126.135 77.032 124.783 76.3202L114.615 70.9682C114.078 70.6858 113.666 70.2758 113.387 69.8002C113.108 69.3665 112.946 68.8502 112.946 68.2961V52.9868C112.946 51.4496 114.193 50.2034 115.73 50.2034Z", fill: "#777777" }) }));
};
const SumSubVerified = (_C) => {
  var rest = __objRest(_C, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "138", height: "90", viewBox: "0 0 138 90", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.3724 8.50603H105.165C107.301 8.50603 109.032 10.2371 109.032 12.3724V37.5518C110.38 37.3595 111.759 37.26 113.16 37.26C114.648 37.26 116.11 37.3721 117.538 37.5885V12.3724C117.538 5.53932 111.999 0 105.165 0H12.3724C5.53932 0 0 5.53932 0 12.3724V77.3275C0 84.1606 5.53932 89.6999 12.3724 89.6999H96.1428C93.005 87.4199 90.3423 84.5257 88.3313 81.1939H12.3724C10.2371 81.1939 8.50603 79.4629 8.50603 77.3275V12.3724C8.50603 10.2371 10.2371 8.50603 12.3724 8.50603ZM97.4334 40.2106C98.1159 40.2106 98.7466 40.4316 99.2582 40.8059C96.5627 42.2823 94.1276 44.1748 92.0392 46.3968H69.5955C67.8873 46.3968 66.5024 45.012 66.5024 43.3037C66.5024 41.5954 67.8873 40.2106 69.5955 40.2106H97.4334ZM69.5955 60.3158H84.7862C84.3889 62.2282 84.1801 64.2097 84.1801 66.24C84.1801 66.2973 84.1803 66.3546 84.1806 66.4119C84.1808 66.4419 84.181 66.472 84.1813 66.502H69.5955C67.8873 66.502 66.5024 65.1172 66.5024 63.4089C66.5024 61.7006 67.8873 60.3158 69.5955 60.3158ZM20.6061 67.7489C19.2069 67.7489 18.1051 67.434 17.3005 66.8044C16.5135 66.1923 16.1199 65.344 16.1199 64.2596C16.1199 62.5631 16.6271 60.7878 17.6416 58.9339C18.656 57.0625 20.1251 55.3135 22.049 53.6869C23.9729 52.0428 26.2904 50.7136 29.0013 49.6992C31.7298 48.6673 34.7905 48.1513 38.1836 48.1513C41.5941 48.1513 44.6549 48.6673 47.3658 49.6992C50.0943 50.7136 52.4117 52.0428 54.3181 53.6869C56.242 55.3135 57.7112 57.0625 58.7256 58.9339C59.7575 60.7878 60.2735 62.5631 60.2735 64.2596C60.2735 65.344 59.8712 66.1923 59.0667 66.8044C58.2796 67.434 57.1865 67.7489 55.7873 67.7489H20.6061ZM38.2098 43.4552C36.3384 43.4552 34.6069 42.948 33.0153 41.9336C31.4237 40.9017 30.1382 39.52 29.1587 37.7885C28.1968 36.0395 27.7158 34.0806 27.7158 31.9118C27.7158 29.7781 28.1968 27.8542 29.1587 26.1401C30.1382 24.4261 31.4237 23.0706 33.0153 22.0737C34.6069 21.0768 36.3384 20.5783 38.2098 20.5783C40.0812 20.5783 41.8128 21.068 43.4044 22.0475C44.9959 23.0269 46.2727 24.3736 47.2347 26.0877C48.2141 27.7842 48.7038 29.7081 48.7038 31.8594C48.7038 34.0456 48.2141 36.0132 47.2347 37.7622C46.2727 39.5112 44.9959 40.9017 43.4044 41.9336C41.8128 42.948 40.0812 43.4552 38.2098 43.4552ZM69.5955 27.8383C67.8873 27.8383 66.5024 26.4534 66.5024 24.7452C66.5024 23.0369 67.8873 21.6521 69.5955 21.6521H97.4334C99.1417 21.6521 100.527 23.0369 100.527 24.7452C100.527 26.4534 99.1417 27.8383 97.4334 27.8383H69.5955ZM108.269 43.8226C111.288 40.5926 116.411 40.5926 119.429 43.8226C120.935 45.4336 123.064 46.3152 125.267 46.2408C129.686 46.0914 133.308 49.7135 133.159 54.1321C133.084 56.3359 133.966 58.4644 135.577 59.9701C138.807 62.9889 138.807 68.1112 135.577 71.1301C133.966 72.6357 133.084 74.7642 133.159 76.968C133.308 81.3867 129.686 85.0087 125.267 84.8594C123.064 84.7849 120.935 85.6665 119.429 87.2775C116.411 90.5076 111.288 90.5076 108.269 87.2775C106.764 85.6665 104.635 84.7849 102.431 84.8594C98.0128 85.0087 94.3908 81.3867 94.5401 76.968C94.6146 74.7642 93.733 72.6357 92.122 71.1301C88.8919 68.1112 88.8919 62.9889 92.122 59.9701C93.733 58.4644 94.6146 56.3359 94.5401 54.1321C94.3908 49.7135 98.0128 46.0914 102.431 46.2408C104.635 46.3152 106.764 45.4336 108.269 43.8226ZM124.766 54.1346C123.633 53.3911 122.111 53.7072 121.368 54.8407L110.933 70.7479L106.197 64.9893C105.336 63.9424 103.789 63.7917 102.743 64.6527C101.696 65.5137 101.545 67.0604 102.406 68.1073L109.141 76.297C110.002 77.3439 111.549 77.4946 112.596 76.6336C112.66 76.5806 112.721 76.525 112.779 76.4671C113.074 76.2844 113.335 76.036 113.538 75.7267L125.472 57.5331C126.216 56.3996 125.9 54.8781 124.766 54.1346Z", fill: "#16A34A" }) }));
};
const Tool = (_D) => {
  var rest = __objRest(_D, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 18 18", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M8.21094 17.8359C7.88802 17.8359 7.60677 17.7448 7.36719 17.5625C7.13281 17.3802 6.97917 17.1328 6.90625 16.8203L6.58594 15.4375L6.375 15.3672L5.17969 16.1016C4.90885 16.2734 4.6224 16.3385 4.32031 16.2969C4.02344 16.2604 3.76042 16.1276 3.53125 15.8984L2.4375 14.8125C2.20312 14.5781 2.06771 14.3125 2.03125 14.0156C1.99479 13.7188 2.0625 13.4349 2.23438 13.1641L2.98438 11.9688L2.91406 11.7734L1.53125 11.4531C1.22396 11.3802 0.976562 11.224 0.789062 10.9844C0.606771 10.7448 0.515625 10.4661 0.515625 10.1484V8.60938C0.515625 8.29167 0.606771 8.01562 0.789062 7.78125C0.971354 7.54167 1.21875 7.38281 1.53125 7.30469L2.89844 6.97656L2.97656 6.76562L2.22656 5.57031C2.05469 5.30469 1.98698 5.02344 2.02344 4.72656C2.0599 4.42969 2.19531 4.16406 2.42969 3.92969L3.52344 2.83594C3.7526 2.60677 4.01562 2.47396 4.3125 2.4375C4.60938 2.39583 4.89323 2.45833 5.16406 2.625L6.36719 3.36719L6.58594 3.28125L6.90625 1.89844C6.97917 1.59115 7.13281 1.34635 7.36719 1.16406C7.60677 0.976562 7.88802 0.882812 8.21094 0.882812H9.79688C10.1198 0.882812 10.3984 0.976562 10.6328 1.16406C10.8672 1.34635 11.0208 1.59115 11.0938 1.89844L11.4141 3.28125L11.6328 3.36719L12.8359 2.625C13.1068 2.45833 13.3906 2.39583 13.6875 2.4375C13.9896 2.47396 14.2526 2.60677 14.4766 2.83594L15.5703 3.92969C15.7995 4.16406 15.9323 4.42969 15.9688 4.72656C16.0104 5.02344 15.9453 5.30469 15.7734 5.57031L15.0234 6.76562L15.1094 6.97656L16.4688 7.30469C16.776 7.3776 17.0208 7.53385 17.2031 7.77344C17.3906 8.01302 17.4844 8.29167 17.4844 8.60938V10.1484C17.4844 10.4661 17.3906 10.7448 17.2031 10.9844C17.0208 11.2188 16.776 11.375 16.4688 11.4531L15.0938 11.7734L15.0156 11.9688L15.7656 13.1641C15.9375 13.4349 16.0026 13.7188 15.9609 14.0156C15.9245 14.3125 15.7917 14.5781 15.5625 14.8125L14.4688 15.8984C14.2396 16.1276 13.974 16.2604 13.6719 16.2969C13.375 16.3385 13.0911 16.2734 12.8203 16.1016L11.6172 15.3672L11.4141 15.4375L11.0938 16.8203C11.0208 17.1328 10.8672 17.3802 10.6328 17.5625C10.3984 17.7448 10.1198 17.8359 9.79688 17.8359H8.21094ZM8.40625 16.4219H9.60156C9.72656 16.4219 9.79688 16.362 9.8125 16.2422L10.2812 14.3203C10.5417 14.263 10.7839 14.1875 11.0078 14.0938C11.2318 13.9948 11.4401 13.8854 11.6328 13.7656L13.3125 14.7969C13.4115 14.8646 13.5078 14.8542 13.6016 14.7656L14.4297 13.9297C14.513 13.8568 14.5208 13.763 14.4531 13.6484L13.4219 11.9766C13.5312 11.7891 13.6328 11.5807 13.7266 11.3516C13.8255 11.1224 13.9036 10.8854 13.9609 10.6406L15.8906 10.1797C16.0104 10.1589 16.0703 10.0859 16.0703 9.96094V8.78906C16.0703 8.66927 16.0104 8.59635 15.8906 8.57031L13.9688 8.10938C13.9062 7.84896 13.8229 7.60156 13.7188 7.36719C13.6198 7.13281 13.5234 6.93229 13.4297 6.76562L14.4609 5.08594C14.5339 4.97656 14.526 4.8776 14.4375 4.78906L13.6094 3.97656C13.5208 3.89323 13.4219 3.88021 13.3125 3.9375L11.6328 4.96094C11.4401 4.85156 11.2292 4.75 11 4.65625C10.776 4.55729 10.5365 4.47656 10.2812 4.41406L9.8125 2.47656C9.79688 2.35677 9.72656 2.29688 9.60156 2.29688H8.40625C8.27604 2.29688 8.20052 2.35677 8.17969 2.47656L7.72656 4.39844C7.47656 4.46094 7.22917 4.54427 6.98438 4.64844C6.74479 4.7474 6.53646 4.84896 6.35938 4.95312L4.67969 3.9375C4.57552 3.88021 4.47917 3.89062 4.39062 3.96875L3.55469 4.78906C3.47135 4.8776 3.46354 4.97656 3.53125 5.08594L4.5625 6.76562C4.47396 6.93229 4.3776 7.13281 4.27344 7.36719C4.16927 7.60156 4.08854 7.84896 4.03125 8.10938L2.10938 8.57031C1.98958 8.59635 1.92969 8.66927 1.92969 8.78906V9.96094C1.92969 10.0859 1.98958 10.1589 2.10938 10.1797L4.03125 10.6328C4.09375 10.8828 4.17448 11.1224 4.27344 11.3516C4.3724 11.5755 4.47396 11.7839 4.57812 11.9766L3.53906 13.6562C3.47656 13.7656 3.48438 13.8594 3.5625 13.9375L4.39844 14.7656C4.49219 14.8542 4.58594 14.8672 4.67969 14.8047L6.36719 13.7656C6.5599 13.8854 6.77083 13.9948 7 14.0938C7.23438 14.1875 7.47396 14.263 7.71875 14.3203L8.17969 16.2422C8.20052 16.362 8.27604 16.4219 8.40625 16.4219ZM9 12.3281C8.45833 12.3281 7.96094 12.1953 7.50781 11.9297C7.0599 11.6589 6.70052 11.2995 6.42969 10.8516C6.16406 10.4036 6.03125 9.90625 6.03125 9.35938C6.03125 8.81771 6.16406 8.32292 6.42969 7.875C6.70052 7.42708 7.0599 7.07031 7.50781 6.80469C7.96094 6.53906 8.45833 6.40625 9 6.40625C9.54688 6.40625 10.0443 6.53906 10.4922 6.80469C10.9401 7.07031 11.2969 7.42708 11.5625 7.875C11.8281 8.32292 11.9609 8.81771 11.9609 9.35938C11.9609 9.90104 11.8281 10.3984 11.5625 10.8516C11.2969 11.3047 10.9401 11.6641 10.4922 11.9297C10.0443 12.1953 9.54688 12.3281 9 12.3281ZM9 10.9844C9.29167 10.9844 9.5599 10.9115 9.80469 10.7656C10.0495 10.6146 10.2422 10.4167 10.3828 10.1719C10.5286 9.92708 10.6016 9.65625 10.6016 9.35938C10.6016 9.0625 10.5286 8.79427 10.3828 8.55469C10.2422 8.3099 10.0495 8.11458 9.80469 7.96875C9.5599 7.82292 9.29167 7.75 9 7.75C8.70312 7.75 8.43229 7.82292 8.1875 7.96875C7.94271 8.11458 7.7474 8.3099 7.60156 8.55469C7.45573 8.79427 7.38281 9.0625 7.38281 9.35938C7.38281 9.66146 7.45573 9.9349 7.60156 10.1797C7.7474 10.4245 7.94271 10.6198 8.1875 10.7656C8.43229 10.9115 8.70312 10.9844 9 10.9844Z", fill: "black" }) }));
};
const Twitter = (_E) => {
  var rest = __objRest(_E, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "23", height: "22", viewBox: "0 0 23 22", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M13.0237 9.77569L18.9811 3H17.5699L12.3949 8.88203L8.2648 3H3.5L9.74693 11.8955L3.5 19H4.9112L10.3725 12.787L14.7352 19H19.5M5.42053 4.04127H7.58853L17.5688 18.0099H15.4003", fill: "white" }) }));
};
const World = (_F) => {
  var rest = __objRest(_F, []);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "12", height: "13", viewBox: "0 0 12 13", fill: "none" }, rest), { children: /* @__PURE__ */ jsx("path", { d: "M6.25977 11.1992C6.07617 11.1992 5.89844 11.127 5.72656 10.9824C5.55859 10.834 5.47461 10.6797 5.47461 10.5195C5.47461 10.3398 5.51172 10.1719 5.58594 10.0156C5.66406 9.85547 5.70117 9.67773 5.69727 9.48242C5.69727 9.41211 5.66406 9.34375 5.59766 9.27734C5.53516 9.20703 5.41797 9.11133 5.24609 8.99023C5.07812 8.86914 4.83594 8.68945 4.51953 8.45117C4.22266 8.23242 4.07422 7.97656 4.07422 7.68359C4.07422 7.57422 4.09766 7.48047 4.14453 7.40234C4.19141 7.32031 4.23828 7.24219 4.28516 7.16797C4.33203 7.09375 4.35547 7.01562 4.35547 6.93359C4.35547 6.85938 4.31836 6.78711 4.24414 6.7168C4.16992 6.64648 4.06445 6.55078 3.92773 6.42969L3.07227 5.68555C2.66211 5.33008 2.3457 4.98438 2.12305 4.64844C1.9043 4.3125 1.8125 3.99023 1.84766 3.68164C1.89062 3.39258 2.03516 3.11133 2.28125 2.83789C2.53125 2.56055 2.85156 2.31055 3.24219 2.08789C3.63281 1.86133 4.06641 1.68164 4.54297 1.54883C5.02344 1.41602 5.51367 1.34961 6.01367 1.34961C6.69336 1.34961 7.30273 1.45313 7.8418 1.66016C8.38086 1.86328 8.75977 2.13477 8.97852 2.47461C8.88086 2.67773 8.74023 2.86914 8.55664 3.04883C8.37695 3.22461 8.17773 3.38672 7.95898 3.53516C7.74023 3.68359 7.52539 3.81445 7.31445 3.92773C7.10742 4.04102 6.92773 4.13477 6.77539 4.20898C6.85742 4.33789 6.92383 4.45508 6.97461 4.56055C7.02539 4.66602 7.05078 4.76758 7.05078 4.86523C7.05078 5.05273 7 5.20703 6.89844 5.32812C6.80078 5.44922 6.65625 5.50977 6.46484 5.50977C6.3125 5.50977 6.16211 5.4707 6.01367 5.39258C5.86914 5.31055 5.73242 5.23047 5.60352 5.15234C5.47461 5.07031 5.36328 5.0293 5.26953 5.0293C5.1875 5.0293 5.11523 5.05273 5.05273 5.09961C4.99414 5.14258 4.96484 5.20508 4.96484 5.28711C4.96484 5.35742 5.00391 5.44727 5.08203 5.55664C5.16406 5.66211 5.26367 5.76758 5.38086 5.87305C5.50195 5.97461 5.62305 6.06055 5.74414 6.13086C5.86523 6.19727 5.9668 6.23047 6.04883 6.23047C6.16211 6.23047 6.2832 6.19727 6.41211 6.13086C6.54492 6.06055 6.67383 5.99219 6.79883 5.92578C6.92383 5.85547 7.03516 5.82031 7.13281 5.82031C7.29688 5.82031 7.48828 5.87891 7.70703 5.99609C7.92578 6.11328 8.13867 6.26172 8.3457 6.44141C8.55273 6.62109 8.72266 6.80664 8.85547 6.99805C8.99219 7.18555 9.06055 7.35156 9.06055 7.49609C9.06055 7.69531 8.98828 7.94922 8.84375 8.25781C8.70312 8.56641 8.51953 8.89062 8.29297 9.23047C8.06641 9.57031 7.82422 9.88867 7.56641 10.1855C7.3125 10.4824 7.06836 10.7266 6.83398 10.918C6.59961 11.1055 6.4082 11.1992 6.25977 11.1992ZM6.02539 12.7461C5.20898 12.7461 4.43945 12.5898 3.7168 12.2773C2.99805 11.9648 2.36328 11.5332 1.8125 10.9824C1.26172 10.4316 0.830078 9.79688 0.517578 9.07812C0.205078 8.35547 0.0488281 7.58594 0.0488281 6.76953C0.0488281 5.95312 0.205078 5.18555 0.517578 4.4668C0.830078 3.74414 1.25977 3.10742 1.80664 2.55664C2.35742 2.00586 2.99219 1.57422 3.71094 1.26172C4.43359 0.949219 5.20312 0.792969 6.01953 0.792969C6.83594 0.792969 7.60547 0.949219 8.32812 1.26172C9.05078 1.57422 9.6875 2.00586 10.2383 2.55664C10.7891 3.10742 11.2207 3.74414 11.5332 4.4668C11.8457 5.18555 12.002 5.95312 12.002 6.76953C12.002 7.58594 11.8457 8.35547 11.5332 9.07812C11.2207 9.79688 10.7891 10.4316 10.2383 10.9824C9.6875 11.5332 9.05078 11.9648 8.32812 12.2773C7.60938 12.5898 6.8418 12.7461 6.02539 12.7461ZM6.02539 11.9492C6.73242 11.9492 7.39844 11.8125 8.02344 11.5391C8.64844 11.2695 9.19922 10.8965 9.67578 10.4199C10.1523 9.94336 10.5254 9.39258 10.7949 8.76758C11.0684 8.14258 11.2051 7.47656 11.2051 6.76953C11.2051 6.0625 11.0684 5.39648 10.7949 4.77148C10.5254 4.14648 10.1504 3.5957 9.66992 3.11914C9.19336 2.64258 8.64258 2.26953 8.01758 2C7.39258 1.72656 6.72656 1.58984 6.01953 1.58984C5.3125 1.58984 4.64648 1.72656 4.02148 2C3.39648 2.26953 2.8457 2.64258 2.36914 3.11914C1.89648 3.5957 1.52344 4.14648 1.25 4.77148C0.980469 5.39648 0.845703 6.0625 0.845703 6.76953C0.845703 7.47656 0.980469 8.14258 1.25 8.76758C1.52344 9.39258 1.89844 9.94336 2.375 10.4199C2.85156 10.8965 3.40234 11.2695 4.02734 11.5391C4.65234 11.8125 5.31836 11.9492 6.02539 11.9492Z", fill: "black" }) }));
};
const index$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BlueCheck,
  Building,
  Check,
  Chevron,
  Clock,
  Close,
  Copy,
  Error: ErrorIcon,
  Eye,
  Graphic,
  Help,
  Info,
  Logo,
  Logout,
  ModalClose,
  More,
  NotEye: NoEye,
  Plus,
  Point,
  Profile,
  Redo,
  RightArrow,
  RightChevron,
  Shield,
  SumSubFail,
  SumSubPending,
  SumSubVerified,
  Tool,
  Twitter,
  World
}, Symbol.toStringTag, { value: "Module" }));
const itemSchema$2 = z.object({
  ctaText: z.string(),
  link: z.string(),
  description: z.string(),
  title: z.string()
});
const alertSchema = itemSchema$2;
const Alert = (props) => {
  const {
    title,
    description,
    ctaText,
    link
  } = props;
  useComponentValidation({
    props,
    schema: alertSchema
  });
  return /* @__PURE__ */ jsxs("div", { onClick: () => {
    window.location.href = link;
  }, role: "button", style: {
    background: "linear-gradient(180deg, #27272A 0%, #000 100%)"
  }, className: "rounded-3xl flex p-8 gap-6", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-1 flex-col gap-1", children: [
      /* @__PURE__ */ jsx("p", { className: "text-white font-bold text-xl", children: title }),
      /* @__PURE__ */ jsx("p", { className: "text-white/50", children: description })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex gap-6 items-center", children: ctaText && /* @__PURE__ */ jsx(Button, { textSize: "sm", className: "bg-smokeWhite", children: ctaText }) })
  ] });
};
const Spinner$1 = () => {
  return /* @__PURE__ */ jsx("div", { className: "w-full justify-center flex", children: /* @__PURE__ */ jsx("div", { className: " text-disabledGray inline-block h-5 w-5 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]", role: "status", children: /* @__PURE__ */ jsx("span", { className: "!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]", children: "Loading..." }) }) });
};
const globals = "";
const Button = forwardRef((_G, ref) => {
  var _H = _G, {
    textWeight = "bold",
    children,
    textSize = "md",
    isFullWidth = true,
    isLoading,
    className = "",
    hasBorder,
    leftIcon,
    rightIcon,
    isDark
  } = _H, rest = __objRest(_H, [
    "textWeight",
    "children",
    "textSize",
    "isFullWidth",
    "isLoading",
    "className",
    "hasBorder",
    "leftIcon",
    "rightIcon",
    "isDark"
  ]);
  const fontSize = textSize === "md" ? "text-base" : "text-sm";
  const fontWeight = textWeight === "bold" ? "font-bold" : textWeight ? "font-medium" : "font-normal";
  return /* @__PURE__ */ jsx("button", __spreadProps(__spreadValues({ ref, className: `border shadow-none transition-all focus:text-black hover:text-black outline-none justify-center flex items-center gap-1.5 transition ${!rest.disabled && !isDark ? "hover:bg-gray-100" : ""} rounded-3xl ${fontSize} ${fontWeight} py-3 px-4 ${isFullWidth ? "w-full" : ""} ${hasBorder ? "border-neutral-300 border" : "border-transparent"} 
        ${rest.disabled ? "bg-neutral-950 opacity-25 focus:text-white hover:text-white text-white cursor-not-allowed" : ""} 
        ${isDark ? "focus:text-white bg-black text-white hover:bg-black hover:text-white" : ""}
        ${isLoading ? "cursor-not-allowed" : ""} ${className}` }, rest), { children: isLoading ? /* @__PURE__ */ jsx(Spinner$1, {}) : /* @__PURE__ */ jsxs(Fragment, { children: [
    leftIcon,
    children,
    rightIcon
  ] }) }));
});
Button.displayName = "Button";
const ViewAllButton$1 = ({
  children,
  href,
  onClick
}) => {
  const className = "transition gap-1.5 outline-none py-1.5 px-3 items-center text-black border-gray-200 border flex justify-center bg-white rounded-3xl hover:bg-gray-100";
  return href ? /* @__PURE__ */ jsx("a", { href, className: `${className} no-underline`, children }) : /* @__PURE__ */ jsx("button", { onClick, className: `${className} button-border`, children });
};
const CardContainer$1 = forwardRef((_I, ref) => {
  var _J = _I, {
    className,
    children,
    onClick,
    hasExtraPadding,
    hasBorder = true,
    rightCol,
    hoverStyles = "hover:scale-[1.02] hover:bg-smokeWhite"
  } = _J, rest = __objRest(_J, [
    "className",
    "children",
    "onClick",
    "hasExtraPadding",
    "hasBorder",
    "rightCol",
    "hoverStyles"
  ]);
  const commonProps = __spreadValues(__spreadProps(__spreadValues({
    ref
  }, onClick ? {
    role: "button",
    onClick
  } : {}), {
    className: `relative overflow-hidden rounded-2xl p-4 flex items-start gap-6 w-full CardContainer-container bg-white justify-center ${hasExtraPadding ? "p-8" : ""} ${hasBorder ? " border-2 border-gray-200" : ""} ${hoverStyles} transition-all ${className}`
  }), rest);
  return /* @__PURE__ */ jsxs("div", __spreadProps(__spreadValues({}, commonProps), { children: [
    /* @__PURE__ */ jsx("div", { className: "flex flex-col items-start gap-4 w-full justify-between flex-1 self-stretch", children }),
    rightCol && /* @__PURE__ */ jsx("div", { className: `block self-center`, children: rightCol })
  ] }));
});
CardContainer$1.displayName = "CardContainer";
const CardHeader$1 = ({
  title,
  text,
  isFeatured
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1 w-full flex-1", children: [
    /* @__PURE__ */ jsx("h3", { className: `${isFeatured ? "text-3xl" : "text-xl"} font-medium text-black`, children: title }),
    text && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("p", { className: `inline ${isFeatured ? "text-xl" : "text-base"} text-disabledGray show-html`, dangerouslySetInnerHTML: {
      __html: text
    } }) })
  ] });
};
const Checkbox = forwardRef((_K, ref) => {
  var _L = _K, {
    label,
    id: id2
  } = _L, rest = __objRest(_L, [
    "label",
    "id"
  ]);
  return /* @__PURE__ */ jsxs("div", { className: "flex gap-2 items-center p-2 hover:bg-offWhite rounded-xl", children: [
    /* @__PURE__ */ jsx("input", __spreadValues({ ref, id: id2, type: "checkbox", className: "peer appearance-none cursor-pointer w-4 h-4 rounded border-neutral-300 border focus:border-black hover:border-neutral-400 shrink-0 checked:bg-black checked:border-0" }, rest)),
    /* @__PURE__ */ jsx("label", { className: "cursor-pointer w-full", htmlFor: id2, children: label }),
    /* @__PURE__ */ jsx(Check, { width: "12", height: "12", viewBox: "0 0 20 20", fill: "white", className: "pointer-events-none absolute w-4 h-3 mt-1 ml-px hidden peer-checked:block" })
  ] });
});
const CopyButton = ({
  codeToCopy,
  className,
  callback,
  children
}) => {
  const [copyStatus, setCopyStatus] = useState(false);
  useEffect(() => {
    callback == null ? void 0 : callback(copyStatus);
  }, [copyStatus]);
  const handleCopyClick = () => __async(void 0, null, function* () {
    try {
      setCopyStatus(true);
      yield window.navigator.clipboard.writeText(codeToCopy);
      callback == null ? void 0 : callback(true);
      setTimeout(() => setCopyStatus(false), 2e3);
    } catch (err) {
      console.error("Unable to copy to clipboard.", err);
    }
  });
  return /* @__PURE__ */ jsx(Button, { onClick: handleCopyClick, className: `${copyStatus ? "cursor-not-allowed hover:bg-green-50 hover:text-green-700 text-green-700 bg-green-50" : `bg-smokeWhite`} ${className || ""}`, leftIcon: copyStatus ? /* @__PURE__ */ jsx(Check, {}) : /* @__PURE__ */ jsx(Copy, {}), children });
};
const Fieldset = (_M) => {
  var _N = _M, {
    children
  } = _N, rest = __objRest(_N, [
    "children"
  ]);
  return /* @__PURE__ */ jsx("fieldset", __spreadProps(__spreadValues({ className: "flex flex-col gap-2" }, rest), { children }));
};
const FormError = ({
  children
}) => {
  return /* @__PURE__ */ jsx("p", { className: "text-red-600 text-sm", children });
};
const FormFieldDescription = ({
  children,
  isPassed = false,
  isError = false
}) => {
  return /* @__PURE__ */ jsxs("p", { className: `${isError ? "text-red-600" : ""} ${isPassed && !isError ? "text-green-700" : "text-quickSilver"} text-sm flex gap-1 items-center`, children: [
    isPassed && /* @__PURE__ */ jsx(Check, {}),
    isError && /* @__PURE__ */ jsx(ErrorIcon, {}),
    children
  ] });
};
const FormLabel = (_O) => {
  var _P = _O, {
    children,
    isError
  } = _P, rest = __objRest(_P, [
    "children",
    "isError"
  ]);
  return /* @__PURE__ */ jsx("label", __spreadProps(__spreadValues({ className: `font-medium text-base ${isError ? "text-red-600" : ""}` }, rest), { children }));
};
const Container = ({
  children,
  gap: gap2 = "md",
  className
}) => {
  const gapSpacing = {
    xxs: "gap-0.5",
    xs: "gap-1",
    md: "gap-1 lg:gap-4"
  };
  return /* @__PURE__ */ jsx("div", { className: `flex ${gapSpacing[gap2]} flex flex-col ${className}`, children });
};
const Title = ({
  children,
  className,
  fontSize = "lg",
  fontWeight = "font-medium",
  as
}) => {
  const fontSizeClass = {
    xxs: "text-base",
    xs: "text-xl",
    md: "text-2xl",
    lg: "text-[32px]"
  };
  const Tag = as || "h1";
  return /* @__PURE__ */ jsx(Tag, { className: `${fontWeight} ${fontSizeClass[fontSize]} ${className}`, children });
};
const Subitle = ({
  children,
  className,
  fontSize = "lg",
  fontWeight = "font-normal",
  as
}) => {
  const fontSizeClass = {
    xxs: "text-sm",
    xs: "text-base",
    md: "text-lg",
    lg: "text-xl"
  };
  const Tag = as || "p";
  return /* @__PURE__ */ jsx(Tag, { className: `${fontWeight} text-black/[.5] ${fontSizeClass[fontSize]} ${className}`, children });
};
const Input = forwardRef((_Q, ref) => {
  var _R = _Q, {
    className = "",
    type = "text",
    isError
  } = _R, rest = __objRest(_R, [
    "className",
    "type",
    "isError"
  ]);
  return /* @__PURE__ */ jsx("input", __spreadValues({ role: "textbox", ref, type, className: `placeholder:text-black/[.38] shadow-none outline-none px-4 py-3 rounded-xl ${rest.disabled ? "text-black/25 bg-smokeWhite cursor-no-drop" : "border-neutral-300 border focus:border-black hover:border-neutral-400"} ${isError ? "border-red-600" : ""}  ${className}` }, rest));
});
Input.displayName = "Input";
const PasswordInput = forwardRef((_S, ref) => {
  var _T = _S, {
    isError
  } = _T, rest = __objRest(_T, [
    "isError"
  ]);
  const [showPassword, setShowPassword] = useState(false);
  const handleOnClick = (e2) => {
    e2.preventDefault();
    setShowPassword(!showPassword);
  };
  return /* @__PURE__ */ jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ jsx(Input, __spreadValues({ type: showPassword ? "text" : "password", isError, ref, className: "w-full" }, rest)),
    /* @__PURE__ */ jsx("button", { type: "button", onClick: handleOnClick, className: "border-0 absolute top-1/2 transform -translate-y-1/2 right-4 cursor-pointer", children: !showPassword ? /* @__PURE__ */ jsx(Eye, {}) : /* @__PURE__ */ jsx(NoEye, {}) })
  ] });
});
PasswordInput.displayName = "PasswordInput";
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e2 = 1; e2 < arguments.length; e2++) {
      var t2 = arguments[e2];
      for (var r2 in t2)
        ({}).hasOwnProperty.call(t2, r2) && (n2[r2] = t2[r2]);
    }
    return n2;
  }, _extends$2.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r2, e2) {
  if (null == r2)
    return {};
  var t2 = {};
  for (var n2 in r2)
    if ({}.hasOwnProperty.call(r2, n2)) {
      if (e2.indexOf(n2) >= 0)
        continue;
      t2[n2] = r2[n2];
    }
  return t2;
}
var propTypes$2 = { exports: {} };
var reactIs$1 = { exports: {} };
var reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1)
    return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b = "function" === typeof Symbol && Symbol.for, c2 = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e2 = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n2 = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r2 = b ? Symbol.for("react.memo") : 60115, t2 = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x2 = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z2(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var u = a2.$$typeof;
      switch (u) {
        case c2:
          switch (a2 = a2.type, a2) {
            case l:
            case m:
            case e2:
            case g:
            case f:
            case p:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k:
                case n2:
                case t2:
                case r2:
                case h:
                  return a2;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a2) {
    return z2(a2) === m;
  }
  reactIs_production_min$1.AsyncMode = l;
  reactIs_production_min$1.ConcurrentMode = m;
  reactIs_production_min$1.ContextConsumer = k;
  reactIs_production_min$1.ContextProvider = h;
  reactIs_production_min$1.Element = c2;
  reactIs_production_min$1.ForwardRef = n2;
  reactIs_production_min$1.Fragment = e2;
  reactIs_production_min$1.Lazy = t2;
  reactIs_production_min$1.Memo = r2;
  reactIs_production_min$1.Portal = d;
  reactIs_production_min$1.Profiler = g;
  reactIs_production_min$1.StrictMode = f;
  reactIs_production_min$1.Suspense = p;
  reactIs_production_min$1.isAsyncMode = function(a2) {
    return A(a2) || z2(a2) === l;
  };
  reactIs_production_min$1.isConcurrentMode = A;
  reactIs_production_min$1.isContextConsumer = function(a2) {
    return z2(a2) === k;
  };
  reactIs_production_min$1.isContextProvider = function(a2) {
    return z2(a2) === h;
  };
  reactIs_production_min$1.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === c2;
  };
  reactIs_production_min$1.isForwardRef = function(a2) {
    return z2(a2) === n2;
  };
  reactIs_production_min$1.isFragment = function(a2) {
    return z2(a2) === e2;
  };
  reactIs_production_min$1.isLazy = function(a2) {
    return z2(a2) === t2;
  };
  reactIs_production_min$1.isMemo = function(a2) {
    return z2(a2) === r2;
  };
  reactIs_production_min$1.isPortal = function(a2) {
    return z2(a2) === d;
  };
  reactIs_production_min$1.isProfiler = function(a2) {
    return z2(a2) === g;
  };
  reactIs_production_min$1.isStrictMode = function(a2) {
    return z2(a2) === f;
  };
  reactIs_production_min$1.isSuspense = function(a2) {
    return z2(a2) === p;
  };
  reactIs_production_min$1.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === e2 || a2 === m || a2 === g || a2 === f || a2 === p || a2 === q || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t2 || a2.$$typeof === r2 || a2.$$typeof === h || a2.$$typeof === k || a2.$$typeof === n2 || a2.$$typeof === w || a2.$$typeof === x2 || a2.$$typeof === y || a2.$$typeof === v);
  };
  reactIs_production_min$1.typeOf = z2;
  return reactIs_production_min$1;
}
var reactIs_development$1 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1)
    return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal3 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$1.AsyncMode = AsyncMode;
      reactIs_development$1.ConcurrentMode = ConcurrentMode;
      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element2;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment2;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal3;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement2;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf;
    })();
  }
  return reactIs_development$1;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs)
    return reactIs$1.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs$1.exports = requireReactIs_production_min$1();
  } else {
    reactIs$1.exports = requireReactIs_development$1();
  }
  return reactIs$1.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
        return test2[n2];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from2;
    var to = toObject(target);
    var symbols;
    for (var s2 = 1; s2 < arguments.length; s2++) {
      from2 = Object(arguments[s2]);
      for (var key in from2) {
        if (hasOwnProperty2.call(from2, key)) {
          to[key] = from2[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from2);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from2, symbols[i])) {
            to[symbols[i]] = from2[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas)
    return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x2) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values2, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign2 = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x2) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x2, y) {
      if (x2 === y) {
        return x2 !== 0 || 1 / x2 === 1 / y;
      } else {
        return x2 !== x2 && y !== y;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey2 = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey2] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey2] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode2(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode2(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode2);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode2(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode2(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol2(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol2(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes$2.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes$2.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes$2.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === "production") {
    return () => null;
  }
  return function validate(...args) {
    return propType1(...args) || propType2(...args);
  };
}
function isPlainObject(item) {
  if (typeof item !== "object" || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (!isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach((key) => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? _extends$2({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach((key) => {
      if (key === "__proto__") {
        return;
      }
      if (isPlainObject(source[key]) && key in target && isPlainObject(target[key])) {
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}
function isClassComponent(elementType) {
  const {
    prototype = {}
  } = elementType;
  return Boolean(prototype.isReactComponent);
}
function acceptingRef(props, propName, componentName, location, propFullName) {
  const element = props[propName];
  const safePropName = propFullName || propName;
  if (element == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window === "undefined") {
    return null;
  }
  let warningHint;
  const elementType = element.type;
  if (typeof elementType === "function" && !isClassComponent(elementType)) {
    warningHint = "Did you accidentally use a plain function component for an element instead?";
  }
  if (warningHint !== void 0) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. Expected an element that can hold a ref. ${warningHint} For more information see https://mui.com/r/caveat-with-refs-guide`);
  }
  return null;
}
const elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
const elementAcceptingRef$1 = elementAcceptingRef;
const specialProperty = "exact-prop: ​";
function exactProp(propTypes2) {
  if (process.env.NODE_ENV === "production") {
    return propTypes2;
  }
  return _extends$2({}, propTypes2, {
    [specialProperty]: (props) => {
      const unsupportedProps = Object.keys(props).filter((prop) => !propTypes2.hasOwnProperty(prop));
      if (unsupportedProps.length > 0) {
        return new Error(`The following props are not supported: ${unsupportedProps.map((prop) => `\`${prop}\``).join(", ")}. Please remove them.`);
      }
      return null;
    }
  });
}
function formatMuiErrorMessage$1(code) {
  let url = "https://mui.com/production-error/?code=" + code;
  for (let i = 1; i < arguments.length; i += 1) {
    url += "&args[]=" + encodeURIComponent(arguments[i]);
  }
  return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
}
const formatMuiErrorMessage = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: formatMuiErrorMessage$1
}, Symbol.toStringTag, { value: "Module" }));
var reactIs = { exports: {} };
var reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = Symbol.for("react.element"), c2 = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e2 = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n2 = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t2 = Symbol.for("react.offscreen"), u;
  u = Symbol.for("react.module.reference");
  function v(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var r2 = a2.$$typeof;
      switch (r2) {
        case b:
          switch (a2 = a2.type, a2) {
            case d:
            case f:
            case e2:
            case m:
            case n2:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k:
                case h:
                case l:
                case q:
                case p:
                case g:
                  return a2;
                default:
                  return r2;
              }
          }
        case c2:
          return r2;
      }
    }
  }
  reactIs_production_min.ContextConsumer = h;
  reactIs_production_min.ContextProvider = g;
  reactIs_production_min.Element = b;
  reactIs_production_min.ForwardRef = l;
  reactIs_production_min.Fragment = d;
  reactIs_production_min.Lazy = q;
  reactIs_production_min.Memo = p;
  reactIs_production_min.Portal = c2;
  reactIs_production_min.Profiler = f;
  reactIs_production_min.StrictMode = e2;
  reactIs_production_min.Suspense = m;
  reactIs_production_min.SuspenseList = n2;
  reactIs_production_min.isAsyncMode = function() {
    return false;
  };
  reactIs_production_min.isConcurrentMode = function() {
    return false;
  };
  reactIs_production_min.isContextConsumer = function(a2) {
    return v(a2) === h;
  };
  reactIs_production_min.isContextProvider = function(a2) {
    return v(a2) === g;
  };
  reactIs_production_min.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === b;
  };
  reactIs_production_min.isForwardRef = function(a2) {
    return v(a2) === l;
  };
  reactIs_production_min.isFragment = function(a2) {
    return v(a2) === d;
  };
  reactIs_production_min.isLazy = function(a2) {
    return v(a2) === q;
  };
  reactIs_production_min.isMemo = function(a2) {
    return v(a2) === p;
  };
  reactIs_production_min.isPortal = function(a2) {
    return v(a2) === c2;
  };
  reactIs_production_min.isProfiler = function(a2) {
    return v(a2) === f;
  };
  reactIs_production_min.isStrictMode = function(a2) {
    return v(a2) === e2;
  };
  reactIs_production_min.isSuspense = function(a2) {
    return v(a2) === m;
  };
  reactIs_production_min.isSuspenseList = function(a2) {
    return v(a2) === n2;
  };
  reactIs_production_min.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === d || a2 === f || a2 === e2 || a2 === m || a2 === n2 || a2 === t2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === q || a2.$$typeof === p || a2.$$typeof === g || a2.$$typeof === h || a2.$$typeof === l || a2.$$typeof === u || void 0 !== a2.getModuleId) ? true : false;
  };
  reactIs_production_min.typeOf = v;
  return reactIs_production_min;
}
var reactIs_development = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development)
    return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_SERVER_CONTEXT_TYPE:
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal3 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isConcurrentMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true;
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
      }
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal3;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.SuspenseList = SuspenseList;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement2;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isSuspenseList = isSuspenseList;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
if (process.env.NODE_ENV === "production") {
  reactIs.exports = requireReactIs_production_min();
} else {
  reactIs.exports = requireReactIs_development();
}
var reactIsExports = reactIs.exports;
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn2) {
  const match2 = `${fn2}`.match(fnNameMatchRegex);
  const name = match2 && match2[1];
  return name || "";
}
function getFunctionComponentName(Component2, fallback = "") {
  return Component2.displayName || Component2.name || getFunctionName(Component2) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function getDisplayName(Component2) {
  if (Component2 == null) {
    return void 0;
  }
  if (typeof Component2 === "string") {
    return Component2;
  }
  if (typeof Component2 === "function") {
    return getFunctionComponentName(Component2, "Component");
  }
  if (typeof Component2 === "object") {
    switch (Component2.$$typeof) {
      case reactIsExports.ForwardRef:
        return getWrappedName(Component2, Component2.render, "ForwardRef");
      case reactIsExports.Memo:
        return getWrappedName(Component2, Component2.type, "memo");
      default:
        return void 0;
    }
  }
  return void 0;
}
function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === "production") {
    return null;
  }
  const propValue = props[propName];
  const safePropName = propFullName || propName;
  if (propValue == null) {
    return null;
  }
  if (propValue && propValue.nodeType !== 1) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. Expected an HTMLElement.`);
  }
  return null;
}
const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
const refType$1 = refType;
function capitalize(string) {
  if (typeof string !== "string") {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`capitalize(string)\` expects a string argument.` : formatMuiErrorMessage$1(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function createChainedFunction(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }
    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {
  });
}
function ownerDocument(node2) {
  return node2 && node2.ownerDocument || document;
}
function ownerWindow(node2) {
  const doc = ownerDocument(node2);
  return doc.defaultView || window;
}
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
const useEnhancedEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
const useEnhancedEffect$1 = useEnhancedEffect;
let globalId = 0;
function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = React.useState(idOverride);
  const id2 = idOverride || defaultId;
  React.useEffect(() => {
    if (defaultId == null) {
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id2;
}
const maybeReactUseId = React["useId".toString()];
function useId(idOverride) {
  if (maybeReactUseId !== void 0) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  return useGlobalId(idOverride);
}
function useEventCallback(fn2) {
  const ref = React.useRef(fn2);
  useEnhancedEffect$1(() => {
    ref.current = fn2;
  });
  return React.useRef((...args) => (
    // @ts-expect-error hide `this`
    (0, ref.current)(...args)
  )).current;
}
function useForkRef(...refs) {
  return React.useMemo(() => {
    if (refs.every((ref) => ref == null)) {
      return null;
    }
    return (instance) => {
      refs.forEach((ref) => {
        setRef(ref, instance);
      });
    };
  }, refs);
}
const UNINITIALIZED = {};
function useLazyRef(init2, initArg) {
  const ref = React.useRef(UNINITIALIZED);
  if (ref.current === UNINITIALIZED) {
    ref.current = init2(initArg);
  }
  return ref;
}
const EMPTY = [];
function useOnMount(fn2) {
  React.useEffect(fn2, EMPTY);
}
class Timeout {
  constructor() {
    this.currentId = null;
    this.clear = () => {
      if (this.currentId !== null) {
        clearTimeout(this.currentId);
        this.currentId = null;
      }
    };
    this.disposeEffect = () => {
      return this.clear;
    };
  }
  static create() {
    return new Timeout();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(delay2, fn2) {
    this.clear();
    this.currentId = setTimeout(() => {
      this.currentId = null;
      fn2();
    }, delay2);
  }
}
function useTimeout() {
  const timeout2 = useLazyRef(Timeout.create).current;
  useOnMount(timeout2.disposeEffect);
  return timeout2;
}
let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
const hadFocusVisibleRecentlyTimeout = new Timeout();
const inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  "datetime-local": true
};
function focusTriggersKeyboardModality(node2) {
  const {
    type,
    tagName
  } = node2;
  if (tagName === "INPUT" && inputTypesWhitelist[type] && !node2.readOnly) {
    return true;
  }
  if (tagName === "TEXTAREA" && !node2.readOnly) {
    return true;
  }
  if (node2.isContentEditable) {
    return true;
  }
  return false;
}
function handleKeyDown$1(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}
function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === "hidden") {
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener("keydown", handleKeyDown$1, true);
  doc.addEventListener("mousedown", handlePointerDown, true);
  doc.addEventListener("pointerdown", handlePointerDown, true);
  doc.addEventListener("touchstart", handlePointerDown, true);
  doc.addEventListener("visibilitychange", handleVisibilityChange, true);
}
function isFocusVisible(event) {
  const {
    target
  } = event;
  try {
    return target.matches(":focus-visible");
  } catch (error) {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
  const ref = React.useCallback((node2) => {
    if (node2 != null) {
      prepare(node2.ownerDocument);
    }
  }, []);
  const isFocusVisibleRef = React.useRef(false);
  function handleBlurVisible() {
    if (isFocusVisibleRef.current) {
      hadFocusVisibleRecently = true;
      hadFocusVisibleRecentlyTimeout.start(100, () => {
        hadFocusVisibleRecently = false;
      });
      isFocusVisibleRef.current = false;
      return true;
    }
    return false;
  }
  function handleFocusVisible(event) {
    if (isFocusVisible(event)) {
      isFocusVisibleRef.current = true;
      return true;
    }
    return false;
  }
  return {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref
  };
}
function getScrollbarSize(doc) {
  const documentWidth = doc.documentElement.clientWidth;
  return Math.abs(window.innerWidth - documentWidth);
}
function composeClasses(slots, getUtilityClass, classes = void 0) {
  const output = {};
  Object.keys(slots).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot) => {
      output[slot] = slots[slot].reduce((acc, key) => {
        if (key) {
          const utilityClass = getUtilityClass(key);
          if (utilityClass !== "") {
            acc.push(utilityClass);
          }
          if (classes && classes[key]) {
            acc.push(classes[key]);
          }
        }
        return acc;
      }, []).join(" ");
    }
  );
  return output;
}
const defaultGenerator = (componentName) => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
const ClassNameGenerator$1 = ClassNameGenerator;
const globalStateClasses = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass$1(componentName, slot, globalStatePrefix = "Mui") {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator$1.generate(componentName)}-${slot}`;
}
function clamp$4(val, min2 = Number.MIN_SAFE_INTEGER, max2 = Number.MAX_SAFE_INTEGER) {
  return Math.max(min2, Math.min(val, max2));
}
const clamp$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: clamp$4
}, Symbol.toStringTag, { value: "Module" }));
function isHostComponent(element) {
  return typeof element === "string";
}
function appendOwnerState(elementType, otherProps, ownerState) {
  if (elementType === void 0 || isHostComponent(elementType)) {
    return otherProps;
  }
  return _extends$2({}, otherProps, {
    ownerState: _extends$2({}, otherProps.ownerState, ownerState)
  });
}
function areArraysEqual(array1, array2, itemComparer = (a2, b) => a2 === b) {
  return array1.length === array2.length && array1.every((value, index2) => itemComparer(value, array2[index2]));
}
const defaultContextValue = {
  disableDefaultClasses: false
};
const ClassNameConfiguratorContext = /* @__PURE__ */ React.createContext(defaultContextValue);
if (process.env.NODE_ENV !== "production") {
  ClassNameConfiguratorContext.displayName = "ClassNameConfiguratorContext";
}
function useClassNamesOverride(generateUtilityClass2) {
  const {
    disableDefaultClasses
  } = React.useContext(ClassNameConfiguratorContext);
  return (slot) => {
    if (disableDefaultClasses) {
      return "";
    }
    return generateUtilityClass2(slot);
  };
}
function extractEventHandlers(object, excludeKeys = []) {
  if (object === void 0) {
    return {};
  }
  const result = {};
  Object.keys(object).filter((prop) => prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop) => {
    result[prop] = object[prop];
  });
  return result;
}
function resolveComponentProps(componentProps, ownerState, slotState) {
  if (typeof componentProps === "function") {
    return componentProps(ownerState, slotState);
  }
  return componentProps;
}
function useRootElementName(parameters) {
  const {
    rootElementName: rootElementNameProp = "",
    componentName
  } = parameters;
  const [rootElementName, setRootElementName] = React.useState(rootElementNameProp.toUpperCase());
  if (process.env.NODE_ENV !== "production") {
    React.useEffect(() => {
      if (rootElementNameProp && rootElementName !== rootElementNameProp.toUpperCase()) {
        console.error(`useRootElementName: the \`rootElementName\` prop of ${componentName ? `the ${componentName} component` : "a component"} expected the '${rootElementNameProp}' element, but a '${rootElementName.toLowerCase()}' was rendered instead`, "This may cause hydration issues in an SSR context, for example in a Next.js app");
      }
    }, [rootElementNameProp, rootElementName, componentName]);
  }
  const updateRootElementName = React.useCallback((instance) => {
    var _instance$tagName;
    setRootElementName((_instance$tagName = instance == null ? void 0 : instance.tagName) != null ? _instance$tagName : "");
  }, []);
  return [rootElementName, updateRootElementName];
}
function r(e2) {
  var t2, f, n2 = "";
  if ("string" == typeof e2 || "number" == typeof e2)
    n2 += e2;
  else if ("object" == typeof e2)
    if (Array.isArray(e2)) {
      var o2 = e2.length;
      for (t2 = 0; t2 < o2; t2++)
        e2[t2] && (f = r(e2[t2])) && (n2 && (n2 += " "), n2 += f);
    } else
      for (f in e2)
        e2[f] && (n2 && (n2 += " "), n2 += f);
  return n2;
}
function clsx() {
  for (var e2, t2, f = 0, n2 = "", o2 = arguments.length; f < o2; f++)
    (e2 = arguments[f]) && (t2 = r(e2)) && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
function omitEventHandlers(object) {
  if (object === void 0) {
    return {};
  }
  const result = {};
  Object.keys(object).filter((prop) => !(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop) => {
    result[prop] = object[prop];
  });
  return result;
}
function mergeSlotProps(parameters) {
  const {
    getSlotProps,
    additionalProps,
    externalSlotProps,
    externalForwardedProps,
    className
  } = parameters;
  if (!getSlotProps) {
    const joinedClasses2 = clsx(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle2 = _extends$2({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props2 = _extends$2({}, additionalProps, externalForwardedProps, externalSlotProps);
    if (joinedClasses2.length > 0) {
      props2.className = joinedClasses2;
    }
    if (Object.keys(mergedStyle2).length > 0) {
      props2.style = mergedStyle2;
    }
    return {
      props: props2,
      internalRef: void 0
    };
  }
  const eventHandlers = extractEventHandlers(_extends$2({}, externalForwardedProps, externalSlotProps));
  const componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
  const otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
  const internalSlotProps = getSlotProps(eventHandlers);
  const joinedClasses = clsx(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
  const mergedStyle = _extends$2({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
  const props = _extends$2({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
  if (joinedClasses.length > 0) {
    props.className = joinedClasses;
  }
  if (Object.keys(mergedStyle).length > 0) {
    props.style = mergedStyle;
  }
  return {
    props,
    internalRef: internalSlotProps.ref
  };
}
const _excluded$f = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function useSlotProps(parameters) {
  var _parameters$additiona;
  const {
    elementType,
    externalSlotProps,
    ownerState,
    skipResolvingSlotProps = false
  } = parameters, rest = _objectWithoutPropertiesLoose(parameters, _excluded$f);
  const resolvedComponentsProps = skipResolvingSlotProps ? {} : resolveComponentProps(externalSlotProps, ownerState);
  const {
    props: mergedProps,
    internalRef
  } = mergeSlotProps(_extends$2({}, rest, {
    externalSlotProps: resolvedComponentsProps
  }));
  const ref = useForkRef(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
  const props = appendOwnerState(elementType, _extends$2({}, mergedProps, {
    ref
  }), ownerState);
  return props;
}
function getContainer$1(container) {
  return typeof container === "function" ? container() : container;
}
const Portal = /* @__PURE__ */ React.forwardRef(function Portal2(props, forwardedRef) {
  const {
    children,
    container,
    disablePortal = false
  } = props;
  const [mountNode, setMountNode] = React.useState(null);
  const handleRef = useForkRef(/* @__PURE__ */ React.isValidElement(children) ? children.ref : null, forwardedRef);
  useEnhancedEffect$1(() => {
    if (!disablePortal) {
      setMountNode(getContainer$1(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect$1(() => {
    if (mountNode && !disablePortal) {
      setRef(forwardedRef, mountNode);
      return () => {
        setRef(forwardedRef, null);
      };
    }
    return void 0;
  }, [forwardedRef, mountNode, disablePortal]);
  if (disablePortal) {
    if (/* @__PURE__ */ React.isValidElement(children)) {
      const newProps = {
        ref: handleRef
      };
      return /* @__PURE__ */ React.cloneElement(children, newProps);
    }
    return /* @__PURE__ */ jsx(React.Fragment, {
      children
    });
  }
  return /* @__PURE__ */ jsx(React.Fragment, {
    children: mountNode ? /* @__PURE__ */ ReactDOM.createPortal(children, mountNode) : mountNode
  });
});
process.env.NODE_ENV !== "production" ? Portal.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool
} : void 0;
if (process.env.NODE_ENV !== "production") {
  Portal["propTypes"] = exactProp(Portal.propTypes);
}
function isOverflowing(container) {
  const doc = ownerDocument(container);
  if (doc.body === container) {
    return ownerWindow(container).innerWidth > doc.documentElement.clientWidth;
  }
  return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, show) {
  if (show) {
    element.setAttribute("aria-hidden", "true");
  } else {
    element.removeAttribute("aria-hidden");
  }
}
function getPaddingRight(element) {
  return parseInt(ownerWindow(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(element) {
  const forbiddenTagNames = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"];
  const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
  const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
  return isForbiddenTagName || isInputHidden;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
  const blacklist = [mountElement, currentElement, ...elementsToExclude];
  [].forEach.call(container.children, (element) => {
    const isNotExcludedElement = blacklist.indexOf(element) === -1;
    const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
    if (isNotExcludedElement && isNotForbiddenElement) {
      ariaHidden(element, show);
    }
  });
}
function findIndexOf(items, callback) {
  let idx = -1;
  items.some((item, index2) => {
    if (callback(item)) {
      idx = index2;
      return true;
    }
    return false;
  });
  return idx;
}
function handleContainer(containerInfo, props) {
  const restoreStyle = [];
  const container = containerInfo.container;
  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      const scrollbarSize = getScrollbarSize(ownerDocument(container));
      restoreStyle.push({
        value: container.style.paddingRight,
        property: "padding-right",
        el: container
      });
      container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`;
      const fixedElements2 = ownerDocument(container).querySelectorAll(".mui-fixed");
      [].forEach.call(fixedElements2, (element) => {
        restoreStyle.push({
          value: element.style.paddingRight,
          property: "padding-right",
          el: element
        });
        element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
      });
    }
    let scrollContainer;
    if (container.parentNode instanceof DocumentFragment) {
      scrollContainer = ownerDocument(container).body;
    } else {
      const parent = container.parentElement;
      const containerWindow = ownerWindow(container);
      scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
    }
    restoreStyle.push({
      value: scrollContainer.style.overflow,
      property: "overflow",
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowX,
      property: "overflow-x",
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowY,
      property: "overflow-y",
      el: scrollContainer
    });
    scrollContainer.style.overflow = "hidden";
  }
  const restore = () => {
    restoreStyle.forEach(({
      value,
      el,
      property
    }) => {
      if (value) {
        el.style.setProperty(property, value);
      } else {
        el.style.removeProperty(property);
      }
    });
  };
  return restore;
}
function getHiddenSiblings(container) {
  const hiddenSiblings = [];
  [].forEach.call(container.children, (element) => {
    if (element.getAttribute("aria-hidden") === "true") {
      hiddenSiblings.push(element);
    }
  });
  return hiddenSiblings;
}
class ModalManager {
  constructor() {
    this.containers = void 0;
    this.modals = void 0;
    this.modals = [];
    this.containers = [];
  }
  add(modal, container) {
    let modalIndex = this.modals.indexOf(modal);
    if (modalIndex !== -1) {
      return modalIndex;
    }
    modalIndex = this.modals.length;
    this.modals.push(modal);
    if (modal.modalRef) {
      ariaHidden(modal.modalRef, false);
    }
    const hiddenSiblings = getHiddenSiblings(container);
    ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
    const containerIndex = findIndexOf(this.containers, (item) => item.container === container);
    if (containerIndex !== -1) {
      this.containers[containerIndex].modals.push(modal);
      return modalIndex;
    }
    this.containers.push({
      modals: [modal],
      container,
      restore: null,
      hiddenSiblings
    });
    return modalIndex;
  }
  mount(modal, props) {
    const containerIndex = findIndexOf(this.containers, (item) => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    if (!containerInfo.restore) {
      containerInfo.restore = handleContainer(containerInfo, props);
    }
  }
  remove(modal, ariaHiddenState = true) {
    const modalIndex = this.modals.indexOf(modal);
    if (modalIndex === -1) {
      return modalIndex;
    }
    const containerIndex = findIndexOf(this.containers, (item) => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
    this.modals.splice(modalIndex, 1);
    if (containerInfo.modals.length === 0) {
      if (containerInfo.restore) {
        containerInfo.restore();
      }
      if (modal.modalRef) {
        ariaHidden(modal.modalRef, ariaHiddenState);
      }
      ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
      this.containers.splice(containerIndex, 1);
    } else {
      const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
      if (nextTop.modalRef) {
        ariaHidden(nextTop.modalRef, false);
      }
    }
    return modalIndex;
  }
  isTopModal(modal) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
  }
}
function getContainer(container) {
  return typeof container === "function" ? container() : container;
}
function getHasTransition(children) {
  return children ? children.props.hasOwnProperty("in") : false;
}
const defaultManager = new ModalManager();
function useModal(parameters) {
  const {
    container,
    disableEscapeKeyDown = false,
    disableScrollLock = false,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = defaultManager,
    closeAfterTransition = false,
    onTransitionEnter,
    onTransitionExited,
    children,
    onClose,
    open,
    rootRef
  } = parameters;
  const modal = React.useRef({});
  const mountNodeRef = React.useRef(null);
  const modalRef = React.useRef(null);
  const handleRef = useForkRef(modalRef, rootRef);
  const [exited, setExited] = React.useState(!open);
  const hasTransition = getHasTransition(children);
  let ariaHiddenProp = true;
  if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) {
    ariaHiddenProp = false;
  }
  const getDoc = () => ownerDocument(mountNodeRef.current);
  const getModal = () => {
    modal.current.modalRef = modalRef.current;
    modal.current.mount = mountNodeRef.current;
    return modal.current;
  };
  const handleMounted = () => {
    manager.mount(getModal(), {
      disableScrollLock
    });
    if (modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  };
  const handleOpen = useEventCallback(() => {
    const resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer);
    if (modalRef.current) {
      handleMounted();
    }
  });
  const isTopModal = React.useCallback(() => manager.isTopModal(getModal()), [manager]);
  const handlePortalRef = useEventCallback((node2) => {
    mountNodeRef.current = node2;
    if (!node2) {
      return;
    }
    if (open && isTopModal()) {
      handleMounted();
    } else if (modalRef.current) {
      ariaHidden(modalRef.current, ariaHiddenProp);
    }
  });
  const handleClose = React.useCallback(() => {
    manager.remove(getModal(), ariaHiddenProp);
  }, [ariaHiddenProp, manager]);
  React.useEffect(() => {
    return () => {
      handleClose();
    };
  }, [handleClose]);
  React.useEffect(() => {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
  const createHandleKeyDown = (otherHandlers) => (event) => {
    var _otherHandlers$onKeyD;
    (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
    if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
    !isTopModal()) {
      return;
    }
    if (!disableEscapeKeyDown) {
      event.stopPropagation();
      if (onClose) {
        onClose(event, "escapeKeyDown");
      }
    }
  };
  const createHandleBackdropClick = (otherHandlers) => (event) => {
    var _otherHandlers$onClic;
    (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
    if (event.target !== event.currentTarget) {
      return;
    }
    if (onClose) {
      onClose(event, "backdropClick");
    }
  };
  const getRootProps = (otherHandlers = {}) => {
    const propsEventHandlers = extractEventHandlers(parameters);
    delete propsEventHandlers.onTransitionEnter;
    delete propsEventHandlers.onTransitionExited;
    const externalEventHandlers = _extends$2({}, propsEventHandlers, otherHandlers);
    return _extends$2({
      role: "presentation"
    }, externalEventHandlers, {
      onKeyDown: createHandleKeyDown(externalEventHandlers),
      ref: handleRef
    });
  };
  const getBackdropProps = (otherHandlers = {}) => {
    const externalEventHandlers = otherHandlers;
    return _extends$2({
      "aria-hidden": true
    }, externalEventHandlers, {
      onClick: createHandleBackdropClick(externalEventHandlers),
      open
    });
  };
  const getTransitionProps2 = () => {
    const handleEnter = () => {
      setExited(false);
      if (onTransitionEnter) {
        onTransitionEnter();
      }
    };
    const handleExited = () => {
      setExited(true);
      if (onTransitionExited) {
        onTransitionExited();
      }
      if (closeAfterTransition) {
        handleClose();
      }
    };
    return {
      onEnter: createChainedFunction(handleEnter, children == null ? void 0 : children.props.onEnter),
      onExited: createChainedFunction(handleExited, children == null ? void 0 : children.props.onExited)
    };
  };
  return {
    getRootProps,
    getBackdropProps,
    getTransitionProps: getTransitionProps2,
    rootRef: handleRef,
    portalRef: handlePortalRef,
    isTopModal,
    exited,
    hasTransition
  };
}
const candidatesSelector = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function getTabIndex(node2) {
  const tabindexAttr = parseInt(node2.getAttribute("tabindex") || "", 10);
  if (!Number.isNaN(tabindexAttr)) {
    return tabindexAttr;
  }
  if (node2.contentEditable === "true" || (node2.nodeName === "AUDIO" || node2.nodeName === "VIDEO" || node2.nodeName === "DETAILS") && node2.getAttribute("tabindex") === null) {
    return 0;
  }
  return node2.tabIndex;
}
function isNonTabbableRadio(node2) {
  if (node2.tagName !== "INPUT" || node2.type !== "radio") {
    return false;
  }
  if (!node2.name) {
    return false;
  }
  const getRadio = (selector) => node2.ownerDocument.querySelector(`input[type="radio"]${selector}`);
  let roving = getRadio(`[name="${node2.name}"]:checked`);
  if (!roving) {
    roving = getRadio(`[name="${node2.name}"]`);
  }
  return roving !== node2;
}
function isNodeMatchingSelectorFocusable(node2) {
  if (node2.disabled || node2.tagName === "INPUT" && node2.type === "hidden" || isNonTabbableRadio(node2)) {
    return false;
  }
  return true;
}
function defaultGetTabbable(root2) {
  const regularTabNodes = [];
  const orderedTabNodes = [];
  Array.from(root2.querySelectorAll(candidatesSelector)).forEach((node2, i) => {
    const nodeTabIndex = getTabIndex(node2);
    if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node2)) {
      return;
    }
    if (nodeTabIndex === 0) {
      regularTabNodes.push(node2);
    } else {
      orderedTabNodes.push({
        documentOrder: i,
        tabIndex: nodeTabIndex,
        node: node2
      });
    }
  });
  return orderedTabNodes.sort((a2, b) => a2.tabIndex === b.tabIndex ? a2.documentOrder - b.documentOrder : a2.tabIndex - b.tabIndex).map((a2) => a2.node).concat(regularTabNodes);
}
function defaultIsEnabled() {
  return true;
}
function FocusTrap(props) {
  const {
    children,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableRestoreFocus = false,
    getTabbable = defaultGetTabbable,
    isEnabled = defaultIsEnabled,
    open
  } = props;
  const ignoreNextEnforceFocus = React.useRef(false);
  const sentinelStart = React.useRef(null);
  const sentinelEnd = React.useRef(null);
  const nodeToRestore = React.useRef(null);
  const reactFocusEventTarget = React.useRef(null);
  const activated = React.useRef(false);
  const rootRef = React.useRef(null);
  const handleRef = useForkRef(children.ref, rootRef);
  const lastKeydown = React.useRef(null);
  React.useEffect(() => {
    if (!open || !rootRef.current) {
      return;
    }
    activated.current = !disableAutoFocus;
  }, [disableAutoFocus, open]);
  React.useEffect(() => {
    if (!open || !rootRef.current) {
      return;
    }
    const doc = ownerDocument(rootRef.current);
    if (!rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute("tabIndex")) {
        if (process.env.NODE_ENV !== "production") {
          console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join("\n"));
        }
        rootRef.current.setAttribute("tabIndex", "-1");
      }
      if (activated.current) {
        rootRef.current.focus();
      }
    }
    return () => {
      if (!disableRestoreFocus) {
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          ignoreNextEnforceFocus.current = true;
          nodeToRestore.current.focus();
        }
        nodeToRestore.current = null;
      }
    };
  }, [open]);
  React.useEffect(() => {
    if (!open || !rootRef.current) {
      return;
    }
    const doc = ownerDocument(rootRef.current);
    const loopFocus = (nativeEvent) => {
      lastKeydown.current = nativeEvent;
      if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") {
        return;
      }
      if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
        ignoreNextEnforceFocus.current = true;
        if (sentinelEnd.current) {
          sentinelEnd.current.focus();
        }
      }
    };
    const contain = () => {
      const rootElement = rootRef.current;
      if (rootElement === null) {
        return;
      }
      if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }
      if (rootElement.contains(doc.activeElement)) {
        return;
      }
      if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) {
        return;
      }
      if (doc.activeElement !== reactFocusEventTarget.current) {
        reactFocusEventTarget.current = null;
      } else if (reactFocusEventTarget.current !== null) {
        return;
      }
      if (!activated.current) {
        return;
      }
      let tabbable = [];
      if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) {
        tabbable = getTabbable(rootRef.current);
      }
      if (tabbable.length > 0) {
        var _lastKeydown$current, _lastKeydown$current2;
        const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
        const focusNext = tabbable[0];
        const focusPrevious = tabbable[tabbable.length - 1];
        if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
          if (isShiftTab) {
            focusPrevious.focus();
          } else {
            focusNext.focus();
          }
        }
      } else {
        rootElement.focus();
      }
    };
    doc.addEventListener("focusin", contain);
    doc.addEventListener("keydown", loopFocus, true);
    const interval = setInterval(() => {
      if (doc.activeElement && doc.activeElement.tagName === "BODY") {
        contain();
      }
    }, 50);
    return () => {
      clearInterval(interval);
      doc.removeEventListener("focusin", contain);
      doc.removeEventListener("keydown", loopFocus, true);
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open, getTabbable]);
  const onFocus = (event) => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }
    activated.current = true;
    reactFocusEventTarget.current = event.target;
    const childrenPropsHandler = children.props.onFocus;
    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };
  const handleFocusSentinel = (event) => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }
    activated.current = true;
  };
  return /* @__PURE__ */ jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelStart,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ React.cloneElement(children, {
      ref: handleRef,
      onFocus
    }), /* @__PURE__ */ jsx("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelEnd,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" ? FocusTrap.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes.bool.isRequired
} : void 0;
if (process.env.NODE_ENV !== "production") {
  FocusTrap["propTypes"] = exactProp(FocusTrap.propTypes);
}
const GLOBAL_CLASS_PREFIX = "base";
function buildStateClass(state) {
  return `${GLOBAL_CLASS_PREFIX}--${state}`;
}
function buildSlotClass(componentName, slot) {
  return `${GLOBAL_CLASS_PREFIX}-${componentName}-${slot}`;
}
function generateUtilityClass(componentName, slot) {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? buildStateClass(globalStateClass) : buildSlotClass(componentName, slot);
}
function generateUtilityClasses(componentName, slots) {
  const result = {};
  slots.forEach((slot) => {
    result[slot] = generateUtilityClass(componentName, slot);
  });
  return result;
}
const COMPONENT_NAME$6 = "Modal";
function getModalUtilityClass(slot) {
  return generateUtilityClass(COMPONENT_NAME$6, slot);
}
generateUtilityClasses(COMPONENT_NAME$6, ["root", "hidden", "backdrop"]);
const _excluded$e = ["children", "closeAfterTransition", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onKeyDown", "open", "onTransitionEnter", "onTransitionExited", "slotProps", "slots"];
const useUtilityClasses$6 = (ownerState) => {
  const {
    open,
    exited
  } = ownerState;
  const slots = {
    root: ["root", !open && exited && "hidden"],
    backdrop: ["backdrop"]
  };
  return composeClasses(slots, useClassNamesOverride(getModalUtilityClass));
};
const Modal$1 = /* @__PURE__ */ React.forwardRef(function Modal(props, forwardedRef) {
  var _slots$root;
  const {
    children,
    closeAfterTransition = false,
    container,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = false,
    disableRestoreFocus = false,
    disableScrollLock = false,
    hideBackdrop = false,
    keepMounted = false,
    onBackdropClick,
    open,
    slotProps = {},
    slots = {}
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$e);
  const propsWithDefaults = _extends$2({}, props, {
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted
  });
  const {
    getRootProps,
    getBackdropProps,
    getTransitionProps: getTransitionProps2,
    portalRef,
    isTopModal,
    exited,
    hasTransition
  } = useModal(_extends$2({}, propsWithDefaults, {
    rootRef: forwardedRef
  }));
  const ownerState = _extends$2({}, propsWithDefaults, {
    exited,
    hasTransition
  });
  const classes = useUtilityClasses$6(ownerState);
  const childProps = {};
  if (children.props.tabIndex === void 0) {
    childProps.tabIndex = "-1";
  }
  if (hasTransition) {
    const {
      onEnter,
      onExited
    } = getTransitionProps2();
    childProps.onEnter = onEnter;
    childProps.onExited = onExited;
  }
  const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    getSlotProps: getRootProps,
    className: classes.root,
    ownerState
  });
  const BackdropComponent = slots.backdrop;
  const backdropProps = useSlotProps({
    elementType: BackdropComponent,
    externalSlotProps: slotProps.backdrop,
    getSlotProps: (otherHandlers) => {
      return getBackdropProps(_extends$2({}, otherHandlers, {
        onClick: (e2) => {
          if (onBackdropClick) {
            onBackdropClick(e2);
          }
          if (otherHandlers != null && otherHandlers.onClick) {
            otherHandlers.onClick(e2);
          }
        }
      }));
    },
    className: classes.backdrop,
    ownerState
  });
  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }
  return /* @__PURE__ */ jsx(Portal, {
    ref: portalRef,
    container,
    disablePortal,
    children: /* @__PURE__ */ jsxs(Root, _extends$2({}, rootProps, {
      children: [!hideBackdrop && BackdropComponent ? /* @__PURE__ */ jsx(BackdropComponent, _extends$2({}, backdropProps)) : null, /* @__PURE__ */ jsx(FocusTrap, {
        disableEnforceFocus,
        disableAutoFocus,
        disableRestoreFocus,
        isEnabled: isTopModal,
        open,
        children: /* @__PURE__ */ React.cloneElement(children, childProps)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" ? Modal$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes.bool,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    root: PropTypes.elementType
  })
} : void 0;
function _setPrototypeOf(t2, e2) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t3, e3) {
    return t3.__proto__ = e3, t3;
  }, _setPrototypeOf(t2, e2);
}
function _inheritsLoose(t2, o2) {
  t2.prototype = Object.create(o2.prototype), t2.prototype.constructor = t2, _setPrototypeOf(t2, o2);
}
const config = {
  disabled: false
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function forceReflow2(node2) {
  return node2.scrollTop;
};
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
var Transition = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(Transition2, _React$Component);
  function Transition2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  };
  var _proto = Transition2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout2 = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout2;
    if (timeout2 != null && typeof timeout2 !== "number") {
      exit = timeout2.exit;
      enter = timeout2.enter;
      appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
    }
    return {
      exit,
      enter,
      appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
          if (node2)
            forceReflow(node2);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function() {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function() {
        _this2.safeSetState({
          status: ENTERED
        }, function() {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function() {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function() {
        _this3.safeSetState({
          status: EXITED
        }, function() {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function(event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function() {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout2, handler) {
    this.setNextCallback(handler);
    var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
    if (!node2 || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node2, this.nextCallback], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout2 != null) {
      setTimeout(this.nextCallback, timeout2);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props, children = _this$props.children;
    _this$props.in;
    _this$props.mountOnEnter;
    _this$props.unmountOnExit;
    _this$props.appear;
    _this$props.enter;
    _this$props.exit;
    _this$props.timeout;
    _this$props.addEndListener;
    _this$props.onEnter;
    _this$props.onEntering;
    _this$props.onEntered;
    _this$props.onExit;
    _this$props.onExiting;
    _this$props.onExited;
    _this$props.nodeRef;
    var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === "function" ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };
  return Transition2;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === "undefined" ? PropTypes.any : function(propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener)
      pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop$2() {
}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$2,
  onEntering: noop$2,
  onEntered: noop$2,
  onExit: noop$2,
  onExiting: noop$2,
  onExited: noop$2
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
const Transition$1 = Transition;
function memoize$1(fn2) {
  var cache2 = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache2[arg] === void 0)
      cache2[arg] = fn2(arg);
    return cache2[arg];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid = /* @__PURE__ */ memoize$1(
  function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === void 0 ? process.env.NODE_ENV === "production" : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var isImportRule3 = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;
      if (isImportRule3 && this._alreadyInsertedOrderInsensitiveRule) {
        console.error("You're attempting to insert the following rule:\n" + rule + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.");
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule3;
    }
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e2) {
        if (process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error('There was a problem inserting the following rule: "' + rule + '"', e2);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
    if (process.env.NODE_ENV !== "production") {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash$2(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end2) {
  return value.slice(begin, end2);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array) {
  return array.push(value), value;
}
function combine(array, callback) {
  return array.map(callback).join("");
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root2, parent, type, props, children, length2) {
  return { value, root: root2, parent, type, props, children, line, column, length: length2, return: "" };
}
function copy(root2, props) {
  return assign(node("", null, null, "", null, null, 0), root2, { length: -root2.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end2) {
  return substr(characters, begin, end2);
}
function token(type) {
  switch (type) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace(type) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index2, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
  while (next())
    switch (character) {
      case type:
        return position;
      case 34:
      case 39:
        if (type !== 34 && type !== 39)
          delimiter(character);
        break;
      case 40:
        if (type === 41)
          delimiter(type);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type, index2) {
  while (next())
    if (type + character === 47 + 10)
      break;
    else if (type + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index2, position - 1) + "*" + from(type === 47 ? type : next());
}
function identifier(index2) {
  while (!token(peek()))
    next();
  return slice(index2, position);
}
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root2, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset2 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type = "";
  var props = rules;
  var children = rulesets;
  var reference2 = rule;
  var characters2 = type;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root2, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset2:
            if (ampersand == -1)
              characters2 = replace(characters2, /\f/g, "");
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append(reference2 = ruleset(characters2, root2, parent, index2, offset2, rules, points, type, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset2 === 0)
                parse(characters2, root2, reference2, reference2, props, rulesets, length2, points, children);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse(value, reference2, reference2, rule && append(ruleset(value, reference2, reference2, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse(characters2, reference2, reference2, reference2, [""], children, 0, points, children);
                }
        }
        index2 = offset2 = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset2 > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset2 = length2 = strlen(type = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root2, parent, index2, offset2, rules, points, type, props, children, length2) {
  var post = offset2 - 1;
  var rule = offset2 === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index2; ++i)
    for (var x2 = 0, y = substr(value, post + 1, post = abs(j = points[i])), z2 = value; x2 < size; ++x2)
      if (z2 = trim(j > 0 ? rule[x2] + " " + y : replace(y, /&\f/g, rule[x2])))
        props[k++] = z2;
  return node(value, root2, parent, offset2 === 0 ? RULESET : type, props, children, length2);
}
function comment(value, root2, parent) {
  return node(value, root2, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root2, parent, length2) {
  return node(value, root2, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i = 0; i < length2; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index2, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length)
        break;
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index2, children, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element, index2, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      default:
        parsed[index2] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value, parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent)
      return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (
      // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98
    ) {
      element["return"] = "";
      element.value = "";
    }
  }
};
var ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var isIgnoringComment = function isIgnoringComment2(element) {
  return element.type === "comm" && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm2(cache2) {
  return function(element, index2, children) {
    if (element.type !== "rule" || cache2.compat)
      return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
    if (unsafePseudoClasses) {
      var isNested = !!element.parent;
      var commentContainer = isNested ? element.parent.children : (
        // global rule at the root level
        children
      );
      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node2 = commentContainer[i];
        if (node2.line < element.line) {
          break;
        }
        if (node2.column < element.column) {
          if (isIgnoringComment(node2)) {
            return;
          }
          break;
        }
      }
      unsafePseudoClasses.forEach(function(unsafePseudoClass) {
        console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
      });
    }
  };
};
var isImportRule = function isImportRule2(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules2(index2, children) {
  for (var i = index2 - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }
  return false;
};
var nullifyElement = function nullifyElement2(element) {
  element.type = "";
  element.value = "";
  element["return"] = "";
  element.children = "";
  element.props = "";
};
var incorrectImportAlarm = function incorrectImportAlarm2(element, index2, children) {
  if (!isImportRule(element)) {
    return;
  }
  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index2, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};
function prefix(value, length2) {
  switch (hash$2(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6)
        switch (charat(value, length2 + 1)) {
          case 109:
            if (charat(value, length2 + 4) !== 45)
              break;
          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
          case 115:
            return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
        }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115)
        break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element, index2, children, callback) {
  if (element.length > -1) {
    if (!element["return"])
      switch (element.type) {
        case DECLARATION:
          element["return"] = prefix(element.value, element.length);
          break;
        case KEYFRAMES:
          return serialize([copy(element, {
            value: replace(element.value, "@", "@" + WEBKIT)
          })], callback);
        case RULESET:
          if (element.length)
            return combine(element.props, function(value) {
              switch (match(value, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return serialize([copy(element, {
                    props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
                  })], callback);
                case "::placeholder":
                  return serialize([copy(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
                  }), copy(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
                  }), copy(element, {
                    props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
                  })], callback);
              }
              return "";
            });
      }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options) {
  var key = options.key;
  if (process.env.NODE_ENV !== "production" && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");
  }
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  if (process.env.NODE_ENV !== "production") {
    if (/[^a-z-]/.test(key)) {
      throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + key + '" was passed');
    }
  }
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options.container || document.head;
    Array.prototype.forEach.call(
      // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll('style[data-emotion^="' + key + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  if (process.env.NODE_ENV !== "production") {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache2.compat;
      }
    }), incorrectImportAlarm);
  }
  {
    var currentSheet;
    var finalizingPlugins = [stringify, process.env.NODE_ENV !== "production" ? function(element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles2) {
      return serialize(compile(styles2), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      if (process.env.NODE_ENV !== "production" && serialized.map !== void 0) {
        currentSheet = {
          insert: function insert2(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache2.inserted[serialized.name] = true;
      }
    };
  }
  var cache2 = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache2.sheet.hydrate(nodesToHydrate);
  return cache2;
};
var isBrowser$2 = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = "";
  classNames.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache2, serialized, isStringTag2) {
  var className = cache2.key + "-" + serialized.name;
  if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag2 === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser$2 === false) && cache2.registered[className] === void 0
  ) {
    cache2.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache2, serialized, isStringTag2) {
  registerStyles(cache2, serialized, isStringTag2);
  var className = cache2.key + "-" + serialized.name;
  if (cache2.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache2.insert(serialized === current ? "." + className : "", current, cache2.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h = 0;
  var k, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 255;
      h = /* Math.imul(h, m): */
      (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`;
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize$1(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
if (process.env.NODE_ENV !== "production") {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ["normal", "none", "initial", "inherit", "unset"];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};
  processStyleValue = function processStyleValue3(key, value) {
    if (key === "content") {
      if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }
    var processed = oldProcessStyleValue(key, value);
    if (processed !== "" && !isCustomProperty(key) && key.indexOf("-") !== -1 && hyphenatedCache[key] === void 0) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, "ms-").replace(hyphenPattern, function(str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }
    return processed;
  };
}
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && interpolation.toString() === "NO_COMPONENT_SELECTOR") {
      throw new Error(noComponentSelectorMessage);
    }
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next2 = interpolation.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles2 = interpolation.styles + ";";
        if (process.env.NODE_ENV !== "production" && interpolation.map !== void 0) {
          styles2 += interpolation.map;
        }
        return styles2;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      } else if (process.env.NODE_ENV !== "production") {
        console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      }
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function(match2, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, "") + "`");
          return "${" + fakeVarName + "}";
        });
        if (matched.length) {
          console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(matched, ["`" + replaced + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\n" + ("css`" + replaced + "`"));
        }
      }
      break;
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production") {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case "animation":
            case "animationName": {
              string += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              if (process.env.NODE_ENV !== "production" && _key === "undefined") {
                console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
              }
              string += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
if (process.env.NODE_ENV !== "production") {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
}
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles2 = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles2 += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== "production" && strings[0] === void 0) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }
    styles2 += strings[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles2 += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      if (process.env.NODE_ENV !== "production" && strings[i] === void 0) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }
      styles2 += strings[i];
    }
  }
  var sourceMap;
  if (process.env.NODE_ENV !== "production") {
    styles2 = styles2.replace(sourceMapPattern, function(match3) {
      sourceMap = match3;
      return "";
    });
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles2)) !== null) {
    identifierName += "-" + // $FlowFixMe we know it's not null
    match2[1];
  }
  var name = murmur2(styles2) + identifierName;
  if (process.env.NODE_ENV !== "production") {
    return {
      name,
      styles: styles2,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }
  return {
    name,
    styles: styles2,
    next: cursor
  };
};
var syncFallback = function syncFallback2(create2) {
  return create2();
};
var useInsertionEffect = React["useInsertionEffect"] ? React["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var hasOwn = {}.hasOwnProperty;
var EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
if (process.env.NODE_ENV !== "production") {
  EmotionCacheContext.displayName = "EmotionCacheContext";
}
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref) {
    var cache2 = useContext(EmotionCacheContext);
    return func(props, cache2, ref);
  });
};
var ThemeContext = /* @__PURE__ */ React.createContext({});
if (process.env.NODE_ENV !== "production") {
  ThemeContext.displayName = "EmotionThemeContext";
}
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var Insertion$1 = function Insertion(_ref) {
  var cache2 = _ref.cache, serialized = _ref.serialized, isStringTag2 = _ref.isStringTag;
  registerStyles(cache2, serialized, isStringTag2);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache2, serialized, isStringTag2);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache2, ref) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache2.registered[cssProp] !== void 0) {
    cssProp = cache2.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache2.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, React.useContext(ThemeContext));
  if (process.env.NODE_ENV !== "production" && serialized.name.indexOf("-") === -1) {
    var labelFromStack = props[labelPropName];
    if (labelFromStack) {
      serialized = serializeStyles([serialized, "label:" + labelFromStack + ";"]);
    }
  }
  className += cache2.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwn.call(props, key) && key !== "css" && key !== typePropName && (process.env.NODE_ENV === "production" || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$1, {
    cache: cache2,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ React.createElement(WrappedComponent, newProps));
});
if (process.env.NODE_ENV !== "production") {
  Emotion.displayName = "EmotionCssPropInternal";
}
var testOmitPropsOnStringTag = isPropValid;
var testOmitPropsOnComponent = function testOmitPropsOnComponent2(key) {
  return key !== "theme";
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp2(tag) {
  return typeof tag === "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps2(tag, options, isReal) {
  var shouldForwardProp2;
  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp2 = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }
  if (typeof shouldForwardProp2 !== "function" && isReal) {
    shouldForwardProp2 = tag.__emotion_forwardProp;
  }
  return shouldForwardProp2;
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`;
var Insertion2 = function Insertion3(_ref) {
  var cache2 = _ref.cache, serialized = _ref.serialized, isStringTag2 = _ref.isStringTag;
  registerStyles(cache2, serialized, isStringTag2);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache2, serialized, isStringTag2);
  });
  return null;
};
var createStyled$1 = function createStyled(tag, options) {
  if (process.env.NODE_ENV !== "production") {
    if (tag === void 0) {
      throw new Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
    }
  }
  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;
  if (options !== void 0) {
    identifierName = options.label;
    targetClassName = options.target;
  }
  var shouldForwardProp2 = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp2 || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp("as");
  return function() {
    var args = arguments;
    var styles2 = isReal && tag.__emotion_styles !== void 0 ? tag.__emotion_styles.slice(0) : [];
    if (identifierName !== void 0) {
      styles2.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === void 0) {
      styles2.push.apply(styles2, args);
    } else {
      if (process.env.NODE_ENV !== "production" && args[0][0] === void 0) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }
      styles2.push(args[0][0]);
      var len = args.length;
      var i = 1;
      for (; i < len; i++) {
        if (process.env.NODE_ENV !== "production" && args[0][i] === void 0) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }
        styles2.push(args[i], args[0][i]);
      }
    }
    var Styled = withEmotionCache(function(props, cache2, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = "";
      var classInterpolations = [];
      var mergedProps = props;
      if (props.theme == null) {
        mergedProps = {};
        for (var key in props) {
          mergedProps[key] = props[key];
        }
        mergedProps.theme = React.useContext(ThemeContext);
      }
      if (typeof props.className === "string") {
        className = getRegisteredStyles(cache2.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }
      var serialized = serializeStyles(styles2.concat(classInterpolations), cache2.registered, mergedProps);
      className += cache2.key + "-" + serialized.name;
      if (targetClassName !== void 0) {
        className += " " + targetClassName;
      }
      var finalShouldForwardProp = shouldUseAs && shouldForwardProp2 === void 0 ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};
      for (var _key in props) {
        if (shouldUseAs && _key === "as")
          continue;
        if (
          // $FlowFixMe
          finalShouldForwardProp(_key)
        ) {
          newProps[_key] = props[_key];
        }
      }
      newProps.className = className;
      newProps.ref = ref;
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion2, {
        cache: cache2,
        serialized,
        isStringTag: typeof FinalTag === "string"
      }), /* @__PURE__ */ React.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== void 0 ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles2;
    Styled.__emotion_forwardProp = shouldForwardProp2;
    Object.defineProperty(Styled, "toString", {
      value: function value() {
        if (targetClassName === void 0 && process.env.NODE_ENV !== "production") {
          return "NO_COMPONENT_SELECTOR";
        }
        return "." + targetClassName;
      }
    });
    Styled.withComponent = function(nextTag, nextOptions) {
      return createStyled(nextTag, _extends$2({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles2);
    };
    return Styled;
  };
};
var tags = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
var newStyled = createStyled$1.bind();
tags.forEach(function(tagName) {
  newStyled[tagName] = newStyled(tagName);
});
/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$2(tag, options) {
  const stylesFactory = newStyled(tag, options);
  if (process.env.NODE_ENV !== "production") {
    return (...styles2) => {
      const component = typeof tag === "string" ? `"${tag}"` : "component";
      if (styles2.length === 0) {
        console.error([`MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join("\n"));
      } else if (styles2.some((style2) => style2 === void 0)) {
        console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
      }
      return stylesFactory(...styles2);
    };
  }
  return stylesFactory;
}
const internal_processStyles = (tag, processor) => {
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};
const _excluded$d = ["values", "unit", "step"];
const sortBreakpointsValues = (values2) => {
  const breakpointsAsArray = Object.keys(values2).map((key) => ({
    key,
    val: values2[key]
  })) || [];
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return _extends$2({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};
function createBreakpoints(breakpoints) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: values2 = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit = "px",
    step = 5
  } = breakpoints, other = _objectWithoutPropertiesLoose(breakpoints, _excluded$d);
  const sortedValues = sortBreakpointsValues(values2);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start2, end2) {
    const endIndex = keys.indexOf(end2);
    return `@media (min-width:${typeof values2[start2] === "number" ? values2[start2] : start2}${unit}) and (max-width:${(endIndex !== -1 && typeof values2[keys[endIndex]] === "number" ? values2[keys[endIndex]] : end2) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
  }
  return _extends$2({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}
const shape = {
  borderRadius: 4
};
const shape$1 = shape;
const responsivePropType = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
const responsivePropType$1 = responsivePropType;
function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge(acc, item, {
    clone: false
    // No need to clone deep, it's way faster.
  });
}
const values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (key) => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index2) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index2])] = styleFromPropValue(propValue[index2]);
      return acc;
    }, {});
  }
  if (typeof propValue === "object") {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style2) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style2);
}
function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== "string") {
    return null;
  }
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split(".").reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split(".").reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === "function") {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style$1(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;
  const fn2 = (props) => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = (propValueFinal) => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === "string") {
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn2.propTypes = process.env.NODE_ENV !== "production" ? {
    [prop]: responsivePropType$1
  } : {};
  fn2.filterProps = [prop];
  return fn2;
}
function memoize(fn2) {
  const cache2 = {};
  return (arg) => {
    if (cache2[arg] === void 0) {
      cache2[arg] = fn2(arg);
    }
    return cache2[arg];
  };
}
const properties = {
  m: "margin",
  p: "padding"
};
const directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
};
const aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
};
const getCssProperties = memoize((prop) => {
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a2, b] = prop.split("");
  const property = properties[a2];
  const direction = directions[b] || "";
  return Array.isArray(direction) ? direction.map((dir) => property + dir) : [property + direction];
});
const marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"];
const paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue2, propName) {
  var _getPath;
  const themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue2;
  if (typeof themeSpacing === "number") {
    return (abs2) => {
      if (typeof abs2 === "string") {
        return abs2;
      }
      if (process.env.NODE_ENV !== "production") {
        if (typeof abs2 !== "number") {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs2}.`);
        }
      }
      return themeSpacing * abs2;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return (abs2) => {
      if (typeof abs2 === "string") {
        return abs2;
      }
      if (process.env.NODE_ENV !== "production") {
        if (!Number.isInteger(abs2)) {
          console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join("\n"));
        } else if (abs2 > themeSpacing.length - 1) {
          console.error([`MUI: The value provided (${abs2}) overflows.`, `The supported values are: ${JSON.stringify(themeSpacing)}.`, `${abs2} > ${themeSpacing.length - 1}, you need to add the missing values.`].join("\n"));
        }
      }
      return themeSpacing[abs2];
    };
  }
  if (typeof themeSpacing === "function") {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== "production") {
    console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`, "It should be a number, an array or a function."].join("\n"));
  }
  return () => void 0;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, "spacing", 8, "spacing");
}
function getValue(transformer, propValue) {
  if (typeof propValue === "string" || propValue == null) {
    return propValue;
  }
  const abs2 = Math.abs(propValue);
  const transformed = transformer(abs2);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === "number") {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return (propValue) => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map((prop) => resolveCssProperty(props, keys, prop, transformer)).reduce(merge, {});
}
function margin(props) {
  return style(props, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== "production" ? marginKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
margin.filterProps = marginKeys;
function padding(props) {
  return style(props, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== "production" ? paddingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== "production" ? spacingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
function createSpacing(spacingInput = 8) {
  if (spacingInput.mui) {
    return spacingInput;
  }
  const transform = createUnarySpacing({
    spacing: spacingInput
  });
  const spacing = (...argsInput) => {
    if (process.env.NODE_ENV !== "production") {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map((argument) => {
      const output = transform(argument);
      return typeof output === "number" ? `${output}px` : output;
    }).join(" ");
  };
  spacing.mui = true;
  return spacing;
}
function compose(...styles2) {
  const handlers = styles2.reduce((acc, style2) => {
    style2.filterProps.forEach((prop) => {
      acc[prop] = style2;
    });
    return acc;
  }, {});
  const fn2 = (props) => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn2.propTypes = process.env.NODE_ENV !== "production" ? styles2.reduce((acc, style2) => Object.assign(acc, style2.propTypes), {}) : {};
  fn2.filterProps = styles2.reduce((acc, style2) => acc.concat(style2.filterProps), []);
  return fn2;
}
function borderTransform(value) {
  if (typeof value !== "number") {
    return value;
  }
  return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
  return style$1({
    prop,
    themeKey: "borders",
    transform
  });
}
const border = createBorderStyle("border", borderTransform);
const borderTop = createBorderStyle("borderTop", borderTransform);
const borderRight = createBorderStyle("borderRight", borderTransform);
const borderBottom = createBorderStyle("borderBottom", borderTransform);
const borderLeft = createBorderStyle("borderLeft", borderTransform);
const borderColor = createBorderStyle("borderColor");
const borderTopColor = createBorderStyle("borderTopColor");
const borderRightColor = createBorderStyle("borderRightColor");
const borderBottomColor = createBorderStyle("borderBottomColor");
const borderLeftColor = createBorderStyle("borderLeftColor");
const outline = createBorderStyle("outline", borderTransform);
const outlineColor = createBorderStyle("outlineColor");
const borderRadius = (props) => {
  if (props.borderRadius !== void 0 && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, "shape.borderRadius", 4, "borderRadius");
    const styleFromPropValue = (propValue) => ({
      borderRadius: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType$1
} : {};
borderRadius.filterProps = ["borderRadius"];
compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
const gap = (props) => {
  if (props.gap !== void 0 && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "gap");
    const styleFromPropValue = (propValue) => ({
      gap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: responsivePropType$1
} : {};
gap.filterProps = ["gap"];
const columnGap = (props) => {
  if (props.columnGap !== void 0 && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "columnGap");
    const styleFromPropValue = (propValue) => ({
      columnGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: responsivePropType$1
} : {};
columnGap.filterProps = ["columnGap"];
const rowGap = (props) => {
  if (props.rowGap !== void 0 && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "rowGap");
    const styleFromPropValue = (propValue) => ({
      rowGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: responsivePropType$1
} : {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$1({
  prop: "gridColumn"
});
const gridRow = style$1({
  prop: "gridRow"
});
const gridAutoFlow = style$1({
  prop: "gridAutoFlow"
});
const gridAutoColumns = style$1({
  prop: "gridAutoColumns"
});
const gridAutoRows = style$1({
  prop: "gridAutoRows"
});
const gridTemplateColumns = style$1({
  prop: "gridTemplateColumns"
});
const gridTemplateRows = style$1({
  prop: "gridTemplateRows"
});
const gridTemplateAreas = style$1({
  prop: "gridTemplateAreas"
});
const gridArea = style$1({
  prop: "gridArea"
});
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(value, userValue) {
  if (userValue === "grey") {
    return userValue;
  }
  return value;
}
const color$2 = style$1({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
});
const bgcolor = style$1({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
const backgroundColor = style$1({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose(color$2, bgcolor, backgroundColor);
function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = style$1({
  prop: "width",
  transform: sizingTransform
});
const maxWidth = (props) => {
  if (props.maxWidth !== void 0 && props.maxWidth !== null) {
    const styleFromPropValue = (propValue) => {
      var _props$theme, _props$theme2;
      const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || values[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$1({
  prop: "minWidth",
  transform: sizingTransform
});
const height = style$1({
  prop: "height",
  transform: sizingTransform
});
const maxHeight = style$1({
  prop: "maxHeight",
  transform: sizingTransform
});
const minHeight = style$1({
  prop: "minHeight",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
const boxSizing = style$1({
  prop: "boxSizing"
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: (value) => ({
      "@media print": {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: "typography"
  }
};
const defaultSxConfig$1 = defaultSxConfig;
function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every((object) => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config2) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config2[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style: style2
    } = options;
    if (val == null) {
      return null;
    }
    if (themeKey === "typography" && val === "inherit") {
      return {
        [prop]: val
      };
    }
    const themeMapping = getPath(theme, themeKey) || {};
    if (style2) {
      return style2(props);
    }
    const styleFromPropValue = (propValueFinal) => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === "string") {
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, val, styleFromPropValue);
  }
  function styleFunctionSx2(props) {
    var _theme$unstable_sxCon;
    const {
      sx,
      theme = {}
    } = props || {};
    if (!sx) {
      return null;
    }
    const config2 = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : defaultSxConfig$1;
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === "function") {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== "object") {
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach((styleKey) => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== void 0) {
          if (typeof value === "object") {
            if (config2[styleKey]) {
              css = merge(css, getThemeValue(styleKey, value, theme, config2));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value, (x2) => ({
                [styleKey]: x2
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx2({
                  sx: value,
                  theme
                });
              } else {
                css = merge(css, breakpointsValues);
              }
            }
          } else {
            css = merge(css, getThemeValue(styleKey, value, theme, config2));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx2;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ["sx"];
const styleFunctionSx$1 = styleFunctionSx;
function applyStyles$2(key, styles2) {
  const theme = this;
  if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
    const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
    return {
      [selector]: styles2
    };
  }
  if (theme.palette.mode === key) {
    return styles2;
  }
  return {};
}
const _excluded$c = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$1(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {}
  } = options, other = _objectWithoutPropertiesLoose(options, _excluded$c);
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge({
    breakpoints,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: _extends$2({
      mode: "light"
    }, paletteInput),
    spacing,
    shape: _extends$2({}, shape$1, shapeInput)
  }, other);
  muiTheme.applyStyles = applyStyles$2;
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = _extends$2({}, defaultSxConfig$1, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$1({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme$2(defaultTheme2 = null) {
  const contextTheme = React.useContext(ThemeContext);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme2 : contextTheme;
}
const systemDefaultTheme$1 = createTheme$1();
function useTheme$1(defaultTheme2 = systemDefaultTheme$1) {
  return useTheme$2(defaultTheme2);
}
const _excluded$b = ["ownerState"], _excluded2$1 = ["variants"], _excluded3 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function isStringTag(tag) {
  return typeof tag === "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}
function shouldForwardProp(prop) {
  return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const systemDefaultTheme = createTheme$1();
const lowercaseFirstLetter = (string) => {
  if (!string) {
    return string;
  }
  return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({
  defaultTheme: defaultTheme2,
  theme,
  themeId
}) {
  return isEmpty(theme) ? defaultTheme2 : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
  if (!slot) {
    return null;
  }
  return (props, styles2) => styles2[slot];
}
function processStyleArg(callableStyle, _ref) {
  let {
    ownerState
  } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle(_extends$2({
    ownerState
  }, props)) : callableStyle;
  if (Array.isArray(resolvedStylesArg)) {
    return resolvedStylesArg.flatMap((resolvedStyle) => processStyleArg(resolvedStyle, _extends$2({
      ownerState
    }, props)));
  }
  if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
    const {
      variants = []
    } = resolvedStylesArg, otherStyles = _objectWithoutPropertiesLoose(resolvedStylesArg, _excluded2$1);
    let result = otherStyles;
    variants.forEach((variant) => {
      let isMatch = true;
      if (typeof variant.props === "function") {
        isMatch = variant.props(_extends$2({
          ownerState
        }, props, ownerState));
      } else {
        Object.keys(variant.props).forEach((key) => {
          if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) {
            isMatch = false;
          }
        });
      }
      if (isMatch) {
        if (!Array.isArray(result)) {
          result = [result];
        }
        result.push(typeof variant.style === "function" ? variant.style(_extends$2({
          ownerState
        }, props, ownerState)) : variant.style);
      }
    });
    return result;
  }
  return resolvedStylesArg;
}
function createStyled2(input = {}) {
  const {
    themeId,
    defaultTheme: defaultTheme2 = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp
  } = input;
  const systemSx = (props) => {
    return styleFunctionSx$1(_extends$2({}, props, {
      theme: resolveTheme(_extends$2({}, props, {
        defaultTheme: defaultTheme2,
        themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    internal_processStyles(tag, (styles2) => styles2.filter((style2) => !(style2 != null && style2.__mui_systemSx)));
    const {
      name: componentName,
      slot: componentSlot,
      skipVariantsResolver: inputSkipVariantsResolver,
      skipSx: inputSkipSx,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot))
    } = inputOptions, options = _objectWithoutPropertiesLoose(inputOptions, _excluded3);
    const skipVariantsResolver = inputSkipVariantsResolver !== void 0 ? inputSkipVariantsResolver : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false
    );
    const skipSx = inputSkipSx || false;
    let label;
    if (process.env.NODE_ENV !== "production") {
      if (componentName) {
        label = `${componentName}-${lowercaseFirstLetter(componentSlot || "Root")}`;
      }
    }
    let shouldForwardPropOption = shouldForwardProp;
    if (componentSlot === "Root" || componentSlot === "root") {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      shouldForwardPropOption = void 0;
    }
    const defaultStyledResolver = styled$2(tag, _extends$2({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const transformStyleArg = (stylesArg) => {
      if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || isPlainObject(stylesArg)) {
        return (props) => processStyleArg(stylesArg, _extends$2({}, props, {
          theme: resolveTheme({
            theme: props.theme,
            defaultTheme: defaultTheme2,
            themeId
          })
        }));
      }
      return stylesArg;
    };
    const muiStyledResolver = (styleArg, ...expressions) => {
      let transformedStyleArg = transformStyleArg(styleArg);
      const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push((props) => {
          const theme = resolveTheme(_extends$2({}, props, {
            defaultTheme: defaultTheme2,
            themeId
          }));
          if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) {
            return null;
          }
          const styleOverrides = theme.components[componentName].styleOverrides;
          const resolvedStyleOverrides = {};
          Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
            resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, _extends$2({}, props, {
              theme
            }));
          });
          return overridesResolver(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push((props) => {
          var _theme$components;
          const theme = resolveTheme(_extends$2({}, props, {
            defaultTheme: defaultTheme2,
            themeId
          }));
          const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
          return processStyleArg({
            variants: themeVariants
          }, _extends$2({}, props, {
            theme
          }));
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill("");
        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      }
      const Component2 = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      if (process.env.NODE_ENV !== "production") {
        let displayName;
        if (componentName) {
          displayName = `${componentName}${capitalize(componentSlot || "")}`;
        }
        if (displayName === void 0) {
          displayName = `Styled(${getDisplayName(tag)})`;
        }
        Component2.displayName = displayName;
      }
      if (tag.muiName) {
        Component2.muiName = tag.muiName;
      }
      return Component2;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}
const styled = createStyled2();
const styled$1 = styled;
function createMixins(breakpoints, mixins) {
  return _extends$2({
    toolbar: {
      minHeight: 56,
      [breakpoints.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [breakpoints.up("sm")]: {
        minHeight: 64
      }
    }
  }, mixins);
}
var colorManipulator = {};
var interopRequireDefault = { exports: {} };
(function(module) {
  function _interopRequireDefault2(e2) {
    return e2 && e2.__esModule ? e2 : {
      "default": e2
    };
  }
  module.exports = _interopRequireDefault2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(interopRequireDefault);
var interopRequireDefaultExports = interopRequireDefault.exports;
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(formatMuiErrorMessage);
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(clamp$3);
var _interopRequireDefault$2 = interopRequireDefaultExports;
Object.defineProperty(colorManipulator, "__esModule", {
  value: true
});
colorManipulator.alpha = alpha$2;
colorManipulator.blend = blend;
colorManipulator.colorChannel = void 0;
var darken_1 = colorManipulator.darken = darken;
colorManipulator.decomposeColor = decomposeColor;
colorManipulator.emphasize = emphasize;
var getContrastRatio_1 = colorManipulator.getContrastRatio = getContrastRatio;
colorManipulator.getLuminance = getLuminance;
colorManipulator.hexToRgb = hexToRgb;
colorManipulator.hslToRgb = hslToRgb;
var lighten_1 = colorManipulator.lighten = lighten;
colorManipulator.private_safeAlpha = private_safeAlpha;
colorManipulator.private_safeColorChannel = void 0;
colorManipulator.private_safeDarken = private_safeDarken;
colorManipulator.private_safeEmphasize = private_safeEmphasize;
colorManipulator.private_safeLighten = private_safeLighten;
colorManipulator.recomposeColor = recomposeColor;
colorManipulator.rgbToHex = rgbToHex;
var _formatMuiErrorMessage2 = _interopRequireDefault$2(require$$1);
var _clamp = _interopRequireDefault$2(require$$2);
function clampWrapper(value, min2 = 0, max2 = 1) {
  if (process.env.NODE_ENV !== "production") {
    if (value < min2 || value > max2) {
      console.error(`MUI: The value provided ${value} is out of range [${min2}, ${max2}].`);
    }
  }
  return (0, _clamp.default)(value, min2, max2);
}
function hexToRgb(color2) {
  color2 = color2.slice(1);
  const re = new RegExp(`.{1,${color2.length >= 6 ? 2 : 1}}`, "g");
  let colors2 = color2.match(re);
  if (colors2 && colors2[0].length === 1) {
    colors2 = colors2.map((n2) => n2 + n2);
  }
  return colors2 ? `rgb${colors2.length === 4 ? "a" : ""}(${colors2.map((n2, index2) => {
    return index2 < 3 ? parseInt(n2, 16) : Math.round(parseInt(n2, 16) / 255 * 1e3) / 1e3;
  }).join(", ")})` : "";
}
function intToHex(int2) {
  const hex2 = int2.toString(16);
  return hex2.length === 1 ? `0${hex2}` : hex2;
}
function decomposeColor(color2) {
  if (color2.type) {
    return color2;
  }
  if (color2.charAt(0) === "#") {
    return decomposeColor(hexToRgb(color2));
  }
  const marker = color2.indexOf("(");
  const type = color2.substring(0, marker);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${color2}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, _formatMuiErrorMessage2.default)(9, color2));
  }
  let values2 = color2.substring(marker + 1, color2.length - 1);
  let colorSpace;
  if (type === "color") {
    values2 = values2.split(" ");
    colorSpace = values2.shift();
    if (values2.length === 4 && values2[3].charAt(0) === "/") {
      values2[3] = values2[3].slice(1);
    }
    if (["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(colorSpace) === -1) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, _formatMuiErrorMessage2.default)(10, colorSpace));
    }
  } else {
    values2 = values2.split(",");
  }
  values2 = values2.map((value) => parseFloat(value));
  return {
    type,
    values: values2,
    colorSpace
  };
}
const colorChannel = (color2) => {
  const decomposedColor = decomposeColor(color2);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
colorManipulator.colorChannel = colorChannel;
const private_safeColorChannel = (color2, warning2) => {
  try {
    return colorChannel(color2);
  } catch (error) {
    if (warning2 && process.env.NODE_ENV !== "production") {
      console.warn(warning2);
    }
    return color2;
  }
};
colorManipulator.private_safeColorChannel = private_safeColorChannel;
function recomposeColor(color2) {
  const {
    type,
    colorSpace
  } = color2;
  let {
    values: values2
  } = color2;
  if (type.indexOf("rgb") !== -1) {
    values2 = values2.map((n2, i) => i < 3 ? parseInt(n2, 10) : n2);
  } else if (type.indexOf("hsl") !== -1) {
    values2[1] = `${values2[1]}%`;
    values2[2] = `${values2[2]}%`;
  }
  if (type.indexOf("color") !== -1) {
    values2 = `${colorSpace} ${values2.join(" ")}`;
  } else {
    values2 = `${values2.join(", ")}`;
  }
  return `${type}(${values2})`;
}
function rgbToHex(color2) {
  if (color2.indexOf("#") === 0) {
    return color2;
  }
  const {
    values: values2
  } = decomposeColor(color2);
  return `#${values2.map((n2, i) => intToHex(i === 3 ? Math.round(255 * n2) : n2)).join("")}`;
}
function hslToRgb(color2) {
  color2 = decomposeColor(color2);
  const {
    values: values2
  } = color2;
  const h = values2[0];
  const s2 = values2[1] / 100;
  const l = values2[2] / 100;
  const a2 = s2 * Math.min(l, 1 - l);
  const f = (n2, k = (n2 + h / 30) % 12) => l - a2 * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = "rgb";
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color2.type === "hsla") {
    type += "a";
    rgb.push(values2[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
function getLuminance(color2) {
  color2 = decomposeColor(color2);
  let rgb = color2.type === "hsl" || color2.type === "hsla" ? decomposeColor(hslToRgb(color2)).values : color2.values;
  rgb = rgb.map((val) => {
    if (color2.type !== "color") {
      val /= 255;
    }
    return val <= 0.03928 ? val / 12.92 : __pow((val + 0.055) / 1.055, 2.4);
  });
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function alpha$2(color2, value) {
  color2 = decomposeColor(color2);
  value = clampWrapper(value);
  if (color2.type === "rgb" || color2.type === "hsl") {
    color2.type += "a";
  }
  if (color2.type === "color") {
    color2.values[3] = `/${value}`;
  } else {
    color2.values[3] = value;
  }
  return recomposeColor(color2);
}
function private_safeAlpha(color2, value, warning2) {
  try {
    return alpha$2(color2, value);
  } catch (error) {
    if (warning2 && process.env.NODE_ENV !== "production") {
      console.warn(warning2);
    }
    return color2;
  }
}
function darken(color2, coefficient) {
  color2 = decomposeColor(color2);
  coefficient = clampWrapper(coefficient);
  if (color2.type.indexOf("hsl") !== -1) {
    color2.values[2] *= 1 - coefficient;
  } else if (color2.type.indexOf("rgb") !== -1 || color2.type.indexOf("color") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color2);
}
function private_safeDarken(color2, coefficient, warning2) {
  try {
    return darken(color2, coefficient);
  } catch (error) {
    if (warning2 && process.env.NODE_ENV !== "production") {
      console.warn(warning2);
    }
    return color2;
  }
}
function lighten(color2, coefficient) {
  color2 = decomposeColor(color2);
  coefficient = clampWrapper(coefficient);
  if (color2.type.indexOf("hsl") !== -1) {
    color2.values[2] += (100 - color2.values[2]) * coefficient;
  } else if (color2.type.indexOf("rgb") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] += (255 - color2.values[i]) * coefficient;
    }
  } else if (color2.type.indexOf("color") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] += (1 - color2.values[i]) * coefficient;
    }
  }
  return recomposeColor(color2);
}
function private_safeLighten(color2, coefficient, warning2) {
  try {
    return lighten(color2, coefficient);
  } catch (error) {
    if (warning2 && process.env.NODE_ENV !== "production") {
      console.warn(warning2);
    }
    return color2;
  }
}
function emphasize(color2, coefficient = 0.15) {
  return getLuminance(color2) > 0.5 ? darken(color2, coefficient) : lighten(color2, coefficient);
}
function private_safeEmphasize(color2, coefficient, warning2) {
  try {
    return emphasize(color2, coefficient);
  } catch (error) {
    if (warning2 && process.env.NODE_ENV !== "production") {
      console.warn(warning2);
    }
    return color2;
  }
}
function blend(background, overlay, opacity, gamma = 1) {
  const blendChannel = (b, o2) => Math.round(__pow(__pow(b, 1 / gamma) * (1 - opacity) + __pow(o2, 1 / gamma) * opacity, gamma));
  const backgroundColor2 = decomposeColor(background);
  const overlayColor = decomposeColor(overlay);
  const rgb = [blendChannel(backgroundColor2.values[0], overlayColor.values[0]), blendChannel(backgroundColor2.values[1], overlayColor.values[1]), blendChannel(backgroundColor2.values[2], overlayColor.values[2])];
  return recomposeColor({
    type: "rgb",
    values: rgb
  });
}
const common = {
  black: "#000",
  white: "#fff"
};
const common$1 = common;
const grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
const grey$1 = grey;
const purple = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
};
const purple$1 = purple;
const red = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
};
const red$1 = red;
const orange = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
};
const orange$1 = orange;
const blue = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
};
const blue$1 = blue;
const lightBlue = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
};
const lightBlue$1 = lightBlue;
const green = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
const green$1 = green;
const _excluded$a = ["mode", "contrastThreshold", "tonalOffset"];
const light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$1.white,
    default: common$1.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = {
  text: {
    primary: common$1.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: common$1.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === "light") {
      intent.light = lighten_1(intent.main, tonalOffsetLight);
    } else if (direction === "dark") {
      intent.dark = darken_1(intent.main, tonalOffsetDark);
    }
  }
}
function getDefaultPrimary(mode2 = "light") {
  if (mode2 === "dark") {
    return {
      main: blue$1[200],
      light: blue$1[50],
      dark: blue$1[400]
    };
  }
  return {
    main: blue$1[700],
    light: blue$1[400],
    dark: blue$1[800]
  };
}
function getDefaultSecondary(mode2 = "light") {
  if (mode2 === "dark") {
    return {
      main: purple$1[200],
      light: purple$1[50],
      dark: purple$1[400]
    };
  }
  return {
    main: purple$1[500],
    light: purple$1[300],
    dark: purple$1[700]
  };
}
function getDefaultError(mode2 = "light") {
  if (mode2 === "dark") {
    return {
      main: red$1[500],
      light: red$1[300],
      dark: red$1[700]
    };
  }
  return {
    main: red$1[700],
    light: red$1[400],
    dark: red$1[800]
  };
}
function getDefaultInfo(mode2 = "light") {
  if (mode2 === "dark") {
    return {
      main: lightBlue$1[400],
      light: lightBlue$1[300],
      dark: lightBlue$1[700]
    };
  }
  return {
    main: lightBlue$1[700],
    light: lightBlue$1[500],
    dark: lightBlue$1[900]
  };
}
function getDefaultSuccess(mode2 = "light") {
  if (mode2 === "dark") {
    return {
      main: green$1[400],
      light: green$1[300],
      dark: green$1[700]
    };
  }
  return {
    main: green$1[800],
    light: green$1[500],
    dark: green$1[900]
  };
}
function getDefaultWarning(mode2 = "light") {
  if (mode2 === "dark") {
    return {
      main: orange$1[400],
      light: orange$1[300],
      dark: orange$1[700]
    };
  }
  return {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange$1[500],
    dark: orange$1[900]
  };
}
function createPalette(palette) {
  const {
    mode: mode2 = "light",
    contrastThreshold = 3,
    tonalOffset = 0.2
  } = palette, other = _objectWithoutPropertiesLoose(palette, _excluded$a);
  const primary = palette.primary || getDefaultPrimary(mode2);
  const secondary = palette.secondary || getDefaultSecondary(mode2);
  const error = palette.error || getDefaultError(mode2);
  const info = palette.info || getDefaultInfo(mode2);
  const success = palette.success || getDefaultSuccess(mode2);
  const warning2 = palette.warning || getDefaultWarning(mode2);
  function getContrastText(background) {
    const contrastText = getContrastRatio_1(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const contrast = getContrastRatio_1(background, contrastText);
      if (contrast < 3) {
        console.error([`MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join("\n"));
      }
    }
    return contrastText;
  }
  const augmentColor = ({
    color: color2,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color2 = _extends$2({}, color2);
    if (!color2.main && color2[mainShade]) {
      color2.main = color2[mainShade];
    }
    if (!color2.hasOwnProperty("main")) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${mainShade}\` property.` : formatMuiErrorMessage$1(11, name ? ` (${name})` : "", mainShade));
    }
    if (typeof color2.main !== "string") {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(color2.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage$1(12, name ? ` (${name})` : "", JSON.stringify(color2.main)));
    }
    addLightOrDark(color2, "light", lightShade, tonalOffset);
    addLightOrDark(color2, "dark", darkShade, tonalOffset);
    if (!color2.contrastText) {
      color2.contrastText = getContrastText(color2.main);
    }
    return color2;
  };
  const modes = {
    dark,
    light
  };
  if (process.env.NODE_ENV !== "production") {
    if (!modes[mode2]) {
      console.error(`MUI: The palette mode \`${mode2}\` is not supported.`);
    }
  }
  const paletteOutput = deepmerge(_extends$2({
    // A collection of common colors.
    common: _extends$2({}, common$1),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: mode2,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning2,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: "success"
    }),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, modes[mode2]), other);
  return paletteOutput;
}
const _excluded$9 = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round$2(value) {
  return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette, typography) {
  const _ref = typeof typography === "function" ? typography(palette) : typography, {
    fontFamily = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize = 14,
    // px
    fontWeightLight = 300,
    fontWeightRegular = 400,
    fontWeightMedium = 500,
    fontWeightBold = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16,
    // Apply the CSS properties to all the variants.
    allVariants,
    pxToRem: pxToRem2
  } = _ref, other = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  if (process.env.NODE_ENV !== "production") {
    if (typeof fontSize !== "number") {
      console.error("MUI: `fontSize` is required to be a number.");
    }
    if (typeof htmlFontSize !== "number") {
      console.error("MUI: `htmlFontSize` is required to be a number.");
    }
  }
  const coef = fontSize / 14;
  const pxToRem = pxToRem2 || ((size) => `${size / htmlFontSize * coef}rem`);
  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => _extends$2({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight
  }, fontFamily === defaultFontFamily ? {
    letterSpacing: `${round$2(letterSpacing / size)}em`
  } : {}, casing, allVariants);
  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge(_extends$2({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px2) {
  return [`${px2[0]}px ${px2[1]}px ${px2[2]}px ${px2[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px2[4]}px ${px2[5]}px ${px2[6]}px ${px2[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px2[8]}px ${px2[9]}px ${px2[10]}px ${px2[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
const shadows$1 = shadows;
const _excluded$8 = ["duration", "easing", "delay"];
const easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height2) {
  if (!height2) {
    return 0;
  }
  const constant = height2 / 36;
  return Math.round((4 + 15 * __pow(constant, 0.25) + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
  const mergedEasing = _extends$2({}, easing, inputTransitions.easing);
  const mergedDuration = _extends$2({}, duration, inputTransitions.duration);
  const create2 = (props = ["all"], options = {}) => {
    const {
      duration: durationOption = mergedDuration.standard,
      easing: easingOption = mergedEasing.easeInOut,
      delay: delay2 = 0
    } = options, other = _objectWithoutPropertiesLoose(options, _excluded$8);
    if (process.env.NODE_ENV !== "production") {
      const isString2 = (value) => typeof value === "string";
      const isNumber = (value) => !isNaN(parseFloat(value));
      if (!isString2(props) && !Array.isArray(props)) {
        console.error('MUI: Argument "props" must be a string or Array.');
      }
      if (!isNumber(durationOption) && !isString2(durationOption)) {
        console.error(`MUI: Argument "duration" must be a number or a string but found ${durationOption}.`);
      }
      if (!isString2(easingOption)) {
        console.error('MUI: Argument "easing" must be a string.');
      }
      if (!isNumber(delay2) && !isString2(delay2)) {
        console.error('MUI: Argument "delay" must be a number or a string.');
      }
      if (typeof options !== "object") {
        console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join("\n"));
      }
      if (Object.keys(other).length !== 0) {
        console.error(`MUI: Unrecognized argument(s) [${Object.keys(other).join(",")}].`);
      }
    }
    return (Array.isArray(props) ? props : [props]).map((animatedProp) => `${animatedProp} ${typeof durationOption === "string" ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay2 === "string" ? delay2 : formatMs(delay2)}`).join(",");
  };
  return _extends$2({
    getAutoHeightDuration,
    create: create2
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
const zIndex$1 = zIndex;
const _excluded$7 = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function createTheme(options = {}, ...args) {
  const {
    mixins: mixinsInput = {},
    palette: paletteInput = {},
    transitions: transitionsInput = {},
    typography: typographyInput = {}
  } = options, other = _objectWithoutPropertiesLoose(options, _excluded$7);
  if (options.vars) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`vars\` is a private field used for CSS variables support.
Please use another name.` : formatMuiErrorMessage$1(18));
  }
  const palette = createPalette(paletteInput);
  const systemTheme = createTheme$1(options);
  let muiTheme = deepmerge(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows$1.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: _extends$2({}, zIndex$1)
  });
  muiTheme = deepmerge(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  if (process.env.NODE_ENV !== "production") {
    const stateClasses = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"];
    const traverse = (node2, component) => {
      let key;
      for (key in node2) {
        const child = node2[key];
        if (stateClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const stateClass = generateUtilityClass$1("", key);
            console.error([`MUI: The \`${component}\` component increases the CSS specificity of the \`${key}\` internal state.`, "You can not override it like this: ", JSON.stringify(node2, null, 2), "", `Instead, you need to use the '&.${stateClass}' syntax:`, JSON.stringify({
              root: {
                [`&.${stateClass}`]: child
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join("\n"));
          }
          node2[key] = {};
        }
      }
    };
    Object.keys(muiTheme.components).forEach((component) => {
      const styleOverrides = muiTheme.components[component].styleOverrides;
      if (styleOverrides && component.indexOf("Mui") === 0) {
        traverse(styleOverrides, component);
      }
    });
  }
  muiTheme.unstable_sxConfig = _extends$2({}, defaultSxConfig$1, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$1({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
const defaultTheme = createTheme();
const defaultTheme$1 = defaultTheme;
const THEME_ID = "$$material";
function useTheme() {
  const theme = useTheme$1(defaultTheme$1);
  if (process.env.NODE_ENV !== "production") {
    React.useDebugValue(theme);
  }
  return theme[THEME_ID] || theme;
}
const reflow = (node2) => node2.scrollTop;
function getTransitionProps(props, options) {
  var _style$transitionDura, _style$transitionTimi;
  const {
    timeout: timeout2,
    easing: easing2,
    style: style2 = {}
  } = props;
  return {
    duration: (_style$transitionDura = style2.transitionDuration) != null ? _style$transitionDura : typeof timeout2 === "number" ? timeout2 : timeout2[options.mode] || 0,
    easing: (_style$transitionTimi = style2.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing2 === "object" ? easing2[options.mode] : easing2,
    delay: style2.transitionDelay
  };
}
const _excluded$6 = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
const styles$1 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
const Fade = /* @__PURE__ */ React.forwardRef(function Fade2(props, ref) {
  const theme = useTheme();
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
    addEndListener,
    appear = true,
    children,
    easing: easing2,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style: style2,
    timeout: timeout2 = defaultTimeout,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Transition$1
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$6);
  const nodeRef = React.useRef(null);
  const handleRef = useForkRef(nodeRef, children.ref, ref);
  const normalizedTransitionCallback = (callback) => (maybeIsAppearing) => {
    if (callback) {
      const node2 = nodeRef.current;
      if (maybeIsAppearing === void 0) {
        callback(node2);
      } else {
        callback(node2, maybeIsAppearing);
      }
    }
  };
  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node2, isAppearing) => {
    reflow(node2);
    const transitionProps = getTransitionProps({
      style: style2,
      timeout: timeout2,
      easing: easing2
    }, {
      mode: "enter"
    });
    node2.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
    node2.style.transition = theme.transitions.create("opacity", transitionProps);
    if (onEnter) {
      onEnter(node2, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback((node2) => {
    const transitionProps = getTransitionProps({
      style: style2,
      timeout: timeout2,
      easing: easing2
    }, {
      mode: "exit"
    });
    node2.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
    node2.style.transition = theme.transitions.create("opacity", transitionProps);
    if (onExit) {
      onExit(node2);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleAddEndListener = (next2) => {
    if (addEndListener) {
      addEndListener(nodeRef.current, next2);
    }
  };
  return /* @__PURE__ */ jsx(TransitionComponent, _extends$2({
    appear,
    in: inProp,
    nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout2
  }, other, {
    children: (state, childProps) => {
      return /* @__PURE__ */ React.cloneElement(children, _extends$2({
        style: _extends$2({
          opacity: 0,
          visibility: state === "exited" && !inProp ? "hidden" : void 0
        }, styles$1[state], style2, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Fade.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
const Fade$1 = Fade;
const Modal2 = ({
  title,
  children,
  onClose,
  isOpen,
  style: style2,
  showCloseIcon
}) => {
  return /* @__PURE__ */ jsx(Modal$1, { onClose, "aria-labelledby": "unstyled-modal-title", "aria-describedby": "unstyled-modal-description", open: isOpen, className: "fixed z-40 inset-0 justify-center flex sm:pb-7 sm:pt-11 items-center", slots: {
    backdrop: Backdrop
  }, children: /* @__PURE__ */ jsx(Fade$1, { in: isOpen, children: /* @__PURE__ */ jsxs("div", __spreadProps(__spreadValues({ className: "text-black bg-white w-full h-full sm:w-130 sm:h-auto sm:rounded-3xl outline-0 flex flex-col gap-4 relative" }, style2 ? {
    style: style2
  } : {}), { children: [
    showCloseIcon && /* @__PURE__ */ jsx("button", { "aria-label": "close", className: "shadow-none transition absolute mt-6 mr-8 z-10 hover:opacity-50 hover:bg-neutral-300 rounded-full p-2 right-0", onClick: onClose, children: /* @__PURE__ */ jsx(ModalClose, { fill: "#777777" }) }),
    title && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("div", { className: "flex px-3 pt-2 sm:px-8 sm:pt-6", children: /* @__PURE__ */ jsx("div", { className: "text-black text-xl font-semibold", children: title }) }) }),
    /* @__PURE__ */ jsx("div", { className: "px-3 sm:px-8 overflow-y-auto", children })
  ] })) }) });
};
const Backdrop = forwardRef((props, ref) => {
  const _a = props, {
    className,
    open
  } = _a, other = __objRest(_a, [
    "className",
    "open"
  ]);
  return /* @__PURE__ */ jsx(Fade$1, { in: open, children: /* @__PURE__ */ jsx("div", __spreadValues({ className: `inset-0 fixed -z-10 bg-black opacity-50 ${className}`, ref }, other)) });
});
Backdrop.displayName = "Backdrop";
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto$2 = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto$2]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName$1(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow$1(node2) {
  if (node2 == null) {
    return window;
  }
  if (node2.toString() !== "[object Window]") {
    var ownerDocument2 = node2.ownerDocument;
    return ownerDocument2 ? ownerDocument2.defaultView || window : window;
  }
  return node2;
}
function isElement$1(node2) {
  var OwnElement = getWindow$1(node2).Element;
  return node2 instanceof OwnElement || node2 instanceof Element;
}
function isHTMLElement$2(node2) {
  var OwnElement = getWindow$1(node2).HTMLElement;
  return node2 instanceof OwnElement || node2 instanceof HTMLElement;
}
function isShadowRoot$1(node2) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow$1(node2).ShadowRoot;
  return node2 instanceof OwnElement || node2 instanceof ShadowRoot;
}
function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function(name) {
    var style2 = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement$2(element) || !getNodeName$1(element)) {
      return;
    }
    Object.assign(element.style, style2);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style2 = styleProperties.reduce(function(style3, property) {
        style3[property] = "";
        return style3;
      }, {});
      if (!isHTMLElement$2(element) || !getNodeName$1(element)) {
        return;
      }
      Object.assign(element.style, style2);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max$1 = Math.max;
var min$1 = Math.min;
var round$1 = Math.round;
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function(item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect$1(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement$2(element)) {
    scaleX = element.offsetWidth > 0 ? round$1(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$1(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement$1(element) ? getWindow$1(element) : window, visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x2 = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width2 = clientRect.width / scaleX;
  var height2 = clientRect.height / scaleY;
  return {
    width: width2,
    height: height2,
    top: y,
    right: x2 + width2,
    bottom: y + height2,
    left: x2,
    x: x2,
    y
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect$1(element);
  var width2 = element.offsetWidth;
  var height2 = element.offsetHeight;
  if (Math.abs(clientRect.width - width2) <= 1) {
    width2 = clientRect.width;
  }
  if (Math.abs(clientRect.height - height2) <= 1) {
    height2 = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width2,
    height: height2
  };
}
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot$1(rootNode)) {
    var next2 = child;
    do {
      if (next2 && parent.isSameNode(next2)) {
        return true;
      }
      next2 = next2.parentNode || next2.host;
    } while (next2);
  }
  return false;
}
function getComputedStyle$4(element) {
  return getWindow$1(element).getComputedStyle(element);
}
function isTableElement$1(element) {
  return ["table", "td", "th"].indexOf(getNodeName$1(element)) >= 0;
}
function getDocumentElement$1(element) {
  return ((isElement$1(element) ? element.ownerDocument : (
    // $FlowFixMe[prop-missing]
    element.document
  )) || window.document).documentElement;
}
function getParentNode$1(element) {
  if (getNodeName$1(element) === "html") {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    (isShadowRoot$1(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement$1(element)
  );
}
function getTrueOffsetParent$1(element) {
  if (!isHTMLElement$2(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$4(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock$1(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement$2(element)) {
    var elementCss = getComputedStyle$4(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode$1(element);
  if (isShadowRoot$1(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement$2(currentNode) && ["html", "body"].indexOf(getNodeName$1(currentNode)) < 0) {
    var css = getComputedStyle$4(currentNode);
    if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || ["transform", "perspective"].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent$1(element) {
  var window2 = getWindow$1(element);
  var offsetParent = getTrueOffsetParent$1(element);
  while (offsetParent && isTableElement$1(offsetParent) && getComputedStyle$4(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent$1(offsetParent);
  }
  if (offsetParent && (getNodeName$1(offsetParent) === "html" || getNodeName$1(offsetParent) === "body" && getComputedStyle$4(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock$1(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min2, value, max2) {
  return max$1(min2, min$1(value, max2));
}
function withinMaxClamp(min2, value, max2) {
  var v = within(min2, value, max2);
  return v > max2 ? max2 : v;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys) {
  return keys.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding2, state) {
  padding2 = typeof padding2 === "function" ? padding2(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding2;
  return mergePaddingObject(typeof padding2 !== "number" ? padding2 : expandToHashMap(padding2, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state, name = _ref.name, options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent$1(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state, options = _ref2.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
const arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref, win) {
  var x2 = _ref.x, y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$1(x2 * dpr) / dpr || 0,
    y: round$1(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position2 = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x2 = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x: x2,
    y
  }) : {
    x: x2,
    y
  };
  x2 = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent$1(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow$1(popper2)) {
      offsetParent = getDocumentElement$1(popper2);
      if (getComputedStyle$4(offsetParent).position !== "static" && position2 === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        offsetParent[heightProp]
      );
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        offsetParent[widthProp]
      );
      x2 -= offsetX - popperRect.width;
      x2 *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position2
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x2,
    y
  }, getWindow$1(popper2)) : {
    x: x2,
    y
  };
  x2 = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x2 + "px, " + y + "px)" : "translate3d(" + x2 + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x2 + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state, instance = _ref.instance, options = _ref.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow$1(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement$1(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function getWindowScroll(node2) {
  var win = getWindow$1(node2);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX$1(element) {
  return getBoundingClientRect$1(getDocumentElement$1(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect$1(element, strategy) {
  var win = getWindow$1(element);
  var html = getDocumentElement$1(element);
  var visualViewport = win.visualViewport;
  var width2 = html.clientWidth;
  var height2 = html.clientHeight;
  var x2 = 0;
  var y = 0;
  if (visualViewport) {
    width2 = visualViewport.width;
    height2 = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width: width2,
    height: height2,
    x: x2 + getWindowScrollBarX$1(element),
    y
  };
}
function getDocumentRect$1(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement$1(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width2 = max$1(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height2 = max$1(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x2 = -winScroll.scrollLeft + getWindowScrollBarX$1(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle$4(body || html).direction === "rtl") {
    x2 += max$1(html.clientWidth, body ? body.clientWidth : 0) - width2;
  }
  return {
    width: width2,
    height: height2,
    x: x2,
    y
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$4(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node2) {
  if (["html", "body", "#document"].indexOf(getNodeName$1(node2)) >= 0) {
    return node2.ownerDocument.body;
  }
  if (isHTMLElement$2(node2) && isScrollParent(node2)) {
    return node2;
  }
  return getScrollParent(getParentNode$1(node2));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow$1(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode$1(target)))
  );
}
function rectToClientRect$1(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect$1(element, strategy) {
  var rect = getBoundingClientRect$1(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect$1(getViewportRect$1(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect$1(clippingParent, strategy) : rectToClientRect$1(getDocumentRect$1(getDocumentElement$1(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode$1(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle$4(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement$2(element) ? getOffsetParent$1(element) : element;
  if (!isElement$1(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName$1(clippingParent) !== "body";
  });
}
function getClippingRect$1(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max$1(rect.top, accRect.top);
    accRect.right = min$1(rect.right, accRect.right);
    accRect.bottom = min$1(rect.bottom, accRect.bottom);
    accRect.left = max$1(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref) {
  var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow$1(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding2 = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding2 !== "number" ? padding2 : expandToHashMap(padding2, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect$1(isElement$1(element) ? element : element.contextElement || getDocumentElement$1(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect$1(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect$1(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding2 = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow$1(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding: padding2
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a2, b) {
    return overflows[a2] - overflows[b];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto$2) {
    return [];
  }
  var oppositePlacement = getOppositePlacement$1(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip$3(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding2 = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement$1(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto$2 ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding: padding2,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow$1(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding: padding2
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement$1(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement$1(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
const flip$4 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip$3,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state, name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow$1(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow$1(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
const hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref[0], distance2 = _ref[1];
  skidding = skidding || 0;
  distance2 = (distance2 || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance2,
    y: skidding
  } : {
    x: skidding,
    y: distance2
  };
}
function offset$3(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x2 = _data$state$placement.x, y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x2;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
const offset$4 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset$3
};
function popperOffsets(_ref) {
  var state = _ref.state, name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding2 = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow$1(state, {
    boundary,
    rootBoundary,
    padding: padding2,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min2 = offset2 + overflow[mainSide];
    var max2 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent$1(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min$1(min2, tetherMin) : min2, offset2, tether ? max$1(max2, tetherMax) : max2);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll$1(node2) {
  if (node2 === getWindow$1(node2) || !isHTMLElement$2(node2)) {
    return getWindowScroll(node2);
  } else {
    return getHTMLElementScroll(node2);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$1(rect.width) / element.offsetWidth || 1;
  var scaleY = round$1(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement$2(offsetParent);
  var offsetParentIsScaled = isHTMLElement$2(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement$1(offsetParent);
  var rect = getBoundingClientRect$1(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName$1(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll$1(offsetParent);
    }
    if (isHTMLElement$2(offsetParent)) {
      offsets = getBoundingClientRect$1(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX$1(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce$2(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement$1(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent$1(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$2(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref) {
        var name = _ref.name, _ref$options = _ref.options, options2 = _ref$options === void 0 ? {} : _ref$options, effect2 = _ref.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$4, flip$4, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
const COMPONENT_NAME$5 = "Popper";
function getPopperUtilityClass(slot) {
  return generateUtilityClass(COMPONENT_NAME$5, slot);
}
generateUtilityClasses(COMPONENT_NAME$5, ["root"]);
const _excluded$5 = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], _excluded2 = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function flipPlacement(placement, direction) {
  if (direction === "ltr") {
    return placement;
  }
  switch (placement) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return placement;
  }
}
function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function isHTMLElement$1(element) {
  return element.nodeType !== void 0;
}
function isVirtualElement(element) {
  return !isHTMLElement$1(element);
}
const useUtilityClasses$5 = () => {
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, useClassNamesOverride(getPopperUtilityClass));
};
const defaultPopperOptions = {};
const PopperTooltip = /* @__PURE__ */ React.forwardRef(function PopperTooltip2(props, forwardedRef) {
  var _slots$root;
  const {
    anchorEl,
    children,
    direction,
    disablePortal,
    modifiers,
    open,
    placement: initialPlacement,
    popperOptions,
    popperRef: popperRefProp,
    slotProps = {},
    slots = {},
    TransitionProps
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$5);
  const tooltipRef = React.useRef(null);
  const ownRef = useForkRef(tooltipRef, forwardedRef);
  const popperRef = React.useRef(null);
  const handlePopperRef = useForkRef(popperRef, popperRefProp);
  const handlePopperRefRef = React.useRef(handlePopperRef);
  useEnhancedEffect$1(() => {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  React.useImperativeHandle(popperRefProp, () => popperRef.current, []);
  const rtlPlacement = flipPlacement(initialPlacement, direction);
  const [placement, setPlacement] = React.useState(rtlPlacement);
  const [resolvedAnchorElement, setResolvedAnchorElement] = React.useState(resolveAnchorEl(anchorEl));
  React.useEffect(() => {
    if (popperRef.current) {
      popperRef.current.forceUpdate();
    }
  });
  React.useEffect(() => {
    if (anchorEl) {
      setResolvedAnchorElement(resolveAnchorEl(anchorEl));
    }
  }, [anchorEl]);
  useEnhancedEffect$1(() => {
    if (!resolvedAnchorElement || !open) {
      return void 0;
    }
    const handlePopperUpdate = (data) => {
      setPlacement(data.placement);
    };
    if (process.env.NODE_ENV !== "production") {
      if (resolvedAnchorElement && isHTMLElement$1(resolvedAnchorElement) && resolvedAnchorElement.nodeType === 1) {
        const box = resolvedAnchorElement.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join("\n"));
        }
      }
    }
    let popperModifiers = [{
      name: "preventOverflow",
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: "flip",
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: "onUpdate",
      enabled: true,
      phase: "afterWrite",
      fn: ({
        state
      }) => {
        handlePopperUpdate(state);
      }
    }];
    if (modifiers != null) {
      popperModifiers = popperModifiers.concat(modifiers);
    }
    if (popperOptions && popperOptions.modifiers != null) {
      popperModifiers = popperModifiers.concat(popperOptions.modifiers);
    }
    const popper2 = createPopper(resolvedAnchorElement, tooltipRef.current, _extends$2({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: popperModifiers
    }));
    handlePopperRefRef.current(popper2);
    return () => {
      popper2.destroy();
      handlePopperRefRef.current(null);
    };
  }, [resolvedAnchorElement, disablePortal, modifiers, open, popperOptions, rtlPlacement]);
  const childProps = {
    placement
  };
  if (TransitionProps !== null) {
    childProps.TransitionProps = TransitionProps;
  }
  const classes = useUtilityClasses$5();
  const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    additionalProps: {
      role: "tooltip",
      ref: ownRef
    },
    ownerState: props,
    className: classes.root
  });
  return /* @__PURE__ */ jsx(Root, _extends$2({}, rootProps, {
    children: typeof children === "function" ? children(childProps) : children
  }));
});
const Popper$1 = /* @__PURE__ */ React.forwardRef(function Popper(props, forwardedRef) {
  const {
    anchorEl,
    children,
    container: containerProp,
    direction = "ltr",
    disablePortal = false,
    keepMounted = false,
    modifiers,
    open,
    placement = "bottom",
    popperOptions = defaultPopperOptions,
    popperRef,
    style: style2,
    transition = false,
    slotProps = {},
    slots = {}
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded2);
  const [exited, setExited] = React.useState(true);
  const handleEnter = () => {
    setExited(false);
  };
  const handleExited = () => {
    setExited(true);
  };
  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }
  let container;
  if (containerProp) {
    container = containerProp;
  } else if (anchorEl) {
    const resolvedAnchorEl = resolveAnchorEl(anchorEl);
    container = resolvedAnchorEl && isHTMLElement$1(resolvedAnchorEl) ? ownerDocument(resolvedAnchorEl).body : ownerDocument(null).body;
  }
  const display = !open && keepMounted && (!transition || exited) ? "none" : void 0;
  const transitionProps = transition ? {
    in: open,
    onEnter: handleEnter,
    onExited: handleExited
  } : void 0;
  return /* @__PURE__ */ jsx(Portal, {
    disablePortal,
    container,
    children: /* @__PURE__ */ jsx(PopperTooltip, _extends$2({
      anchorEl,
      direction,
      disablePortal,
      modifiers,
      ref: forwardedRef,
      open: transition ? !exited : open,
      placement,
      popperOptions,
      popperRef,
      slotProps,
      slots
    }, other, {
      style: _extends$2({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display
      }, style2),
      TransitionProps: transitionProps,
      children
    }))
  });
});
process.env.NODE_ENV !== "production" ? Popper$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), (props) => {
    if (props.open) {
      const resolvedAnchorEl = resolveAnchorEl(props.anchorEl);
      if (resolvedAnchorEl && isHTMLElement$1(resolvedAnchorEl) && resolvedAnchorEl.nodeType === 1) {
        const box = resolvedAnchorEl.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join("\n"));
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.getBoundingClientRect !== "function" || isVirtualElement(resolvedAnchorEl) && resolvedAnchorEl.contextElement != null && resolvedAnchorEl.contextElement.nodeType !== 1) {
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join("\n"));
      }
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: PropTypes.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType$1,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
} : void 0;
const Popper2 = (_U) => {
  var _V = _U, {
    children,
    className = "",
    id: idProp,
    content,
    popperStyle,
    isDark,
    placement,
    isPointer = true,
    isActive = true
  } = _V, rest = __objRest(_V, [
    "children",
    "className",
    "id",
    "content",
    "popperStyle",
    "isDark",
    "placement",
    "isPointer",
    "isActive"
  ]);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleHover = (event) => {
    isActive && setAnchorEl(event.currentTarget);
  };
  const handleBlur2 = () => {
    isActive && setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id2 = open ? idProp : void 0;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Popper$1, { id: id2, open, anchorEl, className: "z-50", transition: true, placement, children: ({
      TransitionProps
    }) => {
      return /* @__PURE__ */ jsx(Fade$1, __spreadProps(__spreadValues({}, TransitionProps), { timeout: 350, children: /* @__PURE__ */ jsx("div", { className: `rounded-lg py-2 px-2.5 shadow-md ${!isDark ? "border text-black bg-white" : "text-white bg-black"} ${popperStyle ? popperStyle : ""}`, children: content }) }));
    } }),
    /* @__PURE__ */ jsx("div", __spreadProps(__spreadValues({ "aria-describedby": id2, className: `outline-0 ${className} ${isPointer ? " cursor-pointer" : ""}`, onMouseEnter: handleHover, onMouseLeave: handleBlur2, style: {
      backgroundImage: "none"
    } }, rest), { children }))
  ] });
};
function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}
function clickedRootScrollbar(event, doc) {
  return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
function ClickAwayListener(props) {
  const {
    children,
    disableReactTree = false,
    mouseEvent = "onClick",
    onClickAway,
    touchEvent = "onTouchEnd"
  } = props;
  const movedRef = React.useRef(false);
  const nodeRef = React.useRef(null);
  const activatedRef = React.useRef(false);
  const syntheticEventRef = React.useRef(false);
  React.useEffect(() => {
    setTimeout(() => {
      activatedRef.current = true;
    }, 0);
    return () => {
      activatedRef.current = false;
    };
  }, []);
  const handleRef = useForkRef(
    // @ts-expect-error TODO upstream fix
    children.ref,
    nodeRef
  );
  const handleClickAway = useEventCallback((event) => {
    const insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    const doc = ownerDocument(nodeRef.current);
    if (!activatedRef.current || !nodeRef.current || "clientX" in event && clickedRootScrollbar(event, doc)) {
      return;
    }
    if (movedRef.current) {
      movedRef.current = false;
      return;
    }
    let insideDOM;
    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains(
        // @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target
      ) || nodeRef.current.contains(
        // @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target
      );
    }
    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  });
  const createHandleSynthetic = (handlerName) => (event) => {
    syntheticEventRef.current = true;
    const childrenPropsHandler = children.props[handlerName];
    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };
  const childrenProps = {
    ref: handleRef
  };
  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }
  React.useEffect(() => {
    if (touchEvent !== false) {
      const mappedTouchEvent = mapEventPropToEvent(touchEvent);
      const doc = ownerDocument(nodeRef.current);
      const handleTouchMove = () => {
        movedRef.current = true;
      };
      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener("touchmove", handleTouchMove);
      return () => {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener("touchmove", handleTouchMove);
      };
    }
    return void 0;
  }, [handleClickAway, touchEvent]);
  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }
  React.useEffect(() => {
    if (mouseEvent !== false) {
      const mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      const doc = ownerDocument(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return () => {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }
    return void 0;
  }, [handleClickAway, mouseEvent]);
  return /* @__PURE__ */ jsx(React.Fragment, {
    children: /* @__PURE__ */ React.cloneElement(children, childrenProps)
  });
}
process.env.NODE_ENV !== "production" ? ClickAwayListener.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: PropTypes.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: PropTypes.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", false]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: PropTypes.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: PropTypes.oneOf(["onTouchEnd", "onTouchStart", false])
} : void 0;
if (process.env.NODE_ENV !== "production") {
  ClickAwayListener["propTypes"] = exactProp(ClickAwayListener.propTypes);
}
const COMPONENT_NAME$4 = "Snackbar";
function getSnackbarUtilityClass(slot) {
  return generateUtilityClass(COMPONENT_NAME$4, slot);
}
generateUtilityClasses(COMPONENT_NAME$4, ["root"]);
function useSnackbar(parameters = {}) {
  const {
    autoHideDuration = null,
    disableWindowBlurListener = false,
    onClose,
    open,
    resumeHideDuration
  } = parameters;
  const timerAutoHide = useTimeout();
  React.useEffect(() => {
    if (!open) {
      return void 0;
    }
    function handleKeyDown2(nativeEvent) {
      if (!nativeEvent.defaultPrevented) {
        if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") {
          onClose == null || onClose(nativeEvent, "escapeKeyDown");
        }
      }
    }
    document.addEventListener("keydown", handleKeyDown2);
    return () => {
      document.removeEventListener("keydown", handleKeyDown2);
    };
  }, [open, onClose]);
  const handleClose = useEventCallback((event, reason) => {
    onClose == null || onClose(event, reason);
  });
  const setAutoHideTimer = useEventCallback((autoHideDurationParam) => {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }
    timerAutoHide.start(autoHideDurationParam, () => {
      handleClose(null, "timeout");
    });
  });
  React.useEffect(() => {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }
    return timerAutoHide.clear;
  }, [open, autoHideDuration, setAutoHideTimer, timerAutoHide]);
  const handleClickAway = (event) => {
    onClose == null || onClose(event, "clickaway");
  };
  const handlePause = timerAutoHide.clear;
  const handleResume = React.useCallback(() => {
    if (autoHideDuration != null) {
      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);
  const createHandleBlur = (otherHandlers) => (event) => {
    const onBlurCallback = otherHandlers.onBlur;
    onBlurCallback == null || onBlurCallback(event);
    handleResume();
  };
  const createHandleFocus = (otherHandlers) => (event) => {
    const onFocusCallback = otherHandlers.onFocus;
    onFocusCallback == null || onFocusCallback(event);
    handlePause();
  };
  const createMouseEnter = (otherHandlers) => (event) => {
    const onMouseEnterCallback = otherHandlers.onMouseEnter;
    onMouseEnterCallback == null || onMouseEnterCallback(event);
    handlePause();
  };
  const createMouseLeave = (otherHandlers) => (event) => {
    const onMouseLeaveCallback = otherHandlers.onMouseLeave;
    onMouseLeaveCallback == null || onMouseLeaveCallback(event);
    handleResume();
  };
  React.useEffect(() => {
    if (!disableWindowBlurListener && open) {
      window.addEventListener("focus", handleResume);
      window.addEventListener("blur", handlePause);
      return () => {
        window.removeEventListener("focus", handleResume);
        window.removeEventListener("blur", handlePause);
      };
    }
    return void 0;
  }, [disableWindowBlurListener, open, handleResume, handlePause]);
  const getRootProps = (externalProps = {}) => {
    const externalEventHandlers = _extends$2({}, extractEventHandlers(parameters), extractEventHandlers(externalProps));
    return _extends$2({
      // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
      // See https://github.com/mui/material-ui/issues/29080
      role: "presentation"
    }, externalProps, externalEventHandlers, {
      onBlur: createHandleBlur(externalEventHandlers),
      onFocus: createHandleFocus(externalEventHandlers),
      onMouseEnter: createMouseEnter(externalEventHandlers),
      onMouseLeave: createMouseLeave(externalEventHandlers)
    });
  };
  return {
    getRootProps,
    onClickAway: handleClickAway
  };
}
const _excluded$4 = ["autoHideDuration", "children", "disableWindowBlurListener", "exited", "onBlur", "onClose", "onFocus", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "slotProps", "slots"];
const useUtilityClasses$4 = () => {
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, useClassNamesOverride(getSnackbarUtilityClass));
};
const Snackbar$1 = /* @__PURE__ */ React.forwardRef(function Snackbar(props, forwardedRef) {
  const {
    autoHideDuration = null,
    children,
    disableWindowBlurListener = false,
    exited = true,
    onClose,
    open,
    resumeHideDuration,
    slotProps = {},
    slots = {}
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$4);
  const classes = useUtilityClasses$4();
  const {
    getRootProps,
    onClickAway
  } = useSnackbar(_extends$2({}, props, {
    autoHideDuration,
    disableWindowBlurListener,
    onClose,
    open,
    resumeHideDuration
  }));
  const ownerState = props;
  const Root = slots.root || "div";
  const rootProps = useSlotProps({
    elementType: Root,
    getSlotProps: getRootProps,
    externalForwardedProps: other,
    externalSlotProps: slotProps.root,
    additionalProps: {
      ref: forwardedRef
    },
    ownerState,
    className: classes.root
  });
  const clickAwayListenerProps = useSlotProps({
    elementType: ClickAwayListener,
    externalSlotProps: slotProps.clickAwayListener,
    additionalProps: {
      onClickAway
    },
    ownerState
  });
  delete clickAwayListenerProps.ownerState;
  if (!open && exited) {
    return null;
  }
  return /* @__PURE__ */ jsx(ClickAwayListener, _extends$2({}, clickAwayListenerProps, {
    children: /* @__PURE__ */ jsx(Root, _extends$2({}, rootProps, {
      children
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Snackbar$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   * @default null
   */
  autoHideDuration: PropTypes.number,
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   * @default false
   */
  disableWindowBlurListener: PropTypes.bool,
  /**
   * The prop used to handle exited transition and unmount the component.
   * @default true
   */
  exited: PropTypes.bool,
  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: PropTypes.number,
  /**
   * The props used for each slot inside the Snackbar.
   * @default {}
   */
  slotProps: PropTypes.shape({
    clickAwayListener: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
      children: PropTypes.element.isRequired,
      disableReactTree: PropTypes.bool,
      mouseEvent: PropTypes.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", false]),
      onClickAway: PropTypes.func,
      touchEvent: PropTypes.oneOf(["onTouchEnd", "onTouchStart", false])
    })]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Snackbar.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  })
} : void 0;
function Snackbar2({
  isOpen,
  content,
  onClose
}) {
  const [open, setOpen] = useState(false);
  const [exited, setExited] = useState(true);
  const nodeRef = useRef(null);
  useEffect(() => {
    open !== isOpen && setOpen(isOpen);
  }, [isOpen]);
  const handleClose = (_, reason) => {
    onClose == null ? void 0 : onClose();
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleOnEnter = () => {
    setExited(false);
  };
  const handleOnExited = () => {
    setExited(true);
  };
  return /* @__PURE__ */ jsx(Portal, { container: () => document.getElementsByTagName("body")[0], children: /* @__PURE__ */ jsx(Snackbar$1, { autoHideDuration: 2e3, open, onClose: handleClose, exited, className: "fixed z-50 font-sans flex justify-center items-center bottom-4 left-auto w-full", children: /* @__PURE__ */ jsx(Transition$1, { timeout: {
    enter: 400,
    exit: 400
  }, in: open, appear: true, unmountOnExit: true, onEnter: handleOnEnter, onExited: handleOnExited, nodeRef, children: (status) => /* @__PURE__ */ jsx("div", { className: "flex gap-4 overflow-hidden	bg-slate-900 rounded-2xl border border-solid border-slate-700 shadow-md text-slate-50 p-3 text-start", style: {
    transform: positioningStyles[status],
    transition: "transform 300ms ease"
  }, ref: nodeRef, children: content }) }) }) });
}
const positioningStyles = {
  entering: "translateY(0)",
  entered: "translateY(0)",
  exiting: "translateY(500px)",
  exited: "translateY(500px)",
  unmounted: "translateY(500px)"
};
const defaultValue = {
  activeStep: 0
};
const StepperContext = createContext(defaultValue);
const separatorSchema = z.object({
  step: z.number()
});
const Separator = (props) => {
  const {
    step
  } = props;
  const {
    activeStep
  } = useContext(StepperContext);
  useComponentValidation({
    props,
    schema: separatorSchema
  });
  const isActive = step < activeStep;
  return /* @__PURE__ */ jsx(RightChevron, __spreadValues({}, !isActive ? {
    fill: "rgba(0, 0, 0, 0.38)"
  } : {}));
};
const stepSchema = z.object({
  step: z.number(),
  children: z.custom()
});
const Step = (props) => {
  const {
    children,
    step
  } = props;
  const {
    activeStep
  } = useContext(StepperContext);
  useComponentValidation({
    props,
    schema: stepSchema
  });
  const isActive = step <= activeStep;
  return /* @__PURE__ */ jsx("div", { className: `gap-2 sm:gap-4 flex justify-center items-center text-sm ${isActive ? "text-black" : "text-black/[.38]"} font-medium`, children });
};
const stepperSchema = z.object({
  activeStep: z.number(),
  children: z.custom()
});
const Stepper = (props) => {
  const {
    children,
    activeStep
  } = props;
  useComponentValidation({
    props,
    schema: stepperSchema
  });
  return /* @__PURE__ */ jsx(StepperContext.Provider, { value: {
    activeStep
  }, children: /* @__PURE__ */ jsx("div", { className: "flex gap-2 sm:gap-4", children }) });
};
Stepper.Step = Step;
Stepper.Separator = Separator;
const AccreditationStatus = ({
  status,
  locale
}) => {
  const data = {
    verified: {
      // Is there a way to redirect users back to their previous page? Thinking for users who go through accreditation via Nexus flow, are we able to redirect them back there if verified?
      action: /* @__PURE__ */ jsx(Button, { isDark: true, onClick: () => {
        window.location.href = "/";
      }, children: /* @__PURE__ */ jsx(Trans, { id: "xGVfLh" }) }),
      icon: /* @__PURE__ */ jsx(SumSubVerified, {}),
      title: /* @__PURE__ */ jsx(Trans, { id: "fAZ5ZQ" }),
      text: /* @__PURE__ */ jsx(Trans, { id: "OMniYn" }),
      subText: null
    },
    investmentOnly: {
      action: /* @__PURE__ */ jsx(Button, { isDark: true, onClick: () => {
        window.location.href = "/";
      }, children: /* @__PURE__ */ jsx(Trans, { id: "xGVfLh" }) }),
      icon: /* @__PURE__ */ jsx(SumSubVerified, {}),
      title: /* @__PURE__ */ jsx(Trans, { id: "VC36G0" }),
      text: /* @__PURE__ */ jsx(Trans, { id: "eqRNG5" }),
      subText: null
    },
    pending: {
      action: /* @__PURE__ */ jsx(Button, { className: `bg-smokeWhite`, onClick: () => {
        window.location.href = "/";
      }, children: /* @__PURE__ */ jsx(Trans, { id: "BXa05P" }) }),
      icon: /* @__PURE__ */ jsx(SumSubPending, {}),
      title: /* @__PURE__ */ jsx(Trans, { id: "JgquTG" }),
      text: /* @__PURE__ */ jsx(Trans, { id: "X53EwO" }),
      subText: null
    },
    rejected: {
      action: /* @__PURE__ */ jsx(Button, { isDark: true, onClick: () => {
        window.location.href = "/";
      }, children: /* @__PURE__ */ jsx(Trans, { id: "xGVfLh" }) }),
      icon: /* @__PURE__ */ jsx(SumSubFail, { fill: "rgba(245, 158, 11, 1)" }),
      title: /* @__PURE__ */ jsx(Trans, { id: "tygisN" }),
      text: /* @__PURE__ */ jsx(Trans, { id: "Otc1oj" }),
      subText: null
    }
  };
  const {
    icon,
    title,
    text,
    action,
    subText
  } = data[status];
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-6 text-center items-center", children: [
    icon,
    /* @__PURE__ */ jsx("h1", { className: "text-4xl font-semibold", children: title }),
    /* @__PURE__ */ jsx("p", { className: "text-xl text-black/[.5]", children: text }),
    action,
    subText && /* @__PURE__ */ jsx("p", { className: "text-black/[.5]", children: subText })
  ] }) });
};
const StartAccreditation = ({
  handleOnClick,
  locale
}) => {
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-8 max-w-lg m-auto", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-5", children: [
      /* @__PURE__ */ jsx("p", { className: "text-black/[.5] text-xl", children: /* @__PURE__ */ jsx(Trans, { id: "LLAa/9" }) }),
      /* @__PURE__ */ jsxs(Container, { children: [
        /* @__PURE__ */ jsx(Title, { children: /* @__PURE__ */ jsx(Trans, { id: "KGzdyA" }) }),
        /* @__PURE__ */ jsx(Subitle, { children: /* @__PURE__ */ jsx(Trans, { id: "c0xDoX" }) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "bg-gray-100 p-6 rounded-xl", children: [
      /* @__PURE__ */ jsxs("h2", { className: "font-semibold text-xl flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(BlueCheck, { className: "w-6 h-6" }),
        "At least 1 of these are required"
      ] }),
      /* @__PURE__ */ jsx("hr", { className: "my-4 border-gray-200" }),
      /* @__PURE__ */ jsxs("ul", { className: "space-y-4", children: [
        /* @__PURE__ */ jsxs("li", { children: [
          /* @__PURE__ */ jsx("p", { className: "font-semibold", children: "Income" }),
          /* @__PURE__ */ jsx("p", { className: "text-gray-600 text-sm", children: "Earn more than $200,000 in each of the last two years." })
        ] }),
        /* @__PURE__ */ jsxs("li", { children: [
          /* @__PURE__ */ jsx("p", { className: "font-semibold", children: "Net Worth" }),
          /* @__PURE__ */ jsx("p", { className: "text-gray-600 text-sm", children: "Have a net worth of more than $1 million." })
        ] }),
        /* @__PURE__ */ jsxs("li", { children: [
          /* @__PURE__ */ jsx("p", { className: "font-semibold", children: "Professional Knowledge" }),
          /* @__PURE__ */ jsx("p", { className: "text-gray-600 text-sm", children: "Have a Series 7, 65, or 82 license in good standing." })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-5", children: [
      /* @__PURE__ */ jsx(Button, { isDark: true, onClick: handleOnClick, children: /* @__PURE__ */ jsx(Trans, { id: "API151" }) }),
      /* @__PURE__ */ jsx(Button, { onClick: () => window.location.href = "/dashboard", className: "w-full px-6 py-3 border border-gray-300 text-black font-semibold rounded-full bg-white hover:bg-gray-100", children: /* @__PURE__ */ jsx(Trans, { id: "19db8o" }) })
    ] })
  ] }) });
};
const accreditationSchema = z.object({
  accessToken: z.string().optional(),
  entityId: z.string(),
  locale: z.string(),
  email: z.string(),
  initialStatus: z.enum(["rejected", "pending", "verified", "investmentOnly", "showSumsubIframe"]).optional()
});
const COOKIE_KEY_ACCREDITATION = "accreditation_cookie";
const Accreditation = (props) => {
  const {
    accessToken,
    locale = "en",
    email,
    initialStatus: initialStatusValue
  } = props;
  const initialStatus = initialStatusValue === "showSumsubIframe" ? void 0 : initialStatusValue;
  const customStatus = initialStatus !== void 0 && initialStatusValue !== "showSumsubIframe" || !accessToken;
  const timeout2 = useRef();
  const isInit = useRef(false);
  const startedAccreditation = api.get(COOKIE_KEY_ACCREDITATION) === "true";
  const [screen, setScreen] = useState(!customStatus && !startedAccreditation ? "start" : "sumsub");
  const [status, setStatus] = useState(initialStatus);
  useComponentValidation({
    props,
    schema: accreditationSchema
  });
  const StartAccreditation$1 = () => {
    setScreen("sumsub");
    api.set(COOKIE_KEY_ACCREDITATION, "true");
  };
  if (screen === "start") {
    return /* @__PURE__ */ jsx(StartAccreditation, { locale, handleOnClick: StartAccreditation$1 });
  }
  if (customStatus) {
    return /* @__PURE__ */ jsx("div", { className: "w-full sm:w-[525px] m-auto", children: /* @__PURE__ */ jsx(AccreditationStatus, { locale, status: initialStatus || "rejected" }) });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    status && /* @__PURE__ */ jsx("div", { className: "w-full sm:w-[525px] m-auto", children: /* @__PURE__ */ jsx(AccreditationStatus, { locale, status }) }),
    /* @__PURE__ */ jsx("div", { className: `App ${screen !== "sumsub" ? "hidden" : ""}`, children: /* @__PURE__ */ jsx(SumsubWebSdk, { accessToken, expirationHandler: () => Promise.resolve(accessToken), config: {
      lang: locale,
      email
    }, onMessage: (data, payload) => {
      var _a, _b, _c;
      if (["idCheck.onApplicantStatusChanged", "idCheck.onStepInitiated"].includes(data)) {
        if (timeout2.current) {
          clearTimeout(timeout2.current);
        }
      }
      if (data === "idCheck.onApplicantStatusChanged") {
        if ((payload == null ? void 0 : payload.reviewStatus) === "completed" && ((_a = payload == null ? void 0 : payload.reviewResult) == null ? void 0 : _a.reviewAnswer) === "RED" && ((_b = payload == null ? void 0 : payload.reviewResult) == null ? void 0 : _b.reviewRejectType) !== "RETRY") {
          setStatus("rejected");
          setScreen("status");
        } else if ((payload == null ? void 0 : payload.reviewStatus) === "completed" && ((_c = payload == null ? void 0 : payload.reviewResult) == null ? void 0 : _c.reviewAnswer) === "GREEN") {
          if (isInit.current) {
            timeout2.current = setTimeout(() => {
              setStatus("verified");
              setScreen("status");
            }, 4e3);
          } else {
            setStatus("verified");
            setScreen("status");
          }
        } else if ((payload == null ? void 0 : payload.reviewStatus) === "pending" || (payload == null ? void 0 : payload.reviewStatus) === "onHold") {
          if (isInit.current) {
            timeout2.current = setTimeout(() => {
              setStatus("pending");
              setScreen("status");
            }, 8e3);
          } else {
            setStatus("pending");
            setScreen("status");
          }
        }
      } else if (data === "idCheck.onStepInitiated") {
        setScreen("sumsub");
        setStatus(void 0);
      } else if (data === "idCheck.onInitialized") {
        isInit.current = true;
      }
    } }) })
  ] });
};
const learnMoreSchema = z.object({
  modalContent: z.custom().optional(),
  cookieKey: z.string().optional(),
  title: z.string(),
  text: z.string(),
  learnMoreText: z.string().optional(),
  onClick: z.function().optional(),
  href: z.string().optional()
});
const LearnMoreBlock = (props) => {
  const {
    modalContent,
    cookieKey = "learnMoreButton",
    title,
    href,
    text,
    learnMoreText = "Learn more",
    onClick
  } = props;
  const [isLearnMoreOpen, setIsLearnMoreOpen] = useState(false);
  const [showlearnMore, setLearnMore] = useState(!api.get(cookieKey));
  useComponentValidation({
    props,
    schema: learnMoreSchema
  });
  const handleClose = () => {
    setLearnMore(false);
    api.set(cookieKey, "true");
  };
  return showlearnMore ? /* @__PURE__ */ jsxs(CardContainer$1, { hoverStyles: "", className: "relative bg-gradient-to-b from-gray-50 to-gray-100", children: [
    /* @__PURE__ */ jsx(Modal2, { showCloseIcon: true, isOpen: isLearnMoreOpen, onClose: () => {
      setIsLearnMoreOpen(false);
    }, children: /* @__PURE__ */ jsx("div", { className: "gap-4 flex flex-col text-disabledGray mb-6 mt-6", children: modalContent }) }),
    /* @__PURE__ */ jsx(Close, { role: "button", onClick: handleClose, className: "cursor-pointer transparent-icon absolute right-4 top-2" }),
    /* @__PURE__ */ jsx(CardHeader$1, { title, text }),
    /* @__PURE__ */ jsx(ViewAllButton$1, { onClick: () => {
      onClick == null ? void 0 : onClick();
      if (href) {
        window.location.href = href;
      } else {
        setIsLearnMoreOpen(true);
      }
    }, children: learnMoreText })
  ] }) : null;
};
const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};
const validatePassword = (password) => {
  return password.length > 9;
};
var castle = { exports: {} };
(function(module, exports) {
  (function(n2, t2) {
    t2(exports);
  })(commonjsGlobal, function(B) {
    var a2 = Math;
    function L(n5, t5) {
      for (var r5, e4, u4, c4 = "", i4 = t5 % 26, o4 = 0; o4 < n5.length; o4++)
        c4 += (e4 = i4, 65 <= (u4 = (r5 = n5.charAt(o4)).charCodeAt()) && u4 <= 90 ? String.fromCharCode((u4 - 65 + e4) % 26 + 65) : 97 <= u4 && u4 <= 122 ? String.fromCharCode((u4 - 97 + e4) % 26 + 97) : 32 === u4 ? String.fromCharCode(u4 + 1) : 33 === u4 ? String.fromCharCode(u4 - 1) : r5);
      return c4;
    }
    function N(n5) {
      var t5 = e4;
      function e4(n6, t6) {
        var r6 = i4();
        return (e4 = function(n7, t7) {
          return r6[n7 -= 429];
        })(n6, t6);
      }
      for (var r5 = 330448, u4 = e4, c4 = i4(); true; )
        try {
          if (parseInt(u4(431)) / 1 * (parseInt(u4(433)) / 2) + -parseInt(u4(441)) / 3 + -parseInt(u4(439)) / 4 * (-parseInt(u4(430)) / 5) + parseInt(u4(442)) / 6 * (parseInt(u4(432)) / 7) + parseInt(u4(434)) / 8 + parseInt(u4(435)) / 9 + parseInt(u4(429)) / 10 * (-parseInt(u4(444)) / 11) == r5)
            break;
          c4["push"](c4["shift"]());
        } catch (l4) {
          c4["push"](c4["shift"]());
        }
      function i4() {
        var n6 = [
          "78LFTFPb",
          "join",
          "6173849WbjWNI",
          "10iGiTgu",
          "10xbgVSI",
          "5827eSXxys",
          "602fNLhNo",
          "22cDjmnH",
          "4757280qpSfyX",
          "4147029fYUPdn",
          "charCodeAt",
          "push",
          "length",
          "533284vYiZtB",
          "split",
          "1486773WCoyhE"
        ];
        return (i4 = function() {
          return n6;
        })();
      }
      var o4, a4 = {}, f4 = n5[t5(440)](""), _4 = f4[0], s4 = [_4], v4 = 256, h4 = f4[0], d4 = 256;
      for (n5 = 1; n5 < f4[t5(438)]; n5++)
        o4 = (o4 = f4[n5][t5(436)](0)) < v4 ? f4[n5] : a4[o4] || h4 + _4, s4[t5(437)](o4), _4 = o4["charAt"](0), a4[d4] = h4 + _4, d4++, h4 = o4;
      return s4[t5(443)]("");
    }
    var O = N("gbFgevat?pnyyre,nethzragfĈbclSebzPunaary,trgġģĥyQngn?ĩgĝrdhĕplErfcbafrĴĪVznĩİĲĨĪYąrİfu,vfCbągVaCıŕŗřśŝĂĞxr,ĔnfherGrkg,ĹnqeıvpPŮiŰb,svċűų,făbŨƆŴsłg?ńgCĞcčglņgŌũĵİlŎĶhċLrĐƢUbŮfƢZąhgĿƮƐŕĵGvĔƢƸĔmłrBssƓƈĪƝǅƣƥƧĎƓƪƬǈƯċŗrpłqƭƓZƵǈFǔǖǘĪƼũĀƝŦąt,ĀWFBAǩbYbĉČǥăǧǯǱǳrǦĆǸǲĊŰƹǻǶǽĀǼǨĀǢȇ,iĊĺǁ?ůĹĿgNqncƲeȑĸĺƉȖȘȚŝƏ?ƏeŉƎbȧıEģĩƂȪȨGbşeė,ůfbyſqBșvłĘpůırRČĔĖ,ɄƧƲɈrɊgAFƢɐɒOlVqɖɉĕėəPyŬfAnƺĵɗɟfəɦɨĪɪĖɬlGŊɮƞɰɞɲəɵtɷɔȸrsčůĎjĄƲ,ʇvƲya?łɅqlƉɆpĢĆũłzƫńɟč,ʛʝĦƧſ?ȘƗaɜʨĕqġƄɜĵOƫʪǧɢvɟľpŴĵʷʹǔȷąńȶȖwnpɟɱŴ˂Ƙ˅ˇɟUGZYŖŃˍqˆˈĖƍ˕˃gOʂȪũcůʩɜ˥ɣˈʯy˧rc˩rJʌŕƓNgǶoƱŅsɧƄơybŷƈĲghɃyʸĖUrvtuŴp̈ɟ˲qgŕbǂǍ̌̎Ŵ̘ǃĪ̖̔ƈɄȻỵ̋̍̏Ğċ̡uʐaʜ̆rʟĎʢ̲ČnʦǕĖɟQǲēɟɌƐ̓ąqbj?oʴqʶ̒Ėʺˋ̼eńʻɁa͐ȸbb˟͋Ęˇbƭ͟ŔďfąŕıģďĲa2ͪģŕpoȶ͂ƭǕͣŲc,͸z1,̀ǨͿ10;bt1͹ͥaƈͦƈdͳͫǩͯ?ĕ̀ŹƲQriŻƳƟŗ˯nlZr͌nƢH˃΢ΤʧccPbqrɷďάβʨIčͥł,˹ʰVQ͂Ĥˀ͖,ΰΚˈ΢ʜeơʲıȚϋĪTɧˮŷƭĵIEQΞɣʔ,ĢeqjĐrήapŮůϥ˿ȮhŊũɣĆϬĩƭŉkȳhʗţɲŪȂGlƗƭ͠pch,ΟgȦzЅyht˂ЅĞqϷŴˤίВFhoǅʪˠ͟Ί˃φ˱ȪŨǌĀŹȯ̲eNĩɋſʪȪȌʭȪЗЙjroŸvſĎtЃΫ˦˫ɜˌȶˠȦũ˨ˏрęaкgȳÒЙʽ̓ųƛňϭŌΥĵŐĥœšŘŚĖŝş̢ŢѠŜaŦƋũūŭů˜ŶŸźżžƀȰĖ?ȓϊƛʳhʵĆʾ͏ˀƢҀg͐ĘȹȻȽȿg͖ĘϖŚˈĘsĞĠίrϹƑȔƹɆѻʳkƛRųɟǁĬлĪгȇYĕt̢ђzЃƲqƍҪĆ̖͉hǂčјƢȵϒȚʁŷCvkĦĘ0o637n33,ӊr2s32ũ318390q1?ӇӉӋӍ,081q6ӝЙp767712oĈn9q9pӒ?ӯΰnә4ӻ7ӽӿɌӭӯӱӳ98ǔ85ԋτoonӓ1s?ԊԌԎũn29Ӱ8ԠԐԒԔsԅӮӰӲԗs1p3qʃďԝԟԡqԑԓӗԥӬԧԈȥq0Ӈs5ɜԋrԂs2ͭԺԇԩԯq41noԀ0ͱՔ682?45ԝ24q5ӟԿӋՒũӠӊӌӎ866˼7ՅӏӘӚӜӞ55r9o959?նոպռ,50ԜӦoատչջ9ԦՋӳʂз4ps֍nӉ49ԕЙo01ԕӝp,194ǔԫ7փշ֋ռ").split("?");
    function v(n5) {
      return L(O[n5], 13).split(",");
    }
    var M = N(`Onpxfcār?QryrgćFąpćRače?GnoĈBZPbĔrĔYbnqrq?pbzcċč?vĠeāgvićZFVRİsĳzćfglċĩynff?qĶėlcrReebĖnhŌb?ivĦŚ[anĵķ!ĪĦ]?Ersċpg?cŔgbŃŐ?nethŀĔŊpnyċĖųFgeıtŰŔĬůck?dhrel?tČBjaCŔŐeŃAnŀŊƗgƜŴŴŏrBs?fČƧųŵƫƭƥƙƛƝƓŃĉfpƇcųĖehĔvŀƮŐrpuFlĔurfvŊAŴvsvſĵğ?CƓzǓǒğŊSǄŮvǜơŜtŢŕŷqqRķĢǓčaƓŷggāuǲġůĦǻǋǾĔ?erzbķȄgYǵġǸǜĦŜđŋrȔrZȈŕƕĭŢsŕzśġqǮhƯeNƗȅnccIƓǢaƊbqhŮFhĚŇaźnƗ?uŸqjŸrĞaphœġpƕǠŀGƪŊwninēęċĨĪbxvőšoɛĩȇĦǅƀŊłŕȿŁƓȘJŕxǸȥǕgGĳĂŰyhtıŊohvyqVQĩbyŕĉǀuŰvkĊʌgʎȗƀ?bƽchŋbɊżgZȵćǋƋćoĳķʘƞnʫǂǑʉķqBǀǨaŊĵŀMğćʊſŅɳloĤeĨzfFɖrOʊĚıĦʑqQOʫġQŢęňćƞȠeznɉćŀȉƔ?wfUrȭFvmrȎǠůjroɟɷȈcɬƔƅɬɀ˳˵vgŪƑǑgSʃrǍłȈ?ʢmNȮ˪ĳˡ?ˁhc,ˁȥƚ,pyǙx,ȉȧr̢̗b̛̤a,ųȷǐaq̨̬ǋłŸg̲̮ſˡy̧̤ȉķ̸ǋ̿r,ȓǙțǛ̫jǐĊ?̭ǋǑȆŴŢʶEŢćāđƂīČǸtlŔƽbŶ˟tǷųŀĕƖ̓čĨɣƒųŴʎPňgċ:!?Tbbtċ!Vɉ.?̐ĭr!ĞĬhĕ,΀΂ɁǺcf://z.ſłċ.Ǩ/i1Ζğ́ǮLkfxnsgʁ̱!Ɨ!iåe!JP-mğzö΀D-uwäyc.͹̺ɗŊ13ǀ!˃źf-ȠĔ-kϔ?16ϋNƇʗŹon(102΍204΍0Ϩ.6123456789)?ȗġȵĨ2Ĩ˿;Ϸkƞǆǿƀ-?JROTY_Ħʁt_ḛ̑ƓƓ_ıȠŷςɂoČǙ?zhyĵĭƕƥVͥr˗ǻƮl̋zKQCV?ʊɾʿавȖȘCʐĊ͖ǛŷpđϒĪʊe͸ı́vʗȭŐŸˠđшaъʗ˃˅Ɠ-Ȥљ̰-ĳŌȧђєyĩƀyFĊġvŻѤaFɂȇ?(űūȱ-хŕ-ƽǐŀ͸̟tug϶ɈȂgfZˠɭĖ҃ǿ΁ːȖѓħʝzN΋ī͔Ȓbƚ̟ax҇ƏqƇķĖʖɼ͗ƖČIŝrbCŇ˂āxDhƀ́ƕ˩ĥċŉPuʦҧgUvѿēƆͣlIƀƒŊ˿ҠĶǸѓѿg˟Ѱcqsҩr˳eəɣґʿyCɂĔī?_cӡͨӤӥӧҖŊϝƮƾvǀ_sȳƽƿgӳǦƮѨѓѫѧċӽz_ʆR_ŪĪїĖѧ̄ĔѫfѯĎjǗgѮĥǸǄjĳ̑ĨɸĆ?ʹaχˌʞɳҊɂŀċǜQȷxԫĂͻǝҡāl!ĀqƗĖƜĶԳ!CʙfѫǕFӰǀ?WѮĊͪʛ̑čјrkƆʭɂfNǺƇʁįŢƆv՘͑˟kG̳uԾı҅ėբȌ͎բ̵ƟİaʛůġŻƓ͗ĉȘŊŀŌnն͇ǤvȇȠƏN̰ŔŝҾGЃθǷƬsƯƍŔϞɣɏn˂ʤˠҭ֔ɒŶͽƉɅiśŕoǓʈĦpոŐƉk-z4ʭnā͎ǐɬŷip1.42R01ļic8΍i֣֡Ĭ4?˿ȢҞǆŻťѥ!̵Ăא˭·Տđħґͱ!Рǋ!ȇɊeȲԟˠaŴמ˪q!űͣƺԴ'o'!bs!ǄĦǘǷĨ(׃ŝ!0)!Ǔ׵Г׸ґ׶ūıħ؁f!ץg!ˠײowǊ؏(ҤҳĵȽ!'׻b׽׿.װ҂פצȇĥתƹƟɠ،׳؃׷؉ש(اŌ؛ׯ'϶ŒŔĖʃċǬy!Ɠػ?؇؅ש׫ƞĵ͑Ӟ؁ĲsĆفœǮэyԴեƓُđّكǷj̵ٍˡٛǮ̞ň،ՏǶq٦ْĖaСـĪԡȱʶ٢Ė"׫Ʋƪ"ٍ!sǦ͉ȖӶӱǁʘƚة׬ƟƕĦځǀŕ!ˁŊҙaچىԴšƣڄڒڏ؍Ƣ͑bؓؕ!Ƅ՛؛قٓ؏ıĪĬ͔ӜچkԴڥŖ؏ڢƇ؛ڨīąĵڬ׫ڮٴǹڡͼכ̮קנȲڽŢڿbہםןɋۅ_ӥŲbۏۆ؏ǋnıťl̞ו٫ھۖۘɎۛ!ۏٷے_۔קŬڠ֎چųھրŭ؏۬ۥڭƕۇɿǻˡخ͐גڰھذǷړƺجڀՄǁ.ɗɼ·مرȴٸŐڡ̅فʑɊٿǐӁҀ:ϡ0iu;Ԓqʔܚ0ܜj;˹ǒ͉:ęfʉ΋r;ċΪ:-ܛܤƎ;Ŝǒ֢̟Ń:uŝɧ;Ӥ֦Ͷ-ok1ҾI؟đŊۏFRAGELۏөԈr-˧_ԏɆqݗŪȞƕǍz˃y.Փ΁٠ȕƧڮƮ՛ŮכʣʈʷƆȷڃԀtʔ,ږćPFF?ϞĂtŔ׶Ѷʉŕ͸NǧķG٧݄Κ݇t݊UGZYҩŞRċʠ?AČjɲ΁˝˟ٿŬŢũr˹ثȽBoȨҢĩ7ϲ7ϭĚιǑfɭ=ٽɉ͉ؗ){ɗγn="ЈЊY",e߈HAZNFXRQ";Ɔl߄Ÿڡ=šǫǭeݽ={ҳ:g.̤ȩȫ̷cߩ.Ȟgަͅz߱͆đȚˤl,up߱ѯɄɆɈנВɎ,y߱ȼȾƗࠉΓߪࠌҳƗf}ߚƔߝγtߠӘ!֌ӶrġԠχ(2ϱ,ࠦ6).ƥҋՐ("Ͼy");Ǘ(t߃߅א=tࠬČRՐġȲ(n+"Ѝ˴ɽБȤДeЖaȠ࠴;f&&(a܈࠽࠿ƦяͩƓ(f[eࡇ_IݒQBE_"+n])ݽ.ߏ࠾ƥC࡞͝eࡡࡣࡥEࡨRࡾ࡫࡭࡯))}}ǚǋ߂{}ܨʡ޻ɭࡘࢆࢉuࢋࢎȚŉ࢑{r:r}ࢆࠖ?ԣoHEY،Ɇ؍צlČא̗ޭͭɥ˪čްؔȸǁćĦĮЩ˘ϞƯƐƒƔH޼ƗփqҲ͓ʘšҕǘƁլůɿƺݢŇđʠސՐ̍ā΁čѣJı32İӠʼ?Ȏ٭kؐ˞i8ѣġHނǑRނľSEŰgOࣶġT˔ĦQļǃEH?K-ʹΚݚCȺ̟ݞӜ-̐v-XrƕwjȀ˘Ѷ͵ċ-܉ƒŋङΙͶݚݾѤईࡌ̄ł_ųɳȳŬͼĖ˹j͒׶ȆˠȥȢܬİРѣǠӵdխāʙǹˠ࣡еПnƏđʃӻƦتŃ׈ŝʔɁrܘůɖۗyࣞܡʎक़ʃ˩ॖ?Ճȇġ?ľīĞĦդȅʊĥ०Ƣʃƕ̵gȧ?Sğ̆ԞųЪnࢥYҾ࠮ůޗޙࠣňޝȈǿҾࡷĿࡹҾࡁǶעƥȹȮŕͭএࡃʶŊJ˴ЋŪГڴtঁЇজY2ঞĦঠঢĴҳyǪ̰ƈমkNƽউফƀম׶঱bkƼуॗŮবহরȽলYūীॴসযصtলEॡϑࣸৌ঻঳঵ȅ৒ৃ্লাউࣗ࢏ݱŊ࣍yয়०ॸݰŔɳ৥অfধƓƈঁ2ʇ࠭ӡǷyॼʈclSƋһפ͍ҔřOhssǸঃYVৼڜইޟٰǶgQʞճȅਏǿ̰ࣞҙĈਓ਎اč਍উƥਠĔOlVĨਣॗ̰̑ծȨgNqɕি਩ਭƺਰਲǿਈਵƟ਷ĆĔ৥ѳŐਬȇȞđࣞ॓ǕĦŷਫqһʃĨ࣑ƟOūŕć੄ࣔɇ݀ʄժࢣ΄šٕȨ੉ćƥਥčৼrԌɎ৸੤lčֈŀ਒˟ı੫ČS७̆ȇ੩lੴ̆੷੯ЩҖੳ˘ִख़েΪ઄ʃաc?#ল-ĀaǷe-ĥŊ.ѧǧğਰખĥ-ܲg-ǆɭઌક-ѳ७Ĩآ৿ઓ˃Ǻӣ.ǠҠʉy֫Ÿԥતgjਰ਋Ǉ.ĥ˃k_ਖȅ.ĄǣŕvતqɣԤ_ƣࣄć.ਰૌĂ࢘ૐ?ાોʾxޥŚ#޼ۚͼɟć#ɝૣડٰ૘૦ɠѶǐɺ#NP_८૒˓়૘NQॷŴǸ.Mv૳ݠn_Uઌૹ7ϥk90ଆQF_݊૙ϏʛĚňҪ[qङࢰЅŝ߈ċԖe˃Ƀ"ŨઍŴͨਰ૘ઝǒȽजu࣡રlଁખĄଁ_ીफͣପĬଁઌzɾݠǗঌ݊૰qରĥ2଑ĥű͇ઌ՘ųaݝԐ૘˹Ջѹʞыѣૅʞ_̟ɳઌऊɣǙŝԖ૘ୡ̟p୤੊߲ऋୣଙqޔઌĿӜeĞǄͪ#ųcܛĪ୷૽ĭɽı-ଙॱૂযůૅȞԏ݇ફ୲rxŇȢࡳஏ஑૳ઌ˪ࡐčՐЍōgq#ľࠡͧफɚrଳ૘Ňcѓદͣ-Ȋ૽ۖઑĊ-ઔĨ#ક˹ઠભӨnவଆݠԒਙjŊஷݠٽƁ૘यŢ଩૒ܺbĞɞ܄૙૔xމ௑͑૙c஬Ջઌ׫ȉ݇૷ஓஐƢ஽஻યȇ௣˟ѝॡ଒֫ڞɠѣ#ן஑ħōஓ٤Ǉ୅_ਘϼ֔૊ૃųМȳ௅_ڞ॥୬oୢ୩Ы௭qƏ#ଔఊ́ʭપ઒ыૉ௢஑ʙ_٭ŕȵृఙƢఛǻeą௄pʑʷݚןϏஂ̶ǙŅ.ȈМ୰ȇ૆ʷӍ-ƆȤz઩యۛѹ୓#ૻĕଢ˅ʢܼ૤ٝfেǺƓ঴֎௉ͼĕѝŉ૘΋ʃ஌ઓȉȶजǘ۰lझǓ՜ఱspѝ౓૊݇૛ј୕̗૊௔-ԙэǸ#ԕȇ଑ݞȇԾł૘౷rG݀જ٩ીĈVIાt੕f3ܤėNOYR૙iƇӐପݠ૎ۗȳ௓ʊxx૪vಟࡌ௩ઌł̠lௐૣĀĖઍŸಪج҃ಛ૽z௖ૣభࡑŚN[Ҽū^߈/ľڜޣex/శ̨eݎುȡf/કાĄkତਭଘङۗıઝıiŨɿ[٤ŉಿ"ȚպҍՏ_ૹ࡬ŨŌi[ŝೢతƥʛԏਰ೪୎ଽ#oଁରઆਯ٩ପaவҢ஺஍ાഁషܭɦતஃѹପഌ֟૙மਅȱ૊ഐઝ240kങଌ଒6ܤkϥଌ௅ಃӳ౩క઒_ʎ૟Ԑ௮ଙ୚౿૘౺ˋ΋୐`).split("?");
    function h(n5) {
      return L(M[n5], 13);
    }
    var z2, P, W, G, U, Q, V, Y, Z, J, X, $, K, nn, tn, rn, en, un, cn, on, an, fn2, _n, sn, vn, hn, dn, ln, pn, gn, yn, Hn, mn, wn, bn, En, Dn, xn, Fn, Cn, In, kn, qn = h(0), Rn = h(1), n4 = h(2), t4 = h(3), r4 = h(4), Sn = [qn, Rn, "8", "46"], Tn = Sn.concat([n4, t4, r4, "32", "13", "10"]), jn = h(5), An = h(6), Bn = h(7), Ln = h(8), Nn = h(9), On = h(10), Mn = h(11), zn = h(12), Pn = h(13), Wn = h(14), Gn = h(15), Un = h(16), Qn = h(17), Vn = h(18), Yn = h(19), Zn = h(20), Jn = h(21), Xn = h(22), $n = h(23), qn = h(24), Kn = h(25), nt = h(26), tt = h(27), rt = h(28), et = rt + "s", ut = h(29), ct = h(30), it = h(31), ot = h(32), at = h(33), ft = h(34), _t = "2.4.3", y = 0, H = void 0, d = null, l = Object, st = 255, vt = 15, ht = "undefined", dt = 1535e6, lt = function() {
    }, pt = [], gt = 6, yt = function(r5, e4, u4) {
      var c4 = H, i4 = d;
      return function() {
        for (var n5 = [], t5 = 0; t5 < arguments.length; t5++)
          n5[t5] = arguments[t5];
        return i4 != d && clearTimeout(i4), u4 ? c4 = r5.apply(d, n5) : i4 = setTimeout(function() {
          if (i4 = d, !u4)
            return c4 = r5.apply(d, n5);
        }, e4), c4;
      };
    }, Ht = function(n5) {
      return p(n5) && "" !== n5;
    }, mt = function(n5) {
      return n5 !== H;
    }, p = function(n5) {
      return mt(n5) && n5 !== d;
    }, wt = function(n5) {
      return n5 || H;
    }, bt = function(n5) {
      return n5 ? 1 : 0;
    }, Et = function(n5, t5) {
      return -1 < n5.indexOf(t5);
    }, m = function(n5, t5) {
      return !!(p(n5) && "hasOwnProperty" in n5) && n5.hasOwnProperty(t5);
    }, Dt = function(n5, t5) {
      return t5 in n5 && !!n5[t5];
    }, xt = function(n5) {
      return l[Kn](n5);
    }, Ft = function(n5) {
      return l[nt](n5);
    }, Ct = function(n5, t5) {
      return l[rt](n5, t5);
    }, It = function() {
      return m(l, Kn) && m(l, nt) && m(l, rt);
    }, kt = function(n5) {
      return n5.constructor.name;
    }, qt = l.assign || function(n5, t5) {
      for (var r5 in t5)
        m(t5, r5) && (n5[r5] = t5[r5]);
      return n5;
    }, g = function(n5) {
      return n5.navigator;
    }, _ = function(n5) {
      return n5.document;
    }, Rt = function(n5) {
      return n5.screen;
    }, St = function(n5) {
      return n5.location;
    }, Tt = function(n5) {
      return _(n5).documentElement;
    }, jt = function(n5) {
      return _(n5).body;
    }, At = function(n5, t5, r5) {
      return n5.setAttribute(t5, r5);
    }, Bt = function(n5, t5) {
      if (n5.getAttribute)
        return n5.getAttribute(t5);
    }, Lt = function(n5, t5) {
      n5 && n5.appendChild(t5);
    }, Nt = function(n5, t5) {
      n5 && n5.removeChild(t5);
    }, w = function(n5, t5) {
      return _(n5).createElement(t5);
    }, Ot = function(n5) {
      n5 && n5.parentNode && n5.parentNode.removeChild(n5);
    }, Mt = function(n5, t5, r5) {
      n5.style.setProperty(t5, r5, "important");
    }, zt = function(n5) {
      Mt(n5, "visibility", "hidden"), Mt(n5, "display", "block");
    }, Pt = function(n5) {
      return JSON.stringify(n5);
    }, Wt = function(n5) {
      return JSON.parse(n5);
    }, Gt = function(n5) {
      return !isNaN(n5 - parseFloat(n5));
    }, Ut = function(n5) {
      var t5 = Number.isInteger;
      return p(t5) ? t5(n5) : "number" == typeof n5 && isFinite(n5) && a2[h(249)](n5) === n5;
    }, Qt = function(n5) {
      var t5 = Array.isArray;
      return Vt(t5) ? t5(n5) : "[object Array]" === l.prototype.toString.call(n5);
    }, Vt = function(n5) {
      return "function" == typeof n5;
    }, Yt = function(n5) {
      return "object" == typeof n5 && !Qt(n5);
    }, Zt = function(n5) {
      return "string" == typeof n5;
    }, Jt = function(n5, t5) {
      var r5 = n5 instanceof Object ? n5 : new Object(n5), e4 = isFinite(r5.length) ? a2[h(249)](r5.length) : 0, u4 = 0;
      if (t5 === H) {
        do
          if (u4 in r5 && r5[u4] === H)
            return u4;
        while (++u4 < e4);
      } else {
        do
          if (r5[u4] === t5)
            return u4;
        while (++u4 < e4);
      }
      return -1;
    }, Xt = function(n5) {
      if (Qt(n5) && n5.length)
        return n5.join(",");
    }, $t = function(n5) {
      n5.splice(0, n5.length);
    }, Kt = function(n5, t5) {
      for (var r5 = [], e4 = 0, u4 = n5; e4 < u4.length; e4++) {
        var c4 = u4[e4];
        t5(c4) && r5.push(c4);
      }
      return r5;
    }, nr = function(n5, t5) {
      for (var r5 in n5)
        if (p(n5[r5]) && Yt(n5[r5]) && m(n5[r5], t5))
          return true;
      return false;
    }, c2 = function(n5, t5) {
      for (var r5 = [], e4 = 0, u4 = n5; e4 < u4.length; e4++) {
        var c4 = u4[e4];
        r5.push(t5(c4));
      }
      return r5;
    }, tr = function(n5, t5) {
      for (var r5 = 0, e4 = 0, u4 = n5; e4 < u4.length; e4++)
        t5(u4[e4], r5++);
    }, rr = function(n5) {
      if ("values" in l)
        return l.values(n5);
      var t5, r5 = [];
      for (t5 in n5)
        m(n5, t5) && r5.push(n5[t5]);
      return r5;
    }, er = function(n5) {
      if ("keys" in l)
        return l.keys(n5);
      var t5, r5 = [];
      for (t5 in n5)
        m(n5, t5) && r5.push(t5);
      return r5;
    }, ur = function(n5, t5, r5) {
      for (var e4 = r5, u4 = 0, c4 = 0, i4 = n5; c4 < i4.length; c4++)
        e4 = t5(e4, i4[c4], u4), u4++;
      return e4;
    }, cr = function(n5, t5) {
      for (var r5 = Array(n5), e4 = r5.length - 1; 0 <= e4; e4--)
        r5[e4] = t5;
      return r5;
    }, ir = function(n5) {
      return n5 ? [].concat(n5) : [];
    }, or = function(n5) {
      if (l(n5) !== n5)
        return {};
      for (var t5 in n5)
        Ht(n5[t5]) || delete n5[t5];
      return n5;
    }, ar = function(n5, t5) {
      return !!n5 && 0 <= Jt(n5, t5);
    }, fr = function(n5) {
      var r5 = { "boolean": {}, number: {}, string: {} }, e4 = [];
      return Kt(n5, function(n6) {
        var t5 = typeof n6;
        return t5 in r5 ? !m(r5[t5], n6) && (r5[t5][n6] = true) : !ar(e4, n6) && (e4.push(n6), true);
      });
    }, b = function(n5, t5) {
      for (var r5 = 0; r5 < n5.length; r5++)
        if (n5[r5] === t5)
          return true;
      return false;
    }, _r = function(n5, t5) {
      for (var r5 = 0; r5 < n5.length; )
        n5[r5] === t5 ? n5.splice(r5, 1) : r5++;
      return n5;
    }, sr = function(n5) {
      for (var t5 = [], r5 = 0, e4 = n5; r5 < e4.length; r5++) {
        var u4 = e4[r5];
        Qt(n5[u4]) ? tr(n5[u4], function(n6) {
          return t5.push(n6);
        }) : t5.push(n5[u4]);
      }
      return t5;
    }, vr = h(35), hr = h(36), dr = h(37), lr = h(38), pr = h(39), gr = function(n5, t5, r5) {
      Hr(n5) ? n5[vr](t5, r5, true) : mr(n5) && n5[hr]("".concat(pr).concat(t5), r5);
    }, yr = function(n5, t5, r5) {
      Hr(n5) ? n5[lr](t5, r5, true) : mr(n5) && n5[dr]("".concat(pr).concat(t5), r5);
    }, Hr = function(n5) {
      return !!n5[vr];
    }, mr = function(n5) {
      return !!n5[hr];
    }, wr = function(n5, t5) {
      var r5;
      return void 0 === t5 && (t5 = 2), p(n5) && isFinite(n5) ? (r5 = a2[h(250)](10, t5), a2[h(251)](n5 * r5) / r5) : d;
    }, br = function(n5, t5) {
      return t5 !== y ? n5 / t5 : d;
    }, Er = function(n5) {
      return a2[h(252)]() * n5 | y;
    }, Dr = function(n5, t5) {
      return a2[h(253)](n5 - t5);
    }, xr = function(n5) {
      return y < n5 ? 1 : n5 < y ? -1 : y;
    }, E = function(n5) {
      var e4 = "".concat(Pt(n5));
      return ("0000000" + (ur(e4.split(""), function(n6, t5, r5) {
        return a2[h(254)](31, n6) + e4.charCodeAt(r5) | 0;
      }, 2166136261) >>> 0).toString(16)).substr(-8);
    }, Fr = function() {
      return /* @__PURE__ */ new Date();
    }, Cr = Date.now || function() {
      return Fr().getTime();
    }, Rn = function(n5) {
      return new Date(n5, 1, 1, 0, 0, 1).toUTCString();
    }, Ir = function(n5) {
      var t5 = /* @__PURE__ */ new Date();
      return t5.setSeconds(t5.getSeconds() + n5), t5.toUTCString();
    }, kr = function(n5, t5) {
      for (var r5 = [], e4 = 0, u4 = 0, c4 = n5.split(""); u4 < c4.length; u4++) {
        var i4 = c4[u4], i4 = parseInt(i4, 16) ^ parseInt(t5.charAt(e4), 16);
        r5.push(i4.toString(16)), e4 = (e4 + 1) % t5.length;
      }
      return r5.join("");
    }, qr = function(n5) {
      for (var t5 = "", r5 = 0; r5 < n5.length; r5++)
        t5 += D(n5.charCodeAt(r5));
      return t5;
    }, Rr = function(n5) {
      for (var t5 = "", r5 = 0; r5 < n5.length; r5++)
        t5 += (15 & n5.charCodeAt(r5)).toString(16);
      return t5;
    }, D = function(n5) {
      return ("0" + (n5 & st).toString(16)).slice(-2);
    }, Sr = function(n5) {
      return ("0" + (3 & n5).toString(2)).slice(-2);
    }, Tr = function(n5) {
      return (n5 & vt).toString(16);
    }, jr = function(n5, t5) {
      for (var r5 = a2[h(255)](a2[h(250)](2, 8 * t5) - 1, n5), e4 = "", u4 = 2 * t5; 0 < r5; )
        e4 = D(r5) + e4, r5 >>>= 8;
      if (u4)
        for (; e4.length < u4; )
          e4 = "0" + e4;
      return e4;
    }, Ar = function(n5) {
      var t5 = n5.match(/.{2}/g), r5 = "";
      if (t5)
        for (var e4 = 0, u4 = t5; e4 < u4.length; e4++) {
          var c4 = u4[e4];
          r5 += String.fromCharCode(parseInt(c4, 16) & st);
        }
      return r5;
    }, Br = function(n5) {
      for (var t5 = "", r5 = 0, e4 = n5; r5 < e4.length; r5++) {
        var u4 = e4[r5];
        t5 += D(u4);
      }
      return t5;
    }, Lr = function(n5, t5) {
      for (var r5 = 0, e4 = t5 && n5.length > t5 ? n5.slice(0, t5) : n5, u4 = e4.length, c4 = u4 - 1; 0 <= c4; c4--)
        r5 |= (e4[c4] ? 1 : 0) << u4 - c4 - 1;
      return t5 && u4 < t5 && (r5 <<= t5 - u4), r5;
    }, Nr = 4294967296, Or = function() {
      var e4 = 4022871197;
      return function(n5) {
        n5 = n5.toString();
        for (var t5 = 0; t5 < n5.length; t5++) {
          var r5 = 0.02519603282416938 * (e4 += n5.charCodeAt(t5));
          e4 = (r5 = (r5 - (e4 = r5 >>> 0)) * e4) >>> 0, e4 += (r5 -= e4) * Nr;
        }
        return 23283064365386963e-26 * (e4 >>> 0);
      };
    }, Mr = function(n5) {
      for (var t5 = 0, r5 = 0, e4 = 0, u4 = 1, c4 = Or(), t5 = c4(" "), r5 = c4(" "), e4 = c4(" "), i4 = 0; i4 < n5.length; i4++)
        (t5 -= c4(n5[i4])) < 0 && (t5 += 1), (r5 -= c4(n5[i4])) < 0 && (r5 += 1), (e4 -= c4(n5[i4])) < 0 && (e4 += 1);
      return function() {
        var n6 = 2091639 * t5 + 23283064365386963e-26 * u4;
        return t5 = r5, r5 = e4, e4 = n6 - (u4 = 0 | n6);
      };
    }, zr = function(n5) {
      return n5() * Nr;
    }, Pr = "0-9a-f", Wr = function(n5) {
      return jr(
        zr(n5),
        4
      );
    }, Gr = function() {
      var n5 = Mr([a2[h(252)](), Cr(), a2[h(252)](), a2[h(252)]()]);
      return Wr(n5) + Wr(n5) + Wr(n5) + Wr(n5);
    }, Ur = function(n5) {
      var t5 = new Uint32Array(4);
      return n5.crypto.getRandomValues(t5), c2(t5, function(n6) {
        return jr(n6, 4);
      }).join("").split("");
    }, Qr = function(n5) {
      return n5.crypto.randomUUID().replace(/-/g, "");
    }, Vr = function(n5) {
      var t5;
      if (n5.crypto) {
        if (n5.crypto.subtle && n5.crypto.randomUUID)
          return Qr(n5);
        n5.crypto.getRandomValues && (t5 = Ur(n5));
      }
      return (t5 = t5 || Gr().split(""))[12] = "4", t5[16] = Tr(3 & parseInt(t5[16], 16) | 8), t5.join("");
    }, Yr = function(n5, t5) {
      for (var r5, e4, u4 = 0, c4 = [], i4 = 0; i4 < n5.length && (r5 = [], (e4 = n5.charCodeAt(i4)) < 128 ? r5.push(e4) : e4 < 2048 ? r5.push(192 | e4 >> 6, 128 | 63 & e4) : e4 < 55296 || 57344 <= e4 ? r5.push(224 | e4 >> 12, 128 | e4 >> 6 & 63, 128 | 63 & e4) : (e4 = 65536 + ((1023 & e4) << 10 | 1023 & n5.charCodeAt(++i4)), r5.push(240 | e4 >> 18, 128 | e4 >> 12 & 63, 128 | e4 >> 6 & 63, 128 | 63 & e4)), !t5 || u4 + r5.length <= t5); i4++)
        u4 += r5.length, c4.push.apply(c4, r5);
      return c4;
    }, Zr = function(n5) {
      return n5.toLowerCase();
    }, Jr = function(n5) {
      return n5.toUpperCase();
    }, Xr = function(n5) {
      return n5.length;
    }, $r = function(n5) {
      return Jr(n5.charAt(0)) + n5.slice(1);
    }, Kr = function(n5, t5) {
      return n5 + $r(t5);
    }, e2 = function(n5, t5) {
      return n5 + "." + t5;
    }, ne = function(n5) {
      return n5.replace(/[\x00-\x08\x0E-\x1F\x7F-\x9F]/g, "");
    }, te = function(n5) {
      return n5.replace(/\s/g, " ");
    }, re = function(n5) {
      return n5.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, " ");
    }, ee = function(n5) {
      return te(ne(re(n5 + "")));
    }, ue = function(n5) {
      return n5.toString();
    }, ce = h(40), ie = h(41), oe = h(42), ae = h(43), fe = h(44), _e = h(45), se = h(46), ve = h(47), he = h(48), de = h(49), le = h(50), pe = h(51), ge = h(52), ye = h(53), He = h(54), me = h(55), we = h(56), be = h(57), Ee = h(58), De = h(59), xe = h(60), Fe = h(61), Ce = h(62), Ie = h(63), ke = h(64), qe = h(65), Re = h(66), Se = h(67), Te = h(68), je = h(69), Ae = h(70), Be = h(71), Le = h(72), Ne = h(73), Oe = h(74), Me = h(75), ze = h(76), Pe = h(77), We = h(78), Ge = h(79), Ue = function(n5) {
      return g(n5)[oe];
    }, Qe = function(n5) {
      return g(n5)[ae];
    }, Ve = function(n5) {
      return g(n5)[se];
    }, Ye = function(n5) {
      return g(n5)[fe];
    }, Ze = function(n5) {
      return g(n5)[_e];
    }, Je = function(n5) {
      var t5 = g(n5);
      return t5[ve] || t5[Kr("user", ve)] || t5[Kr("browser", ve)] || t5[Kr("system", ve)];
    }, Xe = function(n5) {
      var t5 = Rt(n5);
      return p(t5[Ee]) ? t5[Ee] : t5[De];
    }, $e = function(n5) {
      return wt(Rt(n5).width);
    }, Ke = function(n5) {
      return wt(Rt(n5).height);
    }, nu = function(n5) {
      return wt(Rt(n5).availWidth);
    }, tu = function(n5) {
      return wt(Rt(n5).availHeight);
    }, ru = function(n5) {
      return wt(g(n5)[he]);
    }, eu = function(n5) {
      return wt(g(n5)[ie]);
    }, uu = function(n5) {
      return g(n5)[de];
    }, cu = function(n5) {
      return c2(uu(n5), function(n6) {
        return n6 && n6.type;
      });
    }, iu = function(n5) {
      return wt(n5.visualViewport);
    }, ou = function(n5) {
      return wt(n5.innerWidth);
    }, au = function(n5) {
      return wt(n5.outerHeight);
    }, fu = function(n5) {
      return g(n5).userAgentData;
    }, _u = function(n5) {
      return g(n5)[we];
    }, su = function(n5) {
      return g(n5)[Ae];
    }, vu = function(n5) {
      return c2(_u(n5), function(n6) {
        return n6.name + n6.description + n6.length + n6.filename;
      });
    }, hu = function(n5) {
      var t5 = g(n5);
      return Vt(t5[le]) && t5[le]() ? 1 : H;
    }, du = function(n5) {
      var t5 = g(n5);
      return me in t5 ? t5[me] : me in n5 ? n5[me] : Kr("ms", me) in t5 ? t5[Kr("ms", me)] : void 0;
    }, lu = function(n5) {
      return g(n5)[pe];
    }, pu = function(n5) {
      return g(n5)[ge];
    }, gu = function(n5) {
      return g(n5)[ye];
    }, yu = function(n5) {
      return g(n5)[Zr(ot)];
    }, Hu = function(n5) {
      return g(n5)[He];
    }, mu = function(n5) {
      return g(n5)[be];
    }, wu = function(n5) {
      return n5[xe] ? n5[xe].toString().length : y;
    }, bu = function(n5) {
      return g(n5)[Fe];
    }, Eu = function(n5) {
      return _(n5)[Ce];
    }, Du = function(n5) {
      return g(n5)[Be];
    }, xu = function(n5) {
      return n5[Le];
    }, Fu = function(n5) {
      return n5[Ne];
    }, Cu = function(n5) {
      return n5[Oe];
    }, Iu = function(n5) {
      return g(n5)[Pe];
    }, ku = function(n5) {
      return n5[We];
    }, qu = function() {
      var n5 = Fr();
      return n5.setTime(0), n5.toLocaleString();
    }, Ru = function(n5) {
      try {
        return Intl.DateTimeFormat()[Se]();
      } catch (t5) {
      }
    }, Su = function(n5) {
      var t5 = Ru();
      if (t5)
        return t5[Te];
    }, Tu = function(n5) {
      var t5 = Ru();
      if (t5)
        return t5[je];
    }, ju = function(n5) {
      return g(n5)[ve + "s"] || [];
    }, Au = function(n5) {
      var t5 = ju(n5), r5 = Tu(), e4 = Xt(t5);
      return r5 && (e4 ? ar(t5, r5) || (e4 = e4 + "," + r5) : e4 = r5), e4;
    }, Bu = function(n5) {
      return Dt(n5, Ie);
    }, Lu = function(n5) {
      return Dt(n5, ke);
    }, Nu = function(n5) {
      return Dt(n5, Re) || Dt(n5, qe);
    }, Ou = 0, Mu = 1, zu = 2, Pu = 3, Wu = 4, Gu = 5, Uu = 6, Qu = 7, Vu = 8, Yu = 9, Zu = 10, Ju = h(80).split(","), Xu = (Ju[Zu], 0), $u = 1, Ku = 2, nc = 3, tc = 4, rc = [{ t: Xu }, { t: Xu }, { t: $u, u: true }, { t: $u, u: true }, { t: $u, u: true }, { t: Ku, u: true }, { t: Ku, u: true }, { t: Ku, u: true }, { i: true, t: $u }, { i: true, t: Ku }, { t: nc }, { t: tc }], ec = 512, uc = 8192, cc = 500, ic = 200, oc = 1e3, ac = 1e3, fc = function(n5) {
      return z2[n5]++;
    }, _c = function(n5) {
      return z2[n5];
    }, sc = function() {
      return 0 < _c(Gu) || 0 < _c(Uu) || 0 < _c(Qu);
    }, vc = function(n5, t5) {
      3 === n5.o && (n5._[2] = n5._[1]), n5._[1] = n5._[0], n5._[0] = t5;
    }, hc = function(n5, t5, r5, e4, u4) {
      return void 0 === u4 && (u4 = 1), { v: n5, h: r5, l: e4, p: t5, _: Array(u4), o: u4, g: y };
    }, dc = function(n5, t5) {
      var r5;
      n5.h && !n5.h(n5, t5) || n5.p && Jt(n5.p, t5.H) < y || (vc(n5, t5), n5.l && !n5.l(n5)) || (r5 = n5.v) && !r5.apply(d, n5._) || n5.g++;
    }, lc = function(n5, t5) {
      return !n5 || !t5;
    }, pc = function(n5, t5, r5) {
      return !n5 || !t5 || !r5;
    }, gc = function(n5, t5) {
      return n5.D - t5.D == 0;
    }, yc = function(n5, t5) {
      if (0 !== n5 || 0 !== t5)
        return a2[h(256)](a2[h(250)](
          n5,
          2
        ) + a2[h(250)](t5, 2));
    }, Hc = function(n5, t5) {
      return Dr(n5.D, t5.D);
    }, mc = function(n5, t5) {
      var r5, e4;
      if (n5.F !== d && n5.C !== d && t5.F !== d && t5.C !== d)
        return r5 = n5.F - t5.F, e4 = n5.C - t5.C, yc(r5, e4);
    }, wc = function(n5, t5, r5) {
      if (!pc(n5, t5, r5)) {
        var e4 = r5.F - t5.F, u4 = r5.C - t5.C, c4 = n5.F - t5.F, i4 = n5.C - t5.C, o4 = e4 * c4 + u4 * i4, e4 = yc(e4, u4), u4 = yc(c4, i4);
        if (e4 && u4 && 2 < e4 && 2 < u4) {
          c4 = wr(o4 / (e4 * u4), 10);
          if (p(c4))
            return 180 * a2[h(257)](c4) / Math.PI;
        }
      }
    }, bc = function(n5, t5, r5) {
      var e4, u4, c4, i4, o4;
      if (!pc(n5, t5, r5) && n5.F !== d && n5.C !== d && n5.I !== d && t5.F !== d && t5.C !== d && t5.I !== d)
        return o4 = r5.F - t5.F, e4 = r5.C - t5.C, u4 = n5.F - t5.F, c4 = n5.C - t5.C, i4 = Dr(o4 * c4, u4 * e4), (o4 = yc(o4 - u4, e4 - c4)) ? i4 / o4 : 0;
    }, Ec = function(n5, t5) {
      var r5, e4;
      if (!lc(n5, t5) && !gc(n5, t5) && mc(n5, t5))
        return r5 = t5.F - n5.F, e4 = t5.C - n5.C, 180 * a2[h(258)](e4, r5) / Math.PI + 180;
    }, Dc = function(n5, t5) {
      if (!lc(n5, t5))
        return mc(n5, t5);
    }, xc = function(n5, t5) {
      if (!lc(n5, t5) && n5.F !== d && n5.C !== d && n5.I !== d && t5.F !== d && t5.C !== d && t5.I !== d)
        return a2[h(253)](10 * n5.F) + a2[h(253)](10 * n5.C) + a2[h(253)](10 * n5.I);
    }, Fc = function(n5, t5) {
      if (!lc(n5, t5))
        return Hc(n5, t5);
    }, Cc = function(n5, t5) {
      return lc(n5, t5) || n5.k !== t5.k ? void 0 : Hc(n5, t5);
    }, Ic = function(n5, t5) {
      return lc(n5, t5) || n5.k === t5.k ? void 0 : Hc(n5, t5);
    }, kc = function(n5) {
      return Jt(
        Sn,
        n5.k
      ) >= y;
    }, qc = function(n5, t5) {
      return n5 !== t5 && xr(n5) - xr(t5) === y;
    }, Rc = function(n5, t5) {
      return !!lc(n5, t5) || n5.F === d || n5.C === d || t5.F === d || t5.C === d || qc(n5.F, t5.F) || qc(n5.C, t5.C) || qc(n5.I, t5.I);
    }, Sc = 0, Tc = 1, jc = 2, Ac = 0, Bc = 1, Lc = 2, Nc = 3, Oc = function(n5, t5) {
      return P[n5] = t5;
    }, Mc = function(n5) {
      return P[n5];
    }, zc = function(n5) {
      return n5.q === y || 1 == n5.q && n5.H === Uu;
    }, Pc = function(n5) {
      var t5;
      return !!n5.R || !(t5 = Mc(Lc)) || n5.D - t5.D > cc;
    }, Wc = function(n5) {
      return !zc(n5);
    }, Gc = function(n5) {
      return !!n5._[1] && !!n5.p && n5._[0].H === n5.p[1] && n5._[1].H === n5.p[0];
    }, Uc = function(n5) {
      return !!n5._[1] && n5._[1].H === Uu && n5._[0].H != Uu;
    }, Qc = function(n5) {
      return !!n5._[1] && n5._[0].H === Uu && n5._[1].H != Uu;
    }, Vc = function(n5) {
      return !!n5._[1] && n5._[1].S == Sc && n5._[0].S == Tc;
    }, Yc = function(n5) {
      return !!n5._[1] && n5._[1].S == Tc && n5._[0].S == jc;
    }, Zc = function(n5) {
      return !!n5._[1] && n5._[1].S == jc && n5._[0].S == jc;
    }, Jc = function(n5) {
      return !!n5._[1] && n5._[1].S == Sc && n5._[0].S == Sc;
    }, Xc = 0.5, $c = function(n5) {
      var t5 = Er(n5.length - 2) + 1;
      n5.splice(t5, 1);
    }, Kc = function(n5, t5) {
      var r5;
      return n5.length ? (r5 = p(t5) ? t5 : Xc, r5 = (n5.length - 1) * r5, Ut(r5) ? n5[r5] : (r5 = a2[h(249)](r5)) + 1 <= n5.length ? (n5[r5] + n5[r5 + 1]) / 2 : n5[r5]) : d;
    }, ni = function(n5, t5) {
      n5.push(t5);
      for (var r5 = n5.length - 1, e4 = n5[r5]; 0 < r5 && e4 < n5[r5 - 1]; )
        n5[r5] = n5[r5 - 1], --r5;
      n5[r5] = e4;
    }, ti = function(n5) {
      return { T: [], j: p(n5) ? n5 : ic };
    }, ri = function(n5) {
      if (n5.T.length < 2)
        return d;
      var t5 = ei(n5, Xc);
      if (t5 == d)
        return d;
      for (var r5 = [], e4 = 0, u4 = n5.T; e4 < u4.length; e4++) {
        var c4 = u4[e4];
        ni(r5, Dr(c4, t5));
      }
      return Kc(r5, Xc);
    }, ei = function(n5, t5) {
      return Kc(n5.T, t5);
    }, ui = function(n5, t5) {
      var r5 = n5.T;
      r5.length >= n5.j && $c(r5), ni(r5, t5);
    }, ci = function(n5, t5) {
      var r5 = { A: d, B: ti(t5), g: y, L: y, N: y, O: H, M: H };
      return n5 && (r5.P = ti(t5)), r5;
    }, ii = function(n5, t5) {
      var r5, e4;
      n5.g++, n5.L += t5, ui(n5.B, t5), p(n5.A) ? (r5 = Dr(t5, n5.A), n5.N += r5, n5.P && (e4 = n5.A + t5, ui(n5.P, e4 == y ? y : r5 / n5.A + t5)), t5 > n5.M && (n5.M = t5), t5 < n5.O && (n5.O = t5)) : n5.O = n5.M = t5, n5.A = t5;
    }, s2 = function(n5, t5, r5, e4, u4, c4, i4, o4) {
      return void 0 === c4 && (c4 = 2), { v: n5, h: e4, l: u4, p: r5, _: Array(c4), W: t5, G: 0, o: c4, U: ci(i4, o4) };
    }, o2 = function(n5, t5) {
      var r5;
      n5.p && Jt(n5.p, t5.H) < y || n5.h && !n5.h(t5) || (n5.W && !n5.G && (n5.G = 1), vc(n5, t5), n5.l && !n5.l(n5)) || (n5.W && n5.W.apply(d, n5._) ? (n5.G++, void 0) : (r5 = n5.v.apply(d, n5._), Gt(r5) && ii(n5.U, r5)));
    }, oi = function(n5) {
      n5._ = Array(n5.o), n5.U = ci(!!n5.U.P, n5.U.B.j), n5.G = 0;
    }, n4 = function(r5) {
      return function(n5, t5) {
        if (n5 && t5)
          return n5.D - t5.D > r5;
      };
    }, ai = n4(cc), fi = n4(1e3), _i = function(n5, t5) {
      var r5;
      if (n5 && t5)
        return Jt(Tn, n5.k) >= y || Jt(Tn, t5.k) > y || !!((r5 = Mc(Bc)) && r5.D > t5.D) || void 0;
    }, si = function(n5) {
      return 1 < n5.g ? wr(br(n5.N, n5.g - 1)) : d;
    }, vi = function(n5) {
      return wr(br(n5.L, n5.g));
    }, u = function(n5) {
      return wr(ei(n5.B));
    }, hi = function(n5) {
      return n5.P && wr(ei(n5.P));
    }, i = function(n5) {
      return wr(ri(n5.B));
    }, di = function(n5) {
      return n5.P && wr(ri(n5.P));
    }, li = function(n5) {
      return wr(n5.M);
    }, pi = function(n5) {
      return wr(n5.O);
    }, gi = function(n5) {
      return wr(n5.L);
    }, yi = function(n5) {
      var t5, r5, e4;
      Pc(n5) && (o2(vn, n5), r5 = i(Cn.U), Gt(r5) && ii(mn, r5), t5 = u(Cn.U), Gt(t5) && ii(wn, t5), e4 = di(Cn.U), Gt(e4) && ii(bn, r5), e4 = hi(Cn.U), Gt(e4) && ii(En, t5), r5 = gi(Cn.U), Gt(r5) && ii(Dn, r5), e4 = gi(In.U), Gt(e4) && ii(xn, e4), Gt(r5) && Gt(e4) && 0 < e4 && ii(Fn, r5 / e4), oi(Cn), oi(In));
    }, Hi = function(n5, t5, r5) {
      var e4 = n5.H;
      if (Gt(e4)) {
        var u4, c4 = t5[e4], i4 = Mc(Nc);
        switch (o2(Hn, n5), c4.t) {
          case Xu:
            p(n5.k) ? (o2(nn, n5), o2(tn, n5), o2(fn2, n5), o2(rn, n5), o2(un, n5), o2(cn, n5), o2(en, n5), o2(ln, n5), o2(pn, n5), o2(gn, n5), o2(yn, n5), dc(W, n5)) : dc(U, n5);
            break;
          case nc:
            o2(on, n5);
            break;
          case tc:
            dc(G, n5);
            break;
          case Ku:
            c4.i ? (o2(J, n5), o2(X, n5), o2($, n5)) : (o2(hn, n5), o2(dn, n5), dc(Q, n5));
            break;
          case $u:
            c4.i && (o2(V, n5), o2(Y, n5), o2(Z, n5), o2(_n, n5), o2(sn, n5), yi(n5), o2(Cn, n5), o2(In, n5)), t5[e4].u && (o2(K, n5), o2(an, n5), o2(fn2, n5));
        }
        r5 && r5.rEv(n5), c4.t != Xu && Oc(Bc, n5), i4 && Gt(i4.H) && i4.R && (u4 = t5[i4.H]).t == $u && u4.i && yi(i4), c4.t == $u && c4.i && (Oc(Lc, n5), Mc(Ac) || (Oc(Ac, n5), o2(vn, n5))), Oc(Nc, n5);
      }
    }, mi = /[a-zA-Z]/, wi = /\d/, bi = function(n5) {
      return !p(n5) || 1 < n5.length ? jc : mi.test(n5) ? Sc : wi.test(n5) ? Tc : jc;
    }, Ei = h(81), Di = h(82), xi = function(n5) {
      return Jt(Ju, n5 && n5.type);
    }, Fi = function(n5, t5) {
      var r5, e4;
      t5 && (r5 = t5.clientX, e4 = t5.clientY), n5.F = p(r5) ? r5 : d, n5.C = p(r5) ? e4 : d;
    }, Ci = function(n5, t5, r5) {
      var e4 = xi(n5), u4 = { H: e4, D: t5 };
      switch (rc[e4].t) {
        case $u:
          Fi(u4, n5), u4.k = n5.button;
          break;
        case Xu:
          u4.V = p(n5.keyCode) ? n5.keyCode : n5.which, u4.Y = n5.code, u4.k = p(u4.Y) ? u4.Y : p(u4.V) ? u4.V + "" : d, u4.Z = p(n5.key) ? n5.key : p(u4.V) ? String.fromCharCode(u4.V) : d, u4.S = bi(u4.Z);
          break;
        case tc:
          u4.F = n5.deltaX, u4.C = n5.deltaY, u4.I = n5.deltaZ;
          break;
        case Ku:
          var c4 = n5[Ei];
          p(c4) && (Fi(u4, c4[0]), u4.q = c4.length);
          break;
        case nc:
          c4 = n5[Di];
          c4 ? (u4.F = c4.alpha, u4.C = c4.beta, u4.I = c4.gamma) : u4.F = u4.C = u4.I = d;
      }
      r5 && r5.pEv(u4, n5);
      e4 = Mc(Nc);
      return e4 && e4.H != u4.H && (e4.R = true), u4;
    }, Ii = lt, ki = function(n5, t5, r5) {
      return r5[t5].t === nc ? n5 : _(n5);
    }, qi = function(n5, t5, r5, e4) {
      var u4 = t5.H, c4 = e4[u4];
      fc(u4) >= (c4.i ? uc : ec) && yr(ki(n5, u4, e4), r5[u4], kn);
    }, Ri = function(n5, t5, r5, e4, u4) {
      var c4 = Si(n5, t5, e4, u4);
      Ii(), qi(n5, c4, r5, e4);
    }, Si = function(n5, t5, r5, e4) {
      var u4 = Ci(t5, Cr(), e4);
      return Hi(u4, r5, e4), u4;
    }, t4 = h(83), r4 = h(84), n4 = h(85), Ti = h(86), ji = [t4, r4, n4], Ai = false, Bi = function(n5, t5, r5, e4, u4) {
      t5.query({ name: n5 }).then(function(n6) {
        var t6 = n6.state;
        Ai || t6 === Ti && (Ai = true, gr(r5, e4, u4));
      })["catch"](lt);
    }, Li = function(n5, t5, r5, e4) {
      for (var u4 = yu(n5), c4 = r5.length - 1; 0 <= c4; c4--) {
        var i4 = ki(n5, c4, e4);
        if (c4 === Zu && u4 && u4.query)
          for (var o4 = ji.length - 1; 0 <= o4; o4--)
            Bi(ji[o4], u4, i4, r5[c4], t5);
        else
          gr(i4, r5[c4], t5);
      }
    }, Ni = function(n5, t5, r5) {
      Ii = yt(n5, t5, r5);
    }, Oi = 300, Mi = function(t5, n5, r5, e4, u4) {
      Ni(n5, Oi), Li(t5, kn = function(n6) {
        return Ri(t5, n6, r5, e4, u4);
      }, r5, e4);
    }, zi = 10, Pi = function() {
      var n5;
      return _c(Zu) > zi && (null != (n5 = si(on.U)) ? n5 : y) > zi;
    }, Wi = function() {
      var n5 = Mc(Ac);
      return !!n5 && n5.F === y && n5.C === y;
    }, Gi = function(n5) {
      return [0 < nn.U.g, sc(), 0 < _c(zu), 0 < U.g, Pi(), 0 < W.g, 0 < Q.g, Wi()];
    }, Ui = function() {
      var n5 = sc() ? V : J, t5 = u(ln.U), r5 = i(ln.U);
      return [
        si(Y.U),
        si(X.U),
        vi(tn.U),
        vi(cn.U),
        vi(K.U),
        si(n5.U),
        u(an.U),
        i(an.U),
        u(K.U),
        i(K.U),
        u(fn2.U),
        i(fn2.U),
        u(un.U),
        i(un.U),
        u(cn.U),
        i(cn.U),
        u(rn.U),
        i(rn.U),
        u(en.U),
        i(en.U),
        u(_n.U),
        i(_n.U),
        u(sn.U),
        i(sn.U),
        u(vn.U),
        i(vn.U),
        pi(vn.U),
        li(vn.U),
        u(dn.U),
        i(dn.U),
        u(hn.U),
        i(hn.U),
        Dr(u(pn.U), t5),
        Dr(i(pn.U), r5),
        Dr(u(gn.U), t5),
        Dr(i(gn.U), r5),
        Dr(u(yn.U), t5),
        Dr(i(yn.U), r5),
        u(wn),
        i(mn),
        u(En),
        i(bn),
        hi(Z.U),
        di(Z.U),
        u(xn),
        i(xn),
        u(Dn),
        i(Dn),
        u(Fn),
        i(Fn),
        gi(Z.U),
        u(Hn.U),
        i(Hn.U)
      ];
    }, t4 = 8, Qi = t4 - 1, Vi = a2[h(250)](2, Qi), Yi = a2[h(250)](2, t4) - 1, Zi = (Yi - Vi) / (13 - Qi), Ji = function(n5) {
      return n5 < Vi ? n5 : a2[h(255)](Yi, a2[h(249)]((a2[h(259)](n5) * Math.LOG2E - Qi) * Zi + Vi));
    }, Xi = function() {
      return [Ji(_c(Vu)), Ji(_c(Ou)), Ji(_c(zu)), Ji(_c(Uu)), Ji(_c(Mu)), Ji(_c(Yu)), Ji(Dr(_c(Wu), _c(Pu))), Ji(1 < Dn.g ? Dn.g - 1 : y), Ji(G.g)];
    }, $i = function(n5, t5) {
      var r5 = n5.length;
      return Array.prototype.unshift.apply(n5, Array.prototype.splice.call(n5, t5 % r5, r5)), n5;
    }, Ki = function(n5, t5) {
      return $i(n5.split(""), t5).join("");
    }, no = function(n5, t5, r5, e4) {
      var u4 = Ki(n5.slice(0, t5), parseInt(r5, 16));
      return kr(e4, u4);
    }, to = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", ro = function(n5, t5) {
      if (n5.btoa)
        return n5.btoa(t5);
      for (var r5, e4 = "", u4 = 0, c4 = 0, i4 = to; t5.charAt(0 | c4) || (i4 = "=", c4 % 1); e4 += i4.charAt(63 & u4 >> 8 - c4 % 1 * 8)) {
        if (r5 = t5.charCodeAt(c4 += 3 / 4), st < r5)
          return d;
        u4 = u4 << 8 | r5;
      }
      return e4;
    }, eo = function(n5, t5) {
      var r5 = ro(n5, t5);
      return null == r5 ? null : r5.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    }, r4 = 4, n4 = 3, t4 = (uo.prototype.e = function(n5) {
      var t5 = function(n6) {
        var t6 = 2, r6 = y, e5 = y;
        if (0 === n6)
          return { s: y, m: y, e: y };
        for (n6 < y && (r6 = 1, n6 = -n6); t6 <= n6; )
          n6 /= t6, e5++;
        for (; n6 < 1; )
          n6 *= t6, e5--;
        return { s: r6, m: n6, e: e5 };
      }(n5), r5 = (r5 = t5.e, e4 = (1 << this.exp) - 1, a2[h(255)](r5, e4)), e4 = function(n6, t6) {
        var r6 = n6 - a2[h(249)](n6), e5 = y;
        if (0 < r6)
          for (var u4 = 1, c4 = r6; !(0 === c4 || t6 < u4); ) {
            c4 *= 2;
            var i4 = a2[h(249)](c4);
            e5 |= i4 << t6 - u4, c4 -= i4, u4++;
          }
        return e5;
      }(t5.m, this.man);
      return r5 << this.man | e4;
    }, uo.prototype.d = function(n5) {
      var t5 = n5 >> this.man & this.a, r5 = n5 & this.b, e4 = this.man;
      return (r5 / a2[h(250)](2, e4) + 1) * a2[h(250)](2, t5);
    }, uo);
    function uo(n5, t5) {
      this.exp = n5, this.man = t5, this.a = (1 << n5) - 1, this.b = (1 << t5) - 1;
    }
    var co, x2, io, oo, ao, fo, _o, so, vo, ho, lo, po, go = new t4(r4, n4), yo = new t4(r4 - 2, n4 + 1), Ho = a2[h(250)](2, 16), mo = function(n5) {
      var t5;
      return Gt(n5) ? (t5 = a2[h(260)](n5, 0)) <= 15 ? 64 | yo.e(t5 + 1) : 128 | go.e(a2[h(255)](t5, Ho) - 14) : 0;
    }, wo = function(n5) {
      for (var t5 = "", r5 = 0, e4 = n5; r5 < e4.length; r5++) {
        var u4 = e4[r5];
        t5 += D(mo(u4));
      }
      return t5;
    }, bo = function(n5) {
      var t5 = a2[h(249)](n5 / 1e3 - dt), t5 = a2[h(260)](a2[h(255)](t5, 268435455), 0);
      return Br([t5 >> 24, t5 >> 16, t5 >> 8, t5]);
    }, Eo = function(n5) {
      var t5 = parseInt(n5.toString().slice(-3), 10);
      return jr(t5, 2);
    }, Do = function(n5) {
      var t5 = Tr(Er(vt));
      return Fo(n5, t5);
    }, xo = function(n5, t5) {
      var r5 = Tr(Er(vt));
      return Fo(n5, r5) + Fo(t5, r5);
    }, Fo = function(n5, t5) {
      return kr(n5.slice(1), t5) + t5;
    }, Co = function(n5, t5) {
      for (var r5, e4 = 3 & n5.length, u4 = n5.length - e4, c4 = t5, i4 = 3432918353, o4 = 461845907, a4 = 0, f4 = 0; a4 < u4; )
        f4 = 255 & n5.charCodeAt(a4) | (255 & n5.charCodeAt(++a4)) << 8 | (255 & n5.charCodeAt(++a4)) << 16 | (255 & n5.charCodeAt(++a4)) << 24, ++a4, c4 = (65535 & (r5 = 5 * (65535 & (c4 = (c4 ^= f4 = (65535 & (f4 = (f4 = (65535 & f4) * i4 + (((f4 >>> 16) * i4 & 65535) << 16) & 4294967295) << 15 | f4 >>> 17)) * o4 + (((f4 >>> 16) * o4 & 65535) << 16) & 4294967295) << 13 | c4 >>> 19)) + ((5 * (c4 >>> 16) & 65535) << 16) & 4294967295)) + 27492 + (((r5 >>> 16) + 58964 & 65535) << 16);
      switch (f4 = 0, e4) {
        case 3:
          f4 ^= (255 & n5.charCodeAt(a4 + 2)) << 16;
        case 2:
          f4 ^= (255 & n5.charCodeAt(a4 + 1)) << 8;
        case 1:
          c4 ^= f4 = (65535 & (f4 = (f4 = (65535 & (f4 ^= 255 & n5.charCodeAt(a4))) * i4 + (((f4 >>> 16) * i4 & 65535) << 16) & 4294967295) << 15 | f4 >>> 17)) * o4 + (((f4 >>> 16) * o4 & 65535) << 16) & 4294967295;
      }
      return c4 = 2246822507 * (65535 & (c4 = (c4 ^= n5.length) ^ c4 >>> 16)) + ((2246822507 * (c4 >>> 16) & 65535) << 16) & 4294967295, ((c4 = 3266489909 * (65535 & (c4 ^= c4 >>> 13)) + ((3266489909 * (c4 >>> 16) & 65535) << 16) & 4294967295) ^ c4 >>> 16) >>> 0;
    }, Io = h(87), ko = function(n5) {
      return g(n5)[Io];
    }, qo = 0, Ro = "__cid", So = "__ctst", To = Array(1024).join("x"), r4 = h(88), jo = r4 + "missing or wrong publishableKey", Ao = r4 + "missing user or event data", Bo = r4 + "missing configuration", Lo = Rn(1970), No = 500, Oo = 100, Mo = h(89), zo = h(90), F = { J: false, X: true, $: h(91), K: 1e3, nn: { tn: "__cuid", rn: 3456e4 }, en: true }, C = function() {
      return F;
    }, Po = function(n5) {
      var t5 = C();
      t5.un && t5.un(n5);
    }, I = function(n5) {
      try {
        return n5();
      } catch (t5) {
        Po(t5);
      }
    }, Wo = h(92), Go = h(93), Uo = h(94), Qo = h(95), Vo = h(96), Yo = h(97), Zo = h(98), Jo = h(99), Xo = h(100), $o = h(101), Ko = h(102), na = h(103), ta = h(104), ra = 2 * Math.PI, ea = [["#f0f", 50, 50], ["#0ff", 100, 50], ["#f70", 75, 100]], ua = function(n5) {
      return !!(n5 && n5.getContext && n5.toDataURL);
    }, ca = function(n5) {
      var t5 = w(n5, Go), t5 = t5.getContext(Jo) || t5.getContext(Xo + Jo), r5 = t5 && t5.getExtension($o);
      return r5 ? t5.getParameter(r5.UNMASKED_RENDERER_WEBGL) : H;
    }, ia = function(n5) {
      var t5 = n5.toDataURL();
      if (t5)
        return Co(t5).toString(16);
    }, oa = function(n5, t5) {
      n5.fillStyle = t5;
    }, aa = function(n5, t5, r5, e4, u4) {
      n5.fillRect(t5, r5, e4, u4);
    }, fa = function(n5, t5, r5, e4) {
      n5.fillText(t5, r5, e4);
    }, _a = function(n5, t5) {
      n5.font = t5;
    }, sa = function(n5, t5, r5) {
      n5.width = t5, n5.height = r5;
    }, va = function(n5) {
      n5.beginPath();
    }, ha = function(n5) {
      n5.closePath();
    }, da = function(n5, t5, r5, e4, u4) {
      n5.arc(75, 75, 75, 0, ra, true);
    }, la = function(n5, t5) {
      t5 ? n5.fill(t5) : n5.fill();
    }, pa = function(n5, t5) {
      sa(n5, 500, 100);
      var r5 = Wo + String.fromCharCode(55357, 56836);
      return t5.textBaseline = Ko, oa(t5, "#f60"), aa(t5, 125, 1, 62, 20), oa(t5, "#069"), _a(t5, Uo), fa(t5, r5, 2, 20), oa(t5, Vo), _a(t5, Qo), fa(t5, r5, 4, 22), ia(n5);
    }, ga = function(n5, t5) {
      sa(n5, 400, 200), t5.globalCompositeOperation = na;
      for (var r5 = 0, e4 = ea; r5 < e4.length; r5++) {
        var u4 = e4[r5], c4 = u4[0];
        u4[1], u4[2], oa(t5, c4), va(t5), da(t5), ha(t5), la(t5, H);
      }
      return oa(t5, "#70f"), da(t5), da(t5), la(t5, Yo), ia(n5);
    }, ya = function(n5) {
      var t5 = w(n5, Go), r5 = ua(t5) ? t5.getContext(Zo) : H;
      if (r5)
        return { cn: I(function() {
          return pa(
            t5,
            r5
          );
        }), on: I(function() {
          return ga(t5, r5);
        }), an: I(function() {
          return ca(n5);
        }) };
    }, Ha = 8, ma = 255, wa = { willReadFrequently: true, desynchronized: true }, ba = function(n5, t5, r5, e4) {
      var u4 = n5.getContext(Zo, e4 = void 0 === e4 ? {} : e4);
      return n5.width = t5, n5.height = r5, u4;
    }, Ea = function() {
      return Er(256);
    }, Da = function(n5, t5) {
      n5.clearRect(0, 0, t5, t5);
    }, xa = function(n5) {
      for (var t5 = [], r5 = 0; r5 < Ha; r5++)
        for (var e4 = 0; e4 < Ha; e4++) {
          var u4 = "".concat(Ea(), ", ").concat(Ea(), ", ").concat(Ea(), ", ").concat(ma);
          oa(n5, "rgba(".concat(u4, ")")), aa(n5, r5, e4, 1, 1), t5.push(u4);
        }
      return t5;
    }, Fa = function(n5) {
      for (var t5 = [], r5 = 0; r5 < Ha; r5++)
        for (var e4 = 0; e4 < Ha; e4++) {
          var u4 = (n5[ta](r5, e4, 1, 1) || {}).data, c4 = u4[0], i4 = u4[1], o4 = u4[2], u4 = u4[3], c4 = "".concat(c4, ", ").concat(i4, ", ").concat(o4, ", ").concat(u4);
          t5.push(c4);
        }
      return t5;
    }, Ca = function(n5) {
      var t5 = w(n5, Go);
      if (ua(t5)) {
        var t5 = ba(t5, Ha, Ha, wa), r5 = xa(t5), e4 = Fa(t5);
        Da(t5, Ha);
        for (var u4 = 0; u4 < r5.length; u4++)
          if (r5[u4] != e4[u4])
            return true;
      }
      return false;
    }, Ia = h(105), ka = h(106), qa = h(107), Ra = function(n5) {
      var t5 = Rt(n5);
      return p(t5[Ia]) && p(t5[ka]) && t5[Ia] > t5[ka] ? br(t5[Ia], t5[ka]) : p(n5[qa]) ? n5[qa] : 1;
    }, Sa = function() {
      var n5 = [].constructor;
      try {
        (-1).toFixed(-1);
      } catch (t5) {
        return Xr(t5.message) + Xr((n5 + "").split(n5.name).join(""));
      }
    }(), Ta = 80 == Sa, ja = 58 == Sa, Aa = 77 == Sa, Ba = h(108), La = h(109), Na = h(110), Oa = h(111), Ma = h(112), za = h(113), Pa = h(114), Wa = h(115), Ga = h(116), Ua = h(117), Qa = h(118), Va = h(119), Ya = h(120), Za = h(121), Ja = h(122), Xa = h(123), $a = h(124), Ka = h(125), nf = h(126), n4 = h(127), t4 = h(128), r4 = h(129), tf = h(130), rf = h(131), ef = h(132), uf = h(133), cf = h(134), of = h(135), af = h(136), ff = h(137), _f = h(138), sf = h(139), vf = h(140), hf = h(141), df = h(142), lf = h(143), pf = h(144), gf = h(145), yf = h(146), Hf = h(147), mf = h(148), wf = h(149), bf = function(n5, t5) {
      return n5[mf] ? n5[mf](t5) : !(!n5[wf][t5] || !n5[wf][t5].specified);
    }, Ef = [n4, t4, r4], Df = function(n5) {
      return -1 < Jt(n5, true);
    }, xf = function(n5) {
      return !!n5["__".concat(Ka)];
    }, Ff = function(n5) {
      return Df([Ef[0] in n5, Ef[1] in n5, Ef[2] in n5]);
    }, Cf = function(n5) {
      return g(n5)[$a];
    }, If = function(n5) {
      var t5 = n5, r5 = _(n5), e4 = Tt(n5);
      return Df([
        $a in t5,
        "_".concat(cf) in t5,
        Oa in t5,
        "_".concat(uf) in t5,
        "__".concat($a, "_").concat(rf) in r5,
        "__".concat(Va, "_").concat(Ya) in r5,
        "__".concat($a, "_").concat(Ya) in r5,
        "__".concat(uf, "_").concat(Ya) in r5,
        "__fx".concat(Va, "_").concat(Ya) in r5,
        "__".concat(Va, "_").concat(_f) in r5,
        "__".concat($a, "_").concat(_f) in r5,
        "__".concat(uf, "_").concat(_f) in r5,
        "__fx".concat(Va, "_").concat(_f) in r5,
        "__".concat($a, "_").concat(rf) in r5,
        "__".concat($a, "_").concat(ef) in r5,
        bf(e4, uf),
        bf(e4, $a),
        bf(e4, Va)
      ]);
    }, kf = function(n5) {
      return !!n5.external && Vt(n5.external.toString) && Et(n5.external.toString(), of);
    }, qf = function(n5) {
      return !(!n5[Ua] && !n5["".concat(Ua, "Controller")]);
    }, Rf = function(n5) {
      return !!n5.spawn;
    }, Sf = function(n5) {
      return !!n5.emit;
    }, Tf = function(n5) {
      return !!n5.Buffer;
    }, jf = function(n5) {
      var t5 = new RegExp(Ja);
      return t5.test(Ye(n5)) || t5.test(Ze(n5));
    }, Af = h(150), Bf = h(151), Lf = h(152), Nf = function(n5) {
      var t5, r5, e4 = g(n5), u4 = _(n5), c4 = 0;
      p(e4[Af]) ? c4 = e4[Af] : (r5 = e4["ms".concat(Af)], p(e4[r5]) && (c4 = e4[r5]));
      try {
        u4.createEvent(Bf), t5 = true;
      } catch (i4) {
        t5 = false;
      }
      return { fn: c4, _n: t5, sn: "on".concat(Lf) in n5 };
    }, n4 = h(153), Of = Gn + n4, Mf = Wn + n4, zf = 0, Pf = 1, Wf = 2, Gf = h(154), Uf = h(155), Qf = h(156), Vf = h(157), Yf = function(n5, t5, r5) {
      return Vt(n5.matchMedia) && r5 != n5.matchMedia(t5).matches;
    }, Zf = function(n5, u4) {
      var t5, r5, e4 = g(n5), c4 = [];
      try {
        var i4 = Ye(n5), o4 = Et(i4, Qf) && Et(i4, Vf), a4 = e4[Uf];
        a4 && a4[Gf] && !o4 ? (c4 = [false, false, false], t5 = function(n6) {
          if (n6)
            for (var t6 = 0, r6 = n6; t6 < r6.length; t6++) {
              var e5 = r6[t6].kind;
              e5 !== Mf && e5 !== Wn || (c4[zf] = true), e5 === Mf && (c4[Pf] = true), e5 !== Of && e5 !== Gn || (c4[Wf] = true);
            }
          u4(c4);
        }, void ((r5 = a4[Gf]()) && r5.then ? r5.then(t5, function() {
          return u4(c4);
        }) : u4(c4))) : u4(c4);
      } catch (f4) {
        u4(c4);
      }
    }, Jf = h(158), Xf = function() {
      return Fr()[Jf]();
    }, $f = function() {
      var n5 = Fr(), t5 = (n5.setDate(1), n5.setMonth(0), n5[Jf]());
      return n5.setMonth(6), Dr(t5, n5[Jf]());
    }, Kf = function(n5) {
      var t5 = [];
      if (!It())
        return t5;
      var r5 = g(n5), e4 = r5;
      do
        for (var u4 = 0, c4 = xt(e4); u4 < c4.length; u4++) {
          var i4 = c4[u4];
          t5.push(i4);
        }
      while (e4 = Ft(e4));
      for (var o4, a4 = [], f4 = 0, _4 = t5; f4 < _4.length; f4++) {
        var i4 = _4[f4], s4 = Ct(Ft(r5), i4);
        p(s4) ? mt(s4.value) ? o4 = s4.value.toString() : mt(s4.get) && (o4 = s4.get.toString()) : o4 = "", a4.push("".concat(i4, "~~~").concat(o4));
      }
      return a4;
    }, n_ = h(159), t_ = h(160), r_ = h(161), e_ = function(n5, t5) {
      switch (n5[r_](t5.replace("'", '"'))) {
        case n_:
          return 2;
        case t_:
          return 1;
        case "":
          return 0;
        default:
          return 3;
      }
    }, u_ = function(n5, t5) {
      return e_(n5, "".concat(Wn, "/").concat(t5));
    }, c_ = function(n5, t5) {
      return e_(n5, "".concat(Gn, "/").concat(t5));
    }, t4 = h(162), r4 = h(163), n4 = h(164), i_ = h(165), o_ = "".concat(t4, "; ").concat(i_, '="').concat(n4, '"'), a_ = h(166), f_ = "".concat(r4, "; ").concat(i_, "=1"), __ = h(167), s_ = h(168), v_ = function(n5) {
      var t5 = w(n5, Wn);
      return [u_(t5, s_), u_(t5, __), u_(t5, f_), u_(t5, a_), u_(t5, o_)];
    }, n4 = h(169), r4 = h(170), h_ = h(171), d_ = h(172), l_ = h(173), p_ = "".concat(t4, "; ").concat(i_, '="').concat(n4, '"'), g_ = "".concat(d_, "; ").concat(i_, '="').concat(r4, '"'), y_ = "".concat(l_, "; ").concat(i_, '="').concat(h_, '"'), H_ = function(n5) {
      var t5 = w(n5, Gn);
      return [c_(t5, y_), c_(t5, g_), c_(t5, p_)];
    }, m_ = function(n5) {
      try {
        return H_(n5).concat(v_(n5));
      } catch (t5) {
        return [];
      }
    }, w_ = function() {
      co++, w_();
    }, b_ = function() {
      co = 0;
      try {
        w_();
      } catch (n5) {
        return { vn: co, hn: n5.message, dn: n5.name, ln: n5.stack ? n5.stack.toString().length : y };
      }
      return { vn: y, hn: "", dn: "", ln: y };
    }, E_ = function() {
      try {
        return (void 0).b, "";
      } catch (n5) {
        return n5.message;
      }
    }, D_ = function() {
      try {
        throw "";
      } catch (n5) {
        try {
          return n5.toSource(), true;
        } catch (t5) {
        }
      }
      return false;
    }, x_ = h(174), F_ = "".concat(x_, "."), C_ = h(175), I_ = h(176), k_ = h(177), q_ = h(178), R_ = h(179), S_ = h(180), T_ = "Internal".concat(S_), j_ = "Range".concat(S_), A_ = 1, B_ = 2, L_ = 3, N_ = 4, O_ = 5, M_ = 6, k = 7, z_ = function(n5) {
      for (var t5 = 0; 0 != n5; )
        n5 >>= 8, t5++;
      return t5;
    }, P_ = function(n5) {
      var t5 = Yr(ee(n5), st);
      return D(t5.length) + Br(t5);
    }, W_ = function(n5, t5) {
      var r5 = Yr(ee(n5), t5), e4 = z_(r5.length);
      return gt < e4 ? D(y) : D(e4) + jr(r5.length, e4) + Br(r5);
    }, G_ = function(n5, t5) {
      return D((31 & n5) << 3 | 7 & t5);
    }, U_ = function(n5, t5, r5) {
      var e4 = G_(n5, t5);
      switch (t5) {
        case M_:
          e4 += D(a2[h(251)](10 * r5));
          break;
        case L_:
          e4 += D(r5);
          break;
        case O_:
          e4 += r5 <= 127 ? D(r5) : jr(1 << 15 | 32767 & r5, 2);
          break;
        case N_:
          e4 += P_(r5);
          break;
        case B_:
        case A_:
          break;
        case k:
          e4 += r5;
      }
      return e4;
    }, Q_ = 0, V_ = 1, Y_ = 2, Z_ = 3, J_ = 4, X_ = 5, $_ = 6, K_ = 7, n1 = 8, t1 = 9, r1 = 10, e1 = 11, u1 = 12, c1 = 13, i1 = 14, o1 = 15, a1 = 16, f1 = 17, _1 = 18, s1 = 19, v1 = 20, h1 = 21, d1 = 22, l1 = 23, p1 = 24, g1 = 25, y1 = 26, H1 = 27, m1 = 28, w1 = 29, b1 = 30, E1 = 31, D1 = 0, x1 = 1, F1 = 2, C1 = 5, I1 = 6, k1 = 10, q1 = 11, R1 = 12, S1 = 13, T1 = 14, j1 = 15, A1 = 16, B1 = 17, L1 = 18, N1 = 19, O1 = 20, M1 = 21, z1 = 22, P1 = 23, W1 = function(n5, t5, r5, e4) {
      try {
        var u4 = n5.localStorage;
        u4 || e4(), u4.setItem(t5, r5), u4.getItem(t5) !== r5 && (u4.removeItem(t5), e4());
      } catch (c4) {
        e4();
      }
    }, G1 = function(n5, t5) {
      try {
        var r5 = n5.localStorage;
        return r5 ? r5.getItem(t5) : d;
      } catch (e4) {
        return d;
      }
    }, U1 = function(n5, t5) {
      try {
        var r5 = n5.localStorage;
        if (r5)
          return r5.removeItem(t5);
      } catch (e4) {
      }
    }, Q1 = { en: false, J: false, pn: false, gn: false }, V1 = function() {
      return Q1;
    }, Y1 = h(181), Z1 = h(182), J1 = h(183), X1 = h(184), $1 = h(185), K1 = h(186), n0 = h(187), t0 = Jn, r0 = h(188), e0 = h(189), u0 = h(190), c0 = h(191), i0 = h(192), o0 = h(193), a0 = h(194), f0 = h(195), _0 = h(196), s0 = h(197), v0 = h(198), h0 = h(199), d0 = h(200), l0 = h(201), p0 = h(202), g0 = h(203), y0 = h(204), H0 = h(205), m0 = h(206), w0 = h(207), b0 = h(208), E0 = e2(at, Jn), D0 = e2(ot, qn), x0 = e2("CSSStyleDeclaration", h(262)), F0 = h(209), C0 = false, I0 = false, k0 = function(n5) {
      return new Proxy(n5, {});
    }, q0 = {}, R0 = e2(a0, _0), S0 = function(n5) {
      return !new RegExp(R0).test(n5);
    }, T0 = function(n5) {
      return !new RegExp(t0).test(n5);
    }, j0 = h(210), A0 = h(211), B0 = h(212), L0 = function(n5, t5) {
      if (n5[j0])
        try {
          var r5 = n5[j0]["version"], e4 = r5 ? n5[j0][r5].defaultCurrentScope : n5[j0].hub;
          return nr(e4.getClient(), t5);
        } catch (u4) {
          Po(u4);
        }
    }, N0 = function(n5) {
      return p(n5[A0]);
    }, O0 = function(n5, t5) {
      var r5 = Qt(t5) ? t5 : [t5];
      if (C0) {
        if (n5 == E0)
          return [];
        r5 = Kt(r5, function(n6) {
          return T0(n6);
        });
      }
      return I0 && n5 == x0 ? [] : r5;
    }, M0 = function(n5) {
      return n5 ? Kt(n5, function(n6) {
        return S0(n6);
      }).length : y;
    }, q = function(n5) {
      return "failed " + n5;
    }, z0 = function(n5) {
      I(function() {
        var e4 = o22(v2()).Hn.yn();
        q0 = ur(er(e4), function(n6, t5, r5) {
          return n6[t5] = M0(e4[t5]), n6;
        }, {});
      });
    }, P0 = (ao = {}, { mn: function() {
      return ao;
    }, wn: function(n5, t5) {
      var r5, e4, u4 = Qt(t5) ? t5 : [t5];
      if (ao[n5])
        return ao[n5] = (e4 = u4, (r5 = ao[n5]) || e4 ? e4 ? r5 ? r5.concat(e4) : e4 : r5 : []);
      ao[n5] = u4;
    } }), W0 = P0.wn, G0 = Gr(), U0 = function(n5) {
      return kt(n5) == Pn;
    }, R = function(n5) {
      var t5 = n5.bn, r5 = n5.En, e4 = n5.Dn;
      try {
        throw x2 = t5(), Error();
      } catch (u4) {
        return !U0(u4) || !!r5 && r5(u4);
      } finally {
        e4 && e4();
      }
    }, Q0 = function(n5) {
      try {
        return x2 = n5(), false;
      } catch (t5) {
        return true;
      }
    }, V0 = function(n5) {
      var t5 = {};
      return t5["function ".concat(n5, "() { ").concat(
        Un,
        " }"
      )] = true, t5["function get ".concat(n5, "() { ").concat(Un, " }")] = true, t5["function () { ".concat(Un, " }")] = true, t5["function ".concat(n5, "() {").concat("\n", "    ").concat(Un).concat("\n", "}")] = true, t5["function get ".concat(n5, "() {").concat("\n", "    ").concat(Un).concat("\n", "}")] = true, t5["function () {".concat("\n", "    ").concat(Un).concat("\n", "}")] = true, t5;
    }, Y0 = function(n5, t5, r5) {
      return 0 === (r5 = void 0 === r5 ? 1 : r5) ? t5.test(n5.message) : t5.test(n5.stack.split("\n")[1]);
    }, t4 = "at ".concat(at, "\\.").concat(Jn, " "), Z0 = new RegExp(t4), n4 = "at Object\\.".concat(Jn), J0 = new RegExp(n4), d_ = h(213), r4 = "at (".concat(at, "\\.)?\\[").concat(d_, "\\]"), X0 = new RegExp(r4), l_ = h(214), i_ = "at (".concat(l_, "\\.)?\\[").concat(d_, "\\]"), $0 = new RegExp(i_), h_ = h(215), K0 = new RegExp(h_), n2 = /\s(.+)\]/, t2 = /get\s/, r2 = /^(screen|navigator)$/i, e22 = h(216), u2 = h(217), c22 = function(n5, apFn, t5, r5, e4) {
      var u4, c4, i4, o4, a4, f4, _4, s4, v4 = n5.self, h4 = Qn in v4;
      return Vt(apFn) ? (u4 = apFn.name.replace(t2, ""), c4 = null == r5 ? void 0 : r5.name, i4 = Ft(apFn), (s4 = {})[q(Y1)] = !!r5 && R({ bn: function() {
        return r5.prototype[u4];
      } }), s4[q(Z1)] = !!r5 && r2.test(c4) && !!(Ct(v4[Zr(c4)], u4) || h4 && v4[Qn][rt](v4[Zr(c4)], u4)), s4[q(J1)] = R({ bn: function() {
        x2 = new apFn();
        var n6 = apFn.call(t5);
        Yt(n6) && Vt(n6.then) && n6["catch"](function(n7) {
          Po(n7);
        });
      } }), s4[q(X1)] = R({ bn: function() {
        x2 = new apFn();
        var n6 = apFn.apply(t5);
        Yt(n6) && Vt(n6.then) && n6["catch"](function(n7) {
          Po(n7);
        });
      } }), s4[q($1)] = R({ bn: function() {
        return new apFn();
      } }), s4[q(n0)] = R({ bn: function() {
        return l[tt](apFn, d).toString();
      }, Dn: function() {
        return l[tt](apFn, i4);
      } }), s4[q(t0)] = !V0(u4)[n5[at][Vn].toString.call(apFn)] || !V0(Jn)[n5[at][Vn].toString.call(apFn.toString)], s4[q(r0)] = Vn in apFn, s4[q(e0)] = !!(Ct(apFn, Yn) || n5[Qn][rt](apFn, Yn) || Ct(apFn, Zn) || n5[Qn][rt](apFn, Zn) || Ct(apFn, Vn) || n5[Qn][rt](apFn, Vn) || Ct(apFn, Jn) || n5[Qn][rt](apFn, Jn)), s4[q(u0)] = !!(m(apFn, Yn) || m(apFn, Zn) || m(apFn, Vn) || m(apFn, Jn)), s4[q(c0)] = er(l[et](apFn)).sort().toString() != u2, s4[q(i0)] = xt(apFn).sort().toString() != u2, s4[q(o0)] = h4 && v4[Qn].ownKeys(apFn).sort().toString() != u2, s4[q(a0)] = R({ bn: function() {
        return l.create(apFn).toString();
      }, En: function(n6) {
        return Ta && !Y0(n6, Z0);
      } }) || R({
        bn: function() {
          return l.create(k0(apFn)).toString();
        },
        En: function(n6) {
          return Ta && !Y0(n6, J0);
        }
      }), s4[q(f0)] = R({ bn: function() {
        x2 = apFn.arguments, x2 = apFn.caller;
      }, En: function(n6) {
        return ja && !Y0(n6, K0, 0);
      } }), s4[q(_0)] = R({ bn: function() {
        x2 = apFn.toString.arguments, x2 = apFn.toString.caller;
      }, En: function(n6) {
        return ja && !Y0(n6, K0, 0);
      } }), s4[q(s0)] = R({ bn: function() {
        return l[tt](apFn, l.create(apFn)).toString();
      }, Dn: function() {
        return l[tt](apFn, i4);
      } }), _4 = s4, (u4 == Jn || e4[E0] || e4[D0]) && (o4 = k0(apFn), a4 = k0(apFn), f4 = k0(apFn), _4 = qt(_4, ((c4 = {})[q(v0)] = !R({ bn: function() {
        apFn.__proto__ = proxy, apFn++;
      }, Dn: function() {
        return l[tt](
          apFn,
          i4
        );
      } }), c4[q(h0)] = !R({ bn: function() {
        return l[tt](o4, l.create(o4)).toString();
      }, Dn: function() {
        return l[tt](o4, i4);
      } }), c4[q(d0)] = !R({ bn: function() {
        a4.__proto__ = a4, a4++;
      }, Dn: function() {
        return l[tt](a4, i4);
      } }), c4[q(l0)] = h4 && R({ bn: function() {
        throw x2 = v4[Qn][tt](apFn, l.create(apFn)), x2 = G0 in apFn, new TypeError();
      }, Dn: function() {
        return l[tt](apFn, i4);
      } }), c4[q(p0)] = h4 && !R({ bn: function() {
        v4[Qn][tt](f4, l.create(f4)), x2 = G0 in f4;
      }, Dn: function() {
        return l[tt](f4, i4);
      } }), c4[q(g0)] = Ta && (R({ bn: function() {
        x2 = apFn instanceof apFn;
      }, En: function(n6) {
        return !Y0(
          n6,
          X0
        );
      } }) || R({ bn: function() {
        var n6 = k0(apFn);
        x2 = n6 instanceof n6;
      }, En: function(n6) {
        return !Y0(n6, $0);
      } })), c4[q(y0)] = Ta && h4 && Q0(function() {
        l.defineProperty(apFn, "", { configurable: true }).toString(), v4[Qn].deleteProperty(apFn, "");
      }), c4))), s4 = Kt(er(_4), function(n6) {
        return !!_4[n6];
      }), { acc: x2, count: s4.length, list: s4 }) : { count: 0, list: [] };
    }, i2 = function(f4) {
      var _4 = {}, s4 = function(n5, t5) {
        var r5 = O0(n5, t5);
        r5.length && (W0(n5, r5), _4[n5] = r5);
      };
      return { yn: function() {
        return _4;
      }, xn: function(n5, t5) {
        var c4, i4 = t5 ? t5.Fn : void 0, o4 = t5 ? t5.Cn : void 0;
        try {
          if (typeof (c4 = n5()) == ht || !c4)
            return;
        } catch (a4) {
          return;
        }
        var r5 = c4.prototype || c4, r5 = fr(xt(r5).concat(er(r5)));
        tr(r5.sort(), function(n6) {
          if (!(n6 == e22 || i4 && !ar(i4, n6) || ar(o4, n6))) {
            var t6 = "".concat(c4.name || (n2.test(c4) ? null == (t6 = n2.exec(c4)) ? void 0 : t6[1] : H), ".").concat(n6);
            try {
              var r6 = c4.prototype || c4, e4 = void 0;
              try {
                var apFn = r6[n6];
                if (Vt(apFn))
                  return (e4 = c22(f4, r6[n6], r6, d, _4)).count ? s4(t6, e4.list) : void 0;
                if ("name" != n6 && "length" != n6 && n6[0] !== Jr(n6[0]))
                  return s4(t6, q(H0));
              } catch (a4) {
              }
              var u4 = Ct(r6, n6).get;
              if ((e4 = c22(f4, u4, r6, c4, _4)).count)
                return s4(t6, e4.list);
            } catch (a4) {
              return Po(a4), s4(t6, m0);
            }
          }
        });
      } };
    }, o22 = function(n5) {
      var t5 = i2(n5), r5 = t5.xn, r5 = (r5(function() {
        return Function;
      }, { Fn: v(0), Cn: v(1) }), r5(function() {
        return AnalyserNode;
      }), r5(function() {
        return AudioBuffer;
      }, { Fn: v(2) }), r5(function() {
        return BiquadFilterNode;
      }, { Fn: v(3) }), r5(function() {
        return CanvasRenderingContext2D;
      }, { Fn: v(4) }), r5(function() {
        return CSSStyleDeclaration;
      }, { Fn: v(5) }), r5(function() {
        return CSS2Properties;
      }, { Fn: v(5) }), r5(function() {
        return Date;
      }, { Fn: v(6) }), r5(function() {
        return GPU;
      }, { Fn: v(7) }), r5(function() {
        return GPUAdapter;
      }, { Fn: v(8) }), r5(
        function() {
          return Intl.DateTimeFormat;
        },
        { Fn: v(9) }
      ), r5(function() {
        return Document;
      }, { Fn: v(10), Cn: v(11) }), r5(function() {
        return DOMRect;
      }), r5(function() {
        return DOMRectReadOnly;
      }), r5(function() {
        return Element;
      }, { Fn: v(12) }), r5(function() {
        return FontFace;
      }, { Fn: v(13) }), r5(function() {
        return HTMLCanvasElement;
      }), r5(function() {
        return HTMLElement;
      }, { Fn: v(14), Cn: v(15) }), r5(function() {
        return HTMLIFrameElement;
      }, { Fn: v(16) }), r5(function() {
        return IntersectionObserverEntry;
      }, { Fn: v(17) }), r5(function() {
        return Math;
      }, { Fn: v(18) }), r5(function() {
        return MediaDevices;
      }, { Fn: v(19) }), r5(function() {
        return Navigator;
      }, { Fn: v(20) }), r5(function() {
        return Node;
      }, { Fn: v(21) }), r5(function() {
        return OffscreenCanvas;
      }, { Fn: v(22) }), r5(function() {
        return OffscreenCanvasRenderingContext2D;
      }, { Fn: v(23) }), r5(function() {
        return Permissions;
      }, { Fn: v(24) }), r5(function() {
        return Range;
      }, { Fn: v(25) }), r5(function() {
        return Intl.RelativeTimeFormat;
      }, { Fn: v(26) }), r5(function() {
        return Screen;
      }), r5(function() {
        return n5[ct];
      }, { Fn: v(27) }), r5(function() {
        return String;
      }, { Fn: v(28) }), r5(function() {
        return StorageManager;
      }, { Fn: v(29) }), r5(function() {
        return SVGRect;
      }), r5(function() {
        return SVGRectElement;
      }, { Fn: v(30) }), r5(function() {
        return SVGTextContentElement;
      }, { Fn: v(31) }), r5(function() {
        return TextMetrics;
      }), r5(function() {
        return WebGLRenderingContext;
      }, { Fn: v(32) }), r5(function() {
        return WebGL2RenderingContext;
      }, { Fn: v(32) }), t5.yn());
      return { Hn: t5, In: r5 };
    }, a22 = function() {
      var r5 = P0.mn(), n5 = ur(er(r5), function(n6, t5) {
        return n6 + r5[t5].length;
      }, 0);
      return { data: r5, total: n5 };
    }, f2 = function(n5, t5) {
      try {
        var r5, e4, u4, c4, i4, o4, a4;
        return Ta ? ((r5 = w(n5, zn)).appendChild(w(n5, Nn)), e4 = w(n5, zn), At(e4, "id", Gr()), t5 ? At(e4, Mn, b0) : At(
          e4,
          On,
          w0
        ), e4.appendChild(r5), Lt(jt(n5), e4), u4 = ir(e4.childNodes)[0], (c4 = ir(u4.childNodes)[0]) && (i4 = (c4 || {}).contentWindow) ? ((o4 = w(i4, zn)).innerHTML = r5, Lt(jt(i4), o4), a4 = ir(o4.childNodes)[0], ir(a4.childNodes)[0].contentWindow) : d) : n5;
      } catch (f4) {
        return Po(f4), n5;
      }
    }, _2 = function(n5, t5, r5) {
      var e4 = n5.self, u4 = { kn: e4 };
      if (t5)
        return u4;
      try {
        var c4 = e4.length, i4 = new DocumentFragment(), o4 = w(n5, zn), a4 = Gr(), f4 = (At(o4, "id", a4), Lt(i4, o4), w(n5, zn)), _4 = (r5 ? At(f4, Mn, b0) : At(f4, On, w0), Lt(f4, w(n5, Nn)), Lt(o4, f4), Lt(jt(n5), i4), e4[c4]);
        return { kn: f2(_4, r5) || e4, qn: o4 };
      } catch (s4) {
        return Po(s4), u4;
      }
    }, s22 = function() {
      return io;
    }, v2 = function() {
      return oo;
    }, h2 = function(n5) {
      C0 = L0(n5, at + Jn) || N0(n5), I0 = L0(n5, B0), n5[ct] && n5[ct][F0]();
    }, d2 = function(n5, t5, r5, e4) {
      var u4 = _2(n5, r5, e4), c4 = u4.kn, u4 = u4.qn;
      oo = c4, io = u4, z0();
    }, l2 = function() {
      Ot(s22());
    }, p2 = h(218), g2 = h(219), y2 = h(220), H2 = function(n5, t5) {
      return n5[p2] && Vt(n5[p2].supports) && n5[p2].supports(t5);
    }, m2 = function(n5) {
      return H2(n5, Na);
    }, w2 = function(n5) {
      var t5 = yu(n5);
      return !(!t5 || !t5.query);
    }, b2 = function(t5, r5) {
      return yu(t5).query({ name: it.toLowerCase() + "s" }).then(function(n5) {
        r5(n5.state == Xn && E2(t5));
      })["catch"](function() {
        return r5(false);
      });
    }, E2 = function(n5) {
      return it in n5 && n5[it].permission === Ga;
    }, D2 = function(n5, t5, r5, e4) {
      if (!Ta || r5)
        return false;
      var u4 = t5;
      try {
        return t5 || (u4 = w(n5, zn), Lt(jt(n5), u4)), !!u4 && !!n5.getComputedStyle && (e4 ? At(u4, Mn, y2) : At(u4, On, g2), n5.getComputedStyle(u4).backgroundColor === "".concat(tf, "(255, ").concat(y, ", ").concat(y, ")"));
      } finally {
        t5 || Nt(jt(n5), u4);
      }
    }, x22 = function(n5) {
      return Yf(n5, za, false);
    }, F2 = function(t5, r5) {
      return I(function() {
        var n5 = t5[Xa]();
        return n5.then(function(n6) {
          return r5("" === n6[oe]);
        }, function() {
          return r5(false);
        }), n5;
      });
    }, C2 = function(n5) {
      var t5 = g(n5);
      return nf in t5 && false === t5[nf];
    }, I2 = function(n5) {
      return ou(n5) === $e(n5) && au(n5) === Ke(n5) || iu(n5) && iu(n5).width === $e(n5) && iu(n5).height === Ke(n5);
    }, k2 = function() {
      return !!q0[e2(ft, $a)];
    }, q2 = function(n5) {
      var t5 = g(n5);
      return Ta && H2(n5, Ba) && (!(af in t5) || !(Ma in t5));
    }, R2 = h(221), S2 = h(222), T2 = function(n5) {
      return Ta && I(function() {
        return j2(n5);
      }) || {};
    }, j2 = function(n5) {
      var t5 = Za in n5[R2].prototype, r5 = H2(n5, La), e4 = Wa in n5, u4 = Pa in n5;
      return { Rn: r5 && !e4, Sn: t5 && !u4, Tn: !(n5[S2] && Qa in (n5[S2].prototype || {})) };
    }, A2 = c2([
      _e,
      ie,
      me,
      he,
      ve,
      ve + "s",
      Fe,
      oe,
      fe,
      ae,
      we,
      de,
      Af
    ], function(n5) {
      return e2(ft, n5);
    }), B2 = c2([h(263), h(264), h(265), h(266), h(58), h(59)], function(n5) {
      return e2(h(267), n5);
    }), L2 = [e2("Date", Jf), e2("Intl.RelativeTimeFormat", Se), e2("Intl.DateTimeFormat", Se)], qn = [e2("String", h(268))], N2 = c2([h(269), h(270), h(271)], function(n5) {
      return e2(h(272), n5);
    }).concat(qn).concat([e2("CSSStyleDeclaration", h(262)), e2("CSS2Properties", h(262))]), t4 = c2([h(273), h(274)], function(n5) {
      return e2(h(275), n5);
    }), O2 = t4.concat([]), M2 = (tr([h(276), h(277), h(278)], function(n5) {
      O2.push(e2(h(279), n5)), O2.push(e2(
        h(280),
        n5
      ));
    }), c2([h(281), h(282), h(283), h(284), h(285), h(286), h(263)], function(n5) {
      return e2(h(287), n5);
    })), z22 = c2([h(288), h(289), h(104), h(290)], function(n5) {
      return e2(h(291), n5);
    }).concat(M2).concat(t4).concat(qn), P2 = c2([h(292), h(293)], function(n5) {
      return e2(h(294), n5);
    }), W2 = function(n5) {
      return Kt(n5, function(n6) {
        return q0[n6];
      }).length;
    }, G2 = function() {
      return c2([A2, B2, L2, N2, O2, z22, M2, P2], function(n5) {
        return W2(n5);
      });
    }, U2 = function(n5) {
      var t5 = n5[qa], r5 = Rt(n5);
      if ((!ja || 1 == t5) && Yf(n5, "(".concat(ce, "-width:").concat(r5.width).concat($n, ") and (").concat(
        ce,
        "-height:"
      ).concat(r5.height).concat($n, ")"), true))
        return true;
    }, Q2 = function(n5) {
      var t5 = n5[qa], t5 = Yf(n5, "(resolution:".concat(t5, "dp").concat($n, ")"), true);
      if (!Aa && t5)
        return true;
    }, V2 = function(n5) {
      var t5 = Rt(n5), r5 = !(t5.width - t5.availWidth || t5.height - t5.availHeight);
      if (800 < t5.width && r5)
        return true;
    }, Y2 = function(n5, t5) {
      var r5 = false, e4 = (tr(n5, function(n6) {
        try {
          "MimeType" == l[nt](n6[0]).constructor.name || (r5 = true);
        } catch (t6) {
          r5 = true;
        }
      }), Kt(xt(t5), function(n6) {
        return isNaN(+n6);
      })), u4 = c2(n5, function(n6) {
        return sr(rr(n6));
      }), u4 = c2(u4, function(n6) {
        return n6 && n6.type;
      });
      return tr(
        u4,
        function(n6) {
          ar(e4, n6) || _r(e4, n6);
        }
      ), tr(n5, function(n6) {
        var t6 = c2(rr(n6), function(n7) {
          return n7 && n7.type;
        });
        tr(t6, function(n7) {
          ar(e4, n7) || (r5 = true);
        });
      }), r5;
    }, Z2 = function(n5) {
      try {
        var t5 = w(n5, Nn);
        return t5.srcdoc = Vr(n5), !!t5.contentWindow;
      } catch (r5) {
        return true;
      }
    }, J2 = function(n5) {
      var t5 = -50;
      return b(er(n5).slice(t5), Ie) && b(xt(n5).slice(t5), Ie);
    }, X2 = function(n5) {
      if (!(Bu(n5) && ut in n5[Ie]))
        return false;
      try {
        var t5 = n5[Ie][ut];
        return Vn in t5.sendMessage || Vn in t5.connect || (new t5.sendMessage(), new t5.connect()), true;
      } catch (r5) {
        return kt(r5) != Pn;
      }
    }, $2 = function() {
      return !!q0[E0];
    }, K2 = h(223), ns = h(224), ts = function(n5) {
      var t5 = g(n5), r5 = $r(ke), e4 = "is".concat(r5);
      return Lu(t5) && kt(Ft(t5[ke])) == r5 && ue(t5[ke][e4]) == "function ".concat(e4, "() { ").concat(Un, " }");
    }, rs = function(n5) {
      return Ta && K2 in Array.prototype && !Dt(n5, ns);
    }, es = function(n5) {
      return rs(n5) && su(n5) === d;
    }, us = function(n5) {
      var t5 = o22(n5).In;
      fo = Wt(Pt(t5));
    }, cs = function(n5) {
      return fo[n5];
    }, is = function(n5) {
      var t5, r5;
      return fo[n5] && (t5 = Wt(Pt(fo[n5])), r5 = [q(Y1), q(Z1), q(J1), q(X1), q($1)], r5 = c2(r5, function(n6) {
        return Jt(t5, n6);
      }), r5 = Math.max.apply(d, r5) + 1, Aa || t5.splice(
        r5,
        0,
        q(K1)
      ), t5);
    }, S = function(n5, t5) {
      return cs(e2(n5, t5));
    }, T = function(n5, t5) {
      return is(e2(n5, t5));
    }, os = h(225), as = function() {
      var n5 = er(fo).length, t5 = { jn: { An: v(33), Bn: v(33), Ln: v(34) }, Nn: { An: v(35), Bn: v(35), On: v(36), Mn: v(36), zn: v(36), Pn: v(37), Wn: v(37) }, Gn: { An: v(38), Bn: v(38), Un: v(38), zn: v(39), Pn: v(40), Wn: v(39) }, Qn: { Un: v(36), Vn: v(36), Yn: v(36), Zn: v(36), Jn: v(36), Xn: v(36), $n: v(36), Kn: v(36), nt: v(36) }, tt: {
        Wn: v(41),
        Pn: v(41),
        zn: v(41),
        rt: v(41),
        et: v(41),
        ut: v(41),
        ct: v(41),
        it: v(41),
        ot: v(41),
        ft: v(42),
        _t: v(42),
        st: v(42),
        vt: v(42),
        ht: v(42),
        dt: v(42),
        lt: v(42)
      }, gt: { zn: v(43), Wn: v(43) }, yt: { ft: v(44), ht: v(44), dt: v(44) }, Ht: { An: v(45), Bn: v(45), Un: v(45), Vn: v(45), Yn: v(45), Jn: v(45), Xn: v(45), $n: v(45), Kn: v(45), nt: v(45), ft: v(42) }, wt: { An: v(46), Bn: v(47), On: v(46), Mn: v(46), Un: v(46), Vn: v(46), Yn: v(46), Zn: v(46), Jn: v(46), Xn: v(46), $n: v(46), Kn: v(46), nt: v(46), Ln: v(48), Wn: v(48), Pn: v(48), zn: v(46), ft: v(49) } }, r5 = { bt: E(S(h(295), h(296))), Et: E(S(h(295), h(297))), Dt: E(S(h(298), h(299))), xt: E(S(h(298), h(300))), Ft: E(S(h(301), h(302))), Ct: E(S(h(301), h(303))), It: E(S(
        h(301),
        h(304)
      )), kt: E(S(h(301), h(305))), qt: E(S(h(301), h(306))), Rt: E(S(h(301), h(307))), St: E(S(h(308), h(309))), Tt: E(S(h(308), h(310))), jt: E(S(h(308), h(311))), At: E(S(h(275), h(274))), Bt: E(S(h(275), h(273))), Lt: E(S(h(275), h(312))), Nt: E(S(h(291), h(104))), Ot: E(S(h(313), h(314))), Mt: E(S(h(313), h(315))), zt: E(S(h(313), h(316))), Pt: E(S(h(313), h(317))), Wt: E(S(h(294), h(293))), Gt: E(S(h(294), h(292))), Ut: E(S(h(34), h(48))), Qt: E(S(h(267), h(266))), Vt: E(S(h(267), h(318))), Yt: E(S(h(267), h(319))), Zt: E(S(h(267), h(265))), Jt: E(S(
        h(267),
        h(58)
      )), Xt: E(S(h(267), h(59))) }, e4 = { bt: E(T(h(295), h(296))), Et: E(T(h(295), h(297))), Dt: E(T(h(298), h(299))), xt: E(T(h(298), h(300))), Ft: E(T(h(301), h(302))), Ct: E(T(h(301), h(303))), It: E(T(h(301), h(304))), kt: E(T(h(301), h(305))), qt: E(T(h(301), h(306))), Rt: E(T(h(301), h(307))), St: E(T(h(308), h(309))), Tt: E(T(h(308), h(310))), jt: E(T(h(308), h(311))), At: E(T(h(275), h(274))), Bt: E(T(h(275), h(273))), Lt: E(T(h(275), h(312))), Nt: E(T(h(291), h(104))), Ot: E(T(h(313), h(314))), Mt: E(T(h(313), h(315))), zt: E(T(h(313), h(316))), Pt: E(T(
        h(313),
        h(317)
      )), Wt: E(T(h(294), h(293))), Gt: E(T(h(294), h(292))), Ut: E(T(h(34), h(48))), Qt: E(T(h(267), h(266))), Vt: E(T(h(267), h(318))), Yt: E(T(h(267), h(319))), Zt: E(T(h(267), h(265))), Jt: E(T(h(267), h(58))), Xt: E(T(h(267), h(59))) }, u4 = t5.jn, c4 = t5.Nn, i4 = t5.Gn, o4 = t5.Qn, a4 = t5.tt, f4 = t5.gt, _4 = t5.yt, s4 = t5.Ht, t5 = t5.wt;
      if (n5)
        return b(c4.An, e4.bt) && b(c4.Bn, e4.Et) && b(c4.On, e4.Dt) && b(c4.Mn, e4.xt) && b(c4.Wn, e4.Bt) && b(c4.Pn, e4.Lt) && b(c4.zn, e4.Nt) ? sf : 3 <= n5 && b(i4.An, r5.bt) && b(i4.Bn, r5.Et) && b(i4.Un, r5.Ft) && b(i4.Wn, r5.Bt) && b(i4.Pn, r5.Lt) && b(i4.zn, r5.Nt) ? vf : b(o4.Un, e4.Ft) && b(
          o4.Vn,
          e4.Ct
        ) && b(o4.Yn, e4.It) && b(o4.Zn, e4.kt) && b(o4.Jn, e4.qt) && b(o4.Xn, e4.Rt) && b(o4.$n, e4.St) && b(o4.Kn, e4.Tt) && b(o4.nt, e4.jt) ? hf : 7 <= n5 && b(a4.Wn, r5.Bt) && b(a4.Pn, r5.Lt) && b(a4.zn, r5.Nt) && b(a4.rt, r5.Ot) && b(a4.et, r5.Mt) && b(a4.ut, r5.zt) && b(a4.ct, r5.Pt) && b(a4.it, r5.Wt) && b(a4.ot, r5.Gt) && b(a4.ft, r5.Ut) && b(a4._t, r5.Qt) && b(a4.st, r5.Vt) && b(a4.vt, r5.Yt) && b(a4.ht, r5.Zt) && b(a4.dt, r5.Jt) && b(a4.lt, r5.Xt) ? df : 2 <= n5 && b(f4.zn, e4.Nt) && b(f4.Wn, e4.Bt) ? lf : 3 <= n5 && b(_4.ft, r5.Ut) && b(_4.ht, r5.Zt) && b(_4.dt, r5.Jt) ? pf : 2 <= n5 && b(u4.An, r5.bt) && b(u4.Bn, r5.bt) && b(u4.Ln, r5.At) && r5.Ut == os ? gf : 14 <= n5 && b(s4.An, r5.bt) && b(s4.Bn, r5.bt) && b(s4.Un, r5.Ft) && b(s4.Vn, r5.Ct) && b(s4.Yn, r5.It) && b(s4.Jn, r5.qt) && b(s4.Xn, r5.Rt) && b(s4.$n, r5.St) && b(s4.Kn, r5.Tt) && b(s4.nt, r5.jt) && b(s4.ft, r5.Ut) ? yf : 15 <= n5 && b(t5.An, r5.bt) && b(t5.Bn, r5.Et) && b(t5.On, r5.Dt) && b(t5.Mn, r5.xt) && b(t5.Un, r5.Ft) && b(t5.Vn, r5.Ct) && b(t5.Yn, r5.It) && b(t5.Zn, r5.kt) && b(t5.Jn, r5.qt) && b(t5.Xn, r5.Rt) && b(t5.$n, r5.St) && b(t5.Kn, r5.Tt) && b(t5.An, r5.bt) && b(t5.nt, r5.jt) && b(t5.Ln, r5.At) && b(t5.Wn, r5.Bt) && b(t5.Pn, r5.Lt) && b(t5.zn, r5.Nt) && b(t5.ft, r5.Ut) ? Hf : void 0;
    }, fs = function(n5) {
      n5.$t = true;
    }, _s = function(n5) {
      fs(n5), n5.Kt && n5.Kt();
    }, ss = function(n5) {
      n5.nr && n5.nr();
    }, vs = function(n5) {
      n5.tr && n5.tr();
    }, hs = function(n5, t5, r5) {
      n5.rr = n5.rr - 1, t5 && t5(r5), n5.er && (n5.rr === y ? ((n5.$t ? vs : _s)(n5), ss(n5)) : n5.$t && vs(n5));
    }, ds = function(t5, n5, r5, e4) {
      t5.rr = t5.rr + 1, n5.apply(d, r5.concat([function(n6) {
        hs(t5, e4, n6);
      }]));
    }, ls = function(n5) {
      n5.$t || _s(n5);
    }, ps = false, gs = [], ys = function(n5) {
      for (var t5 = 0, r5 = gs[t5++], e4 = _(n5); r5; )
        r5.call(e4), r5 = gs[t5++];
      $t(gs);
    }, Hs = function(n5) {
      ps || (ps = true, ys(n5));
    }, ms = function(r5, n5) {
      var e4 = _(r5);
      _o = function(n6) {
        var t5 = mr(r5) ? n6 || r5.event : n6;
        (t5 && "readystatechange" !== t5.type || e4.readyState === An) && (Hr(r5) && yr(e4, jn, _o), yr(
          e4,
          "readystatechange",
          _o
        ), yr(r5, "load", _o), Hs(r5));
      }, Hr(r5) && gr(e4, jn, _o), gr(e4, "readystatechange", _o), gr(r5, "load", _o), (e4.readyState === An || e4.readyState === Bn && !Et(Ye(r5), Ln)) && Hs(r5), ps ? setTimeout(function() {
        n5.call(e4);
      }, 1) : gs.push(n5);
    }, ws = function(n5) {
      return !!n5 && new RegExp(Ja).test(n5.ua);
    }, bs = function(n5) {
      return !!n5 && new RegExp(ff).test(n5.r);
    }, Es = function(n5, t5) {
      return !!(n5 && n5.ua && t5) && n5.ua !== t5;
    }, Ds = function(n5, t5) {
      return !!(n5 && n5.p && t5) && n5.p !== t5;
    }, xs = function(n5, t5) {
      return !!(n5 && n5.hc && t5) && n5.hc !== t5;
    }, Fs = function(n5, t5) {
      return !!(n5 && n5.l && t5) && n5.l !== t5;
    }, Cs = function(n5, t5) {
      return !!(n5 && n5.ls && t5) && Pt(n5.ls) !== Pt(t5);
    }, Is = function(n5, t5) {
      return !!(n5 && n5.v && t5) && n5.r !== t5;
    }, ks = function(n5, t5) {
      return !!(n5 && n5.dm && t5) && n5.dm !== t5;
    }, qs = "application/javascript", Rs = h(226), Ss = function() {
      var n5 = new Blob([Rs], { type: qs }), n5 = URL.createObjectURL(n5);
      return new Worker(n5);
    }, Ts = function(n5) {
      return new Worker(n5);
    }, js = function(n5, t5, r5) {
      var e4, u4;
      try {
        (u4 = n5()).onmessage = function(n6) {
          clearTimeout(e4), r5({ ur: n6.data });
        }, u4.postMessage(""), e4 = setTimeout(function() {
          u4.terminate(), r5({ cr: true });
        }, t5);
      } catch (c4) {
        Po(c4), u4 && u4.terminate(), r5({ ir: true });
      }
    }, As = h(227), Bs = 1024 * 1024, Ls = function(n5, t5) {
      return t5 === n5[xe].toString().length;
    }, Ns = function(n5) {
      var t5 = Qe(n5);
      return t5 !== H && Et(t5, zo) && Ls(n5, 37);
    }, Os = function(n5) {
      var t5 = Qe(n5);
      return t5 !== H && Et(t5, Mo) && Ls(n5, 33);
    }, Ms = function(n5) {
      var t5 = Tt(n5);
      return !!t5 && t5[On] && t5[On][Ge] !== H && Ls(n5, 37);
    }, zs = function(n5) {
      return Du(n5) !== H && Ls(n5, 39);
    }, Ps = h(228), Ws = h(229), Gs = function(c4, i4) {
      var o4 = Vr(c4);
      try {
        xu(c4).open(o4, 1).onupgradeneeded = function(n5) {
          var t5 = n5.target && n5.target.result ? n5.target.result : H;
          try {
            t5[Ps](
              So,
              { autoIncrement: true }
            ).put(new Blob()), i4(false);
          } catch (u4) {
            var r5, e4 = u4;
            return u4 instanceof Error && (e4 = u4.message || u4), Zt(e4) ? (r5 = new RegExp(As).test(e4), i4(r5)) : i4(false);
          } finally {
            t5.close(), xu(c4)[Ws](o4);
          }
        };
      } catch (n5) {
        return i4(false);
      }
    }, Us = function(n5, t5) {
      var r5 = Fu(n5), e4 = n5.localStorage;
      try {
        r5(d, d, d, d);
      } catch (u4) {
        return t5(true);
      }
      try {
        e4.setItem(So, "1"), e4.removeItem(So);
      } catch (u4) {
        return t5(true);
      }
      t5(false);
    }, Qs = function(n5, t5) {
      (g(n5)[Af] !== H ? Gs : Us)(n5, t5);
    }, Vs = function(n5) {
      return Cu(n5) !== H && Cu(n5)[Me] !== H && Cu(n5)[Me][ze] !== H ? Cu(n5)[Me][ze] : 1073741824;
    }, Ys = h(230), Zs = function(u4, c4) {
      Iu(u4)[Ys](function(n5, t5) {
        var r5 = a2[h(251)](t5 / Bs), e4 = 2 * a2[h(251)](Vs(u4) / Bs);
        c4(r5 < e4);
      }, function(n5) {
        c4(false);
      });
    }, Js = function(n5, t5) {
      ku(n5)(0, 1, function() {
        t5(false);
      }, function() {
        t5(true);
      });
    }, Xs = function(n5, t5) {
      (n5.Promise !== H && n5.Promise.allSettled !== H ? Zs : Js)(n5, t5);
    }, $s = function(n5, t5) {
      t5(Hu(n5) === H);
    }, Ks = function(n5, t5) {
      t5(xu(n5) === H);
    }, nv = function(n5, t5) {
      try {
        return Ns(n5) ? Qs(n5, t5) : Os(n5) ? Xs(n5, t5) : Ms(n5) ? $s(n5, t5) : zs(n5) ? Ks(n5, t5) : (t5(false), void 0);
      } catch (r5) {
        Po(r5), t5(false);
      }
    }, tv = "^\\s*([a-z-]*)(.*)$", rv = "([.:#][\\w-]+|\\[.+?\\])", ev = '^\\[([\\w-]+)([~|^$*]?=("([^"]*)"|([\\w-]+)))?(\\s+[is])?\\]$', uv = function(n5) {
      for (var t5, r5 = new RegExp(tv, "i").exec(n5), e4 = r5[1] || void 0, u4 = new RegExp(rv, "gi"); ; ) {
        var c4 = u4.exec(r5[2]);
        if (!c4)
          break;
        var i4 = c4[0];
        switch (i4[0]) {
          case ".":
            return [e4, Mn, i4.slice(1)];
          case "#":
            return [e4, "id", i4.slice(1)];
          case "[":
            var o4 = new RegExp(ev).exec(i4);
            if (o4)
              return [e4, o4[1], null != (t5 = null != (t5 = o4[4]) ? t5 : o4[5]) ? t5 : ""];
        }
      }
      return [e4, void 0, void 0];
    }, cv = function(n5, t5) {
      var r5 = uv(t5), e4 = r5[0], u4 = r5[1], r5 = r5[2], e4 = w(n5, null != e4 ? e4 : zn);
      return u4 && r5 && At(e4, u4, r5), e4;
    }, f = function(n5) {
      return n5;
    }, iv = function() {
      return [[
        f(h(320)),
        f(h(321)),
        f(h(322))
      ], [f(h(323)), f(h(324)), f(h(325))], [f(h(326)), f(h(327)), f(h(328))], [f(h(329)), f(h(330)), f(h(331))], [f(h(332)), f(h(333)), f(h(334))], [f(h(335)), f(h(336)), f(h(337))], [f(h(338))], [f(h(339)), f(h(340)), f(h(341))], [f(h(342))], [f(h(343)), f(h(344)), f(h(345))], [f(h(346)), f(h(347)), f(h(348))], [f(h(349)), f(h(350)), f(h(351))], [f(h(352)), f(h(353)), f(h(354))], [f(h(355)), f(h(356)), f(h(357))], [f(h(358)), f(h(359)), f(h(360))], [f(h(361)), f(h(362)), f(h(363))], [f(h(364)), f(h(365)), f(h(366))], [
        f(h(367)),
        f(h(368)),
        f(h(369))
      ], [f(h(370)), f(h(371)), f(h(372))], [f(h(373)), f(h(374)), f(h(375))], [f(h(376)), f(h(377)), f(h(378))], [f(h(379)), f(h(380)), f(h(381))], [f(h(382)), f(h(383)), f(h(384))], [f(h(385)), f(h(386)), f(h(387))], [f(h(388)), f(h(389)), f(h(390))], [f(h(391)), f(h(392))], [f(h(393))], [f(h(394)), f(h(395)), f(h(396))], [f(h(397))], [f(h(398)), f(h(399)), f(h(400))], [f(h(401)), f(h(402)), f(h(403))], [f(h(404)), f(h(405)), f(h(406))], [f(h(407)), f(h(408)), f(h(409))], [f(h(410)), f(h(411)), f(h(412))], [f(h(413))], [
        f(h(414)),
        f(h(415)),
        f(h(416))
      ], [f(h(417)), f(h(418)), f(h(419))], [f(h(420)), f(h(421))], [f(h(422)), f(h(423)), f(h(424))], [f(h(425)), f(h(426)), f(h(427))], [f(h(428)), f(h(429)), f(h(430))], [f(h(431)), f(h(432)), f(h(433))]];
    }, ov = function(n5, t5) {
      try {
        var r5 = iv(), e4 = ur(r5, function(n6, t6) {
          return n6.concat(t6);
        }, []);
        _v(n5, e4, function(n6) {
          t5(av(r5, n6));
        });
      } catch (u4) {
        Po(u4), t5(void 0);
      }
    }, av = function(n5, t5) {
      for (var r5, e4 = 0; e4 < n5.length; e4++)
        fv(n5[e4], t5) && (r5 = r5 || []).push(e4);
      return r5;
    }, fv = function(n5, t5) {
      for (var r5 = 0, e4 = n5; r5 < e4.length; r5++)
        if (t5[e4[r5]])
          return true;
      return false;
    }, _v = function(n5, t5, r5) {
      for (var e4 = w(n5, zn), u4 = (zt(e4), new Array(t5.length)), c4 = 0; c4 < t5.length; ++c4) {
        var i4 = cv(n5, t5[c4]), o4 = w(n5, zn);
        zt(o4), Lt(o4, i4), Lt(e4, i4), u4[c4] = i4;
      }
      Lt(jt(n5), e4);
      var a4 = {};
      setTimeout(function() {
        try {
          for (var n6 = 0; n6 < t5.length; ++n6)
            u4[n6].offsetParent || (a4[t5[n6]] = true);
        } finally {
          Ot(e4);
        }
        r5(a4);
      }, 0);
    }, sv = { email: false, hidden: false, password: false, tel: false, text: false }, vv = h(231), hv = h(232), dv = function(n5, t5) {
      n5.target && n5.target.value && n5.target.type && n5.target.type in sv && (hv !== n5.inputType && "data" in n5 && vv !== n5.animationName || (sv[n5.target.type] = true, t5(sv)));
    }, lv = function(n5, t5, r5) {
      gr(_(n5), t5, function(n6) {
        return I(function() {
          return dv(n6, r5);
        });
      });
    }, pv = function(n5, t5) {
      lv(n5, "animationstart", t5), lv(n5, "input", t5);
    }, gv = 1e3, yv = 1e3, Hv = {}, mv = {}, wv = 0, bv = 1, Ev = { rr: y, er: false, $t: false, Kt: void 0, tr: void 0, nr: void 0, cr: 300 }, j = function(n5, t5, r5, e4) {
      return so && so(n5, t5, r5, e4), r5;
    }, Dv = function(n5) {
      return c2(n5, function(n6) {
        return !!n6;
      });
    }, A = function(n5, t5, r5) {
      p(r5) && (Hv[n5] = U_(n5, t5, r5)), t5 != k && j(wv, n5, r5);
    }, xv = function(n5, t5) {
      t5 && (Hv[n5] = U_(n5, B_)), j(wv, n5, t5);
    }, Fv = function(n5, t5, r5) {
      t5 ? mv[n5] = U_(n5, B_) : r5 && false === t5 && (mv[n5] = U_(n5, A_)), j(bv, n5, t5);
    }, Cv = function(n5, t5, r5) {
      var e4, u4;
      void 0 === r5 && (r5 = wv), t5 && t5.length && (e4 = Co(t5.sort().join("")), u4 = D(t5.length) + jr(e4, 4), u4 = U_(n5, k, u4), r5 === wv ? Hv[n5] = u4 : r5 === bv && (mv[n5] = u4)), j(r5, n5, t5, e4);
    }, Iv = function(n5) {
      var t5 = G2(), r5 = c2(t5, function(n6) {
        return Tr(n6);
      }).join(""), e4 = U_(n5, k, r5);
      mv[n5] = e4, j(bv, n5, t5, r5);
    }, kv = function(n5, t5) {
      p(t5) && (Hv[n5] = 25.5 < t5 ? U_(n5, O_, a2[h(251)](t5)) : U_(n5, M_, t5), j(wv, n5, t5));
    }, qv = function(n5, t5, r5) {
      var e4;
      j(wv, n5, t5), p(t5) && (e4 = Jt(r5, t5), Hv[n5] = y <= e4 ? U_(n5, L_, e4) : U_(n5, N_, t5));
    }, Rv = function(n5, t5) {
      var r5 = 32767 & n5, e4 = 65535 & t5;
      return r5 == e4 ? jr(32768 | r5, 2) : jr(r5, 2) + jr(e4, 2);
    }, Sv = function(n5, t5) {
      var r5 = $e(n5), e4 = nu(n5), u4 = Ke(n5), c4 = tu(n5), i4 = Rv(r5, e4), o4 = Rv(u4, c4);
      A(t5, k, i4 + o4), j(wv, t5, [r5, u4, e4, c4]);
    }, Tv = function(n5, t5) {
      var r5 = Nf(t5), e4 = parseInt("".concat(bt(r5._n)).concat(bt(r5.sn)), 2), r5 = D((63 & r5.fn) << 2 | e4);
      A(n5, k, r5), j(wv, n5, e4);
    }, jv = function(n5) {
      var t5 = Xf(), r5 = $f(), e4 = D(t5 / 15) + D(r5 / 15);
      A(n5, k, e4), j(wv, n5, [t5, r5]);
    }, Av = function(n5, t5) {
      var r5;
      t5.length && (r5 = [t5[Wf], t5[Pf], t5[zf]], A(n5, k, Bv(r5)), j(wv, n5, Dv(r5)));
    }, Bv = function(n5) {
      var t5 = c2(n5, function(n6) {
        return bt(n6);
      }), r5 = Lr(t5, H);
      return D(n5.length) + jr(r5, a2[h(261)](t5.length / 8));
    }, Lv = function(n5, t5) {
      var r5;
      t5 && t5.length && (r5 = jr(parseInt(c2(t5, Sr).join(""), 2), 2), A(E1, k, r5), j(wv, n5, t5));
    }, Nv = function(n5, t5) {
      var r5 = [D_(), Eu(n5), Nu(n5), bu(n5), Cf(n5), Bu(n5), Hu(n5), yu(n5), gu(n5), ko(n5), pu(n5), lu(n5)];
      A(t5, k, Bv(r5)), j(wv, t5, Dv(r5));
    }, Ov = function(n5, t5) {
      var r5 = [xf(n5), Ff(n5), If(n5), kf(n5), Rf(n5), qf(n5), Sf(n5), Tf(n5)];
      A(t5, k, Bv(r5)), j(wv, t5, Dv(r5));
    }, Mv = function(n5, t5) {
      var r5 = T2(n5), r5 = [J2(n5), X2(n5), r5.Rn, r5.Sn, r5.Tn, jf(n5), E2(n5), I(function() {
        return x22(n5);
      }), C2(n5), I2(n5), q2(n5), I(function() {
        return m2(n5);
      }), Cf(n5) == H];
      e3(t5, k, Bv(r5)), j(
        bv,
        t5,
        Dv(r5)
      );
    }, zv = h(233), Pv = h(234), Wv = h(235), Gv = h(236), Uv = h(237), Qv = h(238), Vv = h(239), Yv = h(240), Zv = h(241), Jv = h(242), Xv = h(243), $v = function(n5) {
      return n5.slice(2) + "-" + n5.slice(2, 2);
    }, Kv = "20181001000000", n3 = ["20030107", "20100101"], t3 = function(n5) {
      var t5 = fu(n5);
      t5 ? "" === t5[oe] ? Fv(T1, true) : Xa in t5 && ds(Ev, F2, [t5], function(n6) {
        Fv(T1, n6);
      }) : Fv(T1, false);
    }, r3 = function(n5) {
      var t5 = rr(V1());
      e3(n5, k, Bv(t5)), j(bv, n5, t5);
    }, e3 = function(n5, t5, r5) {
      p(r5) && (mv[n5] = U_(n5, t5, r5)), t5 != k && j(bv, n5, r5);
    }, u3 = function(n5, t5) {
      p(t5) && (A(n5, k, W_(t5, 512)), j(wv, n5, t5));
    }, c3 = function() {
      return rr(Hv);
    }, i3 = function() {
      return rr(mv);
    }, o3 = (n4 = 2, r4 = _t.split("."), l_ = parseInt(r4[0], 10) - 1, d_ = parseInt(r4[1], 10), i_ = parseInt(r4[2], 10), jr(n4 << 13 | (3 & l_) << 11 | (31 & d_) << 6 | 63 & i_, 2)), a3 = 0, f3 = 4, _3 = D(st), s3 = 4, v3 = function(n5, t5, r5, e4) {
      var u4 = Lr(t5, 12), u4 = s3 << 12 | 4095 & u4;
      return [D(u4 >> 8) + D(u4), wo(r5), Br(e4)];
    }, h3 = function(n5, t5) {
      return D((7 & n5) << 5 | 31 & t5);
    }, d3 = function(n5, t5, r5, e4) {
      var u4 = c3(), c4 = i3(), i4 = v3(n5, Gi(), Ui(), Xi()), o4 = D(Er(256)), a4 = Cr(), a4 = xo(bo(a4), Eo(a4)), f4 = h3(a3, u4.length), _4 = h3(f3, c4.length), f4 = f4 + u4.join("") + _4 + c4.join("") + i4.join("") + _3, u4 = no(
        a4,
        4,
        a4.charAt(3),
        f4
      ), _4 = no(t5, 8, t5.charAt(9), a4 + u4), c4 = r5 + e4 + o3 + t5 + _4, i4 = D(c4.length), f4 = kr(c4 + i4, o4), a4 = Ar(o4 + f4);
      return eo(n5, a4) || "";
    }, l3 = function(n5, t5, r5, e4) {
      var u4 = _(n5);
      try {
        u4.cookie = "".concat(t5, "=").concat(r5, ";path=/;").concat(e4).concat("SameSite=Lax");
      } catch (c4) {
      }
    }, p3 = function(n5, t5) {
      var r5 = _(n5);
      try {
        return (r5.cookie.match("(^|; )".concat(t5, "=([^;]*)")) || 0)[2];
      } catch (e4) {
        return null;
      }
    }, g3 = Rn(1970), y3 = function() {
      return vo;
    }, H3 = function(n5, t5, r5) {
      for (var e4 = 0, u4 = St(n5).hostname, c4 = u4.split("."), i4 = 1 === c4.length; e4 < c4.length - 1 || i4; )
        u4 = c4.slice(-1 - ++e4).join("."), l3(n5, t5, "", "expires=".concat(r5 || g3, ";domain=").concat(u4, ";")), i4 = false;
    }, m3 = D(9), w3 = {}, b3 = false, E3 = false, D3 = [], x3 = function(n5, t5, r5, e4) {
      W1(n5, t5, r5, e4 || lt);
    }, F3 = function(n5, t5, r5) {
      var e4 = y3(), e4 = e4 ? "domain=".concat(e4, ";") : "", u4 = C(), u4 = "expires=".concat(Ir(u4.nn.rn), ";").concat(e4);
      l3(n5, t5, r5, u4);
    }, C3 = function() {
      return E3;
    }, I3 = function(n5, t5, r5) {
      D3.push([t5, r5]);
    }, k3 = function(n5) {
      if (!C().ar)
        throw jo;
      if (b3) {
        E3 = true;
        for (var t5 = D3.length, r5 = q3()._r, e4 = 0; e4 < t5; e4++)
          D3[e4][1]._value = r5, D3[e4][0](r5);
      }
    }, q3 = function() {
      return w3[Ro];
    }, R3 = function(n5) {
      w3[Ro] = n5;
    }, S3 = function(n5, t5) {
      R3(t5);
      var r5 = C();
      r5.J ? x3(n5, r5.nn.tn, t5.sr, function() {
        return F3(n5, r5.nn.tn, t5.sr);
      }) : (F3(n5, r5.nn.tn, t5.sr), x3(n5, r5.nn.tn, t5.sr));
    }, T3 = function(n5) {
      return q3() || A3(n5, Vr(n5));
    }, j3 = function(n5) {
      if (b3)
        return T3(n5)._r;
    }, A3 = function(n5, t5) {
      var r5 = { sr: t5, _r: C().ar ? d3(n5, t5, m3, qr(C().ar.slice(3))) : "" };
      return R3(r5), r5;
    }, B3 = function(n5) {
      var t5 = q3();
      if (t5)
        return A3(n5, t5.sr);
    }, L3 = function(r5, e4) {
      return r5.then = function(n5, t5) {
        return n5(e4), r5;
      }, r5;
    }, N3 = "POST", O3 = "withCredentials", M3 = 4, z3 = function() {
      try {
        var n5;
        if (typeof XMLHttpRequest !== ht)
          return n5 = new XMLHttpRequest(), O3 in n5 ? n5 : void 0;
      } catch (t5) {
      }
    }, P3 = function(n5, t5, r5) {
      if (r5.vr && (clearTimeout(r5.vr), r5.vr = H), r5.hr === H)
        for (var e4 = n5.length, u4 = 0; u4 < e4; u4++)
          n5[u4](t5);
      r5.hr = t5;
    }, W3 = function(n5, t5) {
      n5.send(t5);
    }, G3 = yt(W3, 300), U3 = h(244), Q3 = function(n5, t5, r5, e4, u4, c4) {
      var i4, o4, a4 = z3(), f4 = {};
      return a4 && a4.setRequestHeader ? (a4.open(N3, t5, true), i4 = { hr: H, vr: H }, o4 = [], a4.setRequestHeader("Content-Type", "application/json"), a4.setRequestHeader(U3, r5), f4.then = function(n6, t6) {
        return i4.hr !== H ? n6(i4.hr) : o4.push(n6), f4;
      }, a4.onreadystatechange = function() {
        var n6;
        a4.readyState === M3 && (n6 = a4.status, P3(o4, 200 <= n6 && n6 < 400, i4));
      }, e4(function(n6) {
        i4.vr = setTimeout(function() {
          P3(o4, d, i4), a4.abort();
        }, c4), u4(a4, Pt(n6));
      }), f4) : L3(f4, false);
    }, V3 = h(88), Y3 = function(n5, t5) {
      var r5;
      m(n5, "console") && (r5 = n5.console, m(r5, "warn")) && r5.warn(V3 + t5);
    }, Z3 = 0, J3 = 1, X3 = 2, $3 = 4, K3 = 5, nh = 3, th = function(n5) {
      return Zt(n5) ? n5 : Pt(n5);
    }, rh = function(n5, t5, r5, e4, u4, c4) {
      return eh(t5, r5, e4, u4, u4, c4) + jr(n5.length, nh) + qr(n5);
    }, eh = function(n5, t5, r5, e4, u4, c4) {
      for (var i4 = [], o4 = c4 ? W_ : P_, a4 = y; a4 < r5.length; a4++) {
        var f4 = r5[a4], _4 = Jt(e4, f4) >= y, s4 = Jt(u4, f4) >= y, v4 = m(t5, f4) && Ht(t5[f4]);
        if (v4 || _4) {
          var h4 = void 0;
          if (_4) {
            _4 = v4 ? t5[f4] : s4 ? {} : H;
            if (_4 === H)
              continue;
            var d4 = or(_4), v4 = er(d4).slice(y, st);
            h4 = D(v4.length);
            for (var l4 = 0, p4 = v4; l4 < p4.length; l4++)
              var g4 = p4[l4], h4 = (h4 += P_(th(g4))) + P_(th(d4[g4]));
          } else
            h4 = o4(th(t5[f4]));
          i4.push(D(a4) + h4);
        }
      }
      return D(n5) + D(i4.length) + i4.join("");
    }, uh = "id", ch = "email", ih = "phone", oh = "registered_at", ah = "traits", fh = "signature", _h = "address", sh = "name", vh2 = function(n5) {
      return eh(Z3, n5, [uh, ch, ih, oh, ah, fh, sh, _h], [ah, _h], pt, false);
    }, hh = h(245), dh = function(n5) {
      return eh($3, n5, [hh], pt, pt, true);
    }, lh = 3, ph = function(n5, t5, r5, e4) {
      var u4 = D(Er(256)), c4 = Cr(), c4 = Do(bo(c4)), i4 = D(e4.length), o4 = t5.slice(3), i4 = r5 + i4 + e4.join(""), a4 = D(i4.length & st), i4 = no(c4, 4, c4.charAt(3), i4 + a4), a4 = no(Rr(o4), 8, Rr(o4[9]), c4 + i4), o4 = D((15 & lh) << 4), c4 = kr(o4 + a4, u4), i4 = Ar(u4 + c4);
      return eo(n5, i4) || "";
    }, gh = "url", yh = "name", Hh = "referrer", mh = function(n5, t5, r5, e4) {
      return ph(n5, t5, e4.userJwt ? dh({ jwt: e4.userJwt }) : vh2(e4.user), [rh(r5, J3, e4, [yh, gh, Hh], pt, false)]);
    }, wh = function(e4, n5, u4) {
      var c4, i4, o4, a4 = C();
      if (a4.ar)
        return p(u4) && (p(u4.user) || p(u4.userJwt)) ? (c4 = m(u4, gh) ? u4[gh] : St(e4).href, i4 = m(u4, yh) ? u4[yh] : _(e4).title || c4, o4 = m(u4, Hh) ? u4[Hh] : _(e4).referrer, Q3(e4, a4.$, a4.ar, function(r5) {
          return n5.then(function(n6) {
            var t5 = mh(e4, a4.ar, n6, { user: u4.user, userJwt: u4.userJwt, name: i4, url: c4, referrer: o4 });
            r5({ data: t5 });
          });
        }, G3, a4.K)) : (a4.X && Y3(e4, Ao), L3({}, false));
      throw jo;
    }, bh = "name", Eh = "values", Dh = function(n5, t5, r5, e4) {
      return ph(n5, t5, e4.userJwt ? dh({ jwt: e4.userJwt }) : vh2(e4.user), [rh(r5, X3, e4, [bh, Eh], [Eh], false)]);
    }, xh = 0, Fh = 300, Ch = function(e4, n5, u4) {
      var t5, r5 = {}, c4 = C();
      if (c4.ar)
        return p(u4) && (p(u4.user) || p(u4.userJwt)) && p(u4.name) ? (t5 = Cr()) - xh < Fh ? L3(r5, false) : (xh = t5, Q3(e4, c4.$, c4.ar, function(r6) {
          return n5.then(function(n6) {
            var t6 = Dh(e4, c4.ar, n6, u4);
            r6({ data: t6 });
          });
        }, W3, c4.K)) : (c4.X && Y3(e4, Ao), L3(r5, false));
      throw jo;
    }, Ih = "name", kh = "properties", qh = function(n5) {
      return n5.userJwt ? dh({ jwt: n5.userJwt }) : vh2(n5.user);
    }, Rh = function(n5, t5) {
      return rh(n5, K3, t5, [Ih, kh], [kh], false);
    }, Sh = function(n5, t5, r5, e4) {
      return ph(n5, t5, qh(e4), [Rh(r5, e4)]);
    }, Th = {}, jh = function(n5) {
      var t5 = Th[n5];
      return t5.dr && 0 < (t5 = t5.dr - Cr()) ? t5 : 0;
    }, Ah = function(r5, e4) {
      return function(n5) {
        var t5 = Th[r5], t5 = (t5.lr = t5._.splice(0, Oo), c2(t5.lr, function(n6) {
          return Rh(n6._r, n6.pr);
        }));
        n5({ data: ph(ho, e4, r5, t5) });
      };
    }, Bh = function(n5) {
      var r5 = Th[n5], e4 = {};
      if (r5.gr)
        e4.then = function(t5) {
          return setTimeout(function() {
            Bh(n5).then(function(n6) {
              t5(n6);
            });
          }, No), e4;
        };
      else {
        if (r5.yr)
          return L3(e4, r5.Hr);
        r5.gr = true, r5.yr = false, r5.Hr = void 0;
        var u4 = C();
        e4.then = function(t5) {
          return Q3(ho, u4.$, u4.ar, Ah(n5, u4.ar), W3, u4.K).then(function(n6) {
            r5.gr = false, r5.yr = true, r5.Hr = n6, t5(n6);
          }), e4;
        };
      }
      return e4;
    }, Lh = function(r5) {
      var e4 = Th[r5], u4 = jh(r5), c4 = (0 === u4 && (e4.dr = Cr() + No), {});
      return c4.then = function(n5) {
        var t5 = function(t6) {
          Bh(r5).then(function(n6) {
            e4.lr.pop(), 0 === e4.lr.length && (e4.yr = false, e4.Hr = void 0, e4.gr = false), t6(n6);
          });
        };
        return 0 === u4 ? t5(n5) : setTimeout(function() {
          t5(n5);
        }, u4), c4;
      }, c4;
    }, Nh = function(n5) {
      return Th[n5.mr] || (Th[n5.mr] = { _: [], lr: [], dr: 0 }), Th[n5.mr]._.push({ pr: n5.pr, _r: n5._r }), Lh(n5.mr);
    }, Oh = function(n5) {
      return !p(n5) || !(p(n5.user) || p(n5.userJwt)) || !p(n5.name);
    }, Mh = function(e4, u4, c4) {
      var r5, i4 = C();
      if (i4.ar)
        return Oh(c4) ? (i4.X && Y3(e4, Ao), L3({}, false)) : i4.en ? r5 = { then: function(t5, n5) {
          return u4.then(function(n6) {
            Nh({ mr: qh(c4), pr: c4, _r: n6 }).then(function(n7) {
              return t5(n7);
            });
          }), r5;
        } } : Q3(
          e4,
          i4.$,
          i4.ar,
          function(r6) {
            return u4.then(function(n5) {
              var t5 = Sh(e4, i4.ar, n5, c4);
              r6({ data: t5 });
            });
          },
          W3,
          i4.K
        );
      throw jo;
    }, zh = h(246), Ph = h(247), Wh = "name", Gh = function(n5, t5) {
      for (var r5 = new FormData(t5), e4 = {}, u4 = 0, c4 = t5.querySelectorAll("[".concat(zh, "]")); u4 < c4.length; u4++) {
        var i4 = c4[u4], o4 = Bt(i4, zh), i4 = Bt(i4, Wh);
        r5.has(i4) && (e4[o4] = "" + r5.get(i4));
      }
      return { name: Bt(t5, Ph), values: e4 };
    }, Uh = "name", Qh = h(248), Vh = function(n5, t5) {
      for (var r5 = 0, e4 = t5.childNodes; r5 < e4.length; r5++) {
        var u4 = e4[r5];
        if (Bt(u4, Uh) === Qh)
          return u4;
      }
      var c4 = w(n5, "input");
      return At(c4, "type", "hidden"), At(c4, Uh, Qh), Lt(t5, c4), c4;
    }, Yh = function() {
      if (lo)
        return lo;
      throw Bo;
    }, Zh = true, Jh = H, h_ = function(n5) {
      var u4, t5, e4, o4, r5, i4, a4, c4 = n5 || {};
      if ((po = m(c4, "window") ? c4.window : po) || typeof window !== ht && (po = window), !po)
        throw Bo;
      if (m(c4, "storageNamespace") && void ((f4 = c4.storageNamespace) && (F.nn.tn = f4)), m(c4, "storage") && void ((f4 = c4.storage) && (f4.name && (F.nn.tn = f4.name), Ut(f4.expireIn)) && (F.nn.rn = f4.expireIn)), m(c4, "avoidCookies") && (f4 = !!c4.avoidCookies, void (F.J = f4)), m(c4, "cookieDomain") && void ((f4 = c4.cookieDomain) && /\S+\.\S{2,}$/.test(f4) && (vo = f4)), C().J || void (vo = vo || function(n6) {
        for (var t6 = 0, r6 = _(n6), e5 = St(n6).hostname, u5 = "".concat(So).concat(Cr()), c5 = e5.split("."); t6 < c5.length - 1 && (e5 = c5.slice(-1 - ++t6).join("."), l3(n6, u5, u5, "domain=".concat(e5, ";")), !Et(r6.cookie, "".concat(u5, "=").concat(u5))); )
          ;
        return H3(n6, u5), e5;
      }(po)), m(c4, "eFn") && (f4 = c4.eFn, void (F.un = f4)), m(c4, "wUrl") && (f4 = c4.wUrl, void (p(f4) && (F.wr = f4))), m(c4, "dCss") && (f4 = c4.dCss, void (p(f4) && (F.br = f4))), m(c4, "eCss") && (f4 = c4.eCss, void (p(f4) && (F.Er = f4))), m(c4, "pk")) {
        var f4 = c4.pk;
        if (!Ht(f4) || 35 !== f4.length || "pk_" !== f4.slice(0, 3))
          throw jo;
        F.ar = f4, k3();
      }
      if (m(c4, "apiUrl") && void ((f4 = c4.apiUrl) && (F.$ = f4)), m(c4, "timeout") && (f4 = c4.timeout, void (Gt(f4) && (F.K = f4))), m(c4, "verbose") && (f4 = !!c4.verbose, void (F.X = f4)), m(c4, "throttling") && (f4 = c4.throttling, void (p(f4) && (F.en = f4))), Zh) {
        if (!C().ar)
          throw jo;
        c4 = u4 = po, f4 = C(), Q1.en = f4.en, Q1.J = f4.J, n5 = c4, Q1.pn = !!n5.localStorage, W1(n5, So, To, function() {
          Q1.pn && (Q1.gn = true);
        }), void void U1(n5, So), void (lo = a4 = { createRequestToken: function() {
          var r6 = { then: function(n6, t6) {
            return C3() && !r6._value && (B3(i4), r6._value = j3(i4)), r6._value ? n6(r6._value) : I3(i4, n6, r6), r6;
          } };
          return r6;
        }, page: function(n6) {
          return wh(i4, a4.createRequestToken(), n6);
        }, form: function(n6) {
          return Ch(
            i4,
            a4.createRequestToken(),
            n6
          );
        }, custom: function(n6) {
          return Mh(i4, a4.createRequestToken(), n6);
        }, injectTokenOnSubmit: function(t6, r6) {
          t6.preventDefault ? t6.preventDefault() : t6.returnValue = false;
          var e5 = t6.target || t6.srcElement;
          a4.createRequestToken().then(function(n6) {
            At(Vh(i4, e5), "value", n6), r6 ? r6(t6) : e5.submit();
          });
        }, formEventOnSubmit: function(n6, t6, r6, e5) {
          if (!n6.preventDefault)
            return !e5 || (e5(n6, null), void 0);
          n6.preventDefault();
          var u5 = n6.target || n6.srcElement, c5 = qt(Zt(t6) ? { userJwt: t6 } : { user: t6 || {} }, Gh(i4, u5));
          a4.form(c5).then(function(t7) {
            r6 && r6.injectToken ? a4.injectTokenOnSubmit(
              n6,
              function(n7) {
                return e5 ? e5(n7, t7) : u5.submit();
              }
            ) : e5 ? e5(n6, t7) : u5.submit();
          });
        } }), void (ho = i4 = u4), void (P = cr(4, d)), V = s2(Fc, ai), Y = s2(Ec, ai), J = s2(Fc, ai), X = s2(Ec, ai), $ = s2(Dc, ai), Z = s2(Dc, ai, d, d, d, 2, true, oc), mn = ci(false, oc), wn = ci(false, oc), bn = ci(false, oc), En = ci(false, oc), Dn = ci(false, oc), xn = ci(false, oc), Fn = ci(false, oc), Cn = s2(Dc, d, d, d, d, 2, true, oc), In = s2(Fc, d, d, d, d, 2, true, oc), K = s2(Fc, d, [Wu, Pu], d, Gc), nn = s2(Ic, fi, [Mu, Ou], d, Gc), tn = s2(Cc, fi, [Mu, Ou], d, Gc), un = s2(Fc, _i, [Mu]), cn = s2(Fc, _i, [Ou]), rn = s2(Fc, _i, [Mu, Ou], d, Gc), en = s2(Fc, _i, [Ou, Mu], d, Gc), hn = s2(Fc, d, [Uu, Gu, Qu], zc, Qc), dn = s2(Fc, d, [Uu, Gu, Qu], zc, Uc), on = s2(xc), an = s2(Fc, d, [zu]), _n = s2(wc, d, d, d, d, 3, false, oc), sn = s2(wc, ai, d, d, d, 3, false, oc), vn = s2(bc, d, d, d, d, 3, false, oc), fn2 = s2(Fc, d, [zu, Mu], d, Gc), ln = s2(Ic, d, [Mu], d, Jc), pn = s2(Ic, d, [Mu], d, Vc), gn = s2(Ic, d, [Mu], d, Yc), yn = s2(Ic, d, [Mu], d, Zc), void (Hn = s2(Fc, d, d, d, d, 2, true, ac)), W = hc(kc, [Mu]), G = hc(Rc), Q = hc(d, [Uu], Wc), U = hc(d), void void (z2 = cr(Ju.length, 0)), t5 = u4, e4 = function() {
          var n6, t6, r6, e5;
          t6 = u4, void Mi(t6, lt, Ju, rc), n6 = C(), r6 = t6, e5 = n6.nn.tn, n6 = G1(r6, e5) || p3(r6, e5), !!(r6 = n6) && new RegExp("^[".concat(Pr, "]{8}[").concat(Pr, "]{4}[0-5][").concat(
            Pr,
            "]{3}[89ab]["
          ).concat(Pr, "]{3}[").concat(Pr, "]{12}$")).test(r6) || (n6 = Vr(t6)), r6 = A3(e5 = t6, n6), (t6 = C()).J ? l3(e5, t6.nn.tn, "", "expires=".concat(Lo, ";")) : H3(e5, t6.nn.tn), void S3(e5, r6), void (b3 = true), k3();
        }, o4 = function() {
          return B3(u4);
        }, so = void 0, n5 = function() {
          var u5, c5, r6, n6, i5;
          Ev.Kt = e4, Ev.tr = o4, u5 = t5, c5 = C(), pv(u5, function(n7) {
            var t6 = Dv(rr(n7));
            e3(O1, k, Bv(t6)), j(bv, O1, t6);
          }), qv(Q_, Ue(u5), [zv, Pv, Wv, Gv]), qv(V_, Qe(u5), [Mo, zo]), qv(Y_, Je(u5), [$v(Uv), $v(Qv), $v(Vv), $v(Yv), $v(Zv), $v(Jv), $v(Xv), Zr($v(Uv)), Zr($v(Zv))]), kv(Z_, eu(u5)), Sv(u5, J_), A(X_, O_, Xe(u5)), A($_, O_, ru(u5)), kv(K_, Ra(u5)), jv(n1), Cv(t1, I(function() {
            return cu(u5);
          })), Cv(r1, I(function() {
            return vu(u5);
          })), Nv(u5, e1), Ov(u5, h1), u3(u1, Ye(u5)), (r6 = I(function() {
            return ya(u5);
          })) && (A(c1, N_, r6.cn), A(_1, N_, r6.on), A(s1, N_, r6.an)), xv(o1, du(u5)), xv(a1, I(function() {
            return hu(u5);
          })), qv(f1, Ve(u5), n3), A(v1, N_, qu()), A(d1, O_, wu(u5)), qv(l1, mu(u5), [Kv]), n6 = b_(), A(p1, O_, n6.vn), qv(g1, n6.hn, [x_, F_, C_]), qv(y1, n6.dn, [T_, j_, S_]), A(H1, O_, n6.ln), Tv(m1, u5), qv(w1, E_(), [I_, k_, q_, R_]), Cv(b1, Kf(u5)), Lv(E1, m_(u5)), ds(Ev, Zf, [u5], function(n7) {
            Av(i1, n7);
          }), e3(D1, L_, qo), e3(x1, N_, Su()), e3(F1, N_, Au(u5)), e3(z1, N_, Tu()), r3(k1), w2(u5) && ds(Ev, b2, [u5], function(n7) {
            Fv(j1, n7);
          }), Fv(q1, ts(u5)), t3(u5), e3(R1, O_, Sa), Mv(u5, B1), (i5 = es(u5)) && e3(C1, N_, ke), I(function() {
            return h2(u5);
          }), I(function() {
            return us(u5);
          }), ms(u5, function(n7) {
            try {
              d2(u5, n7, c5.br, c5.Er);
              var t6, r7 = a22(), e5 = (e3(I1, O_, r7.total), Iv(M1), i5 || (t6 = I(function() {
                return as();
              }), e3(C1, N_, t6)), [
                I(function() {
                  return Ca(u5);
                }),
                I(function() {
                  return V2(u5);
                }),
                I(function() {
                  return Q2(u5);
                }),
                I(function() {
                  return U2(u5);
                }),
                I(function() {
                  return Y2(_u(u5), uu(u5));
                }),
                Z2(u5),
                I(function() {
                  return D2(u5, s22(), c5.br, c5.Er);
                }),
                k2(),
                $2()
              ]);
              e3(S1, k, Bv(e5)), j(bv, S1, Dv(e5)), ds(Ev, ov, [u5], function(n8) {
                Cv(N1, n8, bv);
              });
            } finally {
              l2();
            }
          }), n6 = c5.wr ? [function() {
            return Ts(c5.wr);
          }, yv] : [function() {
            return Ss();
          }, gv], ds(Ev, js, n6, function(n7) {
            var t6;
            n7.ur ? (t6 = n7.ur, t6 = [Is(t6, r6 && r6.an), Cs(t6, ju(u5)), Fs(t6, Je(u5)), ks(t6, eu(u5)), xs(t6, ru(u5)), Ds(t6, Ue(u5)), Es(t6, Ye(u5)), bs(t6), ws(t6)], e3(A1, k, Bv(t6)), j(bv, A1, Dv(t6))) : (t6 = [!!n7.ir, !!n7.cr], e3(P1, k, Bv(t6)), j(bv, P1, Dv(t6)));
          }), void ds(Ev, nv, [u5], function(n7) {
            Fv(L1, n7, true), j(bv, L1, n7);
          });
        }, void void ((r5 = Ev).er || (n5(), r5.er = true, r5.rr === y || r5.cr === y ? (_s(r5), ss(r5)) : setTimeout(function() {
          return ls(r5);
        }, r5.cr))), void (Zh = false);
      }
      return Jh;
    }, t4 = function(n5, t5) {
      return Yh().injectTokenOnSubmit(n5, t5);
    }, qn = function(n5, t5, r5, e4) {
      return Yh().formEventOnSubmit(n5, t5, r5, e4);
    }, r4 = function() {
      return Yh().createRequestToken();
    }, n4 = function(n5) {
      return Yh().page(n5);
    }, l_ = function(n5) {
      return Yh().form(n5);
    }, d_ = function(n5) {
      return Yh().custom(n5);
    }, i_ = function() {
      return _t;
    }, Jh = {
      configure: h_,
      createRequestToken: r4,
      injectTokenOnSubmit: t4,
      formEventOnSubmit: qn,
      page: n4,
      form: l_,
      custom: d_,
      getVersion: i_
    };
    B.configure = h_, B.createRequestToken = r4, B.custom = d_, B.form = l_, B.formEventOnSubmit = qn, B.getVersion = i_, B.injectTokenOnSubmit = t4, B.page = n4;
  });
})(castle, castle.exports);
var castleExports = castle.exports;
const ForgotPassword = ({
  successUrl,
  csrfToken,
  formAction,
  castleData
}) => {
  const [isValid2, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [errors2, setErrors] = useState("");
  const [emailFormatInvalid, setEmailFormatInvalid] = useState(false);
  const {
    i18n: i18n2
  } = useLingui();
  useEffect(() => {
    if (castleData == null ? void 0 : castleData.castlePublishKey) {
      castleExports.configure({
        pk: castleData.castlePublishKey
      });
    }
  }, []);
  const handleSubmit = (e2) => __async(void 0, null, function* () {
    e2.preventDefault();
    if (!isLoading && isValid2) {
      const requestToken = castleData ? yield castleExports.createRequestToken() : null;
      const data = {
        user: __spreadValues({
          email: emailInput
        }, requestToken ? {
          castle_request_token: requestToken
        } : {}),
        authenticity_token: csrfToken
      };
      try {
        setIsLoading(true);
        const response = yield fetch(formAction, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken
          },
          body: JSON.stringify(data)
        });
        if (response.ok) {
          setIsSuccess(true);
        } else {
          if (response.status === 422) {
            setErrors("There was an error");
            setIsLoading(false);
          }
        }
      } catch (e3) {
        setErrors("There was an error");
        setIsLoading(false);
      }
    }
  });
  const onSuccess = () => {
    window.location.href = successUrl;
  };
  const isError = errors2 !== "";
  return /* @__PURE__ */ jsxs("div", { className: "gap-8 flex flex-col", children: [
    /* @__PURE__ */ jsx(Snackbar2, { isOpen: isSuccess, onClose: () => {
      setIsSuccess(false);
      onSuccess();
    }, content: i18n2._(
      /*i18n*/
      {
        id: "FnEjg1",
        values: {
          emailInput
        }
      }
    ) }),
    /* @__PURE__ */ jsxs(Container, { children: [
      /* @__PURE__ */ jsx(Title, { children: /* @__PURE__ */ jsx(Trans, { id: "slOprG" }) }),
      /* @__PURE__ */ jsx(Subitle, { children: /* @__PURE__ */ jsx(Trans, { id: "V7whZu" }) })
    ] }),
    /* @__PURE__ */ jsxs("form", { onSubmit: handleSubmit, acceptCharset: "UTF-8", className: "flex flex-col gap-8", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "authenticity_token", value: csrfToken }),
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "_method", value: "patch" }),
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "from_verify_email_page", id: "from_verify_email_page" }),
        /* @__PURE__ */ jsxs(Fieldset, { children: [
          /* @__PURE__ */ jsx(FormLabel, { htmlFor: "forgotEmail", isError: isError || emailFormatInvalid, children: /* @__PURE__ */ jsx(Trans, { id: "O3oNi5" }) }),
          /* @__PURE__ */ jsx(Input, { id: "forgotEmail", value: emailInput, onBlur: (e2) => {
            setEmailFormatInvalid(!validateEmail(e2.currentTarget.value));
          }, onChange: (e2) => {
            setErrors("");
            setEmailInput(e2.currentTarget.value);
            setIsValid(validateEmail(e2.currentTarget.value));
          }, isError: isError || emailFormatInvalid, name: "user[email]", placeholder: i18n2._(
            /*i18n*/
            {
              id: "C3nD/1"
            }
          ) }),
          isError && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "2V8vJF", components: {
            0: /* @__PURE__ */ jsx("a", { className: "text-black underline", href: "/register" })
          } }) }),
          emailFormatInvalid && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "io0enF" }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex gap-4", children: [
        /* @__PURE__ */ jsx(Button, { type: "button", hasBorder: true, onClick: onSuccess, children: /* @__PURE__ */ jsx(Trans, { id: "dEgA5A" }) }),
        /* @__PURE__ */ jsx(Button, { isLoading, isDark: true, type: "submit", disabled: !isValid2, children: /* @__PURE__ */ jsx(Trans, { id: "JlFcis" }) })
      ] })
    ] })
  ] });
};
const forgotPasswordSchema = z.object({
  successUrl: z.string(),
  csrfToken: z.string(),
  formAction: z.string(),
  castleData: z.nullable(z.object({
    castlePublishKey: z.string()
  })).optional()
});
const ForgotPasswordParent = (props) => {
  const _a = props, {
    locale = "en"
  } = _a, rest = __objRest(_a, [
    "locale"
  ]);
  useComponentValidation({
    props,
    schema: forgotPasswordSchema
  });
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsx(ForgotPassword, __spreadValues({}, rest)) });
};
const DropdownContext = /* @__PURE__ */ React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  DropdownContext.displayName = "DropdownContext";
}
function areEqual(a2, b) {
  return a2 === b;
}
const EMPTY_OBJECT$1 = {};
const NOOP$1 = () => {
};
function getControlledState(internalState, controlledProps) {
  const augmentedState = _extends$2({}, internalState);
  Object.keys(controlledProps).forEach((key) => {
    if (controlledProps[key] !== void 0) {
      augmentedState[key] = controlledProps[key];
    }
  });
  return augmentedState;
}
function useStateChangeDetection(parameters) {
  const {
    nextState,
    initialState,
    stateComparers,
    onStateChange,
    controlledProps,
    lastActionRef
  } = parameters;
  const internalPreviousStateRef = React.useRef(initialState);
  React.useEffect(() => {
    if (lastActionRef.current === null) {
      return;
    }
    const previousState = getControlledState(internalPreviousStateRef.current, controlledProps);
    Object.keys(nextState).forEach((key) => {
      var _stateComparers$key;
      const stateComparer = (_stateComparers$key = stateComparers[key]) != null ? _stateComparers$key : areEqual;
      const nextStateItem = nextState[key];
      const previousStateItem = previousState[key];
      if (previousStateItem == null && nextStateItem != null || previousStateItem != null && nextStateItem == null || previousStateItem != null && nextStateItem != null && !stateComparer(nextStateItem, previousStateItem)) {
        var _event, _type;
        onStateChange == null || onStateChange((_event = lastActionRef.current.event) != null ? _event : null, key, nextStateItem, (_type = lastActionRef.current.type) != null ? _type : "", nextState);
      }
    });
    internalPreviousStateRef.current = nextState;
    lastActionRef.current = null;
  }, [internalPreviousStateRef, nextState, lastActionRef, onStateChange, stateComparers, controlledProps]);
}
function useControllableReducer(parameters) {
  const lastActionRef = React.useRef(null);
  const {
    reducer,
    initialState,
    controlledProps = EMPTY_OBJECT$1,
    stateComparers = EMPTY_OBJECT$1,
    onStateChange = NOOP$1,
    actionContext,
    componentName = ""
  } = parameters;
  const controlledPropsRef = React.useRef(controlledProps);
  if (process.env.NODE_ENV !== "production") {
    React.useEffect(() => {
      Object.keys(controlledProps).forEach((key) => {
        if (controlledPropsRef.current[key] !== void 0 && controlledProps[key] === void 0) {
          console.error(`useControllableReducer: ${componentName ? `The ${componentName} component` : "A component"} is changing a controlled prop to be uncontrolled: ${key}`);
        }
        if (controlledPropsRef.current[key] === void 0 && controlledProps[key] !== void 0) {
          console.error(`useControllableReducer: ${componentName ? `The ${componentName} component` : "A component"} is changing an uncontrolled prop to be controlled: ${key}`);
        }
      });
    }, [controlledProps, componentName]);
  }
  const reducerWithControlledState = React.useCallback((state, action) => {
    lastActionRef.current = action;
    const controlledState = getControlledState(state, controlledProps);
    const newState = reducer(controlledState, action);
    return newState;
  }, [controlledProps, reducer]);
  const [nextState, dispatch] = React.useReducer(reducerWithControlledState, initialState);
  const dispatchWithContext = React.useCallback((action) => {
    dispatch(_extends$2({}, action, {
      context: actionContext
    }));
  }, [actionContext]);
  useStateChangeDetection({
    nextState,
    initialState,
    stateComparers: stateComparers != null ? stateComparers : EMPTY_OBJECT$1,
    onStateChange: onStateChange != null ? onStateChange : NOOP$1,
    controlledProps,
    lastActionRef
  });
  return [getControlledState(nextState, controlledProps), dispatchWithContext];
}
const DropdownActionTypes = {
  blur: "dropdown:blur",
  escapeKeyDown: "dropdown:escapeKeyDown",
  toggle: "dropdown:toggle",
  open: "dropdown:open",
  close: "dropdown:close"
};
function dropdownReducer(state, action) {
  switch (action.type) {
    case DropdownActionTypes.blur:
      return {
        open: false,
        changeReason: action.event
      };
    case DropdownActionTypes.escapeKeyDown:
      return {
        open: false,
        changeReason: action.event
      };
    case DropdownActionTypes.toggle:
      return {
        open: !state.open,
        changeReason: action.event
      };
    case DropdownActionTypes.open:
      return {
        open: true,
        changeReason: action.event
      };
    case DropdownActionTypes.close:
      return {
        open: false,
        changeReason: action.event
      };
    default:
      throw new Error(`Unhandled action`);
  }
}
function useDropdown(parameters = {}) {
  const {
    defaultOpen,
    onOpenChange,
    open: openProp,
    componentName = "useDropdown"
  } = parameters;
  const [popupId, setPopupId] = React.useState("");
  const [triggerElement, setTriggerElement] = React.useState(null);
  const lastActionType = React.useRef(null);
  const handleStateChange = React.useCallback((event, field, value, reason) => {
    if (field === "open") {
      onOpenChange == null || onOpenChange(event, value);
    }
    lastActionType.current = reason;
  }, [onOpenChange]);
  const controlledProps = React.useMemo(() => openProp !== void 0 ? {
    open: openProp
  } : {}, [openProp]);
  const [state, dispatch] = useControllableReducer({
    controlledProps,
    initialState: defaultOpen ? {
      open: true,
      changeReason: null
    } : {
      open: false,
      changeReason: null
    },
    onStateChange: handleStateChange,
    reducer: dropdownReducer,
    componentName
  });
  React.useEffect(() => {
    if (!state.open && lastActionType.current !== null && lastActionType.current !== DropdownActionTypes.blur) {
      triggerElement == null || triggerElement.focus();
    }
  }, [state.open, triggerElement]);
  const contextValue = {
    state,
    dispatch,
    popupId,
    registerPopup: setPopupId,
    registerTrigger: setTriggerElement,
    triggerElement
  };
  return {
    contextValue,
    open: state.open
  };
}
function Dropdown(props) {
  const {
    children,
    open,
    defaultOpen,
    onOpenChange
  } = props;
  const {
    contextValue
  } = useDropdown({
    defaultOpen,
    onOpenChange,
    open
  });
  return /* @__PURE__ */ jsx(DropdownContext.Provider, {
    value: contextValue,
    children
  });
}
process.env.NODE_ENV !== "production" ? Dropdown.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * If `true`, the dropdown is initially open.
   */
  defaultOpen: PropTypes.bool,
  /**
   * Callback fired when the component requests to be opened or closed.
   */
  onOpenChange: PropTypes.func,
  /**
   * Allows to control whether the dropdown is open.
   * This is a controlled counterpart of `defaultOpen`.
   */
  open: PropTypes.bool
} : void 0;
if (process.env.NODE_ENV !== "production") {
  Dropdown["propTypes"] = exactProp(Dropdown.propTypes);
}
const COMPONENT_NAME$3 = "Menu";
function getMenuUtilityClass(slot) {
  return generateUtilityClass(COMPONENT_NAME$3, slot);
}
generateUtilityClasses(COMPONENT_NAME$3, ["root", "listbox", "expanded"]);
const ListActionTypes = {
  blur: "list:blur",
  focus: "list:focus",
  itemClick: "list:itemClick",
  itemHover: "list:itemHover",
  itemsChange: "list:itemsChange",
  keyDown: "list:keyDown",
  resetHighlight: "list:resetHighlight",
  highlightLast: "list:highlightLast",
  textNavigation: "list:textNavigation",
  clearSelection: "list:clearSelection"
};
function findValidItemToHighlight(currentIndex, lookupDirection, items, includeDisabledItems, isItemDisabled, wrapAround) {
  if (items.length === 0 || !includeDisabledItems && items.every((item, itemIndex) => isItemDisabled(item, itemIndex))) {
    return -1;
  }
  let nextFocus = currentIndex;
  for (; ; ) {
    if (!wrapAround && lookupDirection === "next" && nextFocus === items.length || !wrapAround && lookupDirection === "previous" && nextFocus === -1) {
      return -1;
    }
    const nextFocusDisabled = includeDisabledItems ? false : isItemDisabled(items[nextFocus], nextFocus);
    if (nextFocusDisabled) {
      nextFocus += lookupDirection === "next" ? 1 : -1;
      if (wrapAround) {
        nextFocus = (nextFocus + items.length) % items.length;
      }
    } else {
      return nextFocus;
    }
  }
}
function moveHighlight(previouslyHighlightedValue, offset2, context) {
  var _items$nextIndex;
  const {
    items,
    isItemDisabled,
    disableListWrap,
    disabledItemsFocusable,
    itemComparer,
    focusManagement
  } = context;
  const defaultHighlightedIndex = focusManagement === "DOM" ? 0 : -1;
  const maxIndex = items.length - 1;
  const previouslyHighlightedIndex = previouslyHighlightedValue == null ? -1 : items.findIndex((item) => itemComparer(item, previouslyHighlightedValue));
  let nextIndexCandidate;
  let lookupDirection;
  let wrapAround = !disableListWrap;
  switch (offset2) {
    case "reset":
      if (defaultHighlightedIndex === -1) {
        return null;
      }
      nextIndexCandidate = 0;
      lookupDirection = "next";
      wrapAround = false;
      break;
    case "start":
      nextIndexCandidate = 0;
      lookupDirection = "next";
      wrapAround = false;
      break;
    case "end":
      nextIndexCandidate = maxIndex;
      lookupDirection = "previous";
      wrapAround = false;
      break;
    default: {
      const newIndex = previouslyHighlightedIndex + offset2;
      if (newIndex < 0) {
        if (!wrapAround && previouslyHighlightedIndex !== -1 || Math.abs(offset2) > 1) {
          nextIndexCandidate = 0;
          lookupDirection = "next";
        } else {
          nextIndexCandidate = maxIndex;
          lookupDirection = "previous";
        }
      } else if (newIndex > maxIndex) {
        if (!wrapAround || Math.abs(offset2) > 1) {
          nextIndexCandidate = maxIndex;
          lookupDirection = "previous";
        } else {
          nextIndexCandidate = 0;
          lookupDirection = "next";
        }
      } else {
        nextIndexCandidate = newIndex;
        lookupDirection = offset2 >= 0 ? "next" : "previous";
      }
    }
  }
  const nextIndex = findValidItemToHighlight(nextIndexCandidate, lookupDirection, items, disabledItemsFocusable, isItemDisabled, wrapAround);
  if (nextIndex === -1 && previouslyHighlightedValue !== null && !isItemDisabled(previouslyHighlightedValue, previouslyHighlightedIndex)) {
    return previouslyHighlightedValue;
  }
  return (_items$nextIndex = items[nextIndex]) != null ? _items$nextIndex : null;
}
function toggleSelection(item, selectedValues, selectionMode, itemComparer) {
  if (selectionMode === "none") {
    return [];
  }
  if (selectionMode === "single") {
    if (itemComparer(selectedValues[0], item)) {
      return selectedValues;
    }
    return [item];
  }
  if (selectedValues.some((sv) => itemComparer(sv, item))) {
    return selectedValues.filter((sv) => !itemComparer(sv, item));
  }
  return [...selectedValues, item];
}
function handleItemSelection(item, state, context) {
  const {
    itemComparer,
    isItemDisabled,
    selectionMode,
    items
  } = context;
  const {
    selectedValues
  } = state;
  const itemIndex = items.findIndex((i) => itemComparer(item, i));
  if (isItemDisabled(item, itemIndex)) {
    return state;
  }
  const newSelectedValues = toggleSelection(item, selectedValues, selectionMode, itemComparer);
  return _extends$2({}, state, {
    selectedValues: newSelectedValues,
    highlightedValue: item
  });
}
function handleKeyDown(key, state, context) {
  const previouslySelectedValue = state.highlightedValue;
  const {
    orientation,
    pageSize
  } = context;
  switch (key) {
    case "Home":
      return _extends$2({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, "start", context)
      });
    case "End":
      return _extends$2({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, "end", context)
      });
    case "PageUp":
      return _extends$2({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, -pageSize, context)
      });
    case "PageDown":
      return _extends$2({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, pageSize, context)
      });
    case "ArrowUp":
      if (orientation !== "vertical") {
        break;
      }
      return _extends$2({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, -1, context)
      });
    case "ArrowDown":
      if (orientation !== "vertical") {
        break;
      }
      return _extends$2({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, 1, context)
      });
    case "ArrowLeft": {
      if (orientation === "vertical") {
        break;
      }
      const offset2 = orientation === "horizontal-ltr" ? -1 : 1;
      return _extends$2({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, offset2, context)
      });
    }
    case "ArrowRight": {
      if (orientation === "vertical") {
        break;
      }
      const offset2 = orientation === "horizontal-ltr" ? 1 : -1;
      return _extends$2({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, offset2, context)
      });
    }
    case "Enter":
    case " ":
      if (state.highlightedValue === null) {
        return state;
      }
      return handleItemSelection(state.highlightedValue, state, context);
  }
  return state;
}
function handleBlur(state, context) {
  if (context.focusManagement === "DOM") {
    return state;
  }
  return _extends$2({}, state, {
    highlightedValue: null
  });
}
function textCriteriaMatches(nextFocus, searchString, stringifyItem) {
  var _stringifyItem;
  const text = (_stringifyItem = stringifyItem(nextFocus)) == null ? void 0 : _stringifyItem.trim().toLowerCase();
  if (!text || text.length === 0) {
    return false;
  }
  return text.indexOf(searchString) === 0;
}
function handleTextNavigation(state, searchString, context) {
  const {
    items,
    isItemDisabled,
    disabledItemsFocusable,
    getItemAsString
  } = context;
  const startWithCurrentItem = searchString.length > 1;
  let nextItem = startWithCurrentItem ? state.highlightedValue : moveHighlight(state.highlightedValue, 1, context);
  for (let index2 = 0; index2 < items.length; index2 += 1) {
    if (!nextItem || !startWithCurrentItem && state.highlightedValue === nextItem) {
      return state;
    }
    if (textCriteriaMatches(nextItem, searchString, getItemAsString) && (!isItemDisabled(nextItem, items.indexOf(nextItem)) || disabledItemsFocusable)) {
      return _extends$2({}, state, {
        highlightedValue: nextItem
      });
    }
    nextItem = moveHighlight(nextItem, 1, context);
  }
  return state;
}
function handleItemsChange(items, previousItems, state, context) {
  var _state$selectedValues;
  const {
    itemComparer,
    focusManagement
  } = context;
  let newHighlightedValue = null;
  if (state.highlightedValue != null) {
    var _items$find;
    newHighlightedValue = (_items$find = items.find((item) => itemComparer(item, state.highlightedValue))) != null ? _items$find : null;
  } else if (focusManagement === "DOM" && previousItems.length === 0) {
    newHighlightedValue = moveHighlight(null, "reset", context);
  }
  const selectedValues = (_state$selectedValues = state.selectedValues) != null ? _state$selectedValues : [];
  const newSelectedValues = selectedValues.filter((selectedValue) => items.some((item) => itemComparer(item, selectedValue)));
  return _extends$2({}, state, {
    highlightedValue: newHighlightedValue,
    selectedValues: newSelectedValues
  });
}
function handleResetHighlight(state, context) {
  return _extends$2({}, state, {
    highlightedValue: moveHighlight(null, "reset", context)
  });
}
function handleHighlightLast(state, context) {
  return _extends$2({}, state, {
    highlightedValue: moveHighlight(null, "end", context)
  });
}
function handleClearSelection(state, context) {
  return _extends$2({}, state, {
    selectedValues: [],
    highlightedValue: moveHighlight(null, "reset", context)
  });
}
function listReducer(state, action) {
  const {
    type,
    context
  } = action;
  switch (type) {
    case ListActionTypes.keyDown:
      return handleKeyDown(action.key, state, context);
    case ListActionTypes.itemClick:
      return handleItemSelection(action.item, state, context);
    case ListActionTypes.blur:
      return handleBlur(state, context);
    case ListActionTypes.textNavigation:
      return handleTextNavigation(state, action.searchString, context);
    case ListActionTypes.itemsChange:
      return handleItemsChange(action.items, action.previousItems, state, context);
    case ListActionTypes.resetHighlight:
      return handleResetHighlight(state, context);
    case ListActionTypes.highlightLast:
      return handleHighlightLast(state, context);
    case ListActionTypes.clearSelection:
      return handleClearSelection(state, context);
    default:
      return state;
  }
}
const TEXT_NAVIGATION_RESET_TIMEOUT = 500;
function useTextNavigation(callback) {
  const textCriteriaRef = React.useRef({
    searchString: "",
    lastTime: null
  });
  return React.useCallback((event) => {
    if (event.key.length === 1 && event.key !== " ") {
      const textCriteria = textCriteriaRef.current;
      const lowerKey = event.key.toLowerCase();
      const currentTime = performance.now();
      if (textCriteria.searchString.length > 0 && textCriteria.lastTime && currentTime - textCriteria.lastTime > TEXT_NAVIGATION_RESET_TIMEOUT) {
        textCriteria.searchString = lowerKey;
      } else if (textCriteria.searchString.length !== 1 || lowerKey !== textCriteria.searchString) {
        textCriteria.searchString += lowerKey;
      }
      textCriteria.lastTime = currentTime;
      callback(textCriteria.searchString, event);
    }
  }, [callback]);
}
const EMPTY_OBJECT = {};
const NOOP = () => {
};
const defaultItemComparer = (optionA, optionB) => optionA === optionB;
const defaultIsItemDisabled = () => false;
const defaultItemStringifier = (item) => typeof item === "string" ? item : String(item);
const defaultGetInitialState = () => ({
  highlightedValue: null,
  selectedValues: []
});
function useList(params) {
  const {
    controlledProps = EMPTY_OBJECT,
    disabledItemsFocusable = false,
    disableListWrap = false,
    focusManagement = "activeDescendant",
    getInitialState = defaultGetInitialState,
    getItemDomElement,
    getItemId,
    isItemDisabled = defaultIsItemDisabled,
    rootRef: externalListRef,
    onStateChange = NOOP,
    items,
    itemComparer = defaultItemComparer,
    getItemAsString = defaultItemStringifier,
    onChange,
    onHighlightChange,
    onItemsChange,
    orientation = "vertical",
    pageSize = 5,
    reducerActionContext = EMPTY_OBJECT,
    selectionMode = "single",
    stateReducer: externalReducer,
    componentName = "useList"
  } = params;
  if (process.env.NODE_ENV !== "production") {
    if (focusManagement === "DOM" && getItemDomElement == null) {
      throw new Error("useList: The `getItemDomElement` prop is required when using the `DOM` focus management.");
    }
    if (focusManagement === "activeDescendant" && getItemId == null) {
      throw new Error("useList: The `getItemId` prop is required when using the `activeDescendant` focus management.");
    }
  }
  const listRef = React.useRef(null);
  const handleRef = useForkRef(externalListRef, listRef);
  const handleHighlightChange = React.useCallback((event, value, reason) => {
    onHighlightChange == null || onHighlightChange(event, value, reason);
    if (focusManagement === "DOM" && value != null && (reason === ListActionTypes.itemClick || reason === ListActionTypes.keyDown || reason === ListActionTypes.textNavigation)) {
      var _getItemDomElement;
      getItemDomElement == null || (_getItemDomElement = getItemDomElement(value)) == null || _getItemDomElement.focus();
    }
  }, [getItemDomElement, onHighlightChange, focusManagement]);
  const stateComparers = React.useMemo(() => ({
    highlightedValue: itemComparer,
    selectedValues: (valuesArray1, valuesArray2) => areArraysEqual(valuesArray1, valuesArray2, itemComparer)
  }), [itemComparer]);
  const handleStateChange = React.useCallback((event, field, value, reason, state2) => {
    onStateChange == null || onStateChange(event, field, value, reason, state2);
    switch (field) {
      case "highlightedValue":
        handleHighlightChange(event, value, reason);
        break;
      case "selectedValues":
        onChange == null || onChange(event, value, reason);
        break;
    }
  }, [handleHighlightChange, onChange, onStateChange]);
  const listActionContext = React.useMemo(() => {
    return {
      disabledItemsFocusable,
      disableListWrap,
      focusManagement,
      isItemDisabled,
      itemComparer,
      items,
      getItemAsString,
      onHighlightChange: handleHighlightChange,
      orientation,
      pageSize,
      selectionMode,
      stateComparers
    };
  }, [disabledItemsFocusable, disableListWrap, focusManagement, isItemDisabled, itemComparer, items, getItemAsString, handleHighlightChange, orientation, pageSize, selectionMode, stateComparers]);
  const initialState = getInitialState();
  const reducer = externalReducer != null ? externalReducer : listReducer;
  const actionContext = React.useMemo(() => _extends$2({}, reducerActionContext, listActionContext), [reducerActionContext, listActionContext]);
  const [state, dispatch] = useControllableReducer({
    reducer,
    actionContext,
    initialState,
    controlledProps,
    stateComparers,
    onStateChange: handleStateChange,
    componentName
  });
  const {
    highlightedValue,
    selectedValues
  } = state;
  const handleTextNavigation2 = useTextNavigation((searchString, event) => dispatch({
    type: ListActionTypes.textNavigation,
    event,
    searchString
  }));
  const previousItems = React.useRef([]);
  React.useEffect(() => {
    if (areArraysEqual(previousItems.current, items, itemComparer)) {
      return;
    }
    dispatch({
      type: ListActionTypes.itemsChange,
      event: null,
      items,
      previousItems: previousItems.current
    });
    previousItems.current = items;
    onItemsChange == null || onItemsChange(items);
  }, [items, itemComparer, dispatch, onItemsChange]);
  const createHandleKeyDown = (externalHandlers) => (event) => {
    var _externalHandlers$onK;
    (_externalHandlers$onK = externalHandlers.onKeyDown) == null || _externalHandlers$onK.call(externalHandlers, event);
    if (event.defaultMuiPrevented) {
      return;
    }
    const keysToPreventDefault = ["Home", "End", "PageUp", "PageDown"];
    if (orientation === "vertical") {
      keysToPreventDefault.push("ArrowUp", "ArrowDown");
    } else {
      keysToPreventDefault.push("ArrowLeft", "ArrowRight");
    }
    if (focusManagement === "activeDescendant") {
      keysToPreventDefault.push(" ", "Enter");
    }
    if (keysToPreventDefault.includes(event.key)) {
      event.preventDefault();
    }
    dispatch({
      type: ListActionTypes.keyDown,
      key: event.key,
      event
    });
    handleTextNavigation2(event);
  };
  const createHandleBlur = (externalHandlers) => (event) => {
    var _externalHandlers$onB, _listRef$current;
    (_externalHandlers$onB = externalHandlers.onBlur) == null || _externalHandlers$onB.call(externalHandlers, event);
    if (event.defaultMuiPrevented) {
      return;
    }
    if ((_listRef$current = listRef.current) != null && _listRef$current.contains(event.relatedTarget)) {
      return;
    }
    dispatch({
      type: ListActionTypes.blur,
      event
    });
  };
  const getRootProps = (externalProps = {}) => {
    const externalEventHandlers = extractEventHandlers(externalProps);
    return _extends$2({}, externalProps, {
      "aria-activedescendant": focusManagement === "activeDescendant" && highlightedValue != null ? getItemId(highlightedValue) : void 0,
      tabIndex: focusManagement === "DOM" ? -1 : 0,
      ref: handleRef
    }, externalEventHandlers, {
      onBlur: createHandleBlur(externalEventHandlers),
      onKeyDown: createHandleKeyDown(externalEventHandlers)
    });
  };
  const getItemState = React.useCallback((item) => {
    const selected = (selectedValues != null ? selectedValues : []).some((value) => value != null && itemComparer(item, value));
    const highlighted = highlightedValue != null && itemComparer(item, highlightedValue);
    const focusable = focusManagement === "DOM";
    return {
      focusable,
      highlighted,
      selected
    };
  }, [itemComparer, selectedValues, highlightedValue, focusManagement]);
  const contextValue = React.useMemo(() => ({
    dispatch,
    getItemState
  }), [dispatch, getItemState]);
  React.useDebugValue({
    state
  });
  return {
    contextValue,
    dispatch,
    getRootProps,
    rootRef: handleRef,
    state
  };
}
const ListContext = /* @__PURE__ */ React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  ListContext.displayName = "ListContext";
}
function useListItem(parameters) {
  const {
    handlePointerOverEvents = false,
    item
  } = parameters;
  const listContext = React.useContext(ListContext);
  if (!listContext) {
    throw new Error("useListItem must be used within a ListProvider");
  }
  const {
    dispatch,
    getItemState
  } = listContext;
  const {
    highlighted,
    selected,
    focusable
  } = getItemState(item);
  const createHandleClick = React.useCallback((externalHandlers) => (event) => {
    var _externalHandlers$onC;
    (_externalHandlers$onC = externalHandlers.onClick) == null || _externalHandlers$onC.call(externalHandlers, event);
    if (event.defaultPrevented) {
      return;
    }
    if (process.env.NODE_ENV !== "production") {
      if (item === void 0) {
        throw new Error(["MUI: The `item` provided to useListItem() is undefined.", "This should happen only during server-side rendering under React 17."].join("\n"));
      }
    }
    dispatch({
      type: ListActionTypes.itemClick,
      item,
      event
    });
  }, [dispatch, item]);
  const createHandlePointerOver = React.useCallback((externalHandlers) => (event) => {
    var _externalHandlers$onM;
    (_externalHandlers$onM = externalHandlers.onMouseOver) == null || _externalHandlers$onM.call(externalHandlers, event);
    if (event.defaultPrevented) {
      return;
    }
    if (process.env.NODE_ENV !== "production") {
      if (item === void 0) {
        throw new Error(["MUI: The `item` provided to useListItem() is undefined.", "This should happen only during server-side rendering under React 17."].join("\n"));
      }
    }
    dispatch({
      type: ListActionTypes.itemHover,
      item,
      event
    });
  }, [dispatch, item]);
  let tabIndex;
  if (focusable) {
    tabIndex = highlighted ? 0 : -1;
  }
  const getRootProps = (externalProps = {}) => {
    const externalEventHandlers = extractEventHandlers(externalProps);
    return _extends$2({}, externalProps, {
      onClick: createHandleClick(externalEventHandlers),
      onPointerOver: handlePointerOverEvents ? createHandlePointerOver(externalEventHandlers) : void 0,
      tabIndex
    });
  };
  return {
    getRootProps,
    highlighted,
    selected
  };
}
function menuReducer(state, action) {
  if (action.type === ListActionTypes.itemHover) {
    return _extends$2({}, state, {
      highlightedValue: action.item
    });
  }
  const newState = listReducer(state, action);
  if (newState.highlightedValue === null && action.context.items.length > 0) {
    return _extends$2({}, newState, {
      highlightedValue: action.context.items[0]
    });
  }
  if (action.type === ListActionTypes.keyDown) {
    if (action.event.key === "Escape") {
      return _extends$2({}, newState, {
        open: false
      });
    }
  }
  if (action.type === ListActionTypes.blur) {
    var _action$context$listb;
    if (!((_action$context$listb = action.context.listboxRef.current) != null && _action$context$listb.contains(action.event.relatedTarget))) {
      var _action$context$listb2, _action$event$related;
      const listboxId = (_action$context$listb2 = action.context.listboxRef.current) == null ? void 0 : _action$context$listb2.getAttribute("id");
      const controlledBy = (_action$event$related = action.event.relatedTarget) == null ? void 0 : _action$event$related.getAttribute("aria-controls");
      if (listboxId && controlledBy && listboxId === controlledBy) {
        return newState;
      }
      return _extends$2({}, newState, {
        open: false,
        highlightedValue: action.context.items[0]
      });
    }
  }
  return newState;
}
const CompoundComponentContext = /* @__PURE__ */ React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  CompoundComponentContext.displayName = "CompoundComponentContext";
}
function sortSubitems(subitems) {
  const subitemsArray = Array.from(subitems.keys()).map((key) => {
    const subitem = subitems.get(key);
    return {
      key,
      subitem
    };
  });
  subitemsArray.sort((a2, b) => {
    const aNode = a2.subitem.ref.current;
    const bNode = b.subitem.ref.current;
    if (aNode === null || bNode === null || aNode === bNode) {
      return 0;
    }
    return aNode.compareDocumentPosition(bNode) & Node.DOCUMENT_POSITION_PRECEDING ? 1 : -1;
  });
  return new Map(subitemsArray.map((item) => [item.key, item.subitem]));
}
function useCompoundParent() {
  const [subitems, setSubitems] = React.useState(/* @__PURE__ */ new Map());
  const subitemKeys = React.useRef(/* @__PURE__ */ new Set());
  const deregisterItem = React.useCallback(function deregisterItem2(id2) {
    subitemKeys.current.delete(id2);
    setSubitems((previousState) => {
      const newState = new Map(previousState);
      newState.delete(id2);
      return newState;
    });
  }, []);
  const registerItem = React.useCallback(function registerItem2(id2, item) {
    let providedOrGeneratedId;
    if (typeof id2 === "function") {
      providedOrGeneratedId = id2(subitemKeys.current);
    } else {
      providedOrGeneratedId = id2;
    }
    subitemKeys.current.add(providedOrGeneratedId);
    setSubitems((previousState) => {
      const newState = new Map(previousState);
      newState.set(providedOrGeneratedId, item);
      return newState;
    });
    return {
      id: providedOrGeneratedId,
      deregister: () => deregisterItem(providedOrGeneratedId)
    };
  }, [deregisterItem]);
  const sortedSubitems = React.useMemo(() => sortSubitems(subitems), [subitems]);
  const getItemIndex = React.useCallback(function getItemIndex2(id2) {
    return Array.from(sortedSubitems.keys()).indexOf(id2);
  }, [sortedSubitems]);
  const contextValue = React.useMemo(() => ({
    getItemIndex,
    registerItem,
    totalSubitemCount: subitems.size
  }), [getItemIndex, registerItem, subitems.size]);
  return {
    contextValue,
    subitems: sortedSubitems
  };
}
function useCompoundItem(id2, itemMetadata) {
  const context = React.useContext(CompoundComponentContext);
  if (context === null) {
    throw new Error("useCompoundItem must be used within a useCompoundParent");
  }
  const {
    registerItem
  } = context;
  const [registeredId, setRegisteredId] = React.useState(typeof id2 === "function" ? void 0 : id2);
  useEnhancedEffect$1(() => {
    const {
      id: returnedId,
      deregister
    } = registerItem(id2, itemMetadata);
    setRegisteredId(returnedId);
    return deregister;
  }, [registerItem, itemMetadata, id2]);
  return {
    id: registeredId,
    index: registeredId !== void 0 ? context.getItemIndex(registeredId) : -1,
    totalItemCount: context.totalSubitemCount
  };
}
function combineHooksSlotProps(getFirstProps, getSecondProps) {
  return function getCombinedProps(external = {}) {
    const firstResult = _extends$2({}, external, getFirstProps(external));
    const result = _extends$2({}, firstResult, getSecondProps(firstResult));
    return result;
  };
}
const FALLBACK_MENU_CONTEXT$1 = {
  dispatch: () => {
  },
  popupId: "",
  registerPopup: () => {
  },
  registerTrigger: () => {
  },
  state: {
    open: true,
    changeReason: null
  },
  triggerElement: null
};
function useMenu(parameters = {}) {
  var _useId, _React$useContext;
  const {
    listboxRef: listboxRefProp,
    onItemsChange,
    id: idParam,
    disabledItemsFocusable = true,
    disableListWrap = false,
    autoFocus = true,
    componentName = "useMenu"
  } = parameters;
  const rootRef = React.useRef(null);
  const handleRef = useForkRef(rootRef, listboxRefProp);
  const listboxId = (_useId = useId(idParam)) != null ? _useId : "";
  const {
    state: {
      open,
      changeReason
    },
    dispatch: menuDispatch,
    triggerElement,
    registerPopup
  } = (_React$useContext = React.useContext(DropdownContext)) != null ? _React$useContext : FALLBACK_MENU_CONTEXT$1;
  const isInitiallyOpen = React.useRef(open);
  const {
    subitems,
    contextValue: compoundComponentContextValue
  } = useCompoundParent();
  const subitemKeys = React.useMemo(() => Array.from(subitems.keys()), [subitems]);
  const getItemDomElement = React.useCallback((itemId) => {
    var _subitems$get$ref$cur, _subitems$get;
    if (itemId == null) {
      return null;
    }
    return (_subitems$get$ref$cur = (_subitems$get = subitems.get(itemId)) == null ? void 0 : _subitems$get.ref.current) != null ? _subitems$get$ref$cur : null;
  }, [subitems]);
  const isItemDisabled = React.useCallback((id2) => {
    var _subitems$get2;
    return (subitems == null || (_subitems$get2 = subitems.get(id2)) == null ? void 0 : _subitems$get2.disabled) || false;
  }, [subitems]);
  const getItemAsString = React.useCallback((id2) => {
    var _subitems$get3, _subitems$get4;
    return ((_subitems$get3 = subitems.get(id2)) == null ? void 0 : _subitems$get3.label) || ((_subitems$get4 = subitems.get(id2)) == null || (_subitems$get4 = _subitems$get4.ref.current) == null ? void 0 : _subitems$get4.innerText);
  }, [subitems]);
  const reducerActionContext = React.useMemo(() => ({
    listboxRef: rootRef
  }), [rootRef]);
  const {
    dispatch: listDispatch,
    getRootProps: getListRootProps,
    contextValue: listContextValue,
    state: {
      highlightedValue
    },
    rootRef: mergedListRef
  } = useList({
    disabledItemsFocusable,
    disableListWrap,
    focusManagement: "DOM",
    getItemDomElement,
    getInitialState: () => ({
      selectedValues: [],
      highlightedValue: null
    }),
    isItemDisabled,
    items: subitemKeys,
    getItemAsString,
    rootRef: handleRef,
    onItemsChange,
    reducerActionContext,
    selectionMode: "none",
    stateReducer: menuReducer,
    componentName
  });
  useEnhancedEffect$1(() => {
    registerPopup(listboxId);
  }, [listboxId, registerPopup]);
  useEnhancedEffect$1(() => {
    if (open && (changeReason == null ? void 0 : changeReason.type) === "keydown" && changeReason.key === "ArrowUp") {
      listDispatch({
        type: ListActionTypes.highlightLast,
        event: changeReason
      });
    }
  }, [open, changeReason, listDispatch]);
  React.useEffect(() => {
    if (open && autoFocus && highlightedValue && !isInitiallyOpen.current) {
      var _subitems$get5;
      (_subitems$get5 = subitems.get(highlightedValue)) == null || (_subitems$get5 = _subitems$get5.ref) == null || (_subitems$get5 = _subitems$get5.current) == null || _subitems$get5.focus();
    }
  }, [open, autoFocus, highlightedValue, subitems, subitemKeys]);
  React.useEffect(() => {
    var _rootRef$current;
    if ((_rootRef$current = rootRef.current) != null && _rootRef$current.contains(document.activeElement) && highlightedValue !== null) {
      var _subitems$get6;
      subitems == null || (_subitems$get6 = subitems.get(highlightedValue)) == null || (_subitems$get6 = _subitems$get6.ref.current) == null || _subitems$get6.focus();
    }
  }, [highlightedValue, subitems]);
  const createHandleBlur = (otherHandlers) => (event) => {
    var _otherHandlers$onBlur, _rootRef$current2;
    (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
    if (event.defaultMuiPrevented) {
      return;
    }
    if ((_rootRef$current2 = rootRef.current) != null && _rootRef$current2.contains(event.relatedTarget) || event.relatedTarget === triggerElement) {
      return;
    }
    menuDispatch({
      type: DropdownActionTypes.blur,
      event
    });
  };
  const createHandleKeyDown = (otherHandlers) => (event) => {
    var _otherHandlers$onKeyD;
    (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
    if (event.defaultMuiPrevented) {
      return;
    }
    if (event.key === "Escape") {
      menuDispatch({
        type: DropdownActionTypes.escapeKeyDown,
        event
      });
    }
  };
  const getOwnListboxHandlers = (otherHandlers = {}) => ({
    onBlur: createHandleBlur(otherHandlers),
    onKeyDown: createHandleKeyDown(otherHandlers)
  });
  const getListboxProps = (externalProps = {}) => {
    const getCombinedRootProps = combineHooksSlotProps(getOwnListboxHandlers, getListRootProps);
    const externalEventHandlers = extractEventHandlers(externalProps);
    return _extends$2({}, externalProps, externalEventHandlers, getCombinedRootProps(externalEventHandlers), {
      id: listboxId,
      role: "menu"
    });
  };
  React.useDebugValue({
    subitems,
    highlightedValue
  });
  return {
    contextValue: _extends$2({}, compoundComponentContextValue, listContextValue),
    dispatch: listDispatch,
    getListboxProps,
    highlightedValue,
    listboxRef: mergedListRef,
    menuItems: subitems,
    open,
    triggerElement
  };
}
function MenuProvider(props) {
  const {
    value,
    children
  } = props;
  const {
    dispatch,
    getItemIndex,
    getItemState,
    registerItem,
    totalSubitemCount
  } = value;
  const listContextValue = React.useMemo(() => ({
    dispatch,
    getItemState,
    getItemIndex
  }), [dispatch, getItemIndex, getItemState]);
  const compoundComponentContextValue = React.useMemo(() => ({
    getItemIndex,
    registerItem,
    totalSubitemCount
  }), [registerItem, getItemIndex, totalSubitemCount]);
  return /* @__PURE__ */ jsx(CompoundComponentContext.Provider, {
    value: compoundComponentContextValue,
    children: /* @__PURE__ */ jsx(ListContext.Provider, {
      value: listContextValue,
      children
    })
  });
}
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v) => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp$2(start2, value, end2) {
  return max(start2, min(value, end2));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length2 = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length2] > rects.floating[length2]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl)
        return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding2) {
  return __spreadValues({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, padding2);
}
function getPaddingObject(padding2) {
  return typeof padding2 !== "number" ? expandPaddingObject(padding2) : {
    top: padding2,
    right: padding2,
    bottom: padding2,
    left: padding2
  };
}
function rectToClientRect(rect) {
  const {
    x: x2,
    y,
    width: width2,
    height: height2
  } = rect;
  return {
    width: width2,
    height: height2,
    top: y,
    left: x2,
    right: x2 + width2,
    bottom: y + height2,
    x: x2,
    y
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference: reference2,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference2.x + reference2.width / 2 - floating.width / 2;
  const commonY = reference2.y + reference2.height / 2 - floating.height / 2;
  const commonAlign = reference2[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference2.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case "right":
      coords = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference2.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference2.x,
        y: reference2.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = (reference2, floating, config2) => __async(void 0, null, function* () {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware: middleware2 = [],
    platform: platform2
  } = config2;
  const validMiddleware = middleware2.filter(Boolean);
  const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(floating);
  let rects = yield platform2.getElementRects({
    reference: reference2,
    floating,
    strategy
  });
  let {
    x: x2,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn: fn2
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = yield fn2({
      x: x2,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference: reference2,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y = nextY != null ? nextY : y;
    middlewareData = __spreadProps(__spreadValues({}, middlewareData), {
      [name]: __spreadValues(__spreadValues({}, middlewareData[name]), data)
    });
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? yield platform2.getElementRects({
            reference: reference2,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x: x2,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
});
function detectOverflow(state, options) {
  return __async(this, null, function* () {
    var _await$platform$isEle;
    if (options === void 0) {
      options = {};
    }
    const {
      x: x2,
      y,
      platform: platform2,
      rects,
      elements,
      strategy
    } = state;
    const {
      boundary = "clippingAncestors",
      rootBoundary = "viewport",
      elementContext = "floating",
      altBoundary = false,
      padding: padding2 = 0
    } = evaluate(options, state);
    const paddingObject = getPaddingObject(padding2);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = rectToClientRect(yield platform2.getClippingRect({
      element: ((_await$platform$isEle = yield platform2.isElement == null ? void 0 : platform2.isElement(element)) != null ? _await$platform$isEle : true) ? element : element.contextElement || (yield platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
      boundary,
      rootBoundary,
      strategy
    }));
    const rect = elementContext === "floating" ? {
      x: x2,
      y,
      width: rects.floating.width,
      height: rects.floating.height
    } : rects.reference;
    const offsetParent = yield platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating);
    const offsetScale = (yield platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? (yield platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
      x: 1,
      y: 1
    } : {
      x: 1,
      y: 1
    };
    const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? yield platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
      elements,
      rect,
      offsetParent,
      strategy
    }) : rect);
    return {
      top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
      bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
      left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
      right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
  });
}
const flip$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    fn(state) {
      return __async(this, null, function* () {
        var _middlewareData$arrow, _middlewareData$flip;
        const {
          placement,
          middlewareData,
          rects,
          initialPlacement,
          platform: platform2,
          elements
        } = state;
        const _a2 = evaluate(options, state), {
          mainAxis: checkMainAxis = true,
          crossAxis: checkCrossAxis = true,
          fallbackPlacements: specifiedFallbackPlacements,
          fallbackStrategy = "bestFit",
          fallbackAxisSideDirection = "none",
          flipAlignment = true
        } = _a2, detectOverflowOptions = __objRest(_a2, [
          "mainAxis",
          "crossAxis",
          "fallbackPlacements",
          "fallbackStrategy",
          "fallbackAxisSideDirection",
          "flipAlignment"
        ]);
        if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
          return {};
        }
        const side = getSide(placement);
        const isBasePlacement = getSide(initialPlacement) === initialPlacement;
        const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating);
        const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
        if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") {
          fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
        }
        const placements2 = [initialPlacement, ...fallbackPlacements];
        const overflow = yield detectOverflow(state, detectOverflowOptions);
        const overflows = [];
        let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
        if (checkMainAxis) {
          overflows.push(overflow[side]);
        }
        if (checkCrossAxis) {
          const sides = getAlignmentSides(placement, rects, rtl);
          overflows.push(overflow[sides[0]], overflow[sides[1]]);
        }
        overflowsData = [...overflowsData, {
          placement,
          overflows
        }];
        if (!overflows.every((side2) => side2 <= 0)) {
          var _middlewareData$flip2, _overflowsData$filter;
          const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
          const nextPlacement = placements2[nextIndex];
          if (nextPlacement) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
          let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a2, b) => a2.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
          if (!resetPlacement) {
            switch (fallbackStrategy) {
              case "bestFit": {
                var _overflowsData$map$so;
                const placement2 = (_overflowsData$map$so = overflowsData.map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a2, b) => a2[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                if (placement2) {
                  resetPlacement = placement2;
                }
                break;
              }
              case "initialPlacement":
                resetPlacement = initialPlacement;
                break;
            }
          }
          if (placement !== resetPlacement) {
            return {
              reset: {
                placement: resetPlacement
              }
            };
          }
        }
        return {};
      });
    }
  };
};
function convertValueToCoords(state, options) {
  return __async(this, null, function* () {
    const {
      placement,
      platform: platform2,
      elements
    } = state;
    const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating);
    const side = getSide(placement);
    const alignment = getAlignment(placement);
    const isVertical = getSideAxis(placement) === "y";
    const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = evaluate(options, state);
    let {
      mainAxis,
      crossAxis,
      alignmentAxis
    } = typeof rawValue === "number" ? {
      mainAxis: rawValue,
      crossAxis: 0,
      alignmentAxis: null
    } : __spreadValues({
      mainAxis: 0,
      crossAxis: 0,
      alignmentAxis: null
    }, rawValue);
    if (alignment && typeof alignmentAxis === "number") {
      crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    }
    return isVertical ? {
      x: crossAxis * crossAxisMulti,
      y: mainAxis * mainAxisMulti
    } : {
      x: mainAxis * mainAxisMulti,
      y: crossAxis * crossAxisMulti
    };
  });
}
const offset$2 = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    fn(state) {
      return __async(this, null, function* () {
        var _middlewareData$offse, _middlewareData$arrow;
        const {
          x: x2,
          y,
          placement,
          middlewareData
        } = state;
        const diffCoords = yield convertValueToCoords(state, options);
        if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
          return {};
        }
        return {
          x: x2 + diffCoords.x,
          y: y + diffCoords.y,
          data: __spreadProps(__spreadValues({}, diffCoords), {
            placement
          })
        };
      });
    }
  };
};
const shift$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    fn(state) {
      return __async(this, null, function* () {
        const {
          x: x2,
          y,
          placement
        } = state;
        const _a2 = evaluate(options, state), {
          mainAxis: checkMainAxis = true,
          crossAxis: checkCrossAxis = false,
          limiter = {
            fn: (_ref) => {
              let {
                x: x3,
                y: y2
              } = _ref;
              return {
                x: x3,
                y: y2
              };
            }
          }
        } = _a2, detectOverflowOptions = __objRest(_a2, [
          "mainAxis",
          "crossAxis",
          "limiter"
        ]);
        const coords = {
          x: x2,
          y
        };
        const overflow = yield detectOverflow(state, detectOverflowOptions);
        const crossAxis = getSideAxis(getSide(placement));
        const mainAxis = getOppositeAxis(crossAxis);
        let mainAxisCoord = coords[mainAxis];
        let crossAxisCoord = coords[crossAxis];
        if (checkMainAxis) {
          const minSide = mainAxis === "y" ? "top" : "left";
          const maxSide = mainAxis === "y" ? "bottom" : "right";
          const min2 = mainAxisCoord + overflow[minSide];
          const max2 = mainAxisCoord - overflow[maxSide];
          mainAxisCoord = clamp$2(min2, mainAxisCoord, max2);
        }
        if (checkCrossAxis) {
          const minSide = crossAxis === "y" ? "top" : "left";
          const maxSide = crossAxis === "y" ? "bottom" : "right";
          const min2 = crossAxisCoord + overflow[minSide];
          const max2 = crossAxisCoord - overflow[maxSide];
          crossAxisCoord = clamp$2(min2, crossAxisCoord, max2);
        }
        const limitedCoords = limiter.fn(__spreadProps(__spreadValues({}, state), {
          [mainAxis]: mainAxisCoord,
          [crossAxis]: crossAxisCoord
        }));
        return __spreadProps(__spreadValues({}, limitedCoords), {
          data: {
            x: limitedCoords.x - x2,
            y: limitedCoords.y - y
          }
        });
      });
    }
  };
};
function getNodeName(node2) {
  if (isNode(node2)) {
    return (node2.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node2) {
  var _node$ownerDocument;
  return (node2 == null || (_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node2) {
  var _ref;
  return (_ref = (isNode(node2) ? node2.ownerDocument : node2.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$3(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = getComputedStyle$3(element);
  return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || ["transform", "perspective", "filter"].some((value) => (css.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports)
    return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node2) {
  return ["html", "body", "#document"].includes(getNodeName(node2));
}
function getComputedStyle$3(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node2) {
  if (getNodeName(node2) === "html") {
    return node2;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node2.assignedSlot || // DOM Element detected.
    node2.parentNode || // ShadowRoot detected.
    isShadowRoot(node2) && node2.host || // Fallback.
    getDocumentElement(node2)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node2) {
  const parentNode = getParentNode(node2);
  if (isLastTraversableNode(parentNode)) {
    return node2.ownerDocument ? node2.ownerDocument.body : node2.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node2, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node2);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node2.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getCssDimensions(element) {
  const css = getComputedStyle$3(element);
  let width2 = parseFloat(css.width) || 0;
  let height2 = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width2;
  const offsetHeight = hasOffset ? element.offsetHeight : height2;
  const shouldFallback = round(width2) !== offsetWidth || round(height2) !== offsetHeight;
  if (shouldFallback) {
    width2 = offsetWidth;
    height2 = offsetHeight;
  }
  return {
    width: width2,
    height: height2,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width: width2,
    height: height2,
    $
  } = getCssDimensions(domElement);
  let x2 = ($ ? round(rect.width) : rect.width) / width2;
  let y = ($ ? round(rect.height) : rect.height) / height2;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x: x2,
    y
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale2 = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale2 = getScale(offsetParent);
      }
    } else {
      scale2 = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x2 = (clientRect.left + visualOffsets.x) / scale2.x;
  let y = (clientRect.top + visualOffsets.y) / scale2.y;
  let width2 = clientRect.width / scale2.x;
  let height2 = clientRect.height / scale2.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = currentWin.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$3(currentIFrame);
      const left2 = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top2 = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y *= iframeScale.y;
      width2 *= iframeScale.x;
      height2 *= iframeScale.y;
      x2 += left2;
      y += top2;
      currentWin = getWindow(currentIFrame);
      currentIFrame = currentWin.frameElement;
    }
  }
  return rectToClientRect({
    width: width2,
    height: height2,
    x: x2,
    y
  });
}
const topLayerSelectors = [":popover-open", ":modal"];
function isTopLayer(element) {
  return topLayerSelectors.some((selector) => {
    try {
      return element.matches(selector);
    } catch (e2) {
      return false;
    }
  });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale2 = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale2 = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale2.x,
    height: rect.height * scale2.y,
    x: rect.x * scale2.x - scroll.scrollLeft * scale2.x + offsets.x,
    y: rect.y * scale2.y - scroll.scrollTop * scale2.y + offsets.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width2 = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height2 = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$3(body).direction === "rtl") {
    x2 += max(html.clientWidth, body.clientWidth) - width2;
  }
  return {
    width: width2,
    height: height2,
    x: x2,
    y
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width2 = html.clientWidth;
  let height2 = html.clientHeight;
  let x2 = 0;
  let y = 0;
  if (visualViewport) {
    width2 = visualViewport.width;
    height2 = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width: width2,
    height: height2,
    x: x2,
    y
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top2 = clientRect.top + element.clientTop;
  const left2 = clientRect.left + element.clientLeft;
  const scale2 = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width2 = element.clientWidth * scale2.x;
  const height2 = element.clientHeight * scale2.y;
  const x2 = left2 * scale2.x;
  const y = top2 * scale2.y;
  return {
    width: width2,
    height: height2,
    x: x2,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = __spreadProps(__spreadValues({}, clippingAncestor), {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    });
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$3(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache2) {
  const cachedResult = cache2.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$3(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$3(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache2.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width: width2,
    height: height2
  } = getCssDimensions(element);
  return {
    width: width2,
    height: height2
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const x2 = rect.left + scroll.scrollLeft - offsets.x;
  const y = rect.top + scroll.scrollTop - offsets.y;
  return {
    x: x2,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle$3(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$3(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = function(data) {
  return __async(this, null, function* () {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = yield getDimensionsFn(data.floating);
    return {
      reference: getRectRelativeToOffsetParent(data.reference, yield getOffsetParentFn(data.floating), data.strategy),
      floating: {
        x: 0,
        y: 0,
        width: floatingDimensions.width,
        height: floatingDimensions.height
      }
    };
  });
};
function isRTL(element) {
  return getComputedStyle$3(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root2 = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left: left2,
      top: top2,
      width: width2,
      height: height2
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width2 || !height2) {
      return;
    }
    const insetTop = floor(top2);
    const insetRight = floor(root2.clientWidth - (left2 + width2));
    const insetBottom = floor(root2.clientHeight - (top2 + height2));
    const insetLeft = floor(left2);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, __spreadProps(__spreadValues({}, options), {
        // Handle <iframe>s
        root: root2.ownerDocument
      }));
    } catch (e2) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference2, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference2);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference2) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference2);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset$1 = offset$2;
const shift$1 = shift$2;
const flip$1 = flip$2;
const computePosition = (reference2, floating, options) => {
  const cache2 = /* @__PURE__ */ new Map();
  const mergedOptions = __spreadValues({
    platform
  }, options);
  const platformWithCache = __spreadProps(__spreadValues({}, mergedOptions.platform), {
    _c: cache2
  });
  return computePosition$1(reference2, floating, __spreadProps(__spreadValues({}, mergedOptions), {
    platform: platformWithCache
  }));
};
var index = typeof document !== "undefined" ? useLayoutEffect : useEffect;
function deepEqual(a2, b) {
  if (a2 === b) {
    return true;
  }
  if (typeof a2 !== typeof b) {
    return false;
  }
  if (typeof a2 === "function" && a2.toString() === b.toString()) {
    return true;
  }
  let length2;
  let i;
  let keys;
  if (a2 && b && typeof a2 === "object") {
    if (Array.isArray(a2)) {
      length2 = a2.length;
      if (length2 !== b.length)
        return false;
      for (i = length2; i-- !== 0; ) {
        if (!deepEqual(a2[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a2);
    length2 = keys.length;
    if (length2 !== Object.keys(b).length) {
      return false;
    }
    for (i = length2; i-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length2; i-- !== 0; ) {
      const key = keys[i];
      if (key === "_owner" && a2.$$typeof) {
        continue;
      }
      if (!deepEqual(a2[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a2 !== a2 && b !== b;
}
function getDPR(element) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
  const ref = React.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware: middleware2 = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware2);
  if (!deepEqual(latestMiddleware, middleware2)) {
    setLatestMiddleware(middleware2);
  }
  const [_reference, _setReference] = React.useState(null);
  const [_floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback((node2) => {
    if (node2 !== referenceRef.current) {
      referenceRef.current = node2;
      _setReference(node2);
    }
  }, []);
  const setFloating = React.useCallback((node2) => {
    if (node2 !== floatingRef.current) {
      floatingRef.current = node2;
      _setFloating(node2);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const update = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config2 = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config2.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config2).then((data2) => {
      const fullData = __spreadProps(__spreadValues({}, data2), {
        isPositioned: true
      });
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => __spreadProps(__spreadValues({}, data2), {
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl)
      referenceRef.current = referenceEl;
    if (floatingEl)
      floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x2 = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return __spreadValues(__spreadProps(__spreadValues({}, initialStyles), {
        transform: "translate(" + x2 + "px, " + y + "px)"
      }), getDPR(elements.floating) >= 1.5 && {
        willChange: "transform"
      });
    }
    return {
      position: strategy,
      left: x2,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React.useMemo(() => __spreadProps(__spreadValues({}, data), {
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}
const offset = (options, deps) => __spreadProps(__spreadValues({}, offset$1(options)), {
  options: [options, deps]
});
const shift = (options, deps) => __spreadProps(__spreadValues({}, shift$1(options)), {
  options: [options, deps]
});
const flip = (options, deps) => __spreadProps(__spreadValues({}, flip$1(options)), {
  options: [options, deps]
});
const COMPONENT_NAME$2 = "Popup";
function getPopupUtilityClass(slot) {
  return generateUtilityClass(COMPONENT_NAME$2, slot);
}
generateUtilityClasses(COMPONENT_NAME$2, ["root", "open"]);
const TransitionContext = /* @__PURE__ */ React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  TransitionContext.displayName = "TransitionContext";
}
function useTransitionTrigger(requestEnter) {
  const [exitTransitionFinished, setExitTransitionFinished] = React.useState(true);
  const hasPendingExitTransition = React.useRef(false);
  const registeredTransitions = React.useRef(0);
  const [hasTransition, setHasTransition] = React.useState(false);
  const previousRequestEnter = React.useRef(requestEnter);
  React.useEffect(() => {
    if (!requestEnter && // checking registeredTransitions.current instead of hasTransition to avoid this effect re-firing whenever hasTransition changes
    registeredTransitions.current > 0 && // prevents waiting for a pending transition right after mounting
    previousRequestEnter.current !== requestEnter) {
      hasPendingExitTransition.current = true;
      setExitTransitionFinished(false);
    }
    previousRequestEnter.current = requestEnter;
  }, [requestEnter]);
  const handleExited = React.useCallback(() => {
    hasPendingExitTransition.current = false;
    setExitTransitionFinished(true);
  }, []);
  const registerTransition = React.useCallback(() => {
    registeredTransitions.current += 1;
    setHasTransition(true);
    return () => {
      registeredTransitions.current -= 1;
      if (registeredTransitions.current === 0) {
        setHasTransition(false);
      }
    };
  }, []);
  let hasExited;
  if (!hasTransition) {
    hasExited = !requestEnter;
  } else if (requestEnter) {
    hasExited = false;
  } else {
    hasExited = !hasPendingExitTransition.current && exitTransitionFinished;
  }
  const contextValue = React.useMemo(() => ({
    requestedEnter: requestEnter,
    onExited: handleExited,
    registerTransition,
    hasExited
  }), [handleExited, requestEnter, registerTransition, hasExited]);
  return {
    contextValue,
    hasExited
  };
}
const PopupContext = /* @__PURE__ */ React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  PopupContext.displayName = "PopupContext";
}
const _excluded$3 = ["anchor", "children", "container", "disablePortal", "keepMounted", "middleware", "offset", "open", "placement", "slotProps", "slots", "strategy"];
function useUtilityClasses$3(ownerState) {
  const {
    open
  } = ownerState;
  const slots = {
    root: ["root", open && "open"]
  };
  return composeClasses(slots, useClassNamesOverride(getPopupUtilityClass));
}
function resolveAnchor(anchor) {
  return typeof anchor === "function" ? anchor() : anchor;
}
const Popup = /* @__PURE__ */ React.forwardRef(function Popup2(props, forwardedRef) {
  var _slots$root;
  const {
    anchor: anchorProp,
    children,
    container,
    disablePortal = false,
    keepMounted = false,
    middleware: middleware2,
    offset: offsetProp = 0,
    open = false,
    placement = "bottom",
    slotProps = {},
    slots = {},
    strategy = "absolute"
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$3);
  const {
    refs,
    elements,
    floatingStyles,
    update,
    placement: finalPlacement
  } = useFloating({
    elements: {
      reference: resolveAnchor(anchorProp)
    },
    open,
    middleware: middleware2 != null ? middleware2 : [offset(offsetProp != null ? offsetProp : 0), flip(), shift()],
    placement,
    strategy,
    whileElementsMounted: !keepMounted ? autoUpdate : void 0
  });
  const handleRef = useForkRef(refs.setFloating, forwardedRef);
  useEnhancedEffect$1(() => {
    if (keepMounted && open && elements.reference && elements.floating) {
      const cleanup = autoUpdate(elements.reference, elements.floating, update);
      return cleanup;
    }
    return void 0;
  }, [keepMounted, open, elements, update]);
  const ownerState = _extends$2({}, props, {
    disablePortal,
    keepMounted,
    offset,
    open,
    placement,
    finalPlacement,
    strategy
  });
  const {
    contextValue,
    hasExited: hasTransitionExited
  } = useTransitionTrigger(open);
  const visibility = keepMounted && hasTransitionExited ? "hidden" : void 0;
  const classes = useUtilityClasses$3(ownerState);
  const Root = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : "div";
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    ownerState,
    className: classes.root,
    additionalProps: {
      ref: handleRef,
      role: "tooltip",
      style: _extends$2({}, floatingStyles, {
        visibility
      })
    }
  });
  const popupContextValue = React.useMemo(() => ({
    placement: finalPlacement
  }), [finalPlacement]);
  const shouldRender = keepMounted || !hasTransitionExited;
  if (!shouldRender) {
    return null;
  }
  return /* @__PURE__ */ jsx(Portal, {
    disablePortal,
    container,
    children: /* @__PURE__ */ jsx(PopupContext.Provider, {
      value: popupContextValue,
      children: /* @__PURE__ */ jsx(TransitionContext.Provider, {
        value: contextValue,
        children: /* @__PURE__ */ jsx(Root, _extends$2({}, rootProps, {
          children
        }))
      })
    })
  });
});
process.env.NODE_ENV !== "production" ? Popup.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtual element](https://floating-ui.com/docs/virtual-elements),
   * or a function that returns either.
   * It's used to set the position of the popup.
   */
  anchor: PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]),
  /**
   * @ignore
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * An HTML element or function that returns one. The container will have the portal children appended to it.
   * By default, it uses the body of the top-level document object, so it's `document.body` in these cases.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true`, the popup will be rendered where it is defined, without the use of portals.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the popup will exist in the DOM even if it's closed.
   * Its visibility will be controlled by the `visibility` CSS property.
   *
   * Otherwise, a closed popup will be removed from the DOM.
   *
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Collection of Floating UI middleware to use when positioning the popup.
   * If not provided, the [`offset`](https://floating-ui.com/docs/offset)
   * and [`flip`](https://floating-ui.com/docs/flip) functions will be used.
   *
   * @see https://floating-ui.com/docs/computePosition#middleware
   */
  middleware: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([false]), PropTypes.shape({
    fn: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.any
  })])),
  /**
   * Distance between a popup and the trigger element.
   * This prop is ignored when custom `middleware` is provided.
   *
   * @default 0
   * @see https://floating-ui.com/docs/offset
   */
  offset: PropTypes.oneOfType([PropTypes.func, PropTypes.number, PropTypes.shape({
    alignmentAxis: PropTypes.number,
    crossAxis: PropTypes.number,
    mainAxis: PropTypes.number
  })]),
  /**
   * If `true`, the popup is visible.
   *
   * @default false
   */
  open: PropTypes.bool,
  /**
   * Determines where to place the popup relative to the trigger element.
   *
   * @default 'bottom'
   * @see https://floating-ui.com/docs/computePosition#placement
   */
  placement: PropTypes.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The props used for each slot inside the Popup.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popup.
   * Either a string to use a HTML element or a component.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The type of CSS position property to use (absolute or fixed).
   *
   * @default 'absolute'
   * @see https://floating-ui.com/docs/computePosition#strategy
   */
  strategy: PropTypes.oneOf(["absolute", "fixed"])
} : void 0;
const _excluded$2 = ["actions", "anchor", "children", "onItemsChange", "slotProps", "slots"];
function useUtilityClasses$2(ownerState) {
  const {
    open
  } = ownerState;
  const slots = {
    root: ["root", open && "expanded"],
    listbox: ["listbox", open && "expanded"]
  };
  return composeClasses(slots, useClassNamesOverride(getMenuUtilityClass));
}
const Menu = /* @__PURE__ */ React.forwardRef(function Menu2(props, forwardedRef) {
  var _slots$root, _slots$listbox;
  const {
    actions,
    anchor: anchorProp,
    children,
    onItemsChange,
    slotProps = {},
    slots = {}
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$2);
  const {
    contextValue,
    getListboxProps,
    dispatch,
    open,
    triggerElement
  } = useMenu({
    onItemsChange,
    componentName: "Menu"
  });
  const anchor = anchorProp != null ? anchorProp : triggerElement;
  React.useImperativeHandle(actions, () => ({
    dispatch,
    resetHighlight: () => dispatch({
      type: ListActionTypes.resetHighlight,
      event: null
    })
  }), [dispatch]);
  const ownerState = _extends$2({}, props, {
    open
  });
  const classes = useUtilityClasses$2(ownerState);
  const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    additionalProps: {
      ref: forwardedRef,
      role: void 0
    },
    className: classes.root,
    ownerState
  });
  const Listbox2 = (_slots$listbox = slots.listbox) != null ? _slots$listbox : "ul";
  const listboxProps = useSlotProps({
    elementType: Listbox2,
    getSlotProps: getListboxProps,
    externalSlotProps: slotProps.listbox,
    className: classes.listbox,
    ownerState
  });
  if (open === true && anchor == null) {
    return /* @__PURE__ */ jsx(Root, _extends$2({}, rootProps, {
      children: /* @__PURE__ */ jsx(Listbox2, _extends$2({}, listboxProps, {
        children: /* @__PURE__ */ jsx(MenuProvider, {
          value: contextValue,
          children
        })
      }))
    }));
  }
  return /* @__PURE__ */ jsx(Popup, _extends$2({
    keepMounted: true
  }, rootProps, {
    open,
    anchor,
    slots: {
      root: Root
    },
    children: /* @__PURE__ */ jsx(Listbox2, _extends$2({}, listboxProps, {
      children: /* @__PURE__ */ jsx(MenuProvider, {
        value: contextValue,
        children
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Menu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref with imperative actions that can be performed on the menu.
   */
  actions: refType$1,
  /**
   * The element based on which the menu is positioned.
   */
  anchor: PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]),
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Function called when the items displayed in the menu change.
   */
  onItemsChange: PropTypes.func,
  /**
   * The props used for each slot inside the Menu.
   * @default {}
   */
  slotProps: PropTypes.shape({
    listbox: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Menu.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    listbox: PropTypes.elementType,
    root: PropTypes.elementType
  })
} : void 0;
function useButton(parameters = {}) {
  const {
    disabled = false,
    focusableWhenDisabled,
    href,
    rootRef: externalRef,
    tabIndex,
    to,
    type,
    rootElementName: rootElementNameProp
  } = parameters;
  const buttonRef = React.useRef();
  const [active, setActive] = React.useState(false);
  const {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible();
  const [focusVisible, setFocusVisible] = React.useState(false);
  if (disabled && !focusableWhenDisabled && focusVisible) {
    setFocusVisible(false);
  }
  React.useEffect(() => {
    isFocusVisibleRef.current = focusVisible;
  }, [focusVisible, isFocusVisibleRef]);
  const [rootElementName, updateRootElementName] = useRootElementName({
    rootElementName: rootElementNameProp != null ? rootElementNameProp : href || to ? "a" : void 0,
    componentName: "Button"
  });
  const createHandleMouseLeave = (otherHandlers) => (event) => {
    var _otherHandlers$onMous;
    if (focusVisible) {
      event.preventDefault();
    }
    (_otherHandlers$onMous = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous.call(otherHandlers, event);
  };
  const createHandleBlur = (otherHandlers) => (event) => {
    var _otherHandlers$onBlur;
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }
    (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
  };
  const createHandleFocus = (otherHandlers) => (event) => {
    var _otherHandlers$onFocu2;
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      var _otherHandlers$onFocu;
      setFocusVisible(true);
      (_otherHandlers$onFocu = otherHandlers.onFocusVisible) == null || _otherHandlers$onFocu.call(otherHandlers, event);
    }
    (_otherHandlers$onFocu2 = otherHandlers.onFocus) == null || _otherHandlers$onFocu2.call(otherHandlers, event);
  };
  const isNativeButton = () => {
    const button = buttonRef.current;
    return rootElementName === "BUTTON" || rootElementName === "INPUT" && ["button", "submit", "reset"].includes(button == null ? void 0 : button.type) || rootElementName === "A" && (button == null ? void 0 : button.href);
  };
  const createHandleClick = (otherHandlers) => (event) => {
    if (!disabled) {
      var _otherHandlers$onClic;
      (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
    }
  };
  const createHandleMouseDown = (otherHandlers) => (event) => {
    var _otherHandlers$onMous2;
    if (!disabled) {
      setActive(true);
      document.addEventListener("mouseup", () => {
        setActive(false);
      }, {
        once: true
      });
    }
    (_otherHandlers$onMous2 = otherHandlers.onMouseDown) == null || _otherHandlers$onMous2.call(otherHandlers, event);
  };
  const createHandleKeyDown = (otherHandlers) => (event) => {
    var _otherHandlers$onKeyD;
    (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
    if (event.defaultMuiPrevented) {
      return;
    }
    if (event.target === event.currentTarget && !isNativeButton() && event.key === " ") {
      event.preventDefault();
    }
    if (event.target === event.currentTarget && event.key === " " && !disabled) {
      setActive(true);
    }
    if (event.target === event.currentTarget && !isNativeButton() && event.key === "Enter" && !disabled) {
      var _otherHandlers$onClic2;
      (_otherHandlers$onClic2 = otherHandlers.onClick) == null || _otherHandlers$onClic2.call(otherHandlers, event);
      event.preventDefault();
    }
  };
  const createHandleKeyUp = (otherHandlers) => (event) => {
    var _otherHandlers$onKeyU;
    if (event.target === event.currentTarget) {
      setActive(false);
    }
    (_otherHandlers$onKeyU = otherHandlers.onKeyUp) == null || _otherHandlers$onKeyU.call(otherHandlers, event);
    if (event.target === event.currentTarget && !isNativeButton() && !disabled && event.key === " " && !event.defaultMuiPrevented) {
      var _otherHandlers$onClic3;
      (_otherHandlers$onClic3 = otherHandlers.onClick) == null || _otherHandlers$onClic3.call(otherHandlers, event);
    }
  };
  const handleRef = useForkRef(updateRootElementName, externalRef, focusVisibleRef, buttonRef);
  const buttonProps = {};
  if (tabIndex !== void 0) {
    buttonProps.tabIndex = tabIndex;
  }
  if (rootElementName === "BUTTON") {
    buttonProps.type = type != null ? type : "button";
    if (focusableWhenDisabled) {
      buttonProps["aria-disabled"] = disabled;
    } else {
      buttonProps.disabled = disabled;
    }
  } else if (rootElementName === "INPUT") {
    if (type && ["button", "submit", "reset"].includes(type)) {
      if (focusableWhenDisabled) {
        buttonProps["aria-disabled"] = disabled;
      } else {
        buttonProps.disabled = disabled;
      }
    }
  } else if (rootElementName !== "") {
    if (!href && !to) {
      buttonProps.role = "button";
      buttonProps.tabIndex = tabIndex != null ? tabIndex : 0;
    }
    if (disabled) {
      buttonProps["aria-disabled"] = disabled;
      buttonProps.tabIndex = focusableWhenDisabled ? tabIndex != null ? tabIndex : 0 : -1;
    }
  }
  const getRootProps = (externalProps = {}) => {
    const externalEventHandlers = _extends$2({}, extractEventHandlers(parameters), extractEventHandlers(externalProps));
    const props = _extends$2({
      type
    }, externalEventHandlers, buttonProps, externalProps, {
      onBlur: createHandleBlur(externalEventHandlers),
      onClick: createHandleClick(externalEventHandlers),
      onFocus: createHandleFocus(externalEventHandlers),
      onKeyDown: createHandleKeyDown(externalEventHandlers),
      onKeyUp: createHandleKeyUp(externalEventHandlers),
      onMouseDown: createHandleMouseDown(externalEventHandlers),
      onMouseLeave: createHandleMouseLeave(externalEventHandlers),
      ref: handleRef
    });
    delete props.onFocusVisible;
    return props;
  };
  return {
    getRootProps,
    focusVisible,
    setFocusVisible,
    active,
    rootRef: handleRef
  };
}
function useMenuButton(parameters = {}) {
  const {
    disabled = false,
    focusableWhenDisabled,
    rootRef: externalRef
  } = parameters;
  const menuContext = React.useContext(DropdownContext);
  if (menuContext === null) {
    throw new Error("useMenuButton: no menu context available.");
  }
  const {
    state,
    dispatch,
    registerTrigger,
    popupId
  } = menuContext;
  const {
    getRootProps: getButtonRootProps,
    rootRef: buttonRootRef,
    active
  } = useButton({
    disabled,
    focusableWhenDisabled,
    rootRef: externalRef
  });
  const handleRef = useForkRef(buttonRootRef, registerTrigger);
  const createHandleClick = (otherHandlers) => (event) => {
    var _otherHandlers$onClic;
    (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
    if (event.defaultMuiPrevented) {
      return;
    }
    dispatch({
      type: DropdownActionTypes.toggle,
      event
    });
  };
  const createHandleKeyDown = (otherHandlers) => (event) => {
    var _otherHandlers$onKeyD;
    (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
    if (event.defaultMuiPrevented) {
      return;
    }
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      dispatch({
        type: DropdownActionTypes.open,
        event
      });
    }
  };
  const getOwnRootProps = (otherHandlers = {}) => ({
    onClick: createHandleClick(otherHandlers),
    onKeyDown: createHandleKeyDown(otherHandlers)
  });
  const getRootProps = (externalProps = {}) => {
    const externalEventHandlers = extractEventHandlers(externalProps);
    const getCombinedProps = combineHooksSlotProps(getOwnRootProps, getButtonRootProps);
    return _extends$2({
      "aria-haspopup": "menu",
      "aria-expanded": state.open,
      "aria-controls": popupId
    }, externalProps, externalEventHandlers, getCombinedProps(externalEventHandlers), {
      tabIndex: 0,
      // this is needed to make the button focused after click in Safari
      ref: handleRef
    });
  };
  return {
    active,
    getRootProps,
    open: state.open,
    rootRef: handleRef
  };
}
const COMPONENT_NAME$1 = "MenuButton";
function getMenuButtonUtilityClass(slot) {
  return generateUtilityClass(COMPONENT_NAME$1, slot);
}
generateUtilityClasses(COMPONENT_NAME$1, ["root", "active", "disabled", "expanded"]);
const _excluded$1 = ["children", "disabled", "label", "slots", "slotProps", "focusableWhenDisabled"];
const useUtilityClasses$1 = (ownerState) => {
  const {
    active,
    disabled,
    open
  } = ownerState;
  const slots = {
    root: ["root", disabled && "disabled", active && "active", open && "expanded"]
  };
  return composeClasses(slots, useClassNamesOverride(getMenuButtonUtilityClass));
};
const MenuButton$2 = /* @__PURE__ */ React.forwardRef(function MenuButton(props, forwardedRef) {
  const {
    children,
    disabled = false,
    slots = {},
    slotProps = {},
    focusableWhenDisabled = false
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$1);
  const {
    getRootProps,
    open,
    active
  } = useMenuButton({
    disabled,
    focusableWhenDisabled,
    rootRef: forwardedRef
  });
  const ownerState = _extends$2({}, props, {
    open,
    active,
    disabled,
    focusableWhenDisabled
  });
  const classes = useUtilityClasses$1(ownerState);
  const Root = slots.root || "button";
  const rootProps = useSlotProps({
    elementType: Root,
    getSlotProps: getRootProps,
    externalForwardedProps: other,
    externalSlotProps: slotProps.root,
    additionalProps: {
      ref: forwardedRef,
      type: "button"
    },
    ownerState,
    className: classes.root
  });
  return /* @__PURE__ */ jsx(Root, _extends$2({}, rootProps, {
    children
  }));
});
process.env.NODE_ENV !== "production" ? MenuButton$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Class name applied to the root element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, allows a disabled button to receive focus.
   * @default false
   */
  focusableWhenDisabled: PropTypes.bool,
  /**
   * Label of the button
   */
  label: PropTypes.string,
  /**
   * The components used for each slot inside the MenuButton.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The props used for each slot inside the MenuButton.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  })
} : void 0;
const COMPONENT_NAME = "MenuItem";
function getMenuItemUtilityClass(slot) {
  return generateUtilityClass(COMPONENT_NAME, slot);
}
const menuItemClasses = generateUtilityClasses(COMPONENT_NAME, ["root", "disabled", "focusVisible"]);
function idGenerator(existingKeys) {
  return `menu-item-${existingKeys.size}`;
}
const FALLBACK_MENU_CONTEXT = {
  dispatch: () => {
  },
  popupId: "",
  registerPopup: () => {
  },
  registerTrigger: () => {
  },
  state: {
    open: true,
    changeReason: null
  },
  triggerElement: null
};
function useMenuItem(params) {
  var _React$useContext;
  const {
    disabled = false,
    id: idParam,
    rootRef: externalRef,
    label,
    disableFocusOnHover = false
  } = params;
  const id2 = useId(idParam);
  const itemRef = React.useRef(null);
  const itemMetadata = React.useMemo(() => ({
    disabled,
    id: id2 != null ? id2 : "",
    label,
    ref: itemRef
  }), [disabled, id2, label]);
  const {
    dispatch
  } = (_React$useContext = React.useContext(DropdownContext)) != null ? _React$useContext : FALLBACK_MENU_CONTEXT;
  const {
    getRootProps: getListRootProps,
    highlighted
  } = useListItem({
    item: id2,
    handlePointerOverEvents: !disableFocusOnHover
  });
  const {
    index: index2,
    totalItemCount
  } = useCompoundItem(id2 != null ? id2 : idGenerator, itemMetadata);
  const {
    getRootProps: getButtonProps,
    focusVisible,
    rootRef: buttonRefHandler
  } = useButton({
    disabled,
    focusableWhenDisabled: true
  });
  const handleRef = useForkRef(buttonRefHandler, externalRef, itemRef);
  React.useDebugValue({
    id: id2,
    highlighted,
    disabled,
    label
  });
  const createHandleClick = (otherHandlers) => (event) => {
    var _otherHandlers$onClic;
    (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
    if (event.defaultMuiPrevented) {
      return;
    }
    dispatch({
      type: DropdownActionTypes.close,
      event
    });
  };
  const getOwnHandlers = (otherHandlers = {}) => _extends$2({}, otherHandlers, {
    onClick: createHandleClick(otherHandlers)
  });
  function getRootProps(externalProps = {}) {
    const externalEventHandlers = extractEventHandlers(externalProps);
    const getCombinedRootProps = combineHooksSlotProps(getOwnHandlers, combineHooksSlotProps(getButtonProps, getListRootProps));
    return _extends$2({}, externalProps, externalEventHandlers, getCombinedRootProps(externalEventHandlers), {
      id: id2,
      ref: handleRef,
      role: "menuitem"
    });
  }
  if (id2 === void 0) {
    return {
      getRootProps,
      disabled: false,
      focusVisible,
      highlighted: false,
      index: -1,
      totalItemCount: 0,
      rootRef: handleRef
    };
  }
  return {
    getRootProps,
    disabled,
    focusVisible,
    highlighted,
    index: index2,
    totalItemCount,
    rootRef: handleRef
  };
}
function useMenuItemContextStabilizer(id2) {
  const listContext = React.useContext(ListContext);
  if (!listContext) {
    throw new Error("MenuItem: ListContext was not found.");
  }
  const itemId = useId(id2);
  const {
    getItemState,
    dispatch
  } = listContext;
  let itemState;
  if (itemId != null) {
    itemState = getItemState(itemId);
  } else {
    itemState = {
      focusable: true,
      highlighted: false,
      selected: false
    };
  }
  const {
    highlighted,
    selected,
    focusable
  } = itemState;
  const localGetItemState = React.useCallback((itemValue) => {
    if (itemValue !== itemId) {
      throw new Error(["Base UI MenuItem: Tried to access the state of another MenuItem.", `itemValue: ${itemValue} | id: ${itemId}`, "This is unsupported when the MenuItem uses the MenuItemContextStabilizer as a performance optimization."].join("/n"));
    }
    return {
      highlighted,
      selected,
      focusable
    };
  }, [highlighted, selected, focusable, itemId]);
  const localContextValue = React.useMemo(() => ({
    dispatch,
    getItemState: localGetItemState
  }), [dispatch, localGetItemState]);
  return {
    contextValue: localContextValue,
    id: itemId
  };
}
const _excluded = ["children", "disabled", "label", "id", "slotProps", "slots"];
function useUtilityClasses(ownerState) {
  const {
    disabled,
    focusVisible
  } = ownerState;
  const slots = {
    root: ["root", disabled && "disabled", focusVisible && "focusVisible"]
  };
  return composeClasses(slots, useClassNamesOverride(getMenuItemUtilityClass));
}
const InnerMenuItem = /* @__PURE__ */ React.memo(/* @__PURE__ */ React.forwardRef(function MenuItem(props, forwardedRef) {
  var _slots$root;
  const {
    children,
    disabled: disabledProp = false,
    label,
    id: id2,
    slotProps = {},
    slots = {}
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    getRootProps,
    disabled,
    focusVisible,
    highlighted
  } = useMenuItem({
    id: id2,
    disabled: disabledProp,
    rootRef: forwardedRef,
    label
  });
  const ownerState = _extends$2({}, props, {
    disabled,
    focusVisible,
    highlighted
  });
  const classes = useUtilityClasses(ownerState);
  const Root = (_slots$root = slots.root) != null ? _slots$root : "li";
  const rootProps = useSlotProps({
    elementType: Root,
    getSlotProps: getRootProps,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    className: classes.root,
    ownerState
  });
  return /* @__PURE__ */ jsx(Root, _extends$2({}, rootProps, {
    children
  }));
}));
const MenuItem$2 = /* @__PURE__ */ React.forwardRef(function MenuItem2(props, ref) {
  const {
    id: idProp
  } = props;
  const {
    contextValue,
    id: id2
  } = useMenuItemContextStabilizer(idProp);
  return /* @__PURE__ */ jsx(ListContext.Provider, {
    value: contextValue,
    children: /* @__PURE__ */ jsx(InnerMenuItem, _extends$2({}, props, {
      id: id2,
      ref
    }))
  });
});
process.env.NODE_ENV !== "production" ? MenuItem$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the menu item will be disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the menu item won't receive focus when the mouse moves over it.
   *
   * @default false
   */
  disableFocusOnHover: PropTypes.bool,
  /**
   * A text representation of the menu item's content.
   * Used for keyboard text navigation matching.
   */
  label: PropTypes.string,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * The props used for each slot inside the MenuItem.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the MenuItem.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  })
} : void 0;
const LanguageSelector = ({
  locale = "en"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const createHandleMenuClick = (locale2) => {
    const url = new URL(window.location.href);
    if (locale2 === "TR") {
      url.searchParams.append("locale", "tr");
    } else {
      url.searchParams.delete("locale");
    }
    return () => {
      window.location.href = url.href;
    };
  };
  const unSelectedLocale = locale === "en" ? "TR" : "EN";
  return /* @__PURE__ */ jsxs(Dropdown, { onOpenChange: () => setIsOpen(!isOpen), children: [
    /* @__PURE__ */ jsxs(MenuButton$1, { children: [
      /* @__PURE__ */ jsx(World, {}),
      locale,
      /* @__PURE__ */ jsx(Chevron, { style: {
        transition: "all 0.3s ease-out",
        transform: isOpen ? "rotate(180deg)" : ""
      } })
    ] }),
    /* @__PURE__ */ jsx(Menu, { slots: {
      listbox: Listbox$1
    }, children: /* @__PURE__ */ jsx(MenuItem$1, { onClick: createHandleMenuClick(unSelectedLocale), children: unSelectedLocale }) })
  ] });
};
const Listbox$1 = styled$1("ul")(() => `
  font-size: 12px;
  box-sizing: border-box;
  padding: 6px;
  margin: 6px 0;
  border-radius: 12px;
  overflow: auto;
  outline: 0px;
  color: black;
  z-index: 1;
  `);
const MenuItem$1 = styled$1(MenuItem$2)(() => `
    min-width: 50px;
    text-align:center;
  list-style: none;
  cursor:pointer;
  padding: 4px 6px;
  border-radius: 4px;
  user-select: none;

  &:last-of-type {
    border-bottom: none;
  }

  &:focus {
    outline: 3px solid #D7D7D7;
    background-color: #D7D7D7;
    color: black;
  }

  &.${menuItemClasses.disabled} {
    color: black;
  }
  `);
const MenuButton$1 = styled$1(MenuButton$2)(() => `
  box-shadow: unset;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.5;
  padding: 4px 6px;
  border-radius: 4px;
  transition: all 150ms ease;
  cursor: pointer;
  background: transparent;
  border: 1px solid transparent;
  color: black;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    background: #D7D7D7;
    border-color: #D7D7D7;
    color: black;
  }

  &:active {
    background: #D7D7D7;
    border-color: #D7D7D7;
    color: black;
  }

  &:focus-visible {
    background: #D7D7D7;
    border-color: #D7D7D7;
    color: black;
  }
  `);
const Login = ({
  csrfToken,
  formAction,
  castleData
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [emailFormatInvalid, setEmailFormatInvalid] = useState(false);
  const [passwordInvalid, setPasswordInvalid] = useState(false);
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [email, setEmail] = useState("");
  const [errors2, setErrors] = useState();
  const {
    i18n: i18n2
  } = useLingui();
  useEffect(() => {
    if (castleData == null ? void 0 : castleData.castlePublishKey) {
      castleExports.configure({
        pk: castleData.castlePublishKey
      });
    }
  }, []);
  const handleSubmit = (e2) => __async(void 0, null, function* () {
    e2.preventDefault();
    if (!isLoading && isValid2) {
      setEmailFormatInvalid(false);
      setPasswordInvalid(false);
      const requestToken = castleData ? yield castleExports.createRequestToken() : null;
      const data = {
        user: __spreadValues({
          email,
          remember_me: remember ? 1 : 0,
          password
        }, requestToken ? {
          castle_request_token: requestToken
        } : {}),
        authenticity_token: csrfToken
      };
      try {
        setIsLoading(true);
        const response = yield fetch(formAction, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken
          },
          body: JSON.stringify(data)
        });
        if (response.ok) {
          const data2 = yield response.json();
          window.location.href = data2.redirect;
        } else {
          if (response.status === 422) {
            const e22 = yield response.json();
            setErrors(e22);
            setIsLoading(false);
          }
        }
      } catch (e3) {
        setErrors({
          "system": ["There was an error"]
        });
        setIsLoading(false);
      }
    }
  });
  const isPasswordError = !isLoading && !!(errors2 == null ? void 0 : errors2.password);
  const isEmailError = !isLoading && !!(errors2 == null ? void 0 : errors2.email);
  const restErrors = errors2 ? Object.keys(errors2).filter((errorKey) => {
    if (errorKey !== "email" && errorKey !== "password") {
      return true;
    }
    return false;
  }).map((error) => {
    return errors2[error];
  }) : [];
  const isValid2 = validateEmail(email) && validatePassword(password);
  return /* @__PURE__ */ jsxs("div", { className: "gap-8 flex flex-col", children: [
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Title, { children: /* @__PURE__ */ jsx(Trans, { id: "6UbQ3u" }) }) }),
    restErrors.length > 0 && /* @__PURE__ */ jsx("div", { children: restErrors.map((e2) => {
      return /* @__PURE__ */ jsx(FormError, { children: e2 });
    }) }),
    /* @__PURE__ */ jsxs("form", { onSubmit: handleSubmit, acceptCharset: "UTF-8", className: "flex flex-col gap-8", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "authenticity_token", value: csrfToken }),
        /* @__PURE__ */ jsxs(Fieldset, { children: [
          /* @__PURE__ */ jsx(FormLabel, { htmlFor: "loginEmail", isError: isEmailError || emailFormatInvalid, children: /* @__PURE__ */ jsx(Trans, { id: "O3oNi5" }) }),
          /* @__PURE__ */ jsx(Input, { autoFocus: true, id: "loginEmail", value: email, onBlur: (e2) => {
            setEmailFormatInvalid(!validateEmail(e2.currentTarget.value));
          }, onChange: (e2) => {
            if (errors2 == null ? void 0 : errors2.email) {
              const _a = errors2, {
                email: email2
              } = _a, noEmail = __objRest(_a, [
                // eslint-disable-next-line no-unused-vars
                "email"
              ]);
              setErrors(__spreadValues({}, noEmail));
            }
            setEmail(e2.currentTarget.value);
          }, isError: !!(errors2 == null ? void 0 : errors2.email) || emailFormatInvalid, name: "user[email]", placeholder: i18n2._(
            /*i18n*/
            {
              id: "C3nD/1"
            }
          ) }),
          emailFormatInvalid && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "io0enF" }) }),
          isEmailError && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "2V8vJF", components: {
            0: /* @__PURE__ */ jsx("a", { className: "text-black underline text-sm", href: "/register" })
          } }) })
        ] }),
        /* @__PURE__ */ jsxs(Fieldset, { children: [
          /* @__PURE__ */ jsx(FormLabel, { htmlFor: "password", isError: isPasswordError, children: /* @__PURE__ */ jsx(Trans, { id: "8ZsakT" }) }),
          /* @__PURE__ */ jsx(PasswordInput, { id: "password", onBlur: (e2) => {
            setPasswordInvalid(!validatePassword(e2.currentTarget.value));
          }, value: password, onChange: (e2) => {
            if (errors2 == null ? void 0 : errors2.password) {
              const _a = errors2, {
                password: password2
              } = _a, noPwd = __objRest(_a, [
                // eslint-disable-next-line no-unused-vars
                "password"
              ]);
              setErrors(__spreadValues({}, noPwd));
            }
            setPassword(e2.currentTarget.value);
          }, isError: isPasswordError, name: "user[password]", placeholder: i18n2._(
            /*i18n*/
            {
              id: "NgaR6B"
            }
          ) }),
          passwordInvalid && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "TaFX2+" }) }),
          isPasswordError ? /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "G9V/if", components: {
            0: /* @__PURE__ */ jsx("a", { className: "text-black underline text-sm", href: "/users/password/new" })
          } }) }) : /* @__PURE__ */ jsx("a", { className: "text-quickSilver hover:underline text-sm", href: "/users/password/new", children: "Forgot your password?" })
        ] }),
        /* @__PURE__ */ jsx(Fieldset, { children: /* @__PURE__ */ jsx(Checkbox, { onChange: (e2) => {
          setRemember(e2.currentTarget.checked);
        }, checked: remember, id: "remember", label: /* @__PURE__ */ jsx(Trans, { id: "zjEFCa" }) }) })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "flex gap-4", children: /* @__PURE__ */ jsx(Button, { name: "login-submit", isLoading, isDark: true, type: "submit", disabled: !isValid2, children: /* @__PURE__ */ jsx(Trans, { id: "sQia9P" }) }) })
    ] })
  ] });
};
const loginSchema = z.object({
  csrfToken: z.string(),
  formAction: z.string(),
  castleData: z.nullable(z.object({
    castlePublishKey: z.string()
  })).optional()
});
const LoginParent = (props) => {
  const _a = props, {
    locale = "en"
  } = _a, rest = __objRest(_a, [
    "locale"
  ]);
  useComponentValidation({
    props,
    schema: loginSchema
  });
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsx(Login, __spreadValues({}, rest)) });
};
const LoginMfa = ({
  csrfToken,
  formAction,
  castleData,
  lost2FaLink,
  showSecurityKeyLink
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errors2, setErrors] = useState("");
  const {
    i18n: i18n2
  } = useLingui();
  const isValid2 = code.length > 5;
  useEffect(() => {
    if (castleData == null ? void 0 : castleData.castlePublishKey) {
      castleExports.configure({
        pk: castleData.castlePublishKey
      });
    }
  }, []);
  const onSuccess = (redirectUrl2) => {
    window.location.href = redirectUrl2;
  };
  const handleSubmit = (e2) => __async(void 0, null, function* () {
    e2.preventDefault();
    if (!isLoading && isValid2) {
      const requestToken = castleData ? yield castleExports.createRequestToken() : null;
      const data = {
        multi_factor_authentication_totp: __spreadValues({
          otp_attempt: code
        }, requestToken ? {
          castle_request_token: requestToken
        } : {}),
        authenticity_token: csrfToken
      };
      try {
        setIsLoading(true);
        const response = yield fetch(formAction, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken
          },
          body: JSON.stringify(data)
        });
        if (response.ok) {
          const data2 = yield response.json();
          if (data2.message) {
            setMessage(data2.message);
            setRedirectUrl(data2.redirect);
          } else {
            onSuccess(data2.redirect);
          }
        } else {
          if (response.status === 422) {
            setErrors("There was an error");
            setIsLoading(false);
          }
        }
      } catch (e3) {
        setErrors("There was an error");
        setIsLoading(false);
      }
    }
  });
  const onCancel = () => {
    window.location.href = "/";
  };
  const isError = errors2 !== "";
  return /* @__PURE__ */ jsxs("div", { className: "gap-8 flex flex-col", children: [
    /* @__PURE__ */ jsx(Snackbar2, { isOpen: !!message, onClose: () => {
      setMessage("");
      onSuccess(redirectUrl);
    }, content: message }),
    /* @__PURE__ */ jsxs(Container, { children: [
      /* @__PURE__ */ jsx(Title, { children: /* @__PURE__ */ jsx(Trans, { id: "f/GGcY" }) }),
      /* @__PURE__ */ jsx(Subitle, { children: /* @__PURE__ */ jsx(Trans, { id: "oIFqPS" }) })
    ] }),
    /* @__PURE__ */ jsxs("form", { onSubmit: handleSubmit, acceptCharset: "UTF-8", className: "flex flex-col gap-8", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "authenticity_token", value: csrfToken }),
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "_method", value: "patch" }),
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "from_verify_email_page", id: "from_verify_email_page" }),
        /* @__PURE__ */ jsxs(Fieldset, { children: [
          /* @__PURE__ */ jsx(FormLabel, { htmlFor: "mfaCode", isError, children: /* @__PURE__ */ jsx(Trans, { id: "EWPtMO" }) }),
          /* @__PURE__ */ jsx(Input, { autoFocus: true, id: "mfaCode", value: code, onChange: (e2) => {
            setErrors("");
            setCode(e2.currentTarget.value);
          }, isError, name: "multi_factor_authentication_totp[otp_attempt]", placeholder: i18n2._(
            /*i18n*/
            {
              id: "lPgKS3"
            }
          ) }),
          !isError && (lost2FaLink ? /* @__PURE__ */ jsx(FormFieldDescription, { children: /* @__PURE__ */ jsx("a", { href: lost2FaLink, children: /* @__PURE__ */ jsx(Trans, { id: "VJIXn+" }) }) }) : /* @__PURE__ */ jsx(FormFieldDescription, { children: /* @__PURE__ */ jsx("a", { href: "https://coinlist.co/help/lost-access-to-my-2fa-device", children: /* @__PURE__ */ jsx(Trans, { id: "VJIXn+" }) }) })),
          isError && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "havey5", components: {
            0: /* @__PURE__ */ jsx("a", { className: "text-black underline", href: lost2FaLink || "https://coinlist.co/help/lost-access-to-my-2fa-device" })
          } }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex gap-4", children: [
        /* @__PURE__ */ jsx(Button, { type: "button", hasBorder: true, onClick: onCancel, children: /* @__PURE__ */ jsx(Trans, { id: "dEgA5A" }) }),
        /* @__PURE__ */ jsx(Button, { isLoading, isDark: true, type: "submit", disabled: !isValid2, children: /* @__PURE__ */ jsx(Trans, { id: "uSMfoN" }) })
      ] })
    ] }),
    showSecurityKeyLink && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("a", { className: "text-black underline js-show_security_key", href: "javascript:void(0)", children: /* @__PURE__ */ jsx(Trans, { id: "AULyh4" }) }) })
  ] });
};
const mfaLoginSchema = z.object({
  csrfToken: z.string(),
  formAction: z.string(),
  castleData: z.nullable(z.object({
    castlePublishKey: z.string()
  })).optional(),
  lost2FaLink: z.string().optional(),
  showSecurityKeyLink: z.boolean().optional()
});
const MfaParent = (props) => {
  const _a = props, {
    locale = "en"
  } = _a, rest = __objRest(_a, [
    "locale"
  ]);
  useComponentValidation({
    props,
    schema: mfaLoginSchema
  });
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsx(LoginMfa, __spreadValues({}, rest)) });
};
const Step1 = ({
  onContinue
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "gap-8 flex flex-col max-w-[472px] m-auto", children: [
    /* @__PURE__ */ jsxs(Container, { children: [
      /* @__PURE__ */ jsx(Title, { children: /* @__PURE__ */ jsx(Trans, { id: "T65b7l" }) }),
      /* @__PURE__ */ jsx(Subitle, { children: /* @__PURE__ */ jsx(Trans, { id: "i99UAx" }) })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex gap-4 justify-between flex-col sm:flex-row", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center sm:flex-col gap-4", children: [
        /* @__PURE__ */ jsx("img", { className: "w-[40px] sm:w-[90px]", src: "https://cdn.coinlist.co/onboarding_assets/google_authenticator_logo.png" }),
        /* @__PURE__ */ jsxs("p", { className: "text-lg text-center", children: [
          "Google ",
          /* @__PURE__ */ jsx("br", { className: "hidden sm:block" }),
          " Authenticator"
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center sm:flex-col gap-4", children: [
        /* @__PURE__ */ jsx("img", { className: "w-[40px] sm:w-[90px] rounded-full", src: "https://cdn.coinlist.co/onboarding_assets/duo_mobile_logo.png" }),
        /* @__PURE__ */ jsx("p", { className: "text-lg", children: "Duo Mobile" })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center sm:flex-col gap-4", children: [
        /* @__PURE__ */ jsx("img", { className: "w-[40px] sm:w-[90px]", src: "https://cdn.coinlist.co/onboarding_assets/authy_logo.png" }),
        /* @__PURE__ */ jsx("p", { className: "text-lg", children: "Authy" })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Button, { isDark: true, onClick: onContinue, children: /* @__PURE__ */ jsx(Trans, { id: "xGVfLh" }) }),
    /* @__PURE__ */ jsx("em", { className: "bg-gray-300 h-px w-5/6 m-auto" }),
    /* @__PURE__ */ jsxs("div", { className: "rounded-2xl p-4 bg-offWhite flex gap-4 items-center flex-row", children: [
      /* @__PURE__ */ jsx(Shield, { className: "min-w-8" }),
      /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("p", { className: "font-normal text-sm", children: [
        /* @__PURE__ */ jsx(Trans, { id: "sCHNLH" }),
        " ",
        /* @__PURE__ */ jsx("a", { href: i18n._(
          /*i18n*/
          {
            id: "puIMZD"
          }
        ), target: "_blank", className: "underline", children: /* @__PURE__ */ jsx(Trans, { id: "N0AaQl" }) })
      ] }) })
    ] })
  ] });
};
var lib = {};
var ErrorCorrectLevel = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
};
var mode$1 = {
  MODE_NUMBER: 1 << 0,
  MODE_ALPHA_NUM: 1 << 1,
  MODE_8BIT_BYTE: 1 << 2,
  MODE_KANJI: 1 << 3
};
var mode = mode$1;
function QR8bitByte(data) {
  this.mode = mode.MODE_8BIT_BYTE;
  this.data = data;
}
QR8bitByte.prototype = {
  getLength: function(buffer) {
    return this.data.length;
  },
  write: function(buffer) {
    for (var i = 0; i < this.data.length; i++) {
      buffer.put(this.data.charCodeAt(i), 8);
    }
  }
};
var _8BitByte = QR8bitByte;
var ECL = ErrorCorrectLevel;
function QRRSBlock(totalCount, dataCount) {
  this.totalCount = totalCount;
  this.dataCount = dataCount;
}
QRRSBlock.RS_BLOCK_TABLE = [
  // L
  // M
  // Q
  // H
  // 1
  [1, 26, 19],
  [1, 26, 16],
  [1, 26, 13],
  [1, 26, 9],
  // 2
  [1, 44, 34],
  [1, 44, 28],
  [1, 44, 22],
  [1, 44, 16],
  // 3
  [1, 70, 55],
  [1, 70, 44],
  [2, 35, 17],
  [2, 35, 13],
  // 4		
  [1, 100, 80],
  [2, 50, 32],
  [2, 50, 24],
  [4, 25, 9],
  // 5
  [1, 134, 108],
  [2, 67, 43],
  [2, 33, 15, 2, 34, 16],
  [2, 33, 11, 2, 34, 12],
  // 6
  [2, 86, 68],
  [4, 43, 27],
  [4, 43, 19],
  [4, 43, 15],
  // 7		
  [2, 98, 78],
  [4, 49, 31],
  [2, 32, 14, 4, 33, 15],
  [4, 39, 13, 1, 40, 14],
  // 8
  [2, 121, 97],
  [2, 60, 38, 2, 61, 39],
  [4, 40, 18, 2, 41, 19],
  [4, 40, 14, 2, 41, 15],
  // 9
  [2, 146, 116],
  [3, 58, 36, 2, 59, 37],
  [4, 36, 16, 4, 37, 17],
  [4, 36, 12, 4, 37, 13],
  // 10		
  [2, 86, 68, 2, 87, 69],
  [4, 69, 43, 1, 70, 44],
  [6, 43, 19, 2, 44, 20],
  [6, 43, 15, 2, 44, 16],
  // 11
  [4, 101, 81],
  [1, 80, 50, 4, 81, 51],
  [4, 50, 22, 4, 51, 23],
  [3, 36, 12, 8, 37, 13],
  // 12
  [2, 116, 92, 2, 117, 93],
  [6, 58, 36, 2, 59, 37],
  [4, 46, 20, 6, 47, 21],
  [7, 42, 14, 4, 43, 15],
  // 13
  [4, 133, 107],
  [8, 59, 37, 1, 60, 38],
  [8, 44, 20, 4, 45, 21],
  [12, 33, 11, 4, 34, 12],
  // 14
  [3, 145, 115, 1, 146, 116],
  [4, 64, 40, 5, 65, 41],
  [11, 36, 16, 5, 37, 17],
  [11, 36, 12, 5, 37, 13],
  // 15
  [5, 109, 87, 1, 110, 88],
  [5, 65, 41, 5, 66, 42],
  [5, 54, 24, 7, 55, 25],
  [11, 36, 12],
  // 16
  [5, 122, 98, 1, 123, 99],
  [7, 73, 45, 3, 74, 46],
  [15, 43, 19, 2, 44, 20],
  [3, 45, 15, 13, 46, 16],
  // 17
  [1, 135, 107, 5, 136, 108],
  [10, 74, 46, 1, 75, 47],
  [1, 50, 22, 15, 51, 23],
  [2, 42, 14, 17, 43, 15],
  // 18
  [5, 150, 120, 1, 151, 121],
  [9, 69, 43, 4, 70, 44],
  [17, 50, 22, 1, 51, 23],
  [2, 42, 14, 19, 43, 15],
  // 19
  [3, 141, 113, 4, 142, 114],
  [3, 70, 44, 11, 71, 45],
  [17, 47, 21, 4, 48, 22],
  [9, 39, 13, 16, 40, 14],
  // 20
  [3, 135, 107, 5, 136, 108],
  [3, 67, 41, 13, 68, 42],
  [15, 54, 24, 5, 55, 25],
  [15, 43, 15, 10, 44, 16],
  // 21
  [4, 144, 116, 4, 145, 117],
  [17, 68, 42],
  [17, 50, 22, 6, 51, 23],
  [19, 46, 16, 6, 47, 17],
  // 22
  [2, 139, 111, 7, 140, 112],
  [17, 74, 46],
  [7, 54, 24, 16, 55, 25],
  [34, 37, 13],
  // 23
  [4, 151, 121, 5, 152, 122],
  [4, 75, 47, 14, 76, 48],
  [11, 54, 24, 14, 55, 25],
  [16, 45, 15, 14, 46, 16],
  // 24
  [6, 147, 117, 4, 148, 118],
  [6, 73, 45, 14, 74, 46],
  [11, 54, 24, 16, 55, 25],
  [30, 46, 16, 2, 47, 17],
  // 25
  [8, 132, 106, 4, 133, 107],
  [8, 75, 47, 13, 76, 48],
  [7, 54, 24, 22, 55, 25],
  [22, 45, 15, 13, 46, 16],
  // 26
  [10, 142, 114, 2, 143, 115],
  [19, 74, 46, 4, 75, 47],
  [28, 50, 22, 6, 51, 23],
  [33, 46, 16, 4, 47, 17],
  // 27
  [8, 152, 122, 4, 153, 123],
  [22, 73, 45, 3, 74, 46],
  [8, 53, 23, 26, 54, 24],
  [12, 45, 15, 28, 46, 16],
  // 28
  [3, 147, 117, 10, 148, 118],
  [3, 73, 45, 23, 74, 46],
  [4, 54, 24, 31, 55, 25],
  [11, 45, 15, 31, 46, 16],
  // 29
  [7, 146, 116, 7, 147, 117],
  [21, 73, 45, 7, 74, 46],
  [1, 53, 23, 37, 54, 24],
  [19, 45, 15, 26, 46, 16],
  // 30
  [5, 145, 115, 10, 146, 116],
  [19, 75, 47, 10, 76, 48],
  [15, 54, 24, 25, 55, 25],
  [23, 45, 15, 25, 46, 16],
  // 31
  [13, 145, 115, 3, 146, 116],
  [2, 74, 46, 29, 75, 47],
  [42, 54, 24, 1, 55, 25],
  [23, 45, 15, 28, 46, 16],
  // 32
  [17, 145, 115],
  [10, 74, 46, 23, 75, 47],
  [10, 54, 24, 35, 55, 25],
  [19, 45, 15, 35, 46, 16],
  // 33
  [17, 145, 115, 1, 146, 116],
  [14, 74, 46, 21, 75, 47],
  [29, 54, 24, 19, 55, 25],
  [11, 45, 15, 46, 46, 16],
  // 34
  [13, 145, 115, 6, 146, 116],
  [14, 74, 46, 23, 75, 47],
  [44, 54, 24, 7, 55, 25],
  [59, 46, 16, 1, 47, 17],
  // 35
  [12, 151, 121, 7, 152, 122],
  [12, 75, 47, 26, 76, 48],
  [39, 54, 24, 14, 55, 25],
  [22, 45, 15, 41, 46, 16],
  // 36
  [6, 151, 121, 14, 152, 122],
  [6, 75, 47, 34, 76, 48],
  [46, 54, 24, 10, 55, 25],
  [2, 45, 15, 64, 46, 16],
  // 37
  [17, 152, 122, 4, 153, 123],
  [29, 74, 46, 14, 75, 47],
  [49, 54, 24, 10, 55, 25],
  [24, 45, 15, 46, 46, 16],
  // 38
  [4, 152, 122, 18, 153, 123],
  [13, 74, 46, 32, 75, 47],
  [48, 54, 24, 14, 55, 25],
  [42, 45, 15, 32, 46, 16],
  // 39
  [20, 147, 117, 4, 148, 118],
  [40, 75, 47, 7, 76, 48],
  [43, 54, 24, 22, 55, 25],
  [10, 45, 15, 67, 46, 16],
  // 40
  [19, 148, 118, 6, 149, 119],
  [18, 75, 47, 31, 76, 48],
  [34, 54, 24, 34, 55, 25],
  [20, 45, 15, 61, 46, 16]
];
QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
  var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
  if (rsBlock == void 0) {
    throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
  }
  var length2 = rsBlock.length / 3;
  var list = new Array();
  for (var i = 0; i < length2; i++) {
    var count = rsBlock[i * 3 + 0];
    var totalCount = rsBlock[i * 3 + 1];
    var dataCount = rsBlock[i * 3 + 2];
    for (var j = 0; j < count; j++) {
      list.push(new QRRSBlock(totalCount, dataCount));
    }
  }
  return list;
};
QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
  switch (errorCorrectLevel) {
    case ECL.L:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
    case ECL.M:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
    case ECL.Q:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
    case ECL.H:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
    default:
      return void 0;
  }
};
var RSBlock$1 = QRRSBlock;
function QRBitBuffer() {
  this.buffer = new Array();
  this.length = 0;
}
QRBitBuffer.prototype = {
  get: function(index2) {
    var bufIndex = Math.floor(index2 / 8);
    return (this.buffer[bufIndex] >>> 7 - index2 % 8 & 1) == 1;
  },
  put: function(num, length2) {
    for (var i = 0; i < length2; i++) {
      this.putBit((num >>> length2 - i - 1 & 1) == 1);
    }
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(bit) {
    var bufIndex = Math.floor(this.length / 8);
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0);
    }
    if (bit) {
      this.buffer[bufIndex] |= 128 >>> this.length % 8;
    }
    this.length++;
  }
};
var BitBuffer$1 = QRBitBuffer;
var QRMath = {
  glog: function(n2) {
    if (n2 < 1) {
      throw new Error("glog(" + n2 + ")");
    }
    return QRMath.LOG_TABLE[n2];
  },
  gexp: function(n2) {
    while (n2 < 0) {
      n2 += 255;
    }
    while (n2 >= 256) {
      n2 -= 255;
    }
    return QRMath.EXP_TABLE[n2];
  },
  EXP_TABLE: new Array(256),
  LOG_TABLE: new Array(256)
};
for (var i = 0; i < 8; i++) {
  QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
  QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
  QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
}
var math$2 = QRMath;
var math$1 = math$2;
function QRPolynomial(num, shift2) {
  if (num.length == void 0) {
    throw new Error(num.length + "/" + shift2);
  }
  var offset2 = 0;
  while (offset2 < num.length && num[offset2] == 0) {
    offset2++;
  }
  this.num = new Array(num.length - offset2 + shift2);
  for (var i = 0; i < num.length - offset2; i++) {
    this.num[i] = num[i + offset2];
  }
}
QRPolynomial.prototype = {
  get: function(index2) {
    return this.num[index2];
  },
  getLength: function() {
    return this.num.length;
  },
  multiply: function(e2) {
    var num = new Array(this.getLength() + e2.getLength() - 1);
    for (var i = 0; i < this.getLength(); i++) {
      for (var j = 0; j < e2.getLength(); j++) {
        num[i + j] ^= math$1.gexp(math$1.glog(this.get(i)) + math$1.glog(e2.get(j)));
      }
    }
    return new QRPolynomial(num, 0);
  },
  mod: function(e2) {
    if (this.getLength() - e2.getLength() < 0) {
      return this;
    }
    var ratio = math$1.glog(this.get(0)) - math$1.glog(e2.get(0));
    var num = new Array(this.getLength());
    for (var i = 0; i < this.getLength(); i++) {
      num[i] = this.get(i);
    }
    for (var i = 0; i < e2.getLength(); i++) {
      num[i] ^= math$1.gexp(math$1.glog(e2.get(i)) + ratio);
    }
    return new QRPolynomial(num, 0).mod(e2);
  }
};
var Polynomial$2 = QRPolynomial;
var Mode = mode$1;
var Polynomial$1 = Polynomial$2;
var math = math$2;
var QRMaskPattern = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
};
var QRUtil = {
  PATTERN_POSITION_TABLE: [
    [],
    [6, 18],
    [6, 22],
    [6, 26],
    [6, 30],
    [6, 34],
    [6, 22, 38],
    [6, 24, 42],
    [6, 26, 46],
    [6, 28, 50],
    [6, 30, 54],
    [6, 32, 58],
    [6, 34, 62],
    [6, 26, 46, 66],
    [6, 26, 48, 70],
    [6, 26, 50, 74],
    [6, 30, 54, 78],
    [6, 30, 56, 82],
    [6, 30, 58, 86],
    [6, 34, 62, 90],
    [6, 28, 50, 72, 94],
    [6, 26, 50, 74, 98],
    [6, 30, 54, 78, 102],
    [6, 28, 54, 80, 106],
    [6, 32, 58, 84, 110],
    [6, 30, 58, 86, 114],
    [6, 34, 62, 90, 118],
    [6, 26, 50, 74, 98, 122],
    [6, 30, 54, 78, 102, 126],
    [6, 26, 52, 78, 104, 130],
    [6, 30, 56, 82, 108, 134],
    [6, 34, 60, 86, 112, 138],
    [6, 30, 58, 86, 114, 142],
    [6, 34, 62, 90, 118, 146],
    [6, 30, 54, 78, 102, 126, 150],
    [6, 24, 50, 76, 102, 128, 154],
    [6, 28, 54, 80, 106, 132, 158],
    [6, 32, 58, 84, 110, 136, 162],
    [6, 26, 54, 82, 110, 138, 166],
    [6, 30, 58, 86, 114, 142, 170]
  ],
  G15: 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0,
  G18: 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0,
  G15_MASK: 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1,
  getBCHTypeInfo: function(data) {
    var d = data << 10;
    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
      d ^= QRUtil.G15 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15);
    }
    return (data << 10 | d) ^ QRUtil.G15_MASK;
  },
  getBCHTypeNumber: function(data) {
    var d = data << 12;
    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
      d ^= QRUtil.G18 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18);
    }
    return data << 12 | d;
  },
  getBCHDigit: function(data) {
    var digit = 0;
    while (data != 0) {
      digit++;
      data >>>= 1;
    }
    return digit;
  },
  getPatternPosition: function(typeNumber) {
    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
  },
  getMask: function(maskPattern, i, j) {
    switch (maskPattern) {
      case QRMaskPattern.PATTERN000:
        return (i + j) % 2 == 0;
      case QRMaskPattern.PATTERN001:
        return i % 2 == 0;
      case QRMaskPattern.PATTERN010:
        return j % 3 == 0;
      case QRMaskPattern.PATTERN011:
        return (i + j) % 3 == 0;
      case QRMaskPattern.PATTERN100:
        return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
      case QRMaskPattern.PATTERN101:
        return i * j % 2 + i * j % 3 == 0;
      case QRMaskPattern.PATTERN110:
        return (i * j % 2 + i * j % 3) % 2 == 0;
      case QRMaskPattern.PATTERN111:
        return (i * j % 3 + (i + j) % 2) % 2 == 0;
      default:
        throw new Error("bad maskPattern:" + maskPattern);
    }
  },
  getErrorCorrectPolynomial: function(errorCorrectLength) {
    var a2 = new Polynomial$1([1], 0);
    for (var i = 0; i < errorCorrectLength; i++) {
      a2 = a2.multiply(new Polynomial$1([1, math.gexp(i)], 0));
    }
    return a2;
  },
  getLengthInBits: function(mode2, type) {
    if (1 <= type && type < 10) {
      switch (mode2) {
        case Mode.MODE_NUMBER:
          return 10;
        case Mode.MODE_ALPHA_NUM:
          return 9;
        case Mode.MODE_8BIT_BYTE:
          return 8;
        case Mode.MODE_KANJI:
          return 8;
        default:
          throw new Error("mode:" + mode2);
      }
    } else if (type < 27) {
      switch (mode2) {
        case Mode.MODE_NUMBER:
          return 12;
        case Mode.MODE_ALPHA_NUM:
          return 11;
        case Mode.MODE_8BIT_BYTE:
          return 16;
        case Mode.MODE_KANJI:
          return 10;
        default:
          throw new Error("mode:" + mode2);
      }
    } else if (type < 41) {
      switch (mode2) {
        case Mode.MODE_NUMBER:
          return 14;
        case Mode.MODE_ALPHA_NUM:
          return 13;
        case Mode.MODE_8BIT_BYTE:
          return 16;
        case Mode.MODE_KANJI:
          return 12;
        default:
          throw new Error("mode:" + mode2);
      }
    } else {
      throw new Error("type:" + type);
    }
  },
  getLostPoint: function(qrCode) {
    var moduleCount = qrCode.getModuleCount();
    var lostPoint = 0;
    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount; col++) {
        var sameCount = 0;
        var dark2 = qrCode.isDark(row, col);
        for (var r2 = -1; r2 <= 1; r2++) {
          if (row + r2 < 0 || moduleCount <= row + r2) {
            continue;
          }
          for (var c2 = -1; c2 <= 1; c2++) {
            if (col + c2 < 0 || moduleCount <= col + c2) {
              continue;
            }
            if (r2 == 0 && c2 == 0) {
              continue;
            }
            if (dark2 == qrCode.isDark(row + r2, col + c2)) {
              sameCount++;
            }
          }
        }
        if (sameCount > 5) {
          lostPoint += 3 + sameCount - 5;
        }
      }
    }
    for (var row = 0; row < moduleCount - 1; row++) {
      for (var col = 0; col < moduleCount - 1; col++) {
        var count = 0;
        if (qrCode.isDark(row, col))
          count++;
        if (qrCode.isDark(row + 1, col))
          count++;
        if (qrCode.isDark(row, col + 1))
          count++;
        if (qrCode.isDark(row + 1, col + 1))
          count++;
        if (count == 0 || count == 4) {
          lostPoint += 3;
        }
      }
    }
    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount - 6; col++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) {
          lostPoint += 40;
        }
      }
    }
    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount - 6; row++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) {
          lostPoint += 40;
        }
      }
    }
    var darkCount = 0;
    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount; row++) {
        if (qrCode.isDark(row, col)) {
          darkCount++;
        }
      }
    }
    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
    lostPoint += ratio * 10;
    return lostPoint;
  }
};
var util$1 = QRUtil;
var BitByte = _8BitByte;
var RSBlock = RSBlock$1;
var BitBuffer = BitBuffer$1;
var util = util$1;
var Polynomial = Polynomial$2;
function QRCode$1(typeNumber, errorCorrectLevel) {
  this.typeNumber = typeNumber;
  this.errorCorrectLevel = errorCorrectLevel;
  this.modules = null;
  this.moduleCount = 0;
  this.dataCache = null;
  this.dataList = [];
}
var proto = QRCode$1.prototype;
proto.addData = function(data) {
  var newData = new BitByte(data);
  this.dataList.push(newData);
  this.dataCache = null;
};
proto.isDark = function(row, col) {
  if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
    throw new Error(row + "," + col);
  }
  return this.modules[row][col];
};
proto.getModuleCount = function() {
  return this.moduleCount;
};
proto.make = function() {
  if (this.typeNumber < 1) {
    var typeNumber = 1;
    for (typeNumber = 1; typeNumber < 40; typeNumber++) {
      var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);
      var buffer = new BitBuffer();
      var totalDataCount = 0;
      for (var i = 0; i < rsBlocks.length; i++) {
        totalDataCount += rsBlocks[i].dataCount;
      }
      for (var i = 0; i < this.dataList.length; i++) {
        var data = this.dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
      }
      if (buffer.getLengthInBits() <= totalDataCount * 8)
        break;
    }
    this.typeNumber = typeNumber;
  }
  this.makeImpl(false, this.getBestMaskPattern());
};
proto.makeImpl = function(test2, maskPattern) {
  this.moduleCount = this.typeNumber * 4 + 17;
  this.modules = new Array(this.moduleCount);
  for (var row = 0; row < this.moduleCount; row++) {
    this.modules[row] = new Array(this.moduleCount);
    for (var col = 0; col < this.moduleCount; col++) {
      this.modules[row][col] = null;
    }
  }
  this.setupPositionProbePattern(0, 0);
  this.setupPositionProbePattern(this.moduleCount - 7, 0);
  this.setupPositionProbePattern(0, this.moduleCount - 7);
  this.setupPositionAdjustPattern();
  this.setupTimingPattern();
  this.setupTypeInfo(test2, maskPattern);
  if (this.typeNumber >= 7) {
    this.setupTypeNumber(test2);
  }
  if (this.dataCache == null) {
    this.dataCache = QRCode$1.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
  }
  this.mapData(this.dataCache, maskPattern);
};
proto.setupPositionProbePattern = function(row, col) {
  for (var r2 = -1; r2 <= 7; r2++) {
    if (row + r2 <= -1 || this.moduleCount <= row + r2)
      continue;
    for (var c2 = -1; c2 <= 7; c2++) {
      if (col + c2 <= -1 || this.moduleCount <= col + c2)
        continue;
      if (0 <= r2 && r2 <= 6 && (c2 == 0 || c2 == 6) || 0 <= c2 && c2 <= 6 && (r2 == 0 || r2 == 6) || 2 <= r2 && r2 <= 4 && 2 <= c2 && c2 <= 4) {
        this.modules[row + r2][col + c2] = true;
      } else {
        this.modules[row + r2][col + c2] = false;
      }
    }
  }
};
proto.getBestMaskPattern = function() {
  var minLostPoint = 0;
  var pattern = 0;
  for (var i = 0; i < 8; i++) {
    this.makeImpl(true, i);
    var lostPoint = util.getLostPoint(this);
    if (i == 0 || minLostPoint > lostPoint) {
      minLostPoint = lostPoint;
      pattern = i;
    }
  }
  return pattern;
};
proto.createMovieClip = function(target_mc, instance_name, depth) {
  var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
  var cs = 1;
  this.make();
  for (var row = 0; row < this.modules.length; row++) {
    var y = row * cs;
    for (var col = 0; col < this.modules[row].length; col++) {
      var x2 = col * cs;
      var dark2 = this.modules[row][col];
      if (dark2) {
        qr_mc.beginFill(0, 100);
        qr_mc.moveTo(x2, y);
        qr_mc.lineTo(x2 + cs, y);
        qr_mc.lineTo(x2 + cs, y + cs);
        qr_mc.lineTo(x2, y + cs);
        qr_mc.endFill();
      }
    }
  }
  return qr_mc;
};
proto.setupTimingPattern = function() {
  for (var r2 = 8; r2 < this.moduleCount - 8; r2++) {
    if (this.modules[r2][6] != null) {
      continue;
    }
    this.modules[r2][6] = r2 % 2 == 0;
  }
  for (var c2 = 8; c2 < this.moduleCount - 8; c2++) {
    if (this.modules[6][c2] != null) {
      continue;
    }
    this.modules[6][c2] = c2 % 2 == 0;
  }
};
proto.setupPositionAdjustPattern = function() {
  var pos = util.getPatternPosition(this.typeNumber);
  for (var i = 0; i < pos.length; i++) {
    for (var j = 0; j < pos.length; j++) {
      var row = pos[i];
      var col = pos[j];
      if (this.modules[row][col] != null) {
        continue;
      }
      for (var r2 = -2; r2 <= 2; r2++) {
        for (var c2 = -2; c2 <= 2; c2++) {
          if (r2 == -2 || r2 == 2 || c2 == -2 || c2 == 2 || r2 == 0 && c2 == 0) {
            this.modules[row + r2][col + c2] = true;
          } else {
            this.modules[row + r2][col + c2] = false;
          }
        }
      }
    }
  }
};
proto.setupTypeNumber = function(test2) {
  var bits = util.getBCHTypeNumber(this.typeNumber);
  for (var i = 0; i < 18; i++) {
    var mod = !test2 && (bits >> i & 1) == 1;
    this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
  }
  for (var i = 0; i < 18; i++) {
    var mod = !test2 && (bits >> i & 1) == 1;
    this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
  }
};
proto.setupTypeInfo = function(test2, maskPattern) {
  var data = this.errorCorrectLevel << 3 | maskPattern;
  var bits = util.getBCHTypeInfo(data);
  for (var i = 0; i < 15; i++) {
    var mod = !test2 && (bits >> i & 1) == 1;
    if (i < 6) {
      this.modules[i][8] = mod;
    } else if (i < 8) {
      this.modules[i + 1][8] = mod;
    } else {
      this.modules[this.moduleCount - 15 + i][8] = mod;
    }
  }
  for (var i = 0; i < 15; i++) {
    var mod = !test2 && (bits >> i & 1) == 1;
    if (i < 8) {
      this.modules[8][this.moduleCount - i - 1] = mod;
    } else if (i < 9) {
      this.modules[8][15 - i - 1 + 1] = mod;
    } else {
      this.modules[8][15 - i - 1] = mod;
    }
  }
  this.modules[this.moduleCount - 8][8] = !test2;
};
proto.mapData = function(data, maskPattern) {
  var inc = -1;
  var row = this.moduleCount - 1;
  var bitIndex = 7;
  var byteIndex = 0;
  for (var col = this.moduleCount - 1; col > 0; col -= 2) {
    if (col == 6)
      col--;
    while (true) {
      for (var c2 = 0; c2 < 2; c2++) {
        if (this.modules[row][col - c2] == null) {
          var dark2 = false;
          if (byteIndex < data.length) {
            dark2 = (data[byteIndex] >>> bitIndex & 1) == 1;
          }
          var mask = util.getMask(maskPattern, row, col - c2);
          if (mask) {
            dark2 = !dark2;
          }
          this.modules[row][col - c2] = dark2;
          bitIndex--;
          if (bitIndex == -1) {
            byteIndex++;
            bitIndex = 7;
          }
        }
      }
      row += inc;
      if (row < 0 || this.moduleCount <= row) {
        row -= inc;
        inc = -inc;
        break;
      }
    }
  }
};
QRCode$1.PAD0 = 236;
QRCode$1.PAD1 = 17;
QRCode$1.createData = function(typeNumber, errorCorrectLevel, dataList) {
  var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
  var buffer = new BitBuffer();
  for (var i = 0; i < dataList.length; i++) {
    var data = dataList[i];
    buffer.put(data.mode, 4);
    buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber));
    data.write(buffer);
  }
  var totalDataCount = 0;
  for (var i = 0; i < rsBlocks.length; i++) {
    totalDataCount += rsBlocks[i].dataCount;
  }
  if (buffer.getLengthInBits() > totalDataCount * 8) {
    throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
  }
  if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
    buffer.put(0, 4);
  }
  while (buffer.getLengthInBits() % 8 != 0) {
    buffer.putBit(false);
  }
  while (true) {
    if (buffer.getLengthInBits() >= totalDataCount * 8) {
      break;
    }
    buffer.put(QRCode$1.PAD0, 8);
    if (buffer.getLengthInBits() >= totalDataCount * 8) {
      break;
    }
    buffer.put(QRCode$1.PAD1, 8);
  }
  return QRCode$1.createBytes(buffer, rsBlocks);
};
QRCode$1.createBytes = function(buffer, rsBlocks) {
  var offset2 = 0;
  var maxDcCount = 0;
  var maxEcCount = 0;
  var dcdata = new Array(rsBlocks.length);
  var ecdata = new Array(rsBlocks.length);
  for (var r2 = 0; r2 < rsBlocks.length; r2++) {
    var dcCount = rsBlocks[r2].dataCount;
    var ecCount = rsBlocks[r2].totalCount - dcCount;
    maxDcCount = Math.max(maxDcCount, dcCount);
    maxEcCount = Math.max(maxEcCount, ecCount);
    dcdata[r2] = new Array(dcCount);
    for (var i = 0; i < dcdata[r2].length; i++) {
      dcdata[r2][i] = 255 & buffer.buffer[i + offset2];
    }
    offset2 += dcCount;
    var rsPoly = util.getErrorCorrectPolynomial(ecCount);
    var rawPoly = new Polynomial(dcdata[r2], rsPoly.getLength() - 1);
    var modPoly = rawPoly.mod(rsPoly);
    ecdata[r2] = new Array(rsPoly.getLength() - 1);
    for (var i = 0; i < ecdata[r2].length; i++) {
      var modIndex = i + modPoly.getLength() - ecdata[r2].length;
      ecdata[r2][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
    }
  }
  var totalCodeCount = 0;
  for (var i = 0; i < rsBlocks.length; i++) {
    totalCodeCount += rsBlocks[i].totalCount;
  }
  var data = new Array(totalCodeCount);
  var index2 = 0;
  for (var i = 0; i < maxDcCount; i++) {
    for (var r2 = 0; r2 < rsBlocks.length; r2++) {
      if (i < dcdata[r2].length) {
        data[index2++] = dcdata[r2][i];
      }
    }
  }
  for (var i = 0; i < maxEcCount; i++) {
    for (var r2 = 0; r2 < rsBlocks.length; r2++) {
      if (i < ecdata[r2].length) {
        data[index2++] = ecdata[r2][i];
      }
    }
  }
  return data;
};
var QRCode_1 = QRCode$1;
var QRCodeSvg$1 = {};
Object.defineProperty(QRCodeSvg$1, "__esModule", {
  value: true
});
var _extends$1 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _propTypes$1 = propTypesExports;
var _propTypes2$1 = _interopRequireDefault$1(_propTypes$1);
var _react$1 = React__default;
var _react2$1 = _interopRequireDefault$1(_react$1);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _objectWithoutProperties$1(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i))
      continue;
    target[i] = obj[i];
  }
  return target;
}
var propTypes$1 = {
  bgColor: _propTypes2$1.default.oneOfType([_propTypes2$1.default.object, _propTypes2$1.default.string]).isRequired,
  bgD: _propTypes2$1.default.string.isRequired,
  fgColor: _propTypes2$1.default.oneOfType([_propTypes2$1.default.object, _propTypes2$1.default.string]).isRequired,
  fgD: _propTypes2$1.default.string.isRequired,
  size: _propTypes2$1.default.number.isRequired,
  title: _propTypes2$1.default.string,
  viewBoxSize: _propTypes2$1.default.number.isRequired,
  xmlns: _propTypes2$1.default.string
};
var QRCodeSvg = (0, _react$1.forwardRef)(function(_ref, ref) {
  var bgColor = _ref.bgColor, bgD = _ref.bgD, fgD = _ref.fgD, fgColor = _ref.fgColor, size = _ref.size, title = _ref.title, viewBoxSize = _ref.viewBoxSize, _ref$xmlns = _ref.xmlns, xmlns = _ref$xmlns === void 0 ? "http://www.w3.org/2000/svg" : _ref$xmlns, props = _objectWithoutProperties$1(_ref, ["bgColor", "bgD", "fgD", "fgColor", "size", "title", "viewBoxSize", "xmlns"]);
  return _react2$1.default.createElement(
    "svg",
    _extends$1({}, props, { height: size, ref, viewBox: "0 0 " + viewBoxSize + " " + viewBoxSize, width: size, xmlns }),
    title ? _react2$1.default.createElement(
      "title",
      null,
      title
    ) : null,
    _react2$1.default.createElement("path", { d: bgD, fill: bgColor }),
    _react2$1.default.createElement("path", { d: fgD, fill: fgColor })
  );
});
QRCodeSvg.displayName = "QRCodeSvg";
QRCodeSvg.propTypes = propTypes$1;
QRCodeSvg$1.default = QRCodeSvg;
Object.defineProperty(lib, "__esModule", {
  value: true
});
lib.QRCode = void 0;
var _extends = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _propTypes = propTypesExports;
var _propTypes2 = _interopRequireDefault(_propTypes);
var _ErrorCorrectLevel = ErrorCorrectLevel;
var _ErrorCorrectLevel2 = _interopRequireDefault(_ErrorCorrectLevel);
var _QRCode = QRCode_1;
var _QRCode2 = _interopRequireDefault(_QRCode);
var _react = React__default;
var _react2 = _interopRequireDefault(_react);
var _QRCodeSvg = QRCodeSvg$1;
var _QRCodeSvg2 = _interopRequireDefault(_QRCodeSvg);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i))
      continue;
    target[i] = obj[i];
  }
  return target;
}
var propTypes = {
  bgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  fgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  level: _propTypes2.default.string,
  size: _propTypes2.default.number,
  value: _propTypes2.default.string.isRequired
};
var QRCode = (0, _react.forwardRef)(function(_ref, ref) {
  var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "#FFFFFF" : _ref$bgColor, _ref$fgColor = _ref.fgColor, fgColor = _ref$fgColor === void 0 ? "#000000" : _ref$fgColor, _ref$level = _ref.level, level = _ref$level === void 0 ? "L" : _ref$level, _ref$size = _ref.size, size = _ref$size === void 0 ? 256 : _ref$size, value = _ref.value, props = _objectWithoutProperties(_ref, ["bgColor", "fgColor", "level", "size", "value"]);
  var qrcode = new _QRCode2.default(-1, _ErrorCorrectLevel2.default[level]);
  qrcode.addData(value);
  qrcode.make();
  var cells = qrcode.modules;
  return _react2.default.createElement(_QRCodeSvg2.default, _extends({}, props, {
    bgColor,
    bgD: cells.map(function(row, rowIndex) {
      return row.map(function(cell, cellIndex) {
        return !cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    fgColor,
    fgD: cells.map(function(row, rowIndex) {
      return row.map(function(cell, cellIndex) {
        return cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    ref,
    size,
    viewBoxSize: cells.length
  }));
});
lib.QRCode = QRCode;
QRCode.displayName = "QRCode";
QRCode.propTypes = propTypes;
var _default = lib.default = QRCode;
const CodesModal = ({
  isOpen,
  codes
}) => {
  const [copyStatus, setCopyStatus] = useState(false);
  const handleCopyCallback = (status) => {
    setCopyStatus(status);
  };
  const handleRedirect = () => {
    window.location.href = "/kyc";
  };
  return /* @__PURE__ */ jsx(Modal2, { showCloseIcon: false, isOpen, onClose: handleRedirect, children: /* @__PURE__ */ jsxs("div", { className: "py-3 sm:py-8", children: [
    /* @__PURE__ */ jsx("h2", { className: `mb-4 font-medium text-[28px]`, children: /* @__PURE__ */ jsx(Trans, { id: "txnnFL" }) }),
    /* @__PURE__ */ jsx("p", { className: `font-base opacity-50`, children: /* @__PURE__ */ jsx(Trans, { id: "6OPNcL" }) }),
    /* @__PURE__ */ jsx("div", { className: "grid grid-cols-2 min-[350px]:grid-cols-3 sm:grid-cols-3 mt-8 gap-4 text-center", children: codes.map((code) => {
      return /* @__PURE__ */ jsx("code", { className: "font-base", children: code.code });
    }) }),
    /* @__PURE__ */ jsxs("div", { className: "flex justify-between gap-4 mt-8", children: [
      /* @__PURE__ */ jsx(CopyButton, { codeToCopy: codes.map((code) => {
        return code.code;
      }).join(", "), callback: handleCopyCallback, children: copyStatus ? /* @__PURE__ */ jsx(Trans, { id: "6V3Ea3" }) : /* @__PURE__ */ jsx(Trans, { id: "S9/u59" }) }),
      /* @__PURE__ */ jsx(Button, { isDark: true, onClick: handleRedirect, children: /* @__PURE__ */ jsx(Trans, { id: "DPfwMq" }) })
    ] })
  ] }) });
};
const Step2 = ({
  url,
  codeToCopy,
  formAction,
  csrfToken,
  castleData
}) => {
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [codes, setCodes] = useState([]);
  const [isError, setIsError] = useState(false);
  const [copyStatus, setCopyStatus] = useState(false);
  const isValid2 = code.length > 0;
  useEffect(() => {
    if (castleData == null ? void 0 : castleData.castlePublishKey) {
      castleExports.configure({
        pk: castleData.castlePublishKey
      });
    }
  }, []);
  const handleSubmit = (e2) => __async(void 0, null, function* () {
    e2.preventDefault();
    if (!isLoading && isValid2) {
      const requestToken = castleData ? yield castleExports.createRequestToken() : null;
      const data = {
        multi_factor_authentication_totp: __spreadValues({
          otp_attempt: code
        }, requestToken ? {
          castle_request_token: requestToken
        } : {}),
        authenticity_token: csrfToken
      };
      try {
        setIsError(false);
        setIsLoading(true);
        const response = yield fetch(formAction, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken
          },
          body: JSON.stringify(data)
        });
        if (response.ok) {
          const data2 = yield response.json();
          setCodes(data2.codes);
          setIsSuccess(true);
        } else {
          if (response.status === 422) {
            setIsError(true);
            setIsLoading(false);
          }
        }
      } catch (errors2) {
        console.log(errors2);
        setIsLoading(false);
      }
    }
  });
  const handleOnChange = (e2) => {
    setCode(e2.currentTarget.value);
  };
  const handleCopyCallback = (status) => {
    setCopyStatus(status);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(CodesModal, { isOpen: isSuccess, codes }),
    /* @__PURE__ */ jsxs("div", { className: "flex gap-x-24 max-w-[800px]", children: [
      /* @__PURE__ */ jsxs("div", { className: "hidden flex-col gap-8 hidden lg:flex min-w-64 lg:justify-end", children: [
        /* @__PURE__ */ jsx("div", { style: {
          height: "auto",
          margin: "0 auto",
          maxWidth: 250,
          width: "100%"
        }, children: /* @__PURE__ */ jsx(_default, { value: url, size: 250, style: {
          height: "auto",
          maxWidth: "100%",
          width: "100%"
        } }) }),
        /* @__PURE__ */ jsx(CopyButton, { codeToCopy, callback: handleCopyCallback, children: copyStatus ? /* @__PURE__ */ jsx(Trans, { id: "6V3Ea3" }) : /* @__PURE__ */ jsx(Trans, { id: "PeJVpn" }) })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "gap-8 flex flex-col", children: [
        /* @__PURE__ */ jsxs(Container, { children: [
          /* @__PURE__ */ jsx(Title, { children: /* @__PURE__ */ jsx(Trans, { id: "T65b7l" }) }),
          /* @__PURE__ */ jsx(Subitle, { children: /* @__PURE__ */ jsx(Trans, { id: "4+5GhB" }) })
        ] }),
        /* @__PURE__ */ jsx(CopyButton, { className: "flex lg:hidden", codeToCopy, callback: handleCopyCallback, children: copyStatus ? /* @__PURE__ */ jsx(Trans, { id: "6V3Ea3" }) : /* @__PURE__ */ jsx(Trans, { id: "PeJVpn" }) }),
        /* @__PURE__ */ jsxs("form", { onSubmit: handleSubmit, className: "flex flex-col gap-8", children: [
          /* @__PURE__ */ jsxs(Fieldset, { children: [
            /* @__PURE__ */ jsx(FormLabel, { htmlFor: "code", children: /* @__PURE__ */ jsx(Trans, { id: "Z9mCS6" }) }),
            /* @__PURE__ */ jsx(Input, { autoFocus: true, id: "code", onChange: handleOnChange, type: "text", placeholder: i18n._(
              /*i18n*/
              {
                id: "lPgKS3"
              }
            ) }),
            isError && /* @__PURE__ */ jsxs(FormError, { children: [
              /* @__PURE__ */ jsx(Trans, { id: "EK6YGK" }),
              " ",
              /* @__PURE__ */ jsx("a", { href: i18n._(
                /*i18n*/
                {
                  id: "puIMZD"
                }
              ), target: "_blank", className: "underline text-black", children: /* @__PURE__ */ jsx(Trans, { id: "C1DCFO" }) })
            ] })
          ] }),
          /* @__PURE__ */ jsx(Button, { isLoading, disabled: !isValid2, isDark: true, children: /* @__PURE__ */ jsx(Trans, { id: "hQRttt" }) })
        ] })
      ] })
    ] })
  ] });
};
const mfaSchema = z.object({
  csrfToken: z.string(),
  formAction: z.string(),
  castleData: z.nullable(z.object({
    castlePublishKey: z.string()
  })).optional(),
  url: z.string(),
  codeToCopy: z.string(),
  locale: z.string().optional()
});
const Mfa = (props) => {
  const {
    url,
    codeToCopy,
    formAction,
    csrfToken,
    castleData,
    locale = "en"
  } = props;
  const [step, setStep] = useState(0);
  useComponentValidation({
    props,
    schema: mfaSchema
  });
  const steps2 = [/* @__PURE__ */ jsx(Step1, { onContinue: () => setStep(1) }), /* @__PURE__ */ jsx(Step2, { castleData, csrfToken, formAction, codeToCopy, url })];
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: steps2[step] });
};
const Register = ({
  csrfToken,
  formAction,
  castleData,
  isBusiness = false,
  locale
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [emailFormatInvalid, setEmailFormatInvalid] = useState(false);
  const [password, setPassword] = useState("");
  const [checkbox, setCheckbox] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [checkbox3, setCheckbox3] = useState(false);
  const [isPasswordLengthError, setIsPasswordLengthError] = useState(false);
  const [email, setEmail] = useState("");
  const [errors2, setErrors] = useState();
  const {
    i18n: i18n2
  } = useLingui();
  useEffect(() => {
    if (castleData == null ? void 0 : castleData.castlePublishKey) {
      castleExports.configure({
        pk: castleData.castlePublishKey
      });
    }
  }, []);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const fromAlpha = urlParams.get("from_alpha");
    if (fromAlpha !== null) {
      api.set("referral_source", "alpha", {
        expires: 365
      });
    }
  }, []);
  const handleSubmit = (e2) => __async(void 0, null, function* () {
    e2.preventDefault();
    if (!isLoading && isValid2) {
      setEmailFormatInvalid(false);
      const requestToken = castleData ? yield castleExports.createRequestToken() : null;
      const data = {
        user: __spreadValues({
          email,
          isBusiness,
          password
        }, requestToken ? {
          castle_request_token: requestToken
        } : {}),
        authenticity_token: csrfToken
      };
      try {
        setIsLoading(true);
        const response = yield fetch(formAction, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken
          },
          body: JSON.stringify(data)
        });
        if (response.ok) {
          const data2 = yield response.json();
          window.location.href = data2.redirect;
        } else {
          if (response.status === 422) {
            const e22 = yield response.json();
            setErrors(e22);
            setIsLoading(false);
          }
        }
      } catch (e3) {
        setErrors({
          "system": ["There was an error"]
        });
        setIsLoading(false);
      }
    }
  });
  const isPasswordError = !isLoading && !!(errors2 == null ? void 0 : errors2.password);
  const isEmailError = !isLoading && !!(errors2 == null ? void 0 : errors2.email);
  const restErrors = errors2 ? Object.keys(errors2).filter((errorKey) => {
    if (errorKey !== "email" && errorKey !== "password") {
      return true;
    }
    return false;
  }).map((error) => {
    return errors2[error];
  }) : [];
  const isValid2 = validateEmail(email) && validatePassword(password) && (locale === "tr" ? checkbox && checkbox2 && checkbox3 : true);
  return /* @__PURE__ */ jsxs("div", { className: "gap-8 flex flex-col", children: [
    /* @__PURE__ */ jsxs(Container, { children: [
      /* @__PURE__ */ jsx(Title, { children: isBusiness ? /* @__PURE__ */ jsx(Trans, { id: "/rRuUa" }) : /* @__PURE__ */ jsx(Trans, { id: "X1eXLH" }) }),
      /* @__PURE__ */ jsx(Subitle, { children: isBusiness ? /* @__PURE__ */ jsx(Trans, { id: "KW2Pmm" }) : /* @__PURE__ */ jsx(Trans, { id: "5Ehy8S" }) })
    ] }),
    restErrors.length > 0 && /* @__PURE__ */ jsx("div", { children: restErrors.map((e2) => {
      return /* @__PURE__ */ jsx(FormError, { children: e2 });
    }) }),
    /* @__PURE__ */ jsxs("form", { onSubmit: handleSubmit, acceptCharset: "UTF-8", className: "flex flex-col gap-8", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "authenticity_token", value: csrfToken }),
        /* @__PURE__ */ jsxs(Fieldset, { children: [
          /* @__PURE__ */ jsx(FormLabel, { htmlFor: "registerEmail", isError: isEmailError || emailFormatInvalid, children: isBusiness ? /* @__PURE__ */ jsx(Trans, { id: "UWHEkW" }) : /* @__PURE__ */ jsx(Trans, { id: "O3oNi5" }) }),
          /* @__PURE__ */ jsx(Input, { autoFocus: true, id: "registerEmail", value: email, onBlur: (e2) => {
            setEmailFormatInvalid(!validateEmail(e2.currentTarget.value));
          }, onChange: (e2) => {
            if (errors2 == null ? void 0 : errors2.email) {
              const _a = errors2, {
                email: email2
              } = _a, noEmail = __objRest(_a, [
                // eslint-disable-next-line no-unused-vars
                "email"
              ]);
              setErrors(__spreadValues({}, noEmail));
            }
            setEmail(e2.currentTarget.value);
          }, isError: !!(errors2 == null ? void 0 : errors2.email) || emailFormatInvalid, name: "user[email]", placeholder: isBusiness ? i18n2._(
            /*i18n*/
            {
              id: "whludS"
            }
          ) : i18n2._(
            /*i18n*/
            {
              id: "C3nD/1"
            }
          ) }),
          emailFormatInvalid && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "io0enF" }) }),
          isEmailError && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "axWtcV", components: {
            0: /* @__PURE__ */ jsx("a", { className: "text-black underline text-sm", href: "/login" })
          } }) })
        ] }),
        /* @__PURE__ */ jsxs(Fieldset, { children: [
          /* @__PURE__ */ jsx(FormLabel, { htmlFor: "password", isError: isPasswordError, children: /* @__PURE__ */ jsx(Trans, { id: "8ZsakT" }) }),
          /* @__PURE__ */ jsx(PasswordInput, { id: "password", value: password, onChange: (e2) => {
            if (errors2 == null ? void 0 : errors2.password) {
              const _a = errors2, {
                password: password2
              } = _a, noPwd = __objRest(_a, [
                // eslint-disable-next-line no-unused-vars
                "password"
              ]);
              setErrors(__spreadValues({}, noPwd));
            }
            if (validatePassword(password)) {
              setIsPasswordLengthError(false);
            }
            setPassword(e2.currentTarget.value);
          }, isError: isPasswordError || isPasswordLengthError, onBlur: () => !validatePassword(password) && setIsPasswordLengthError(true), name: "user[password]", placeholder: i18n2._(
            /*i18n*/
            {
              id: "NgaR6B"
            }
          ) }),
          /* @__PURE__ */ jsx(FormFieldDescription, { isError: isPasswordLengthError && !validatePassword(password), isPassed: validatePassword(password), children: /* @__PURE__ */ jsx(Trans, { id: "TaFX2+" }) })
        ] }),
        locale === "tr" && /* @__PURE__ */ jsxs(Fieldset, { children: [
          /* @__PURE__ */ jsx(Checkbox, { onChange: (e2) => {
            setCheckbox(e2.currentTarget.checked);
          }, checked: checkbox, id: "checkbox1", label: /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("a", { target: "_blank", className: "text-black underline", href: "https://tr.coinlist.co/documents/legal/tr/terms_v1.pdf", children: "Kullanıcı Sözleşmesini" }),
            " Okudum ve Anladım."
          ] }) }),
          /* @__PURE__ */ jsx(Checkbox, { onChange: (e2) => {
            setCheckbox2(e2.currentTarget.checked);
          }, checked: checkbox2, id: "checkbox2", label: /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("a", { target: "_blank", className: "text-black underline", href: "https://coinlist.co/documents/legal/tr/privacy_v1.pdf", children: "Kullanıcı Sözleşmesi Aydınlatma Metnini" }),
            " Okudum ve Anladım."
          ] }) }),
          /* @__PURE__ */ jsx(Checkbox, { onChange: (e2) => {
            setCheckbox3(e2.currentTarget.checked);
          }, checked: checkbox3, id: "checkbox3", label: /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("a", { target: "_blank", className: "text-black underline", href: "https://coinlist.co/documents/legal/tr/user_agreement_explicit_consent_v1.pdf", children: "Kullanıcı Sözleşmesi Açık Rıza Metni" }),
            " Okudum ve Kabul Ettim."
          ] }) })
        ] })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "flex gap-4", children: /* @__PURE__ */ jsx(Button, { name: "register-submit", isLoading, isDark: true, type: "submit", disabled: !isValid2, children: /* @__PURE__ */ jsx(Trans, { id: "1hMWR6" }) }) })
    ] }),
    /* @__PURE__ */ jsx("p", { className: "text-quickSilver text-center", children: isBusiness ? /* @__PURE__ */ jsx(Trans, { id: "k/YP30", components: {
      0: /* @__PURE__ */ jsx("a", { href: "/register", className: "text-black" }),
      1: /* @__PURE__ */ jsx(RightArrow, { width: "14", className: "inline" })
    } }) : /* @__PURE__ */ jsx(Trans, { id: "PYf+ML", components: {
      0: /* @__PURE__ */ jsx("a", { href: "/register/business", className: "text-black" }),
      1: /* @__PURE__ */ jsx(RightArrow, { width: "14", className: "inline" })
    } }) })
  ] });
};
const registerSchema = z.object({
  csrfToken: z.string(),
  formAction: z.string(),
  castleData: z.nullable(z.object({
    castlePublishKey: z.string()
  })).optional(),
  isBusiness: z.boolean().optional(),
  locale: z.string()
});
const RegisterParent = (props) => {
  const _a = props, {
    locale = "en"
  } = _a, rest = __objRest(_a, [
    "locale"
  ]);
  useComponentValidation({
    props,
    schema: registerSchema
  });
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsx(Register, __spreadProps(__spreadValues({}, rest), { locale })) });
};
const ErrorState = () => {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-6 justify-center items-center", children: [
    /* @__PURE__ */ jsx(Logo, {}),
    /* @__PURE__ */ jsx("p", { className: "text-xl font-semibold", children: /* @__PURE__ */ jsx(Trans, { id: "TXHuXK" }) }),
    /* @__PURE__ */ jsx(Button, { onClick: () => {
      window.location.href = "/";
    }, isFullWidth: false, isDark: true, children: /* @__PURE__ */ jsx(Trans, { id: "QIc67y" }) })
  ] });
};
const ResetPassword = ({
  csrfToken,
  formAction,
  castleData,
  email,
  resetPasswordToken
}) => {
  const [isValid2, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isPaswordEqualError, setIsPaswordEqualError] = useState(false);
  const [successLocation, setSuccessLocation] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [errors2, setErrors] = useState();
  const {
    i18n: i18n2
  } = useLingui();
  useEffect(() => {
    if (castleData == null ? void 0 : castleData.castlePublishKey) {
      castleExports.configure({
        pk: castleData.castlePublishKey
      });
    }
  }, []);
  const handleSubmit = (e2) => __async(void 0, null, function* () {
    e2.preventDefault();
    if (!isLoading && isValid2) {
      const requestToken = castleData ? yield castleExports.createRequestToken() : null;
      const data = {
        user: __spreadValues({
          reset_password_token: resetPasswordToken,
          password,
          password_confirmation: passwordConfirmation
        }, requestToken ? {
          castle_request_token: requestToken
        } : {}),
        authenticity_token: csrfToken
      };
      try {
        setIsLoading(true);
        const response = yield fetch(formAction, {
          method: "PATCH",
          mode: "cors",
          cache: "no-cache",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken
          },
          body: JSON.stringify(data)
        });
        if (response.ok) {
          setIsSuccess(true);
          const data2 = yield response.json();
          setSuccessLocation(data2.location);
        } else {
          if (response.status === 422) {
            const e22 = yield response.json();
            setErrors(e22);
            setIsLoading(false);
          }
        }
      } catch (errors22) {
        console.log(errors22);
        setIsLoading(false);
      }
    }
  });
  const onSuccess = () => {
    window.location.href = successLocation;
  };
  const isPasswordError = !isLoading && !!(errors2 == null ? void 0 : errors2.password);
  const isPasswordConfirmationError = !isLoading && !!(errors2 == null ? void 0 : errors2.password_confirmation);
  const restErrors = errors2 ? Object.keys(errors2).filter((errorKey) => {
    if (errorKey !== "password_confirmation" && errorKey !== "password") {
      return true;
    }
    return false;
  }).map((error) => {
    return errors2[error];
  }) : [];
  const handleOnBlur = (password2, confirmPassword) => {
    setIsPaswordEqualError(password2 !== confirmPassword);
  };
  if (email === "") {
    return /* @__PURE__ */ jsx(ErrorState, {});
  }
  return /* @__PURE__ */ jsxs("div", { className: "gap-8 flex flex-col", children: [
    /* @__PURE__ */ jsx(Snackbar2, { isOpen: isSuccess, onClose: () => {
      setIsSuccess(false);
      onSuccess();
    }, content: i18n2._(
      /*i18n*/
      {
        id: "m/25r1"
      }
    ) }),
    /* @__PURE__ */ jsxs(Container, { children: [
      /* @__PURE__ */ jsx(Title, { children: /* @__PURE__ */ jsx(Trans, { id: "slOprG" }) }),
      /* @__PURE__ */ jsx(Subitle, { children: /* @__PURE__ */ jsx(Trans, { id: "IxYE8T" }) })
    ] }),
    restErrors.length > 0 && /* @__PURE__ */ jsx("div", { children: restErrors.map((e2) => {
      return /* @__PURE__ */ jsx(FormError, { children: e2 });
    }) }),
    /* @__PURE__ */ jsxs("form", { onSubmit: handleSubmit, acceptCharset: "UTF-8", className: "flex flex-col gap-8", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "authenticity_token", value: csrfToken }),
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "_method", value: "patch" }),
        /* @__PURE__ */ jsxs(Fieldset, { children: [
          /* @__PURE__ */ jsx(FormLabel, { children: /* @__PURE__ */ jsx(Trans, { id: "O3oNi5" }) }),
          /* @__PURE__ */ jsx(Input, { value: email, disabled: true })
        ] }),
        /* @__PURE__ */ jsxs(Fieldset, { children: [
          /* @__PURE__ */ jsx(FormLabel, { htmlFor: "password", isError: isPasswordError, children: /* @__PURE__ */ jsx(Trans, { id: "7vhWI8" }) }),
          /* @__PURE__ */ jsx(Input, { id: "password", value: password, onChange: (e2) => {
            if (errors2 == null ? void 0 : errors2.password) {
              const _a = errors2, {
                password: password2
              } = _a, noPwd = __objRest(_a, [
                // eslint-disable-next-line no-unused-vars
                "password"
              ]);
              setErrors(__spreadValues({}, noPwd));
            }
            setPassword(e2.currentTarget.value);
            setIsValid(validatePassword(e2.currentTarget.value) && e2.currentTarget.value === passwordConfirmation);
          }, type: "password", isError: !!(errors2 == null ? void 0 : errors2.password), name: "user[password]", placeholder: i18n2._(
            /*i18n*/
            {
              id: "dDyAXD"
            }
          ), onBlur: (e2) => {
            handleOnBlur(passwordConfirmation, e2.currentTarget.value);
          } }),
          /* @__PURE__ */ jsx(FormFieldDescription, { isPassed: validatePassword(password), children: /* @__PURE__ */ jsx(Trans, { id: "TaFX2+" }) }),
          isPasswordError && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "fV2Bu6" }) })
        ] }),
        /* @__PURE__ */ jsxs(Fieldset, { children: [
          /* @__PURE__ */ jsx(FormLabel, { htmlFor: "passwordConfirm", isError: isPasswordError, children: /* @__PURE__ */ jsx(Trans, { id: "xnWESi" }) }),
          /* @__PURE__ */ jsx(Input, { id: "passwordConfirm", value: passwordConfirmation, onBlur: (e2) => {
            handleOnBlur(e2.currentTarget.value, password);
          }, onChange: (e2) => {
            if (errors2 == null ? void 0 : errors2.password_confirmation) {
              const _a = errors2, {
                password_confirmation: password_confirmation
              } = _a, noPwd = __objRest(_a, [
                // eslint-disable-next-line no-unused-vars
                "password_confirmation"
              ]);
              setErrors(__spreadValues({}, noPwd));
            }
            setPasswordConfirmation(e2.currentTarget.value);
            setIsValid(validatePassword(e2.currentTarget.value) && e2.currentTarget.value === password);
          }, type: "password", isError: !!(errors2 == null ? void 0 : errors2.password_confirmation), name: "user[password_confirmation]", placeholder: i18n2._(
            /*i18n*/
            {
              id: "t0qQZE"
            }
          ) }),
          isPasswordConfirmationError && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "fV2Bu6" }) }),
          isPaswordEqualError && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "2BlKXa" }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex gap-4", children: [
        /* @__PURE__ */ jsx(Button, { type: "button", hasBorder: true, onClick: onSuccess, children: /* @__PURE__ */ jsx(Trans, { id: "dEgA5A" }) }),
        /* @__PURE__ */ jsx(Button, { isLoading, isDark: true, type: "submit", disabled: !isValid2, children: /* @__PURE__ */ jsx(Trans, { id: "JlFcis" }) })
      ] })
    ] })
  ] });
};
const resetPwdSchema = z.object({
  csrfToken: z.string(),
  formAction: z.string(),
  castleData: z.nullable(z.object({
    castlePublishKey: z.string()
  })).optional(),
  email: z.string(),
  resetPasswordToken: z.string()
});
const ResetPasswordParent = (props) => {
  const _a = props, {
    locale = "en"
  } = _a, rest = __objRest(_a, [
    "locale"
  ]);
  useComponentValidation({
    props,
    schema: resetPwdSchema
  });
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsx(ResetPassword, __spreadValues({}, rest)) });
};
const ChangeEmailForm = ({
  email,
  onCancel,
  csrfToken,
  formAction
}) => {
  const [isValid2, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [emailFormatInvalid, setEmailFormatInvalid] = useState(false);
  const [password, setPassword] = useState("");
  const [errors2, setErrors] = useState();
  const handleSubmit = (e2) => __async(void 0, null, function* () {
    e2.preventDefault();
    if (!isLoading && isValid2) {
      const data = {
        user: {
          email: emailInput,
          current_password: password
        },
        authenticity_token: csrfToken
      };
      try {
        setIsLoading(true);
        const response = yield fetch(formAction, {
          method: "PATCH",
          mode: "cors",
          cache: "no-cache",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken
          },
          body: JSON.stringify(data)
        });
        if (response.ok) {
          setIsSuccess(true);
        } else {
          if (response.status === 422) {
            const e22 = yield response.json();
            setIsLoading(false);
            setErrors(e22);
          }
        }
      } catch (errors22) {
        console.log(errors22);
        setIsLoading(false);
      }
    }
  });
  const isPasswordError = !isLoading && !!(errors2 == null ? void 0 : errors2.current_password);
  const isEmailError = !isLoading && !!(errors2 == null ? void 0 : errors2.email);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Snackbar2, { isOpen: isSuccess, onClose: () => {
      setIsSuccess(false);
      window.location.reload();
    }, content: i18n._(
      /*i18n*/
      {
        id: "nenSSa"
      }
    ) }),
    /* @__PURE__ */ jsxs(Container, { children: [
      /* @__PURE__ */ jsx(Title, { children: /* @__PURE__ */ jsx(Trans, { id: "Xl7vxL" }) }),
      /* @__PURE__ */ jsx(Subitle, { children: /* @__PURE__ */ jsx(Trans, { id: "/IfJQv" }) })
    ] }),
    /* @__PURE__ */ jsxs("form", { onSubmit: handleSubmit, acceptCharset: "UTF-8", className: "flex flex-col gap-8", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "authenticity_token", value: csrfToken }),
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "_method", value: "patch" }),
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "from_verify_email_page", id: "from_verify_email_page" }),
        /* @__PURE__ */ jsxs(Fieldset, { children: [
          /* @__PURE__ */ jsx(FormLabel, { children: /* @__PURE__ */ jsx(Trans, { id: "TCHTjf" }) }),
          /* @__PURE__ */ jsx(Input, { disabled: true, value: email })
        ] }),
        /* @__PURE__ */ jsxs(Fieldset, { children: [
          /* @__PURE__ */ jsx(FormLabel, { htmlFor: "email", isError: isEmailError || emailFormatInvalid, children: /* @__PURE__ */ jsx(Trans, { id: "xqAzrN" }) }),
          /* @__PURE__ */ jsx(Input, { id: "email", value: emailInput, onBlur: (e2) => {
            setEmailFormatInvalid(!validateEmail(e2.currentTarget.value));
          }, onChange: (e2) => {
            if (errors2 == null ? void 0 : errors2.email) {
              const _a = errors2, {
                email: email2
              } = _a, noEmail = __objRest(_a, [
                // eslint-disable-next-line no-unused-vars
                "email"
              ]);
              setErrors(__spreadValues({}, noEmail));
            }
            setEmailInput(e2.currentTarget.value);
            setIsValid(validatePassword(password) && validateEmail(e2.currentTarget.value));
          }, isError: isEmailError || emailFormatInvalid, name: "user[email]", placeholder: i18n._(
            /*i18n*/
            {
              id: "ELlD6h"
            }
          ) }),
          isEmailError && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "AcnTuz" }) }),
          emailFormatInvalid && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "io0enF" }) })
        ] }),
        /* @__PURE__ */ jsxs(Fieldset, { children: [
          /* @__PURE__ */ jsx(FormLabel, { htmlFor: "password", isError: isPasswordError, children: /* @__PURE__ */ jsx(Trans, { id: "8ZsakT" }) }),
          /* @__PURE__ */ jsx(Input, { id: "password", value: password, onChange: (e2) => {
            if (errors2 == null ? void 0 : errors2.current_password) {
              const _a = errors2, {
                current_password: current_password
              } = _a, noPwd = __objRest(_a, [
                // eslint-disable-next-line no-unused-vars
                "current_password"
              ]);
              setErrors(__spreadValues({}, noPwd));
            }
            setPassword(e2.currentTarget.value);
            setIsValid(validatePassword(e2.currentTarget.value) && validateEmail(emailInput));
          }, type: "password", isError: !!(errors2 == null ? void 0 : errors2.current_password), name: "user[current_password]", placeholder: i18n._(
            /*i18n*/
            {
              id: "NgaR6B"
            }
          ) }),
          isPasswordError && /* @__PURE__ */ jsx(FormError, { children: /* @__PURE__ */ jsx(Trans, { id: "fV2Bu6" }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex gap-4", children: [
        /* @__PURE__ */ jsx(Button, { type: "button", hasBorder: true, onClick: onCancel, children: /* @__PURE__ */ jsx(Trans, { id: "dEgA5A" }) }),
        /* @__PURE__ */ jsx(Button, { isLoading, isDark: true, type: "submit", disabled: !isValid2, children: /* @__PURE__ */ jsx(Trans, { id: "tfDRzk" }) })
      ] })
    ] })
  ] });
};
const verifyEmailSchema = z.object({
  email: z.string(),
  csrfToken: z.string(),
  formAction: z.string(),
  resendUrl: z.string(),
  locale: z.string().optional()
});
const VerifyEmail = (props) => {
  const {
    email,
    csrfToken,
    formAction,
    resendUrl,
    locale = "en"
  } = props;
  const [showForm, setShowForm] = useState(false);
  const [isSent, setIsSent] = useState(false);
  useComponentValidation({
    props,
    schema: verifyEmailSchema
  });
  const handleResend = (e2) => __async(void 0, null, function* () {
    if (!isSent) {
      setIsSent(true);
      e2.preventDefault();
      const data = {
        authenticity_token: csrfToken
      };
      try {
        const response = yield fetch(resendUrl, {
          method: "PATCH",
          mode: "cors",
          cache: "no-cache",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken
          },
          redirect: "follow",
          body: JSON.stringify(data)
        });
        if (response.ok) {
          setIsSent(true);
        }
      } catch (e3) {
        console.log("error");
      }
      setTimeout(() => setIsSent(false), 2e3);
    }
  });
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsx("div", { className: "gap-8 flex flex-col", children: !showForm ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Container, { children: [
      /* @__PURE__ */ jsx(Title, { children: /* @__PURE__ */ jsx(Trans, { id: "/IBv6X" }) }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Subitle, { className: "inline mr-1", children: /* @__PURE__ */ jsx(Trans, { id: "1Ye+/r" }) }),
        /* @__PURE__ */ jsx("strong", { className: "font-medium mb-4 text-xl", children: email })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ jsx(Button, { onClick: handleResend, className: isSent ? "cursor-not-allowed hover:bg-green-50 hover:text-green-700 text-green-700 bg-green-50" : `bg-smokeWhite`, leftIcon: isSent ? /* @__PURE__ */ jsx(Check, {}) : /* @__PURE__ */ jsx(Redo, {}), children: isSent ? /* @__PURE__ */ jsx(Trans, { id: "GD9Rsj" }) : /* @__PURE__ */ jsx(Trans, { id: "MyjAbr" }) }),
      /* @__PURE__ */ jsx(Button, { hasBorder: true, onClick: () => setShowForm(true), children: /* @__PURE__ */ jsx(Trans, { id: "feCRNv" }) })
    ] })
  ] }) : /* @__PURE__ */ jsx(ChangeEmailForm, { formAction, csrfToken, email, onCancel: () => setShowForm(false) }) }) });
};
const sectionSchema = z.object({
  showAll: z.boolean().optional(),
  setShowAll: z.custom().optional(),
  limit: z.number().optional(),
  locale: z.string(),
  itemsLength: z.number().optional(),
  title: z.custom().optional(),
  children: z.custom(),
  subtitle: z.custom().optional(),
  viewMoreOnClick: z.function().optional()
});
const Parent = (props) => {
  const {
    showAll,
    setShowAll,
    itemsLength = 0,
    title,
    subtitle,
    locale,
    limit,
    children,
    viewMoreOnClick
  } = props;
  useComponentValidation({
    props,
    schema: sectionSchema
  });
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-6 flex-1", children: [
    (title || subtitle) && /* @__PURE__ */ jsxs(Container, { gap: "xs", children: [
      title && /* @__PURE__ */ jsx(Title, { fontSize: "md", children: title }),
      subtitle && /* @__PURE__ */ jsx(Subitle, { fontSize: "xs", children: subtitle })
    ] }),
    children,
    (!!viewMoreOnClick || limit && limit < itemsLength) && /* @__PURE__ */ jsx(Button, { onClick: () => {
      if (viewMoreOnClick) {
        viewMoreOnClick();
      } else {
        setShowAll == null ? void 0 : setShowAll(!showAll);
      }
    }, className: "bg-smokeWhite", children: !showAll ? /* @__PURE__ */ jsx(Trans, { id: "N6Pxr9" }) : /* @__PURE__ */ jsx(Trans, { id: "rhJPjn" }) })
  ] }) });
};
const alertListSchema = z.object({
  limit: z.number().optional(),
  locale: z.string(),
  items: itemSchema$2.array()
});
const AlertList = (props) => {
  const {
    locale,
    items,
    limit
  } = props;
  const [showAll, setShowAll] = useState(false);
  useComponentValidation({
    props,
    schema: alertListSchema
  });
  if (items.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(Parent, { limit, showAll, setShowAll, itemsLength: items.length, locale, children: /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-6", children: items.filter((_, key) => {
    return limit && !showAll ? key < limit : true;
  }).map((item) => {
    return /* @__PURE__ */ jsx(Alert, { link: item.link, ctaText: item.ctaText, description: item.description, title: item.title });
  }) }) });
};
const itemSchema$1 = z.object({
  link: z.string(),
  date: z.string(),
  description: z.string(),
  image: z.string(),
  title: z.string()
});
const featuredSchema = z.intersection(itemSchema$1, z.object({
  buttonText: z.custom()
}));
const Featured = (props) => {
  const {
    image,
    title,
    description,
    date: date2,
    buttonText,
    link
  } = props;
  useComponentValidation({
    props,
    schema: featuredSchema
  });
  return /* @__PURE__ */ jsx("div", __spreadProps(__spreadValues({ onClick: () => {
    window.location.href = link;
  }, role: "button", className: "bg-auto sm:bg-cover p-8 min-h-72 sm:col-span-2 rounded-[32px] hover:scale-[1.02] transition-all" }, image ? {
    style: {
      backgroundImage: `url(${image})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center"
    }
  } : {}), { children: /* @__PURE__ */ jsx("div", { className: "sm:w-[46%] flex flex-col items-start flex-1", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-4 w-full flex-1", children: [
    /* @__PURE__ */ jsx("h3", { className: `text-5xl font-semibold text-white`, children: title }),
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("p", { className: "text-white text-xl", children: description }),
      /* @__PURE__ */ jsx("p", { className: "text-white/50 text-xl", children: date2 })
    ] }),
    /* @__PURE__ */ jsx(Button, { className: "bg-white", children: buttonText })
  ] }) }) }));
};
const featuredEmptySchema = z.object({
  locale: z.string()
});
const FeaturedEmpty = (props) => {
  const {
    locale
  } = props;
  useComponentValidation({
    props,
    schema: featuredEmptySchema
  });
  return /* @__PURE__ */ jsx(Parent, { locale, title: /* @__PURE__ */ jsx(Trans, { id: "MLuGvV" }), subtitle: /* @__PURE__ */ jsx(Trans, { id: "1IScCi" }), children: /* @__PURE__ */ jsxs("div", { className: "rounded-2xl flex flex-col py-8 bg-offWhite gap-6", children: [
    /* @__PURE__ */ jsx(Container, { className: "text-center", children: /* @__PURE__ */ jsx(Title, { fontSize: "xs", children: /* @__PURE__ */ jsx(Trans, { id: "UsYcv3" }) }) }),
    /* @__PURE__ */ jsx(Button, { onClick: () => {
      window.location.href = "/token-launches";
    }, hasBorder: true, isFullWidth: false, className: "bg-white w-auto min-w-56 self-center", children: /* @__PURE__ */ jsx(Trans, { id: "Xdajro" }) })
  ] }) });
};
const featuredListSchema = z.object({
  limit: z.number().optional(),
  locale: z.string(),
  items: itemSchema$1.array()
});
const FeaturedList = (props) => {
  const {
    locale,
    items,
    limit
  } = props;
  const [showAll, setShowAll] = useState(false);
  useComponentValidation({
    props,
    schema: featuredListSchema
  });
  if (items.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(Parent, { limit, showAll, setShowAll, itemsLength: items.length, locale, title: /* @__PURE__ */ jsx(Trans, { id: "MLuGvV" }), subtitle: /* @__PURE__ */ jsx(Trans, { id: "1IScCi" }), children: /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-6", children: items.filter((_, key) => {
    return limit && !showAll ? key < limit : true;
  }).map((item) => {
    return /* @__PURE__ */ jsx(Featured, { link: item.link, buttonText: /* @__PURE__ */ jsx(Trans, { id: "jpctdh" }), date: item.date, description: item.description, image: item.image, title: item.title });
  }) }) });
};
const portfolioValueSchema = z.object({
  value: z.string(),
  locale: z.string()
});
const PortfolioValue = (props) => {
  const {
    value,
    locale
  } = props;
  useComponentValidation({
    props,
    schema: portfolioValueSchema
  });
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsxs(CardContainer$1, { hasExtraPadding: true, hoverStyles: "", children: [
    /* @__PURE__ */ jsx("h3", { className: "text-quickSilver text-xl", children: /* @__PURE__ */ jsx(Trans, { id: "MqA4qt" }) }),
    /* @__PURE__ */ jsx("p", { className: "text-black font-bold text-4xl", children: value }),
    /* @__PURE__ */ jsx(Button, { isDark: true, onClick: () => {
      window.location.href = "/wallet_redirect/usdc/deposit";
    }, children: /* @__PURE__ */ jsx(Trans, { id: "BSj/hz" }) }),
    /* @__PURE__ */ jsx(Button, { className: "bg-smokeWhite", onClick: () => {
      window.location.href = "/wallets";
    }, children: /* @__PURE__ */ jsx(Trans, { id: "oarJCB" }) })
  ] }) });
};
const itemSchema = z.object({
  title: z.custom(),
  image: z.string(),
  link: z.string(),
  description: z.custom().optional()
});
const dashboardSchema = z.intersection(itemSchema, z.object({
  isCentered: z.boolean().optional()
}));
const DashboardBlock = (props) => {
  const {
    title,
    description,
    image,
    isCentered,
    link
  } = props;
  useComponentValidation({
    props,
    schema: dashboardSchema
  });
  return /* @__PURE__ */ jsx(CardContainer$1, { onClick: () => {
    window.location.href = link;
  }, rightCol: !isCentered && /* @__PURE__ */ jsx(RightChevron, { fill: "rgba(0, 0, 0, 0.5)" }), className: "cursor-pointer", children: /* @__PURE__ */ jsxs("div", { className: `flex items-center gap-4 ${isCentered ? "flex-col w-full min-h-36 justify-center" : "flex-row w-auto"}`, children: [
    /* @__PURE__ */ jsx("img", { className: "rounded-full w-12 h-12 border-smokeWhite border", src: image }),
    /* @__PURE__ */ jsxs(Container, { gap: "xs", className: isCentered ? "text-center" : "", children: [
      /* @__PURE__ */ jsx(Title, { as: "h3", fontSize: "xs", className: isCentered ? "" : "sm:text-left", children: title }),
      description && /* @__PURE__ */ jsx(Subitle, { fontSize: "xs", className: `hidden sm:block ${isCentered ? "" : "sm:text-left"}`, children: description })
    ] })
  ] }) });
};
const distributionSchema = z.object({
  limit: z.number().optional(),
  locale: z.string(),
  entityId: z.string(),
  title: z.custom(),
  items: z.object({
    unlocked: z.number(),
    symbol: z.string(),
    nextDistribution: z.string(),
    image: z.string(),
    name: z.string(),
    allocation: z.number(),
    totalAllocation: z.number()
  }).array()
});
const DistributionSection = (props) => {
  const {
    title,
    locale,
    limit,
    items,
    entityId
  } = props;
  const [showAll, setShowAll] = useState(false);
  useComponentValidation({
    props,
    schema: distributionSchema
  });
  if (items.length === 0) {
    return null;
  }
  const now2 = /* @__PURE__ */ new Date();
  return /* @__PURE__ */ jsx(Parent, { limit, showAll, setShowAll, itemsLength: 2, locale, title, children: /* @__PURE__ */ jsxs("table", { className: "md:min-w-[500px] border-spacing-x-4", children: [
    /* @__PURE__ */ jsxs("tr", { children: [
      /* @__PURE__ */ jsxs("td", { className: "text-black/[.5] flex items-center gap-1", children: [
        /* @__PURE__ */ jsx(Trans, { id: "TP9/K5" }),
        /* @__PURE__ */ jsx(Popper2, { isDark: true, content: i18n._(
          /*i18n*/
          {
            id: "zX7Mg4"
          }
        ), popperStyle: "mt-1", className: "w-full", children: /* @__PURE__ */ jsx(Info, {}) })
      ] }),
      /* @__PURE__ */ jsx("td", { className: "text-black/[.5] text-right", children: /* @__PURE__ */ jsx(Trans, { id: "Eolc0F" }) }),
      /* @__PURE__ */ jsx("td", { className: "text-black/[.5] text-right hidden md:block", children: /* @__PURE__ */ jsx(Trans, { id: "1ZF9KQ" }) })
    ] }),
    items.filter((_, key) => {
      return limit && !showAll ? key < limit : true;
    }).map((item, key) => {
      const date2 = item.nextDistribution && new Date(item.nextDistribution);
      let diffDays;
      if (date2) {
        const msDifference = date2.getTime() - now2.getTime();
        diffDays = Math.ceil(msDifference / (1e3 * 60 * 60 * 24));
      }
      return /* @__PURE__ */ jsxs("tr", { children: [
        /* @__PURE__ */ jsx("td", { className: "py-4", children: /* @__PURE__ */ jsxs("a", { href: `/${entityId}/wallets/${item.name.toLocaleLowerCase()}`, className: "flex items-center gap-4", children: [
          /* @__PURE__ */ jsx("img", { className: "w-10 h-10 rounded-full", src: item.image }),
          /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ jsx("label", { className: "cursor-pointer text-base", children: item.name }),
            /* @__PURE__ */ jsxs("label", { className: "cursor-pointer text-black/[.5] text-sm", children: [
              item.unlocked.toLocaleString(),
              " / ",
              item.totalAllocation.toLocaleString(),
              " ",
              item.symbol
            ] })
          ] })
        ] }) }),
        /* @__PURE__ */ jsx("td", { className: "py-4 text-right", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ jsxs("label", { className: "text-base", children: [
            item.allocation.toLocaleString(),
            " ",
            item.symbol
          ] }),
          /* @__PURE__ */ jsx("label", { className: "text-black/[.5] text-sm hidden md:block", children: /* @__PURE__ */ jsx(Trans, { id: "NmTvB0", values: {
            0: (item.unlocked / item.totalAllocation * 100).toFixed(2)
          } }) }),
          /* @__PURE__ */ jsx("label", { className: "text-black/[.5] text-sm md:hidden", children: diffDays ? /* @__PURE__ */ jsx(Trans, { id: "pRV3nZ", values: {
            diffDays
          } }) : /* @__PURE__ */ jsx(Trans, { id: "7mDP6a" }) })
        ] }) }),
        /* @__PURE__ */ jsx("td", { className: "py-4 text-right hidden md:block", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ jsx("label", { className: "text-base", children: diffDays ? /* @__PURE__ */ jsx(Trans, { id: "pRV3nZ", values: {
            diffDays
          } }) : /* @__PURE__ */ jsx(Trans, { id: "7mDP6a" }) }),
          date2 && /* @__PURE__ */ jsx("label", { className: "text-black/[.5] text-sm", children: date2.toLocaleString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric"
          }) })
        ] }) })
      ] }, item.name + key);
    })
  ] }) });
};
const activeNowSchema = z.object({
  limit: z.number().optional(),
  locale: z.string(),
  title: z.custom(),
  subtitle: z.custom().optional(),
  hasTwoCols: z.boolean().optional(),
  isCard: z.boolean().optional(),
  items: itemSchema.array(),
  viewMoreOnClick: z.function().optional()
});
const Section = (props) => {
  const {
    items,
    title,
    subtitle,
    hasTwoCols,
    locale,
    limit,
    isCard,
    viewMoreOnClick
  } = props;
  const [showAll, setShowAll] = useState(false);
  useComponentValidation({
    props,
    schema: activeNowSchema
  });
  if (items.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(Parent, { viewMoreOnClick, limit, showAll, setShowAll, itemsLength: items.length, locale, title, subtitle, children: /* @__PURE__ */ jsx("div", { className: isCard ? "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" : hasTwoCols ? "grid grid-cols-1 lg:grid-cols-2 gap-6" : "flex flex-col gap-6", children: items.filter((_, key) => {
    return limit && !showAll ? key < limit : true;
  }).map((item, key) => {
    return /* @__PURE__ */ jsx(DashboardBlock, { isCentered: isCard, description: item.description, link: item.link, image: item.image, title: item.title }, item.link + key);
  }) }) });
};
const menuSchema = z.object({
  locale: z.string(),
  user: z.custom(),
  isBusiness: z.boolean().optional(),
  extraAccounts: z.custom().array().optional(),
  canCreatePersonEntities: z.boolean().optional(),
  setEntityPath: z.string(),
  csrfToken: z.string(),
  onlyEntities: z.boolean().optional()
});
const HeaderMenu = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const {
    user,
    locale,
    extraAccounts,
    isBusiness,
    setEntityPath,
    csrfToken,
    onlyEntities
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const menuButtonRef = useRef(null);
  const menuRef = useRef(null);
  const scrollableRef = useRef(null);
  useComponentValidation({
    props,
    schema: menuSchema
  });
  const handleItemClick = (entity) => () => __async(void 0, null, function* () {
    const data = {
      entity: entity.slug
    };
    yield fetch(setEntityPath, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify(data)
    });
    window.location.href = entity.url;
  });
  const getSelectedEntity = useCallback(() => {
    return extraAccounts == null ? void 0 : extraAccounts.find((entity) => {
      return entity.isSelected;
    });
  }, [extraAccounts]);
  const selectedEntity = getSelectedEntity();
  const menuPosition = ((_a = menuButtonRef == null ? void 0 : menuButtonRef.current) == null ? void 0 : _a.getBoundingClientRect()) && ((_b = menuRef == null ? void 0 : menuRef.current) == null ? void 0 : _b.getBoundingClientRect()) && {
    x: ((_d = (_c = menuButtonRef == null ? void 0 : menuButtonRef.current) == null ? void 0 : _c.getBoundingClientRect()) == null ? void 0 : _d.width) + ((_e = menuButtonRef == null ? void 0 : menuButtonRef.current) == null ? void 0 : _e.getBoundingClientRect().left) - ((_f = menuRef.current) == null ? void 0 : _f.getBoundingClientRect().width),
    y: ((_g = menuButtonRef == null ? void 0 : menuButtonRef.current) == null ? void 0 : _g.getBoundingClientRect().top) + ((_h = menuButtonRef == null ? void 0 : menuButtonRef.current) == null ? void 0 : _h.getBoundingClientRect().height)
  };
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsxs(Dropdown, { open: isOpen, onOpenChange: () => setIsOpen(!isOpen), children: [
    /* @__PURE__ */ jsx(ClickAwayListener, { onClickAway: () => setIsOpen(false), children: /* @__PURE__ */ jsxs(MenuButton2, { ref: menuButtonRef, className: "border", children: [
      /* @__PURE__ */ jsx(Profile, {}),
      (selectedEntity == null ? void 0 : selectedEntity.name) || (user.first_name ? `${user.first_name} ${user.last_name}` : /* @__PURE__ */ jsx(Trans, { id: "AeXO77" })),
      /* @__PURE__ */ jsx(Chevron, { style: {
        transition: "all 0.3s ease-out",
        transform: isOpen ? "rotate(180deg)" : ""
      } })
    ] }) }),
    /* @__PURE__ */ jsxs(Menu, __spreadProps(__spreadValues({ ref: menuRef, slots: {
      listbox: Listbox
    } }, menuPosition ? {
      style: {
        zIndex: 10,
        transform: `translate(${menuPosition.x}px, ${menuPosition.y}px)`
      }
    } : {}), { children: [
      /* @__PURE__ */ jsx("div", { className: "relative", children: /* @__PURE__ */ jsx("div", { className: "max-h-64 overflow-auto", ref: scrollableRef, children: extraAccounts == null ? void 0 : extraAccounts.map((account, key) => {
        const isLastItem = key === extraAccounts.length - 1;
        return /* @__PURE__ */ jsxs(MenuItem3, __spreadProps(__spreadValues({ className: isLastItem ? "border-b-0" : "" }, account.isSelected ? {
          hasBackground: false
        } : {
          as: "a",
          onClick: handleItemClick(account),
          //onTouchStart & onTouchEnd used to differentiate between click and scroll on mobile
          onTouchStart: (e2) => {
            e2.currentTarget.dataset.touchStartY = e2.touches[0].clientY.toString();
          },
          //captures initial touch position
          onTouchEnd: (e2) => {
            const startY = parseFloat(e2.currentTarget.dataset.touchStartY || "0");
            const endY = e2.changedTouches[0].clientY;
            const threshold = 10;
            if (Math.abs(endY - startY) < threshold) {
              e2.preventDefault();
              handleItemClick(account)();
            }
          }
        }), { children: [
          /* @__PURE__ */ jsxs("div", { className: `flex flex-col items-start ${account.isSelected ? "" : "cursor-pointer"} flex-1`, children: [
            /* @__PURE__ */ jsx("span", { className: "font-medium", children: account.name || (key === 0 ? user.email : /* @__PURE__ */ jsx(Trans, { id: "QcyjR1", values: {
              0: key + 1
            } })) }),
            /* @__PURE__ */ jsx("span", { className: "text-sm text-quickSilver", children: key === 0 ? account.name ? user.email : account.type : account.type })
          ] }),
          account.isSelected && extraAccounts.length > 1 && /* @__PURE__ */ jsx(Check, { fill: "black" })
        ] }), account.slug);
      }) }) }),
      isBusiness && !onlyEntities && /* @__PURE__ */ jsx(MenuItem3, { as: "a", href: "/kyc/organization", className: "border-t border-black/10", onTouchStart: () => window.location.href = "/kyc/organization", children: /* @__PURE__ */ jsxs("div", { className: "flex w-full justify-between items-center text-black/[.5] text-sm", children: [
        /* @__PURE__ */ jsx(Trans, { id: "5K91US" }),
        /* @__PURE__ */ jsx(Plus, {})
      ] }) }),
      !onlyEntities && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs(MenuItem3, { as: "a", href: "/account", onTouchStart: () => window.location.href = "/account", children: [
          /* @__PURE__ */ jsx(More, {}),
          /* @__PURE__ */ jsx(Trans, { id: "2FYpfJ" })
        ] }),
        /* @__PURE__ */ jsxs(MenuItem3, { as: "a", href: "/help", onTouchStart: () => window.location.href = "/help", children: [
          /* @__PURE__ */ jsx(Help, {}),
          /* @__PURE__ */ jsx(Trans, { id: "c3XJ18" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(MenuItem3, { as: "a", href: "/logout", className: "text-[#DC2626]", onTouchStart: () => window.location.href = "/logout", children: [
        /* @__PURE__ */ jsx(Logout, {}),
        /* @__PURE__ */ jsx("span", { className: "text-[#DC2626]", children: /* @__PURE__ */ jsx(Trans, { id: "FgAxTj" }) })
      ] })
    ] }))
  ] }) });
};
const Listbox = styled$1("div")(() => `
  box-sizing: border-box;
  margin: 6px 0;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  overflow: auto;
  outline: 0px;
  color: black;
  z-index: 10;
  position:relative;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
  background-color: white;
  min-width: 265px;
  `);
const MenuItem3 = styled$1(MenuItem$2)(({
  hasBackground = true
}) => `
  a {
    cursor:pointer;
  }
  padding: 16px;
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.10);
  align-items:center;
  gap: 8px;
  color: black!important;
  background-color: white;

  &:hover {
    background: ${hasBackground ? "rgba(250, 250, 250, 1)" : ""};
    text-decoration: none
  }
  `);
const MenuButton2 = styled$1(MenuButton$2)(() => `
  box-shadow: unset;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  padding: 10px 12px;
  border-radius: 4px;
  transition: all 150ms ease;
  cursor: pointer;
  background: transparent;
  border: 2px solid #F0F0F0!important;
  color: black!important;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 12px;

  &:hover {
    background: rgba(250, 250, 250, 1);
    color: black;
    text-decoration: none
  }

  &:active {
    background: rgba(250, 250, 250, 1);
    color: black;
  }

  &:focus-visible {
    background: rgba(250, 250, 250, 1);
    color: black;
  }
  `);
const getEvents = (entityId = null, apiUrl) => __async(void 0, null, function* () {
  const response = yield fetch(`${apiUrl}/entities/${entityId}/milestones?milestone_type=time_bounded&status[]=eligible&status[]=claimable&is_featured=false`);
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const data = yield response.json();
  return data;
});
const getFeaturedMilestone = (entityId = null, apiUrl) => __async(void 0, null, function* () {
  const response = yield fetch(`${apiUrl}/entities/${entityId}/milestones?status[]=eligible&status[]=claimable&is_featured=true`);
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const data = yield response.json();
  return data;
});
const getAchievements = (entityId = null, apiUrl) => __async(void 0, null, function* () {
  const response = yield fetch(`${apiUrl}/entities/${entityId}/milestones?milestone_type=milestone&status[]=eligible&status[]=claimable&is_featured=false`);
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const data = yield response.json();
  return data;
});
const getHistory = (entityId = null, apiUrl, limit, lastClaimedOrExpiredAt, lastId = null) => __async(void 0, null, function* () {
  const response = yield fetch(`${apiUrl}/entities/${entityId}/milestones/history?${limit ? `limit=${limit}` : ""}${lastClaimedOrExpiredAt && lastClaimedOrExpiredAt !== "" ? `&last_claimed_or_expired_at=${lastClaimedOrExpiredAt}` : ""}${lastId ? `&last_id=${lastId}` : ""}`);
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const data = yield response.json();
  return data;
});
const claimMilestone = (_0) => __async(void 0, [_0], function* ({
  entityId,
  milestoneId,
  apiUrl,
  csrfToken
}) {
  const response = yield fetch(`${apiUrl}/entities/${entityId}/milestones/${milestoneId}/claim`, __spreadValues({
    method: "POST"
  }, csrfToken ? {
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken
    }
  } : {}));
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  yield response.json();
});
const getTiers = (apiUrl) => __async(void 0, null, function* () {
  const response = yield fetch(`${apiUrl}/tiers`);
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const data = yield response.json();
  return data;
});
const getUser = (entityId = null, apiUrl) => __async(void 0, null, function* () {
  const response = yield fetch(`${apiUrl}/entities/${entityId}`);
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const data = yield response.json();
  return data;
});
const Context = createContext({
  entityId: "",
  apiUrl: "",
  csrfToken: "",
  refreshKarma: () => {
  },
  isRefetched: false,
  amplitudeEvent: () => {
  }
});
var __assign = function() {
  __assign = Object.assign || function __assign2(t2) {
    for (var s2, i = 1, n2 = arguments.length; i < n2; i++) {
      s2 = arguments[i];
      for (var p in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p))
          t2[p] = s2[p];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e2 = new Error(message);
  return e2.name = "SuppressedError", e2.error = error, e2.suppressed = suppressed, e2;
};
const MotionConfigContext$1 = createContext({
  transformPagePoint: (p) => p,
  isStatic: false,
  reducedMotion: "never"
});
const MotionContext$1 = createContext({});
const PresenceContext$1 = createContext(null);
const isBrowser$1 = typeof document !== "undefined";
const useIsomorphicLayoutEffect$1 = isBrowser$1 ? useLayoutEffect : useEffect;
const LazyContext$1 = createContext({ strict: false });
const camelToDash$1 = (str) => str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
const optimizedAppearDataId$1 = "framerAppearId";
const optimizedAppearDataAttribute$1 = "data-" + camelToDash$1(optimizedAppearDataId$1);
function useVisualElement$1(Component2, visualState, props, createVisualElement) {
  const { visualElement: parent } = useContext(MotionContext$1);
  const lazyContext = useContext(LazyContext$1);
  const presenceContext = useContext(PresenceContext$1);
  const reducedMotionConfig = useContext(MotionConfigContext$1).reducedMotion;
  const visualElementRef = useRef();
  createVisualElement = createVisualElement || lazyContext.renderer;
  if (!visualElementRef.current && createVisualElement) {
    visualElementRef.current = createVisualElement(Component2, {
      visualState,
      parent,
      props,
      presenceContext,
      blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
      reducedMotionConfig
    });
  }
  const visualElement = visualElementRef.current;
  useInsertionEffect$1(() => {
    visualElement && visualElement.update(props, presenceContext);
  });
  const wantsHandoff = useRef(Boolean(props[optimizedAppearDataAttribute$1] && !window.HandoffComplete));
  useIsomorphicLayoutEffect$1(() => {
    if (!visualElement)
      return;
    visualElement.render();
    if (wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
  });
  useEffect(() => {
    if (!visualElement)
      return;
    visualElement.updateFeatures();
    if (!wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
    if (wantsHandoff.current) {
      wantsHandoff.current = false;
      window.HandoffComplete = true;
    }
  });
  return visualElement;
}
function isRefObject$1(ref) {
  return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}
function useMotionRef$1(visualState, visualElement, externalRef) {
  return useCallback(
    (instance) => {
      instance && visualState.mount && visualState.mount(instance);
      if (visualElement) {
        instance ? visualElement.mount(instance) : visualElement.unmount();
      }
      if (externalRef) {
        if (typeof externalRef === "function") {
          externalRef(instance);
        } else if (isRefObject$1(externalRef)) {
          externalRef.current = instance;
        }
      }
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]
  );
}
function isVariantLabel$1(v) {
  return typeof v === "string" || Array.isArray(v);
}
function isAnimationControls$1(v) {
  return v !== null && typeof v === "object" && typeof v.start === "function";
}
const variantPriorityOrder$1 = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
];
const variantProps$1 = ["initial", ...variantPriorityOrder$1];
function isControllingVariants$1(props) {
  return isAnimationControls$1(props.animate) || variantProps$1.some((name) => isVariantLabel$1(props[name]));
}
function isVariantNode$1(props) {
  return Boolean(isControllingVariants$1(props) || props.variants);
}
function getCurrentTreeVariants$1(props, context) {
  if (isControllingVariants$1(props)) {
    const { initial, animate } = props;
    return {
      initial: initial === false || isVariantLabel$1(initial) ? initial : void 0,
      animate: isVariantLabel$1(animate) ? animate : void 0
    };
  }
  return props.inherit !== false ? context : {};
}
function useCreateMotionContext$1(props) {
  const { initial, animate } = getCurrentTreeVariants$1(props, useContext(MotionContext$1));
  return useMemo(() => ({ initial, animate }), [variantLabelsAsDependency$1(initial), variantLabelsAsDependency$1(animate)]);
}
function variantLabelsAsDependency$1(prop) {
  return Array.isArray(prop) ? prop.join(" ") : prop;
}
const featureProps$1 = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
const featureDefinitions$1 = {};
for (const key in featureProps$1) {
  featureDefinitions$1[key] = {
    isEnabled: (props) => featureProps$1[key].some((name) => !!props[name])
  };
}
function loadFeatures$1(features) {
  for (const key in features) {
    featureDefinitions$1[key] = __spreadValues(__spreadValues({}, featureDefinitions$1[key]), features[key]);
  }
}
const LayoutGroupContext$1 = createContext({});
const SwitchLayoutGroupContext$1 = createContext({});
const motionComponentSymbol$1 = Symbol.for("motionComponentSymbol");
function createMotionComponent$1({ preloadedFeatures: preloadedFeatures2, createVisualElement, useRender, useVisualState, Component: Component2 }) {
  preloadedFeatures2 && loadFeatures$1(preloadedFeatures2);
  function MotionComponent(props, externalRef) {
    let MeasureLayout2;
    const configAndProps = __spreadProps(__spreadValues(__spreadValues({}, useContext(MotionConfigContext$1)), props), {
      layoutId: useLayoutId$1(props)
    });
    const { isStatic } = configAndProps;
    const context = useCreateMotionContext$1(props);
    const visualState = useVisualState(props, isStatic);
    if (!isStatic && isBrowser$1) {
      context.visualElement = useVisualElement$1(Component2, visualState, configAndProps, createVisualElement);
      const initialLayoutGroupConfig = useContext(SwitchLayoutGroupContext$1);
      const isStrict = useContext(LazyContext$1).strict;
      if (context.visualElement) {
        MeasureLayout2 = context.visualElement.loadFeatures(
          // Note: Pass the full new combined props to correctly re-render dynamic feature components.
          configAndProps,
          isStrict,
          preloadedFeatures2,
          initialLayoutGroupConfig
        );
      }
    }
    return React.createElement(
      MotionContext$1.Provider,
      { value: context },
      MeasureLayout2 && context.visualElement ? React.createElement(MeasureLayout2, __spreadValues({ visualElement: context.visualElement }, configAndProps)) : null,
      useRender(Component2, props, useMotionRef$1(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
    );
  }
  const ForwardRefComponent = forwardRef(MotionComponent);
  ForwardRefComponent[motionComponentSymbol$1] = Component2;
  return ForwardRefComponent;
}
function useLayoutId$1({ layoutId }) {
  const layoutGroupId = useContext(LayoutGroupContext$1).id;
  return layoutGroupId && layoutId !== void 0 ? layoutGroupId + "-" + layoutId : layoutId;
}
function createMotionProxy(createConfig) {
  function custom2(Component2, customMotionComponentConfig = {}) {
    return createMotionComponent$1(createConfig(Component2, customMotionComponentConfig));
  }
  if (typeof Proxy === "undefined") {
    return custom2;
  }
  const componentCache = /* @__PURE__ */ new Map();
  return new Proxy(custom2, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (_target, key) => {
      if (!componentCache.has(key)) {
        componentCache.set(key, custom2(key));
      }
      return componentCache.get(key);
    }
  });
}
const lowercaseSVGElements$1 = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function isSVGComponent$1(Component2) {
  if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component2 !== "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    Component2.includes("-")
  ) {
    return false;
  } else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements$1.indexOf(Component2) > -1 || /**
     * If it contains a capital letter, it's an SVG component
     */
    /[A-Z]/.test(Component2)
  ) {
    return true;
  }
  return false;
}
const scaleCorrectors$1 = {};
function addScaleCorrector$1(correctors) {
  Object.assign(scaleCorrectors$1, correctors);
}
const transformPropOrder$1 = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
];
const transformProps$1 = new Set(transformPropOrder$1);
function isForcedMotionValue$1(key, { layout: layout2, layoutId }) {
  return transformProps$1.has(key) || key.startsWith("origin") || (layout2 || layoutId !== void 0) && (!!scaleCorrectors$1[key] || key === "opacity");
}
const isMotionValue$1 = (value) => Boolean(value && value.getVelocity);
const translateAlias$1 = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
const numTransforms$1 = transformPropOrder$1.length;
function buildTransform$1(transform, { enableHardwareAcceleration = true, allowTransformNone = true }, transformIsDefault, transformTemplate) {
  let transformString = "";
  for (let i = 0; i < numTransforms$1; i++) {
    const key = transformPropOrder$1[i];
    if (transform[key] !== void 0) {
      const transformName = translateAlias$1[key] || key;
      transformString += `${transformName}(${transform[key]}) `;
    }
  }
  if (enableHardwareAcceleration && !transform.z) {
    transformString += "translateZ(0)";
  }
  transformString = transformString.trim();
  if (transformTemplate) {
    transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
  } else if (allowTransformNone && transformIsDefault) {
    transformString = "none";
  }
  return transformString;
}
const checkStringStartsWith$1 = (token2) => (key) => typeof key === "string" && key.startsWith(token2);
const isCSSVariableName$1 = checkStringStartsWith$1("--");
const isCSSVariableToken$1 = checkStringStartsWith$1("var(--");
const cssVariableRegex = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;
const getValueAsType$1 = (value, type) => {
  return type && typeof value === "number" ? type.transform(value) : value;
};
const clamp$1 = (min2, max2, v) => Math.min(Math.max(v, min2), max2);
const number$1 = {
  test: (v) => typeof v === "number",
  parse: parseFloat,
  transform: (v) => v
};
const alpha$1 = __spreadProps(__spreadValues({}, number$1), {
  transform: (v) => clamp$1(0, 1, v)
});
const scale$1 = __spreadProps(__spreadValues({}, number$1), {
  default: 1
});
const sanitize$1 = (v) => Math.round(v * 1e5) / 1e5;
const floatRegex$1 = /(-)?([\d]*\.?[\d])+/g;
const colorRegex$1 = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const singleColorRegex$1 = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function isString$1(v) {
  return typeof v === "string";
}
const createUnitType$1 = (unit) => ({
  test: (v) => isString$1(v) && v.endsWith(unit) && v.split(" ").length === 1,
  parse: parseFloat,
  transform: (v) => `${v}${unit}`
});
const degrees$1 = createUnitType$1("deg");
const percent$1 = createUnitType$1("%");
const px$1 = createUnitType$1("px");
const vh$1 = createUnitType$1("vh");
const vw$1 = createUnitType$1("vw");
const progressPercentage$1 = __spreadProps(__spreadValues({}, percent$1), {
  parse: (v) => percent$1.parse(v) / 100,
  transform: (v) => percent$1.transform(v * 100)
});
const int$1 = __spreadProps(__spreadValues({}, number$1), {
  transform: Math.round
});
const numberValueTypes$1 = {
  // Border props
  borderWidth: px$1,
  borderTopWidth: px$1,
  borderRightWidth: px$1,
  borderBottomWidth: px$1,
  borderLeftWidth: px$1,
  borderRadius: px$1,
  radius: px$1,
  borderTopLeftRadius: px$1,
  borderTopRightRadius: px$1,
  borderBottomRightRadius: px$1,
  borderBottomLeftRadius: px$1,
  // Positioning props
  width: px$1,
  maxWidth: px$1,
  height: px$1,
  maxHeight: px$1,
  size: px$1,
  top: px$1,
  right: px$1,
  bottom: px$1,
  left: px$1,
  // Spacing props
  padding: px$1,
  paddingTop: px$1,
  paddingRight: px$1,
  paddingBottom: px$1,
  paddingLeft: px$1,
  margin: px$1,
  marginTop: px$1,
  marginRight: px$1,
  marginBottom: px$1,
  marginLeft: px$1,
  // Transform props
  rotate: degrees$1,
  rotateX: degrees$1,
  rotateY: degrees$1,
  rotateZ: degrees$1,
  scale: scale$1,
  scaleX: scale$1,
  scaleY: scale$1,
  scaleZ: scale$1,
  skew: degrees$1,
  skewX: degrees$1,
  skewY: degrees$1,
  distance: px$1,
  translateX: px$1,
  translateY: px$1,
  translateZ: px$1,
  x: px$1,
  y: px$1,
  z: px$1,
  perspective: px$1,
  transformPerspective: px$1,
  opacity: alpha$1,
  originX: progressPercentage$1,
  originY: progressPercentage$1,
  originZ: px$1,
  // Misc
  zIndex: int$1,
  // SVG
  fillOpacity: alpha$1,
  strokeOpacity: alpha$1,
  numOctaves: int$1
};
function buildHTMLStyles$1(state, latestValues, options, transformTemplate) {
  const { style: style2, vars, transform, transformOrigin } = state;
  let hasTransform2 = false;
  let hasTransformOrigin = false;
  let transformIsNone = true;
  for (const key in latestValues) {
    const value = latestValues[key];
    if (isCSSVariableName$1(key)) {
      vars[key] = value;
      continue;
    }
    const valueType = numberValueTypes$1[key];
    const valueAsType = getValueAsType$1(value, valueType);
    if (transformProps$1.has(key)) {
      hasTransform2 = true;
      transform[key] = valueAsType;
      if (!transformIsNone)
        continue;
      if (value !== (valueType.default || 0))
        transformIsNone = false;
    } else if (key.startsWith("origin")) {
      hasTransformOrigin = true;
      transformOrigin[key] = valueAsType;
    } else {
      style2[key] = valueAsType;
    }
  }
  if (!latestValues.transform) {
    if (hasTransform2 || transformTemplate) {
      style2.transform = buildTransform$1(state.transform, options, transformIsNone, transformTemplate);
    } else if (style2.transform) {
      style2.transform = "none";
    }
  }
  if (hasTransformOrigin) {
    const { originX = "50%", originY = "50%", originZ = 0 } = transformOrigin;
    style2.transformOrigin = `${originX} ${originY} ${originZ}`;
  }
}
const createHtmlRenderState$1 = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function copyRawValuesOnly$1(target, source, props) {
  for (const key in source) {
    if (!isMotionValue$1(source[key]) && !isForcedMotionValue$1(key, props)) {
      target[key] = source[key];
    }
  }
}
function useInitialMotionValues$1({ transformTemplate }, visualState, isStatic) {
  return useMemo(() => {
    const state = createHtmlRenderState$1();
    buildHTMLStyles$1(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
    return Object.assign({}, state.vars, state.style);
  }, [visualState]);
}
function useStyle$1(props, visualState, isStatic) {
  const styleProp = props.style || {};
  const style2 = {};
  copyRawValuesOnly$1(style2, styleProp, props);
  Object.assign(style2, useInitialMotionValues$1(props, visualState, isStatic));
  return props.transformValues ? props.transformValues(style2) : style2;
}
function useHTMLProps$1(props, visualState, isStatic) {
  const htmlProps = {};
  const style2 = useStyle$1(props, visualState, isStatic);
  if (props.drag && props.dragListener !== false) {
    htmlProps.draggable = false;
    style2.userSelect = style2.WebkitUserSelect = style2.WebkitTouchCallout = "none";
    style2.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
  }
  if (props.tabIndex === void 0 && (props.onTap || props.onTapStart || props.whileTap)) {
    htmlProps.tabIndex = 0;
  }
  htmlProps.style = style2;
  return htmlProps;
}
const validMotionProps$1 = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function isValidMotionProp$1(key) {
  return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || validMotionProps$1.has(key);
}
let shouldForward$1 = (key) => !isValidMotionProp$1(key);
function loadExternalIsValidProp$1(isValidProp) {
  if (!isValidProp)
    return;
  shouldForward$1 = (key) => key.startsWith("on") ? !isValidMotionProp$1(key) : isValidProp(key);
}
try {
  loadExternalIsValidProp$1(require("@emotion/is-prop-valid").default);
} catch (_a) {
}
function filterProps$1(props, isDom, forwardMotionProps) {
  const filteredProps = {};
  for (const key in props) {
    if (key === "values" && typeof props.values === "object")
      continue;
    if (shouldForward$1(key) || forwardMotionProps === true && isValidMotionProp$1(key) || !isDom && !isValidMotionProp$1(key) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) {
      filteredProps[key] = props[key];
    }
  }
  return filteredProps;
}
function calcOrigin$3(origin, offset2, size) {
  return typeof origin === "string" ? origin : px$1.transform(offset2 + size * origin);
}
function calcSVGTransformOrigin$1(dimensions, originX, originY) {
  const pxOriginX = calcOrigin$3(originX, dimensions.x, dimensions.width);
  const pxOriginY = calcOrigin$3(originY, dimensions.y, dimensions.height);
  return `${pxOriginX} ${pxOriginY}`;
}
const dashKeys$1 = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
};
const camelKeys$1 = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath$1(attrs, length2, spacing = 1, offset2 = 0, useDashCase = true) {
  attrs.pathLength = 1;
  const keys = useDashCase ? dashKeys$1 : camelKeys$1;
  attrs[keys.offset] = px$1.transform(-offset2);
  const pathLength = px$1.transform(length2);
  const pathSpacing = px$1.transform(spacing);
  attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}
function buildSVGAttrs$1(state, _W, options, isSVGTag2, transformTemplate) {
  var _X = _W, {
    attrX,
    attrY,
    attrScale,
    originX,
    originY,
    pathLength,
    pathSpacing = 1,
    pathOffset = 0
  } = _X, latest = __objRest(_X, [
    "attrX",
    "attrY",
    "attrScale",
    "originX",
    "originY",
    "pathLength",
    "pathSpacing",
    "pathOffset"
  ]);
  buildHTMLStyles$1(state, latest, options, transformTemplate);
  if (isSVGTag2) {
    if (state.style.viewBox) {
      state.attrs.viewBox = state.style.viewBox;
    }
    return;
  }
  state.attrs = state.style;
  state.style = {};
  const { attrs, style: style2, dimensions } = state;
  if (attrs.transform) {
    if (dimensions)
      style2.transform = attrs.transform;
    delete attrs.transform;
  }
  if (dimensions && (originX !== void 0 || originY !== void 0 || style2.transform)) {
    style2.transformOrigin = calcSVGTransformOrigin$1(dimensions, originX !== void 0 ? originX : 0.5, originY !== void 0 ? originY : 0.5);
  }
  if (attrX !== void 0)
    attrs.x = attrX;
  if (attrY !== void 0)
    attrs.y = attrY;
  if (attrScale !== void 0)
    attrs.scale = attrScale;
  if (pathLength !== void 0) {
    buildSVGPath$1(attrs, pathLength, pathSpacing, pathOffset, false);
  }
}
const createSvgRenderState$1 = () => __spreadProps(__spreadValues({}, createHtmlRenderState$1()), {
  attrs: {}
});
const isSVGTag$1 = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";
function useSVGProps$1(props, visualState, _isStatic, Component2) {
  const visualProps = useMemo(() => {
    const state = createSvgRenderState$1();
    buildSVGAttrs$1(state, visualState, { enableHardwareAcceleration: false }, isSVGTag$1(Component2), props.transformTemplate);
    return __spreadProps(__spreadValues({}, state.attrs), {
      style: __spreadValues({}, state.style)
    });
  }, [visualState]);
  if (props.style) {
    const rawStyles = {};
    copyRawValuesOnly$1(rawStyles, props.style, props);
    visualProps.style = __spreadValues(__spreadValues({}, rawStyles), visualProps.style);
  }
  return visualProps;
}
function createUseRender$1(forwardMotionProps = false) {
  const useRender = (Component2, props, ref, { latestValues }, isStatic) => {
    const useVisualProps = isSVGComponent$1(Component2) ? useSVGProps$1 : useHTMLProps$1;
    const visualProps = useVisualProps(props, latestValues, isStatic, Component2);
    const filteredProps = filterProps$1(props, typeof Component2 === "string", forwardMotionProps);
    const elementProps = __spreadProps(__spreadValues(__spreadValues({}, filteredProps), visualProps), {
      ref
    });
    const { children } = props;
    const renderedChildren = useMemo(() => isMotionValue$1(children) ? children.get() : children, [children]);
    return createElement(Component2, __spreadProps(__spreadValues({}, elementProps), {
      children: renderedChildren
    }));
  };
  return useRender;
}
function renderHTML$1(element, { style: style2, vars }, styleProp, projection) {
  Object.assign(element.style, style2, projection && projection.getProjectionStyles(styleProp));
  for (const key in vars) {
    element.style.setProperty(key, vars[key]);
  }
}
const camelCaseAttributes$1 = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function renderSVG$1(element, renderState, _styleProp, projection) {
  renderHTML$1(element, renderState, void 0, projection);
  for (const key in renderState.attrs) {
    element.setAttribute(!camelCaseAttributes$1.has(key) ? camelToDash$1(key) : key, renderState.attrs[key]);
  }
}
function scrapeMotionValuesFromProps$3(props, prevProps) {
  const { style: style2 } = props;
  const newValues = {};
  for (const key in style2) {
    if (isMotionValue$1(style2[key]) || prevProps.style && isMotionValue$1(prevProps.style[key]) || isForcedMotionValue$1(key, props)) {
      newValues[key] = style2[key];
    }
  }
  return newValues;
}
function scrapeMotionValuesFromProps$2(props, prevProps) {
  const newValues = scrapeMotionValuesFromProps$3(props, prevProps);
  for (const key in props) {
    if (isMotionValue$1(props[key]) || isMotionValue$1(prevProps[key])) {
      const targetKey = transformPropOrder$1.indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
      newValues[targetKey] = props[key];
    }
  }
  return newValues;
}
function resolveVariantFromProps$1(props, definition, custom2, currentValues = {}, currentVelocity = {}) {
  if (typeof definition === "function") {
    definition = definition(custom2 !== void 0 ? custom2 : props.custom, currentValues, currentVelocity);
  }
  if (typeof definition === "string") {
    definition = props.variants && props.variants[definition];
  }
  if (typeof definition === "function") {
    definition = definition(custom2 !== void 0 ? custom2 : props.custom, currentValues, currentVelocity);
  }
  return definition;
}
function useConstant$1(init2) {
  const ref = useRef(null);
  if (ref.current === null) {
    ref.current = init2();
  }
  return ref.current;
}
const isKeyframesTarget$1 = (v) => {
  return Array.isArray(v);
};
const isCustomValue$1 = (v) => {
  return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const resolveFinalValueInKeyframes$1 = (v) => {
  return isKeyframesTarget$1(v) ? v[v.length - 1] || 0 : v;
};
function resolveMotionValue$1(value) {
  const unwrappedValue = isMotionValue$1(value) ? value.get() : value;
  return isCustomValue$1(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}
function makeState$1({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps2, createRenderState, onMount }, props, context, presenceContext) {
  const state = {
    latestValues: makeLatestValues$1(props, context, presenceContext, scrapeMotionValuesFromProps2),
    renderState: createRenderState()
  };
  if (onMount) {
    state.mount = (instance) => onMount(props, instance, state);
  }
  return state;
}
const makeUseVisualState$1 = (config2) => (props, isStatic) => {
  const context = useContext(MotionContext$1);
  const presenceContext = useContext(PresenceContext$1);
  const make = () => makeState$1(config2, props, context, presenceContext);
  return isStatic ? make() : useConstant$1(make);
};
function makeLatestValues$1(props, context, presenceContext, scrapeMotionValues) {
  const values2 = {};
  const motionValues = scrapeMotionValues(props, {});
  for (const key in motionValues) {
    values2[key] = resolveMotionValue$1(motionValues[key]);
  }
  let { initial, animate } = props;
  const isControllingVariants$1$1 = isControllingVariants$1(props);
  const isVariantNode$1$1 = isVariantNode$1(props);
  if (context && isVariantNode$1$1 && !isControllingVariants$1$1 && props.inherit !== false) {
    if (initial === void 0)
      initial = context.initial;
    if (animate === void 0)
      animate = context.animate;
  }
  let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
  isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
  const variantToSet = isInitialAnimationBlocked ? animate : initial;
  if (variantToSet && typeof variantToSet !== "boolean" && !isAnimationControls$1(variantToSet)) {
    const list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
    list.forEach((definition) => {
      const resolved = resolveVariantFromProps$1(props, definition);
      if (!resolved)
        return;
      const _a = resolved, { transitionEnd, transition } = _a, target = __objRest(_a, ["transitionEnd", "transition"]);
      for (const key in target) {
        let valueTarget = target[key];
        if (Array.isArray(valueTarget)) {
          const index2 = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
          valueTarget = valueTarget[index2];
        }
        if (valueTarget !== null) {
          values2[key] = valueTarget;
        }
      }
      for (const key in transitionEnd)
        values2[key] = transitionEnd[key];
    });
  }
  return values2;
}
const noop$1 = (any) => any;
class Queue {
  constructor() {
    this.order = [];
    this.scheduled = /* @__PURE__ */ new Set();
  }
  add(process2) {
    if (!this.scheduled.has(process2)) {
      this.scheduled.add(process2);
      this.order.push(process2);
      return true;
    }
  }
  remove(process2) {
    const index2 = this.order.indexOf(process2);
    if (index2 !== -1) {
      this.order.splice(index2, 1);
      this.scheduled.delete(process2);
    }
  }
  clear() {
    this.order.length = 0;
    this.scheduled.clear();
  }
}
function createRenderStep$1(runNextFrame) {
  let thisFrame = new Queue();
  let nextFrame = new Queue();
  let numToRun = 0;
  let isProcessing = false;
  let flushNextFrame = false;
  const toKeepAlive = /* @__PURE__ */ new WeakSet();
  const step = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (callback, keepAlive = false, immediate = false) => {
      const addToCurrentFrame = immediate && isProcessing;
      const queue = addToCurrentFrame ? thisFrame : nextFrame;
      if (keepAlive)
        toKeepAlive.add(callback);
      if (queue.add(callback) && addToCurrentFrame && isProcessing) {
        numToRun = thisFrame.order.length;
      }
      return callback;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (callback) => {
      nextFrame.remove(callback);
      toKeepAlive.delete(callback);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (frameData2) => {
      if (isProcessing) {
        flushNextFrame = true;
        return;
      }
      isProcessing = true;
      [thisFrame, nextFrame] = [nextFrame, thisFrame];
      nextFrame.clear();
      numToRun = thisFrame.order.length;
      if (numToRun) {
        for (let i = 0; i < numToRun; i++) {
          const callback = thisFrame.order[i];
          callback(frameData2);
          if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
          }
        }
      }
      isProcessing = false;
      if (flushNextFrame) {
        flushNextFrame = false;
        step.process(frameData2);
      }
    }
  };
  return step;
}
const stepsOrder$1 = [
  "prepare",
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
];
const maxElapsed$1 = 40;
function createRenderBatcher$1(scheduleNextBatch, allowKeepAlive) {
  let runNextFrame = false;
  let useDefaultElapsed = true;
  const state = {
    delta: 0,
    timestamp: 0,
    isProcessing: false
  };
  const steps2 = stepsOrder$1.reduce((acc, key) => {
    acc[key] = createRenderStep$1(() => runNextFrame = true);
    return acc;
  }, {});
  const processStep = (stepId) => steps2[stepId].process(state);
  const processBatch = () => {
    const timestamp = performance.now();
    runNextFrame = false;
    state.delta = useDefaultElapsed ? 1e3 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed$1), 1);
    state.timestamp = timestamp;
    state.isProcessing = true;
    stepsOrder$1.forEach(processStep);
    state.isProcessing = false;
    if (runNextFrame && allowKeepAlive) {
      useDefaultElapsed = false;
      scheduleNextBatch(processBatch);
    }
  };
  const wake = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!state.isProcessing) {
      scheduleNextBatch(processBatch);
    }
  };
  const schedule = stepsOrder$1.reduce((acc, key) => {
    const step = steps2[key];
    acc[key] = (process2, keepAlive = false, immediate = false) => {
      if (!runNextFrame)
        wake();
      return step.schedule(process2, keepAlive, immediate);
    };
    return acc;
  }, {});
  const cancel = (process2) => stepsOrder$1.forEach((key) => steps2[key].cancel(process2));
  return { schedule, cancel, state, steps: steps2 };
}
const { schedule: frame$1, cancel: cancelFrame$1, state: frameData$1, steps: steps$1 } = createRenderBatcher$1(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop$1, true);
const svgMotionConfig$1 = {
  useVisualState: makeUseVisualState$1({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$2,
    createRenderState: createSvgRenderState$1,
    onMount: (props, instance, { renderState, latestValues }) => {
      frame$1.read(() => {
        try {
          renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
        } catch (e2) {
          renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      });
      frame$1.render(() => {
        buildSVGAttrs$1(renderState, latestValues, { enableHardwareAcceleration: false }, isSVGTag$1(instance.tagName), props.transformTemplate);
        renderSVG$1(instance, renderState);
      });
    }
  })
};
const htmlMotionConfig$1 = {
  useVisualState: makeUseVisualState$1({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$3,
    createRenderState: createHtmlRenderState$1
  })
};
function createDomMotionConfig(Component2, { forwardMotionProps = false }, preloadedFeatures2, createVisualElement) {
  const baseConfig = isSVGComponent$1(Component2) ? svgMotionConfig$1 : htmlMotionConfig$1;
  return __spreadProps(__spreadValues({}, baseConfig), {
    preloadedFeatures: preloadedFeatures2,
    useRender: createUseRender$1(forwardMotionProps),
    createVisualElement,
    Component: Component2
  });
}
function addDomEvent$1(target, eventName, handler, options = { passive: true }) {
  target.addEventListener(eventName, handler, options);
  return () => target.removeEventListener(eventName, handler);
}
const isPrimaryPointer$1 = (event) => {
  if (event.pointerType === "mouse") {
    return typeof event.button !== "number" || event.button <= 0;
  } else {
    return event.isPrimary !== false;
  }
};
function extractEventInfo$1(event, pointType = "page") {
  return {
    point: {
      x: event[pointType + "X"],
      y: event[pointType + "Y"]
    }
  };
}
const addPointerInfo$1 = (handler) => {
  return (event) => isPrimaryPointer$1(event) && handler(event, extractEventInfo$1(event));
};
function addPointerEvent$1(target, eventName, handler, options) {
  return addDomEvent$1(target, eventName, addPointerInfo$1(handler), options);
}
const combineFunctions$1 = (a2, b) => (v) => b(a2(v));
const pipe$1 = (...transformers) => transformers.reduce(combineFunctions$1);
function createLock$1(name) {
  let lock = null;
  return () => {
    const openLock = () => {
      lock = null;
    };
    if (lock === null) {
      lock = name;
      return openLock;
    }
    return false;
  };
}
const globalHorizontalLock$1 = createLock$1("dragHorizontal");
const globalVerticalLock$1 = createLock$1("dragVertical");
function getGlobalLock$1(drag2) {
  let lock = false;
  if (drag2 === "y") {
    lock = globalVerticalLock$1();
  } else if (drag2 === "x") {
    lock = globalHorizontalLock$1();
  } else {
    const openHorizontal = globalHorizontalLock$1();
    const openVertical = globalVerticalLock$1();
    if (openHorizontal && openVertical) {
      lock = () => {
        openHorizontal();
        openVertical();
      };
    } else {
      if (openHorizontal)
        openHorizontal();
      if (openVertical)
        openVertical();
    }
  }
  return lock;
}
function isDragActive$1() {
  const openGestureLock = getGlobalLock$1(true);
  if (!openGestureLock)
    return true;
  openGestureLock();
  return false;
}
let Feature$1 = class Feature {
  constructor(node2) {
    this.isMounted = false;
    this.node = node2;
  }
  update() {
  }
};
function addHoverEvent$1(node2, isActive) {
  const eventName = "pointer" + (isActive ? "enter" : "leave");
  const callbackName = "onHover" + (isActive ? "Start" : "End");
  const handleEvent = (event, info) => {
    if (event.pointerType === "touch" || isDragActive$1())
      return;
    const props = node2.getProps();
    if (node2.animationState && props.whileHover) {
      node2.animationState.setActive("whileHover", isActive);
    }
    if (props[callbackName]) {
      frame$1.update(() => props[callbackName](event, info));
    }
  };
  return addPointerEvent$1(node2.current, eventName, handleEvent, {
    passive: !node2.getProps()[callbackName]
  });
}
let HoverGesture$1 = class HoverGesture extends Feature$1 {
  mount() {
    this.unmount = pipe$1(addHoverEvent$1(this.node, true), addHoverEvent$1(this.node, false));
  }
  unmount() {
  }
};
let FocusGesture$1 = class FocusGesture extends Feature$1 {
  constructor() {
    super(...arguments);
    this.isActive = false;
  }
  onFocus() {
    let isFocusVisible2 = false;
    try {
      isFocusVisible2 = this.node.current.matches(":focus-visible");
    } catch (e2) {
      isFocusVisible2 = true;
    }
    if (!isFocusVisible2 || !this.node.animationState)
      return;
    this.node.animationState.setActive("whileFocus", true);
    this.isActive = true;
  }
  onBlur() {
    if (!this.isActive || !this.node.animationState)
      return;
    this.node.animationState.setActive("whileFocus", false);
    this.isActive = false;
  }
  mount() {
    this.unmount = pipe$1(addDomEvent$1(this.node.current, "focus", () => this.onFocus()), addDomEvent$1(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
};
const isNodeOrChild$1 = (parent, child) => {
  if (!child) {
    return false;
  } else if (parent === child) {
    return true;
  } else {
    return isNodeOrChild$1(parent, child.parentElement);
  }
};
function fireSyntheticPointerEvent$1(name, handler) {
  if (!handler)
    return;
  const syntheticPointerEvent = new PointerEvent("pointer" + name);
  handler(syntheticPointerEvent, extractEventInfo$1(syntheticPointerEvent));
}
let PressGesture$1 = class PressGesture extends Feature$1 {
  constructor() {
    super(...arguments);
    this.removeStartListeners = noop$1;
    this.removeEndListeners = noop$1;
    this.removeAccessibleListeners = noop$1;
    this.startPointerPress = (startEvent, startInfo) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const props = this.node.getProps();
      const endPointerPress = (endEvent, endInfo) => {
        if (!this.checkPressEnd())
          return;
        const { onTap, onTapCancel, globalTapTarget } = this.node.getProps();
        frame$1.update(() => {
          !globalTapTarget && !isNodeOrChild$1(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
        });
      };
      const removePointerUpListener = addPointerEvent$1(window, "pointerup", endPointerPress, { passive: !(props.onTap || props["onPointerUp"]) });
      const removePointerCancelListener = addPointerEvent$1(window, "pointercancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo), { passive: !(props.onTapCancel || props["onPointerCancel"]) });
      this.removeEndListeners = pipe$1(removePointerUpListener, removePointerCancelListener);
      this.startPress(startEvent, startInfo);
    };
    this.startAccessiblePress = () => {
      const handleKeydown = (keydownEvent) => {
        if (keydownEvent.key !== "Enter" || this.isPressing)
          return;
        const handleKeyup = (keyupEvent) => {
          if (keyupEvent.key !== "Enter" || !this.checkPressEnd())
            return;
          fireSyntheticPointerEvent$1("up", (event, info) => {
            const { onTap } = this.node.getProps();
            if (onTap) {
              frame$1.update(() => onTap(event, info));
            }
          });
        };
        this.removeEndListeners();
        this.removeEndListeners = addDomEvent$1(this.node.current, "keyup", handleKeyup);
        fireSyntheticPointerEvent$1("down", (event, info) => {
          this.startPress(event, info);
        });
      };
      const removeKeydownListener = addDomEvent$1(this.node.current, "keydown", handleKeydown);
      const handleBlur2 = () => {
        if (!this.isPressing)
          return;
        fireSyntheticPointerEvent$1("cancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo));
      };
      const removeBlurListener = addDomEvent$1(this.node.current, "blur", handleBlur2);
      this.removeAccessibleListeners = pipe$1(removeKeydownListener, removeBlurListener);
    };
  }
  startPress(event, info) {
    this.isPressing = true;
    const { onTapStart, whileTap } = this.node.getProps();
    if (whileTap && this.node.animationState) {
      this.node.animationState.setActive("whileTap", true);
    }
    if (onTapStart) {
      frame$1.update(() => onTapStart(event, info));
    }
  }
  checkPressEnd() {
    this.removeEndListeners();
    this.isPressing = false;
    const props = this.node.getProps();
    if (props.whileTap && this.node.animationState) {
      this.node.animationState.setActive("whileTap", false);
    }
    return !isDragActive$1();
  }
  cancelPress(event, info) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel } = this.node.getProps();
    if (onTapCancel) {
      frame$1.update(() => onTapCancel(event, info));
    }
  }
  mount() {
    const props = this.node.getProps();
    const removePointerListener = addPointerEvent$1(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, { passive: !(props.onTapStart || props["onPointerStart"]) });
    const removeFocusListener = addDomEvent$1(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = pipe$1(removePointerListener, removeFocusListener);
  }
  unmount() {
    this.removeStartListeners();
    this.removeEndListeners();
    this.removeAccessibleListeners();
  }
};
const observerCallbacks$1 = /* @__PURE__ */ new WeakMap();
const observers$1 = /* @__PURE__ */ new WeakMap();
const fireObserverCallback$1 = (entry) => {
  const callback = observerCallbacks$1.get(entry.target);
  callback && callback(entry);
};
const fireAllObserverCallbacks$1 = (entries) => {
  entries.forEach(fireObserverCallback$1);
};
function initIntersectionObserver$1(_Y) {
  var _Z = _Y, { root: root2 } = _Z, options = __objRest(_Z, ["root"]);
  const lookupRoot = root2 || document;
  if (!observers$1.has(lookupRoot)) {
    observers$1.set(lookupRoot, {});
  }
  const rootObservers = observers$1.get(lookupRoot);
  const key = JSON.stringify(options);
  if (!rootObservers[key]) {
    rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks$1, __spreadValues({ root: root2 }, options));
  }
  return rootObservers[key];
}
function observeIntersection$1(element, options, callback) {
  const rootInteresectionObserver = initIntersectionObserver$1(options);
  observerCallbacks$1.set(element, callback);
  rootInteresectionObserver.observe(element);
  return () => {
    observerCallbacks$1.delete(element);
    rootInteresectionObserver.unobserve(element);
  };
}
const thresholdNames$1 = {
  some: 0,
  all: 1
};
let InViewFeature$1 = class InViewFeature extends Feature$1 {
  constructor() {
    super(...arguments);
    this.hasEnteredView = false;
    this.isInView = false;
  }
  startObserver() {
    this.unmount();
    const { viewport: viewport2 = {} } = this.node.getProps();
    const { root: root2, margin: rootMargin, amount = "some", once } = viewport2;
    const options = {
      root: root2 ? root2.current : void 0,
      rootMargin,
      threshold: typeof amount === "number" ? amount : thresholdNames$1[amount]
    };
    const onIntersectionUpdate = (entry) => {
      const { isIntersecting } = entry;
      if (this.isInView === isIntersecting)
        return;
      this.isInView = isIntersecting;
      if (once && !isIntersecting && this.hasEnteredView) {
        return;
      } else if (isIntersecting) {
        this.hasEnteredView = true;
      }
      if (this.node.animationState) {
        this.node.animationState.setActive("whileInView", isIntersecting);
      }
      const { onViewportEnter, onViewportLeave } = this.node.getProps();
      const callback = isIntersecting ? onViewportEnter : onViewportLeave;
      callback && callback(entry);
    };
    return observeIntersection$1(this.node.current, options, onIntersectionUpdate);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver === "undefined")
      return;
    const { props, prevProps } = this.node;
    const hasOptionsChanged = ["amount", "margin", "root"].some(hasViewportOptionChanged$1(props, prevProps));
    if (hasOptionsChanged) {
      this.startObserver();
    }
  }
  unmount() {
  }
};
function hasViewportOptionChanged$1({ viewport: viewport2 = {} }, { viewport: prevViewport = {} } = {}) {
  return (name) => viewport2[name] !== prevViewport[name];
}
const gestureAnimations$1 = {
  inView: {
    Feature: InViewFeature$1
  },
  tap: {
    Feature: PressGesture$1
  },
  focus: {
    Feature: FocusGesture$1
  },
  hover: {
    Feature: HoverGesture$1
  }
};
function shallowCompare$1(next2, prev2) {
  if (!Array.isArray(prev2))
    return false;
  const prevLength = prev2.length;
  if (prevLength !== next2.length)
    return false;
  for (let i = 0; i < prevLength; i++) {
    if (prev2[i] !== next2[i])
      return false;
  }
  return true;
}
function getCurrent(visualElement) {
  const current = {};
  visualElement.values.forEach((value, key) => current[key] = value.get());
  return current;
}
function getVelocity$2(visualElement) {
  const velocity = {};
  visualElement.values.forEach((value, key) => velocity[key] = value.getVelocity());
  return velocity;
}
function resolveVariant$1(visualElement, definition, custom2) {
  const props = visualElement.getProps();
  return resolveVariantFromProps$1(props, definition, custom2 !== void 0 ? custom2 : props.custom, getCurrent(visualElement), getVelocity$2(visualElement));
}
let warning$1 = noop$1;
let invariant$1 = noop$1;
if (process.env.NODE_ENV !== "production") {
  warning$1 = (check, message) => {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  invariant$1 = (check, message) => {
    if (!check) {
      throw new Error(message);
    }
  };
}
const secondsToMilliseconds$1 = (seconds) => seconds * 1e3;
const millisecondsToSeconds$1 = (milliseconds) => milliseconds / 1e3;
const instantAnimationState = {
  current: false
};
const isBezierDefinition$1 = (easing2) => Array.isArray(easing2) && typeof easing2[0] === "number";
function isWaapiSupportedEasing$1(easing2) {
  return Boolean(!easing2 || typeof easing2 === "string" && supportedWaapiEasing$1[easing2] || isBezierDefinition$1(easing2) || Array.isArray(easing2) && easing2.every(isWaapiSupportedEasing$1));
}
const cubicBezierAsString$1 = ([a2, b, c2, d]) => `cubic-bezier(${a2}, ${b}, ${c2}, ${d})`;
const supportedWaapiEasing$1 = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: cubicBezierAsString$1([0, 0.65, 0.55, 1]),
  circOut: cubicBezierAsString$1([0.55, 0, 1, 0.45]),
  backIn: cubicBezierAsString$1([0.31, 0.01, 0.66, -0.59]),
  backOut: cubicBezierAsString$1([0.33, 1.53, 0.69, 0.99])
};
function mapEasingToNativeEasing$1(easing2) {
  if (!easing2)
    return void 0;
  return isBezierDefinition$1(easing2) ? cubicBezierAsString$1(easing2) : Array.isArray(easing2) ? easing2.map(mapEasingToNativeEasing$1) : supportedWaapiEasing$1[easing2];
}
function animateStyle$1(element, valueName, keyframes2, { delay: delay2 = 0, duration: duration2, repeat = 0, repeatType = "loop", ease: ease2, times } = {}) {
  const keyframeOptions = { [valueName]: keyframes2 };
  if (times)
    keyframeOptions.offset = times;
  const easing2 = mapEasingToNativeEasing$1(ease2);
  if (Array.isArray(easing2))
    keyframeOptions.easing = easing2;
  return element.animate(keyframeOptions, {
    delay: delay2,
    duration: duration2,
    easing: !Array.isArray(easing2) ? easing2 : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}
function getFinalKeyframe$1(keyframes2, { repeat, repeatType = "loop" }) {
  const index2 = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes2.length - 1;
  return keyframes2[index2];
}
const calcBezier$1 = (t2, a1, a2) => (((1 - 3 * a2 + 3 * a1) * t2 + (3 * a2 - 6 * a1)) * t2 + 3 * a1) * t2;
const subdivisionPrecision$1 = 1e-7;
const subdivisionMaxIterations$1 = 12;
function binarySubdivide$1(x2, lowerBound, upperBound, mX1, mX2) {
  let currentX;
  let currentT;
  let i = 0;
  do {
    currentT = lowerBound + (upperBound - lowerBound) / 2;
    currentX = calcBezier$1(currentT, mX1, mX2) - x2;
    if (currentX > 0) {
      upperBound = currentT;
    } else {
      lowerBound = currentT;
    }
  } while (Math.abs(currentX) > subdivisionPrecision$1 && ++i < subdivisionMaxIterations$1);
  return currentT;
}
function cubicBezier$1(mX1, mY1, mX2, mY2) {
  if (mX1 === mY1 && mX2 === mY2)
    return noop$1;
  const getTForX = (aX) => binarySubdivide$1(aX, 0, 1, mX1, mX2);
  return (t2) => t2 === 0 || t2 === 1 ? t2 : calcBezier$1(getTForX(t2), mY1, mY2);
}
const easeIn$1 = cubicBezier$1(0.42, 0, 1, 1);
const easeOut$1 = cubicBezier$1(0, 0, 0.58, 1);
const easeInOut$1 = cubicBezier$1(0.42, 0, 0.58, 1);
const isEasingArray$1 = (ease2) => {
  return Array.isArray(ease2) && typeof ease2[0] !== "number";
};
const mirrorEasing$1 = (easing2) => (p) => p <= 0.5 ? easing2(2 * p) / 2 : (2 - easing2(2 * (1 - p))) / 2;
const reverseEasing$1 = (easing2) => (p) => 1 - easing2(1 - p);
const circIn$1 = (p) => 1 - Math.sin(Math.acos(p));
const circOut$1 = reverseEasing$1(circIn$1);
const circInOut$1 = mirrorEasing$1(circIn$1);
const backOut$1 = cubicBezier$1(0.33, 1.53, 0.69, 0.99);
const backIn$1 = reverseEasing$1(backOut$1);
const backInOut$1 = mirrorEasing$1(backIn$1);
const anticipate$1 = (p) => (p *= 2) < 1 ? 0.5 * backIn$1(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
const easingLookup$1 = {
  linear: noop$1,
  easeIn: easeIn$1,
  easeInOut: easeInOut$1,
  easeOut: easeOut$1,
  circIn: circIn$1,
  circInOut: circInOut$1,
  circOut: circOut$1,
  backIn: backIn$1,
  backInOut: backInOut$1,
  backOut: backOut$1,
  anticipate: anticipate$1
};
const easingDefinitionToFunction$1 = (definition) => {
  if (Array.isArray(definition)) {
    invariant$1(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
    const [x1, y1, x2, y2] = definition;
    return cubicBezier$1(x1, y1, x2, y2);
  } else if (typeof definition === "string") {
    invariant$1(easingLookup$1[definition] !== void 0, `Invalid easing type '${definition}'`);
    return easingLookup$1[definition];
  }
  return definition;
};
const isColorString$1 = (type, testProp) => (v) => {
  return Boolean(isString$1(v) && singleColorRegex$1.test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
};
const splitColor$1 = (aName, bName, cName) => (v) => {
  if (!isString$1(v))
    return v;
  const [a2, b, c2, alpha2] = v.match(floatRegex$1);
  return {
    [aName]: parseFloat(a2),
    [bName]: parseFloat(b),
    [cName]: parseFloat(c2),
    alpha: alpha2 !== void 0 ? parseFloat(alpha2) : 1
  };
};
const clampRgbUnit$1 = (v) => clamp$1(0, 255, v);
const rgbUnit$1 = __spreadProps(__spreadValues({}, number$1), {
  transform: (v) => Math.round(clampRgbUnit$1(v))
});
const rgba$1 = {
  test: isColorString$1("rgb", "red"),
  parse: splitColor$1("red", "green", "blue"),
  transform: ({ red: red2, green: green2, blue: blue2, alpha: alpha$1$1 = 1 }) => "rgba(" + rgbUnit$1.transform(red2) + ", " + rgbUnit$1.transform(green2) + ", " + rgbUnit$1.transform(blue2) + ", " + sanitize$1(alpha$1.transform(alpha$1$1)) + ")"
};
function parseHex$1(v) {
  let r2 = "";
  let g = "";
  let b = "";
  let a2 = "";
  if (v.length > 5) {
    r2 = v.substring(1, 3);
    g = v.substring(3, 5);
    b = v.substring(5, 7);
    a2 = v.substring(7, 9);
  } else {
    r2 = v.substring(1, 2);
    g = v.substring(2, 3);
    b = v.substring(3, 4);
    a2 = v.substring(4, 5);
    r2 += r2;
    g += g;
    b += b;
    a2 += a2;
  }
  return {
    red: parseInt(r2, 16),
    green: parseInt(g, 16),
    blue: parseInt(b, 16),
    alpha: a2 ? parseInt(a2, 16) / 255 : 1
  };
}
const hex$1 = {
  test: isColorString$1("#"),
  parse: parseHex$1,
  transform: rgba$1.transform
};
const hsla$1 = {
  test: isColorString$1("hsl", "hue"),
  parse: splitColor$1("hue", "saturation", "lightness"),
  transform: ({ hue, saturation, lightness, alpha: alpha$1$1 = 1 }) => {
    return "hsla(" + Math.round(hue) + ", " + percent$1.transform(sanitize$1(saturation)) + ", " + percent$1.transform(sanitize$1(lightness)) + ", " + sanitize$1(alpha$1.transform(alpha$1$1)) + ")";
  }
};
const color$1 = {
  test: (v) => rgba$1.test(v) || hex$1.test(v) || hsla$1.test(v),
  parse: (v) => {
    if (rgba$1.test(v)) {
      return rgba$1.parse(v);
    } else if (hsla$1.test(v)) {
      return hsla$1.parse(v);
    } else {
      return hex$1.parse(v);
    }
  },
  transform: (v) => {
    return isString$1(v) ? v : v.hasOwnProperty("red") ? rgba$1.transform(v) : hsla$1.transform(v);
  }
};
const mix$1 = (from2, to, progress2) => -progress2 * from2 + progress2 * to + from2;
function hueToRgb$1(p, q, t2) {
  if (t2 < 0)
    t2 += 1;
  if (t2 > 1)
    t2 -= 1;
  if (t2 < 1 / 6)
    return p + (q - p) * 6 * t2;
  if (t2 < 1 / 2)
    return q;
  if (t2 < 2 / 3)
    return p + (q - p) * (2 / 3 - t2) * 6;
  return p;
}
function hslaToRgba$1({ hue, saturation, lightness, alpha: alpha2 }) {
  hue /= 360;
  saturation /= 100;
  lightness /= 100;
  let red2 = 0;
  let green2 = 0;
  let blue2 = 0;
  if (!saturation) {
    red2 = green2 = blue2 = lightness;
  } else {
    const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
    const p = 2 * lightness - q;
    red2 = hueToRgb$1(p, q, hue + 1 / 3);
    green2 = hueToRgb$1(p, q, hue);
    blue2 = hueToRgb$1(p, q, hue - 1 / 3);
  }
  return {
    red: Math.round(red2 * 255),
    green: Math.round(green2 * 255),
    blue: Math.round(blue2 * 255),
    alpha: alpha2
  };
}
const mixLinearColor$1 = (from2, to, v) => {
  const fromExpo = from2 * from2;
  return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const colorTypes$1 = [hex$1, rgba$1, hsla$1];
const getColorType$1 = (v) => colorTypes$1.find((type) => type.test(v));
function asRGBA$1(color2) {
  const type = getColorType$1(color2);
  invariant$1(Boolean(type), `'${color2}' is not an animatable color. Use the equivalent color code instead.`);
  let model = type.parse(color2);
  if (type === hsla$1) {
    model = hslaToRgba$1(model);
  }
  return model;
}
const mixColor$1 = (from2, to) => {
  const fromRGBA = asRGBA$1(from2);
  const toRGBA = asRGBA$1(to);
  const blended = __spreadValues({}, fromRGBA);
  return (v) => {
    blended.red = mixLinearColor$1(fromRGBA.red, toRGBA.red, v);
    blended.green = mixLinearColor$1(fromRGBA.green, toRGBA.green, v);
    blended.blue = mixLinearColor$1(fromRGBA.blue, toRGBA.blue, v);
    blended.alpha = mix$1(fromRGBA.alpha, toRGBA.alpha, v);
    return rgba$1.transform(blended);
  };
};
function test$1(v) {
  var _a, _b;
  return isNaN(v) && isString$1(v) && (((_a = v.match(floatRegex$1)) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match(colorRegex$1)) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const cssVarTokeniser = {
  regex: cssVariableRegex,
  countKey: "Vars",
  token: "${v}",
  parse: noop$1
};
const colorTokeniser = {
  regex: colorRegex$1,
  countKey: "Colors",
  token: "${c}",
  parse: color$1.parse
};
const numberTokeniser = {
  regex: floatRegex$1,
  countKey: "Numbers",
  token: "${n}",
  parse: number$1.parse
};
function tokenise(info, { regex, countKey, token: token2, parse: parse2 }) {
  const matches = info.tokenised.match(regex);
  if (!matches)
    return;
  info["num" + countKey] = matches.length;
  info.tokenised = info.tokenised.replace(regex, token2);
  info.values.push(...matches.map(parse2));
}
function analyseComplexValue$1(value) {
  const originalValue = value.toString();
  const info = {
    value: originalValue,
    tokenised: originalValue,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  if (info.value.includes("var(--"))
    tokenise(info, cssVarTokeniser);
  tokenise(info, colorTokeniser);
  tokenise(info, numberTokeniser);
  return info;
}
function parseComplexValue$1(v) {
  return analyseComplexValue$1(v).values;
}
function createTransformer$1(source) {
  const { values: values2, numColors, numVars, tokenised } = analyseComplexValue$1(source);
  const numValues = values2.length;
  return (v) => {
    let output = tokenised;
    for (let i = 0; i < numValues; i++) {
      if (i < numVars) {
        output = output.replace(cssVarTokeniser.token, v[i]);
      } else if (i < numVars + numColors) {
        output = output.replace(colorTokeniser.token, color$1.transform(v[i]));
      } else {
        output = output.replace(numberTokeniser.token, sanitize$1(v[i]));
      }
    }
    return output;
  };
}
const convertNumbersToZero$1 = (v) => typeof v === "number" ? 0 : v;
function getAnimatableNone$3(v) {
  const parsed = parseComplexValue$1(v);
  const transformer = createTransformer$1(v);
  return transformer(parsed.map(convertNumbersToZero$1));
}
const complex$1 = {
  test: test$1,
  parse: parseComplexValue$1,
  createTransformer: createTransformer$1,
  getAnimatableNone: getAnimatableNone$3
};
const mixImmediate$1 = (origin, target) => (p) => `${p > 0 ? target : origin}`;
function getMixer$1(origin, target) {
  if (typeof origin === "number") {
    return (v) => mix$1(origin, target, v);
  } else if (color$1.test(origin)) {
    return mixColor$1(origin, target);
  } else {
    return origin.startsWith("var(") ? mixImmediate$1(origin, target) : mixComplex$1(origin, target);
  }
}
const mixArray$1 = (from2, to) => {
  const output = [...from2];
  const numValues = output.length;
  const blendValue = from2.map((fromThis, i) => getMixer$1(fromThis, to[i]));
  return (v) => {
    for (let i = 0; i < numValues; i++) {
      output[i] = blendValue[i](v);
    }
    return output;
  };
};
const mixObject$1 = (origin, target) => {
  const output = __spreadValues(__spreadValues({}, origin), target);
  const blendValue = {};
  for (const key in output) {
    if (origin[key] !== void 0 && target[key] !== void 0) {
      blendValue[key] = getMixer$1(origin[key], target[key]);
    }
  }
  return (v) => {
    for (const key in blendValue) {
      output[key] = blendValue[key](v);
    }
    return output;
  };
};
const mixComplex$1 = (origin, target) => {
  const template = complex$1.createTransformer(target);
  const originStats = analyseComplexValue$1(origin);
  const targetStats = analyseComplexValue$1(target);
  const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
  if (canInterpolate) {
    return pipe$1(mixArray$1(originStats.values, targetStats.values), template);
  } else {
    warning$1(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
    return mixImmediate$1(origin, target);
  }
};
const progress$1 = (from2, to, value) => {
  const toFromDifference = to - from2;
  return toFromDifference === 0 ? 1 : (value - from2) / toFromDifference;
};
const mixNumber$2 = (from2, to) => (p) => mix$1(from2, to, p);
function detectMixerFactory(v) {
  if (typeof v === "number") {
    return mixNumber$2;
  } else if (typeof v === "string") {
    return color$1.test(v) ? mixColor$1 : mixComplex$1;
  } else if (Array.isArray(v)) {
    return mixArray$1;
  } else if (typeof v === "object") {
    return mixObject$1;
  }
  return mixNumber$2;
}
function createMixers$1(output, ease2, customMixer) {
  const mixers = [];
  const mixerFactory = customMixer || detectMixerFactory(output[0]);
  const numMixers = output.length - 1;
  for (let i = 0; i < numMixers; i++) {
    let mixer = mixerFactory(output[i], output[i + 1]);
    if (ease2) {
      const easingFunction = Array.isArray(ease2) ? ease2[i] || noop$1 : ease2;
      mixer = pipe$1(easingFunction, mixer);
    }
    mixers.push(mixer);
  }
  return mixers;
}
function interpolate$1(input, output, { clamp: isClamp = true, ease: ease2, mixer } = {}) {
  const inputLength = input.length;
  invariant$1(inputLength === output.length, "Both input and output ranges must be the same length");
  if (inputLength === 1)
    return () => output[0];
  if (input[0] > input[inputLength - 1]) {
    input = [...input].reverse();
    output = [...output].reverse();
  }
  const mixers = createMixers$1(output, ease2, mixer);
  const numMixers = mixers.length;
  const interpolator = (v) => {
    let i = 0;
    if (numMixers > 1) {
      for (; i < input.length - 2; i++) {
        if (v < input[i + 1])
          break;
      }
    }
    const progressInRange = progress$1(input[i], input[i + 1], v);
    return mixers[i](progressInRange);
  };
  return isClamp ? (v) => interpolator(clamp$1(input[0], input[inputLength - 1], v)) : interpolator;
}
function fillOffset$1(offset2, remaining) {
  const min2 = offset2[offset2.length - 1];
  for (let i = 1; i <= remaining; i++) {
    const offsetProgress = progress$1(0, remaining, i);
    offset2.push(mix$1(min2, 1, offsetProgress));
  }
}
function defaultOffset$1(arr) {
  const offset2 = [0];
  fillOffset$1(offset2, arr.length - 1);
  return offset2;
}
function convertOffsetToTimes$1(offset2, duration2) {
  return offset2.map((o2) => o2 * duration2);
}
function defaultEasing$1(values2, easing2) {
  return values2.map(() => easing2 || easeInOut$1).splice(0, values2.length - 1);
}
function keyframes$1({ duration: duration2 = 300, keyframes: keyframeValues, times, ease: ease2 = "easeInOut" }) {
  const easingFunctions = isEasingArray$1(ease2) ? ease2.map(easingDefinitionToFunction$1) : easingDefinitionToFunction$1(ease2);
  const state = {
    done: false,
    value: keyframeValues[0]
  };
  const absoluteTimes = convertOffsetToTimes$1(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : defaultOffset$1(keyframeValues),
    duration2
  );
  const mapTimeToKeyframe = interpolate$1(absoluteTimes, keyframeValues, {
    ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing$1(keyframeValues, easingFunctions)
  });
  return {
    calculatedDuration: duration2,
    next: (t2) => {
      state.value = mapTimeToKeyframe(t2);
      state.done = t2 >= duration2;
      return state;
    }
  };
}
function velocityPerSecond$1(velocity, frameDuration) {
  return frameDuration ? velocity * (1e3 / frameDuration) : 0;
}
const velocitySampleDuration$1 = 5;
function calcGeneratorVelocity$1(resolveValue, t2, current) {
  const prevT = Math.max(t2 - velocitySampleDuration$1, 0);
  return velocityPerSecond$1(current - resolveValue(prevT), t2 - prevT);
}
const safeMin$1 = 1e-3;
const minDuration$1 = 0.01;
const maxDuration$3 = 10;
const minDamping$1 = 0.05;
const maxDamping$1 = 1;
function findSpring$1({ duration: duration2 = 800, bounce = 0.25, velocity = 0, mass = 1 }) {
  let envelope;
  let derivative;
  warning$1(duration2 <= secondsToMilliseconds$1(maxDuration$3), "Spring duration must be 10 seconds or less");
  let dampingRatio = 1 - bounce;
  dampingRatio = clamp$1(minDamping$1, maxDamping$1, dampingRatio);
  duration2 = clamp$1(minDuration$1, maxDuration$3, millisecondsToSeconds$1(duration2));
  if (dampingRatio < 1) {
    envelope = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration2;
      const a2 = exponentialDecay - velocity;
      const b = calcAngularFreq$1(undampedFreq2, dampingRatio);
      const c2 = Math.exp(-delta);
      return safeMin$1 - a2 / b * c2;
    };
    derivative = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration2;
      const d = delta * velocity + velocity;
      const e2 = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq2, 2) * duration2;
      const f = Math.exp(-delta);
      const g = calcAngularFreq$1(Math.pow(undampedFreq2, 2), dampingRatio);
      const factor = -envelope(undampedFreq2) + safeMin$1 > 0 ? -1 : 1;
      return factor * ((d - e2) * f) / g;
    };
  } else {
    envelope = (undampedFreq2) => {
      const a2 = Math.exp(-undampedFreq2 * duration2);
      const b = (undampedFreq2 - velocity) * duration2 + 1;
      return -safeMin$1 + a2 * b;
    };
    derivative = (undampedFreq2) => {
      const a2 = Math.exp(-undampedFreq2 * duration2);
      const b = (velocity - undampedFreq2) * (duration2 * duration2);
      return a2 * b;
    };
  }
  const initialGuess = 5 / duration2;
  const undampedFreq = approximateRoot$1(envelope, derivative, initialGuess);
  duration2 = secondsToMilliseconds$1(duration2);
  if (isNaN(undampedFreq)) {
    return {
      stiffness: 100,
      damping: 10,
      duration: duration2
    };
  } else {
    const stiffness = Math.pow(undampedFreq, 2) * mass;
    return {
      stiffness,
      damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
      duration: duration2
    };
  }
}
const rootIterations$1 = 12;
function approximateRoot$1(envelope, derivative, initialGuess) {
  let result = initialGuess;
  for (let i = 1; i < rootIterations$1; i++) {
    result = result - envelope(result) / derivative(result);
  }
  return result;
}
function calcAngularFreq$1(undampedFreq, dampingRatio) {
  return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
const durationKeys$1 = ["duration", "bounce"];
const physicsKeys$1 = ["stiffness", "damping", "mass"];
function isSpringType$1(options, keys) {
  return keys.some((key) => options[key] !== void 0);
}
function getSpringOptions$1(options) {
  let springOptions = __spreadValues({
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: false
  }, options);
  if (!isSpringType$1(options, physicsKeys$1) && isSpringType$1(options, durationKeys$1)) {
    const derived = findSpring$1(options);
    springOptions = __spreadProps(__spreadValues(__spreadValues({}, springOptions), derived), {
      mass: 1
    });
    springOptions.isResolvedFromDuration = true;
  }
  return springOptions;
}
function spring$1(__) {
  var _$ = __, { keyframes: keyframes2, restDelta, restSpeed } = _$, options = __objRest(_$, ["keyframes", "restDelta", "restSpeed"]);
  const origin = keyframes2[0];
  const target = keyframes2[keyframes2.length - 1];
  const state = { done: false, value: origin };
  const { stiffness, damping, mass, duration: duration2, velocity, isResolvedFromDuration } = getSpringOptions$1(__spreadProps(__spreadValues({}, options), {
    velocity: -millisecondsToSeconds$1(options.velocity || 0)
  }));
  const initialVelocity = velocity || 0;
  const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
  const initialDelta = target - origin;
  const undampedAngularFreq = millisecondsToSeconds$1(Math.sqrt(stiffness / mass));
  const isGranularScale = Math.abs(initialDelta) < 5;
  restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
  restDelta || (restDelta = isGranularScale ? 5e-3 : 0.5);
  let resolveSpring;
  if (dampingRatio < 1) {
    const angularFreq = calcAngularFreq$1(undampedAngularFreq, dampingRatio);
    resolveSpring = (t2) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t2);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t2) + initialDelta * Math.cos(angularFreq * t2));
    };
  } else if (dampingRatio === 1) {
    resolveSpring = (t2) => target - Math.exp(-undampedAngularFreq * t2) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t2);
  } else {
    const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
    resolveSpring = (t2) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t2);
      const freqForT = Math.min(dampedAngularFreq * t2, 300);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
    };
  }
  return {
    calculatedDuration: isResolvedFromDuration ? duration2 || null : null,
    next: (t2) => {
      const current = resolveSpring(t2);
      if (!isResolvedFromDuration) {
        let currentVelocity = initialVelocity;
        if (t2 !== 0) {
          if (dampingRatio < 1) {
            currentVelocity = calcGeneratorVelocity$1(resolveSpring, t2, current);
          } else {
            currentVelocity = 0;
          }
        }
        const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
      } else {
        state.done = t2 >= duration2;
      }
      state.value = state.done ? target : current;
      return state;
    }
  };
}
function inertia$1({ keyframes: keyframes2, velocity = 0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min: min2, max: max2, restDelta = 0.5, restSpeed }) {
  const origin = keyframes2[0];
  const state = {
    done: false,
    value: origin
  };
  const isOutOfBounds = (v) => min2 !== void 0 && v < min2 || max2 !== void 0 && v > max2;
  const nearestBoundary = (v) => {
    if (min2 === void 0)
      return max2;
    if (max2 === void 0)
      return min2;
    return Math.abs(min2 - v) < Math.abs(max2 - v) ? min2 : max2;
  };
  let amplitude = power * velocity;
  const ideal = origin + amplitude;
  const target = modifyTarget === void 0 ? ideal : modifyTarget(ideal);
  if (target !== ideal)
    amplitude = target - origin;
  const calcDelta = (t2) => -amplitude * Math.exp(-t2 / timeConstant);
  const calcLatest = (t2) => target + calcDelta(t2);
  const applyFriction = (t2) => {
    const delta = calcDelta(t2);
    const latest = calcLatest(t2);
    state.done = Math.abs(delta) <= restDelta;
    state.value = state.done ? target : latest;
  };
  let timeReachedBoundary;
  let spring$1$1;
  const checkCatchBoundary = (t2) => {
    if (!isOutOfBounds(state.value))
      return;
    timeReachedBoundary = t2;
    spring$1$1 = spring$1({
      keyframes: [state.value, nearestBoundary(state.value)],
      velocity: calcGeneratorVelocity$1(calcLatest, t2, state.value),
      damping: bounceDamping,
      stiffness: bounceStiffness,
      restDelta,
      restSpeed
    });
  };
  checkCatchBoundary(0);
  return {
    calculatedDuration: null,
    next: (t2) => {
      let hasUpdatedFrame = false;
      if (!spring$1$1 && timeReachedBoundary === void 0) {
        hasUpdatedFrame = true;
        applyFriction(t2);
        checkCatchBoundary(t2);
      }
      if (timeReachedBoundary !== void 0 && t2 > timeReachedBoundary) {
        return spring$1$1.next(t2 - timeReachedBoundary);
      } else {
        !hasUpdatedFrame && applyFriction(t2);
        return state;
      }
    }
  };
}
const frameloopDriver$1 = (update) => {
  const passTimestamp = ({ timestamp }) => update(timestamp);
  return {
    start: () => frame$1.update(passTimestamp, true),
    stop: () => cancelFrame$1(passTimestamp),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => frameData$1.isProcessing ? frameData$1.timestamp : performance.now()
  };
};
const maxGeneratorDuration$1 = 2e4;
function calcGeneratorDuration$1(generator) {
  let duration2 = 0;
  const timeStep = 50;
  let state = generator.next(duration2);
  while (!state.done && duration2 < maxGeneratorDuration$1) {
    duration2 += timeStep;
    state = generator.next(duration2);
  }
  return duration2 >= maxGeneratorDuration$1 ? Infinity : duration2;
}
const types = {
  decay: inertia$1,
  inertia: inertia$1,
  tween: keyframes$1,
  keyframes: keyframes$1,
  spring: spring$1
};
function animateValue(_aa) {
  var _ba = _aa, { autoplay = true, delay: delay2 = 0, driver = frameloopDriver$1, keyframes: keyframes$1$1, type = "keyframes", repeat = 0, repeatDelay = 0, repeatType = "loop", onPlay, onStop, onComplete, onUpdate } = _ba, options = __objRest(_ba, ["autoplay", "delay", "driver", "keyframes", "type", "repeat", "repeatDelay", "repeatType", "onPlay", "onStop", "onComplete", "onUpdate"]);
  let speed = 1;
  let hasStopped = false;
  let resolveFinishedPromise;
  let currentFinishedPromise;
  const updateFinishedPromise = () => {
    currentFinishedPromise = new Promise((resolve) => {
      resolveFinishedPromise = resolve;
    });
  };
  updateFinishedPromise();
  let animationDriver;
  const generatorFactory = types[type] || keyframes$1;
  let mapNumbersToKeyframes;
  if (generatorFactory !== keyframes$1 && typeof keyframes$1$1[0] !== "number") {
    if (process.env.NODE_ENV !== "production") {
      invariant$1(keyframes$1$1.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${keyframes$1$1}`);
    }
    mapNumbersToKeyframes = interpolate$1([0, 100], keyframes$1$1, {
      clamp: false
    });
    keyframes$1$1 = [0, 100];
  }
  const generator = generatorFactory(__spreadProps(__spreadValues({}, options), { keyframes: keyframes$1$1 }));
  let mirroredGenerator;
  if (repeatType === "mirror") {
    mirroredGenerator = generatorFactory(__spreadProps(__spreadValues({}, options), {
      keyframes: [...keyframes$1$1].reverse(),
      velocity: -(options.velocity || 0)
    }));
  }
  let playState = "idle";
  let holdTime = null;
  let startTime = null;
  let cancelTime = null;
  if (generator.calculatedDuration === null && repeat) {
    generator.calculatedDuration = calcGeneratorDuration$1(generator);
  }
  const { calculatedDuration } = generator;
  let resolvedDuration = Infinity;
  let totalDuration = Infinity;
  if (calculatedDuration !== null) {
    resolvedDuration = calculatedDuration + repeatDelay;
    totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
  }
  let currentTime = 0;
  const tick = (timestamp) => {
    if (startTime === null)
      return;
    if (speed > 0)
      startTime = Math.min(startTime, timestamp);
    if (speed < 0)
      startTime = Math.min(timestamp - totalDuration / speed, startTime);
    if (holdTime !== null) {
      currentTime = holdTime;
    } else {
      currentTime = Math.round(timestamp - startTime) * speed;
    }
    const timeWithoutDelay = currentTime - delay2 * (speed >= 0 ? 1 : -1);
    const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
    currentTime = Math.max(timeWithoutDelay, 0);
    if (playState === "finished" && holdTime === null) {
      currentTime = totalDuration;
    }
    let elapsed = currentTime;
    let frameGenerator = generator;
    if (repeat) {
      const progress2 = Math.min(currentTime, totalDuration) / resolvedDuration;
      let currentIteration = Math.floor(progress2);
      let iterationProgress = progress2 % 1;
      if (!iterationProgress && progress2 >= 1) {
        iterationProgress = 1;
      }
      iterationProgress === 1 && currentIteration--;
      currentIteration = Math.min(currentIteration, repeat + 1);
      const isOddIteration = Boolean(currentIteration % 2);
      if (isOddIteration) {
        if (repeatType === "reverse") {
          iterationProgress = 1 - iterationProgress;
          if (repeatDelay) {
            iterationProgress -= repeatDelay / resolvedDuration;
          }
        } else if (repeatType === "mirror") {
          frameGenerator = mirroredGenerator;
        }
      }
      elapsed = clamp$1(0, 1, iterationProgress) * resolvedDuration;
    }
    const state = isInDelayPhase ? { done: false, value: keyframes$1$1[0] } : frameGenerator.next(elapsed);
    if (mapNumbersToKeyframes) {
      state.value = mapNumbersToKeyframes(state.value);
    }
    let { done } = state;
    if (!isInDelayPhase && calculatedDuration !== null) {
      done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
    }
    const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
    if (onUpdate) {
      onUpdate(state.value);
    }
    if (isAnimationFinished) {
      finish();
    }
    return state;
  };
  const stopAnimationDriver = () => {
    animationDriver && animationDriver.stop();
    animationDriver = void 0;
  };
  const cancel = () => {
    playState = "idle";
    stopAnimationDriver();
    resolveFinishedPromise();
    updateFinishedPromise();
    startTime = cancelTime = null;
  };
  const finish = () => {
    playState = "finished";
    onComplete && onComplete();
    stopAnimationDriver();
    resolveFinishedPromise();
  };
  const play = () => {
    if (hasStopped)
      return;
    if (!animationDriver)
      animationDriver = driver(tick);
    const now2 = animationDriver.now();
    onPlay && onPlay();
    if (holdTime !== null) {
      startTime = now2 - holdTime;
    } else if (!startTime || playState === "finished") {
      startTime = now2;
    }
    if (playState === "finished") {
      updateFinishedPromise();
    }
    cancelTime = startTime;
    holdTime = null;
    playState = "running";
    animationDriver.start();
  };
  if (autoplay) {
    play();
  }
  const controls = {
    then(resolve, reject) {
      return currentFinishedPromise.then(resolve, reject);
    },
    get time() {
      return millisecondsToSeconds$1(currentTime);
    },
    set time(newTime) {
      newTime = secondsToMilliseconds$1(newTime);
      currentTime = newTime;
      if (holdTime !== null || !animationDriver || speed === 0) {
        holdTime = newTime;
      } else {
        startTime = animationDriver.now() - newTime / speed;
      }
    },
    get duration() {
      const duration2 = generator.calculatedDuration === null ? calcGeneratorDuration$1(generator) : generator.calculatedDuration;
      return millisecondsToSeconds$1(duration2);
    },
    get speed() {
      return speed;
    },
    set speed(newSpeed) {
      if (newSpeed === speed || !animationDriver)
        return;
      speed = newSpeed;
      controls.time = millisecondsToSeconds$1(currentTime);
    },
    get state() {
      return playState;
    },
    play,
    pause: () => {
      playState = "paused";
      holdTime = currentTime;
    },
    stop: () => {
      hasStopped = true;
      if (playState === "idle")
        return;
      playState = "idle";
      onStop && onStop();
      cancel();
    },
    cancel: () => {
      if (cancelTime !== null)
        tick(cancelTime);
      cancel();
    },
    complete: () => {
      playState = "finished";
    },
    sample: (elapsed) => {
      startTime = 0;
      return tick(elapsed);
    }
  };
  return controls;
}
function memo$1(callback) {
  let result;
  return () => {
    if (result === void 0)
      result = callback();
    return result;
  };
}
const supportsWaapi$1 = memo$1(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
const acceleratedValues$1 = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]);
const sampleDelta$1 = 10;
const maxDuration$2 = 2e4;
const requiresPregeneratedKeyframes$1 = (valueName, options) => options.type === "spring" || valueName === "backgroundColor" || !isWaapiSupportedEasing$1(options.ease);
function createAcceleratedAnimation(value, valueName, _ca) {
  var _da = _ca, { onUpdate, onComplete } = _da, options = __objRest(_da, ["onUpdate", "onComplete"]);
  const canAccelerateAnimation = supportsWaapi$1() && acceleratedValues$1.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
  if (!canAccelerateAnimation)
    return false;
  let hasStopped = false;
  let resolveFinishedPromise;
  let currentFinishedPromise;
  let pendingCancel = false;
  const updateFinishedPromise = () => {
    currentFinishedPromise = new Promise((resolve) => {
      resolveFinishedPromise = resolve;
    });
  };
  updateFinishedPromise();
  let { keyframes: keyframes2, duration: duration2 = 300, ease: ease2, times } = options;
  if (requiresPregeneratedKeyframes$1(valueName, options)) {
    const sampleAnimation = animateValue(__spreadProps(__spreadValues({}, options), {
      repeat: 0,
      delay: 0
    }));
    let state = { done: false, value: keyframes2[0] };
    const pregeneratedKeyframes = [];
    let t2 = 0;
    while (!state.done && t2 < maxDuration$2) {
      state = sampleAnimation.sample(t2);
      pregeneratedKeyframes.push(state.value);
      t2 += sampleDelta$1;
    }
    times = void 0;
    keyframes2 = pregeneratedKeyframes;
    duration2 = t2 - sampleDelta$1;
    ease2 = "linear";
  }
  const animation = animateStyle$1(value.owner.current, valueName, keyframes2, __spreadProps(__spreadValues({}, options), {
    duration: duration2,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: ease2,
    times
  }));
  const cancelAnimation = () => {
    pendingCancel = false;
    animation.cancel();
  };
  const safeCancel = () => {
    pendingCancel = true;
    frame$1.update(cancelAnimation);
    resolveFinishedPromise();
    updateFinishedPromise();
  };
  animation.onfinish = () => {
    if (pendingCancel)
      return;
    value.set(getFinalKeyframe$1(keyframes2, options));
    onComplete && onComplete();
    safeCancel();
  };
  const controls = {
    then(resolve, reject) {
      return currentFinishedPromise.then(resolve, reject);
    },
    attachTimeline(timeline) {
      animation.timeline = timeline;
      animation.onfinish = null;
      return noop$1;
    },
    get time() {
      return millisecondsToSeconds$1(animation.currentTime || 0);
    },
    set time(newTime) {
      animation.currentTime = secondsToMilliseconds$1(newTime);
    },
    get speed() {
      return animation.playbackRate;
    },
    set speed(newSpeed) {
      animation.playbackRate = newSpeed;
    },
    get duration() {
      return millisecondsToSeconds$1(duration2);
    },
    play: () => {
      if (hasStopped)
        return;
      animation.play();
      cancelFrame$1(cancelAnimation);
    },
    pause: () => animation.pause(),
    stop: () => {
      hasStopped = true;
      if (animation.playState === "idle")
        return;
      const { currentTime } = animation;
      if (currentTime) {
        const sampleAnimation = animateValue(__spreadProps(__spreadValues({}, options), {
          autoplay: false
        }));
        value.setWithVelocity(sampleAnimation.sample(currentTime - sampleDelta$1).value, sampleAnimation.sample(currentTime).value, sampleDelta$1);
      }
      safeCancel();
    },
    complete: () => {
      if (pendingCancel)
        return;
      animation.finish();
    },
    cancel: safeCancel
  };
  return controls;
}
function createInstantAnimation({ keyframes: keyframes2, delay: delay2, onUpdate, onComplete }) {
  const setValue = () => {
    onUpdate && onUpdate(keyframes2[keyframes2.length - 1]);
    onComplete && onComplete();
    return {
      time: 0,
      speed: 1,
      duration: 0,
      play: noop$1,
      pause: noop$1,
      stop: noop$1,
      then: (resolve) => {
        resolve();
        return Promise.resolve();
      },
      cancel: noop$1,
      complete: noop$1
    };
  };
  return delay2 ? animateValue({
    keyframes: [0, 1],
    duration: 0,
    delay: delay2,
    onComplete: setValue
  }) : setValue();
}
const underDampedSpring$1 = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
};
const criticallyDampedSpring$1 = (target) => ({
  type: "spring",
  stiffness: 550,
  damping: target === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
});
const keyframesTransition$1 = {
  type: "keyframes",
  duration: 0.8
};
const ease$1 = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
};
const getDefaultTransition$1 = (valueKey, { keyframes: keyframes2 }) => {
  if (keyframes2.length > 2) {
    return keyframesTransition$1;
  } else if (transformProps$1.has(valueKey)) {
    return valueKey.startsWith("scale") ? criticallyDampedSpring$1(keyframes2[1]) : underDampedSpring$1;
  }
  return ease$1;
};
const isAnimatable$1 = (key, value) => {
  if (key === "zIndex")
    return false;
  if (typeof value === "number" || Array.isArray(value))
    return true;
  if (typeof value === "string" && // It's animatable if we have a string
  (complex$1.test(value) || value === "0") && // And it contains numbers and/or colors
  !value.startsWith("url(")) {
    return true;
  }
  return false;
};
const maxDefaults$1 = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter$1(v) {
  const [name, value] = v.slice(0, -1).split("(");
  if (name === "drop-shadow")
    return v;
  const [number2] = value.match(floatRegex$1) || [];
  if (!number2)
    return v;
  const unit = value.replace(number2, "");
  let defaultValue2 = maxDefaults$1.has(name) ? 1 : 0;
  if (number2 !== value)
    defaultValue2 *= 100;
  return name + "(" + defaultValue2 + unit + ")";
}
const functionRegex$1 = /([a-z-]*)\(.*?\)/g;
const filter$1 = __spreadProps(__spreadValues({}, complex$1), {
  getAnimatableNone: (v) => {
    const functions = v.match(functionRegex$1);
    return functions ? functions.map(applyDefaultFilter$1).join(" ") : v;
  }
});
const defaultValueTypes$1 = __spreadProps(__spreadValues({}, numberValueTypes$1), {
  // Color props
  color: color$1,
  backgroundColor: color$1,
  outlineColor: color$1,
  fill: color$1,
  stroke: color$1,
  // Border props
  borderColor: color$1,
  borderTopColor: color$1,
  borderRightColor: color$1,
  borderBottomColor: color$1,
  borderLeftColor: color$1,
  filter: filter$1,
  WebkitFilter: filter$1
});
const getDefaultValueType$1 = (key) => defaultValueTypes$1[key];
function getAnimatableNone$2(key, value) {
  let defaultValueType = getDefaultValueType$1(key);
  if (defaultValueType !== filter$1)
    defaultValueType = complex$1;
  return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : void 0;
}
const isZeroValueString$1 = (v) => /^0[^.\s]+$/.test(v);
function isNone$1(value) {
  if (typeof value === "number") {
    return value === 0;
  } else if (value !== null) {
    return value === "none" || value === "0" || isZeroValueString$1(value);
  }
}
function getKeyframes(value, valueName, target, transition) {
  const isTargetAnimatable = isAnimatable$1(valueName, target);
  let keyframes2;
  if (Array.isArray(target)) {
    keyframes2 = [...target];
  } else {
    keyframes2 = [null, target];
  }
  const defaultOrigin = transition.from !== void 0 ? transition.from : value.get();
  let animatableTemplateValue = void 0;
  const noneKeyframeIndexes = [];
  for (let i = 0; i < keyframes2.length; i++) {
    if (keyframes2[i] === null) {
      keyframes2[i] = i === 0 ? defaultOrigin : keyframes2[i - 1];
    }
    if (isNone$1(keyframes2[i])) {
      noneKeyframeIndexes.push(i);
    }
    if (typeof keyframes2[i] === "string" && keyframes2[i] !== "none" && keyframes2[i] !== "0") {
      animatableTemplateValue = keyframes2[i];
    }
  }
  if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) {
    for (let i = 0; i < noneKeyframeIndexes.length; i++) {
      const index2 = noneKeyframeIndexes[i];
      keyframes2[index2] = getAnimatableNone$2(valueName, animatableTemplateValue);
    }
  }
  return keyframes2;
}
function isTransitionDefined$1(_ea) {
  var _fa = _ea, { when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from: from2, elapsed } = _fa, transition = __objRest(_fa, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from", "elapsed"]);
  return !!Object.keys(transition).length;
}
function getValueTransition$1(transition, key) {
  return transition[key] || transition["default"] || transition;
}
const MotionGlobalConfig$1 = {
  skipAnimations: false
};
const animateMotionValue$1 = (valueName, value, target, transition = {}) => {
  return (onComplete) => {
    const valueTransition = getValueTransition$1(transition, valueName) || {};
    const delay2 = valueTransition.delay || transition.delay || 0;
    let { elapsed = 0 } = transition;
    elapsed = elapsed - secondsToMilliseconds$1(delay2);
    const keyframes2 = getKeyframes(value, valueName, target, valueTransition);
    const originKeyframe = keyframes2[0];
    const targetKeyframe = keyframes2[keyframes2.length - 1];
    const isOriginAnimatable = isAnimatable$1(valueName, originKeyframe);
    const isTargetAnimatable = isAnimatable$1(valueName, targetKeyframe);
    warning$1(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    let options = __spreadProps(__spreadValues({
      keyframes: keyframes2,
      velocity: value.getVelocity(),
      ease: "easeOut"
    }, valueTransition), {
      delay: -elapsed,
      onUpdate: (v) => {
        value.set(v);
        valueTransition.onUpdate && valueTransition.onUpdate(v);
      },
      onComplete: () => {
        onComplete();
        valueTransition.onComplete && valueTransition.onComplete();
      }
    });
    if (!isTransitionDefined$1(valueTransition)) {
      options = __spreadValues(__spreadValues({}, options), getDefaultTransition$1(valueName, options));
    }
    if (options.duration) {
      options.duration = secondsToMilliseconds$1(options.duration);
    }
    if (options.repeatDelay) {
      options.repeatDelay = secondsToMilliseconds$1(options.repeatDelay);
    }
    if (!isOriginAnimatable || !isTargetAnimatable || instantAnimationState.current || valueTransition.type === false || MotionGlobalConfig$1.skipAnimations) {
      return createInstantAnimation(options);
    }
    if (
      /**
       * If this is a handoff animation, the optimised animation will be running via
       * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
       * optimised animation.
       */
      !transition.isHandoff && value.owner && value.owner.current instanceof HTMLElement && /**
       * If we're outputting values to onUpdate then we can't use WAAPI as there's
       * no way to read the value from WAAPI every frame.
       */
      !value.owner.getProps().onUpdate
    ) {
      const acceleratedAnimation = createAcceleratedAnimation(value, valueName, options);
      if (acceleratedAnimation)
        return acceleratedAnimation;
    }
    return animateValue(options);
  };
};
function isWillChangeMotionValue$1(value) {
  return Boolean(isMotionValue$1(value) && value.add);
}
const isNumericalString$1 = (v) => /^\-?\d*\.?\d+$/.test(v);
function addUniqueItem$1(arr, item) {
  if (arr.indexOf(item) === -1)
    arr.push(item);
}
function removeItem$1(arr, item) {
  const index2 = arr.indexOf(item);
  if (index2 > -1)
    arr.splice(index2, 1);
}
let SubscriptionManager$1 = class SubscriptionManager {
  constructor() {
    this.subscriptions = [];
  }
  add(handler) {
    addUniqueItem$1(this.subscriptions, handler);
    return () => removeItem$1(this.subscriptions, handler);
  }
  notify(a2, b, c2) {
    const numSubscriptions = this.subscriptions.length;
    if (!numSubscriptions)
      return;
    if (numSubscriptions === 1) {
      this.subscriptions[0](a2, b, c2);
    } else {
      for (let i = 0; i < numSubscriptions; i++) {
        const handler = this.subscriptions[i];
        handler && handler(a2, b, c2);
      }
    }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
};
const warned$1 = /* @__PURE__ */ new Set();
function warnOnce$1(condition, message, element) {
  if (condition || warned$1.has(message))
    return;
  console.warn(message);
  if (element)
    console.warn(element);
  warned$1.add(message);
}
const isFloat$1 = (value) => {
  return !isNaN(parseFloat(value));
};
let MotionValue$1 = class MotionValue {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(init2, options = {}) {
    this.version = "10.18.0";
    this.timeDelta = 0;
    this.lastUpdated = 0;
    this.canTrackVelocity = false;
    this.events = {};
    this.updateAndNotify = (v, render = true) => {
      this.prev = this.current;
      this.current = v;
      const { delta, timestamp } = frameData$1;
      if (this.lastUpdated !== timestamp) {
        this.timeDelta = delta;
        this.lastUpdated = timestamp;
        frame$1.postRender(this.scheduleVelocityCheck);
      }
      if (this.prev !== this.current && this.events.change) {
        this.events.change.notify(this.current);
      }
      if (this.events.velocityChange) {
        this.events.velocityChange.notify(this.getVelocity());
      }
      if (render && this.events.renderRequest) {
        this.events.renderRequest.notify(this.current);
      }
    };
    this.scheduleVelocityCheck = () => frame$1.postRender(this.velocityCheck);
    this.velocityCheck = ({ timestamp }) => {
      if (timestamp !== this.lastUpdated) {
        this.prev = this.current;
        if (this.events.velocityChange) {
          this.events.velocityChange.notify(this.getVelocity());
        }
      }
    };
    this.hasAnimated = false;
    this.prev = this.current = init2;
    this.canTrackVelocity = isFloat$1(this.current);
    this.owner = options.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(subscription) {
    if (process.env.NODE_ENV !== "production") {
      warnOnce$1(false, `value.onChange(callback) is deprecated. Switch to value.on("change", callback).`);
    }
    return this.on("change", subscription);
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager$1();
    }
    const unsubscribe = this.events[eventName].add(callback);
    if (eventName === "change") {
      return () => {
        unsubscribe();
        frame$1.read(() => {
          if (!this.events.change.getSize()) {
            this.stop();
          }
        });
      };
    }
    return unsubscribe;
  }
  clearListeners() {
    for (const eventManagers in this.events) {
      this.events[eventManagers].clear();
    }
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(passiveEffect, stopPassiveEffect) {
    this.passiveEffect = passiveEffect;
    this.stopPassiveEffect = stopPassiveEffect;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(v, render = true) {
    if (!render || !this.passiveEffect) {
      this.updateAndNotify(v, render);
    } else {
      this.passiveEffect(v, this.updateAndNotify);
    }
  }
  setWithVelocity(prev2, current, delta) {
    this.set(current);
    this.prev = prev2;
    this.timeDelta = delta;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(v) {
    this.updateAndNotify(v);
    this.prev = v;
    this.stop();
    if (this.stopPassiveEffect)
      this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      velocityPerSecond$1(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(startAnimation) {
    this.stop();
    return new Promise((resolve) => {
      this.hasAnimated = true;
      this.animation = startAnimation(resolve);
      if (this.events.animationStart) {
        this.events.animationStart.notify();
      }
    }).then(() => {
      if (this.events.animationComplete) {
        this.events.animationComplete.notify();
      }
      this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    if (this.animation) {
      this.animation.stop();
      if (this.events.animationCancel) {
        this.events.animationCancel.notify();
      }
    }
    this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners();
    this.stop();
    if (this.stopPassiveEffect) {
      this.stopPassiveEffect();
    }
  }
};
function motionValue$1(init2, options) {
  return new MotionValue$1(init2, options);
}
const testValueType$1 = (v) => (type) => type.test(v);
const auto$1 = {
  test: (v) => v === "auto",
  parse: (v) => v
};
const dimensionValueTypes$1 = [number$1, px$1, percent$1, degrees$1, vw$1, vh$1, auto$1];
const findDimensionValueType$1 = (v) => dimensionValueTypes$1.find(testValueType$1(v));
const valueTypes$1 = [...dimensionValueTypes$1, color$1, complex$1];
const findValueType$1 = (v) => valueTypes$1.find(testValueType$1(v));
function setMotionValue$1(visualElement, key, value) {
  if (visualElement.hasValue(key)) {
    visualElement.getValue(key).set(value);
  } else {
    visualElement.addValue(key, motionValue$1(value));
  }
}
function setTarget$1(visualElement, definition) {
  const resolved = resolveVariant$1(visualElement, definition);
  let _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, { transitionEnd = {}, transition = {} } = _a, target = __objRest(_a, ["transitionEnd", "transition"]);
  target = __spreadValues(__spreadValues({}, target), transitionEnd);
  for (const key in target) {
    const value = resolveFinalValueInKeyframes$1(target[key]);
    setMotionValue$1(visualElement, key, value);
  }
}
function checkTargetForNewValues(visualElement, target, origin) {
  var _a, _b;
  const newValueKeys = Object.keys(target).filter((key) => !visualElement.hasValue(key));
  const numNewValues = newValueKeys.length;
  if (!numNewValues)
    return;
  for (let i = 0; i < numNewValues; i++) {
    const key = newValueKeys[i];
    const targetValue = target[key];
    let value = null;
    if (Array.isArray(targetValue)) {
      value = targetValue[0];
    }
    if (value === null) {
      value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
    }
    if (value === void 0 || value === null)
      continue;
    if (typeof value === "string" && (isNumericalString$1(value) || isZeroValueString$1(value))) {
      value = parseFloat(value);
    } else if (!findValueType$1(value) && complex$1.test(targetValue)) {
      value = getAnimatableNone$2(key, targetValue);
    }
    visualElement.addValue(key, motionValue$1(value, { owner: visualElement }));
    if (origin[key] === void 0) {
      origin[key] = value;
    }
    if (value !== null)
      visualElement.setBaseTarget(key, value);
  }
}
function getOriginFromTransition(key, transition) {
  if (!transition)
    return;
  const valueTransition = transition[key] || transition["default"] || transition;
  return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
  const origin = {};
  for (const key in target) {
    const transitionOrigin = getOriginFromTransition(key, transition);
    if (transitionOrigin !== void 0) {
      origin[key] = transitionOrigin;
    } else {
      const value = visualElement.getValue(key);
      if (value) {
        origin[key] = value.get();
      }
    }
  }
  return origin;
}
function shouldBlockAnimation$1({ protectedKeys, needsAnimating }, key) {
  const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
  needsAnimating[key] = false;
  return shouldBlock;
}
function hasKeyframesChanged$1(value, target) {
  const current = value.get();
  if (Array.isArray(target)) {
    for (let i = 0; i < target.length; i++) {
      if (target[i] !== current)
        return true;
    }
  } else {
    return current !== target;
  }
}
function animateTarget$1(visualElement, definition, { delay: delay2 = 0, transitionOverride, type } = {}) {
  let _a = visualElement.makeTargetAnimatable(definition), { transition = visualElement.getDefaultTransition(), transitionEnd } = _a, target = __objRest(_a, ["transition", "transitionEnd"]);
  const willChange = visualElement.getValue("willChange");
  if (transitionOverride)
    transition = transitionOverride;
  const animations2 = [];
  const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
  for (const key in target) {
    const value = visualElement.getValue(key);
    const valueTarget = target[key];
    if (!value || valueTarget === void 0 || animationTypeState && shouldBlockAnimation$1(animationTypeState, key)) {
      continue;
    }
    const valueTransition = __spreadValues({
      delay: delay2,
      elapsed: 0
    }, getValueTransition$1(transition || {}, key));
    if (window.HandoffAppearAnimations) {
      const appearId = visualElement.getProps()[optimizedAppearDataAttribute$1];
      if (appearId) {
        const elapsed = window.HandoffAppearAnimations(appearId, key, value, frame$1);
        if (elapsed !== null) {
          valueTransition.elapsed = elapsed;
          valueTransition.isHandoff = true;
        }
      }
    }
    let canSkip = !valueTransition.isHandoff && !hasKeyframesChanged$1(value, valueTarget);
    if (valueTransition.type === "spring" && (value.getVelocity() || valueTransition.velocity)) {
      canSkip = false;
    }
    if (value.animation) {
      canSkip = false;
    }
    if (canSkip)
      continue;
    value.start(animateMotionValue$1(key, value, valueTarget, visualElement.shouldReduceMotion && transformProps$1.has(key) ? { type: false } : valueTransition));
    const animation = value.animation;
    if (isWillChangeMotionValue$1(willChange)) {
      willChange.add(key);
      animation.then(() => willChange.remove(key));
    }
    animations2.push(animation);
  }
  if (transitionEnd) {
    Promise.all(animations2).then(() => {
      transitionEnd && setTarget$1(visualElement, transitionEnd);
    });
  }
  return animations2;
}
function animateVariant$1(visualElement, variant, options = {}) {
  const resolved = resolveVariant$1(visualElement, variant, options.custom);
  let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
  if (options.transitionOverride) {
    transition = options.transitionOverride;
  }
  const getAnimation = resolved ? () => Promise.all(animateTarget$1(visualElement, resolved, options)) : () => Promise.resolve();
  const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0) => {
    const { delayChildren = 0, staggerChildren, staggerDirection } = transition;
    return animateChildren$1(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
  } : () => Promise.resolve();
  const { when } = transition;
  if (when) {
    const [first, last] = when === "beforeChildren" ? [getAnimation, getChildAnimations] : [getChildAnimations, getAnimation];
    return first().then(() => last());
  } else {
    return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
  }
}
function animateChildren$1(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
  const animations2 = [];
  const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
  const generateStaggerDuration = staggerDirection === 1 ? (i = 0) => i * staggerChildren : (i = 0) => maxStaggerDuration - i * staggerChildren;
  Array.from(visualElement.variantChildren).sort(sortByTreeOrder$1).forEach((child, i) => {
    child.notify("AnimationStart", variant);
    animations2.push(animateVariant$1(child, variant, __spreadProps(__spreadValues({}, options), {
      delay: delayChildren + generateStaggerDuration(i)
    })).then(() => child.notify("AnimationComplete", variant)));
  });
  return Promise.all(animations2);
}
function sortByTreeOrder$1(a2, b) {
  return a2.sortNodePosition(b);
}
function animateVisualElement$1(visualElement, definition, options = {}) {
  visualElement.notify("AnimationStart", definition);
  let animation;
  if (Array.isArray(definition)) {
    const animations2 = definition.map((variant) => animateVariant$1(visualElement, variant, options));
    animation = Promise.all(animations2);
  } else if (typeof definition === "string") {
    animation = animateVariant$1(visualElement, definition, options);
  } else {
    const resolvedDefinition = typeof definition === "function" ? resolveVariant$1(visualElement, definition, options.custom) : definition;
    animation = Promise.all(animateTarget$1(visualElement, resolvedDefinition, options));
  }
  return animation.then(() => visualElement.notify("AnimationComplete", definition));
}
const reversePriorityOrder$1 = [...variantPriorityOrder$1].reverse();
const numAnimationTypes$1 = variantPriorityOrder$1.length;
function animateList$1(visualElement) {
  return (animations2) => Promise.all(animations2.map(({ animation, options }) => animateVisualElement$1(visualElement, animation, options)));
}
function createAnimationState$1(visualElement) {
  let animate = animateList$1(visualElement);
  const state = createState$1();
  let isInitialRender = true;
  const buildResolvedTypeValues = (acc, definition) => {
    const resolved = resolveVariant$1(visualElement, definition);
    if (resolved) {
      const _a = resolved, { transition, transitionEnd } = _a, target = __objRest(_a, ["transition", "transitionEnd"]);
      acc = __spreadValues(__spreadValues(__spreadValues({}, acc), target), transitionEnd);
    }
    return acc;
  };
  function setAnimateFunction(makeAnimator) {
    animate = makeAnimator(visualElement);
  }
  function animateChanges(options, changedActiveType) {
    const props = visualElement.getProps();
    const context = visualElement.getVariantContext(true) || {};
    const animations2 = [];
    const removedKeys = /* @__PURE__ */ new Set();
    let encounteredKeys = {};
    let removedVariantIndex = Infinity;
    for (let i = 0; i < numAnimationTypes$1; i++) {
      const type = reversePriorityOrder$1[i];
      const typeState = state[type];
      const prop = props[type] !== void 0 ? props[type] : context[type];
      const propIsVariant = isVariantLabel$1(prop);
      const activeDelta = type === changedActiveType ? typeState.isActive : null;
      if (activeDelta === false)
        removedVariantIndex = i;
      let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
      if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) {
        isInherited = false;
      }
      typeState.protectedKeys = __spreadValues({}, encounteredKeys);
      if (
        // If it isn't active and hasn't *just* been set as inactive
        !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
        !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
        isAnimationControls$1(prop) || typeof prop === "boolean"
      ) {
        continue;
      }
      const variantDidChange = checkVariantsDidChange$1(typeState.prevProp, prop);
      let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
      type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
      i > removedVariantIndex && propIsVariant;
      let handledRemovedValues = false;
      const definitionList = Array.isArray(prop) ? prop : [prop];
      let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
      if (activeDelta === false)
        resolvedValues = {};
      const { prevResolvedValues = {} } = typeState;
      const allKeys = __spreadValues(__spreadValues({}, prevResolvedValues), resolvedValues);
      const markToAnimate = (key) => {
        shouldAnimateType = true;
        if (removedKeys.has(key)) {
          handledRemovedValues = true;
          removedKeys.delete(key);
        }
        typeState.needsAnimating[key] = true;
      };
      for (const key in allKeys) {
        const next2 = resolvedValues[key];
        const prev2 = prevResolvedValues[key];
        if (encounteredKeys.hasOwnProperty(key))
          continue;
        let valueHasChanged = false;
        if (isKeyframesTarget$1(next2) && isKeyframesTarget$1(prev2)) {
          valueHasChanged = !shallowCompare$1(next2, prev2);
        } else {
          valueHasChanged = next2 !== prev2;
        }
        if (valueHasChanged) {
          if (next2 !== void 0) {
            markToAnimate(key);
          } else {
            removedKeys.add(key);
          }
        } else if (next2 !== void 0 && removedKeys.has(key)) {
          markToAnimate(key);
        } else {
          typeState.protectedKeys[key] = true;
        }
      }
      typeState.prevProp = prop;
      typeState.prevResolvedValues = resolvedValues;
      if (typeState.isActive) {
        encounteredKeys = __spreadValues(__spreadValues({}, encounteredKeys), resolvedValues);
      }
      if (isInitialRender && visualElement.blockInitialAnimation) {
        shouldAnimateType = false;
      }
      if (shouldAnimateType && (!isInherited || handledRemovedValues)) {
        animations2.push(...definitionList.map((animation) => ({
          animation,
          options: __spreadValues({ type }, options)
        })));
      }
    }
    if (removedKeys.size) {
      const fallbackAnimation = {};
      removedKeys.forEach((key) => {
        const fallbackTarget = visualElement.getBaseTarget(key);
        if (fallbackTarget !== void 0) {
          fallbackAnimation[key] = fallbackTarget;
        }
      });
      animations2.push({ animation: fallbackAnimation });
    }
    let shouldAnimate = Boolean(animations2.length);
    if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) {
      shouldAnimate = false;
    }
    isInitialRender = false;
    return shouldAnimate ? animate(animations2) : Promise.resolve();
  }
  function setActive(type, isActive, options) {
    var _a;
    if (state[type].isActive === isActive)
      return Promise.resolve();
    (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
      var _a2;
      return (_a2 = child.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(type, isActive);
    });
    state[type].isActive = isActive;
    const animations2 = animateChanges(options, type);
    for (const key in state) {
      state[key].protectedKeys = {};
    }
    return animations2;
  }
  return {
    animateChanges,
    setActive,
    setAnimateFunction,
    getState: () => state
  };
}
function checkVariantsDidChange$1(prev2, next2) {
  if (typeof next2 === "string") {
    return next2 !== prev2;
  } else if (Array.isArray(next2)) {
    return !shallowCompare$1(next2, prev2);
  }
  return false;
}
function createTypeState$1(isActive = false) {
  return {
    isActive,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState$1() {
  return {
    animate: createTypeState$1(true),
    whileInView: createTypeState$1(),
    whileHover: createTypeState$1(),
    whileTap: createTypeState$1(),
    whileDrag: createTypeState$1(),
    whileFocus: createTypeState$1(),
    exit: createTypeState$1()
  };
}
let AnimationFeature$1 = class AnimationFeature extends Feature$1 {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(node2) {
    super(node2);
    node2.animationState || (node2.animationState = createAnimationState$1(node2));
  }
  updateAnimationControlsSubscription() {
    const { animate } = this.node.getProps();
    this.unmount();
    if (isAnimationControls$1(animate)) {
      this.unmount = animate.subscribe(this.node);
    }
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate } = this.node.getProps();
    const { animate: prevAnimate } = this.node.prevProps || {};
    if (animate !== prevAnimate) {
      this.updateAnimationControlsSubscription();
    }
  }
  unmount() {
  }
};
let id$3 = 0;
let ExitAnimationFeature$1 = class ExitAnimationFeature extends Feature$1 {
  constructor() {
    super(...arguments);
    this.id = id$3++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent, onExitComplete, custom: custom2 } = this.node.presenceContext;
    const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || isPresent === prevIsPresent) {
      return;
    }
    const exitAnimation = this.node.animationState.setActive("exit", !isPresent, { custom: custom2 !== null && custom2 !== void 0 ? custom2 : this.node.getProps().custom });
    if (onExitComplete && !isPresent) {
      exitAnimation.then(() => onExitComplete(this.id));
    }
  }
  mount() {
    const { register } = this.node.presenceContext || {};
    if (register) {
      this.unmount = register(this.id);
    }
  }
  unmount() {
  }
};
const animations$1 = {
  animation: {
    Feature: AnimationFeature$1
  },
  exit: {
    Feature: ExitAnimationFeature$1
  }
};
const distance$1 = (a2, b) => Math.abs(a2 - b);
function distance2D$1(a2, b) {
  const xDelta = distance$1(a2.x, b.x);
  const yDelta = distance$1(a2.y, b.y);
  return Math.sqrt(__pow(xDelta, 2) + __pow(yDelta, 2));
}
let PanSession$1 = class PanSession {
  constructor(event, handlers, { transformPagePoint, contextWindow, dragSnapToOrigin = false } = {}) {
    this.startEvent = null;
    this.lastMoveEvent = null;
    this.lastMoveEventInfo = null;
    this.handlers = {};
    this.contextWindow = window;
    this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const info2 = getPanInfo$1(this.lastMoveEventInfo, this.history);
      const isPanStarted = this.startEvent !== null;
      const isDistancePastThreshold = distance2D$1(info2.offset, { x: 0, y: 0 }) >= 3;
      if (!isPanStarted && !isDistancePastThreshold)
        return;
      const { point: point2 } = info2;
      const { timestamp: timestamp2 } = frameData$1;
      this.history.push(__spreadProps(__spreadValues({}, point2), { timestamp: timestamp2 }));
      const { onStart, onMove } = this.handlers;
      if (!isPanStarted) {
        onStart && onStart(this.lastMoveEvent, info2);
        this.startEvent = this.lastMoveEvent;
      }
      onMove && onMove(this.lastMoveEvent, info2);
    };
    this.handlePointerMove = (event2, info2) => {
      this.lastMoveEvent = event2;
      this.lastMoveEventInfo = transformPoint$1(info2, this.transformPagePoint);
      frame$1.update(this.updatePoint, true);
    };
    this.handlePointerUp = (event2, info2) => {
      this.end();
      const { onEnd, onSessionEnd, resumeAnimation } = this.handlers;
      if (this.dragSnapToOrigin)
        resumeAnimation && resumeAnimation();
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const panInfo = getPanInfo$1(event2.type === "pointercancel" ? this.lastMoveEventInfo : transformPoint$1(info2, this.transformPagePoint), this.history);
      if (this.startEvent && onEnd) {
        onEnd(event2, panInfo);
      }
      onSessionEnd && onSessionEnd(event2, panInfo);
    };
    if (!isPrimaryPointer$1(event))
      return;
    this.dragSnapToOrigin = dragSnapToOrigin;
    this.handlers = handlers;
    this.transformPagePoint = transformPagePoint;
    this.contextWindow = contextWindow || window;
    const info = extractEventInfo$1(event);
    const initialInfo = transformPoint$1(info, this.transformPagePoint);
    const { point } = initialInfo;
    const { timestamp } = frameData$1;
    this.history = [__spreadProps(__spreadValues({}, point), { timestamp })];
    const { onSessionStart } = handlers;
    onSessionStart && onSessionStart(event, getPanInfo$1(initialInfo, this.history));
    this.removeListeners = pipe$1(addPointerEvent$1(this.contextWindow, "pointermove", this.handlePointerMove), addPointerEvent$1(this.contextWindow, "pointerup", this.handlePointerUp), addPointerEvent$1(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(handlers) {
    this.handlers = handlers;
  }
  end() {
    this.removeListeners && this.removeListeners();
    cancelFrame$1(this.updatePoint);
  }
};
function transformPoint$1(info, transformPagePoint) {
  return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint$1(a2, b) {
  return { x: a2.x - b.x, y: a2.y - b.y };
}
function getPanInfo$1({ point }, history) {
  return {
    point,
    delta: subtractPoint$1(point, lastDevicePoint$1(history)),
    offset: subtractPoint$1(point, startDevicePoint$1(history)),
    velocity: getVelocity$1(history, 0.1)
  };
}
function startDevicePoint$1(history) {
  return history[0];
}
function lastDevicePoint$1(history) {
  return history[history.length - 1];
}
function getVelocity$1(history, timeDelta) {
  if (history.length < 2) {
    return { x: 0, y: 0 };
  }
  let i = history.length - 1;
  let timestampedPoint = null;
  const lastPoint = lastDevicePoint$1(history);
  while (i >= 0) {
    timestampedPoint = history[i];
    if (lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds$1(timeDelta)) {
      break;
    }
    i--;
  }
  if (!timestampedPoint) {
    return { x: 0, y: 0 };
  }
  const time2 = millisecondsToSeconds$1(lastPoint.timestamp - timestampedPoint.timestamp);
  if (time2 === 0) {
    return { x: 0, y: 0 };
  }
  const currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time2,
    y: (lastPoint.y - timestampedPoint.y) / time2
  };
  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }
  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }
  return currentVelocity;
}
function calcLength$1(axis) {
  return axis.max - axis.min;
}
function isNear$1(value, target = 0, maxDistance = 0.01) {
  return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta$1(delta, source, target, origin = 0.5) {
  delta.origin = origin;
  delta.originPoint = mix$1(source.min, source.max, delta.origin);
  delta.scale = calcLength$1(target) / calcLength$1(source);
  if (isNear$1(delta.scale, 1, 1e-4) || isNaN(delta.scale))
    delta.scale = 1;
  delta.translate = mix$1(target.min, target.max, delta.origin) - delta.originPoint;
  if (isNear$1(delta.translate) || isNaN(delta.translate))
    delta.translate = 0;
}
function calcBoxDelta$1(delta, source, target, origin) {
  calcAxisDelta$1(delta.x, source.x, target.x, origin ? origin.originX : void 0);
  calcAxisDelta$1(delta.y, source.y, target.y, origin ? origin.originY : void 0);
}
function calcRelativeAxis$1(target, relative, parent) {
  target.min = parent.min + relative.min;
  target.max = target.min + calcLength$1(relative);
}
function calcRelativeBox$1(target, relative, parent) {
  calcRelativeAxis$1(target.x, relative.x, parent.x);
  calcRelativeAxis$1(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition$1(target, layout2, parent) {
  target.min = layout2.min - parent.min;
  target.max = target.min + calcLength$1(layout2);
}
function calcRelativePosition$1(target, layout2, parent) {
  calcRelativeAxisPosition$1(target.x, layout2.x, parent.x);
  calcRelativeAxisPosition$1(target.y, layout2.y, parent.y);
}
function applyConstraints$1(point, { min: min2, max: max2 }, elastic) {
  if (min2 !== void 0 && point < min2) {
    point = elastic ? mix$1(min2, point, elastic.min) : Math.max(point, min2);
  } else if (max2 !== void 0 && point > max2) {
    point = elastic ? mix$1(max2, point, elastic.max) : Math.min(point, max2);
  }
  return point;
}
function calcRelativeAxisConstraints$1(axis, min2, max2) {
  return {
    min: min2 !== void 0 ? axis.min + min2 : void 0,
    max: max2 !== void 0 ? axis.max + max2 - (axis.max - axis.min) : void 0
  };
}
function calcRelativeConstraints$1(layoutBox, { top: top2, left: left2, bottom: bottom2, right: right2 }) {
  return {
    x: calcRelativeAxisConstraints$1(layoutBox.x, left2, right2),
    y: calcRelativeAxisConstraints$1(layoutBox.y, top2, bottom2)
  };
}
function calcViewportAxisConstraints$1(layoutAxis, constraintsAxis) {
  let min2 = constraintsAxis.min - layoutAxis.min;
  let max2 = constraintsAxis.max - layoutAxis.max;
  if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) {
    [min2, max2] = [max2, min2];
  }
  return { min: min2, max: max2 };
}
function calcViewportConstraints$1(layoutBox, constraintsBox) {
  return {
    x: calcViewportAxisConstraints$1(layoutBox.x, constraintsBox.x),
    y: calcViewportAxisConstraints$1(layoutBox.y, constraintsBox.y)
  };
}
function calcOrigin$2(source, target) {
  let origin = 0.5;
  const sourceLength = calcLength$1(source);
  const targetLength = calcLength$1(target);
  if (targetLength > sourceLength) {
    origin = progress$1(target.min, target.max - sourceLength, source.min);
  } else if (sourceLength > targetLength) {
    origin = progress$1(source.min, source.max - targetLength, target.min);
  }
  return clamp$1(0, 1, origin);
}
function rebaseAxisConstraints$1(layout2, constraints) {
  const relativeConstraints = {};
  if (constraints.min !== void 0) {
    relativeConstraints.min = constraints.min - layout2.min;
  }
  if (constraints.max !== void 0) {
    relativeConstraints.max = constraints.max - layout2.min;
  }
  return relativeConstraints;
}
const defaultElastic$1 = 0.35;
function resolveDragElastic$1(dragElastic = defaultElastic$1) {
  if (dragElastic === false) {
    dragElastic = 0;
  } else if (dragElastic === true) {
    dragElastic = defaultElastic$1;
  }
  return {
    x: resolveAxisElastic$1(dragElastic, "left", "right"),
    y: resolveAxisElastic$1(dragElastic, "top", "bottom")
  };
}
function resolveAxisElastic$1(dragElastic, minLabel, maxLabel) {
  return {
    min: resolvePointElastic$1(dragElastic, minLabel),
    max: resolvePointElastic$1(dragElastic, maxLabel)
  };
}
function resolvePointElastic$1(dragElastic, label) {
  return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}
const createAxisDelta$1 = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
});
const createDelta$1 = () => ({
  x: createAxisDelta$1(),
  y: createAxisDelta$1()
});
const createAxis$1 = () => ({ min: 0, max: 0 });
const createBox$1 = () => ({
  x: createAxis$1(),
  y: createAxis$1()
});
function eachAxis$1(callback) {
  return [callback("x"), callback("y")];
}
function convertBoundingBoxToBox$1({ top: top2, left: left2, right: right2, bottom: bottom2 }) {
  return {
    x: { min: left2, max: right2 },
    y: { min: top2, max: bottom2 }
  };
}
function convertBoxToBoundingBox$1({ x: x2, y }) {
  return { top: y.min, right: x2.max, bottom: y.max, left: x2.min };
}
function transformBoxPoints$1(point, transformPoint2) {
  if (!transformPoint2)
    return point;
  const topLeft = transformPoint2({ x: point.left, y: point.top });
  const bottomRight = transformPoint2({ x: point.right, y: point.bottom });
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x
  };
}
function isIdentityScale$1(scale2) {
  return scale2 === void 0 || scale2 === 1;
}
function hasScale$1({ scale: scale2, scaleX, scaleY }) {
  return !isIdentityScale$1(scale2) || !isIdentityScale$1(scaleX) || !isIdentityScale$1(scaleY);
}
function hasTransform$1(values2) {
  return hasScale$1(values2) || has2DTranslate$1(values2) || values2.z || values2.rotate || values2.rotateX || values2.rotateY;
}
function has2DTranslate$1(values2) {
  return is2DTranslate$1(values2.x) || is2DTranslate$1(values2.y);
}
function is2DTranslate$1(value) {
  return value && value !== "0%";
}
function scalePoint$1(point, scale2, originPoint) {
  const distanceFromOrigin = point - originPoint;
  const scaled = scale2 * distanceFromOrigin;
  return originPoint + scaled;
}
function applyPointDelta$1(point, translate, scale2, originPoint, boxScale) {
  if (boxScale !== void 0) {
    point = scalePoint$1(point, boxScale, originPoint);
  }
  return scalePoint$1(point, scale2, originPoint) + translate;
}
function applyAxisDelta$1(axis, translate = 0, scale2 = 1, originPoint, boxScale) {
  axis.min = applyPointDelta$1(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = applyPointDelta$1(axis.max, translate, scale2, originPoint, boxScale);
}
function applyBoxDelta$1(box, { x: x2, y }) {
  applyAxisDelta$1(box.x, x2.translate, x2.scale, x2.originPoint);
  applyAxisDelta$1(box.y, y.translate, y.scale, y.originPoint);
}
function applyTreeDeltas$1(box, treeScale, treePath, isSharedTransition = false) {
  const treeLength = treePath.length;
  if (!treeLength)
    return;
  treeScale.x = treeScale.y = 1;
  let node2;
  let delta;
  for (let i = 0; i < treeLength; i++) {
    node2 = treePath[i];
    delta = node2.projectionDelta;
    const instance = node2.instance;
    if (instance && instance.style && instance.style.display === "contents") {
      continue;
    }
    if (isSharedTransition && node2.options.layoutScroll && node2.scroll && node2 !== node2.root) {
      transformBox$1(box, {
        x: -node2.scroll.offset.x,
        y: -node2.scroll.offset.y
      });
    }
    if (delta) {
      treeScale.x *= delta.x.scale;
      treeScale.y *= delta.y.scale;
      applyBoxDelta$1(box, delta);
    }
    if (isSharedTransition && hasTransform$1(node2.latestValues)) {
      transformBox$1(box, node2.latestValues);
    }
  }
  treeScale.x = snapToDefault(treeScale.x);
  treeScale.y = snapToDefault(treeScale.y);
}
function snapToDefault(scale2) {
  if (Number.isInteger(scale2))
    return scale2;
  return scale2 > 1.0000000000001 || scale2 < 0.999999999999 ? scale2 : 1;
}
function translateAxis$1(axis, distance2) {
  axis.min = axis.min + distance2;
  axis.max = axis.max + distance2;
}
function transformAxis$1(axis, transforms, [key, scaleKey, originKey]) {
  const axisOrigin = transforms[originKey] !== void 0 ? transforms[originKey] : 0.5;
  const originPoint = mix$1(axis.min, axis.max, axisOrigin);
  applyAxisDelta$1(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
const xKeys$2 = ["x", "scaleX", "originX"];
const yKeys$2 = ["y", "scaleY", "originY"];
function transformBox$1(box, transform) {
  transformAxis$1(box.x, transform, xKeys$2);
  transformAxis$1(box.y, transform, yKeys$2);
}
function measureViewportBox$1(instance, transformPoint2) {
  return convertBoundingBoxToBox$1(transformBoxPoints$1(instance.getBoundingClientRect(), transformPoint2));
}
function measurePageBox$1(element, rootProjectionNode2, transformPagePoint) {
  const viewportBox = measureViewportBox$1(element, transformPagePoint);
  const { scroll } = rootProjectionNode2;
  if (scroll) {
    translateAxis$1(viewportBox.x, scroll.offset.x);
    translateAxis$1(viewportBox.y, scroll.offset.y);
  }
  return viewportBox;
}
const getContextWindow$1 = ({ current }) => {
  return current ? current.ownerDocument.defaultView : null;
};
const elementDragControls$1 = /* @__PURE__ */ new WeakMap();
let VisualElementDragControls$1 = class VisualElementDragControls {
  constructor(visualElement) {
    this.openGlobalLock = null;
    this.isDragging = false;
    this.currentDirection = null;
    this.originPoint = { x: 0, y: 0 };
    this.constraints = false;
    this.hasMutatedConstraints = false;
    this.elastic = createBox$1();
    this.visualElement = visualElement;
  }
  start(originEvent, { snapToCursor = false } = {}) {
    const { presenceContext } = this.visualElement;
    if (presenceContext && presenceContext.isPresent === false)
      return;
    const onSessionStart = (event) => {
      const { dragSnapToOrigin: dragSnapToOrigin2 } = this.getProps();
      dragSnapToOrigin2 ? this.pauseAnimation() : this.stopAnimation();
      if (snapToCursor) {
        this.snapToCursor(extractEventInfo$1(event, "page").point);
      }
    };
    const onStart = (event, info) => {
      const { drag: drag2, dragPropagation, onDragStart } = this.getProps();
      if (drag2 && !dragPropagation) {
        if (this.openGlobalLock)
          this.openGlobalLock();
        this.openGlobalLock = getGlobalLock$1(drag2);
        if (!this.openGlobalLock)
          return;
      }
      this.isDragging = true;
      this.currentDirection = null;
      this.resolveConstraints();
      if (this.visualElement.projection) {
        this.visualElement.projection.isAnimationBlocked = true;
        this.visualElement.projection.target = void 0;
      }
      eachAxis$1((axis) => {
        let current = this.getAxisMotionValue(axis).get() || 0;
        if (percent$1.test(current)) {
          const { projection } = this.visualElement;
          if (projection && projection.layout) {
            const measuredAxis = projection.layout.layoutBox[axis];
            if (measuredAxis) {
              const length2 = calcLength$1(measuredAxis);
              current = length2 * (parseFloat(current) / 100);
            }
          }
        }
        this.originPoint[axis] = current;
      });
      if (onDragStart) {
        frame$1.update(() => onDragStart(event, info), false, true);
      }
      const { animationState } = this.visualElement;
      animationState && animationState.setActive("whileDrag", true);
    };
    const onMove = (event, info) => {
      const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag } = this.getProps();
      if (!dragPropagation && !this.openGlobalLock)
        return;
      const { offset: offset2 } = info;
      if (dragDirectionLock && this.currentDirection === null) {
        this.currentDirection = getCurrentDirection$1(offset2);
        if (this.currentDirection !== null) {
          onDirectionLock && onDirectionLock(this.currentDirection);
        }
        return;
      }
      this.updateAxis("x", info.point, offset2);
      this.updateAxis("y", info.point, offset2);
      this.visualElement.render();
      onDrag && onDrag(event, info);
    };
    const onSessionEnd = (event, info) => this.stop(event, info);
    const resumeAnimation = () => eachAxis$1((axis) => {
      var _a;
      return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
    });
    const { dragSnapToOrigin } = this.getProps();
    this.panSession = new PanSession$1(originEvent, {
      onSessionStart,
      onStart,
      onMove,
      onSessionEnd,
      resumeAnimation
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin,
      contextWindow: getContextWindow$1(this.visualElement)
    });
  }
  stop(event, info) {
    const isDragging = this.isDragging;
    this.cancel();
    if (!isDragging)
      return;
    const { velocity } = info;
    this.startAnimation(velocity);
    const { onDragEnd } = this.getProps();
    if (onDragEnd) {
      frame$1.update(() => onDragEnd(event, info));
    }
  }
  cancel() {
    this.isDragging = false;
    const { projection, animationState } = this.visualElement;
    if (projection) {
      projection.isAnimationBlocked = false;
    }
    this.panSession && this.panSession.end();
    this.panSession = void 0;
    const { dragPropagation } = this.getProps();
    if (!dragPropagation && this.openGlobalLock) {
      this.openGlobalLock();
      this.openGlobalLock = null;
    }
    animationState && animationState.setActive("whileDrag", false);
  }
  updateAxis(axis, _point, offset2) {
    const { drag: drag2 } = this.getProps();
    if (!offset2 || !shouldDrag$1(axis, drag2, this.currentDirection))
      return;
    const axisValue = this.getAxisMotionValue(axis);
    let next2 = this.originPoint[axis] + offset2[axis];
    if (this.constraints && this.constraints[axis]) {
      next2 = applyConstraints$1(next2, this.constraints[axis], this.elastic[axis]);
    }
    axisValue.set(next2);
  }
  resolveConstraints() {
    var _a;
    const { dragConstraints, dragElastic } = this.getProps();
    const layout2 = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
    const prevConstraints = this.constraints;
    if (dragConstraints && isRefObject$1(dragConstraints)) {
      if (!this.constraints) {
        this.constraints = this.resolveRefConstraints();
      }
    } else {
      if (dragConstraints && layout2) {
        this.constraints = calcRelativeConstraints$1(layout2.layoutBox, dragConstraints);
      } else {
        this.constraints = false;
      }
    }
    this.elastic = resolveDragElastic$1(dragElastic);
    if (prevConstraints !== this.constraints && layout2 && this.constraints && !this.hasMutatedConstraints) {
      eachAxis$1((axis) => {
        if (this.getAxisMotionValue(axis)) {
          this.constraints[axis] = rebaseAxisConstraints$1(layout2.layoutBox[axis], this.constraints[axis]);
        }
      });
    }
  }
  resolveRefConstraints() {
    const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
    if (!constraints || !isRefObject$1(constraints))
      return false;
    const constraintsElement = constraints.current;
    invariant$1(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection } = this.visualElement;
    if (!projection || !projection.layout)
      return false;
    const constraintsBox = measurePageBox$1(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
    let measuredConstraints = calcViewportConstraints$1(projection.layout.layoutBox, constraintsBox);
    if (onMeasureDragConstraints) {
      const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox$1(measuredConstraints));
      this.hasMutatedConstraints = !!userConstraints;
      if (userConstraints) {
        measuredConstraints = convertBoundingBoxToBox$1(userConstraints);
      }
    }
    return measuredConstraints;
  }
  startAnimation(velocity) {
    const { drag: drag2, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd } = this.getProps();
    const constraints = this.constraints || {};
    const momentumAnimations = eachAxis$1((axis) => {
      if (!shouldDrag$1(axis, drag2, this.currentDirection)) {
        return;
      }
      let transition = constraints && constraints[axis] || {};
      if (dragSnapToOrigin)
        transition = { min: 0, max: 0 };
      const bounceStiffness = dragElastic ? 200 : 1e6;
      const bounceDamping = dragElastic ? 40 : 1e7;
      const inertia2 = __spreadValues(__spreadValues({
        type: "inertia",
        velocity: dragMomentum ? velocity[axis] : 0,
        bounceStiffness,
        bounceDamping,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10
      }, dragTransition), transition);
      return this.startAxisValueAnimation(axis, inertia2);
    });
    return Promise.all(momentumAnimations).then(onDragTransitionEnd);
  }
  startAxisValueAnimation(axis, transition) {
    const axisValue = this.getAxisMotionValue(axis);
    return axisValue.start(animateMotionValue$1(axis, axisValue, 0, transition));
  }
  stopAnimation() {
    eachAxis$1((axis) => this.getAxisMotionValue(axis).stop());
  }
  pauseAnimation() {
    eachAxis$1((axis) => {
      var _a;
      return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
    });
  }
  getAnimationState(axis) {
    var _a;
    return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(axis) {
    const dragKey = "_drag" + axis.toUpperCase();
    const props = this.visualElement.getProps();
    const externalMotionValue = props[dragKey];
    return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : void 0) || 0);
  }
  snapToCursor(point) {
    eachAxis$1((axis) => {
      const { drag: drag2 } = this.getProps();
      if (!shouldDrag$1(axis, drag2, this.currentDirection))
        return;
      const { projection } = this.visualElement;
      const axisValue = this.getAxisMotionValue(axis);
      if (projection && projection.layout) {
        const { min: min2, max: max2 } = projection.layout.layoutBox[axis];
        axisValue.set(point[axis] - mix$1(min2, max2, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: drag2, dragConstraints } = this.getProps();
    const { projection } = this.visualElement;
    if (!isRefObject$1(dragConstraints) || !projection || !this.constraints)
      return;
    this.stopAnimation();
    const boxProgress = { x: 0, y: 0 };
    eachAxis$1((axis) => {
      const axisValue = this.getAxisMotionValue(axis);
      if (axisValue) {
        const latest = axisValue.get();
        boxProgress[axis] = calcOrigin$2({ min: latest, max: latest }, this.constraints[axis]);
      }
    });
    const { transformTemplate } = this.visualElement.getProps();
    this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
    projection.root && projection.root.updateScroll();
    projection.updateLayout();
    this.resolveConstraints();
    eachAxis$1((axis) => {
      if (!shouldDrag$1(axis, drag2, null))
        return;
      const axisValue = this.getAxisMotionValue(axis);
      const { min: min2, max: max2 } = this.constraints[axis];
      axisValue.set(mix$1(min2, max2, boxProgress[axis]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    elementDragControls$1.set(this.visualElement, this);
    const element = this.visualElement.current;
    const stopPointerListener = addPointerEvent$1(element, "pointerdown", (event) => {
      const { drag: drag2, dragListener = true } = this.getProps();
      drag2 && dragListener && this.start(event);
    });
    const measureDragConstraints = () => {
      const { dragConstraints } = this.getProps();
      if (isRefObject$1(dragConstraints)) {
        this.constraints = this.resolveRefConstraints();
      }
    };
    const { projection } = this.visualElement;
    const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
    if (projection && !projection.layout) {
      projection.root && projection.root.updateScroll();
      projection.updateLayout();
    }
    measureDragConstraints();
    const stopResizeListener = addDomEvent$1(window, "resize", () => this.scalePositionWithinConstraints());
    const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta, hasLayoutChanged }) => {
      if (this.isDragging && hasLayoutChanged) {
        eachAxis$1((axis) => {
          const motionValue2 = this.getAxisMotionValue(axis);
          if (!motionValue2)
            return;
          this.originPoint[axis] += delta[axis].translate;
          motionValue2.set(motionValue2.get() + delta[axis].translate);
        });
        this.visualElement.render();
      }
    });
    return () => {
      stopResizeListener();
      stopPointerListener();
      stopMeasureLayoutListener();
      stopLayoutUpdateListener && stopLayoutUpdateListener();
    };
  }
  getProps() {
    const props = this.visualElement.getProps();
    const { drag: drag2 = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = defaultElastic$1, dragMomentum = true } = props;
    return __spreadProps(__spreadValues({}, props), {
      drag: drag2,
      dragDirectionLock,
      dragPropagation,
      dragConstraints,
      dragElastic,
      dragMomentum
    });
  }
};
function shouldDrag$1(direction, drag2, currentDirection) {
  return (drag2 === true || drag2 === direction) && (currentDirection === null || currentDirection === direction);
}
function getCurrentDirection$1(offset2, lockThreshold = 10) {
  let direction = null;
  if (Math.abs(offset2.y) > lockThreshold) {
    direction = "y";
  } else if (Math.abs(offset2.x) > lockThreshold) {
    direction = "x";
  }
  return direction;
}
let DragGesture$1 = class DragGesture extends Feature$1 {
  constructor(node2) {
    super(node2);
    this.removeGroupControls = noop$1;
    this.removeListeners = noop$1;
    this.controls = new VisualElementDragControls$1(node2);
  }
  mount() {
    const { dragControls } = this.node.getProps();
    if (dragControls) {
      this.removeGroupControls = dragControls.subscribe(this.controls);
    }
    this.removeListeners = this.controls.addListeners() || noop$1;
  }
  unmount() {
    this.removeGroupControls();
    this.removeListeners();
  }
};
const asyncHandler$1 = (handler) => (event, info) => {
  if (handler) {
    frame$1.update(() => handler(event, info));
  }
};
let PanGesture$1 = class PanGesture extends Feature$1 {
  constructor() {
    super(...arguments);
    this.removePointerDownListener = noop$1;
  }
  onPointerDown(pointerDownEvent) {
    this.session = new PanSession$1(pointerDownEvent, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: getContextWindow$1(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
    return {
      onSessionStart: asyncHandler$1(onPanSessionStart),
      onStart: asyncHandler$1(onPanStart),
      onMove: onPan,
      onEnd: (event, info) => {
        delete this.session;
        if (onPanEnd) {
          frame$1.update(() => onPanEnd(event, info));
        }
      }
    };
  }
  mount() {
    this.removePointerDownListener = addPointerEvent$1(this.node.current, "pointerdown", (event) => this.onPointerDown(event));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener();
    this.session && this.session.end();
  }
};
function usePresence$1() {
  const context = useContext(PresenceContext$1);
  if (context === null)
    return [true, null];
  const { isPresent, onExitComplete, register } = context;
  const id2 = useId$1();
  useEffect(() => register(id2), []);
  const safeToRemove = () => onExitComplete && onExitComplete(id2);
  return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
const globalProjectionState$1 = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: true,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: false
};
function pixelsToPercent$1(pixels, axis) {
  if (axis.max === axis.min)
    return 0;
  return pixels / (axis.max - axis.min) * 100;
}
const correctBorderRadius$1 = {
  correct: (latest, node2) => {
    if (!node2.target)
      return latest;
    if (typeof latest === "string") {
      if (px$1.test(latest)) {
        latest = parseFloat(latest);
      } else {
        return latest;
      }
    }
    const x2 = pixelsToPercent$1(latest, node2.target.x);
    const y = pixelsToPercent$1(latest, node2.target.y);
    return `${x2}% ${y}%`;
  }
};
const correctBoxShadow$1 = {
  correct: (latest, { treeScale, projectionDelta }) => {
    const original = latest;
    const shadow = complex$1.parse(latest);
    if (shadow.length > 5)
      return original;
    const template = complex$1.createTransformer(latest);
    const offset2 = typeof shadow[0] !== "number" ? 1 : 0;
    const xScale = projectionDelta.x.scale * treeScale.x;
    const yScale = projectionDelta.y.scale * treeScale.y;
    shadow[0 + offset2] /= xScale;
    shadow[1 + offset2] /= yScale;
    const averageScale = mix$1(xScale, yScale, 0.5);
    if (typeof shadow[2 + offset2] === "number")
      shadow[2 + offset2] /= averageScale;
    if (typeof shadow[3 + offset2] === "number")
      shadow[3 + offset2] /= averageScale;
    return template(shadow);
  }
};
let MeasureLayoutWithContext$1 = class MeasureLayoutWithContext extends React__default.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
    const { projection } = visualElement;
    addScaleCorrector$1(defaultScaleCorrectors$1);
    if (projection) {
      if (layoutGroup.group)
        layoutGroup.group.add(projection);
      if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
        switchLayoutGroup.register(projection);
      }
      projection.root.didUpdate();
      projection.addEventListener("animationComplete", () => {
        this.safeToRemove();
      });
      projection.setOptions(__spreadProps(__spreadValues({}, projection.options), {
        onExitComplete: () => this.safeToRemove()
      }));
    }
    globalProjectionState$1.hasEverUpdated = true;
  }
  getSnapshotBeforeUpdate(prevProps) {
    const { layoutDependency, visualElement, drag: drag2, isPresent } = this.props;
    const projection = visualElement.projection;
    if (!projection)
      return null;
    projection.isPresent = isPresent;
    if (drag2 || prevProps.layoutDependency !== layoutDependency || layoutDependency === void 0) {
      projection.willUpdate();
    } else {
      this.safeToRemove();
    }
    if (prevProps.isPresent !== isPresent) {
      if (isPresent) {
        projection.promote();
      } else if (!projection.relegate()) {
        frame$1.postRender(() => {
          const stack = projection.getStack();
          if (!stack || !stack.members.length) {
            this.safeToRemove();
          }
        });
      }
    }
    return null;
  }
  componentDidUpdate() {
    const { projection } = this.props.visualElement;
    if (projection) {
      projection.root.didUpdate();
      queueMicrotask(() => {
        if (!projection.currentAnimation && projection.isLead()) {
          this.safeToRemove();
        }
      });
    }
  }
  componentWillUnmount() {
    const { visualElement, layoutGroup, switchLayoutGroup: promoteContext } = this.props;
    const { projection } = visualElement;
    if (projection) {
      projection.scheduleCheckAfterUnmount();
      if (layoutGroup && layoutGroup.group)
        layoutGroup.group.remove(projection);
      if (promoteContext && promoteContext.deregister)
        promoteContext.deregister(projection);
    }
  }
  safeToRemove() {
    const { safeToRemove } = this.props;
    safeToRemove && safeToRemove();
  }
  render() {
    return null;
  }
};
function MeasureLayout$1(props) {
  const [isPresent, safeToRemove] = usePresence$1();
  const layoutGroup = useContext(LayoutGroupContext$1);
  return React__default.createElement(MeasureLayoutWithContext$1, __spreadProps(__spreadValues({}, props), { layoutGroup, switchLayoutGroup: useContext(SwitchLayoutGroupContext$1), isPresent, safeToRemove }));
}
const defaultScaleCorrectors$1 = {
  borderRadius: __spreadProps(__spreadValues({}, correctBorderRadius$1), {
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  }),
  borderTopLeftRadius: correctBorderRadius$1,
  borderTopRightRadius: correctBorderRadius$1,
  borderBottomLeftRadius: correctBorderRadius$1,
  borderBottomRightRadius: correctBorderRadius$1,
  boxShadow: correctBoxShadow$1
};
const borders$1 = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
const numBorders$1 = borders$1.length;
const asNumber$1 = (value) => typeof value === "string" ? parseFloat(value) : value;
const isPx$1 = (value) => typeof value === "number" || px$1.test(value);
function mixValues$1(target, follow, lead, progress2, shouldCrossfadeOpacity, isOnlyMember) {
  if (shouldCrossfadeOpacity) {
    target.opacity = mix$1(
      0,
      // TODO Reinstate this if only child
      lead.opacity !== void 0 ? lead.opacity : 1,
      easeCrossfadeIn$1(progress2)
    );
    target.opacityExit = mix$1(follow.opacity !== void 0 ? follow.opacity : 1, 0, easeCrossfadeOut$1(progress2));
  } else if (isOnlyMember) {
    target.opacity = mix$1(follow.opacity !== void 0 ? follow.opacity : 1, lead.opacity !== void 0 ? lead.opacity : 1, progress2);
  }
  for (let i = 0; i < numBorders$1; i++) {
    const borderLabel = `border${borders$1[i]}Radius`;
    let followRadius = getRadius$1(follow, borderLabel);
    let leadRadius = getRadius$1(lead, borderLabel);
    if (followRadius === void 0 && leadRadius === void 0)
      continue;
    followRadius || (followRadius = 0);
    leadRadius || (leadRadius = 0);
    const canMix = followRadius === 0 || leadRadius === 0 || isPx$1(followRadius) === isPx$1(leadRadius);
    if (canMix) {
      target[borderLabel] = Math.max(mix$1(asNumber$1(followRadius), asNumber$1(leadRadius), progress2), 0);
      if (percent$1.test(leadRadius) || percent$1.test(followRadius)) {
        target[borderLabel] += "%";
      }
    } else {
      target[borderLabel] = leadRadius;
    }
  }
  if (follow.rotate || lead.rotate) {
    target.rotate = mix$1(follow.rotate || 0, lead.rotate || 0, progress2);
  }
}
function getRadius$1(values2, radiusName) {
  return values2[radiusName] !== void 0 ? values2[radiusName] : values2.borderRadius;
}
const easeCrossfadeIn$1 = compress$1(0, 0.5, circOut$1);
const easeCrossfadeOut$1 = compress$1(0.5, 0.95, noop$1);
function compress$1(min2, max2, easing2) {
  return (p) => {
    if (p < min2)
      return 0;
    if (p > max2)
      return 1;
    return easing2(progress$1(min2, max2, p));
  };
}
function copyAxisInto$1(axis, originAxis) {
  axis.min = originAxis.min;
  axis.max = originAxis.max;
}
function copyBoxInto$1(box, originBox) {
  copyAxisInto$1(box.x, originBox.x);
  copyAxisInto$1(box.y, originBox.y);
}
function removePointDelta$1(point, translate, scale2, originPoint, boxScale) {
  point -= translate;
  point = scalePoint$1(point, 1 / scale2, originPoint);
  if (boxScale !== void 0) {
    point = scalePoint$1(point, 1 / boxScale, originPoint);
  }
  return point;
}
function removeAxisDelta$1(axis, translate = 0, scale2 = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
  if (percent$1.test(translate)) {
    translate = parseFloat(translate);
    const relativeProgress = mix$1(sourceAxis.min, sourceAxis.max, translate / 100);
    translate = relativeProgress - sourceAxis.min;
  }
  if (typeof translate !== "number")
    return;
  let originPoint = mix$1(originAxis.min, originAxis.max, origin);
  if (axis === originAxis)
    originPoint -= translate;
  axis.min = removePointDelta$1(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = removePointDelta$1(axis.max, translate, scale2, originPoint, boxScale);
}
function removeAxisTransforms$1(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
  removeAxisDelta$1(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
const xKeys$1 = ["x", "scaleX", "originX"];
const yKeys$1 = ["y", "scaleY", "originY"];
function removeBoxTransforms$1(box, transforms, originBox, sourceBox) {
  removeAxisTransforms$1(box.x, transforms, xKeys$1, originBox ? originBox.x : void 0, sourceBox ? sourceBox.x : void 0);
  removeAxisTransforms$1(box.y, transforms, yKeys$1, originBox ? originBox.y : void 0, sourceBox ? sourceBox.y : void 0);
}
function isAxisDeltaZero$1(delta) {
  return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero$1(delta) {
  return isAxisDeltaZero$1(delta.x) && isAxisDeltaZero$1(delta.y);
}
function boxEquals$1(a2, b) {
  return a2.x.min === b.x.min && a2.x.max === b.x.max && a2.y.min === b.y.min && a2.y.max === b.y.max;
}
function boxEqualsRounded$1(a2, b) {
  return Math.round(a2.x.min) === Math.round(b.x.min) && Math.round(a2.x.max) === Math.round(b.x.max) && Math.round(a2.y.min) === Math.round(b.y.min) && Math.round(a2.y.max) === Math.round(b.y.max);
}
function aspectRatio$1(box) {
  return calcLength$1(box.x) / calcLength$1(box.y);
}
let NodeStack$1 = class NodeStack {
  constructor() {
    this.members = [];
  }
  add(node2) {
    addUniqueItem$1(this.members, node2);
    node2.scheduleRender();
  }
  remove(node2) {
    removeItem$1(this.members, node2);
    if (node2 === this.prevLead) {
      this.prevLead = void 0;
    }
    if (node2 === this.lead) {
      const prevLead = this.members[this.members.length - 1];
      if (prevLead) {
        this.promote(prevLead);
      }
    }
  }
  relegate(node2) {
    const indexOfNode = this.members.findIndex((member) => node2 === member);
    if (indexOfNode === 0)
      return false;
    let prevLead;
    for (let i = indexOfNode; i >= 0; i--) {
      const member = this.members[i];
      if (member.isPresent !== false) {
        prevLead = member;
        break;
      }
    }
    if (prevLead) {
      this.promote(prevLead);
      return true;
    } else {
      return false;
    }
  }
  promote(node2, preserveFollowOpacity) {
    const prevLead = this.lead;
    if (node2 === prevLead)
      return;
    this.prevLead = prevLead;
    this.lead = node2;
    node2.show();
    if (prevLead) {
      prevLead.instance && prevLead.scheduleRender();
      node2.scheduleRender();
      node2.resumeFrom = prevLead;
      if (preserveFollowOpacity) {
        node2.resumeFrom.preserveOpacity = true;
      }
      if (prevLead.snapshot) {
        node2.snapshot = prevLead.snapshot;
        node2.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
      }
      if (node2.root && node2.root.isUpdating) {
        node2.isLayoutDirty = true;
      }
      const { crossfade } = node2.options;
      if (crossfade === false) {
        prevLead.hide();
      }
    }
  }
  exitAnimationComplete() {
    this.members.forEach((node2) => {
      const { options, resumingFrom } = node2;
      options.onExitComplete && options.onExitComplete();
      if (resumingFrom) {
        resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
      }
    });
  }
  scheduleRender() {
    this.members.forEach((node2) => {
      node2.instance && node2.scheduleRender(false);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    if (this.lead && this.lead.snapshot) {
      this.lead.snapshot = void 0;
    }
  }
};
function buildProjectionTransform$1(delta, treeScale, latestTransform) {
  let transform = "";
  const xTranslate = delta.x.translate / treeScale.x;
  const yTranslate = delta.y.translate / treeScale.y;
  if (xTranslate || yTranslate) {
    transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
  }
  if (treeScale.x !== 1 || treeScale.y !== 1) {
    transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
  }
  if (latestTransform) {
    const { rotate, rotateX, rotateY } = latestTransform;
    if (rotate)
      transform += `rotate(${rotate}deg) `;
    if (rotateX)
      transform += `rotateX(${rotateX}deg) `;
    if (rotateY)
      transform += `rotateY(${rotateY}deg) `;
  }
  const elementScaleX = delta.x.scale * treeScale.x;
  const elementScaleY = delta.y.scale * treeScale.y;
  if (elementScaleX !== 1 || elementScaleY !== 1) {
    transform += `scale(${elementScaleX}, ${elementScaleY})`;
  }
  return transform || "none";
}
const compareByDepth$1 = (a2, b) => a2.depth - b.depth;
let FlatTree$1 = class FlatTree {
  constructor() {
    this.children = [];
    this.isDirty = false;
  }
  add(child) {
    addUniqueItem$1(this.children, child);
    this.isDirty = true;
  }
  remove(child) {
    removeItem$1(this.children, child);
    this.isDirty = true;
  }
  forEach(callback) {
    this.isDirty && this.children.sort(compareByDepth$1);
    this.isDirty = false;
    this.children.forEach(callback);
  }
};
function delay$1(callback, timeout2) {
  const start2 = performance.now();
  const checkElapsed = ({ timestamp }) => {
    const elapsed = timestamp - start2;
    if (elapsed >= timeout2) {
      cancelFrame$1(checkElapsed);
      callback(elapsed - timeout2);
    }
  };
  frame$1.read(checkElapsed, true);
  return () => cancelFrame$1(checkElapsed);
}
function record(data) {
  if (window.MotionDebug) {
    window.MotionDebug.record(data);
  }
}
function isSVGElement$1(element) {
  return element instanceof SVGElement && element.tagName !== "svg";
}
function animateSingleValue$1(value, keyframes2, options) {
  const motionValue$1$1 = isMotionValue$1(value) ? value : motionValue$1(value);
  motionValue$1$1.start(animateMotionValue$1("", motionValue$1$1, keyframes2, options));
  return motionValue$1$1.animation;
}
const transformAxes$1 = ["", "X", "Y", "Z"];
const hiddenVisibility$1 = { visibility: "hidden" };
const animationTarget$1 = 1e3;
let id$2 = 0;
const projectionFrameData = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function createProjectionNode$2({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform }) {
  return class ProjectionNode {
    constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()) {
      this.id = id$2++;
      this.animationId = 0;
      this.children = /* @__PURE__ */ new Set();
      this.options = {};
      this.isTreeAnimating = false;
      this.isAnimationBlocked = false;
      this.isLayoutDirty = false;
      this.isProjectionDirty = false;
      this.isSharedProjectionDirty = false;
      this.isTransformDirty = false;
      this.updateManuallyBlocked = false;
      this.updateBlockedByResize = false;
      this.isUpdating = false;
      this.isSVG = false;
      this.needsReset = false;
      this.shouldResetTransform = false;
      this.treeScale = { x: 1, y: 1 };
      this.eventHandlers = /* @__PURE__ */ new Map();
      this.hasTreeAnimated = false;
      this.updateScheduled = false;
      this.projectionUpdateScheduled = false;
      this.checkUpdateFailed = () => {
        if (this.isUpdating) {
          this.isUpdating = false;
          this.clearAllSnapshots();
        }
      };
      this.updateProjection = () => {
        this.projectionUpdateScheduled = false;
        projectionFrameData.totalNodes = projectionFrameData.resolvedTargetDeltas = projectionFrameData.recalculatedProjection = 0;
        this.nodes.forEach(propagateDirtyNodes$1);
        this.nodes.forEach(resolveTargetDelta$1);
        this.nodes.forEach(calcProjection$1);
        this.nodes.forEach(cleanDirtyNodes$1);
        record(projectionFrameData);
      };
      this.hasProjected = false;
      this.isVisible = true;
      this.animationProgress = 0;
      this.sharedNodes = /* @__PURE__ */ new Map();
      this.latestValues = latestValues;
      this.root = parent ? parent.root || parent : this;
      this.path = parent ? [...parent.path, parent] : [];
      this.parent = parent;
      this.depth = parent ? parent.depth + 1 : 0;
      for (let i = 0; i < this.path.length; i++) {
        this.path[i].shouldResetTransform = true;
      }
      if (this.root === this)
        this.nodes = new FlatTree$1();
    }
    addEventListener(name, handler) {
      if (!this.eventHandlers.has(name)) {
        this.eventHandlers.set(name, new SubscriptionManager$1());
      }
      return this.eventHandlers.get(name).add(handler);
    }
    notifyListeners(name, ...args) {
      const subscriptionManager = this.eventHandlers.get(name);
      subscriptionManager && subscriptionManager.notify(...args);
    }
    hasListeners(name) {
      return this.eventHandlers.has(name);
    }
    /**
     * Lifecycles
     */
    mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = isSVGElement$1(instance);
      this.instance = instance;
      const { layoutId, layout: layout2, visualElement } = this.options;
      if (visualElement && !visualElement.current) {
        visualElement.mount(instance);
      }
      this.root.nodes.add(this);
      this.parent && this.parent.children.add(this);
      if (isLayoutDirty && (layout2 || layoutId)) {
        this.isLayoutDirty = true;
      }
      if (attachResizeListener) {
        let cancelDelay;
        const resizeUnblockUpdate = () => this.root.updateBlockedByResize = false;
        attachResizeListener(instance, () => {
          this.root.updateBlockedByResize = true;
          cancelDelay && cancelDelay();
          cancelDelay = delay$1(resizeUnblockUpdate, 250);
          if (globalProjectionState$1.hasAnimatedSinceResize) {
            globalProjectionState$1.hasAnimatedSinceResize = false;
            this.nodes.forEach(finishAnimation$1);
          }
        });
      }
      if (layoutId) {
        this.root.registerSharedNode(layoutId, this);
      }
      if (this.options.animate !== false && visualElement && (layoutId || layout2)) {
        this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout }) => {
          if (this.isTreeAnimationBlocked()) {
            this.target = void 0;
            this.relativeTarget = void 0;
            return;
          }
          const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || defaultLayoutTransition$1;
          const { onLayoutAnimationStart, onLayoutAnimationComplete } = visualElement.getProps();
          const targetChanged = !this.targetLayout || !boxEqualsRounded$1(this.targetLayout, newLayout) || hasRelativeTargetChanged;
          const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
          if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
            if (this.resumeFrom) {
              this.resumingFrom = this.resumeFrom;
              this.resumingFrom.resumingFrom = void 0;
            }
            this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
            const animationOptions = __spreadProps(__spreadValues({}, getValueTransition$1(layoutTransition, "layout")), {
              onPlay: onLayoutAnimationStart,
              onComplete: onLayoutAnimationComplete
            });
            if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
              animationOptions.delay = 0;
              animationOptions.type = false;
            }
            this.startAnimation(animationOptions);
          } else {
            if (!hasLayoutChanged) {
              finishAnimation$1(this);
            }
            if (this.isLead() && this.options.onExitComplete) {
              this.options.onExitComplete();
            }
          }
          this.targetLayout = newLayout;
        });
      }
    }
    unmount() {
      this.options.layoutId && this.willUpdate();
      this.root.nodes.remove(this);
      const stack = this.getStack();
      stack && stack.remove(this);
      this.parent && this.parent.children.delete(this);
      this.instance = void 0;
      cancelFrame$1(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = true;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = false;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
    }
    // Note: currently only running on root node
    startUpdate() {
      if (this.isUpdateBlocked())
        return;
      this.isUpdating = true;
      this.nodes && this.nodes.forEach(resetRotation);
      this.animationId++;
    }
    getTransformTemplate() {
      const { visualElement } = this.options;
      return visualElement && visualElement.getProps().transformTemplate;
    }
    willUpdate(shouldNotifyListeners = true) {
      this.root.hasTreeAnimated = true;
      if (this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      !this.root.isUpdating && this.root.startUpdate();
      if (this.isLayoutDirty)
        return;
      this.isLayoutDirty = true;
      for (let i = 0; i < this.path.length; i++) {
        const node2 = this.path[i];
        node2.shouldResetTransform = true;
        node2.updateScroll("snapshot");
        if (node2.options.layoutRoot) {
          node2.willUpdate(false);
        }
      }
      const { layoutId, layout: layout2 } = this.options;
      if (layoutId === void 0 && !layout2)
        return;
      const transformTemplate = this.getTransformTemplate();
      this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : void 0;
      this.updateSnapshot();
      shouldNotifyListeners && this.notifyListeners("willUpdate");
    }
    update() {
      this.updateScheduled = false;
      const updateWasBlocked = this.isUpdateBlocked();
      if (updateWasBlocked) {
        this.unblockUpdate();
        this.clearAllSnapshots();
        this.nodes.forEach(clearMeasurements$1);
        return;
      }
      if (!this.isUpdating) {
        this.nodes.forEach(clearIsLayoutDirty$1);
      }
      this.isUpdating = false;
      this.nodes.forEach(resetTransformStyle$1);
      this.nodes.forEach(updateLayout$1);
      this.nodes.forEach(notifyLayoutUpdate$1);
      this.clearAllSnapshots();
      const now2 = performance.now();
      frameData$1.delta = clamp$1(0, 1e3 / 60, now2 - frameData$1.timestamp);
      frameData$1.timestamp = now2;
      frameData$1.isProcessing = true;
      steps$1.update.process(frameData$1);
      steps$1.preRender.process(frameData$1);
      steps$1.render.process(frameData$1);
      frameData$1.isProcessing = false;
    }
    didUpdate() {
      if (!this.updateScheduled) {
        this.updateScheduled = true;
        queueMicrotask(() => this.update());
      }
    }
    clearAllSnapshots() {
      this.nodes.forEach(clearSnapshot$1);
      this.sharedNodes.forEach(removeLeadSnapshots$1);
    }
    scheduleUpdateProjection() {
      if (!this.projectionUpdateScheduled) {
        this.projectionUpdateScheduled = true;
        frame$1.preRender(this.updateProjection, false, true);
      }
    }
    scheduleCheckAfterUnmount() {
      frame$1.postRender(() => {
        if (this.isLayoutDirty) {
          this.root.didUpdate();
        } else {
          this.root.checkUpdateFailed();
        }
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      if (this.snapshot || !this.instance)
        return;
      this.snapshot = this.measure();
    }
    updateLayout() {
      if (!this.instance)
        return;
      this.updateScroll();
      if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) {
        return;
      }
      if (this.resumeFrom && !this.resumeFrom.instance) {
        for (let i = 0; i < this.path.length; i++) {
          const node2 = this.path[i];
          node2.updateScroll();
        }
      }
      const prevLayout = this.layout;
      this.layout = this.measure(false);
      this.layoutCorrected = createBox$1();
      this.isLayoutDirty = false;
      this.projectionDelta = void 0;
      this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement } = this.options;
      visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : void 0);
    }
    updateScroll(phase = "measure") {
      let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) {
        needsMeasurement = false;
      }
      if (needsMeasurement) {
        this.scroll = {
          animationId: this.root.animationId,
          phase,
          isRoot: checkIsScrollRoot(this.instance),
          offset: measureScroll(this.instance)
        };
      }
    }
    resetTransform() {
      if (!resetTransform)
        return;
      const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
      const hasProjection = this.projectionDelta && !isDeltaZero$1(this.projectionDelta);
      const transformTemplate = this.getTransformTemplate();
      const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : void 0;
      const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
      if (isResetRequested && (hasProjection || hasTransform$1(this.latestValues) || transformTemplateHasChanged)) {
        resetTransform(this.instance, transformTemplateValue);
        this.shouldResetTransform = false;
        this.scheduleRender();
      }
    }
    measure(removeTransform = true) {
      const pageBox = this.measurePageBox();
      let layoutBox = this.removeElementScroll(pageBox);
      if (removeTransform) {
        layoutBox = this.removeTransform(layoutBox);
      }
      roundBox$1(layoutBox);
      return {
        animationId: this.root.animationId,
        measuredBox: pageBox,
        layoutBox,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement } = this.options;
      if (!visualElement)
        return createBox$1();
      const box = visualElement.measureViewportBox();
      const { scroll } = this.root;
      if (scroll) {
        translateAxis$1(box.x, scroll.offset.x);
        translateAxis$1(box.y, scroll.offset.y);
      }
      return box;
    }
    removeElementScroll(box) {
      const boxWithoutScroll = createBox$1();
      copyBoxInto$1(boxWithoutScroll, box);
      for (let i = 0; i < this.path.length; i++) {
        const node2 = this.path[i];
        const { scroll, options } = node2;
        if (node2 !== this.root && scroll && options.layoutScroll) {
          if (scroll.isRoot) {
            copyBoxInto$1(boxWithoutScroll, box);
            const { scroll: rootScroll } = this.root;
            if (rootScroll) {
              translateAxis$1(boxWithoutScroll.x, -rootScroll.offset.x);
              translateAxis$1(boxWithoutScroll.y, -rootScroll.offset.y);
            }
          }
          translateAxis$1(boxWithoutScroll.x, scroll.offset.x);
          translateAxis$1(boxWithoutScroll.y, scroll.offset.y);
        }
      }
      return boxWithoutScroll;
    }
    applyTransform(box, transformOnly = false) {
      const withTransforms = createBox$1();
      copyBoxInto$1(withTransforms, box);
      for (let i = 0; i < this.path.length; i++) {
        const node2 = this.path[i];
        if (!transformOnly && node2.options.layoutScroll && node2.scroll && node2 !== node2.root) {
          transformBox$1(withTransforms, {
            x: -node2.scroll.offset.x,
            y: -node2.scroll.offset.y
          });
        }
        if (!hasTransform$1(node2.latestValues))
          continue;
        transformBox$1(withTransforms, node2.latestValues);
      }
      if (hasTransform$1(this.latestValues)) {
        transformBox$1(withTransforms, this.latestValues);
      }
      return withTransforms;
    }
    removeTransform(box) {
      const boxWithoutTransform = createBox$1();
      copyBoxInto$1(boxWithoutTransform, box);
      for (let i = 0; i < this.path.length; i++) {
        const node2 = this.path[i];
        if (!node2.instance)
          continue;
        if (!hasTransform$1(node2.latestValues))
          continue;
        hasScale$1(node2.latestValues) && node2.updateSnapshot();
        const sourceBox = createBox$1();
        const nodeBox = node2.measurePageBox();
        copyBoxInto$1(sourceBox, nodeBox);
        removeBoxTransforms$1(boxWithoutTransform, node2.latestValues, node2.snapshot ? node2.snapshot.layoutBox : void 0, sourceBox);
      }
      if (hasTransform$1(this.latestValues)) {
        removeBoxTransforms$1(boxWithoutTransform, this.latestValues);
      }
      return boxWithoutTransform;
    }
    setTargetDelta(delta) {
      this.targetDelta = delta;
      this.root.scheduleUpdateProjection();
      this.isProjectionDirty = true;
    }
    setOptions(options) {
      this.options = __spreadProps(__spreadValues(__spreadValues({}, this.options), options), {
        crossfade: options.crossfade !== void 0 ? options.crossfade : true
      });
    }
    clearMeasurements() {
      this.scroll = void 0;
      this.layout = void 0;
      this.snapshot = void 0;
      this.prevTransformTemplateValue = void 0;
      this.targetDelta = void 0;
      this.target = void 0;
      this.isLayoutDirty = false;
    }
    forceRelativeParentToResolveTarget() {
      if (!this.relativeParent)
        return;
      if (this.relativeParent.resolvedRelativeTargetAt !== frameData$1.timestamp) {
        this.relativeParent.resolveTargetDelta(true);
      }
    }
    resolveTargetDelta(forceRecalculation = false) {
      var _a;
      const lead = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
      this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
      this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
      const isShared = Boolean(this.resumingFrom) || this !== lead;
      const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
      if (canSkip)
        return;
      const { layout: layout2, layoutId } = this.options;
      if (!this.layout || !(layout2 || layoutId))
        return;
      this.resolvedRelativeTargetAt = frameData$1.timestamp;
      if (!this.targetDelta && !this.relativeTarget) {
        const relativeParent = this.getClosestProjectingParent();
        if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
          this.relativeParent = relativeParent;
          this.forceRelativeParentToResolveTarget();
          this.relativeTarget = createBox$1();
          this.relativeTargetOrigin = createBox$1();
          calcRelativePosition$1(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
          copyBoxInto$1(this.relativeTarget, this.relativeTargetOrigin);
        } else {
          this.relativeParent = this.relativeTarget = void 0;
        }
      }
      if (!this.relativeTarget && !this.targetDelta)
        return;
      if (!this.target) {
        this.target = createBox$1();
        this.targetWithTransforms = createBox$1();
      }
      if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
        this.forceRelativeParentToResolveTarget();
        calcRelativeBox$1(this.target, this.relativeTarget, this.relativeParent.target);
      } else if (this.targetDelta) {
        if (Boolean(this.resumingFrom)) {
          this.target = this.applyTransform(this.layout.layoutBox);
        } else {
          copyBoxInto$1(this.target, this.layout.layoutBox);
        }
        applyBoxDelta$1(this.target, this.targetDelta);
      } else {
        copyBoxInto$1(this.target, this.layout.layoutBox);
      }
      if (this.attemptToResolveRelativeTarget) {
        this.attemptToResolveRelativeTarget = false;
        const relativeParent = this.getClosestProjectingParent();
        if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
          this.relativeParent = relativeParent;
          this.forceRelativeParentToResolveTarget();
          this.relativeTarget = createBox$1();
          this.relativeTargetOrigin = createBox$1();
          calcRelativePosition$1(this.relativeTargetOrigin, this.target, relativeParent.target);
          copyBoxInto$1(this.relativeTarget, this.relativeTargetOrigin);
        } else {
          this.relativeParent = this.relativeTarget = void 0;
        }
      }
      projectionFrameData.resolvedTargetDeltas++;
    }
    getClosestProjectingParent() {
      if (!this.parent || hasScale$1(this.parent.latestValues) || has2DTranslate$1(this.parent.latestValues)) {
        return void 0;
      }
      if (this.parent.isProjecting()) {
        return this.parent;
      } else {
        return this.parent.getClosestProjectingParent();
      }
    }
    isProjecting() {
      return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var _a;
      const lead = this.getLead();
      const isShared = Boolean(this.resumingFrom) || this !== lead;
      let canSkip = true;
      if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) {
        canSkip = false;
      }
      if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) {
        canSkip = false;
      }
      if (this.resolvedRelativeTargetAt === frameData$1.timestamp) {
        canSkip = false;
      }
      if (canSkip)
        return;
      const { layout: layout2, layoutId } = this.options;
      this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
      if (!this.isTreeAnimating) {
        this.targetDelta = this.relativeTarget = void 0;
      }
      if (!this.layout || !(layout2 || layoutId))
        return;
      copyBoxInto$1(this.layoutCorrected, this.layout.layoutBox);
      const prevTreeScaleX = this.treeScale.x;
      const prevTreeScaleY = this.treeScale.y;
      applyTreeDeltas$1(this.layoutCorrected, this.treeScale, this.path, isShared);
      if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
        lead.target = lead.layout.layoutBox;
      }
      const { target } = lead;
      if (!target) {
        if (this.projectionTransform) {
          this.projectionDelta = createDelta$1();
          this.projectionTransform = "none";
          this.scheduleRender();
        }
        return;
      }
      if (!this.projectionDelta) {
        this.projectionDelta = createDelta$1();
        this.projectionDeltaWithTransform = createDelta$1();
      }
      const prevProjectionTransform = this.projectionTransform;
      calcBoxDelta$1(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
      this.projectionTransform = buildProjectionTransform$1(this.projectionDelta, this.treeScale);
      if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
        this.hasProjected = true;
        this.scheduleRender();
        this.notifyListeners("projectionUpdate", target);
      }
      projectionFrameData.recalculatedProjection++;
    }
    hide() {
      this.isVisible = false;
    }
    show() {
      this.isVisible = true;
    }
    scheduleRender(notifyAll = true) {
      this.options.scheduleRender && this.options.scheduleRender();
      if (notifyAll) {
        const stack = this.getStack();
        stack && stack.scheduleRender();
      }
      if (this.resumingFrom && !this.resumingFrom.instance) {
        this.resumingFrom = void 0;
      }
    }
    setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
      const snapshot = this.snapshot;
      const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
      const mixedValues = __spreadValues({}, this.latestValues);
      const targetDelta = createDelta$1();
      if (!this.relativeParent || !this.relativeParent.options.layoutRoot) {
        this.relativeTarget = this.relativeTargetOrigin = void 0;
      }
      this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
      const relativeLayout = createBox$1();
      const snapshotSource = snapshot ? snapshot.source : void 0;
      const layoutSource = this.layout ? this.layout.source : void 0;
      const isSharedLayoutAnimation = snapshotSource !== layoutSource;
      const stack = this.getStack();
      const isOnlyMember = !stack || stack.members.length <= 1;
      const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade$1));
      this.animationProgress = 0;
      let prevRelativeTarget;
      this.mixTargetDelta = (latest) => {
        const progress2 = latest / 1e3;
        mixAxisDelta$1(targetDelta.x, delta.x, progress2);
        mixAxisDelta$1(targetDelta.y, delta.y, progress2);
        this.setTargetDelta(targetDelta);
        if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
          calcRelativePosition$1(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
          mixBox$1(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress2);
          if (prevRelativeTarget && boxEquals$1(this.relativeTarget, prevRelativeTarget)) {
            this.isProjectionDirty = false;
          }
          if (!prevRelativeTarget)
            prevRelativeTarget = createBox$1();
          copyBoxInto$1(prevRelativeTarget, this.relativeTarget);
        }
        if (isSharedLayoutAnimation) {
          this.animationValues = mixedValues;
          mixValues$1(mixedValues, snapshotLatestValues, this.latestValues, progress2, shouldCrossfadeOpacity, isOnlyMember);
        }
        this.root.scheduleUpdateProjection();
        this.scheduleRender();
        this.animationProgress = progress2;
      };
      this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(options) {
      this.notifyListeners("animationStart");
      this.currentAnimation && this.currentAnimation.stop();
      if (this.resumingFrom && this.resumingFrom.currentAnimation) {
        this.resumingFrom.currentAnimation.stop();
      }
      if (this.pendingAnimation) {
        cancelFrame$1(this.pendingAnimation);
        this.pendingAnimation = void 0;
      }
      this.pendingAnimation = frame$1.update(() => {
        globalProjectionState$1.hasAnimatedSinceResize = true;
        this.currentAnimation = animateSingleValue$1(0, animationTarget$1, __spreadProps(__spreadValues({}, options), {
          onUpdate: (latest) => {
            this.mixTargetDelta(latest);
            options.onUpdate && options.onUpdate(latest);
          },
          onComplete: () => {
            options.onComplete && options.onComplete();
            this.completeAnimation();
          }
        }));
        if (this.resumingFrom) {
          this.resumingFrom.currentAnimation = this.currentAnimation;
        }
        this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      if (this.resumingFrom) {
        this.resumingFrom.currentAnimation = void 0;
        this.resumingFrom.preserveOpacity = void 0;
      }
      const stack = this.getStack();
      stack && stack.exitAnimationComplete();
      this.resumingFrom = this.currentAnimation = this.animationValues = void 0;
      this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      if (this.currentAnimation) {
        this.mixTargetDelta && this.mixTargetDelta(animationTarget$1);
        this.currentAnimation.stop();
      }
      this.completeAnimation();
    }
    applyTransformsToTarget() {
      const lead = this.getLead();
      let { targetWithTransforms, target, layout: layout2, latestValues } = lead;
      if (!targetWithTransforms || !target || !layout2)
        return;
      if (this !== lead && this.layout && layout2 && shouldAnimatePositionOnly$1(this.options.animationType, this.layout.layoutBox, layout2.layoutBox)) {
        target = this.target || createBox$1();
        const xLength = calcLength$1(this.layout.layoutBox.x);
        target.x.min = lead.target.x.min;
        target.x.max = target.x.min + xLength;
        const yLength = calcLength$1(this.layout.layoutBox.y);
        target.y.min = lead.target.y.min;
        target.y.max = target.y.min + yLength;
      }
      copyBoxInto$1(targetWithTransforms, target);
      transformBox$1(targetWithTransforms, latestValues);
      calcBoxDelta$1(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
    }
    registerSharedNode(layoutId, node2) {
      if (!this.sharedNodes.has(layoutId)) {
        this.sharedNodes.set(layoutId, new NodeStack$1());
      }
      const stack = this.sharedNodes.get(layoutId);
      stack.add(node2);
      const config2 = node2.options.initialPromotionConfig;
      node2.promote({
        transition: config2 ? config2.transition : void 0,
        preserveFollowOpacity: config2 && config2.shouldPreserveFollowOpacity ? config2.shouldPreserveFollowOpacity(node2) : void 0
      });
    }
    isLead() {
      const stack = this.getStack();
      return stack ? stack.lead === this : true;
    }
    getLead() {
      var _a;
      const { layoutId } = this.options;
      return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
    }
    getPrevLead() {
      var _a;
      const { layoutId } = this.options;
      return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : void 0;
    }
    getStack() {
      const { layoutId } = this.options;
      if (layoutId)
        return this.root.sharedNodes.get(layoutId);
    }
    promote({ needsReset, transition, preserveFollowOpacity } = {}) {
      const stack = this.getStack();
      if (stack)
        stack.promote(this, preserveFollowOpacity);
      if (needsReset) {
        this.projectionDelta = void 0;
        this.needsReset = true;
      }
      if (transition)
        this.setOptions({ transition });
    }
    relegate() {
      const stack = this.getStack();
      if (stack) {
        return stack.relegate(this);
      } else {
        return false;
      }
    }
    resetRotation() {
      const { visualElement } = this.options;
      if (!visualElement)
        return;
      let hasRotate = false;
      const { latestValues } = visualElement;
      if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) {
        hasRotate = true;
      }
      if (!hasRotate)
        return;
      const resetValues = {};
      for (let i = 0; i < transformAxes$1.length; i++) {
        const key = "rotate" + transformAxes$1[i];
        if (latestValues[key]) {
          resetValues[key] = latestValues[key];
          visualElement.setStaticValue(key, 0);
        }
      }
      visualElement.render();
      for (const key in resetValues) {
        visualElement.setStaticValue(key, resetValues[key]);
      }
      visualElement.scheduleRender();
    }
    getProjectionStyles(styleProp) {
      var _a, _b;
      if (!this.instance || this.isSVG)
        return void 0;
      if (!this.isVisible) {
        return hiddenVisibility$1;
      }
      const styles2 = {
        visibility: ""
      };
      const transformTemplate = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = false;
        styles2.opacity = "";
        styles2.pointerEvents = resolveMotionValue$1(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
        styles2.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
        return styles2;
      }
      const lead = this.getLead();
      if (!this.projectionDelta || !this.layout || !lead.target) {
        const emptyStyles = {};
        if (this.options.layoutId) {
          emptyStyles.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1;
          emptyStyles.pointerEvents = resolveMotionValue$1(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
        }
        if (this.hasProjected && !hasTransform$1(this.latestValues)) {
          emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
          this.hasProjected = false;
        }
        return emptyStyles;
      }
      const valuesToRender = lead.animationValues || lead.latestValues;
      this.applyTransformsToTarget();
      styles2.transform = buildProjectionTransform$1(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
      if (transformTemplate) {
        styles2.transform = transformTemplate(valuesToRender, styles2.transform);
      }
      const { x: x2, y } = this.projectionDelta;
      styles2.transformOrigin = `${x2.origin * 100}% ${y.origin * 100}% 0`;
      if (lead.animationValues) {
        styles2.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
      } else {
        styles2.opacity = lead === this ? valuesToRender.opacity !== void 0 ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== void 0 ? valuesToRender.opacityExit : 0;
      }
      for (const key in scaleCorrectors$1) {
        if (valuesToRender[key] === void 0)
          continue;
        const { correct, applyTo } = scaleCorrectors$1[key];
        const corrected = styles2.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
        if (applyTo) {
          const num = applyTo.length;
          for (let i = 0; i < num; i++) {
            styles2[applyTo[i]] = corrected;
          }
        } else {
          styles2[key] = corrected;
        }
      }
      if (this.options.layoutId) {
        styles2.pointerEvents = lead === this ? resolveMotionValue$1(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
      }
      return styles2;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((node2) => {
        var _a;
        return (_a = node2.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
      });
      this.root.nodes.forEach(clearMeasurements$1);
      this.root.sharedNodes.clear();
    }
  };
}
function updateLayout$1(node2) {
  node2.updateLayout();
}
function notifyLayoutUpdate$1(node2) {
  var _a;
  const snapshot = ((_a = node2.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node2.snapshot;
  if (node2.isLead() && node2.layout && snapshot && node2.hasListeners("didUpdate")) {
    const { layoutBox: layout2, measuredBox: measuredLayout } = node2.layout;
    const { animationType } = node2.options;
    const isShared = snapshot.source !== node2.layout.source;
    if (animationType === "size") {
      eachAxis$1((axis) => {
        const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        const length2 = calcLength$1(axisSnapshot);
        axisSnapshot.min = layout2[axis].min;
        axisSnapshot.max = axisSnapshot.min + length2;
      });
    } else if (shouldAnimatePositionOnly$1(animationType, snapshot.layoutBox, layout2)) {
      eachAxis$1((axis) => {
        const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        const length2 = calcLength$1(layout2[axis]);
        axisSnapshot.max = axisSnapshot.min + length2;
        if (node2.relativeTarget && !node2.currentAnimation) {
          node2.isProjectionDirty = true;
          node2.relativeTarget[axis].max = node2.relativeTarget[axis].min + length2;
        }
      });
    }
    const layoutDelta = createDelta$1();
    calcBoxDelta$1(layoutDelta, layout2, snapshot.layoutBox);
    const visualDelta = createDelta$1();
    if (isShared) {
      calcBoxDelta$1(visualDelta, node2.applyTransform(measuredLayout, true), snapshot.measuredBox);
    } else {
      calcBoxDelta$1(visualDelta, layout2, snapshot.layoutBox);
    }
    const hasLayoutChanged = !isDeltaZero$1(layoutDelta);
    let hasRelativeTargetChanged = false;
    if (!node2.resumeFrom) {
      const relativeParent = node2.getClosestProjectingParent();
      if (relativeParent && !relativeParent.resumeFrom) {
        const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
        if (parentSnapshot && parentLayout) {
          const relativeSnapshot = createBox$1();
          calcRelativePosition$1(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
          const relativeLayout = createBox$1();
          calcRelativePosition$1(relativeLayout, layout2, parentLayout.layoutBox);
          if (!boxEqualsRounded$1(relativeSnapshot, relativeLayout)) {
            hasRelativeTargetChanged = true;
          }
          if (relativeParent.options.layoutRoot) {
            node2.relativeTarget = relativeLayout;
            node2.relativeTargetOrigin = relativeSnapshot;
            node2.relativeParent = relativeParent;
          }
        }
      }
    }
    node2.notifyListeners("didUpdate", {
      layout: layout2,
      snapshot,
      delta: visualDelta,
      layoutDelta,
      hasLayoutChanged,
      hasRelativeTargetChanged
    });
  } else if (node2.isLead()) {
    const { onExitComplete } = node2.options;
    onExitComplete && onExitComplete();
  }
  node2.options.transition = void 0;
}
function propagateDirtyNodes$1(node2) {
  projectionFrameData.totalNodes++;
  if (!node2.parent)
    return;
  if (!node2.isProjecting()) {
    node2.isProjectionDirty = node2.parent.isProjectionDirty;
  }
  node2.isSharedProjectionDirty || (node2.isSharedProjectionDirty = Boolean(node2.isProjectionDirty || node2.parent.isProjectionDirty || node2.parent.isSharedProjectionDirty));
  node2.isTransformDirty || (node2.isTransformDirty = node2.parent.isTransformDirty);
}
function cleanDirtyNodes$1(node2) {
  node2.isProjectionDirty = node2.isSharedProjectionDirty = node2.isTransformDirty = false;
}
function clearSnapshot$1(node2) {
  node2.clearSnapshot();
}
function clearMeasurements$1(node2) {
  node2.clearMeasurements();
}
function clearIsLayoutDirty$1(node2) {
  node2.isLayoutDirty = false;
}
function resetTransformStyle$1(node2) {
  const { visualElement } = node2.options;
  if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) {
    visualElement.notify("BeforeLayoutMeasure");
  }
  node2.resetTransform();
}
function finishAnimation$1(node2) {
  node2.finishAnimation();
  node2.targetDelta = node2.relativeTarget = node2.target = void 0;
  node2.isProjectionDirty = true;
}
function resolveTargetDelta$1(node2) {
  node2.resolveTargetDelta();
}
function calcProjection$1(node2) {
  node2.calcProjection();
}
function resetRotation(node2) {
  node2.resetRotation();
}
function removeLeadSnapshots$1(stack) {
  stack.removeLeadSnapshot();
}
function mixAxisDelta$1(output, delta, p) {
  output.translate = mix$1(delta.translate, 0, p);
  output.scale = mix$1(delta.scale, 1, p);
  output.origin = delta.origin;
  output.originPoint = delta.originPoint;
}
function mixAxis$1(output, from2, to, p) {
  output.min = mix$1(from2.min, to.min, p);
  output.max = mix$1(from2.max, to.max, p);
}
function mixBox$1(output, from2, to, p) {
  mixAxis$1(output.x, from2.x, to.x, p);
  mixAxis$1(output.y, from2.y, to.y, p);
}
function hasOpacityCrossfade$1(node2) {
  return node2.animationValues && node2.animationValues.opacityExit !== void 0;
}
const defaultLayoutTransition$1 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
const userAgentContains$1 = (string) => typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
const roundPoint$1 = userAgentContains$1("applewebkit/") && !userAgentContains$1("chrome/") ? Math.round : noop$1;
function roundAxis$1(axis) {
  axis.min = roundPoint$1(axis.min);
  axis.max = roundPoint$1(axis.max);
}
function roundBox$1(box) {
  roundAxis$1(box.x);
  roundAxis$1(box.y);
}
function shouldAnimatePositionOnly$1(animationType, snapshot, layout2) {
  return animationType === "position" || animationType === "preserve-aspect" && !isNear$1(aspectRatio$1(snapshot), aspectRatio$1(layout2), 0.2);
}
const DocumentProjectionNode$1 = createProjectionNode$2({
  attachResizeListener: (ref, notify) => addDomEvent$1(ref, "resize", notify),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => true
});
const rootProjectionNode$1 = {
  current: void 0
};
const HTMLProjectionNode$1 = createProjectionNode$2({
  measureScroll: (instance) => ({
    x: instance.scrollLeft,
    y: instance.scrollTop
  }),
  defaultParent: () => {
    if (!rootProjectionNode$1.current) {
      const documentNode = new DocumentProjectionNode$1({});
      documentNode.mount(window);
      documentNode.setOptions({ layoutScroll: true });
      rootProjectionNode$1.current = documentNode;
    }
    return rootProjectionNode$1.current;
  },
  resetTransform: (instance, value) => {
    instance.style.transform = value !== void 0 ? value : "none";
  },
  checkIsScrollRoot: (instance) => Boolean(window.getComputedStyle(instance).position === "fixed")
});
const drag$1 = {
  pan: {
    Feature: PanGesture$1
  },
  drag: {
    Feature: DragGesture$1,
    ProjectionNode: HTMLProjectionNode$1,
    MeasureLayout: MeasureLayout$1
  }
};
const splitCSSVariableRegex$1 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable$1(current) {
  const match2 = splitCSSVariableRegex$1.exec(current);
  if (!match2)
    return [,];
  const [, token2, fallback] = match2;
  return [token2, fallback];
}
const maxDepth$1 = 4;
function getVariableValue$1(current, element, depth = 1) {
  invariant$1(depth <= maxDepth$1, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
  const [token2, fallback] = parseCSSVariable$1(current);
  if (!token2)
    return;
  const resolved = window.getComputedStyle(element).getPropertyValue(token2);
  if (resolved) {
    const trimmed = resolved.trim();
    return isNumericalString$1(trimmed) ? parseFloat(trimmed) : trimmed;
  } else if (isCSSVariableToken$1(fallback)) {
    return getVariableValue$1(fallback, element, depth + 1);
  } else {
    return fallback;
  }
}
function resolveCSSVariables(visualElement, _ga, transitionEnd) {
  var target = __objRest(_ga, []);
  const element = visualElement.current;
  if (!(element instanceof Element))
    return { target, transitionEnd };
  if (transitionEnd) {
    transitionEnd = __spreadValues({}, transitionEnd);
  }
  visualElement.values.forEach((value) => {
    const current = value.get();
    if (!isCSSVariableToken$1(current))
      return;
    const resolved = getVariableValue$1(current, element);
    if (resolved)
      value.set(resolved);
  });
  for (const key in target) {
    const current = target[key];
    if (!isCSSVariableToken$1(current))
      continue;
    const resolved = getVariableValue$1(current, element);
    if (!resolved)
      continue;
    target[key] = resolved;
    if (!transitionEnd)
      transitionEnd = {};
    if (transitionEnd[key] === void 0) {
      transitionEnd[key] = current;
    }
  }
  return { target, transitionEnd };
}
const positionalKeys$1 = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]);
const isPositionalKey = (key) => positionalKeys$1.has(key);
const hasPositionalKey = (target) => {
  return Object.keys(target).some(isPositionalKey);
};
const isNumOrPxType$1 = (v) => v === number$1 || v === px$1;
const getPosFromMatrix$1 = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
const getTranslateFromMatrix$1 = (pos2, pos3) => (_bbox, { transform }) => {
  if (transform === "none" || !transform)
    return 0;
  const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
  if (matrix3d) {
    return getPosFromMatrix$1(matrix3d[1], pos3);
  } else {
    const matrix = transform.match(/^matrix\((.+)\)$/);
    if (matrix) {
      return getPosFromMatrix$1(matrix[1], pos2);
    } else {
      return 0;
    }
  }
};
const transformKeys$1 = /* @__PURE__ */ new Set(["x", "y", "z"]);
const nonTranslationalTransformKeys$1 = transformPropOrder$1.filter((key) => !transformKeys$1.has(key));
function removeNonTranslationalTransform$1(visualElement) {
  const removedTransforms = [];
  nonTranslationalTransformKeys$1.forEach((key) => {
    const value = visualElement.getValue(key);
    if (value !== void 0) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  });
  if (removedTransforms.length)
    visualElement.render();
  return removedTransforms;
}
const positionalValues$1 = {
  // Dimensions
  width: ({ x: x2 }, { paddingLeft = "0", paddingRight = "0" }) => x2.max - x2.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
  height: ({ y }, { paddingTop = "0", paddingBottom = "0" }) => y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
  top: (_bbox, { top: top2 }) => parseFloat(top2),
  left: (_bbox, { left: left2 }) => parseFloat(left2),
  bottom: ({ y }, { top: top2 }) => parseFloat(top2) + (y.max - y.min),
  right: ({ x: x2 }, { left: left2 }) => parseFloat(left2) + (x2.max - x2.min),
  // Transform
  x: getTranslateFromMatrix$1(4, 13),
  y: getTranslateFromMatrix$1(5, 14)
};
positionalValues$1.translateX = positionalValues$1.x;
positionalValues$1.translateY = positionalValues$1.y;
const convertChangedValueTypes = (target, visualElement, changedKeys) => {
  const originBbox = visualElement.measureViewportBox();
  const element = visualElement.current;
  const elementComputedStyle = getComputedStyle(element);
  const { display } = elementComputedStyle;
  const origin = {};
  if (display === "none") {
    visualElement.setStaticValue("display", target.display || "block");
  }
  changedKeys.forEach((key) => {
    origin[key] = positionalValues$1[key](originBbox, elementComputedStyle);
  });
  visualElement.render();
  const targetBbox = visualElement.measureViewportBox();
  changedKeys.forEach((key) => {
    const value = visualElement.getValue(key);
    value && value.jump(origin[key]);
    target[key] = positionalValues$1[key](targetBbox, elementComputedStyle);
  });
  return target;
};
const checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {}) => {
  target = __spreadValues({}, target);
  transitionEnd = __spreadValues({}, transitionEnd);
  const targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
  let removedTransformValues = [];
  let hasAttemptedToRemoveTransformValues = false;
  const changedValueTypeKeys = [];
  targetPositionalKeys.forEach((key) => {
    const value = visualElement.getValue(key);
    if (!visualElement.hasValue(key))
      return;
    let from2 = origin[key];
    let fromType = findDimensionValueType$1(from2);
    const to = target[key];
    let toType;
    if (isKeyframesTarget$1(to)) {
      const numKeyframes = to.length;
      const fromIndex = to[0] === null ? 1 : 0;
      from2 = to[fromIndex];
      fromType = findDimensionValueType$1(from2);
      for (let i = fromIndex; i < numKeyframes; i++) {
        if (to[i] === null)
          break;
        if (!toType) {
          toType = findDimensionValueType$1(to[i]);
          invariant$1(toType === fromType || isNumOrPxType$1(fromType) && isNumOrPxType$1(toType), "Keyframes must be of the same dimension as the current value");
        } else {
          invariant$1(findDimensionValueType$1(to[i]) === toType, "All keyframes must be of the same type");
        }
      }
    } else {
      toType = findDimensionValueType$1(to);
    }
    if (fromType !== toType) {
      if (isNumOrPxType$1(fromType) && isNumOrPxType$1(toType)) {
        const current = value.get();
        if (typeof current === "string") {
          value.set(parseFloat(current));
        }
        if (typeof to === "string") {
          target[key] = parseFloat(to);
        } else if (Array.isArray(to) && toType === px$1) {
          target[key] = to.map(parseFloat);
        }
      } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from2 === 0 || to === 0)) {
        if (from2 === 0) {
          value.set(toType.transform(from2));
        } else {
          target[key] = fromType.transform(to);
        }
      } else {
        if (!hasAttemptedToRemoveTransformValues) {
          removedTransformValues = removeNonTranslationalTransform$1(visualElement);
          hasAttemptedToRemoveTransformValues = true;
        }
        changedValueTypeKeys.push(key);
        transitionEnd[key] = transitionEnd[key] !== void 0 ? transitionEnd[key] : target[key];
        value.jump(to);
      }
    }
  });
  if (changedValueTypeKeys.length) {
    const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
    const convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
    if (removedTransformValues.length) {
      removedTransformValues.forEach(([key, value]) => {
        visualElement.getValue(key).set(value);
      });
    }
    visualElement.render();
    if (isBrowser$1 && scrollY !== null) {
      window.scrollTo({ top: scrollY });
    }
    return { target: convertedTarget, transitionEnd };
  } else {
    return { target, transitionEnd };
  }
};
function unitConversion(visualElement, target, origin, transitionEnd) {
  return hasPositionalKey(target) ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : { target, transitionEnd };
}
const parseDomVariant = (visualElement, target, origin, transitionEnd) => {
  const resolved = resolveCSSVariables(visualElement, target, transitionEnd);
  target = resolved.target;
  transitionEnd = resolved.transitionEnd;
  return unitConversion(visualElement, target, origin, transitionEnd);
};
const prefersReducedMotion$1 = { current: null };
const hasReducedMotionListener$1 = { current: false };
function initPrefersReducedMotion$1() {
  hasReducedMotionListener$1.current = true;
  if (!isBrowser$1)
    return;
  if (window.matchMedia) {
    const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
    const setReducedMotionPreferences = () => prefersReducedMotion$1.current = motionMediaQuery.matches;
    motionMediaQuery.addListener(setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion$1.current = false;
  }
}
function updateMotionValuesFromProps$1(element, next2, prev2) {
  const { willChange } = next2;
  for (const key in next2) {
    const nextValue = next2[key];
    const prevValue = prev2[key];
    if (isMotionValue$1(nextValue)) {
      element.addValue(key, nextValue);
      if (isWillChangeMotionValue$1(willChange)) {
        willChange.add(key);
      }
      if (process.env.NODE_ENV === "development") {
        warnOnce$1(nextValue.version === "10.18.0", `Attempting to mix Framer Motion versions ${nextValue.version} with 10.18.0 may not work as expected.`);
      }
    } else if (isMotionValue$1(prevValue)) {
      element.addValue(key, motionValue$1(nextValue, { owner: element }));
      if (isWillChangeMotionValue$1(willChange)) {
        willChange.remove(key);
      }
    } else if (prevValue !== nextValue) {
      if (element.hasValue(key)) {
        const existingValue = element.getValue(key);
        !existingValue.hasAnimated && existingValue.set(nextValue);
      } else {
        const latestValue = element.getStaticValue(key);
        element.addValue(key, motionValue$1(latestValue !== void 0 ? latestValue : nextValue, { owner: element }));
      }
    }
  }
  for (const key in prev2) {
    if (next2[key] === void 0)
      element.removeValue(key);
  }
  return next2;
}
const visualElementStore$1 = /* @__PURE__ */ new WeakMap();
const featureNames = Object.keys(featureDefinitions$1);
const numFeatures = featureNames.length;
const propEventHandlers$1 = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
const numVariantProps$1 = variantProps$1.length;
let VisualElement$1 = class VisualElement {
  constructor({ parent, props, presenceContext, reducedMotionConfig, visualState }, options = {}) {
    this.current = null;
    this.children = /* @__PURE__ */ new Set();
    this.isVariantNode = false;
    this.isControllingVariants = false;
    this.shouldReduceMotion = null;
    this.values = /* @__PURE__ */ new Map();
    this.features = {};
    this.valueSubscriptions = /* @__PURE__ */ new Map();
    this.prevMotionValues = {};
    this.events = {};
    this.propEventSubscriptions = {};
    this.notifyUpdate = () => this.notify("Update", this.latestValues);
    this.render = () => {
      if (!this.current)
        return;
      this.triggerBuild();
      this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
    };
    this.scheduleRender = () => frame$1.render(this.render, false, true);
    const { latestValues, renderState } = visualState;
    this.latestValues = latestValues;
    this.baseTarget = __spreadValues({}, latestValues);
    this.initialValues = props.initial ? __spreadValues({}, latestValues) : {};
    this.renderState = renderState;
    this.parent = parent;
    this.props = props;
    this.presenceContext = presenceContext;
    this.depth = parent ? parent.depth + 1 : 0;
    this.reducedMotionConfig = reducedMotionConfig;
    this.options = options;
    this.isControllingVariants = isControllingVariants$1(props);
    this.isVariantNode = isVariantNode$1(props);
    if (this.isVariantNode) {
      this.variantChildren = /* @__PURE__ */ new Set();
    }
    this.manuallyAnimateOnMount = Boolean(parent && parent.current);
    const _a = this.scrapeMotionValuesFromProps(props, {}), { willChange } = _a, initialMotionValues = __objRest(_a, ["willChange"]);
    for (const key in initialMotionValues) {
      const value = initialMotionValues[key];
      if (latestValues[key] !== void 0 && isMotionValue$1(value)) {
        value.set(latestValues[key], false);
        if (isWillChangeMotionValue$1(willChange)) {
          willChange.add(key);
        }
      }
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(_props, _prevProps) {
    return {};
  }
  mount(instance) {
    this.current = instance;
    visualElementStore$1.set(instance, this);
    if (this.projection && !this.projection.instance) {
      this.projection.mount(instance);
    }
    if (this.parent && this.isVariantNode && !this.isControllingVariants) {
      this.removeFromVariantTree = this.parent.addVariantChild(this);
    }
    this.values.forEach((value, key) => this.bindToMotionValue(key, value));
    if (!hasReducedMotionListener$1.current) {
      initPrefersReducedMotion$1();
    }
    this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : prefersReducedMotion$1.current;
    if (process.env.NODE_ENV !== "production") {
      warnOnce$1(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
    }
    if (this.parent)
      this.parent.children.add(this);
    this.update(this.props, this.presenceContext);
  }
  unmount() {
    visualElementStore$1.delete(this.current);
    this.projection && this.projection.unmount();
    cancelFrame$1(this.notifyUpdate);
    cancelFrame$1(this.render);
    this.valueSubscriptions.forEach((remove) => remove());
    this.removeFromVariantTree && this.removeFromVariantTree();
    this.parent && this.parent.children.delete(this);
    for (const key in this.events) {
      this.events[key].clear();
    }
    for (const key in this.features) {
      this.features[key].unmount();
    }
    this.current = null;
  }
  bindToMotionValue(key, value) {
    const valueIsTransform = transformProps$1.has(key);
    const removeOnChange = value.on("change", (latestValue) => {
      this.latestValues[key] = latestValue;
      this.props.onUpdate && frame$1.update(this.notifyUpdate, false, true);
      if (valueIsTransform && this.projection) {
        this.projection.isTransformDirty = true;
      }
    });
    const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(key, () => {
      removeOnChange();
      removeOnRenderRequest();
    });
  }
  sortNodePosition(other) {
    if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) {
      return 0;
    }
    return this.sortInstanceNodePosition(this.current, other.current);
  }
  loadFeatures(_ha, isStrict, preloadedFeatures2, initialLayoutGroupConfig) {
    var _ia = _ha, { children } = _ia, renderedProps = __objRest(_ia, ["children"]);
    let ProjectionNodeConstructor;
    let MeasureLayout2;
    if (process.env.NODE_ENV !== "production" && preloadedFeatures2 && isStrict) {
      const strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      renderedProps.ignoreStrict ? warning$1(false, strictMessage) : invariant$1(false, strictMessage);
    }
    for (let i = 0; i < numFeatures; i++) {
      const name = featureNames[i];
      const { isEnabled, Feature: FeatureConstructor, ProjectionNode, MeasureLayout: MeasureLayoutComponent } = featureDefinitions$1[name];
      if (ProjectionNode)
        ProjectionNodeConstructor = ProjectionNode;
      if (isEnabled(renderedProps)) {
        if (!this.features[name] && FeatureConstructor) {
          this.features[name] = new FeatureConstructor(this);
        }
        if (MeasureLayoutComponent) {
          MeasureLayout2 = MeasureLayoutComponent;
        }
      }
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
      this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
      const { layoutId, layout: layout2, drag: drag2, dragConstraints, layoutScroll, layoutRoot } = renderedProps;
      this.projection.setOptions({
        layoutId,
        layout: layout2,
        alwaysMeasureLayout: Boolean(drag2) || dragConstraints && isRefObject$1(dragConstraints),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof layout2 === "string" ? layout2 : "both",
        initialPromotionConfig: initialLayoutGroupConfig,
        layoutScroll,
        layoutRoot
      });
    }
    return MeasureLayout2;
  }
  updateFeatures() {
    for (const key in this.features) {
      const feature = this.features[key];
      if (feature.isMounted) {
        feature.update();
      } else {
        feature.mount();
        feature.isMounted = true;
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox$1();
  }
  getStaticValue(key) {
    return this.latestValues[key];
  }
  setStaticValue(key, value) {
    this.latestValues[key] = value;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(target, canMutate = true) {
    return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(props, presenceContext) {
    if (props.transformTemplate || this.props.transformTemplate) {
      this.scheduleRender();
    }
    this.prevProps = this.props;
    this.props = props;
    this.prevPresenceContext = this.presenceContext;
    this.presenceContext = presenceContext;
    for (let i = 0; i < propEventHandlers$1.length; i++) {
      const key = propEventHandlers$1[i];
      if (this.propEventSubscriptions[key]) {
        this.propEventSubscriptions[key]();
        delete this.propEventSubscriptions[key];
      }
      const listener = props["on" + key];
      if (listener) {
        this.propEventSubscriptions[key] = this.on(key, listener);
      }
    }
    this.prevMotionValues = updateMotionValuesFromProps$1(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
    if (this.handleChildMotionValue) {
      this.handleChildMotionValue();
    }
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(name) {
    return this.props.variants ? this.props.variants[name] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(startAtParent = false) {
    if (startAtParent) {
      return this.parent ? this.parent.getVariantContext() : void 0;
    }
    if (!this.isControllingVariants) {
      const context2 = this.parent ? this.parent.getVariantContext() || {} : {};
      if (this.props.initial !== void 0) {
        context2.initial = this.props.initial;
      }
      return context2;
    }
    const context = {};
    for (let i = 0; i < numVariantProps$1; i++) {
      const name = variantProps$1[i];
      const prop = this.props[name];
      if (isVariantLabel$1(prop) || prop === false) {
        context[name] = prop;
      }
    }
    return context;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(child) {
    const closestVariantNode = this.getClosestVariantNode();
    if (closestVariantNode) {
      closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
      return () => closestVariantNode.variantChildren.delete(child);
    }
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(key, value) {
    if (value !== this.values.get(key)) {
      this.removeValue(key);
      this.bindToMotionValue(key, value);
    }
    this.values.set(key, value);
    this.latestValues[key] = value.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(key) {
    this.values.delete(key);
    const unsubscribe = this.valueSubscriptions.get(key);
    if (unsubscribe) {
      unsubscribe();
      this.valueSubscriptions.delete(key);
    }
    delete this.latestValues[key];
    this.removeValueFromRenderState(key, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(key) {
    return this.values.has(key);
  }
  getValue(key, defaultValue2) {
    if (this.props.values && this.props.values[key]) {
      return this.props.values[key];
    }
    let value = this.values.get(key);
    if (value === void 0 && defaultValue2 !== void 0) {
      value = motionValue$1(defaultValue2, { owner: this });
      this.addValue(key, value);
    }
    return value;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(key) {
    var _a;
    return this.latestValues[key] !== void 0 || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(key, value) {
    this.baseTarget[key] = value;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(key) {
    var _a;
    const { initial } = this.props;
    const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = resolveVariantFromProps$1(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : void 0;
    if (initial && valueFromInitial !== void 0) {
      return valueFromInitial;
    }
    const target = this.getBaseTargetFromProps(this.props, key);
    if (target !== void 0 && !isMotionValue$1(target))
      return target;
    return this.initialValues[key] !== void 0 && valueFromInitial === void 0 ? void 0 : this.baseTarget[key];
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager$1();
    }
    return this.events[eventName].add(callback);
  }
  notify(eventName, ...args) {
    if (this.events[eventName]) {
      this.events[eventName].notify(...args);
    }
  }
};
let DOMVisualElement$1 = class DOMVisualElement extends VisualElement$1 {
  sortInstanceNodePosition(a2, b) {
    return a2.compareDocumentPosition(b) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(props, key) {
    return props.style ? props.style[key] : void 0;
  }
  removeValueFromRenderState(key, { vars, style: style2 }) {
    delete vars[key];
    delete style2[key];
  }
  makeTargetAnimatableFromInstance(_ja, { transformValues }, isMounted) {
    var _ka = _ja, { transition, transitionEnd } = _ka, target = __objRest(_ka, ["transition", "transitionEnd"]);
    let origin = getOrigin(target, transition || {}, this);
    if (transformValues) {
      if (transitionEnd)
        transitionEnd = transformValues(transitionEnd);
      if (target)
        target = transformValues(target);
      if (origin)
        origin = transformValues(origin);
    }
    if (isMounted) {
      checkTargetForNewValues(this, target, origin);
      const parsed = parseDomVariant(this, target, origin, transitionEnd);
      transitionEnd = parsed.transitionEnd;
      target = parsed.target;
    }
    return __spreadValues({
      transition,
      transitionEnd
    }, target);
  }
};
function getComputedStyle$2(element) {
  return window.getComputedStyle(element);
}
let HTMLVisualElement$1 = class HTMLVisualElement extends DOMVisualElement$1 {
  constructor() {
    super(...arguments);
    this.type = "html";
  }
  readValueFromInstance(instance, key) {
    if (transformProps$1.has(key)) {
      const defaultType = getDefaultValueType$1(key);
      return defaultType ? defaultType.default || 0 : 0;
    } else {
      const computedStyle = getComputedStyle$2(instance);
      const value = (isCSSVariableName$1(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
      return typeof value === "string" ? value.trim() : value;
    }
  }
  measureInstanceViewportBox(instance, { transformPagePoint }) {
    return measureViewportBox$1(instance, transformPagePoint);
  }
  build(renderState, latestValues, options, props) {
    buildHTMLStyles$1(renderState, latestValues, options, props.transformTemplate);
  }
  scrapeMotionValuesFromProps(props, prevProps) {
    return scrapeMotionValuesFromProps$3(props, prevProps);
  }
  handleChildMotionValue() {
    if (this.childSubscription) {
      this.childSubscription();
      delete this.childSubscription;
    }
    const { children } = this.props;
    if (isMotionValue$1(children)) {
      this.childSubscription = children.on("change", (latest) => {
        if (this.current)
          this.current.textContent = `${latest}`;
      });
    }
  }
  renderInstance(instance, renderState, styleProp, projection) {
    renderHTML$1(instance, renderState, styleProp, projection);
  }
};
let SVGVisualElement$1 = class SVGVisualElement extends DOMVisualElement$1 {
  constructor() {
    super(...arguments);
    this.type = "svg";
    this.isSVGTag = false;
  }
  getBaseTargetFromProps(props, key) {
    return props[key];
  }
  readValueFromInstance(instance, key) {
    if (transformProps$1.has(key)) {
      const defaultType = getDefaultValueType$1(key);
      return defaultType ? defaultType.default || 0 : 0;
    }
    key = !camelCaseAttributes$1.has(key) ? camelToDash$1(key) : key;
    return instance.getAttribute(key);
  }
  measureInstanceViewportBox() {
    return createBox$1();
  }
  scrapeMotionValuesFromProps(props, prevProps) {
    return scrapeMotionValuesFromProps$2(props, prevProps);
  }
  build(renderState, latestValues, options, props) {
    buildSVGAttrs$1(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
  }
  renderInstance(instance, renderState, styleProp, projection) {
    renderSVG$1(instance, renderState, styleProp, projection);
  }
  mount(instance) {
    this.isSVGTag = isSVGTag$1(instance.tagName);
    super.mount(instance);
  }
};
const createDomVisualElement$1 = (Component2, options) => {
  return isSVGComponent$1(Component2) ? new SVGVisualElement$1(options, { enableHardwareAcceleration: false }) : new HTMLVisualElement$1(options, { enableHardwareAcceleration: true });
};
const layout$1 = {
  layout: {
    ProjectionNode: HTMLProjectionNode$1,
    MeasureLayout: MeasureLayout$1
  }
};
const preloadedFeatures = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, animations$1), gestureAnimations$1), drag$1), layout$1);
const motion$1 = /* @__PURE__ */ createMotionProxy((Component2, config2) => createDomMotionConfig(Component2, config2, preloadedFeatures, createDomVisualElement$1));
var formatForDisplay = function(number2, includeDecimals, decimalPrecision, includeCommas) {
  var decimalCount = includeDecimals ? decimalPrecision : 0;
  var parsedNumber = parseFloat("".concat(Math.max(number2, 0))).toFixed(decimalCount);
  var numberToFormat = includeCommas ? parseFloat(parsedNumber).toLocaleString("en-US", { minimumFractionDigits: includeDecimals ? decimalPrecision : 0 }) : parsedNumber;
  return numberToFormat.split("").reverse();
};
var usePrevious = function(value) {
  var ref = useRef(null);
  useEffect(function() {
    ref.current = value;
  }, [value]);
  return ref.current;
};
function isObject$2(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$2;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$2 = freeGlobal || freeSelf || Function("return this")();
var _root = root$2;
var root$1 = _root;
var now$2 = function() {
  return root$1.Date.now();
};
var now_1 = now$2;
var reWhitespace = /\s/;
function trimmedEndIndex$1(string) {
  var index2 = string.length;
  while (index2-- && reWhitespace.test(string.charAt(index2))) {
  }
  return index2;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var _baseTrim = baseTrim$1;
var root = _root;
var Symbol$3 = root.Symbol;
var _Symbol = Symbol$3;
var Symbol$2 = _Symbol;
var objectProto$1 = Object.prototype;
var hasOwnProperty = objectProto$1.hasOwnProperty;
var nativeObjectToString$1 = objectProto$1.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e2) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto = Object.prototype;
var nativeObjectToString = objectProto.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$1 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag$1(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$1;
function isObjectLike$1(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$1;
var baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1;
var symbolTag = "[object Symbol]";
function isSymbol$1(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
var isSymbol_1 = isSymbol$1;
var baseTrim = _baseTrim, isObject$1 = isObject_1, isSymbol = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$1(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$1(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$1;
var isObject = isObject_1, now$1 = now_1, toNumber = toNumber_1;
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time2;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time2) {
    lastInvokeTime = time2;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time2) : result;
  }
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time2 = now$1();
    if (shouldInvoke(time2)) {
      return trailingEdge(time2);
    }
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  function trailingEdge(time2) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time2);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now$1());
  }
  function debounced() {
    var time2 = now$1(), isInvoking = shouldInvoke(time2);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time2;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce;
const debounce$1 = /* @__PURE__ */ getDefaultExportFromCjs(debounce_1);
const styles = "";
var DecimalColumn = function(_a) {
  var fontSize = _a.fontSize, color2 = _a.color, isComma = _a.isComma, digitStyles = _a.digitStyles;
  return React__default.createElement("span", { style: __assign({ fontSize, lineHeight: fontSize, color: color2, marginLeft: "calc(-".concat(fontSize, " / 10)") }, digitStyles) }, isComma ? "," : ".");
};
var NumberColumn = memo$2(function(_a) {
  var digit = _a.digit, delta = _a.delta, fontSize = _a.fontSize, color2 = _a.color, incrementColor = _a.incrementColor, decrementColor = _a.decrementColor, digitStyles = _a.digitStyles;
  var _b = useState(0), position2 = _b[0], setPosition = _b[1];
  var _c = useState(null), animationClass = _c[0], setAnimationClass = _c[1];
  var currentDigit = +digit;
  var previousDigit = usePrevious(+currentDigit);
  var columnContainer = useRef(null);
  var handleAnimationComplete = useCallback(debounce$1(function() {
    setAnimationClass("");
  }, 200), []);
  var setColumnToNumber = useCallback(function(number2) {
    var _a2, _b2;
    if ((_a2 = columnContainer === null || columnContainer === void 0 ? void 0 : columnContainer.current) === null || _a2 === void 0 ? void 0 : _a2.clientHeight) {
      setPosition(((_b2 = columnContainer === null || columnContainer === void 0 ? void 0 : columnContainer.current) === null || _b2 === void 0 ? void 0 : _b2.clientHeight) * parseInt(number2, 10));
    }
  }, []);
  useEffect(function() {
    setAnimationClass(previousDigit !== currentDigit ? delta : "");
  }, [digit, delta]);
  useEffect(function() {
    setColumnToNumber(digit);
  }, [digit, setColumnToNumber]);
  if (digit === "-") {
    return React__default.createElement("span", { style: __assign({ color: color2, fontSize, lineHeight: fontSize, marginRight: "calc(".concat(fontSize, " / 5)") }, digitStyles) }, digit);
  }
  return React__default.createElement(
    "div",
    { className: "ticker-column-container", ref: columnContainer, style: __assign({ fontSize, lineHeight: fontSize, height: "auto", color: color2, "--increment-color": "".concat(incrementColor), "--decrement-color": "".concat(decrementColor) }, digitStyles) },
    React__default.createElement(motion$1.div, { animate: { x: 0, y: position2 }, className: "ticker-column ".concat(animationClass), onAnimationComplete: handleAnimationComplete }, [9, 8, 7, 6, 5, 4, 3, 2, 1, 0].map(function(num) {
      return React__default.createElement(
        "div",
        { className: "ticker-digit", key: num },
        React__default.createElement("span", { style: __assign({ fontSize, lineHeight: fontSize }, digitStyles) }, num)
      );
    })),
    React__default.createElement("span", { className: "number-placeholder" }, "0")
  );
}, function(prevProps, nextProps) {
  return prevProps.digit === nextProps.digit && prevProps.delta === nextProps.delta;
});
var AnimatedCounter = function(_a) {
  var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.fontSize, fontSize = _c === void 0 ? "18px" : _c, _d = _a.color, color2 = _d === void 0 ? "black" : _d, _e = _a.incrementColor, incrementColor = _e === void 0 ? "#32cd32" : _e, _f = _a.decrementColor, decrementColor = _f === void 0 ? "#fe6862" : _f, _g = _a.includeDecimals, includeDecimals = _g === void 0 ? true : _g, _h = _a.decimalPrecision, decimalPrecision = _h === void 0 ? 2 : _h, _j = _a.includeCommas, includeCommas = _j === void 0 ? false : _j, _k = _a.containerStyles, containerStyles = _k === void 0 ? {} : _k, _l = _a.digitStyles, digitStyles = _l === void 0 ? {} : _l;
  var numArray = formatForDisplay(Math.abs(value), includeDecimals, decimalPrecision, includeCommas);
  var previousNumber = usePrevious(value);
  var isNegative = value < 0;
  var delta = null;
  if (previousNumber !== null) {
    if (value > previousNumber) {
      delta = "increase";
    } else if (value < previousNumber) {
      delta = "decrease";
    }
  }
  return React__default.createElement(
    motion$1.div,
    { layout: true, className: "ticker-view", style: __assign({}, containerStyles) },
    numArray.map(function(number2, index2) {
      return number2 === "." || number2 === "," ? React__default.createElement(DecimalColumn, { key: index2, fontSize, color: color2, isComma: number2 === ",", digitStyles }) : React__default.createElement(NumberColumn, { key: index2, digit: number2, delta, color: color2, fontSize, incrementColor, decrementColor, digitStyles });
    }),
    isNegative && React__default.createElement(NumberColumn, { key: "negative-feedback", digit: "-", delta, color: color2, fontSize, incrementColor, decrementColor, digitStyles })
  );
};
var colors$2 = {};
var log = {};
var picocolors_browser = { exports: {} };
var x = String;
var create = function() {
  return { isColorSupported: false, reset: x, bold: x, dim: x, italic: x, underline: x, inverse: x, hidden: x, strikethrough: x, black: x, red: x, green: x, yellow: x, blue: x, magenta: x, cyan: x, white: x, gray: x, bgBlack: x, bgRed: x, bgGreen: x, bgYellow: x, bgBlue: x, bgMagenta: x, bgCyan: x, bgWhite: x };
};
picocolors_browser.exports = create();
picocolors_browser.exports.createColors = create;
var picocolors_browserExports = picocolors_browser.exports;
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  function _export(target, all) {
    for (var name in all)
      Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
      });
  }
  _export(exports, {
    dim: function() {
      return dim;
    },
    default: function() {
      return _default2;
    }
  });
  const _picocolors = /* @__PURE__ */ _interop_require_default(picocolors_browserExports);
  function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  let alreadyShown = /* @__PURE__ */ new Set();
  function log2(type, messages2, key) {
    if (typeof process !== "undefined" && process.env.JEST_WORKER_ID)
      return;
    if (key && alreadyShown.has(key))
      return;
    if (key)
      alreadyShown.add(key);
    console.warn("");
    messages2.forEach((message) => console.warn(type, "-", message));
  }
  function dim(input) {
    return _picocolors.default.dim(input);
  }
  const _default2 = {
    info(key, messages2) {
      log2(_picocolors.default.bold(_picocolors.default.cyan("info")), ...Array.isArray(key) ? [
        key
      ] : [
        messages2,
        key
      ]);
    },
    warn(key, messages2) {
      log2(_picocolors.default.bold(_picocolors.default.yellow("warn")), ...Array.isArray(key) ? [
        key
      ] : [
        messages2,
        key
      ]);
    },
    risk(key, messages2) {
      log2(_picocolors.default.bold(_picocolors.default.magenta("risk")), ...Array.isArray(key) ? [
        key
      ] : [
        messages2,
        key
      ]);
    }
  };
})(log);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _default2;
    }
  });
  const _log = /* @__PURE__ */ _interop_require_default(log);
  function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function warn({ version, from: from2, to }) {
    _log.default.warn(`${from2}-color-renamed`, [
      `As of Tailwind CSS ${version}, \`${from2}\` has been renamed to \`${to}\`.`,
      "Update your configuration file to silence this warning."
    ]);
  }
  const _default2 = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
      950: "#020617"
    },
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712"
    },
    zinc: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#a1a1aa",
      500: "#71717a",
      600: "#52525b",
      700: "#3f3f46",
      800: "#27272a",
      900: "#18181b",
      950: "#09090b"
    },
    neutral: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#e5e5e5",
      300: "#d4d4d4",
      400: "#a3a3a3",
      500: "#737373",
      600: "#525252",
      700: "#404040",
      800: "#262626",
      900: "#171717",
      950: "#0a0a0a"
    },
    stone: {
      50: "#fafaf9",
      100: "#f5f5f4",
      200: "#e7e5e4",
      300: "#d6d3d1",
      400: "#a8a29e",
      500: "#78716c",
      600: "#57534e",
      700: "#44403c",
      800: "#292524",
      900: "#1c1917",
      950: "#0c0a09"
    },
    red: {
      50: "#fef2f2",
      100: "#fee2e2",
      200: "#fecaca",
      300: "#fca5a5",
      400: "#f87171",
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d",
      950: "#450a0a"
    },
    orange: {
      50: "#fff7ed",
      100: "#ffedd5",
      200: "#fed7aa",
      300: "#fdba74",
      400: "#fb923c",
      500: "#f97316",
      600: "#ea580c",
      700: "#c2410c",
      800: "#9a3412",
      900: "#7c2d12",
      950: "#431407"
    },
    amber: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
      950: "#451a03"
    },
    yellow: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006"
    },
    lime: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05"
    },
    green: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#22c55e",
      600: "#16a34a",
      700: "#15803d",
      800: "#166534",
      900: "#14532d",
      950: "#052e16"
    },
    emerald: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22"
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e"
    },
    cyan: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344"
    },
    sky: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
      950: "#082f49"
    },
    blue: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554"
    },
    indigo: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
      950: "#1e1b4b"
    },
    violet: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065"
    },
    purple: {
      50: "#faf5ff",
      100: "#f3e8ff",
      200: "#e9d5ff",
      300: "#d8b4fe",
      400: "#c084fc",
      500: "#a855f7",
      600: "#9333ea",
      700: "#7e22ce",
      800: "#6b21a8",
      900: "#581c87",
      950: "#3b0764"
    },
    fuchsia: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e"
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724"
    },
    rose: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519"
    },
    get lightBlue() {
      warn({
        version: "v2.2",
        from: "lightBlue",
        to: "sky"
      });
      return this.sky;
    },
    get warmGray() {
      warn({
        version: "v3.0",
        from: "warmGray",
        to: "stone"
      });
      return this.stone;
    },
    get trueGray() {
      warn({
        version: "v3.0",
        from: "trueGray",
        to: "neutral"
      });
      return this.neutral;
    },
    get coolGray() {
      warn({
        version: "v3.0",
        from: "coolGray",
        to: "gray"
      });
      return this.gray;
    },
    get blueGray() {
      warn({
        version: "v3.0",
        from: "blueGray",
        to: "slate"
      });
      return this.slate;
    }
  };
})(colors$2);
let colors = colors$2;
var colors_1 = (colors.__esModule ? colors : { default: colors }).default;
const colors$1 = /* @__PURE__ */ getDefaultExportFromCjs(colors_1);
const DEFAULT_COLOR = "yellow-700";
const getColor = ({
  isLast = false,
  tierColor = "yellow-700",
  lastPosition
}) => {
  const positions = (tierColor || DEFAULT_COLOR).split("-");
  const colorNumber = lastPosition || Number(positions[1]);
  const numberToReduce = colorNumber === 300 ? 200 : colorNumber < 300 ? colorNumber / 2 : 300;
  const colorPosition = isLast ? colorNumber - numberToReduce : positions[1];
  return colors$1[positions[0]][colorPosition];
};
const getSpecificColor = ({
  tierColor = DEFAULT_COLOR
}) => {
  const positions = (tierColor || DEFAULT_COLOR).split("-");
  const colorNumber = Number(positions[1]);
  return colors$1[positions[0]][colorNumber];
};
const get3dColor = ({
  tierColor = DEFAULT_COLOR
}) => {
  const positions = (tierColor || DEFAULT_COLOR).split("-");
  const colorNumber = Number(positions[1]);
  const colorToPosition = colorNumber + 100;
  return {
    // @ts-ignore:next-line
    toColor: colors$1[positions[0]][colorNumber],
    // @ts-ignore:next-line
    fromColor: colors$1[positions[0]][colorToPosition]
  };
};
const getUserTier = ({
  user,
  tiers
}) => {
  return tiers.find((tier) => {
    return tier.id === user.tier_id;
  });
};
const getTierImage = ({
  userTier
}) => {
  var _a;
  return (_a = userTier == null ? void 0 : userTier.images) == null ? void 0 : _a.find((image) => {
    return !image.includes("spline");
  });
};
const hexToRGB = (hex2, alpha2) => {
  const r2 = parseInt(hex2.slice(1, 3), 16);
  const g = parseInt(hex2.slice(3, 5), 16);
  const b = parseInt(hex2.slice(5, 7), 16);
  if (alpha2) {
    return `rgba(${r2}, ${g}, ${b}, ${alpha2})`;
  }
  return `rgb(${r2}, ${g}, ${b})`;
};
const getPercentile = ({
  tier,
  position: position2,
  isReal = false,
  dataTiers
}) => {
  var _a;
  let percentile;
  if (position2 === 0 && dataTiers.length > 1) {
    percentile = Math.round(dataTiers[1].percentile * 100);
  } else if (position2 === dataTiers.length - 1) {
    percentile = Math.round((1 - tier.percentile) * 100);
  } else {
    percentile = ((_a = dataTiers == null ? void 0 : dataTiers[position2 + 1]) == null ? void 0 : _a.percentile) ? Math.round((dataTiers[position2 + 1].percentile - tier.percentile) * 100) : 0;
  }
  return percentile < 16 && !isReal ? percentile + 5 : percentile;
};
const getTierText = ({
  tier,
  position: position2,
  dataTiers
}) => {
  if (position2 === 0 && dataTiers.length > 1) {
    return `Bottom ${getPercentile({
      tier,
      position: position2,
      isReal: true,
      dataTiers
    })}% of earners`;
  }
  if (position2 === dataTiers.length - 1) {
    return `Top ${getPercentile({
      tier,
      position: position2,
      isReal: true,
      dataTiers
    })}% of earners`;
  }
  return `${getPercentile({
    tier,
    position: position2,
    isReal: true,
    dataTiers
  })}% of earners`;
};
const AnimatedNumbers = ({
  user,
  isAnimated
}) => {
  const [animating, setAnimating] = useState(isAnimated);
  useEffect(() => {
    if (animating !== isAnimated) {
      setAnimating(isAnimated);
      if (isAnimated) {
        setTimeout(() => {
          setAnimating(false);
        }, 500);
      }
    }
  }, [isAnimated]);
  const {
    karma_points: karmaPoints,
    tier_color: tierColor
  } = user;
  const color2 = getSpecificColor({
    tierColor
  });
  const containsOne = !!karmaPoints && karmaPoints.toString().includes("1");
  const showAnimation = containsOne ? animating : isAnimated;
  return /* @__PURE__ */ jsx("div", { className: "text-5xl font-bold text-black w-full animated-number text-left", children: showAnimation ? /* @__PURE__ */ jsx(AnimatedCounter, { incrementColor: color2, decrementColor: "black", decimalPrecision: 0, value: karmaPoints || 0, color: "black", fontSize: "48px" }) : /* @__PURE__ */ jsx("p", { className: "tracking-[2px]", children: karmaPoints || 0 }) });
};
const KarmaProgress = ({
  user,
  dataTiers
}) => {
  if (!dataTiers) {
    return null;
  }
  const {
    fromColor,
    toColor
  } = get3dColor({
    tierColor: user.tier_color
  });
  const getTierPosition = () => {
    return dataTiers == null ? void 0 : dataTiers.findIndex((tier) => {
      return tier.id === user.tier_id;
    });
  };
  const tierPosition = getTierPosition();
  const getNextTier = () => {
    return dataTiers[tierPosition + 1];
  };
  const nextTier = getNextTier();
  const tierMinPoints = nextTier ? nextTier.min_points : dataTiers[tierPosition].min_points;
  const widthPercentageNumber = user.karma_points / tierMinPoints * 100;
  const widthPercentage = `${widthPercentageNumber > 100 ? 70 : widthPercentageNumber}%`;
  const getPointerBgColor = () => {
    if (widthPercentageNumber < 25 && user.tier_percentile > 0) {
      return "linear-gradient(0deg, #dc2626 0%, #b91c1c 100%)";
    }
    if (widthPercentageNumber < 75 || !nextTier) {
      return `linear-gradient(0deg, ${fromColor} 0%, ${toColor} 100%)`;
    } else {
      return "linear-gradient(0deg, #059669 0%, #15803d 100%)";
    }
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "flex gap-1.5 h-3 w-full relative my-1.5", children: [
    /* @__PURE__ */ jsx("div", { className: "-top-1.5 absolute rounded-full h-6 w-6 flex justify-center items-center", style: {
      background: getPointerBgColor(),
      left: widthPercentage,
      transition: "left ease 0.5s"
    }, children: /* @__PURE__ */ jsx("div", { className: "w-3 h-3 bg-white rounded-full" }) }),
    user.tier_percentile > 0 && /* @__PURE__ */ jsx("div", { className: `bg-gradient-to-t to-red-600 from-red-700 h-full rounded-full flex-1` }),
    /* @__PURE__ */ jsx("div", { style: {
      background: `linear-gradient(0deg, ${fromColor} 0%, ${toColor} 100%)`
    }, className: `${user.tier_percentile > 0 && !!nextTier ? "w-2/4" : "w-3/4"} h-full rounded-full` }),
    nextTier && /* @__PURE__ */ jsx("div", { className: "bg-gradient-to-t to-green-600 from-green-700 h-full rounded-full flex-1" })
  ] }) });
};
const warned = /* @__PURE__ */ new Set();
function warnOnce(condition, message, element) {
  if (condition || warned.has(message))
    return;
  console.warn(message);
  if (element)
    console.warn(element);
  warned.add(message);
}
function createDOMMotionComponentProxy(componentFactory) {
  if (typeof Proxy === "undefined") {
    return componentFactory;
  }
  const componentCache = /* @__PURE__ */ new Map();
  const deprecatedFactoryFunction = (...args) => {
    if (process.env.NODE_ENV !== "production") {
      warnOnce(false, "motion() is deprecated. Use motion.create() instead.");
    }
    return componentFactory(...args);
  };
  return new Proxy(deprecatedFactoryFunction, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (_target, key) => {
      if (key === "create")
        return componentFactory;
      if (!componentCache.has(key)) {
        componentCache.set(key, componentFactory(key));
      }
      return componentCache.get(key);
    }
  });
}
function isAnimationControls(v) {
  return v !== null && typeof v === "object" && typeof v.start === "function";
}
const isKeyframesTarget = (v) => {
  return Array.isArray(v);
};
function shallowCompare(next2, prev2) {
  if (!Array.isArray(prev2))
    return false;
  const prevLength = prev2.length;
  if (prevLength !== next2.length)
    return false;
  for (let i = 0; i < prevLength; i++) {
    if (prev2[i] !== next2[i])
      return false;
  }
  return true;
}
function isVariantLabel(v) {
  return typeof v === "string" || Array.isArray(v);
}
function getValueState(visualElement) {
  const state = [{}, {}];
  visualElement === null || visualElement === void 0 ? void 0 : visualElement.values.forEach((value, key) => {
    state[0][key] = value.get();
    state[1][key] = value.getVelocity();
  });
  return state;
}
function resolveVariantFromProps(props, definition, custom2, visualElement) {
  if (typeof definition === "function") {
    const [current, velocity] = getValueState(visualElement);
    definition = definition(custom2 !== void 0 ? custom2 : props.custom, current, velocity);
  }
  if (typeof definition === "string") {
    definition = props.variants && props.variants[definition];
  }
  if (typeof definition === "function") {
    const [current, velocity] = getValueState(visualElement);
    definition = definition(custom2 !== void 0 ? custom2 : props.custom, current, velocity);
  }
  return definition;
}
function resolveVariant(visualElement, definition, custom2) {
  const props = visualElement.getProps();
  return resolveVariantFromProps(props, definition, custom2 !== void 0 ? custom2 : props.custom, visualElement);
}
const variantPriorityOrder = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
];
const variantProps = ["initial", ...variantPriorityOrder];
const transformPropOrder = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
];
const transformProps = new Set(transformPropOrder);
const secondsToMilliseconds = (seconds) => seconds * 1e3;
const millisecondsToSeconds = (milliseconds) => milliseconds / 1e3;
const underDampedSpring = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
};
const criticallyDampedSpring = (target) => ({
  type: "spring",
  stiffness: 550,
  damping: target === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
});
const keyframesTransition = {
  type: "keyframes",
  duration: 0.8
};
const ease = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
};
const getDefaultTransition = (valueKey, { keyframes: keyframes2 }) => {
  if (keyframes2.length > 2) {
    return keyframesTransition;
  } else if (transformProps.has(valueKey)) {
    return valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes2[1]) : underDampedSpring;
  }
  return ease;
};
function isTransitionDefined(_la) {
  var _ma = _la, { when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from: from2, elapsed } = _ma, transition = __objRest(_ma, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from", "elapsed"]);
  return !!Object.keys(transition).length;
}
function getValueTransition(transition, key) {
  return transition[key] || transition["default"] || transition;
}
const MotionGlobalConfig = {
  skipAnimations: false,
  useManualTiming: false
};
const isNotNull = (value) => value !== null;
function getFinalKeyframe(keyframes2, { repeat, repeatType = "loop" }, finalKeyframe) {
  const resolvedKeyframes = keyframes2.filter(isNotNull);
  const index2 = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
  return !index2 || finalKeyframe === void 0 ? resolvedKeyframes[index2] : finalKeyframe;
}
const noop = (any) => any;
function createRenderStep(runNextFrame) {
  let thisFrame = /* @__PURE__ */ new Set();
  let nextFrame = /* @__PURE__ */ new Set();
  let isProcessing = false;
  let flushNextFrame = false;
  const toKeepAlive = /* @__PURE__ */ new WeakSet();
  let latestFrameData = {
    delta: 0,
    timestamp: 0,
    isProcessing: false
  };
  function triggerCallback(callback) {
    if (toKeepAlive.has(callback)) {
      step.schedule(callback);
      runNextFrame();
    }
    callback(latestFrameData);
  }
  const step = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (callback, keepAlive = false, immediate = false) => {
      const addToCurrentFrame = immediate && isProcessing;
      const queue = addToCurrentFrame ? thisFrame : nextFrame;
      if (keepAlive)
        toKeepAlive.add(callback);
      if (!queue.has(callback))
        queue.add(callback);
      return callback;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (callback) => {
      nextFrame.delete(callback);
      toKeepAlive.delete(callback);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (frameData2) => {
      latestFrameData = frameData2;
      if (isProcessing) {
        flushNextFrame = true;
        return;
      }
      isProcessing = true;
      [thisFrame, nextFrame] = [nextFrame, thisFrame];
      nextFrame.clear();
      thisFrame.forEach(triggerCallback);
      isProcessing = false;
      if (flushNextFrame) {
        flushNextFrame = false;
        step.process(frameData2);
      }
    }
  };
  return step;
}
const stepsOrder = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
const maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
  let runNextFrame = false;
  let useDefaultElapsed = true;
  const state = {
    delta: 0,
    timestamp: 0,
    isProcessing: false
  };
  const flagRunNextFrame = () => runNextFrame = true;
  const steps2 = stepsOrder.reduce((acc, key) => {
    acc[key] = createRenderStep(flagRunNextFrame);
    return acc;
  }, {});
  const { read: read2, resolveKeyframes, update, preRender, render, postRender } = steps2;
  const processBatch = () => {
    const timestamp = performance.now();
    runNextFrame = false;
    state.delta = useDefaultElapsed ? 1e3 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
    state.timestamp = timestamp;
    state.isProcessing = true;
    read2.process(state);
    resolveKeyframes.process(state);
    update.process(state);
    preRender.process(state);
    render.process(state);
    postRender.process(state);
    state.isProcessing = false;
    if (runNextFrame && allowKeepAlive) {
      useDefaultElapsed = false;
      scheduleNextBatch(processBatch);
    }
  };
  const wake = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!state.isProcessing) {
      scheduleNextBatch(processBatch);
    }
  };
  const schedule = stepsOrder.reduce((acc, key) => {
    const step = steps2[key];
    acc[key] = (process2, keepAlive = false, immediate = false) => {
      if (!runNextFrame)
        wake();
      return step.schedule(process2, keepAlive, immediate);
    };
    return acc;
  }, {});
  const cancel = (process2) => {
    for (let i = 0; i < stepsOrder.length; i++) {
      steps2[stepsOrder[i]].cancel(process2);
    }
  };
  return { schedule, cancel, state, steps: steps2 };
}
const { schedule: frame, cancel: cancelFrame, state: frameData, steps } = createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop, true);
const isZeroValueString = (v) => /^0[^.\s]+$/u.test(v);
function isNone(value) {
  if (typeof value === "number") {
    return value === 0;
  } else if (value !== null) {
    return value === "none" || value === "0" || isZeroValueString(value);
  } else {
    return true;
  }
}
let warning = noop;
let invariant = noop;
if (process.env.NODE_ENV !== "production") {
  warning = (check, message) => {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  invariant = (check, message) => {
    if (!check) {
      throw new Error(message);
    }
  };
}
const isNumericalString = (v) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);
const checkStringStartsWith = (token2) => (key) => typeof key === "string" && key.startsWith(token2);
const isCSSVariableName = checkStringStartsWith("--");
const startsAsVariableToken = checkStringStartsWith("var(--");
const isCSSVariableToken = (value) => {
  const startsWithToken = startsAsVariableToken(value);
  if (!startsWithToken)
    return false;
  return singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
const splitCSSVariableRegex = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function parseCSSVariable(current) {
  const match2 = splitCSSVariableRegex.exec(current);
  if (!match2)
    return [,];
  const [, token1, token2, fallback] = match2;
  return [`--${token1 !== null && token1 !== void 0 ? token1 : token2}`, fallback];
}
const maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
  invariant(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
  const [token2, fallback] = parseCSSVariable(current);
  if (!token2)
    return;
  const resolved = window.getComputedStyle(element).getPropertyValue(token2);
  if (resolved) {
    const trimmed = resolved.trim();
    return isNumericalString(trimmed) ? parseFloat(trimmed) : trimmed;
  }
  return isCSSVariableToken(fallback) ? getVariableValue(fallback, element, depth + 1) : fallback;
}
const clamp = (min2, max2, v) => {
  if (v > max2)
    return max2;
  if (v < min2)
    return min2;
  return v;
};
const number = {
  test: (v) => typeof v === "number",
  parse: parseFloat,
  transform: (v) => v
};
const alpha = __spreadProps(__spreadValues({}, number), {
  transform: (v) => clamp(0, 1, v)
});
const scale = __spreadProps(__spreadValues({}, number), {
  default: 1
});
const sanitize = (v) => Math.round(v * 1e5) / 1e5;
const floatRegex = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
const colorRegex = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
const singleColorRegex = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function isString(v) {
  return typeof v === "string";
}
function isNullish(v) {
  return v == null;
}
const createUnitType = (unit) => ({
  test: (v) => isString(v) && v.endsWith(unit) && v.split(" ").length === 1,
  parse: parseFloat,
  transform: (v) => `${v}${unit}`
});
const degrees = /* @__PURE__ */ createUnitType("deg");
const percent = /* @__PURE__ */ createUnitType("%");
const px = /* @__PURE__ */ createUnitType("px");
const vh = /* @__PURE__ */ createUnitType("vh");
const vw = /* @__PURE__ */ createUnitType("vw");
const progressPercentage = __spreadProps(__spreadValues({}, percent), {
  parse: (v) => percent.parse(v) / 100,
  transform: (v) => percent.transform(v * 100)
});
const positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]);
const isNumOrPxType = (v) => v === number || v === px;
const getPosFromMatrix = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
const getTranslateFromMatrix = (pos2, pos3) => (_bbox, { transform }) => {
  if (transform === "none" || !transform)
    return 0;
  const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
  if (matrix3d) {
    return getPosFromMatrix(matrix3d[1], pos3);
  } else {
    const matrix = transform.match(/^matrix\((.+)\)$/u);
    if (matrix) {
      return getPosFromMatrix(matrix[1], pos2);
    } else {
      return 0;
    }
  }
};
const transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]);
const nonTranslationalTransformKeys = transformPropOrder.filter((key) => !transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
  const removedTransforms = [];
  nonTranslationalTransformKeys.forEach((key) => {
    const value = visualElement.getValue(key);
    if (value !== void 0) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  });
  return removedTransforms;
}
const positionalValues = {
  // Dimensions
  width: ({ x: x2 }, { paddingLeft = "0", paddingRight = "0" }) => x2.max - x2.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
  height: ({ y }, { paddingTop = "0", paddingBottom = "0" }) => y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
  top: (_bbox, { top: top2 }) => parseFloat(top2),
  left: (_bbox, { left: left2 }) => parseFloat(left2),
  bottom: ({ y }, { top: top2 }) => parseFloat(top2) + (y.max - y.min),
  right: ({ x: x2 }, { left: left2 }) => parseFloat(left2) + (x2.max - x2.min),
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;
const testValueType = (v) => (type) => type.test(v);
const auto = {
  test: (v) => v === "auto",
  parse: (v) => v
};
const dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
const findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v));
const toResolve = /* @__PURE__ */ new Set();
let isScheduled = false;
let anyNeedsMeasurement = false;
function measureAllKeyframes() {
  if (anyNeedsMeasurement) {
    const resolversToMeasure = Array.from(toResolve).filter((resolver) => resolver.needsMeasurement);
    const elementsToMeasure = new Set(resolversToMeasure.map((resolver) => resolver.element));
    const transformsToRestore = /* @__PURE__ */ new Map();
    elementsToMeasure.forEach((element) => {
      const removedTransforms = removeNonTranslationalTransform(element);
      if (!removedTransforms.length)
        return;
      transformsToRestore.set(element, removedTransforms);
      element.render();
    });
    resolversToMeasure.forEach((resolver) => resolver.measureInitialState());
    elementsToMeasure.forEach((element) => {
      element.render();
      const restore = transformsToRestore.get(element);
      if (restore) {
        restore.forEach(([key, value]) => {
          var _a;
          (_a = element.getValue(key)) === null || _a === void 0 ? void 0 : _a.set(value);
        });
      }
    });
    resolversToMeasure.forEach((resolver) => resolver.measureEndState());
    resolversToMeasure.forEach((resolver) => {
      if (resolver.suspendedScrollY !== void 0) {
        window.scrollTo(0, resolver.suspendedScrollY);
      }
    });
  }
  anyNeedsMeasurement = false;
  isScheduled = false;
  toResolve.forEach((resolver) => resolver.complete());
  toResolve.clear();
}
function readAllKeyframes() {
  toResolve.forEach((resolver) => {
    resolver.readKeyframes();
    if (resolver.needsMeasurement) {
      anyNeedsMeasurement = true;
    }
  });
}
function flushKeyframeResolvers() {
  readAllKeyframes();
  measureAllKeyframes();
}
class KeyframeResolver {
  constructor(unresolvedKeyframes, onComplete, name, motionValue2, element, isAsync2 = false) {
    this.isComplete = false;
    this.isAsync = false;
    this.needsMeasurement = false;
    this.isScheduled = false;
    this.unresolvedKeyframes = [...unresolvedKeyframes];
    this.onComplete = onComplete;
    this.name = name;
    this.motionValue = motionValue2;
    this.element = element;
    this.isAsync = isAsync2;
  }
  scheduleResolve() {
    this.isScheduled = true;
    if (this.isAsync) {
      toResolve.add(this);
      if (!isScheduled) {
        isScheduled = true;
        frame.read(readAllKeyframes);
        frame.resolveKeyframes(measureAllKeyframes);
      }
    } else {
      this.readKeyframes();
      this.complete();
    }
  }
  readKeyframes() {
    const { unresolvedKeyframes, name, element, motionValue: motionValue2 } = this;
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      if (unresolvedKeyframes[i] === null) {
        if (i === 0) {
          const currentValue = motionValue2 === null || motionValue2 === void 0 ? void 0 : motionValue2.get();
          const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
          if (currentValue !== void 0) {
            unresolvedKeyframes[0] = currentValue;
          } else if (element && name) {
            const valueAsRead = element.readValue(name, finalKeyframe);
            if (valueAsRead !== void 0 && valueAsRead !== null) {
              unresolvedKeyframes[0] = valueAsRead;
            }
          }
          if (unresolvedKeyframes[0] === void 0) {
            unresolvedKeyframes[0] = finalKeyframe;
          }
          if (motionValue2 && currentValue === void 0) {
            motionValue2.set(unresolvedKeyframes[0]);
          }
        } else {
          unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
      }
    }
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = true;
    this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
    toResolve.delete(this);
  }
  cancel() {
    if (!this.isComplete) {
      this.isScheduled = false;
      toResolve.delete(this);
    }
  }
  resume() {
    if (!this.isComplete)
      this.scheduleResolve();
  }
}
const isColorString = (type, testProp) => (v) => {
  return Boolean(isString(v) && singleColorRegex.test(v) && v.startsWith(type) || testProp && !isNullish(v) && Object.prototype.hasOwnProperty.call(v, testProp));
};
const splitColor = (aName, bName, cName) => (v) => {
  if (!isString(v))
    return v;
  const [a2, b, c2, alpha2] = v.match(floatRegex);
  return {
    [aName]: parseFloat(a2),
    [bName]: parseFloat(b),
    [cName]: parseFloat(c2),
    alpha: alpha2 !== void 0 ? parseFloat(alpha2) : 1
  };
};
const clampRgbUnit = (v) => clamp(0, 255, v);
const rgbUnit = __spreadProps(__spreadValues({}, number), {
  transform: (v) => Math.round(clampRgbUnit(v))
});
const rgba = {
  test: /* @__PURE__ */ isColorString("rgb", "red"),
  parse: /* @__PURE__ */ splitColor("red", "green", "blue"),
  transform: ({ red: red2, green: green2, blue: blue2, alpha: alpha$12 = 1 }) => "rgba(" + rgbUnit.transform(red2) + ", " + rgbUnit.transform(green2) + ", " + rgbUnit.transform(blue2) + ", " + sanitize(alpha.transform(alpha$12)) + ")"
};
function parseHex(v) {
  let r2 = "";
  let g = "";
  let b = "";
  let a2 = "";
  if (v.length > 5) {
    r2 = v.substring(1, 3);
    g = v.substring(3, 5);
    b = v.substring(5, 7);
    a2 = v.substring(7, 9);
  } else {
    r2 = v.substring(1, 2);
    g = v.substring(2, 3);
    b = v.substring(3, 4);
    a2 = v.substring(4, 5);
    r2 += r2;
    g += g;
    b += b;
    a2 += a2;
  }
  return {
    red: parseInt(r2, 16),
    green: parseInt(g, 16),
    blue: parseInt(b, 16),
    alpha: a2 ? parseInt(a2, 16) / 255 : 1
  };
}
const hex = {
  test: /* @__PURE__ */ isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
};
const hsla = {
  test: /* @__PURE__ */ isColorString("hsl", "hue"),
  parse: /* @__PURE__ */ splitColor("hue", "saturation", "lightness"),
  transform: ({ hue, saturation, lightness, alpha: alpha$12 = 1 }) => {
    return "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha.transform(alpha$12)) + ")";
  }
};
const color = {
  test: (v) => rgba.test(v) || hex.test(v) || hsla.test(v),
  parse: (v) => {
    if (rgba.test(v)) {
      return rgba.parse(v);
    } else if (hsla.test(v)) {
      return hsla.parse(v);
    } else {
      return hex.parse(v);
    }
  },
  transform: (v) => {
    return isString(v) ? v : v.hasOwnProperty("red") ? rgba.transform(v) : hsla.transform(v);
  }
};
function test(v) {
  var _a, _b;
  return isNaN(v) && isString(v) && (((_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const NUMBER_TOKEN = "number";
const COLOR_TOKEN = "color";
const VAR_TOKEN = "var";
const VAR_FUNCTION_TOKEN = "var(";
const SPLIT_TOKEN = "${}";
const complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function analyseComplexValue(value) {
  const originalValue = value.toString();
  const values2 = [];
  const indexes = {
    color: [],
    number: [],
    var: []
  };
  const types2 = [];
  let i = 0;
  const tokenised = originalValue.replace(complexRegex, (parsedValue) => {
    if (color.test(parsedValue)) {
      indexes.color.push(i);
      types2.push(COLOR_TOKEN);
      values2.push(color.parse(parsedValue));
    } else if (parsedValue.startsWith(VAR_FUNCTION_TOKEN)) {
      indexes.var.push(i);
      types2.push(VAR_TOKEN);
      values2.push(parsedValue);
    } else {
      indexes.number.push(i);
      types2.push(NUMBER_TOKEN);
      values2.push(parseFloat(parsedValue));
    }
    ++i;
    return SPLIT_TOKEN;
  });
  const split = tokenised.split(SPLIT_TOKEN);
  return { values: values2, split, indexes, types: types2 };
}
function parseComplexValue(v) {
  return analyseComplexValue(v).values;
}
function createTransformer(source) {
  const { split, types: types2 } = analyseComplexValue(source);
  const numSections = split.length;
  return (v) => {
    let output = "";
    for (let i = 0; i < numSections; i++) {
      output += split[i];
      if (v[i] !== void 0) {
        const type = types2[i];
        if (type === NUMBER_TOKEN) {
          output += sanitize(v[i]);
        } else if (type === COLOR_TOKEN) {
          output += color.transform(v[i]);
        } else {
          output += v[i];
        }
      }
    }
    return output;
  };
}
const convertNumbersToZero = (v) => typeof v === "number" ? 0 : v;
function getAnimatableNone$1(v) {
  const parsed = parseComplexValue(v);
  const transformer = createTransformer(v);
  return transformer(parsed.map(convertNumbersToZero));
}
const complex = {
  test,
  parse: parseComplexValue,
  createTransformer,
  getAnimatableNone: getAnimatableNone$1
};
const maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
  const [name, value] = v.slice(0, -1).split("(");
  if (name === "drop-shadow")
    return v;
  const [number2] = value.match(floatRegex) || [];
  if (!number2)
    return v;
  const unit = value.replace(number2, "");
  let defaultValue2 = maxDefaults.has(name) ? 1 : 0;
  if (number2 !== value)
    defaultValue2 *= 100;
  return name + "(" + defaultValue2 + unit + ")";
}
const functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const filter = __spreadProps(__spreadValues({}, complex), {
  getAnimatableNone: (v) => {
    const functions = v.match(functionRegex);
    return functions ? functions.map(applyDefaultFilter).join(" ") : v;
  }
});
const int = __spreadProps(__spreadValues({}, number), {
  transform: Math.round
});
const numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Transform props
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  // Misc
  zIndex: int,
  backgroundPositionX: px,
  backgroundPositionY: px,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};
const defaultValueTypes = __spreadProps(__spreadValues({}, numberValueTypes), {
  // Color props
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter,
  WebkitFilter: filter
});
const getDefaultValueType = (key) => defaultValueTypes[key];
function getAnimatableNone(key, value) {
  let defaultValueType = getDefaultValueType(key);
  if (defaultValueType !== filter)
    defaultValueType = complex;
  return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : void 0;
}
const invalidTemplates = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name) {
  let i = 0;
  let animatableTemplate = void 0;
  while (i < unresolvedKeyframes.length && !animatableTemplate) {
    const keyframe = unresolvedKeyframes[i];
    if (typeof keyframe === "string" && !invalidTemplates.has(keyframe) && analyseComplexValue(keyframe).values.length) {
      animatableTemplate = unresolvedKeyframes[i];
    }
    i++;
  }
  if (animatableTemplate && name) {
    for (const noneIndex of noneKeyframeIndexes) {
      unresolvedKeyframes[noneIndex] = getAnimatableNone(name, animatableTemplate);
    }
  }
}
class DOMKeyframesResolver extends KeyframeResolver {
  constructor(unresolvedKeyframes, onComplete, name, motionValue2, element) {
    super(unresolvedKeyframes, onComplete, name, motionValue2, element, true);
  }
  readKeyframes() {
    const { unresolvedKeyframes, element, name } = this;
    if (!element || !element.current)
      return;
    super.readKeyframes();
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      let keyframe = unresolvedKeyframes[i];
      if (typeof keyframe === "string") {
        keyframe = keyframe.trim();
        if (isCSSVariableToken(keyframe)) {
          const resolved = getVariableValue(keyframe, element.current);
          if (resolved !== void 0) {
            unresolvedKeyframes[i] = resolved;
          }
          if (i === unresolvedKeyframes.length - 1) {
            this.finalKeyframe = keyframe;
          }
        }
      }
    }
    this.resolveNoneKeyframes();
    if (!positionalKeys.has(name) || unresolvedKeyframes.length !== 2) {
      return;
    }
    const [origin, target] = unresolvedKeyframes;
    const originType = findDimensionValueType(origin);
    const targetType = findDimensionValueType(target);
    if (originType === targetType)
      return;
    if (isNumOrPxType(originType) && isNumOrPxType(targetType)) {
      for (let i = 0; i < unresolvedKeyframes.length; i++) {
        const value = unresolvedKeyframes[i];
        if (typeof value === "string") {
          unresolvedKeyframes[i] = parseFloat(value);
        }
      }
    } else {
      this.needsMeasurement = true;
    }
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes, name } = this;
    const noneKeyframeIndexes = [];
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      if (isNone(unresolvedKeyframes[i])) {
        noneKeyframeIndexes.push(i);
      }
    }
    if (noneKeyframeIndexes.length) {
      makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
  }
  measureInitialState() {
    const { element, unresolvedKeyframes, name } = this;
    if (!element || !element.current)
      return;
    if (name === "height") {
      this.suspendedScrollY = window.pageYOffset;
    }
    this.measuredOrigin = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
    unresolvedKeyframes[0] = this.measuredOrigin;
    const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
    if (measureKeyframe !== void 0) {
      element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
  }
  measureEndState() {
    var _a;
    const { element, name, unresolvedKeyframes } = this;
    if (!element || !element.current)
      return;
    const value = element.getValue(name);
    value && value.jump(this.measuredOrigin, false);
    const finalKeyframeIndex = unresolvedKeyframes.length - 1;
    const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
    unresolvedKeyframes[finalKeyframeIndex] = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
    if (finalKeyframe !== null && this.finalKeyframe === void 0) {
      this.finalKeyframe = finalKeyframe;
    }
    if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) {
      this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue]) => {
        element.getValue(unsetTransformName).set(unsetTransformValue);
      });
    }
    this.resolveNoneKeyframes();
  }
}
function memo(callback) {
  let result;
  return () => {
    if (result === void 0)
      result = callback();
    return result;
  };
}
let now;
function clearTime() {
  now = void 0;
}
const time = {
  now: () => {
    if (now === void 0) {
      time.set(frameData.isProcessing || MotionGlobalConfig.useManualTiming ? frameData.timestamp : performance.now());
    }
    return now;
  },
  set: (newTime) => {
    now = newTime;
    queueMicrotask(clearTime);
  }
};
const isAnimatable = (value, name) => {
  if (name === "zIndex")
    return false;
  if (typeof value === "number" || Array.isArray(value))
    return true;
  if (typeof value === "string" && // It's animatable if we have a string
  (complex.test(value) || value === "0") && // And it contains numbers and/or colors
  !value.startsWith("url(")) {
    return true;
  }
  return false;
};
function hasKeyframesChanged(keyframes2) {
  const current = keyframes2[0];
  if (keyframes2.length === 1)
    return true;
  for (let i = 0; i < keyframes2.length; i++) {
    if (keyframes2[i] !== current)
      return true;
  }
}
function canAnimate(keyframes2, name, type, velocity) {
  const originKeyframe = keyframes2[0];
  if (originKeyframe === null)
    return false;
  if (name === "display" || name === "visibility")
    return true;
  const targetKeyframe = keyframes2[keyframes2.length - 1];
  const isOriginAnimatable = isAnimatable(originKeyframe, name);
  const isTargetAnimatable = isAnimatable(targetKeyframe, name);
  warning(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
  if (!isOriginAnimatable || !isTargetAnimatable) {
    return false;
  }
  return hasKeyframesChanged(keyframes2) || type === "spring" && velocity;
}
const MAX_RESOLVE_DELAY = 40;
class BaseAnimation {
  constructor(_na) {
    var _oa = _na, { autoplay = true, delay: delay2 = 0, type = "keyframes", repeat = 0, repeatDelay = 0, repeatType = "loop" } = _oa, options = __objRest(_oa, ["autoplay", "delay", "type", "repeat", "repeatDelay", "repeatType"]);
    this.isStopped = false;
    this.hasAttemptedResolve = false;
    this.createdAt = time.now();
    this.options = __spreadValues({
      autoplay,
      delay: delay2,
      type,
      repeat,
      repeatDelay,
      repeatType
    }, options);
    this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    if (!this.resolvedAt)
      return this.createdAt;
    return this.resolvedAt - this.createdAt > MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    if (!this._resolved && !this.hasAttemptedResolve) {
      flushKeyframeResolvers();
    }
    return this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(keyframes2, finalKeyframe) {
    this.resolvedAt = time.now();
    this.hasAttemptedResolve = true;
    const { name, type, velocity, delay: delay2, onComplete, onUpdate, isGenerator } = this.options;
    if (!isGenerator && !canAnimate(keyframes2, name, type, velocity)) {
      if (!delay2) {
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(getFinalKeyframe(keyframes2, this.options, finalKeyframe));
        onComplete === null || onComplete === void 0 ? void 0 : onComplete();
        this.resolveFinishedPromise();
        return;
      } else {
        this.options.duration = 0;
      }
    }
    const resolvedAnimation = this.initPlayback(keyframes2, finalKeyframe);
    if (resolvedAnimation === false)
      return;
    this._resolved = __spreadValues({
      keyframes: keyframes2,
      finalKeyframe
    }, resolvedAnimation);
    this.onPostResolved();
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(resolve, reject) {
    return this.currentFinishedPromise.then(resolve, reject);
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((resolve) => {
      this.resolveFinishedPromise = resolve;
    });
  }
}
function velocityPerSecond(velocity, frameDuration) {
  return frameDuration ? velocity * (1e3 / frameDuration) : 0;
}
const velocitySampleDuration = 5;
function calcGeneratorVelocity(resolveValue, t2, current) {
  const prevT = Math.max(t2 - velocitySampleDuration, 0);
  return velocityPerSecond(current - resolveValue(prevT), t2 - prevT);
}
const safeMin = 1e-3;
const minDuration = 0.01;
const maxDuration$1 = 10;
const minDamping = 0.05;
const maxDamping = 1;
function findSpring({ duration: duration2 = 800, bounce = 0.25, velocity = 0, mass = 1 }) {
  let envelope;
  let derivative;
  warning(duration2 <= secondsToMilliseconds(maxDuration$1), "Spring duration must be 10 seconds or less");
  let dampingRatio = 1 - bounce;
  dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
  duration2 = clamp(minDuration, maxDuration$1, millisecondsToSeconds(duration2));
  if (dampingRatio < 1) {
    envelope = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration2;
      const a2 = exponentialDecay - velocity;
      const b = calcAngularFreq(undampedFreq2, dampingRatio);
      const c2 = Math.exp(-delta);
      return safeMin - a2 / b * c2;
    };
    derivative = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration2;
      const d = delta * velocity + velocity;
      const e2 = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq2, 2) * duration2;
      const f = Math.exp(-delta);
      const g = calcAngularFreq(Math.pow(undampedFreq2, 2), dampingRatio);
      const factor = -envelope(undampedFreq2) + safeMin > 0 ? -1 : 1;
      return factor * ((d - e2) * f) / g;
    };
  } else {
    envelope = (undampedFreq2) => {
      const a2 = Math.exp(-undampedFreq2 * duration2);
      const b = (undampedFreq2 - velocity) * duration2 + 1;
      return -safeMin + a2 * b;
    };
    derivative = (undampedFreq2) => {
      const a2 = Math.exp(-undampedFreq2 * duration2);
      const b = (velocity - undampedFreq2) * (duration2 * duration2);
      return a2 * b;
    };
  }
  const initialGuess = 5 / duration2;
  const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
  duration2 = secondsToMilliseconds(duration2);
  if (isNaN(undampedFreq)) {
    return {
      stiffness: 100,
      damping: 10,
      duration: duration2
    };
  } else {
    const stiffness = Math.pow(undampedFreq, 2) * mass;
    return {
      stiffness,
      damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
      duration: duration2
    };
  }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
  let result = initialGuess;
  for (let i = 1; i < rootIterations; i++) {
    result = result - envelope(result) / derivative(result);
  }
  return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
  return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
const durationKeys = ["duration", "bounce"];
const physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
  return keys.some((key) => options[key] !== void 0);
}
function getSpringOptions(options) {
  let springOptions = __spreadValues({
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: false
  }, options);
  if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
    const derived = findSpring(options);
    springOptions = __spreadProps(__spreadValues(__spreadValues({}, springOptions), derived), {
      mass: 1
    });
    springOptions.isResolvedFromDuration = true;
  }
  return springOptions;
}
function spring(_pa) {
  var _qa = _pa, { keyframes: keyframes2, restDelta, restSpeed } = _qa, options = __objRest(_qa, ["keyframes", "restDelta", "restSpeed"]);
  const origin = keyframes2[0];
  const target = keyframes2[keyframes2.length - 1];
  const state = { done: false, value: origin };
  const { stiffness, damping, mass, duration: duration2, velocity, isResolvedFromDuration } = getSpringOptions(__spreadProps(__spreadValues({}, options), {
    velocity: -millisecondsToSeconds(options.velocity || 0)
  }));
  const initialVelocity = velocity || 0;
  const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
  const initialDelta = target - origin;
  const undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass));
  const isGranularScale = Math.abs(initialDelta) < 5;
  restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
  restDelta || (restDelta = isGranularScale ? 5e-3 : 0.5);
  let resolveSpring;
  if (dampingRatio < 1) {
    const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
    resolveSpring = (t2) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t2);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t2) + initialDelta * Math.cos(angularFreq * t2));
    };
  } else if (dampingRatio === 1) {
    resolveSpring = (t2) => target - Math.exp(-undampedAngularFreq * t2) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t2);
  } else {
    const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
    resolveSpring = (t2) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t2);
      const freqForT = Math.min(dampedAngularFreq * t2, 300);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
    };
  }
  return {
    calculatedDuration: isResolvedFromDuration ? duration2 || null : null,
    next: (t2) => {
      const current = resolveSpring(t2);
      if (!isResolvedFromDuration) {
        let currentVelocity = 0;
        if (dampingRatio < 1) {
          currentVelocity = t2 === 0 ? secondsToMilliseconds(initialVelocity) : calcGeneratorVelocity(resolveSpring, t2, current);
        }
        const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
      } else {
        state.done = t2 >= duration2;
      }
      state.value = state.done ? target : current;
      return state;
    }
  };
}
function inertia({ keyframes: keyframes2, velocity = 0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min: min2, max: max2, restDelta = 0.5, restSpeed }) {
  const origin = keyframes2[0];
  const state = {
    done: false,
    value: origin
  };
  const isOutOfBounds = (v) => min2 !== void 0 && v < min2 || max2 !== void 0 && v > max2;
  const nearestBoundary = (v) => {
    if (min2 === void 0)
      return max2;
    if (max2 === void 0)
      return min2;
    return Math.abs(min2 - v) < Math.abs(max2 - v) ? min2 : max2;
  };
  let amplitude = power * velocity;
  const ideal = origin + amplitude;
  const target = modifyTarget === void 0 ? ideal : modifyTarget(ideal);
  if (target !== ideal)
    amplitude = target - origin;
  const calcDelta = (t2) => -amplitude * Math.exp(-t2 / timeConstant);
  const calcLatest = (t2) => target + calcDelta(t2);
  const applyFriction = (t2) => {
    const delta = calcDelta(t2);
    const latest = calcLatest(t2);
    state.done = Math.abs(delta) <= restDelta;
    state.value = state.done ? target : latest;
  };
  let timeReachedBoundary;
  let spring$12;
  const checkCatchBoundary = (t2) => {
    if (!isOutOfBounds(state.value))
      return;
    timeReachedBoundary = t2;
    spring$12 = spring({
      keyframes: [state.value, nearestBoundary(state.value)],
      velocity: calcGeneratorVelocity(calcLatest, t2, state.value),
      // TODO: This should be passing * 1000
      damping: bounceDamping,
      stiffness: bounceStiffness,
      restDelta,
      restSpeed
    });
  };
  checkCatchBoundary(0);
  return {
    calculatedDuration: null,
    next: (t2) => {
      let hasUpdatedFrame = false;
      if (!spring$12 && timeReachedBoundary === void 0) {
        hasUpdatedFrame = true;
        applyFriction(t2);
        checkCatchBoundary(t2);
      }
      if (timeReachedBoundary !== void 0 && t2 >= timeReachedBoundary) {
        return spring$12.next(t2 - timeReachedBoundary);
      } else {
        !hasUpdatedFrame && applyFriction(t2);
        return state;
      }
    }
  };
}
const calcBezier = (t2, a1, a2) => (((1 - 3 * a2 + 3 * a1) * t2 + (3 * a2 - 6 * a1)) * t2 + 3 * a1) * t2;
const subdivisionPrecision = 1e-7;
const subdivisionMaxIterations = 12;
function binarySubdivide(x2, lowerBound, upperBound, mX1, mX2) {
  let currentX;
  let currentT;
  let i = 0;
  do {
    currentT = lowerBound + (upperBound - lowerBound) / 2;
    currentX = calcBezier(currentT, mX1, mX2) - x2;
    if (currentX > 0) {
      upperBound = currentT;
    } else {
      lowerBound = currentT;
    }
  } while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
  return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
  if (mX1 === mY1 && mX2 === mY2)
    return noop;
  const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
  return (t2) => t2 === 0 || t2 === 1 ? t2 : calcBezier(getTForX(t2), mY1, mY2);
}
const easeIn = /* @__PURE__ */ cubicBezier(0.42, 0, 1, 1);
const easeOut = /* @__PURE__ */ cubicBezier(0, 0, 0.58, 1);
const easeInOut = /* @__PURE__ */ cubicBezier(0.42, 0, 0.58, 1);
const isEasingArray = (ease2) => {
  return Array.isArray(ease2) && typeof ease2[0] !== "number";
};
const mirrorEasing = (easing2) => (p) => p <= 0.5 ? easing2(2 * p) / 2 : (2 - easing2(2 * (1 - p))) / 2;
const reverseEasing = (easing2) => (p) => 1 - easing2(1 - p);
const circIn = (p) => 1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circIn);
const backOut = /* @__PURE__ */ cubicBezier(0.33, 1.53, 0.69, 0.99);
const backIn = /* @__PURE__ */ reverseEasing(backOut);
const backInOut = /* @__PURE__ */ mirrorEasing(backIn);
const anticipate = (p) => (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
const easingLookup = {
  linear: noop,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate
};
const easingDefinitionToFunction = (definition) => {
  if (Array.isArray(definition)) {
    invariant(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
    const [x1, y1, x2, y2] = definition;
    return cubicBezier(x1, y1, x2, y2);
  } else if (typeof definition === "string") {
    invariant(easingLookup[definition] !== void 0, `Invalid easing type '${definition}'`);
    return easingLookup[definition];
  }
  return definition;
};
const combineFunctions = (a2, b) => (v) => b(a2(v));
const pipe = (...transformers) => transformers.reduce(combineFunctions);
const progress = (from2, to, value) => {
  const toFromDifference = to - from2;
  return toFromDifference === 0 ? 1 : (value - from2) / toFromDifference;
};
const mixNumber$1 = (from2, to, progress2) => {
  return from2 + (to - from2) * progress2;
};
function hueToRgb(p, q, t2) {
  if (t2 < 0)
    t2 += 1;
  if (t2 > 1)
    t2 -= 1;
  if (t2 < 1 / 6)
    return p + (q - p) * 6 * t2;
  if (t2 < 1 / 2)
    return q;
  if (t2 < 2 / 3)
    return p + (q - p) * (2 / 3 - t2) * 6;
  return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha: alpha2 }) {
  hue /= 360;
  saturation /= 100;
  lightness /= 100;
  let red2 = 0;
  let green2 = 0;
  let blue2 = 0;
  if (!saturation) {
    red2 = green2 = blue2 = lightness;
  } else {
    const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
    const p = 2 * lightness - q;
    red2 = hueToRgb(p, q, hue + 1 / 3);
    green2 = hueToRgb(p, q, hue);
    blue2 = hueToRgb(p, q, hue - 1 / 3);
  }
  return {
    red: Math.round(red2 * 255),
    green: Math.round(green2 * 255),
    blue: Math.round(blue2 * 255),
    alpha: alpha2
  };
}
function mixImmediate(a2, b) {
  return (p) => p > 0 ? b : a2;
}
const mixLinearColor = (from2, to, v) => {
  const fromExpo = from2 * from2;
  const expo = v * (to * to - fromExpo) + fromExpo;
  return expo < 0 ? 0 : Math.sqrt(expo);
};
const colorTypes = [hex, rgba, hsla];
const getColorType = (v) => colorTypes.find((type) => type.test(v));
function asRGBA(color2) {
  const type = getColorType(color2);
  warning(Boolean(type), `'${color2}' is not an animatable color. Use the equivalent color code instead.`);
  if (!Boolean(type))
    return false;
  let model = type.parse(color2);
  if (type === hsla) {
    model = hslaToRgba(model);
  }
  return model;
}
const mixColor = (from2, to) => {
  const fromRGBA = asRGBA(from2);
  const toRGBA = asRGBA(to);
  if (!fromRGBA || !toRGBA) {
    return mixImmediate(from2, to);
  }
  const blended = __spreadValues({}, fromRGBA);
  return (v) => {
    blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
    blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
    blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
    blended.alpha = mixNumber$1(fromRGBA.alpha, toRGBA.alpha, v);
    return rgba.transform(blended);
  };
};
const invisibleValues = /* @__PURE__ */ new Set(["none", "hidden"]);
function mixVisibility(origin, target) {
  if (invisibleValues.has(origin)) {
    return (p) => p <= 0 ? origin : target;
  } else {
    return (p) => p >= 1 ? target : origin;
  }
}
function mixNumber(a2, b) {
  return (p) => mixNumber$1(a2, b, p);
}
function getMixer(a2) {
  if (typeof a2 === "number") {
    return mixNumber;
  } else if (typeof a2 === "string") {
    return isCSSVariableToken(a2) ? mixImmediate : color.test(a2) ? mixColor : mixComplex;
  } else if (Array.isArray(a2)) {
    return mixArray;
  } else if (typeof a2 === "object") {
    return color.test(a2) ? mixColor : mixObject;
  }
  return mixImmediate;
}
function mixArray(a2, b) {
  const output = [...a2];
  const numValues = output.length;
  const blendValue = a2.map((v, i) => getMixer(v)(v, b[i]));
  return (p) => {
    for (let i = 0; i < numValues; i++) {
      output[i] = blendValue[i](p);
    }
    return output;
  };
}
function mixObject(a2, b) {
  const output = __spreadValues(__spreadValues({}, a2), b);
  const blendValue = {};
  for (const key in output) {
    if (a2[key] !== void 0 && b[key] !== void 0) {
      blendValue[key] = getMixer(a2[key])(a2[key], b[key]);
    }
  }
  return (v) => {
    for (const key in blendValue) {
      output[key] = blendValue[key](v);
    }
    return output;
  };
}
function matchOrder(origin, target) {
  var _a;
  const orderedOrigin = [];
  const pointers = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < target.values.length; i++) {
    const type = target.types[i];
    const originIndex = origin.indexes[type][pointers[type]];
    const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
    orderedOrigin[i] = originValue;
    pointers[type]++;
  }
  return orderedOrigin;
}
const mixComplex = (origin, target) => {
  const template = complex.createTransformer(target);
  const originStats = analyseComplexValue(origin);
  const targetStats = analyseComplexValue(target);
  const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
  if (canInterpolate) {
    if (invisibleValues.has(origin) && !targetStats.values.length || invisibleValues.has(target) && !originStats.values.length) {
      return mixVisibility(origin, target);
    }
    return pipe(mixArray(matchOrder(originStats, targetStats), targetStats.values), template);
  } else {
    warning(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
    return mixImmediate(origin, target);
  }
};
function mix(from2, to, p) {
  if (typeof from2 === "number" && typeof to === "number" && typeof p === "number") {
    return mixNumber$1(from2, to, p);
  }
  const mixer = getMixer(from2);
  return mixer(from2, to);
}
function createMixers(output, ease2, customMixer) {
  const mixers = [];
  const mixerFactory = customMixer || mix;
  const numMixers = output.length - 1;
  for (let i = 0; i < numMixers; i++) {
    let mixer = mixerFactory(output[i], output[i + 1]);
    if (ease2) {
      const easingFunction = Array.isArray(ease2) ? ease2[i] || noop : ease2;
      mixer = pipe(easingFunction, mixer);
    }
    mixers.push(mixer);
  }
  return mixers;
}
function interpolate(input, output, { clamp: isClamp = true, ease: ease2, mixer } = {}) {
  const inputLength = input.length;
  invariant(inputLength === output.length, "Both input and output ranges must be the same length");
  if (inputLength === 1)
    return () => output[0];
  if (inputLength === 2 && input[0] === input[1])
    return () => output[1];
  if (input[0] > input[inputLength - 1]) {
    input = [...input].reverse();
    output = [...output].reverse();
  }
  const mixers = createMixers(output, ease2, mixer);
  const numMixers = mixers.length;
  const interpolator = (v) => {
    let i = 0;
    if (numMixers > 1) {
      for (; i < input.length - 2; i++) {
        if (v < input[i + 1])
          break;
      }
    }
    const progressInRange = progress(input[i], input[i + 1], v);
    return mixers[i](progressInRange);
  };
  return isClamp ? (v) => interpolator(clamp(input[0], input[inputLength - 1], v)) : interpolator;
}
function fillOffset(offset2, remaining) {
  const min2 = offset2[offset2.length - 1];
  for (let i = 1; i <= remaining; i++) {
    const offsetProgress = progress(0, remaining, i);
    offset2.push(mixNumber$1(min2, 1, offsetProgress));
  }
}
function defaultOffset(arr) {
  const offset2 = [0];
  fillOffset(offset2, arr.length - 1);
  return offset2;
}
function convertOffsetToTimes(offset2, duration2) {
  return offset2.map((o2) => o2 * duration2);
}
function defaultEasing(values2, easing2) {
  return values2.map(() => easing2 || easeInOut).splice(0, values2.length - 1);
}
function keyframes({ duration: duration2 = 300, keyframes: keyframeValues, times, ease: ease2 = "easeInOut" }) {
  const easingFunctions = isEasingArray(ease2) ? ease2.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease2);
  const state = {
    done: false,
    value: keyframeValues[0]
  };
  const absoluteTimes = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : defaultOffset(keyframeValues),
    duration2
  );
  const mapTimeToKeyframe = interpolate(absoluteTimes, keyframeValues, {
    ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions)
  });
  return {
    calculatedDuration: duration2,
    next: (t2) => {
      state.value = mapTimeToKeyframe(t2);
      state.done = t2 >= duration2;
      return state;
    }
  };
}
const maxGeneratorDuration = 2e4;
function calcGeneratorDuration(generator) {
  let duration2 = 0;
  const timeStep = 50;
  let state = generator.next(duration2);
  while (!state.done && duration2 < maxGeneratorDuration) {
    duration2 += timeStep;
    state = generator.next(duration2);
  }
  return duration2 >= maxGeneratorDuration ? Infinity : duration2;
}
const frameloopDriver = (update) => {
  const passTimestamp = ({ timestamp }) => update(timestamp);
  return {
    start: () => frame.update(passTimestamp, true),
    stop: () => cancelFrame(passTimestamp),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => frameData.isProcessing ? frameData.timestamp : time.now()
  };
};
const generators = {
  decay: inertia,
  inertia,
  tween: keyframes,
  keyframes,
  spring
};
const percentToProgress = (percent2) => percent2 / 100;
class MainThreadAnimation extends BaseAnimation {
  constructor(options) {
    super(options);
    this.holdTime = null;
    this.cancelTime = null;
    this.currentTime = 0;
    this.playbackSpeed = 1;
    this.pendingPlayState = "running";
    this.startTime = null;
    this.state = "idle";
    this.stop = () => {
      this.resolver.cancel();
      this.isStopped = true;
      if (this.state === "idle")
        return;
      this.teardown();
      const { onStop } = this.options;
      onStop && onStop();
    };
    const { name, motionValue: motionValue2, element, keyframes: keyframes2 } = this.options;
    const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || KeyframeResolver;
    const onResolved = (resolvedKeyframes, finalKeyframe) => this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
    this.resolver = new KeyframeResolver$1(keyframes2, onResolved, name, motionValue2, element);
    this.resolver.scheduleResolve();
  }
  initPlayback(keyframes$12) {
    const { type = "keyframes", repeat = 0, repeatDelay = 0, repeatType, velocity = 0 } = this.options;
    const generatorFactory = generators[type] || keyframes;
    let mapPercentToKeyframes;
    let mirroredGenerator;
    if (generatorFactory !== keyframes && typeof keyframes$12[0] !== "number") {
      if (process.env.NODE_ENV !== "production") {
        invariant(keyframes$12.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${keyframes$12}`);
      }
      mapPercentToKeyframes = pipe(percentToProgress, mix(keyframes$12[0], keyframes$12[1]));
      keyframes$12 = [0, 100];
    }
    const generator = generatorFactory(__spreadProps(__spreadValues({}, this.options), { keyframes: keyframes$12 }));
    if (repeatType === "mirror") {
      mirroredGenerator = generatorFactory(__spreadProps(__spreadValues({}, this.options), {
        keyframes: [...keyframes$12].reverse(),
        velocity: -velocity
      }));
    }
    if (generator.calculatedDuration === null) {
      generator.calculatedDuration = calcGeneratorDuration(generator);
    }
    const { calculatedDuration } = generator;
    const resolvedDuration = calculatedDuration + repeatDelay;
    const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    return {
      generator,
      mirroredGenerator,
      mapPercentToKeyframes,
      calculatedDuration,
      resolvedDuration,
      totalDuration
    };
  }
  onPostResolved() {
    const { autoplay = true } = this.options;
    this.play();
    if (this.pendingPlayState === "paused" || !autoplay) {
      this.pause();
    } else {
      this.state = this.pendingPlayState;
    }
  }
  tick(timestamp, sample = false) {
    const { resolved } = this;
    if (!resolved) {
      const { keyframes: keyframes3 } = this.options;
      return { done: true, value: keyframes3[keyframes3.length - 1] };
    }
    const { finalKeyframe, generator, mirroredGenerator, mapPercentToKeyframes, keyframes: keyframes2, calculatedDuration, totalDuration, resolvedDuration } = resolved;
    if (this.startTime === null)
      return generator.next(0);
    const { delay: delay2, repeat, repeatType, repeatDelay, onUpdate } = this.options;
    if (this.speed > 0) {
      this.startTime = Math.min(this.startTime, timestamp);
    } else if (this.speed < 0) {
      this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
    }
    if (sample) {
      this.currentTime = timestamp;
    } else if (this.holdTime !== null) {
      this.currentTime = this.holdTime;
    } else {
      this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
    }
    const timeWithoutDelay = this.currentTime - delay2 * (this.speed >= 0 ? 1 : -1);
    const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
    this.currentTime = Math.max(timeWithoutDelay, 0);
    if (this.state === "finished" && this.holdTime === null) {
      this.currentTime = totalDuration;
    }
    let elapsed = this.currentTime;
    let frameGenerator = generator;
    if (repeat) {
      const progress2 = Math.min(this.currentTime, totalDuration) / resolvedDuration;
      let currentIteration = Math.floor(progress2);
      let iterationProgress = progress2 % 1;
      if (!iterationProgress && progress2 >= 1) {
        iterationProgress = 1;
      }
      iterationProgress === 1 && currentIteration--;
      currentIteration = Math.min(currentIteration, repeat + 1);
      const isOddIteration = Boolean(currentIteration % 2);
      if (isOddIteration) {
        if (repeatType === "reverse") {
          iterationProgress = 1 - iterationProgress;
          if (repeatDelay) {
            iterationProgress -= repeatDelay / resolvedDuration;
          }
        } else if (repeatType === "mirror") {
          frameGenerator = mirroredGenerator;
        }
      }
      elapsed = clamp(0, 1, iterationProgress) * resolvedDuration;
    }
    const state = isInDelayPhase ? { done: false, value: keyframes2[0] } : frameGenerator.next(elapsed);
    if (mapPercentToKeyframes) {
      state.value = mapPercentToKeyframes(state.value);
    }
    let { done } = state;
    if (!isInDelayPhase && calculatedDuration !== null) {
      done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
    }
    const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
    if (isAnimationFinished && finalKeyframe !== void 0) {
      state.value = getFinalKeyframe(keyframes2, this.options, finalKeyframe);
    }
    if (onUpdate) {
      onUpdate(state.value);
    }
    if (isAnimationFinished) {
      this.finish();
    }
    return state;
  }
  get duration() {
    const { resolved } = this;
    return resolved ? millisecondsToSeconds(resolved.calculatedDuration) : 0;
  }
  get time() {
    return millisecondsToSeconds(this.currentTime);
  }
  set time(newTime) {
    newTime = secondsToMilliseconds(newTime);
    this.currentTime = newTime;
    if (this.holdTime !== null || this.speed === 0) {
      this.holdTime = newTime;
    } else if (this.driver) {
      this.startTime = this.driver.now() - newTime / this.speed;
    }
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(newSpeed) {
    const hasChanged = this.playbackSpeed !== newSpeed;
    this.playbackSpeed = newSpeed;
    if (hasChanged) {
      this.time = millisecondsToSeconds(this.currentTime);
    }
  }
  play() {
    if (!this.resolver.isScheduled) {
      this.resolver.resume();
    }
    if (!this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver = frameloopDriver, onPlay, startTime } = this.options;
    if (!this.driver) {
      this.driver = driver((timestamp) => this.tick(timestamp));
    }
    onPlay && onPlay();
    const now2 = this.driver.now();
    if (this.holdTime !== null) {
      this.startTime = now2 - this.holdTime;
    } else if (!this.startTime) {
      this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
    } else if (this.state === "finished") {
      this.startTime = now2;
    }
    if (this.state === "finished") {
      this.updateFinishedPromise();
    }
    this.cancelTime = this.startTime;
    this.holdTime = null;
    this.state = "running";
    this.driver.start();
  }
  pause() {
    var _a;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused";
    this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
  }
  complete() {
    if (this.state !== "running") {
      this.play();
    }
    this.pendingPlayState = this.state = "finished";
    this.holdTime = null;
  }
  finish() {
    this.teardown();
    this.state = "finished";
    const { onComplete } = this.options;
    onComplete && onComplete();
  }
  cancel() {
    if (this.cancelTime !== null) {
      this.tick(this.cancelTime);
    }
    this.teardown();
    this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle";
    this.stopDriver();
    this.resolveFinishedPromise();
    this.updateFinishedPromise();
    this.startTime = this.cancelTime = null;
    this.resolver.cancel();
  }
  stopDriver() {
    if (!this.driver)
      return;
    this.driver.stop();
    this.driver = void 0;
  }
  sample(time2) {
    this.startTime = 0;
    return this.tick(time2, true);
  }
}
const acceleratedValues = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
const isBezierDefinition = (easing2) => Array.isArray(easing2) && typeof easing2[0] === "number";
function isWaapiSupportedEasing(easing2) {
  return Boolean(!easing2 || typeof easing2 === "string" && easing2 in supportedWaapiEasing || isBezierDefinition(easing2) || Array.isArray(easing2) && easing2.every(isWaapiSupportedEasing));
}
const cubicBezierAsString = ([a2, b, c2, d]) => `cubic-bezier(${a2}, ${b}, ${c2}, ${d})`;
const supportedWaapiEasing = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
};
function mapEasingToNativeEasingWithDefault(easing2) {
  return mapEasingToNativeEasing(easing2) || supportedWaapiEasing.easeOut;
}
function mapEasingToNativeEasing(easing2) {
  if (!easing2) {
    return void 0;
  } else if (isBezierDefinition(easing2)) {
    return cubicBezierAsString(easing2);
  } else if (Array.isArray(easing2)) {
    return easing2.map(mapEasingToNativeEasingWithDefault);
  } else {
    return supportedWaapiEasing[easing2];
  }
}
function animateStyle(element, valueName, keyframes2, { delay: delay2 = 0, duration: duration2 = 300, repeat = 0, repeatType = "loop", ease: ease2, times } = {}) {
  const keyframeOptions = { [valueName]: keyframes2 };
  if (times)
    keyframeOptions.offset = times;
  const easing2 = mapEasingToNativeEasing(ease2);
  if (Array.isArray(easing2))
    keyframeOptions.easing = easing2;
  return element.animate(keyframeOptions, {
    delay: delay2,
    duration: duration2,
    easing: !Array.isArray(easing2) ? easing2 : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}
const supportsWaapi = /* @__PURE__ */ memo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
const sampleDelta = 10;
const maxDuration = 2e4;
function requiresPregeneratedKeyframes(options) {
  return options.type === "spring" || !isWaapiSupportedEasing(options.ease);
}
function pregenerateKeyframes(keyframes2, options) {
  const sampleAnimation = new MainThreadAnimation(__spreadProps(__spreadValues({}, options), {
    keyframes: keyframes2,
    repeat: 0,
    delay: 0,
    isGenerator: true
  }));
  let state = { done: false, value: keyframes2[0] };
  const pregeneratedKeyframes = [];
  let t2 = 0;
  while (!state.done && t2 < maxDuration) {
    state = sampleAnimation.sample(t2);
    pregeneratedKeyframes.push(state.value);
    t2 += sampleDelta;
  }
  return {
    times: void 0,
    keyframes: pregeneratedKeyframes,
    duration: t2 - sampleDelta,
    ease: "linear"
  };
}
class AcceleratedAnimation extends BaseAnimation {
  constructor(options) {
    super(options);
    const { name, motionValue: motionValue2, element, keyframes: keyframes2 } = this.options;
    this.resolver = new DOMKeyframesResolver(keyframes2, (resolvedKeyframes, finalKeyframe) => this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue2, element);
    this.resolver.scheduleResolve();
  }
  initPlayback(keyframes2, finalKeyframe) {
    var _a;
    let { duration: duration2 = 300, times, ease: ease2, type, motionValue: motionValue2, name, startTime } = this.options;
    if (!((_a = motionValue2.owner) === null || _a === void 0 ? void 0 : _a.current)) {
      return false;
    }
    if (requiresPregeneratedKeyframes(this.options)) {
      const _a2 = this.options, { onComplete, onUpdate, motionValue: motionValue3, element } = _a2, options = __objRest(_a2, ["onComplete", "onUpdate", "motionValue", "element"]);
      const pregeneratedAnimation = pregenerateKeyframes(keyframes2, options);
      keyframes2 = pregeneratedAnimation.keyframes;
      if (keyframes2.length === 1) {
        keyframes2[1] = keyframes2[0];
      }
      duration2 = pregeneratedAnimation.duration;
      times = pregeneratedAnimation.times;
      ease2 = pregeneratedAnimation.ease;
      type = "keyframes";
    }
    const animation = animateStyle(motionValue2.owner.current, name, keyframes2, __spreadProps(__spreadValues({}, this.options), { duration: duration2, times, ease: ease2 }));
    animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
    if (this.pendingTimeline) {
      animation.timeline = this.pendingTimeline;
      this.pendingTimeline = void 0;
    } else {
      animation.onfinish = () => {
        const { onComplete } = this.options;
        motionValue2.set(getFinalKeyframe(keyframes2, this.options, finalKeyframe));
        onComplete && onComplete();
        this.cancel();
        this.resolveFinishedPromise();
      };
    }
    return {
      animation,
      duration: duration2,
      times,
      type,
      ease: ease2,
      keyframes: keyframes2
    };
  }
  get duration() {
    const { resolved } = this;
    if (!resolved)
      return 0;
    const { duration: duration2 } = resolved;
    return millisecondsToSeconds(duration2);
  }
  get time() {
    const { resolved } = this;
    if (!resolved)
      return 0;
    const { animation } = resolved;
    return millisecondsToSeconds(animation.currentTime || 0);
  }
  set time(newTime) {
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation } = resolved;
    animation.currentTime = secondsToMilliseconds(newTime);
  }
  get speed() {
    const { resolved } = this;
    if (!resolved)
      return 1;
    const { animation } = resolved;
    return animation.playbackRate;
  }
  set speed(newSpeed) {
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation } = resolved;
    animation.playbackRate = newSpeed;
  }
  get state() {
    const { resolved } = this;
    if (!resolved)
      return "idle";
    const { animation } = resolved;
    return animation.playState;
  }
  get startTime() {
    const { resolved } = this;
    if (!resolved)
      return null;
    const { animation } = resolved;
    return animation.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(timeline) {
    if (!this._resolved) {
      this.pendingTimeline = timeline;
    } else {
      const { resolved } = this;
      if (!resolved)
        return noop;
      const { animation } = resolved;
      animation.timeline = timeline;
      animation.onfinish = null;
    }
    return noop;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation } = resolved;
    if (animation.playState === "finished") {
      this.updateFinishedPromise();
    }
    animation.play();
  }
  pause() {
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation } = resolved;
    animation.pause();
  }
  stop() {
    this.resolver.cancel();
    this.isStopped = true;
    if (this.state === "idle")
      return;
    this.resolveFinishedPromise();
    this.updateFinishedPromise();
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation, keyframes: keyframes2, duration: duration2, type, ease: ease2, times } = resolved;
    if (animation.playState === "idle" || animation.playState === "finished") {
      return;
    }
    if (this.time) {
      const _a = this.options, { motionValue: motionValue2, onUpdate, onComplete, element } = _a, options = __objRest(_a, ["motionValue", "onUpdate", "onComplete", "element"]);
      const sampleAnimation = new MainThreadAnimation(__spreadProps(__spreadValues({}, options), {
        keyframes: keyframes2,
        duration: duration2,
        type,
        ease: ease2,
        times,
        isGenerator: true
      }));
      const sampleTime = secondsToMilliseconds(this.time);
      motionValue2.setWithVelocity(sampleAnimation.sample(sampleTime - sampleDelta).value, sampleAnimation.sample(sampleTime).value, sampleDelta);
    }
    const { onStop } = this.options;
    onStop && onStop();
    this.cancel();
  }
  complete() {
    const { resolved } = this;
    if (!resolved)
      return;
    resolved.animation.finish();
  }
  cancel() {
    const { resolved } = this;
    if (!resolved)
      return;
    resolved.animation.cancel();
  }
  static supports(options) {
    const { motionValue: motionValue2, name, repeatDelay, repeatType, damping, type } = options;
    return supportsWaapi() && name && acceleratedValues.has(name) && motionValue2 && motionValue2.owner && motionValue2.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !motionValue2.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
  }
}
function observeTimeline(update, timeline) {
  let prevProgress;
  const onFrame = () => {
    const { currentTime } = timeline;
    const percentage = currentTime === null ? 0 : currentTime.value;
    const progress2 = percentage / 100;
    if (prevProgress !== progress2) {
      update(progress2);
    }
    prevProgress = progress2;
  };
  frame.update(onFrame, true);
  return () => cancelFrame(onFrame);
}
const supportsScrollTimeline = memo(() => window.ScrollTimeline !== void 0);
class GroupPlaybackControls {
  constructor(animations2) {
    this.stop = () => this.runAll("stop");
    this.animations = animations2.filter(Boolean);
  }
  then(onResolve, onReject) {
    return Promise.all(this.animations).then(onResolve).catch(onReject);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(propName) {
    return this.animations[0][propName];
  }
  setAll(propName, newValue) {
    for (let i = 0; i < this.animations.length; i++) {
      this.animations[i][propName] = newValue;
    }
  }
  attachTimeline(timeline) {
    const cancelAll = this.animations.map((animation) => {
      if (supportsScrollTimeline() && animation.attachTimeline) {
        animation.attachTimeline(timeline);
      } else {
        animation.pause();
        return observeTimeline((progress2) => {
          animation.time = animation.duration * progress2;
        }, timeline);
      }
    });
    return () => {
      cancelAll.forEach((cancelTimeline, i) => {
        if (cancelTimeline)
          cancelTimeline();
        this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(time2) {
    this.setAll("time", time2);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(speed) {
    this.setAll("speed", speed);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let max2 = 0;
    for (let i = 0; i < this.animations.length; i++) {
      max2 = Math.max(max2, this.animations[i].duration);
    }
    return max2;
  }
  runAll(methodName) {
    this.animations.forEach((controls) => controls[methodName]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
const animateMotionValue = (name, value, target, transition = {}, element, isHandoff, onEnd) => (onComplete) => {
  const valueTransition = getValueTransition(transition, name) || {};
  const delay2 = valueTransition.delay || transition.delay || 0;
  let { elapsed = 0 } = transition;
  elapsed = elapsed - secondsToMilliseconds(delay2);
  let options = __spreadProps(__spreadValues({
    keyframes: Array.isArray(target) ? target : [null, target],
    ease: "easeOut",
    velocity: value.getVelocity()
  }, valueTransition), {
    delay: -elapsed,
    onUpdate: (v) => {
      value.set(v);
      valueTransition.onUpdate && valueTransition.onUpdate(v);
    },
    onComplete: () => {
      onComplete();
      valueTransition.onComplete && valueTransition.onComplete();
      onEnd && onEnd();
    },
    onStop: onEnd,
    name,
    motionValue: value,
    element: isHandoff ? void 0 : element
  });
  if (!isTransitionDefined(valueTransition)) {
    options = __spreadValues(__spreadValues({}, options), getDefaultTransition(name, options));
  }
  if (options.duration) {
    options.duration = secondsToMilliseconds(options.duration);
  }
  if (options.repeatDelay) {
    options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
  }
  if (options.from !== void 0) {
    options.keyframes[0] = options.from;
  }
  let shouldSkip = false;
  if (options.type === false || options.duration === 0 && !options.repeatDelay) {
    options.duration = 0;
    if (options.delay === 0) {
      shouldSkip = true;
    }
  }
  if (shouldSkip && !isHandoff && value.get() !== void 0) {
    const finalKeyframe = getFinalKeyframe(options.keyframes, valueTransition);
    if (finalKeyframe !== void 0) {
      frame.update(() => {
        options.onUpdate(finalKeyframe);
        options.onComplete();
      });
      return new GroupPlaybackControls([]);
    }
  }
  if (!isHandoff && AcceleratedAnimation.supports(options)) {
    return new AcceleratedAnimation(options);
  } else {
    return new MainThreadAnimation(options);
  }
};
const isCustomValue = (v) => {
  return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const resolveFinalValueInKeyframes = (v) => {
  return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};
function addUniqueItem(arr, item) {
  if (arr.indexOf(item) === -1)
    arr.push(item);
}
function removeItem(arr, item) {
  const index2 = arr.indexOf(item);
  if (index2 > -1)
    arr.splice(index2, 1);
}
class SubscriptionManager2 {
  constructor() {
    this.subscriptions = [];
  }
  add(handler) {
    addUniqueItem(this.subscriptions, handler);
    return () => removeItem(this.subscriptions, handler);
  }
  notify(a2, b, c2) {
    const numSubscriptions = this.subscriptions.length;
    if (!numSubscriptions)
      return;
    if (numSubscriptions === 1) {
      this.subscriptions[0](a2, b, c2);
    } else {
      for (let i = 0; i < numSubscriptions; i++) {
        const handler = this.subscriptions[i];
        handler && handler(a2, b, c2);
      }
    }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const MAX_VELOCITY_DELTA = 30;
const isFloat = (value) => {
  return !isNaN(parseFloat(value));
};
class MotionValue2 {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(init2, options = {}) {
    this.version = "11.5.6";
    this.canTrackVelocity = null;
    this.events = {};
    this.updateAndNotify = (v, render = true) => {
      const currentTime = time.now();
      if (this.updatedAt !== currentTime) {
        this.setPrevFrameValue();
      }
      this.prev = this.current;
      this.setCurrent(v);
      if (this.current !== this.prev && this.events.change) {
        this.events.change.notify(this.current);
      }
      if (render && this.events.renderRequest) {
        this.events.renderRequest.notify(this.current);
      }
    };
    this.hasAnimated = false;
    this.setCurrent(init2);
    this.owner = options.owner;
  }
  setCurrent(current) {
    this.current = current;
    this.updatedAt = time.now();
    if (this.canTrackVelocity === null && current !== void 0) {
      this.canTrackVelocity = isFloat(this.current);
    }
  }
  setPrevFrameValue(prevFrameValue = this.current) {
    this.prevFrameValue = prevFrameValue;
    this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(subscription) {
    if (process.env.NODE_ENV !== "production") {
      warnOnce(false, `value.onChange(callback) is deprecated. Switch to value.on("change", callback).`);
    }
    return this.on("change", subscription);
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager2();
    }
    const unsubscribe = this.events[eventName].add(callback);
    if (eventName === "change") {
      return () => {
        unsubscribe();
        frame.read(() => {
          if (!this.events.change.getSize()) {
            this.stop();
          }
        });
      };
    }
    return unsubscribe;
  }
  clearListeners() {
    for (const eventManagers in this.events) {
      this.events[eventManagers].clear();
    }
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(passiveEffect, stopPassiveEffect) {
    this.passiveEffect = passiveEffect;
    this.stopPassiveEffect = stopPassiveEffect;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(v, render = true) {
    if (!render || !this.passiveEffect) {
      this.updateAndNotify(v, render);
    } else {
      this.passiveEffect(v, this.updateAndNotify);
    }
  }
  setWithVelocity(prev2, current, delta) {
    this.set(current);
    this.prev = void 0;
    this.prevFrameValue = prev2;
    this.prevUpdatedAt = this.updatedAt - delta;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(v, endAnimation = true) {
    this.updateAndNotify(v);
    this.prev = v;
    this.prevUpdatedAt = this.prevFrameValue = void 0;
    endAnimation && this.stop();
    if (this.stopPassiveEffect)
      this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const currentTime = time.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || currentTime - this.updatedAt > MAX_VELOCITY_DELTA) {
      return 0;
    }
    const delta = Math.min(this.updatedAt - this.prevUpdatedAt, MAX_VELOCITY_DELTA);
    return velocityPerSecond(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(startAnimation) {
    this.stop();
    return new Promise((resolve) => {
      this.hasAnimated = true;
      this.animation = startAnimation(resolve);
      if (this.events.animationStart) {
        this.events.animationStart.notify();
      }
    }).then(() => {
      if (this.events.animationComplete) {
        this.events.animationComplete.notify();
      }
      this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    if (this.animation) {
      this.animation.stop();
      if (this.events.animationCancel) {
        this.events.animationCancel.notify();
      }
    }
    this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners();
    this.stop();
    if (this.stopPassiveEffect) {
      this.stopPassiveEffect();
    }
  }
}
function motionValue(init2, options) {
  return new MotionValue2(init2, options);
}
function setMotionValue(visualElement, key, value) {
  if (visualElement.hasValue(key)) {
    visualElement.getValue(key).set(value);
  } else {
    visualElement.addValue(key, motionValue(value));
  }
}
function setTarget(visualElement, definition) {
  const resolved = resolveVariant(visualElement, definition);
  let _a = resolved || {}, { transitionEnd = {}, transition = {} } = _a, target = __objRest(_a, ["transitionEnd", "transition"]);
  target = __spreadValues(__spreadValues({}, target), transitionEnd);
  for (const key in target) {
    const value = resolveFinalValueInKeyframes(target[key]);
    setMotionValue(visualElement, key, value);
  }
}
const camelToDash = (str) => str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();
const optimizedAppearDataId = "framerAppearId";
const optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);
function getOptimisedAppearId(visualElement) {
  return visualElement.props[optimizedAppearDataAttribute];
}
function getWillChangeName(name) {
  if (transformProps.has(name)) {
    return "transform";
  } else if (acceleratedValues.has(name)) {
    return camelToDash(name);
  }
}
class WillChangeMotionValue extends MotionValue2 {
  constructor() {
    super(...arguments);
    this.output = [];
    this.counts = /* @__PURE__ */ new Map();
  }
  add(name) {
    const styleName = getWillChangeName(name);
    if (!styleName)
      return;
    const prevCount = this.counts.get(styleName) || 0;
    this.counts.set(styleName, prevCount + 1);
    if (prevCount === 0) {
      this.output.push(styleName);
      this.update();
    }
    let hasRemoved = false;
    return () => {
      if (hasRemoved)
        return;
      hasRemoved = true;
      const newCount = this.counts.get(styleName) - 1;
      this.counts.set(styleName, newCount);
      if (newCount === 0) {
        removeItem(this.output, styleName);
        this.update();
      }
    };
  }
  update() {
    this.set(this.output.length ? this.output.join(", ") : "auto");
  }
}
const isMotionValue = (value) => Boolean(value && value.getVelocity);
function isWillChangeMotionValue(value) {
  return Boolean(isMotionValue(value) && value.add);
}
function addValueToWillChange(visualElement, key) {
  var _a;
  if (!visualElement.applyWillChange)
    return;
  let willChange = visualElement.getValue("willChange");
  if (!willChange && !((_a = visualElement.props.style) === null || _a === void 0 ? void 0 : _a.willChange)) {
    willChange = new WillChangeMotionValue("auto");
    visualElement.addValue("willChange", willChange);
  }
  if (isWillChangeMotionValue(willChange)) {
    return willChange.add(key);
  }
}
function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
  const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
  needsAnimating[key] = false;
  return shouldBlock;
}
function animateTarget(visualElement, targetAndTransition, { delay: delay2 = 0, transitionOverride, type } = {}) {
  var _a;
  let _a2 = targetAndTransition, { transition = visualElement.getDefaultTransition(), transitionEnd } = _a2, target = __objRest(_a2, ["transition", "transitionEnd"]);
  if (transitionOverride)
    transition = transitionOverride;
  const animations2 = [];
  const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
  for (const key in target) {
    const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
    const valueTarget = target[key];
    if (valueTarget === void 0 || animationTypeState && shouldBlockAnimation(animationTypeState, key)) {
      continue;
    }
    const valueTransition = __spreadValues({
      delay: delay2
    }, getValueTransition(transition || {}, key));
    let isHandoff = false;
    if (window.MotionHandoffAnimation) {
      const appearId = getOptimisedAppearId(visualElement);
      if (appearId) {
        const startTime = window.MotionHandoffAnimation(appearId, key, frame);
        if (startTime !== null) {
          valueTransition.startTime = startTime;
          isHandoff = true;
        }
      }
    }
    value.start(animateMotionValue(key, value, valueTarget, visualElement.shouldReduceMotion && transformProps.has(key) ? { type: false } : valueTransition, visualElement, isHandoff, addValueToWillChange(visualElement, key)));
    const animation = value.animation;
    if (animation) {
      animations2.push(animation);
    }
  }
  if (transitionEnd) {
    Promise.all(animations2).then(() => {
      frame.update(() => {
        transitionEnd && setTarget(visualElement, transitionEnd);
      });
    });
  }
  return animations2;
}
function animateVariant(visualElement, variant, options = {}) {
  var _a;
  const resolved = resolveVariant(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : void 0);
  let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
  if (options.transitionOverride) {
    transition = options.transitionOverride;
  }
  const getAnimation = resolved ? () => Promise.all(animateTarget(visualElement, resolved, options)) : () => Promise.resolve();
  const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0) => {
    const { delayChildren = 0, staggerChildren, staggerDirection } = transition;
    return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
  } : () => Promise.resolve();
  const { when } = transition;
  if (when) {
    const [first, last] = when === "beforeChildren" ? [getAnimation, getChildAnimations] : [getChildAnimations, getAnimation];
    return first().then(() => last());
  } else {
    return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
  }
}
function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
  const animations2 = [];
  const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
  const generateStaggerDuration = staggerDirection === 1 ? (i = 0) => i * staggerChildren : (i = 0) => maxStaggerDuration - i * staggerChildren;
  Array.from(visualElement.variantChildren).sort(sortByTreeOrder).forEach((child, i) => {
    child.notify("AnimationStart", variant);
    animations2.push(animateVariant(child, variant, __spreadProps(__spreadValues({}, options), {
      delay: delayChildren + generateStaggerDuration(i)
    })).then(() => child.notify("AnimationComplete", variant)));
  });
  return Promise.all(animations2);
}
function sortByTreeOrder(a2, b) {
  return a2.sortNodePosition(b);
}
function animateVisualElement(visualElement, definition, options = {}) {
  visualElement.notify("AnimationStart", definition);
  let animation;
  if (Array.isArray(definition)) {
    const animations2 = definition.map((variant) => animateVariant(visualElement, variant, options));
    animation = Promise.all(animations2);
  } else if (typeof definition === "string") {
    animation = animateVariant(visualElement, definition, options);
  } else {
    const resolvedDefinition = typeof definition === "function" ? resolveVariant(visualElement, definition, options.custom) : definition;
    animation = Promise.all(animateTarget(visualElement, resolvedDefinition, options));
  }
  return animation.then(() => {
    visualElement.notify("AnimationComplete", definition);
  });
}
const numVariantProps = variantProps.length;
function getVariantContext(visualElement) {
  if (!visualElement)
    return void 0;
  if (!visualElement.isControllingVariants) {
    const context2 = visualElement.parent ? getVariantContext(visualElement.parent) || {} : {};
    if (visualElement.props.initial !== void 0) {
      context2.initial = visualElement.props.initial;
    }
    return context2;
  }
  const context = {};
  for (let i = 0; i < numVariantProps; i++) {
    const name = variantProps[i];
    const prop = visualElement.props[name];
    if (isVariantLabel(prop) || prop === false) {
      context[name] = prop;
    }
  }
  return context;
}
const reversePriorityOrder = [...variantPriorityOrder].reverse();
const numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
  return (animations2) => Promise.all(animations2.map(({ animation, options }) => animateVisualElement(visualElement, animation, options)));
}
function createAnimationState(visualElement) {
  let animate = animateList(visualElement);
  let state = createState();
  let isInitialRender = true;
  const buildResolvedTypeValues = (type) => (acc, definition) => {
    var _a;
    const resolved = resolveVariant(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : void 0);
    if (resolved) {
      const _a2 = resolved, { transition, transitionEnd } = _a2, target = __objRest(_a2, ["transition", "transitionEnd"]);
      acc = __spreadValues(__spreadValues(__spreadValues({}, acc), target), transitionEnd);
    }
    return acc;
  };
  function setAnimateFunction(makeAnimator) {
    animate = makeAnimator(visualElement);
  }
  function animateChanges(changedActiveType) {
    const { props } = visualElement;
    const context = getVariantContext(visualElement.parent) || {};
    const animations2 = [];
    const removedKeys = /* @__PURE__ */ new Set();
    let encounteredKeys = {};
    let removedVariantIndex = Infinity;
    for (let i = 0; i < numAnimationTypes; i++) {
      const type = reversePriorityOrder[i];
      const typeState = state[type];
      const prop = props[type] !== void 0 ? props[type] : context[type];
      const propIsVariant = isVariantLabel(prop);
      const activeDelta = type === changedActiveType ? typeState.isActive : null;
      if (activeDelta === false)
        removedVariantIndex = i;
      let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
      if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) {
        isInherited = false;
      }
      typeState.protectedKeys = __spreadValues({}, encounteredKeys);
      if (
        // If it isn't active and hasn't *just* been set as inactive
        !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
        !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
        isAnimationControls(prop) || typeof prop === "boolean"
      ) {
        continue;
      }
      const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
      let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
      type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
      i > removedVariantIndex && propIsVariant;
      let handledRemovedValues = false;
      const definitionList = Array.isArray(prop) ? prop : [prop];
      let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
      if (activeDelta === false)
        resolvedValues = {};
      const { prevResolvedValues = {} } = typeState;
      const allKeys = __spreadValues(__spreadValues({}, prevResolvedValues), resolvedValues);
      const markToAnimate = (key) => {
        shouldAnimateType = true;
        if (removedKeys.has(key)) {
          handledRemovedValues = true;
          removedKeys.delete(key);
        }
        typeState.needsAnimating[key] = true;
        const motionValue2 = visualElement.getValue(key);
        if (motionValue2)
          motionValue2.liveStyle = false;
      };
      for (const key in allKeys) {
        const next2 = resolvedValues[key];
        const prev2 = prevResolvedValues[key];
        if (encounteredKeys.hasOwnProperty(key))
          continue;
        let valueHasChanged = false;
        if (isKeyframesTarget(next2) && isKeyframesTarget(prev2)) {
          valueHasChanged = !shallowCompare(next2, prev2);
        } else {
          valueHasChanged = next2 !== prev2;
        }
        if (valueHasChanged) {
          if (next2 !== void 0 && next2 !== null) {
            markToAnimate(key);
          } else {
            removedKeys.add(key);
          }
        } else if (next2 !== void 0 && removedKeys.has(key)) {
          markToAnimate(key);
        } else {
          typeState.protectedKeys[key] = true;
        }
      }
      typeState.prevProp = prop;
      typeState.prevResolvedValues = resolvedValues;
      if (typeState.isActive) {
        encounteredKeys = __spreadValues(__spreadValues({}, encounteredKeys), resolvedValues);
      }
      if (isInitialRender && visualElement.blockInitialAnimation) {
        shouldAnimateType = false;
      }
      const willAnimateViaParent = isInherited && variantDidChange;
      const needsAnimating = !willAnimateViaParent || handledRemovedValues;
      if (shouldAnimateType && needsAnimating) {
        animations2.push(...definitionList.map((animation) => ({
          animation,
          options: { type }
        })));
      }
    }
    if (removedKeys.size) {
      const fallbackAnimation = {};
      removedKeys.forEach((key) => {
        const fallbackTarget = visualElement.getBaseTarget(key);
        const motionValue2 = visualElement.getValue(key);
        if (motionValue2)
          motionValue2.liveStyle = true;
        fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
      });
      animations2.push({ animation: fallbackAnimation });
    }
    let shouldAnimate = Boolean(animations2.length);
    if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) {
      shouldAnimate = false;
    }
    isInitialRender = false;
    return shouldAnimate ? animate(animations2) : Promise.resolve();
  }
  function setActive(type, isActive) {
    var _a;
    if (state[type].isActive === isActive)
      return Promise.resolve();
    (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
      var _a2;
      return (_a2 = child.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(type, isActive);
    });
    state[type].isActive = isActive;
    const animations2 = animateChanges(type);
    for (const key in state) {
      state[key].protectedKeys = {};
    }
    return animations2;
  }
  return {
    animateChanges,
    setActive,
    setAnimateFunction,
    getState: () => state,
    reset: () => {
      state = createState();
      isInitialRender = true;
    }
  };
}
function checkVariantsDidChange(prev2, next2) {
  if (typeof next2 === "string") {
    return next2 !== prev2;
  } else if (Array.isArray(next2)) {
    return !shallowCompare(next2, prev2);
  }
  return false;
}
function createTypeState(isActive = false) {
  return {
    isActive,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  return {
    animate: createTypeState(true),
    whileInView: createTypeState(),
    whileHover: createTypeState(),
    whileTap: createTypeState(),
    whileDrag: createTypeState(),
    whileFocus: createTypeState(),
    exit: createTypeState()
  };
}
class Feature2 {
  constructor(node2) {
    this.isMounted = false;
    this.node = node2;
  }
  update() {
  }
}
class AnimationFeature2 extends Feature2 {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(node2) {
    super(node2);
    node2.animationState || (node2.animationState = createAnimationState(node2));
  }
  updateAnimationControlsSubscription() {
    const { animate } = this.node.getProps();
    if (isAnimationControls(animate)) {
      this.unmountControls = animate.subscribe(this.node);
    }
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate } = this.node.getProps();
    const { animate: prevAnimate } = this.node.prevProps || {};
    if (animate !== prevAnimate) {
      this.updateAnimationControlsSubscription();
    }
  }
  unmount() {
    var _a;
    this.node.animationState.reset();
    (_a = this.unmountControls) === null || _a === void 0 ? void 0 : _a.call(this);
  }
}
let id$1 = 0;
class ExitAnimationFeature2 extends Feature2 {
  constructor() {
    super(...arguments);
    this.id = id$1++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent, onExitComplete } = this.node.presenceContext;
    const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || isPresent === prevIsPresent) {
      return;
    }
    const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
    if (onExitComplete && !isPresent) {
      exitAnimation.then(() => onExitComplete(this.id));
    }
  }
  mount() {
    const { register } = this.node.presenceContext || {};
    if (register) {
      this.unmount = register(this.id);
    }
  }
  unmount() {
  }
}
const animations = {
  animation: {
    Feature: AnimationFeature2
  },
  exit: {
    Feature: ExitAnimationFeature2
  }
};
const isPrimaryPointer = (event) => {
  if (event.pointerType === "mouse") {
    return typeof event.button !== "number" || event.button <= 0;
  } else {
    return event.isPrimary !== false;
  }
};
function extractEventInfo(event, pointType = "page") {
  return {
    point: {
      x: event[`${pointType}X`],
      y: event[`${pointType}Y`]
    }
  };
}
const addPointerInfo = (handler) => {
  return (event) => isPrimaryPointer(event) && handler(event, extractEventInfo(event));
};
function addDomEvent(target, eventName, handler, options = { passive: true }) {
  target.addEventListener(eventName, handler, options);
  return () => target.removeEventListener(eventName, handler);
}
function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(target, eventName, addPointerInfo(handler), options);
}
const distance = (a2, b) => Math.abs(a2 - b);
function distance2D(a2, b) {
  const xDelta = distance(a2.x, b.x);
  const yDelta = distance(a2.y, b.y);
  return Math.sqrt(__pow(xDelta, 2) + __pow(yDelta, 2));
}
class PanSession2 {
  constructor(event, handlers, { transformPagePoint, contextWindow, dragSnapToOrigin = false } = {}) {
    this.startEvent = null;
    this.lastMoveEvent = null;
    this.lastMoveEventInfo = null;
    this.handlers = {};
    this.contextWindow = window;
    this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const info2 = getPanInfo(this.lastMoveEventInfo, this.history);
      const isPanStarted = this.startEvent !== null;
      const isDistancePastThreshold = distance2D(info2.offset, { x: 0, y: 0 }) >= 3;
      if (!isPanStarted && !isDistancePastThreshold)
        return;
      const { point: point2 } = info2;
      const { timestamp: timestamp2 } = frameData;
      this.history.push(__spreadProps(__spreadValues({}, point2), { timestamp: timestamp2 }));
      const { onStart, onMove } = this.handlers;
      if (!isPanStarted) {
        onStart && onStart(this.lastMoveEvent, info2);
        this.startEvent = this.lastMoveEvent;
      }
      onMove && onMove(this.lastMoveEvent, info2);
    };
    this.handlePointerMove = (event2, info2) => {
      this.lastMoveEvent = event2;
      this.lastMoveEventInfo = transformPoint(info2, this.transformPagePoint);
      frame.update(this.updatePoint, true);
    };
    this.handlePointerUp = (event2, info2) => {
      this.end();
      const { onEnd, onSessionEnd, resumeAnimation } = this.handlers;
      if (this.dragSnapToOrigin)
        resumeAnimation && resumeAnimation();
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const panInfo = getPanInfo(event2.type === "pointercancel" ? this.lastMoveEventInfo : transformPoint(info2, this.transformPagePoint), this.history);
      if (this.startEvent && onEnd) {
        onEnd(event2, panInfo);
      }
      onSessionEnd && onSessionEnd(event2, panInfo);
    };
    if (!isPrimaryPointer(event))
      return;
    this.dragSnapToOrigin = dragSnapToOrigin;
    this.handlers = handlers;
    this.transformPagePoint = transformPagePoint;
    this.contextWindow = contextWindow || window;
    const info = extractEventInfo(event);
    const initialInfo = transformPoint(info, this.transformPagePoint);
    const { point } = initialInfo;
    const { timestamp } = frameData;
    this.history = [__spreadProps(__spreadValues({}, point), { timestamp })];
    const { onSessionStart } = handlers;
    onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
    this.removeListeners = pipe(addPointerEvent(this.contextWindow, "pointermove", this.handlePointerMove), addPointerEvent(this.contextWindow, "pointerup", this.handlePointerUp), addPointerEvent(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(handlers) {
    this.handlers = handlers;
  }
  end() {
    this.removeListeners && this.removeListeners();
    cancelFrame(this.updatePoint);
  }
}
function transformPoint(info, transformPagePoint) {
  return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a2, b) {
  return { x: a2.x - b.x, y: a2.y - b.y };
}
function getPanInfo({ point }, history) {
  return {
    point,
    delta: subtractPoint(point, lastDevicePoint(history)),
    offset: subtractPoint(point, startDevicePoint(history)),
    velocity: getVelocity(history, 0.1)
  };
}
function startDevicePoint(history) {
  return history[0];
}
function lastDevicePoint(history) {
  return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
  if (history.length < 2) {
    return { x: 0, y: 0 };
  }
  let i = history.length - 1;
  let timestampedPoint = null;
  const lastPoint = lastDevicePoint(history);
  while (i >= 0) {
    timestampedPoint = history[i];
    if (lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds(timeDelta)) {
      break;
    }
    i--;
  }
  if (!timestampedPoint) {
    return { x: 0, y: 0 };
  }
  const time2 = millisecondsToSeconds(lastPoint.timestamp - timestampedPoint.timestamp);
  if (time2 === 0) {
    return { x: 0, y: 0 };
  }
  const currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time2,
    y: (lastPoint.y - timestampedPoint.y) / time2
  };
  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }
  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }
  return currentVelocity;
}
function createLock(name) {
  let lock = null;
  return () => {
    const openLock = () => {
      lock = null;
    };
    if (lock === null) {
      lock = name;
      return openLock;
    }
    return false;
  };
}
const globalHorizontalLock = createLock("dragHorizontal");
const globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag2) {
  let lock = false;
  if (drag2 === "y") {
    lock = globalVerticalLock();
  } else if (drag2 === "x") {
    lock = globalHorizontalLock();
  } else {
    const openHorizontal = globalHorizontalLock();
    const openVertical = globalVerticalLock();
    if (openHorizontal && openVertical) {
      lock = () => {
        openHorizontal();
        openVertical();
      };
    } else {
      if (openHorizontal)
        openHorizontal();
      if (openVertical)
        openVertical();
    }
  }
  return lock;
}
function isDragActive() {
  const openGestureLock = getGlobalLock(true);
  if (!openGestureLock)
    return true;
  openGestureLock();
  return false;
}
function isRefObject(ref) {
  return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}
const SCALE_PRECISION = 1e-4;
const SCALE_MIN = 1 - SCALE_PRECISION;
const SCALE_MAX = 1 + SCALE_PRECISION;
const TRANSLATE_PRECISION = 0.01;
const TRANSLATE_MIN = 0 - TRANSLATE_PRECISION;
const TRANSLATE_MAX = 0 + TRANSLATE_PRECISION;
function calcLength(axis) {
  return axis.max - axis.min;
}
function isNear(value, target, maxDistance) {
  return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target, origin = 0.5) {
  delta.origin = origin;
  delta.originPoint = mixNumber$1(source.min, source.max, delta.origin);
  delta.scale = calcLength(target) / calcLength(source);
  delta.translate = mixNumber$1(target.min, target.max, delta.origin) - delta.originPoint;
  if (delta.scale >= SCALE_MIN && delta.scale <= SCALE_MAX || isNaN(delta.scale)) {
    delta.scale = 1;
  }
  if (delta.translate >= TRANSLATE_MIN && delta.translate <= TRANSLATE_MAX || isNaN(delta.translate)) {
    delta.translate = 0;
  }
}
function calcBoxDelta(delta, source, target, origin) {
  calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : void 0);
  calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : void 0);
}
function calcRelativeAxis(target, relative, parent) {
  target.min = parent.min + relative.min;
  target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
  calcRelativeAxis(target.x, relative.x, parent.x);
  calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout2, parent) {
  target.min = layout2.min - parent.min;
  target.max = target.min + calcLength(layout2);
}
function calcRelativePosition(target, layout2, parent) {
  calcRelativeAxisPosition(target.x, layout2.x, parent.x);
  calcRelativeAxisPosition(target.y, layout2.y, parent.y);
}
function applyConstraints(point, { min: min2, max: max2 }, elastic) {
  if (min2 !== void 0 && point < min2) {
    point = elastic ? mixNumber$1(min2, point, elastic.min) : Math.max(point, min2);
  } else if (max2 !== void 0 && point > max2) {
    point = elastic ? mixNumber$1(max2, point, elastic.max) : Math.min(point, max2);
  }
  return point;
}
function calcRelativeAxisConstraints(axis, min2, max2) {
  return {
    min: min2 !== void 0 ? axis.min + min2 : void 0,
    max: max2 !== void 0 ? axis.max + max2 - (axis.max - axis.min) : void 0
  };
}
function calcRelativeConstraints(layoutBox, { top: top2, left: left2, bottom: bottom2, right: right2 }) {
  return {
    x: calcRelativeAxisConstraints(layoutBox.x, left2, right2),
    y: calcRelativeAxisConstraints(layoutBox.y, top2, bottom2)
  };
}
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
  let min2 = constraintsAxis.min - layoutAxis.min;
  let max2 = constraintsAxis.max - layoutAxis.max;
  if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) {
    [min2, max2] = [max2, min2];
  }
  return { min: min2, max: max2 };
}
function calcViewportConstraints(layoutBox, constraintsBox) {
  return {
    x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
    y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
  };
}
function calcOrigin$1(source, target) {
  let origin = 0.5;
  const sourceLength = calcLength(source);
  const targetLength = calcLength(target);
  if (targetLength > sourceLength) {
    origin = progress(target.min, target.max - sourceLength, source.min);
  } else if (sourceLength > targetLength) {
    origin = progress(source.min, source.max - targetLength, target.min);
  }
  return clamp(0, 1, origin);
}
function rebaseAxisConstraints(layout2, constraints) {
  const relativeConstraints = {};
  if (constraints.min !== void 0) {
    relativeConstraints.min = constraints.min - layout2.min;
  }
  if (constraints.max !== void 0) {
    relativeConstraints.max = constraints.max - layout2.min;
  }
  return relativeConstraints;
}
const defaultElastic = 0.35;
function resolveDragElastic(dragElastic = defaultElastic) {
  if (dragElastic === false) {
    dragElastic = 0;
  } else if (dragElastic === true) {
    dragElastic = defaultElastic;
  }
  return {
    x: resolveAxisElastic(dragElastic, "left", "right"),
    y: resolveAxisElastic(dragElastic, "top", "bottom")
  };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
  return {
    min: resolvePointElastic(dragElastic, minLabel),
    max: resolvePointElastic(dragElastic, maxLabel)
  };
}
function resolvePointElastic(dragElastic, label) {
  return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}
const createAxisDelta = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
});
const createDelta = () => ({
  x: createAxisDelta(),
  y: createAxisDelta()
});
const createAxis = () => ({ min: 0, max: 0 });
const createBox = () => ({
  x: createAxis(),
  y: createAxis()
});
function eachAxis(callback) {
  return [callback("x"), callback("y")];
}
function convertBoundingBoxToBox({ top: top2, left: left2, right: right2, bottom: bottom2 }) {
  return {
    x: { min: left2, max: right2 },
    y: { min: top2, max: bottom2 }
  };
}
function convertBoxToBoundingBox({ x: x2, y }) {
  return { top: y.min, right: x2.max, bottom: y.max, left: x2.min };
}
function transformBoxPoints(point, transformPoint2) {
  if (!transformPoint2)
    return point;
  const topLeft = transformPoint2({ x: point.left, y: point.top });
  const bottomRight = transformPoint2({ x: point.right, y: point.bottom });
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x
  };
}
function isIdentityScale(scale2) {
  return scale2 === void 0 || scale2 === 1;
}
function hasScale({ scale: scale2, scaleX, scaleY }) {
  return !isIdentityScale(scale2) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values2) {
  return hasScale(values2) || has2DTranslate(values2) || values2.z || values2.rotate || values2.rotateX || values2.rotateY || values2.skewX || values2.skewY;
}
function has2DTranslate(values2) {
  return is2DTranslate(values2.x) || is2DTranslate(values2.y);
}
function is2DTranslate(value) {
  return value && value !== "0%";
}
function scalePoint(point, scale2, originPoint) {
  const distanceFromOrigin = point - originPoint;
  const scaled = scale2 * distanceFromOrigin;
  return originPoint + scaled;
}
function applyPointDelta(point, translate, scale2, originPoint, boxScale) {
  if (boxScale !== void 0) {
    point = scalePoint(point, boxScale, originPoint);
  }
  return scalePoint(point, scale2, originPoint) + translate;
}
function applyAxisDelta(axis, translate = 0, scale2 = 1, originPoint, boxScale) {
  axis.min = applyPointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = applyPointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function applyBoxDelta(box, { x: x2, y }) {
  applyAxisDelta(box.x, x2.translate, x2.scale, x2.originPoint);
  applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
const TREE_SCALE_SNAP_MIN = 0.999999999999;
const TREE_SCALE_SNAP_MAX = 1.0000000000001;
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
  const treeLength = treePath.length;
  if (!treeLength)
    return;
  treeScale.x = treeScale.y = 1;
  let node2;
  let delta;
  for (let i = 0; i < treeLength; i++) {
    node2 = treePath[i];
    delta = node2.projectionDelta;
    const { visualElement } = node2.options;
    if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") {
      continue;
    }
    if (isSharedTransition && node2.options.layoutScroll && node2.scroll && node2 !== node2.root) {
      transformBox(box, {
        x: -node2.scroll.offset.x,
        y: -node2.scroll.offset.y
      });
    }
    if (delta) {
      treeScale.x *= delta.x.scale;
      treeScale.y *= delta.y.scale;
      applyBoxDelta(box, delta);
    }
    if (isSharedTransition && hasTransform(node2.latestValues)) {
      transformBox(box, node2.latestValues);
    }
  }
  if (treeScale.x < TREE_SCALE_SNAP_MAX && treeScale.x > TREE_SCALE_SNAP_MIN) {
    treeScale.x = 1;
  }
  if (treeScale.y < TREE_SCALE_SNAP_MAX && treeScale.y > TREE_SCALE_SNAP_MIN) {
    treeScale.y = 1;
  }
}
function translateAxis(axis, distance2) {
  axis.min = axis.min + distance2;
  axis.max = axis.max + distance2;
}
function transformAxis(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
  const originPoint = mixNumber$1(axis.min, axis.max, axisOrigin);
  applyAxisDelta(axis, axisTranslate, axisScale, originPoint, boxScale);
}
function transformBox(box, transform) {
  transformAxis(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
  transformAxis(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}
function measureViewportBox(instance, transformPoint2) {
  return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint2));
}
function measurePageBox(element, rootProjectionNode2, transformPagePoint) {
  const viewportBox = measureViewportBox(element, transformPagePoint);
  const { scroll } = rootProjectionNode2;
  if (scroll) {
    translateAxis(viewportBox.x, scroll.offset.x);
    translateAxis(viewportBox.y, scroll.offset.y);
  }
  return viewportBox;
}
const getContextWindow = ({ current }) => {
  return current ? current.ownerDocument.defaultView : null;
};
const elementDragControls = /* @__PURE__ */ new WeakMap();
class VisualElementDragControls2 {
  constructor(visualElement) {
    this.openGlobalLock = null;
    this.isDragging = false;
    this.currentDirection = null;
    this.originPoint = { x: 0, y: 0 };
    this.constraints = false;
    this.hasMutatedConstraints = false;
    this.elastic = createBox();
    this.visualElement = visualElement;
  }
  start(originEvent, { snapToCursor = false } = {}) {
    const { presenceContext } = this.visualElement;
    if (presenceContext && presenceContext.isPresent === false)
      return;
    const onSessionStart = (event) => {
      const { dragSnapToOrigin: dragSnapToOrigin2 } = this.getProps();
      dragSnapToOrigin2 ? this.pauseAnimation() : this.stopAnimation();
      if (snapToCursor) {
        this.snapToCursor(extractEventInfo(event, "page").point);
      }
    };
    const onStart = (event, info) => {
      var _a;
      const { drag: drag2, dragPropagation, onDragStart } = this.getProps();
      if (drag2 && !dragPropagation) {
        if (this.openGlobalLock)
          this.openGlobalLock();
        this.openGlobalLock = getGlobalLock(drag2);
        if (!this.openGlobalLock)
          return;
      }
      this.isDragging = true;
      this.currentDirection = null;
      this.resolveConstraints();
      if (this.visualElement.projection) {
        this.visualElement.projection.isAnimationBlocked = true;
        this.visualElement.projection.target = void 0;
      }
      eachAxis((axis) => {
        let current = this.getAxisMotionValue(axis).get() || 0;
        if (percent.test(current)) {
          const { projection } = this.visualElement;
          if (projection && projection.layout) {
            const measuredAxis = projection.layout.layoutBox[axis];
            if (measuredAxis) {
              const length2 = calcLength(measuredAxis);
              current = length2 * (parseFloat(current) / 100);
            }
          }
        }
        this.originPoint[axis] = current;
      });
      if (onDragStart) {
        frame.postRender(() => onDragStart(event, info));
      }
      (_a = this.removeWillChange) === null || _a === void 0 ? void 0 : _a.call(this);
      this.removeWillChange = addValueToWillChange(this.visualElement, "transform");
      const { animationState } = this.visualElement;
      animationState && animationState.setActive("whileDrag", true);
    };
    const onMove = (event, info) => {
      const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag } = this.getProps();
      if (!dragPropagation && !this.openGlobalLock)
        return;
      const { offset: offset2 } = info;
      if (dragDirectionLock && this.currentDirection === null) {
        this.currentDirection = getCurrentDirection(offset2);
        if (this.currentDirection !== null) {
          onDirectionLock && onDirectionLock(this.currentDirection);
        }
        return;
      }
      this.updateAxis("x", info.point, offset2);
      this.updateAxis("y", info.point, offset2);
      this.visualElement.render();
      onDrag && onDrag(event, info);
    };
    const onSessionEnd = (event, info) => this.stop(event, info);
    const resumeAnimation = () => eachAxis((axis) => {
      var _a;
      return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
    });
    const { dragSnapToOrigin } = this.getProps();
    this.panSession = new PanSession2(originEvent, {
      onSessionStart,
      onStart,
      onMove,
      onSessionEnd,
      resumeAnimation
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin,
      contextWindow: getContextWindow(this.visualElement)
    });
  }
  stop(event, info) {
    var _a;
    (_a = this.removeWillChange) === null || _a === void 0 ? void 0 : _a.call(this);
    const isDragging = this.isDragging;
    this.cancel();
    if (!isDragging)
      return;
    const { velocity } = info;
    this.startAnimation(velocity);
    const { onDragEnd } = this.getProps();
    if (onDragEnd) {
      frame.postRender(() => onDragEnd(event, info));
    }
  }
  cancel() {
    this.isDragging = false;
    const { projection, animationState } = this.visualElement;
    if (projection) {
      projection.isAnimationBlocked = false;
    }
    this.panSession && this.panSession.end();
    this.panSession = void 0;
    const { dragPropagation } = this.getProps();
    if (!dragPropagation && this.openGlobalLock) {
      this.openGlobalLock();
      this.openGlobalLock = null;
    }
    animationState && animationState.setActive("whileDrag", false);
  }
  updateAxis(axis, _point, offset2) {
    const { drag: drag2 } = this.getProps();
    if (!offset2 || !shouldDrag(axis, drag2, this.currentDirection))
      return;
    const axisValue = this.getAxisMotionValue(axis);
    let next2 = this.originPoint[axis] + offset2[axis];
    if (this.constraints && this.constraints[axis]) {
      next2 = applyConstraints(next2, this.constraints[axis], this.elastic[axis]);
    }
    axisValue.set(next2);
  }
  resolveConstraints() {
    var _a;
    const { dragConstraints, dragElastic } = this.getProps();
    const layout2 = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
    const prevConstraints = this.constraints;
    if (dragConstraints && isRefObject(dragConstraints)) {
      if (!this.constraints) {
        this.constraints = this.resolveRefConstraints();
      }
    } else {
      if (dragConstraints && layout2) {
        this.constraints = calcRelativeConstraints(layout2.layoutBox, dragConstraints);
      } else {
        this.constraints = false;
      }
    }
    this.elastic = resolveDragElastic(dragElastic);
    if (prevConstraints !== this.constraints && layout2 && this.constraints && !this.hasMutatedConstraints) {
      eachAxis((axis) => {
        if (this.constraints !== false && this.getAxisMotionValue(axis)) {
          this.constraints[axis] = rebaseAxisConstraints(layout2.layoutBox[axis], this.constraints[axis]);
        }
      });
    }
  }
  resolveRefConstraints() {
    const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
    if (!constraints || !isRefObject(constraints))
      return false;
    const constraintsElement = constraints.current;
    invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection } = this.visualElement;
    if (!projection || !projection.layout)
      return false;
    const constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
    let measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
    if (onMeasureDragConstraints) {
      const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
      this.hasMutatedConstraints = !!userConstraints;
      if (userConstraints) {
        measuredConstraints = convertBoundingBoxToBox(userConstraints);
      }
    }
    return measuredConstraints;
  }
  startAnimation(velocity) {
    const { drag: drag2, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd } = this.getProps();
    const constraints = this.constraints || {};
    const momentumAnimations = eachAxis((axis) => {
      if (!shouldDrag(axis, drag2, this.currentDirection)) {
        return;
      }
      let transition = constraints && constraints[axis] || {};
      if (dragSnapToOrigin)
        transition = { min: 0, max: 0 };
      const bounceStiffness = dragElastic ? 200 : 1e6;
      const bounceDamping = dragElastic ? 40 : 1e7;
      const inertia2 = __spreadValues(__spreadValues({
        type: "inertia",
        velocity: dragMomentum ? velocity[axis] : 0,
        bounceStiffness,
        bounceDamping,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10
      }, dragTransition), transition);
      return this.startAxisValueAnimation(axis, inertia2);
    });
    return Promise.all(momentumAnimations).then(onDragTransitionEnd);
  }
  startAxisValueAnimation(axis, transition) {
    const axisValue = this.getAxisMotionValue(axis);
    return axisValue.start(animateMotionValue(axis, axisValue, 0, transition, this.visualElement, false, addValueToWillChange(this.visualElement, axis)));
  }
  stopAnimation() {
    eachAxis((axis) => this.getAxisMotionValue(axis).stop());
  }
  pauseAnimation() {
    eachAxis((axis) => {
      var _a;
      return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
    });
  }
  getAnimationState(axis) {
    var _a;
    return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(axis) {
    const dragKey = `_drag${axis.toUpperCase()}`;
    const props = this.visualElement.getProps();
    const externalMotionValue = props[dragKey];
    return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : void 0) || 0);
  }
  snapToCursor(point) {
    eachAxis((axis) => {
      const { drag: drag2 } = this.getProps();
      if (!shouldDrag(axis, drag2, this.currentDirection))
        return;
      const { projection } = this.visualElement;
      const axisValue = this.getAxisMotionValue(axis);
      if (projection && projection.layout) {
        const { min: min2, max: max2 } = projection.layout.layoutBox[axis];
        axisValue.set(point[axis] - mixNumber$1(min2, max2, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: drag2, dragConstraints } = this.getProps();
    const { projection } = this.visualElement;
    if (!isRefObject(dragConstraints) || !projection || !this.constraints)
      return;
    this.stopAnimation();
    const boxProgress = { x: 0, y: 0 };
    eachAxis((axis) => {
      const axisValue = this.getAxisMotionValue(axis);
      if (axisValue && this.constraints !== false) {
        const latest = axisValue.get();
        boxProgress[axis] = calcOrigin$1({ min: latest, max: latest }, this.constraints[axis]);
      }
    });
    const { transformTemplate } = this.visualElement.getProps();
    this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
    projection.root && projection.root.updateScroll();
    projection.updateLayout();
    this.resolveConstraints();
    eachAxis((axis) => {
      if (!shouldDrag(axis, drag2, null))
        return;
      const axisValue = this.getAxisMotionValue(axis);
      const { min: min2, max: max2 } = this.constraints[axis];
      axisValue.set(mixNumber$1(min2, max2, boxProgress[axis]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    elementDragControls.set(this.visualElement, this);
    const element = this.visualElement.current;
    const stopPointerListener = addPointerEvent(element, "pointerdown", (event) => {
      const { drag: drag2, dragListener = true } = this.getProps();
      drag2 && dragListener && this.start(event);
    });
    const measureDragConstraints = () => {
      const { dragConstraints } = this.getProps();
      if (isRefObject(dragConstraints) && dragConstraints.current) {
        this.constraints = this.resolveRefConstraints();
      }
    };
    const { projection } = this.visualElement;
    const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
    if (projection && !projection.layout) {
      projection.root && projection.root.updateScroll();
      projection.updateLayout();
    }
    frame.read(measureDragConstraints);
    const stopResizeListener = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints());
    const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta, hasLayoutChanged }) => {
      if (this.isDragging && hasLayoutChanged) {
        eachAxis((axis) => {
          const motionValue2 = this.getAxisMotionValue(axis);
          if (!motionValue2)
            return;
          this.originPoint[axis] += delta[axis].translate;
          motionValue2.set(motionValue2.get() + delta[axis].translate);
        });
        this.visualElement.render();
      }
    });
    return () => {
      stopResizeListener();
      stopPointerListener();
      stopMeasureLayoutListener();
      stopLayoutUpdateListener && stopLayoutUpdateListener();
    };
  }
  getProps() {
    const props = this.visualElement.getProps();
    const { drag: drag2 = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = defaultElastic, dragMomentum = true } = props;
    return __spreadProps(__spreadValues({}, props), {
      drag: drag2,
      dragDirectionLock,
      dragPropagation,
      dragConstraints,
      dragElastic,
      dragMomentum
    });
  }
}
function shouldDrag(direction, drag2, currentDirection) {
  return (drag2 === true || drag2 === direction) && (currentDirection === null || currentDirection === direction);
}
function getCurrentDirection(offset2, lockThreshold = 10) {
  let direction = null;
  if (Math.abs(offset2.y) > lockThreshold) {
    direction = "y";
  } else if (Math.abs(offset2.x) > lockThreshold) {
    direction = "x";
  }
  return direction;
}
class DragGesture2 extends Feature2 {
  constructor(node2) {
    super(node2);
    this.removeGroupControls = noop;
    this.removeListeners = noop;
    this.controls = new VisualElementDragControls2(node2);
  }
  mount() {
    const { dragControls } = this.node.getProps();
    if (dragControls) {
      this.removeGroupControls = dragControls.subscribe(this.controls);
    }
    this.removeListeners = this.controls.addListeners() || noop;
  }
  unmount() {
    this.removeGroupControls();
    this.removeListeners();
  }
}
const asyncHandler = (handler) => (event, info) => {
  if (handler) {
    frame.postRender(() => handler(event, info));
  }
};
class PanGesture2 extends Feature2 {
  constructor() {
    super(...arguments);
    this.removePointerDownListener = noop;
  }
  onPointerDown(pointerDownEvent) {
    this.session = new PanSession2(pointerDownEvent, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: getContextWindow(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
    return {
      onSessionStart: asyncHandler(onPanSessionStart),
      onStart: asyncHandler(onPanStart),
      onMove: onPan,
      onEnd: (event, info) => {
        delete this.session;
        if (onPanEnd) {
          frame.postRender(() => onPanEnd(event, info));
        }
      }
    };
  }
  mount() {
    this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", (event) => this.onPointerDown(event));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener();
    this.session && this.session.end();
  }
}
const PresenceContext = createContext(null);
function usePresence() {
  const context = useContext(PresenceContext);
  if (context === null)
    return [true, null];
  const { isPresent, onExitComplete, register } = context;
  const id2 = useId$1();
  useEffect(() => register(id2), []);
  const safeToRemove = useCallback(() => onExitComplete && onExitComplete(id2), [id2, onExitComplete]);
  return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
const LayoutGroupContext = createContext({});
const SwitchLayoutGroupContext = createContext({});
const globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: true,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: false
};
function pixelsToPercent(pixels, axis) {
  if (axis.max === axis.min)
    return 0;
  return pixels / (axis.max - axis.min) * 100;
}
const correctBorderRadius = {
  correct: (latest, node2) => {
    if (!node2.target)
      return latest;
    if (typeof latest === "string") {
      if (px.test(latest)) {
        latest = parseFloat(latest);
      } else {
        return latest;
      }
    }
    const x2 = pixelsToPercent(latest, node2.target.x);
    const y = pixelsToPercent(latest, node2.target.y);
    return `${x2}% ${y}%`;
  }
};
const correctBoxShadow = {
  correct: (latest, { treeScale, projectionDelta }) => {
    const original = latest;
    const shadow = complex.parse(latest);
    if (shadow.length > 5)
      return original;
    const template = complex.createTransformer(latest);
    const offset2 = typeof shadow[0] !== "number" ? 1 : 0;
    const xScale = projectionDelta.x.scale * treeScale.x;
    const yScale = projectionDelta.y.scale * treeScale.y;
    shadow[0 + offset2] /= xScale;
    shadow[1 + offset2] /= yScale;
    const averageScale = mixNumber$1(xScale, yScale, 0.5);
    if (typeof shadow[2 + offset2] === "number")
      shadow[2 + offset2] /= averageScale;
    if (typeof shadow[3 + offset2] === "number")
      shadow[3 + offset2] /= averageScale;
    return template(shadow);
  }
};
const scaleCorrectors = {};
function addScaleCorrector(correctors) {
  Object.assign(scaleCorrectors, correctors);
}
const { schedule: microtask, cancel: cancelMicrotask } = createRenderBatcher(queueMicrotask, false);
class MeasureLayoutWithContext2 extends Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
    const { projection } = visualElement;
    addScaleCorrector(defaultScaleCorrectors);
    if (projection) {
      if (layoutGroup.group)
        layoutGroup.group.add(projection);
      if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
        switchLayoutGroup.register(projection);
      }
      projection.root.didUpdate();
      projection.addEventListener("animationComplete", () => {
        this.safeToRemove();
      });
      projection.setOptions(__spreadProps(__spreadValues({}, projection.options), {
        onExitComplete: () => this.safeToRemove()
      }));
    }
    globalProjectionState.hasEverUpdated = true;
  }
  getSnapshotBeforeUpdate(prevProps) {
    const { layoutDependency, visualElement, drag: drag2, isPresent } = this.props;
    const projection = visualElement.projection;
    if (!projection)
      return null;
    projection.isPresent = isPresent;
    if (drag2 || prevProps.layoutDependency !== layoutDependency || layoutDependency === void 0) {
      projection.willUpdate();
    } else {
      this.safeToRemove();
    }
    if (prevProps.isPresent !== isPresent) {
      if (isPresent) {
        projection.promote();
      } else if (!projection.relegate()) {
        frame.postRender(() => {
          const stack = projection.getStack();
          if (!stack || !stack.members.length) {
            this.safeToRemove();
          }
        });
      }
    }
    return null;
  }
  componentDidUpdate() {
    const { projection } = this.props.visualElement;
    if (projection) {
      projection.root.didUpdate();
      microtask.postRender(() => {
        if (!projection.currentAnimation && projection.isLead()) {
          this.safeToRemove();
        }
      });
    }
  }
  componentWillUnmount() {
    const { visualElement, layoutGroup, switchLayoutGroup: promoteContext } = this.props;
    const { projection } = visualElement;
    if (projection) {
      projection.scheduleCheckAfterUnmount();
      if (layoutGroup && layoutGroup.group)
        layoutGroup.group.remove(projection);
      if (promoteContext && promoteContext.deregister)
        promoteContext.deregister(projection);
    }
  }
  safeToRemove() {
    const { safeToRemove } = this.props;
    safeToRemove && safeToRemove();
  }
  render() {
    return null;
  }
}
function MeasureLayout(props) {
  const [isPresent, safeToRemove] = usePresence();
  const layoutGroup = useContext(LayoutGroupContext);
  return jsx(MeasureLayoutWithContext2, __spreadProps(__spreadValues({}, props), { layoutGroup, switchLayoutGroup: useContext(SwitchLayoutGroupContext), isPresent, safeToRemove }));
}
const defaultScaleCorrectors = {
  borderRadius: __spreadProps(__spreadValues({}, correctBorderRadius), {
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  }),
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
};
const borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
const numBorders = borders.length;
const asNumber = (value) => typeof value === "string" ? parseFloat(value) : value;
const isPx = (value) => typeof value === "number" || px.test(value);
function mixValues(target, follow, lead, progress2, shouldCrossfadeOpacity, isOnlyMember) {
  if (shouldCrossfadeOpacity) {
    target.opacity = mixNumber$1(
      0,
      // TODO Reinstate this if only child
      lead.opacity !== void 0 ? lead.opacity : 1,
      easeCrossfadeIn(progress2)
    );
    target.opacityExit = mixNumber$1(follow.opacity !== void 0 ? follow.opacity : 1, 0, easeCrossfadeOut(progress2));
  } else if (isOnlyMember) {
    target.opacity = mixNumber$1(follow.opacity !== void 0 ? follow.opacity : 1, lead.opacity !== void 0 ? lead.opacity : 1, progress2);
  }
  for (let i = 0; i < numBorders; i++) {
    const borderLabel = `border${borders[i]}Radius`;
    let followRadius = getRadius(follow, borderLabel);
    let leadRadius = getRadius(lead, borderLabel);
    if (followRadius === void 0 && leadRadius === void 0)
      continue;
    followRadius || (followRadius = 0);
    leadRadius || (leadRadius = 0);
    const canMix = followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius);
    if (canMix) {
      target[borderLabel] = Math.max(mixNumber$1(asNumber(followRadius), asNumber(leadRadius), progress2), 0);
      if (percent.test(leadRadius) || percent.test(followRadius)) {
        target[borderLabel] += "%";
      }
    } else {
      target[borderLabel] = leadRadius;
    }
  }
  if (follow.rotate || lead.rotate) {
    target.rotate = mixNumber$1(follow.rotate || 0, lead.rotate || 0, progress2);
  }
}
function getRadius(values2, radiusName) {
  return values2[radiusName] !== void 0 ? values2[radiusName] : values2.borderRadius;
}
const easeCrossfadeIn = /* @__PURE__ */ compress(0, 0.5, circOut);
const easeCrossfadeOut = /* @__PURE__ */ compress(0.5, 0.95, noop);
function compress(min2, max2, easing2) {
  return (p) => {
    if (p < min2)
      return 0;
    if (p > max2)
      return 1;
    return easing2(progress(min2, max2, p));
  };
}
function copyAxisInto(axis, originAxis) {
  axis.min = originAxis.min;
  axis.max = originAxis.max;
}
function copyBoxInto(box, originBox) {
  copyAxisInto(box.x, originBox.x);
  copyAxisInto(box.y, originBox.y);
}
function copyAxisDeltaInto(delta, originDelta) {
  delta.translate = originDelta.translate;
  delta.scale = originDelta.scale;
  delta.originPoint = originDelta.originPoint;
  delta.origin = originDelta.origin;
}
function removePointDelta(point, translate, scale2, originPoint, boxScale) {
  point -= translate;
  point = scalePoint(point, 1 / scale2, originPoint);
  if (boxScale !== void 0) {
    point = scalePoint(point, 1 / boxScale, originPoint);
  }
  return point;
}
function removeAxisDelta(axis, translate = 0, scale2 = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
  if (percent.test(translate)) {
    translate = parseFloat(translate);
    const relativeProgress = mixNumber$1(sourceAxis.min, sourceAxis.max, translate / 100);
    translate = relativeProgress - sourceAxis.min;
  }
  if (typeof translate !== "number")
    return;
  let originPoint = mixNumber$1(originAxis.min, originAxis.max, origin);
  if (axis === originAxis)
    originPoint -= translate;
  axis.min = removePointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = removePointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function removeAxisTransforms(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
  removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
const xKeys = ["x", "scaleX", "originX"];
const yKeys = ["y", "scaleY", "originY"];
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
  removeAxisTransforms(box.x, transforms, xKeys, originBox ? originBox.x : void 0, sourceBox ? sourceBox.x : void 0);
  removeAxisTransforms(box.y, transforms, yKeys, originBox ? originBox.y : void 0, sourceBox ? sourceBox.y : void 0);
}
function isAxisDeltaZero(delta) {
  return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
  return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function axisEquals(a2, b) {
  return a2.min === b.min && a2.max === b.max;
}
function boxEquals(a2, b) {
  return axisEquals(a2.x, b.x) && axisEquals(a2.y, b.y);
}
function axisEqualsRounded(a2, b) {
  return Math.round(a2.min) === Math.round(b.min) && Math.round(a2.max) === Math.round(b.max);
}
function boxEqualsRounded(a2, b) {
  return axisEqualsRounded(a2.x, b.x) && axisEqualsRounded(a2.y, b.y);
}
function aspectRatio(box) {
  return calcLength(box.x) / calcLength(box.y);
}
function axisDeltaEquals(a2, b) {
  return a2.translate === b.translate && a2.scale === b.scale && a2.originPoint === b.originPoint;
}
class NodeStack2 {
  constructor() {
    this.members = [];
  }
  add(node2) {
    addUniqueItem(this.members, node2);
    node2.scheduleRender();
  }
  remove(node2) {
    removeItem(this.members, node2);
    if (node2 === this.prevLead) {
      this.prevLead = void 0;
    }
    if (node2 === this.lead) {
      const prevLead = this.members[this.members.length - 1];
      if (prevLead) {
        this.promote(prevLead);
      }
    }
  }
  relegate(node2) {
    const indexOfNode = this.members.findIndex((member) => node2 === member);
    if (indexOfNode === 0)
      return false;
    let prevLead;
    for (let i = indexOfNode; i >= 0; i--) {
      const member = this.members[i];
      if (member.isPresent !== false) {
        prevLead = member;
        break;
      }
    }
    if (prevLead) {
      this.promote(prevLead);
      return true;
    } else {
      return false;
    }
  }
  promote(node2, preserveFollowOpacity) {
    const prevLead = this.lead;
    if (node2 === prevLead)
      return;
    this.prevLead = prevLead;
    this.lead = node2;
    node2.show();
    if (prevLead) {
      prevLead.instance && prevLead.scheduleRender();
      node2.scheduleRender();
      node2.resumeFrom = prevLead;
      if (preserveFollowOpacity) {
        node2.resumeFrom.preserveOpacity = true;
      }
      if (prevLead.snapshot) {
        node2.snapshot = prevLead.snapshot;
        node2.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
      }
      if (node2.root && node2.root.isUpdating) {
        node2.isLayoutDirty = true;
      }
      const { crossfade } = node2.options;
      if (crossfade === false) {
        prevLead.hide();
      }
    }
  }
  exitAnimationComplete() {
    this.members.forEach((node2) => {
      const { options, resumingFrom } = node2;
      options.onExitComplete && options.onExitComplete();
      if (resumingFrom) {
        resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
      }
    });
  }
  scheduleRender() {
    this.members.forEach((node2) => {
      node2.instance && node2.scheduleRender(false);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    if (this.lead && this.lead.snapshot) {
      this.lead.snapshot = void 0;
    }
  }
}
function buildProjectionTransform(delta, treeScale, latestTransform) {
  let transform = "";
  const xTranslate = delta.x.translate / treeScale.x;
  const yTranslate = delta.y.translate / treeScale.y;
  const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
  if (xTranslate || yTranslate || zTranslate) {
    transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
  }
  if (treeScale.x !== 1 || treeScale.y !== 1) {
    transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
  }
  if (latestTransform) {
    const { transformPerspective, rotate, rotateX, rotateY, skewX, skewY } = latestTransform;
    if (transformPerspective)
      transform = `perspective(${transformPerspective}px) ${transform}`;
    if (rotate)
      transform += `rotate(${rotate}deg) `;
    if (rotateX)
      transform += `rotateX(${rotateX}deg) `;
    if (rotateY)
      transform += `rotateY(${rotateY}deg) `;
    if (skewX)
      transform += `skewX(${skewX}deg) `;
    if (skewY)
      transform += `skewY(${skewY}deg) `;
  }
  const elementScaleX = delta.x.scale * treeScale.x;
  const elementScaleY = delta.y.scale * treeScale.y;
  if (elementScaleX !== 1 || elementScaleY !== 1) {
    transform += `scale(${elementScaleX}, ${elementScaleY})`;
  }
  return transform || "none";
}
const compareByDepth = (a2, b) => a2.depth - b.depth;
class FlatTree2 {
  constructor() {
    this.children = [];
    this.isDirty = false;
  }
  add(child) {
    addUniqueItem(this.children, child);
    this.isDirty = true;
  }
  remove(child) {
    removeItem(this.children, child);
    this.isDirty = true;
  }
  forEach(callback) {
    this.isDirty && this.children.sort(compareByDepth);
    this.isDirty = false;
    this.children.forEach(callback);
  }
}
function resolveMotionValue(value) {
  const unwrappedValue = isMotionValue(value) ? value.get() : value;
  return isCustomValue(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}
function delay(callback, timeout2) {
  const start2 = time.now();
  const checkElapsed = ({ timestamp }) => {
    const elapsed = timestamp - start2;
    if (elapsed >= timeout2) {
      cancelFrame(checkElapsed);
      callback(elapsed - timeout2);
    }
  };
  frame.read(checkElapsed, true);
  return () => cancelFrame(checkElapsed);
}
function isSVGElement(element) {
  return element instanceof SVGElement && element.tagName !== "svg";
}
function animateSingleValue(value, keyframes2, options) {
  const motionValue$12 = isMotionValue(value) ? value : motionValue(value);
  motionValue$12.start(animateMotionValue("", motionValue$12, keyframes2, options));
  return motionValue$12.animation;
}
const metrics = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
const isDebug = typeof window !== "undefined" && window.MotionDebug !== void 0;
const transformAxes = ["", "X", "Y", "Z"];
const hiddenVisibility = { visibility: "hidden" };
const animationTarget = 1e3;
let id = 0;
function resetDistortingTransform(key, visualElement, values2, sharedAnimationValues) {
  const { latestValues } = visualElement;
  if (latestValues[key]) {
    values2[key] = latestValues[key];
    visualElement.setStaticValue(key, 0);
    if (sharedAnimationValues) {
      sharedAnimationValues[key] = 0;
    }
  }
}
function cancelTreeOptimisedTransformAnimations(projectionNode) {
  projectionNode.hasCheckedOptimisedAppear = true;
  if (projectionNode.root === projectionNode)
    return;
  const { visualElement } = projectionNode.options;
  if (!visualElement)
    return;
  const appearId = getOptimisedAppearId(visualElement);
  if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
    const { layout: layout2, layoutId } = projectionNode.options;
    window.MotionCancelOptimisedAnimation(appearId, "transform", frame, !(layout2 || layoutId));
  }
  const { parent } = projectionNode;
  if (parent && !parent.hasCheckedOptimisedAppear) {
    cancelTreeOptimisedTransformAnimations(parent);
  }
}
function createProjectionNode$1({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform }) {
  return class ProjectionNode {
    constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()) {
      this.id = id++;
      this.animationId = 0;
      this.children = /* @__PURE__ */ new Set();
      this.options = {};
      this.isTreeAnimating = false;
      this.isAnimationBlocked = false;
      this.isLayoutDirty = false;
      this.isProjectionDirty = false;
      this.isSharedProjectionDirty = false;
      this.isTransformDirty = false;
      this.updateManuallyBlocked = false;
      this.updateBlockedByResize = false;
      this.isUpdating = false;
      this.isSVG = false;
      this.needsReset = false;
      this.shouldResetTransform = false;
      this.hasCheckedOptimisedAppear = false;
      this.treeScale = { x: 1, y: 1 };
      this.eventHandlers = /* @__PURE__ */ new Map();
      this.hasTreeAnimated = false;
      this.updateScheduled = false;
      this.scheduleUpdate = () => this.update();
      this.projectionUpdateScheduled = false;
      this.checkUpdateFailed = () => {
        if (this.isUpdating) {
          this.isUpdating = false;
          this.clearAllSnapshots();
        }
      };
      this.updateProjection = () => {
        this.projectionUpdateScheduled = false;
        if (isDebug) {
          metrics.totalNodes = metrics.resolvedTargetDeltas = metrics.recalculatedProjection = 0;
        }
        this.nodes.forEach(propagateDirtyNodes);
        this.nodes.forEach(resolveTargetDelta);
        this.nodes.forEach(calcProjection);
        this.nodes.forEach(cleanDirtyNodes);
        if (isDebug) {
          window.MotionDebug.record(metrics);
        }
      };
      this.resolvedRelativeTargetAt = 0;
      this.hasProjected = false;
      this.isVisible = true;
      this.animationProgress = 0;
      this.sharedNodes = /* @__PURE__ */ new Map();
      this.latestValues = latestValues;
      this.root = parent ? parent.root || parent : this;
      this.path = parent ? [...parent.path, parent] : [];
      this.parent = parent;
      this.depth = parent ? parent.depth + 1 : 0;
      for (let i = 0; i < this.path.length; i++) {
        this.path[i].shouldResetTransform = true;
      }
      if (this.root === this)
        this.nodes = new FlatTree2();
    }
    addEventListener(name, handler) {
      if (!this.eventHandlers.has(name)) {
        this.eventHandlers.set(name, new SubscriptionManager2());
      }
      return this.eventHandlers.get(name).add(handler);
    }
    notifyListeners(name, ...args) {
      const subscriptionManager = this.eventHandlers.get(name);
      subscriptionManager && subscriptionManager.notify(...args);
    }
    hasListeners(name) {
      return this.eventHandlers.has(name);
    }
    /**
     * Lifecycles
     */
    mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = isSVGElement(instance);
      this.instance = instance;
      const { layoutId, layout: layout2, visualElement } = this.options;
      if (visualElement && !visualElement.current) {
        visualElement.mount(instance);
      }
      this.root.nodes.add(this);
      this.parent && this.parent.children.add(this);
      if (isLayoutDirty && (layout2 || layoutId)) {
        this.isLayoutDirty = true;
      }
      if (attachResizeListener) {
        let cancelDelay;
        const resizeUnblockUpdate = () => this.root.updateBlockedByResize = false;
        attachResizeListener(instance, () => {
          this.root.updateBlockedByResize = true;
          cancelDelay && cancelDelay();
          cancelDelay = delay(resizeUnblockUpdate, 250);
          if (globalProjectionState.hasAnimatedSinceResize) {
            globalProjectionState.hasAnimatedSinceResize = false;
            this.nodes.forEach(finishAnimation);
          }
        });
      }
      if (layoutId) {
        this.root.registerSharedNode(layoutId, this);
      }
      if (this.options.animate !== false && visualElement && (layoutId || layout2)) {
        this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout }) => {
          if (this.isTreeAnimationBlocked()) {
            this.target = void 0;
            this.relativeTarget = void 0;
            return;
          }
          const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || defaultLayoutTransition;
          const { onLayoutAnimationStart, onLayoutAnimationComplete } = visualElement.getProps();
          const targetChanged = !this.targetLayout || !boxEqualsRounded(this.targetLayout, newLayout) || hasRelativeTargetChanged;
          const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
          if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
            if (this.resumeFrom) {
              this.resumingFrom = this.resumeFrom;
              this.resumingFrom.resumingFrom = void 0;
            }
            this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
            const animationOptions = __spreadProps(__spreadValues({}, getValueTransition(layoutTransition, "layout")), {
              onPlay: onLayoutAnimationStart,
              onComplete: onLayoutAnimationComplete
            });
            if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
              animationOptions.delay = 0;
              animationOptions.type = false;
            }
            this.startAnimation(animationOptions);
          } else {
            if (!hasLayoutChanged) {
              finishAnimation(this);
            }
            if (this.isLead() && this.options.onExitComplete) {
              this.options.onExitComplete();
            }
          }
          this.targetLayout = newLayout;
        });
      }
    }
    unmount() {
      this.options.layoutId && this.willUpdate();
      this.root.nodes.remove(this);
      const stack = this.getStack();
      stack && stack.remove(this);
      this.parent && this.parent.children.delete(this);
      this.instance = void 0;
      cancelFrame(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = true;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = false;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
    }
    // Note: currently only running on root node
    startUpdate() {
      if (this.isUpdateBlocked())
        return;
      this.isUpdating = true;
      this.nodes && this.nodes.forEach(resetSkewAndRotation);
      this.animationId++;
    }
    getTransformTemplate() {
      const { visualElement } = this.options;
      return visualElement && visualElement.getProps().transformTemplate;
    }
    willUpdate(shouldNotifyListeners = true) {
      this.root.hasTreeAnimated = true;
      if (this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) {
        cancelTreeOptimisedTransformAnimations(this);
      }
      !this.root.isUpdating && this.root.startUpdate();
      if (this.isLayoutDirty)
        return;
      this.isLayoutDirty = true;
      for (let i = 0; i < this.path.length; i++) {
        const node2 = this.path[i];
        node2.shouldResetTransform = true;
        node2.updateScroll("snapshot");
        if (node2.options.layoutRoot) {
          node2.willUpdate(false);
        }
      }
      const { layoutId, layout: layout2 } = this.options;
      if (layoutId === void 0 && !layout2)
        return;
      const transformTemplate = this.getTransformTemplate();
      this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : void 0;
      this.updateSnapshot();
      shouldNotifyListeners && this.notifyListeners("willUpdate");
    }
    update() {
      this.updateScheduled = false;
      const updateWasBlocked = this.isUpdateBlocked();
      if (updateWasBlocked) {
        this.unblockUpdate();
        this.clearAllSnapshots();
        this.nodes.forEach(clearMeasurements);
        return;
      }
      if (!this.isUpdating) {
        this.nodes.forEach(clearIsLayoutDirty);
      }
      this.isUpdating = false;
      this.nodes.forEach(resetTransformStyle);
      this.nodes.forEach(updateLayout);
      this.nodes.forEach(notifyLayoutUpdate);
      this.clearAllSnapshots();
      const now2 = time.now();
      frameData.delta = clamp(0, 1e3 / 60, now2 - frameData.timestamp);
      frameData.timestamp = now2;
      frameData.isProcessing = true;
      steps.update.process(frameData);
      steps.preRender.process(frameData);
      steps.render.process(frameData);
      frameData.isProcessing = false;
    }
    didUpdate() {
      if (!this.updateScheduled) {
        this.updateScheduled = true;
        microtask.read(this.scheduleUpdate);
      }
    }
    clearAllSnapshots() {
      this.nodes.forEach(clearSnapshot);
      this.sharedNodes.forEach(removeLeadSnapshots);
    }
    scheduleUpdateProjection() {
      if (!this.projectionUpdateScheduled) {
        this.projectionUpdateScheduled = true;
        frame.preRender(this.updateProjection, false, true);
      }
    }
    scheduleCheckAfterUnmount() {
      frame.postRender(() => {
        if (this.isLayoutDirty) {
          this.root.didUpdate();
        } else {
          this.root.checkUpdateFailed();
        }
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      if (this.snapshot || !this.instance)
        return;
      this.snapshot = this.measure();
    }
    updateLayout() {
      if (!this.instance)
        return;
      this.updateScroll();
      if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) {
        return;
      }
      if (this.resumeFrom && !this.resumeFrom.instance) {
        for (let i = 0; i < this.path.length; i++) {
          const node2 = this.path[i];
          node2.updateScroll();
        }
      }
      const prevLayout = this.layout;
      this.layout = this.measure(false);
      this.layoutCorrected = createBox();
      this.isLayoutDirty = false;
      this.projectionDelta = void 0;
      this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement } = this.options;
      visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : void 0);
    }
    updateScroll(phase = "measure") {
      let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) {
        needsMeasurement = false;
      }
      if (needsMeasurement) {
        const isRoot = checkIsScrollRoot(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase,
          isRoot,
          offset: measureScroll(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : isRoot
        };
      }
    }
    resetTransform() {
      if (!resetTransform)
        return;
      const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
      const hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
      const transformTemplate = this.getTransformTemplate();
      const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : void 0;
      const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
      if (isResetRequested && (hasProjection || hasTransform(this.latestValues) || transformTemplateHasChanged)) {
        resetTransform(this.instance, transformTemplateValue);
        this.shouldResetTransform = false;
        this.scheduleRender();
      }
    }
    measure(removeTransform = true) {
      const pageBox = this.measurePageBox();
      let layoutBox = this.removeElementScroll(pageBox);
      if (removeTransform) {
        layoutBox = this.removeTransform(layoutBox);
      }
      roundBox(layoutBox);
      return {
        animationId: this.root.animationId,
        measuredBox: pageBox,
        layoutBox,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var _a;
      const { visualElement } = this.options;
      if (!visualElement)
        return createBox();
      const box = visualElement.measureViewportBox();
      const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some(checkNodeWasScrollRoot);
      if (!wasInScrollRoot) {
        const { scroll } = this.root;
        if (scroll) {
          translateAxis(box.x, scroll.offset.x);
          translateAxis(box.y, scroll.offset.y);
        }
      }
      return box;
    }
    removeElementScroll(box) {
      var _a;
      const boxWithoutScroll = createBox();
      copyBoxInto(boxWithoutScroll, box);
      if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) {
        return boxWithoutScroll;
      }
      for (let i = 0; i < this.path.length; i++) {
        const node2 = this.path[i];
        const { scroll, options } = node2;
        if (node2 !== this.root && scroll && options.layoutScroll) {
          if (scroll.wasRoot) {
            copyBoxInto(boxWithoutScroll, box);
          }
          translateAxis(boxWithoutScroll.x, scroll.offset.x);
          translateAxis(boxWithoutScroll.y, scroll.offset.y);
        }
      }
      return boxWithoutScroll;
    }
    applyTransform(box, transformOnly = false) {
      const withTransforms = createBox();
      copyBoxInto(withTransforms, box);
      for (let i = 0; i < this.path.length; i++) {
        const node2 = this.path[i];
        if (!transformOnly && node2.options.layoutScroll && node2.scroll && node2 !== node2.root) {
          transformBox(withTransforms, {
            x: -node2.scroll.offset.x,
            y: -node2.scroll.offset.y
          });
        }
        if (!hasTransform(node2.latestValues))
          continue;
        transformBox(withTransforms, node2.latestValues);
      }
      if (hasTransform(this.latestValues)) {
        transformBox(withTransforms, this.latestValues);
      }
      return withTransforms;
    }
    removeTransform(box) {
      const boxWithoutTransform = createBox();
      copyBoxInto(boxWithoutTransform, box);
      for (let i = 0; i < this.path.length; i++) {
        const node2 = this.path[i];
        if (!node2.instance)
          continue;
        if (!hasTransform(node2.latestValues))
          continue;
        hasScale(node2.latestValues) && node2.updateSnapshot();
        const sourceBox = createBox();
        const nodeBox = node2.measurePageBox();
        copyBoxInto(sourceBox, nodeBox);
        removeBoxTransforms(boxWithoutTransform, node2.latestValues, node2.snapshot ? node2.snapshot.layoutBox : void 0, sourceBox);
      }
      if (hasTransform(this.latestValues)) {
        removeBoxTransforms(boxWithoutTransform, this.latestValues);
      }
      return boxWithoutTransform;
    }
    setTargetDelta(delta) {
      this.targetDelta = delta;
      this.root.scheduleUpdateProjection();
      this.isProjectionDirty = true;
    }
    setOptions(options) {
      this.options = __spreadProps(__spreadValues(__spreadValues({}, this.options), options), {
        crossfade: options.crossfade !== void 0 ? options.crossfade : true
      });
    }
    clearMeasurements() {
      this.scroll = void 0;
      this.layout = void 0;
      this.snapshot = void 0;
      this.prevTransformTemplateValue = void 0;
      this.targetDelta = void 0;
      this.target = void 0;
      this.isLayoutDirty = false;
    }
    forceRelativeParentToResolveTarget() {
      if (!this.relativeParent)
        return;
      if (this.relativeParent.resolvedRelativeTargetAt !== frameData.timestamp) {
        this.relativeParent.resolveTargetDelta(true);
      }
    }
    resolveTargetDelta(forceRecalculation = false) {
      var _a;
      const lead = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
      this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
      this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
      const isShared = Boolean(this.resumingFrom) || this !== lead;
      const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
      if (canSkip)
        return;
      const { layout: layout2, layoutId } = this.options;
      if (!this.layout || !(layout2 || layoutId))
        return;
      this.resolvedRelativeTargetAt = frameData.timestamp;
      if (!this.targetDelta && !this.relativeTarget) {
        const relativeParent = this.getClosestProjectingParent();
        if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
          this.relativeParent = relativeParent;
          this.forceRelativeParentToResolveTarget();
          this.relativeTarget = createBox();
          this.relativeTargetOrigin = createBox();
          calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
          copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
        } else {
          this.relativeParent = this.relativeTarget = void 0;
        }
      }
      if (!this.relativeTarget && !this.targetDelta)
        return;
      if (!this.target) {
        this.target = createBox();
        this.targetWithTransforms = createBox();
      }
      if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
        this.forceRelativeParentToResolveTarget();
        calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
      } else if (this.targetDelta) {
        if (Boolean(this.resumingFrom)) {
          this.target = this.applyTransform(this.layout.layoutBox);
        } else {
          copyBoxInto(this.target, this.layout.layoutBox);
        }
        applyBoxDelta(this.target, this.targetDelta);
      } else {
        copyBoxInto(this.target, this.layout.layoutBox);
      }
      if (this.attemptToResolveRelativeTarget) {
        this.attemptToResolveRelativeTarget = false;
        const relativeParent = this.getClosestProjectingParent();
        if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
          this.relativeParent = relativeParent;
          this.forceRelativeParentToResolveTarget();
          this.relativeTarget = createBox();
          this.relativeTargetOrigin = createBox();
          calcRelativePosition(this.relativeTargetOrigin, this.target, relativeParent.target);
          copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
        } else {
          this.relativeParent = this.relativeTarget = void 0;
        }
      }
      if (isDebug) {
        metrics.resolvedTargetDeltas++;
      }
    }
    getClosestProjectingParent() {
      if (!this.parent || hasScale(this.parent.latestValues) || has2DTranslate(this.parent.latestValues)) {
        return void 0;
      }
      if (this.parent.isProjecting()) {
        return this.parent;
      } else {
        return this.parent.getClosestProjectingParent();
      }
    }
    isProjecting() {
      return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var _a;
      const lead = this.getLead();
      const isShared = Boolean(this.resumingFrom) || this !== lead;
      let canSkip = true;
      if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) {
        canSkip = false;
      }
      if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) {
        canSkip = false;
      }
      if (this.resolvedRelativeTargetAt === frameData.timestamp) {
        canSkip = false;
      }
      if (canSkip)
        return;
      const { layout: layout2, layoutId } = this.options;
      this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
      if (!this.isTreeAnimating) {
        this.targetDelta = this.relativeTarget = void 0;
      }
      if (!this.layout || !(layout2 || layoutId))
        return;
      copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
      const prevTreeScaleX = this.treeScale.x;
      const prevTreeScaleY = this.treeScale.y;
      applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared);
      if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
        lead.target = lead.layout.layoutBox;
        lead.targetWithTransforms = createBox();
      }
      const { target } = lead;
      if (!target) {
        if (this.prevProjectionDelta) {
          this.createProjectionDeltas();
          this.scheduleRender();
        }
        return;
      }
      if (!this.projectionDelta || !this.prevProjectionDelta) {
        this.createProjectionDeltas();
      } else {
        copyAxisDeltaInto(this.prevProjectionDelta.x, this.projectionDelta.x);
        copyAxisDeltaInto(this.prevProjectionDelta.y, this.projectionDelta.y);
      }
      calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
      if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !axisDeltaEquals(this.projectionDelta.x, this.prevProjectionDelta.x) || !axisDeltaEquals(this.projectionDelta.y, this.prevProjectionDelta.y)) {
        this.hasProjected = true;
        this.scheduleRender();
        this.notifyListeners("projectionUpdate", target);
      }
      if (isDebug) {
        metrics.recalculatedProjection++;
      }
    }
    hide() {
      this.isVisible = false;
    }
    show() {
      this.isVisible = true;
    }
    scheduleRender(notifyAll = true) {
      var _a;
      (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.scheduleRender();
      if (notifyAll) {
        const stack = this.getStack();
        stack && stack.scheduleRender();
      }
      if (this.resumingFrom && !this.resumingFrom.instance) {
        this.resumingFrom = void 0;
      }
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = createDelta();
      this.projectionDelta = createDelta();
      this.projectionDeltaWithTransform = createDelta();
    }
    setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
      const snapshot = this.snapshot;
      const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
      const mixedValues = __spreadValues({}, this.latestValues);
      const targetDelta = createDelta();
      if (!this.relativeParent || !this.relativeParent.options.layoutRoot) {
        this.relativeTarget = this.relativeTargetOrigin = void 0;
      }
      this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
      const relativeLayout = createBox();
      const snapshotSource = snapshot ? snapshot.source : void 0;
      const layoutSource = this.layout ? this.layout.source : void 0;
      const isSharedLayoutAnimation = snapshotSource !== layoutSource;
      const stack = this.getStack();
      const isOnlyMember = !stack || stack.members.length <= 1;
      const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade));
      this.animationProgress = 0;
      let prevRelativeTarget;
      this.mixTargetDelta = (latest) => {
        const progress2 = latest / 1e3;
        mixAxisDelta(targetDelta.x, delta.x, progress2);
        mixAxisDelta(targetDelta.y, delta.y, progress2);
        this.setTargetDelta(targetDelta);
        if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
          calcRelativePosition(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
          mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress2);
          if (prevRelativeTarget && boxEquals(this.relativeTarget, prevRelativeTarget)) {
            this.isProjectionDirty = false;
          }
          if (!prevRelativeTarget)
            prevRelativeTarget = createBox();
          copyBoxInto(prevRelativeTarget, this.relativeTarget);
        }
        if (isSharedLayoutAnimation) {
          this.animationValues = mixedValues;
          mixValues(mixedValues, snapshotLatestValues, this.latestValues, progress2, shouldCrossfadeOpacity, isOnlyMember);
        }
        this.root.scheduleUpdateProjection();
        this.scheduleRender();
        this.animationProgress = progress2;
      };
      this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(options) {
      this.notifyListeners("animationStart");
      this.currentAnimation && this.currentAnimation.stop();
      if (this.resumingFrom && this.resumingFrom.currentAnimation) {
        this.resumingFrom.currentAnimation.stop();
      }
      if (this.pendingAnimation) {
        cancelFrame(this.pendingAnimation);
        this.pendingAnimation = void 0;
      }
      this.pendingAnimation = frame.update(() => {
        globalProjectionState.hasAnimatedSinceResize = true;
        this.currentAnimation = animateSingleValue(0, animationTarget, __spreadProps(__spreadValues({}, options), {
          onUpdate: (latest) => {
            this.mixTargetDelta(latest);
            options.onUpdate && options.onUpdate(latest);
          },
          onComplete: () => {
            options.onComplete && options.onComplete();
            this.completeAnimation();
          }
        }));
        if (this.resumingFrom) {
          this.resumingFrom.currentAnimation = this.currentAnimation;
        }
        this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      if (this.resumingFrom) {
        this.resumingFrom.currentAnimation = void 0;
        this.resumingFrom.preserveOpacity = void 0;
      }
      const stack = this.getStack();
      stack && stack.exitAnimationComplete();
      this.resumingFrom = this.currentAnimation = this.animationValues = void 0;
      this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      if (this.currentAnimation) {
        this.mixTargetDelta && this.mixTargetDelta(animationTarget);
        this.currentAnimation.stop();
      }
      this.completeAnimation();
    }
    applyTransformsToTarget() {
      const lead = this.getLead();
      let { targetWithTransforms, target, layout: layout2, latestValues } = lead;
      if (!targetWithTransforms || !target || !layout2)
        return;
      if (this !== lead && this.layout && layout2 && shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout2.layoutBox)) {
        target = this.target || createBox();
        const xLength = calcLength(this.layout.layoutBox.x);
        target.x.min = lead.target.x.min;
        target.x.max = target.x.min + xLength;
        const yLength = calcLength(this.layout.layoutBox.y);
        target.y.min = lead.target.y.min;
        target.y.max = target.y.min + yLength;
      }
      copyBoxInto(targetWithTransforms, target);
      transformBox(targetWithTransforms, latestValues);
      calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
    }
    registerSharedNode(layoutId, node2) {
      if (!this.sharedNodes.has(layoutId)) {
        this.sharedNodes.set(layoutId, new NodeStack2());
      }
      const stack = this.sharedNodes.get(layoutId);
      stack.add(node2);
      const config2 = node2.options.initialPromotionConfig;
      node2.promote({
        transition: config2 ? config2.transition : void 0,
        preserveFollowOpacity: config2 && config2.shouldPreserveFollowOpacity ? config2.shouldPreserveFollowOpacity(node2) : void 0
      });
    }
    isLead() {
      const stack = this.getStack();
      return stack ? stack.lead === this : true;
    }
    getLead() {
      var _a;
      const { layoutId } = this.options;
      return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
    }
    getPrevLead() {
      var _a;
      const { layoutId } = this.options;
      return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : void 0;
    }
    getStack() {
      const { layoutId } = this.options;
      if (layoutId)
        return this.root.sharedNodes.get(layoutId);
    }
    promote({ needsReset, transition, preserveFollowOpacity } = {}) {
      const stack = this.getStack();
      if (stack)
        stack.promote(this, preserveFollowOpacity);
      if (needsReset) {
        this.projectionDelta = void 0;
        this.needsReset = true;
      }
      if (transition)
        this.setOptions({ transition });
    }
    relegate() {
      const stack = this.getStack();
      if (stack) {
        return stack.relegate(this);
      } else {
        return false;
      }
    }
    resetSkewAndRotation() {
      const { visualElement } = this.options;
      if (!visualElement)
        return;
      let hasDistortingTransform = false;
      const { latestValues } = visualElement;
      if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) {
        hasDistortingTransform = true;
      }
      if (!hasDistortingTransform)
        return;
      const resetValues = {};
      if (latestValues.z) {
        resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
      }
      for (let i = 0; i < transformAxes.length; i++) {
        resetDistortingTransform(`rotate${transformAxes[i]}`, visualElement, resetValues, this.animationValues);
        resetDistortingTransform(`skew${transformAxes[i]}`, visualElement, resetValues, this.animationValues);
      }
      visualElement.render();
      for (const key in resetValues) {
        visualElement.setStaticValue(key, resetValues[key]);
        if (this.animationValues) {
          this.animationValues[key] = resetValues[key];
        }
      }
      visualElement.scheduleRender();
    }
    getProjectionStyles(styleProp) {
      var _a, _b;
      if (!this.instance || this.isSVG)
        return void 0;
      if (!this.isVisible) {
        return hiddenVisibility;
      }
      const styles2 = {
        visibility: ""
      };
      const transformTemplate = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = false;
        styles2.opacity = "";
        styles2.pointerEvents = resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
        styles2.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
        return styles2;
      }
      const lead = this.getLead();
      if (!this.projectionDelta || !this.layout || !lead.target) {
        const emptyStyles = {};
        if (this.options.layoutId) {
          emptyStyles.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1;
          emptyStyles.pointerEvents = resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
        }
        if (this.hasProjected && !hasTransform(this.latestValues)) {
          emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
          this.hasProjected = false;
        }
        return emptyStyles;
      }
      const valuesToRender = lead.animationValues || lead.latestValues;
      this.applyTransformsToTarget();
      styles2.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
      if (transformTemplate) {
        styles2.transform = transformTemplate(valuesToRender, styles2.transform);
      }
      const { x: x2, y } = this.projectionDelta;
      styles2.transformOrigin = `${x2.origin * 100}% ${y.origin * 100}% 0`;
      if (lead.animationValues) {
        styles2.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
      } else {
        styles2.opacity = lead === this ? valuesToRender.opacity !== void 0 ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== void 0 ? valuesToRender.opacityExit : 0;
      }
      for (const key in scaleCorrectors) {
        if (valuesToRender[key] === void 0)
          continue;
        const { correct, applyTo } = scaleCorrectors[key];
        const corrected = styles2.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
        if (applyTo) {
          const num = applyTo.length;
          for (let i = 0; i < num; i++) {
            styles2[applyTo[i]] = corrected;
          }
        } else {
          styles2[key] = corrected;
        }
      }
      if (this.options.layoutId) {
        styles2.pointerEvents = lead === this ? resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
      }
      return styles2;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((node2) => {
        var _a;
        return (_a = node2.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
      });
      this.root.nodes.forEach(clearMeasurements);
      this.root.sharedNodes.clear();
    }
  };
}
function updateLayout(node2) {
  node2.updateLayout();
}
function notifyLayoutUpdate(node2) {
  var _a;
  const snapshot = ((_a = node2.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node2.snapshot;
  if (node2.isLead() && node2.layout && snapshot && node2.hasListeners("didUpdate")) {
    const { layoutBox: layout2, measuredBox: measuredLayout } = node2.layout;
    const { animationType } = node2.options;
    const isShared = snapshot.source !== node2.layout.source;
    if (animationType === "size") {
      eachAxis((axis) => {
        const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        const length2 = calcLength(axisSnapshot);
        axisSnapshot.min = layout2[axis].min;
        axisSnapshot.max = axisSnapshot.min + length2;
      });
    } else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout2)) {
      eachAxis((axis) => {
        const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        const length2 = calcLength(layout2[axis]);
        axisSnapshot.max = axisSnapshot.min + length2;
        if (node2.relativeTarget && !node2.currentAnimation) {
          node2.isProjectionDirty = true;
          node2.relativeTarget[axis].max = node2.relativeTarget[axis].min + length2;
        }
      });
    }
    const layoutDelta = createDelta();
    calcBoxDelta(layoutDelta, layout2, snapshot.layoutBox);
    const visualDelta = createDelta();
    if (isShared) {
      calcBoxDelta(visualDelta, node2.applyTransform(measuredLayout, true), snapshot.measuredBox);
    } else {
      calcBoxDelta(visualDelta, layout2, snapshot.layoutBox);
    }
    const hasLayoutChanged = !isDeltaZero(layoutDelta);
    let hasRelativeTargetChanged = false;
    if (!node2.resumeFrom) {
      const relativeParent = node2.getClosestProjectingParent();
      if (relativeParent && !relativeParent.resumeFrom) {
        const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
        if (parentSnapshot && parentLayout) {
          const relativeSnapshot = createBox();
          calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
          const relativeLayout = createBox();
          calcRelativePosition(relativeLayout, layout2, parentLayout.layoutBox);
          if (!boxEqualsRounded(relativeSnapshot, relativeLayout)) {
            hasRelativeTargetChanged = true;
          }
          if (relativeParent.options.layoutRoot) {
            node2.relativeTarget = relativeLayout;
            node2.relativeTargetOrigin = relativeSnapshot;
            node2.relativeParent = relativeParent;
          }
        }
      }
    }
    node2.notifyListeners("didUpdate", {
      layout: layout2,
      snapshot,
      delta: visualDelta,
      layoutDelta,
      hasLayoutChanged,
      hasRelativeTargetChanged
    });
  } else if (node2.isLead()) {
    const { onExitComplete } = node2.options;
    onExitComplete && onExitComplete();
  }
  node2.options.transition = void 0;
}
function propagateDirtyNodes(node2) {
  if (isDebug) {
    metrics.totalNodes++;
  }
  if (!node2.parent)
    return;
  if (!node2.isProjecting()) {
    node2.isProjectionDirty = node2.parent.isProjectionDirty;
  }
  node2.isSharedProjectionDirty || (node2.isSharedProjectionDirty = Boolean(node2.isProjectionDirty || node2.parent.isProjectionDirty || node2.parent.isSharedProjectionDirty));
  node2.isTransformDirty || (node2.isTransformDirty = node2.parent.isTransformDirty);
}
function cleanDirtyNodes(node2) {
  node2.isProjectionDirty = node2.isSharedProjectionDirty = node2.isTransformDirty = false;
}
function clearSnapshot(node2) {
  node2.clearSnapshot();
}
function clearMeasurements(node2) {
  node2.clearMeasurements();
}
function clearIsLayoutDirty(node2) {
  node2.isLayoutDirty = false;
}
function resetTransformStyle(node2) {
  const { visualElement } = node2.options;
  if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) {
    visualElement.notify("BeforeLayoutMeasure");
  }
  node2.resetTransform();
}
function finishAnimation(node2) {
  node2.finishAnimation();
  node2.targetDelta = node2.relativeTarget = node2.target = void 0;
  node2.isProjectionDirty = true;
}
function resolveTargetDelta(node2) {
  node2.resolveTargetDelta();
}
function calcProjection(node2) {
  node2.calcProjection();
}
function resetSkewAndRotation(node2) {
  node2.resetSkewAndRotation();
}
function removeLeadSnapshots(stack) {
  stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
  output.translate = mixNumber$1(delta.translate, 0, p);
  output.scale = mixNumber$1(delta.scale, 1, p);
  output.origin = delta.origin;
  output.originPoint = delta.originPoint;
}
function mixAxis(output, from2, to, p) {
  output.min = mixNumber$1(from2.min, to.min, p);
  output.max = mixNumber$1(from2.max, to.max, p);
}
function mixBox(output, from2, to, p) {
  mixAxis(output.x, from2.x, to.x, p);
  mixAxis(output.y, from2.y, to.y, p);
}
function hasOpacityCrossfade(node2) {
  return node2.animationValues && node2.animationValues.opacityExit !== void 0;
}
const defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
const userAgentContains = (string) => typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
const roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/") ? Math.round : noop;
function roundAxis(axis) {
  axis.min = roundPoint(axis.min);
  axis.max = roundPoint(axis.max);
}
function roundBox(box) {
  roundAxis(box.x);
  roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout2) {
  return animationType === "position" || animationType === "preserve-aspect" && !isNear(aspectRatio(snapshot), aspectRatio(layout2), 0.2);
}
function checkNodeWasScrollRoot(node2) {
  var _a;
  return node2 !== node2.root && ((_a = node2.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}
const DocumentProjectionNode = createProjectionNode$1({
  attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => true
});
const rootProjectionNode = {
  current: void 0
};
const HTMLProjectionNode = createProjectionNode$1({
  measureScroll: (instance) => ({
    x: instance.scrollLeft,
    y: instance.scrollTop
  }),
  defaultParent: () => {
    if (!rootProjectionNode.current) {
      const documentNode = new DocumentProjectionNode({});
      documentNode.mount(window);
      documentNode.setOptions({ layoutScroll: true });
      rootProjectionNode.current = documentNode;
    }
    return rootProjectionNode.current;
  },
  resetTransform: (instance, value) => {
    instance.style.transform = value !== void 0 ? value : "none";
  },
  checkIsScrollRoot: (instance) => Boolean(window.getComputedStyle(instance).position === "fixed")
});
const drag = {
  pan: {
    Feature: PanGesture2
  },
  drag: {
    Feature: DragGesture2,
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
};
function addHoverEvent(node2, isActive) {
  const eventName = isActive ? "pointerenter" : "pointerleave";
  const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
  const handleEvent = (event, info) => {
    if (event.pointerType === "touch" || isDragActive())
      return;
    const props = node2.getProps();
    if (node2.animationState && props.whileHover) {
      node2.animationState.setActive("whileHover", isActive);
    }
    const callback = props[callbackName];
    if (callback) {
      frame.postRender(() => callback(event, info));
    }
  };
  return addPointerEvent(node2.current, eventName, handleEvent, {
    passive: !node2.getProps()[callbackName]
  });
}
class HoverGesture2 extends Feature2 {
  mount() {
    this.unmount = pipe(addHoverEvent(this.node, true), addHoverEvent(this.node, false));
  }
  unmount() {
  }
}
class FocusGesture2 extends Feature2 {
  constructor() {
    super(...arguments);
    this.isActive = false;
  }
  onFocus() {
    let isFocusVisible2 = false;
    try {
      isFocusVisible2 = this.node.current.matches(":focus-visible");
    } catch (e2) {
      isFocusVisible2 = true;
    }
    if (!isFocusVisible2 || !this.node.animationState)
      return;
    this.node.animationState.setActive("whileFocus", true);
    this.isActive = true;
  }
  onBlur() {
    if (!this.isActive || !this.node.animationState)
      return;
    this.node.animationState.setActive("whileFocus", false);
    this.isActive = false;
  }
  mount() {
    this.unmount = pipe(addDomEvent(this.node.current, "focus", () => this.onFocus()), addDomEvent(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const isNodeOrChild = (parent, child) => {
  if (!child) {
    return false;
  } else if (parent === child) {
    return true;
  } else {
    return isNodeOrChild(parent, child.parentElement);
  }
};
function fireSyntheticPointerEvent(name, handler) {
  if (!handler)
    return;
  const syntheticPointerEvent = new PointerEvent("pointer" + name);
  handler(syntheticPointerEvent, extractEventInfo(syntheticPointerEvent));
}
class PressGesture2 extends Feature2 {
  constructor() {
    super(...arguments);
    this.removeStartListeners = noop;
    this.removeEndListeners = noop;
    this.removeAccessibleListeners = noop;
    this.startPointerPress = (startEvent, startInfo) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const props = this.node.getProps();
      const endPointerPress = (endEvent, endInfo) => {
        if (!this.checkPressEnd())
          return;
        const { onTap, onTapCancel, globalTapTarget } = this.node.getProps();
        const handler = !globalTapTarget && !isNodeOrChild(this.node.current, endEvent.target) ? onTapCancel : onTap;
        if (handler) {
          frame.update(() => handler(endEvent, endInfo));
        }
      };
      const removePointerUpListener = addPointerEvent(window, "pointerup", endPointerPress, {
        passive: !(props.onTap || props["onPointerUp"])
      });
      const removePointerCancelListener = addPointerEvent(window, "pointercancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo), {
        passive: !(props.onTapCancel || props["onPointerCancel"])
      });
      this.removeEndListeners = pipe(removePointerUpListener, removePointerCancelListener);
      this.startPress(startEvent, startInfo);
    };
    this.startAccessiblePress = () => {
      const handleKeydown = (keydownEvent) => {
        if (keydownEvent.key !== "Enter" || this.isPressing)
          return;
        const handleKeyup = (keyupEvent) => {
          if (keyupEvent.key !== "Enter" || !this.checkPressEnd())
            return;
          fireSyntheticPointerEvent("up", (event, info) => {
            const { onTap } = this.node.getProps();
            if (onTap) {
              frame.postRender(() => onTap(event, info));
            }
          });
        };
        this.removeEndListeners();
        this.removeEndListeners = addDomEvent(this.node.current, "keyup", handleKeyup);
        fireSyntheticPointerEvent("down", (event, info) => {
          this.startPress(event, info);
        });
      };
      const removeKeydownListener = addDomEvent(this.node.current, "keydown", handleKeydown);
      const handleBlur2 = () => {
        if (!this.isPressing)
          return;
        fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo));
      };
      const removeBlurListener = addDomEvent(this.node.current, "blur", handleBlur2);
      this.removeAccessibleListeners = pipe(removeKeydownListener, removeBlurListener);
    };
  }
  startPress(event, info) {
    this.isPressing = true;
    const { onTapStart, whileTap } = this.node.getProps();
    if (whileTap && this.node.animationState) {
      this.node.animationState.setActive("whileTap", true);
    }
    if (onTapStart) {
      frame.postRender(() => onTapStart(event, info));
    }
  }
  checkPressEnd() {
    this.removeEndListeners();
    this.isPressing = false;
    const props = this.node.getProps();
    if (props.whileTap && this.node.animationState) {
      this.node.animationState.setActive("whileTap", false);
    }
    return !isDragActive();
  }
  cancelPress(event, info) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel } = this.node.getProps();
    if (onTapCancel) {
      frame.postRender(() => onTapCancel(event, info));
    }
  }
  mount() {
    const props = this.node.getProps();
    const removePointerListener = addPointerEvent(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
      passive: !(props.onTapStart || props["onPointerStart"])
    });
    const removeFocusListener = addDomEvent(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = pipe(removePointerListener, removeFocusListener);
  }
  unmount() {
    this.removeStartListeners();
    this.removeEndListeners();
    this.removeAccessibleListeners();
  }
}
const observerCallbacks = /* @__PURE__ */ new WeakMap();
const observers = /* @__PURE__ */ new WeakMap();
const fireObserverCallback = (entry) => {
  const callback = observerCallbacks.get(entry.target);
  callback && callback(entry);
};
const fireAllObserverCallbacks = (entries) => {
  entries.forEach(fireObserverCallback);
};
function initIntersectionObserver(_ra) {
  var _sa = _ra, { root: root2 } = _sa, options = __objRest(_sa, ["root"]);
  const lookupRoot = root2 || document;
  if (!observers.has(lookupRoot)) {
    observers.set(lookupRoot, {});
  }
  const rootObservers = observers.get(lookupRoot);
  const key = JSON.stringify(options);
  if (!rootObservers[key]) {
    rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, __spreadValues({ root: root2 }, options));
  }
  return rootObservers[key];
}
function observeIntersection(element, options, callback) {
  const rootInteresectionObserver = initIntersectionObserver(options);
  observerCallbacks.set(element, callback);
  rootInteresectionObserver.observe(element);
  return () => {
    observerCallbacks.delete(element);
    rootInteresectionObserver.unobserve(element);
  };
}
const thresholdNames = {
  some: 0,
  all: 1
};
class InViewFeature2 extends Feature2 {
  constructor() {
    super(...arguments);
    this.hasEnteredView = false;
    this.isInView = false;
  }
  startObserver() {
    this.unmount();
    const { viewport: viewport2 = {} } = this.node.getProps();
    const { root: root2, margin: rootMargin, amount = "some", once } = viewport2;
    const options = {
      root: root2 ? root2.current : void 0,
      rootMargin,
      threshold: typeof amount === "number" ? amount : thresholdNames[amount]
    };
    const onIntersectionUpdate = (entry) => {
      const { isIntersecting } = entry;
      if (this.isInView === isIntersecting)
        return;
      this.isInView = isIntersecting;
      if (once && !isIntersecting && this.hasEnteredView) {
        return;
      } else if (isIntersecting) {
        this.hasEnteredView = true;
      }
      if (this.node.animationState) {
        this.node.animationState.setActive("whileInView", isIntersecting);
      }
      const { onViewportEnter, onViewportLeave } = this.node.getProps();
      const callback = isIntersecting ? onViewportEnter : onViewportLeave;
      callback && callback(entry);
    };
    return observeIntersection(this.node.current, options, onIntersectionUpdate);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver === "undefined")
      return;
    const { props, prevProps } = this.node;
    const hasOptionsChanged = ["amount", "margin", "root"].some(hasViewportOptionChanged(props, prevProps));
    if (hasOptionsChanged) {
      this.startObserver();
    }
  }
  unmount() {
  }
}
function hasViewportOptionChanged({ viewport: viewport2 = {} }, { viewport: prevViewport = {} } = {}) {
  return (name) => viewport2[name] !== prevViewport[name];
}
const gestureAnimations = {
  inView: {
    Feature: InViewFeature2
  },
  tap: {
    Feature: PressGesture2
  },
  focus: {
    Feature: FocusGesture2
  },
  hover: {
    Feature: HoverGesture2
  }
};
const layout = {
  layout: {
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
};
const MotionConfigContext = createContext({
  transformPagePoint: (p) => p,
  isStatic: false,
  reducedMotion: "never"
});
const MotionContext = createContext({});
const isBrowser = typeof window !== "undefined";
const useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;
const LazyContext = createContext({ strict: false });
let scheduleHandoffComplete = false;
function useVisualElement(Component2, visualState, props, createVisualElement, ProjectionNodeConstructor) {
  var _a;
  const { visualElement: parent } = useContext(MotionContext);
  const lazyContext = useContext(LazyContext);
  const presenceContext = useContext(PresenceContext);
  const reducedMotionConfig = useContext(MotionConfigContext).reducedMotion;
  const visualElementRef = useRef();
  createVisualElement = createVisualElement || lazyContext.renderer;
  if (!visualElementRef.current && createVisualElement) {
    visualElementRef.current = createVisualElement(Component2, {
      visualState,
      parent,
      props,
      presenceContext,
      blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
      reducedMotionConfig
    });
  }
  const visualElement = visualElementRef.current;
  const initialLayoutGroupConfig = useContext(SwitchLayoutGroupContext);
  if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) {
    createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
  }
  useInsertionEffect$1(() => {
    visualElement && visualElement.update(props, presenceContext);
  });
  const optimisedAppearId = props[optimizedAppearDataAttribute];
  const wantsHandoff = useRef(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete && ((_a = window.MotionHasOptimisedAnimation) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)));
  useIsomorphicLayoutEffect(() => {
    if (!visualElement)
      return;
    visualElement.updateFeatures();
    microtask.render(visualElement.render);
    if (wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
  });
  useEffect(() => {
    if (!visualElement)
      return;
    if (!wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
    wantsHandoff.current = false;
    if (!scheduleHandoffComplete) {
      scheduleHandoffComplete = true;
      queueMicrotask(completeHandoff);
    }
  });
  return visualElement;
}
function completeHandoff() {
  window.MotionHandoffIsComplete = true;
}
function createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
  const { layoutId, layout: layout2, drag: drag2, dragConstraints, layoutScroll, layoutRoot } = props;
  visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? void 0 : getClosestProjectingNode(visualElement.parent));
  visualElement.projection.setOptions({
    layoutId,
    layout: layout2,
    alwaysMeasureLayout: Boolean(drag2) || dragConstraints && isRefObject(dragConstraints),
    visualElement,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof layout2 === "string" ? layout2 : "both",
    initialPromotionConfig,
    layoutScroll,
    layoutRoot
  });
}
function getClosestProjectingNode(visualElement) {
  if (!visualElement)
    return void 0;
  return visualElement.options.allowProjection !== false ? visualElement.projection : getClosestProjectingNode(visualElement.parent);
}
function useMotionRef(visualState, visualElement, externalRef) {
  return useCallback(
    (instance) => {
      instance && visualState.mount && visualState.mount(instance);
      if (visualElement) {
        if (instance) {
          visualElement.mount(instance);
        } else {
          visualElement.unmount();
        }
      }
      if (externalRef) {
        if (typeof externalRef === "function") {
          externalRef(instance);
        } else if (isRefObject(externalRef)) {
          externalRef.current = instance;
        }
      }
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]
  );
}
function isControllingVariants(props) {
  return isAnimationControls(props.animate) || variantProps.some((name) => isVariantLabel(props[name]));
}
function isVariantNode(props) {
  return Boolean(isControllingVariants(props) || props.variants);
}
function getCurrentTreeVariants(props, context) {
  if (isControllingVariants(props)) {
    const { initial, animate } = props;
    return {
      initial: initial === false || isVariantLabel(initial) ? initial : void 0,
      animate: isVariantLabel(animate) ? animate : void 0
    };
  }
  return props.inherit !== false ? context : {};
}
function useCreateMotionContext(props) {
  const { initial, animate } = getCurrentTreeVariants(props, useContext(MotionContext));
  return useMemo(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
  return Array.isArray(prop) ? prop.join(" ") : prop;
}
const featureProps = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
const featureDefinitions = {};
for (const key in featureProps) {
  featureDefinitions[key] = {
    isEnabled: (props) => featureProps[key].some((name) => !!props[name])
  };
}
function loadFeatures(features) {
  for (const key in features) {
    featureDefinitions[key] = __spreadValues(__spreadValues({}, featureDefinitions[key]), features[key]);
  }
}
const motionComponentSymbol = Symbol.for("motionComponentSymbol");
function createRendererMotionComponent({ preloadedFeatures: preloadedFeatures2, createVisualElement, useRender, useVisualState, Component: Component2 }) {
  preloadedFeatures2 && loadFeatures(preloadedFeatures2);
  function MotionComponent(props, externalRef) {
    let MeasureLayout2;
    const configAndProps = __spreadProps(__spreadValues(__spreadValues({}, useContext(MotionConfigContext)), props), {
      layoutId: useLayoutId(props)
    });
    const { isStatic } = configAndProps;
    const context = useCreateMotionContext(props);
    const visualState = useVisualState(props, isStatic);
    if (!isStatic && isBrowser) {
      useStrictMode(configAndProps, preloadedFeatures2);
      const layoutProjection = getProjectionFunctionality(configAndProps);
      MeasureLayout2 = layoutProjection.MeasureLayout;
      context.visualElement = useVisualElement(Component2, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
    }
    return jsxs(MotionContext.Provider, { value: context, children: [MeasureLayout2 && context.visualElement ? jsx(MeasureLayout2, __spreadValues({ visualElement: context.visualElement }, configAndProps)) : null, useRender(Component2, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)] });
  }
  const ForwardRefMotionComponent = forwardRef(MotionComponent);
  ForwardRefMotionComponent[motionComponentSymbol] = Component2;
  return ForwardRefMotionComponent;
}
function useLayoutId({ layoutId }) {
  const layoutGroupId = useContext(LayoutGroupContext).id;
  return layoutGroupId && layoutId !== void 0 ? layoutGroupId + "-" + layoutId : layoutId;
}
function useStrictMode(configAndProps, preloadedFeatures2) {
  const isStrict = useContext(LazyContext).strict;
  if (process.env.NODE_ENV !== "production" && preloadedFeatures2 && isStrict) {
    const strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    configAndProps.ignoreStrict ? warning(false, strictMessage) : invariant(false, strictMessage);
  }
}
function getProjectionFunctionality(props) {
  const { drag: drag2, layout: layout2 } = featureDefinitions;
  if (!drag2 && !layout2)
    return {};
  const combined = __spreadValues(__spreadValues({}, drag2), layout2);
  return {
    MeasureLayout: (drag2 === null || drag2 === void 0 ? void 0 : drag2.isEnabled(props)) || (layout2 === null || layout2 === void 0 ? void 0 : layout2.isEnabled(props)) ? combined.MeasureLayout : void 0,
    ProjectionNode: combined.ProjectionNode
  };
}
const lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function isSVGComponent(Component2) {
  if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component2 !== "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    Component2.includes("-")
  ) {
    return false;
  } else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements.indexOf(Component2) > -1 || /**
     * If it contains a capital letter, it's an SVG component
     */
    /[A-Z]/u.test(Component2)
  ) {
    return true;
  }
  return false;
}
function renderHTML(element, { style: style2, vars }, styleProp, projection) {
  Object.assign(element.style, style2, projection && projection.getProjectionStyles(styleProp));
  for (const key in vars) {
    element.style.setProperty(key, vars[key]);
  }
}
const camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function renderSVG(element, renderState, _styleProp, projection) {
  renderHTML(element, renderState, void 0, projection);
  for (const key in renderState.attrs) {
    element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
  }
}
function isForcedMotionValue(key, { layout: layout2, layoutId }) {
  return transformProps.has(key) || key.startsWith("origin") || (layout2 || layoutId !== void 0) && (!!scaleCorrectors[key] || key === "opacity");
}
function scrapeMotionValuesFromProps$1(props, prevProps, visualElement) {
  var _a;
  const { style: style2 } = props;
  const newValues = {};
  for (const key in style2) {
    if (isMotionValue(style2[key]) || prevProps.style && isMotionValue(prevProps.style[key]) || isForcedMotionValue(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== void 0) {
      newValues[key] = style2[key];
    }
  }
  if (visualElement && style2 && typeof style2.willChange === "string") {
    visualElement.applyWillChange = false;
  }
  return newValues;
}
function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
  const newValues = scrapeMotionValuesFromProps$1(props, prevProps, visualElement);
  for (const key in props) {
    if (isMotionValue(props[key]) || isMotionValue(prevProps[key])) {
      const targetKey = transformPropOrder.indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
      newValues[targetKey] = props[key];
    }
  }
  return newValues;
}
function useConstant(init2) {
  const ref = useRef(null);
  if (ref.current === null) {
    ref.current = init2();
  }
  return ref.current;
}
function makeState({ applyWillChange = false, scrapeMotionValuesFromProps: scrapeMotionValuesFromProps2, createRenderState, onMount }, props, context, presenceContext, isStatic) {
  const state = {
    latestValues: makeLatestValues(props, context, presenceContext, isStatic ? false : applyWillChange, scrapeMotionValuesFromProps2),
    renderState: createRenderState()
  };
  if (onMount) {
    state.mount = (instance) => onMount(props, instance, state);
  }
  return state;
}
const makeUseVisualState = (config2) => (props, isStatic) => {
  const context = useContext(MotionContext);
  const presenceContext = useContext(PresenceContext);
  const make = () => makeState(config2, props, context, presenceContext, isStatic);
  return isStatic ? make() : useConstant(make);
};
function addWillChange(willChange, name) {
  const memberName = getWillChangeName(name);
  if (memberName) {
    addUniqueItem(willChange, memberName);
  }
}
function forEachDefinition(props, definition, callback) {
  const list = Array.isArray(definition) ? definition : [definition];
  for (let i = 0; i < list.length; i++) {
    const resolved = resolveVariantFromProps(props, list[i]);
    if (resolved) {
      const _a = resolved, { transitionEnd, transition } = _a, target = __objRest(_a, ["transitionEnd", "transition"]);
      callback(target, transitionEnd);
    }
  }
}
function makeLatestValues(props, context, presenceContext, shouldApplyWillChange, scrapeMotionValues) {
  var _a;
  const values2 = {};
  const willChange = [];
  const applyWillChange = shouldApplyWillChange && ((_a = props.style) === null || _a === void 0 ? void 0 : _a.willChange) === void 0;
  const motionValues = scrapeMotionValues(props, {});
  for (const key in motionValues) {
    values2[key] = resolveMotionValue(motionValues[key]);
  }
  let { initial, animate } = props;
  const isControllingVariants$12 = isControllingVariants(props);
  const isVariantNode$12 = isVariantNode(props);
  if (context && isVariantNode$12 && !isControllingVariants$12 && props.inherit !== false) {
    if (initial === void 0)
      initial = context.initial;
    if (animate === void 0)
      animate = context.animate;
  }
  let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
  isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
  const variantToSet = isInitialAnimationBlocked ? animate : initial;
  if (variantToSet && typeof variantToSet !== "boolean" && !isAnimationControls(variantToSet)) {
    forEachDefinition(props, variantToSet, (target, transitionEnd) => {
      for (const key in target) {
        let valueTarget = target[key];
        if (Array.isArray(valueTarget)) {
          const index2 = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
          valueTarget = valueTarget[index2];
        }
        if (valueTarget !== null) {
          values2[key] = valueTarget;
        }
      }
      for (const key in transitionEnd) {
        values2[key] = transitionEnd[key];
      }
    });
  }
  if (applyWillChange) {
    if (animate && initial !== false && !isAnimationControls(animate)) {
      forEachDefinition(props, animate, (target) => {
        for (const key in target) {
          addWillChange(willChange, key);
        }
      });
    }
    if (willChange.length) {
      values2.willChange = willChange.join(",");
    }
  }
  return values2;
}
const createHtmlRenderState = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
const createSvgRenderState = () => __spreadProps(__spreadValues({}, createHtmlRenderState()), {
  attrs: {}
});
const getValueAsType = (value, type) => {
  return type && typeof value === "number" ? type.transform(value) : value;
};
const translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
const numTransforms = transformPropOrder.length;
function buildTransform(latestValues, transform, transformTemplate) {
  let transformString = "";
  let transformIsDefault = true;
  for (let i = 0; i < numTransforms; i++) {
    const key = transformPropOrder[i];
    const value = latestValues[key];
    if (value === void 0)
      continue;
    let valueIsDefault = true;
    if (typeof value === "number") {
      valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
    } else {
      valueIsDefault = parseFloat(value) === 0;
    }
    if (!valueIsDefault || transformTemplate) {
      const valueAsType = getValueAsType(value, numberValueTypes[key]);
      if (!valueIsDefault) {
        transformIsDefault = false;
        const transformName = translateAlias[key] || key;
        transformString += `${transformName}(${valueAsType}) `;
      }
      if (transformTemplate) {
        transform[key] = valueAsType;
      }
    }
  }
  transformString = transformString.trim();
  if (transformTemplate) {
    transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
  } else if (transformIsDefault) {
    transformString = "none";
  }
  return transformString;
}
function buildHTMLStyles(state, latestValues, transformTemplate) {
  const { style: style2, vars, transformOrigin } = state;
  let hasTransform2 = false;
  let hasTransformOrigin = false;
  for (const key in latestValues) {
    const value = latestValues[key];
    if (transformProps.has(key)) {
      hasTransform2 = true;
      continue;
    } else if (isCSSVariableName(key)) {
      vars[key] = value;
      continue;
    } else {
      const valueAsType = getValueAsType(value, numberValueTypes[key]);
      if (key.startsWith("origin")) {
        hasTransformOrigin = true;
        transformOrigin[key] = valueAsType;
      } else {
        style2[key] = valueAsType;
      }
    }
  }
  if (!latestValues.transform) {
    if (hasTransform2 || transformTemplate) {
      style2.transform = buildTransform(latestValues, state.transform, transformTemplate);
    } else if (style2.transform) {
      style2.transform = "none";
    }
  }
  if (hasTransformOrigin) {
    const { originX = "50%", originY = "50%", originZ = 0 } = transformOrigin;
    style2.transformOrigin = `${originX} ${originY} ${originZ}`;
  }
}
function calcOrigin(origin, offset2, size) {
  return typeof origin === "string" ? origin : px.transform(offset2 + size * origin);
}
function calcSVGTransformOrigin(dimensions, originX, originY) {
  const pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
  const pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
  return `${pxOriginX} ${pxOriginY}`;
}
const dashKeys = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
};
const camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(attrs, length2, spacing = 1, offset2 = 0, useDashCase = true) {
  attrs.pathLength = 1;
  const keys = useDashCase ? dashKeys : camelKeys;
  attrs[keys.offset] = px.transform(-offset2);
  const pathLength = px.transform(length2);
  const pathSpacing = px.transform(spacing);
  attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}
function buildSVGAttrs(state, _ta, isSVGTag2, transformTemplate) {
  var _ua = _ta, {
    attrX,
    attrY,
    attrScale,
    originX,
    originY,
    pathLength,
    pathSpacing = 1,
    pathOffset = 0
  } = _ua, latest = __objRest(_ua, [
    "attrX",
    "attrY",
    "attrScale",
    "originX",
    "originY",
    "pathLength",
    "pathSpacing",
    "pathOffset"
  ]);
  buildHTMLStyles(state, latest, transformTemplate);
  if (isSVGTag2) {
    if (state.style.viewBox) {
      state.attrs.viewBox = state.style.viewBox;
    }
    return;
  }
  state.attrs = state.style;
  state.style = {};
  const { attrs, style: style2, dimensions } = state;
  if (attrs.transform) {
    if (dimensions)
      style2.transform = attrs.transform;
    delete attrs.transform;
  }
  if (dimensions && (originX !== void 0 || originY !== void 0 || style2.transform)) {
    style2.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== void 0 ? originX : 0.5, originY !== void 0 ? originY : 0.5);
  }
  if (attrX !== void 0)
    attrs.x = attrX;
  if (attrY !== void 0)
    attrs.y = attrY;
  if (attrScale !== void 0)
    attrs.scale = attrScale;
  if (pathLength !== void 0) {
    buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
  }
}
const isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";
const svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps,
    createRenderState: createSvgRenderState,
    onMount: (props, instance, { renderState, latestValues }) => {
      frame.read(() => {
        try {
          renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
        } catch (e2) {
          renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      });
      frame.render(() => {
        buildSVGAttrs(renderState, latestValues, isSVGTag(instance.tagName), props.transformTemplate);
        renderSVG(instance, renderState);
      });
    }
  })
};
const htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    applyWillChange: true,
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    createRenderState: createHtmlRenderState
  })
};
function copyRawValuesOnly(target, source, props) {
  for (const key in source) {
    if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
      target[key] = source[key];
    }
  }
}
function useInitialMotionValues({ transformTemplate }, visualState) {
  return useMemo(() => {
    const state = createHtmlRenderState();
    buildHTMLStyles(state, visualState, transformTemplate);
    return Object.assign({}, state.vars, state.style);
  }, [visualState]);
}
function useStyle(props, visualState) {
  const styleProp = props.style || {};
  const style2 = {};
  copyRawValuesOnly(style2, styleProp, props);
  Object.assign(style2, useInitialMotionValues(props, visualState));
  return style2;
}
function useHTMLProps(props, visualState) {
  const htmlProps = {};
  const style2 = useStyle(props, visualState);
  if (props.drag && props.dragListener !== false) {
    htmlProps.draggable = false;
    style2.userSelect = style2.WebkitUserSelect = style2.WebkitTouchCallout = "none";
    style2.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
  }
  if (props.tabIndex === void 0 && (props.onTap || props.onTapStart || props.whileTap)) {
    htmlProps.tabIndex = 0;
  }
  htmlProps.style = style2;
  return htmlProps;
}
const validMotionProps = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function isValidMotionProp(key) {
  return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || validMotionProps.has(key);
}
let shouldForward = (key) => !isValidMotionProp(key);
function loadExternalIsValidProp(isValidProp) {
  if (!isValidProp)
    return;
  shouldForward = (key) => key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
}
try {
  loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
} catch (_a) {
}
function filterProps(props, isDom, forwardMotionProps) {
  const filteredProps = {};
  for (const key in props) {
    if (key === "values" && typeof props.values === "object")
      continue;
    if (shouldForward(key) || forwardMotionProps === true && isValidMotionProp(key) || !isDom && !isValidMotionProp(key) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) {
      filteredProps[key] = props[key];
    }
  }
  return filteredProps;
}
function useSVGProps(props, visualState, _isStatic, Component2) {
  const visualProps = useMemo(() => {
    const state = createSvgRenderState();
    buildSVGAttrs(state, visualState, isSVGTag(Component2), props.transformTemplate);
    return __spreadProps(__spreadValues({}, state.attrs), {
      style: __spreadValues({}, state.style)
    });
  }, [visualState]);
  if (props.style) {
    const rawStyles = {};
    copyRawValuesOnly(rawStyles, props.style, props);
    visualProps.style = __spreadValues(__spreadValues({}, rawStyles), visualProps.style);
  }
  return visualProps;
}
function createUseRender(forwardMotionProps = false) {
  const useRender = (Component2, props, ref, { latestValues }, isStatic) => {
    const useVisualProps = isSVGComponent(Component2) ? useSVGProps : useHTMLProps;
    const visualProps = useVisualProps(props, latestValues, isStatic, Component2);
    const filteredProps = filterProps(props, typeof Component2 === "string", forwardMotionProps);
    const elementProps = Component2 !== Fragment$1 ? __spreadProps(__spreadValues(__spreadValues({}, filteredProps), visualProps), { ref }) : {};
    const { children } = props;
    const renderedChildren = useMemo(() => isMotionValue(children) ? children.get() : children, [children]);
    return createElement(Component2, __spreadProps(__spreadValues({}, elementProps), {
      children: renderedChildren
    }));
  };
  return useRender;
}
function createMotionComponentFactory(preloadedFeatures2, createVisualElement) {
  return function createMotionComponent2(Component2, { forwardMotionProps } = { forwardMotionProps: false }) {
    const baseConfig = isSVGComponent(Component2) ? svgMotionConfig : htmlMotionConfig;
    const config2 = __spreadProps(__spreadValues({}, baseConfig), {
      preloadedFeatures: preloadedFeatures2,
      useRender: createUseRender(forwardMotionProps),
      createVisualElement,
      Component: Component2
    });
    return createRendererMotionComponent(config2);
  };
}
const prefersReducedMotion = { current: null };
const hasReducedMotionListener = { current: false };
function initPrefersReducedMotion() {
  hasReducedMotionListener.current = true;
  if (!isBrowser)
    return;
  if (window.matchMedia) {
    const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
    const setReducedMotionPreferences = () => prefersReducedMotion.current = motionMediaQuery.matches;
    motionMediaQuery.addListener(setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion.current = false;
  }
}
function updateMotionValuesFromProps(element, next2, prev2) {
  for (const key in next2) {
    const nextValue = next2[key];
    const prevValue = prev2[key];
    if (isMotionValue(nextValue)) {
      element.addValue(key, nextValue);
      if (process.env.NODE_ENV === "development") {
        warnOnce(nextValue.version === "11.5.6", `Attempting to mix Framer Motion versions ${nextValue.version} with 11.5.6 may not work as expected.`);
      }
    } else if (isMotionValue(prevValue)) {
      element.addValue(key, motionValue(nextValue, { owner: element }));
    } else if (prevValue !== nextValue) {
      if (element.hasValue(key)) {
        const existingValue = element.getValue(key);
        if (existingValue.liveStyle === true) {
          existingValue.jump(nextValue);
        } else if (!existingValue.hasAnimated) {
          existingValue.set(nextValue);
        }
      } else {
        const latestValue = element.getStaticValue(key);
        element.addValue(key, motionValue(latestValue !== void 0 ? latestValue : nextValue, { owner: element }));
      }
    }
  }
  for (const key in prev2) {
    if (next2[key] === void 0)
      element.removeValue(key);
  }
  return next2;
}
const visualElementStore = /* @__PURE__ */ new WeakMap();
const valueTypes = [...dimensionValueTypes, color, complex];
const findValueType = (v) => valueTypes.find(testValueType(v));
const propEventHandlers = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class VisualElement2 {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
    return {};
  }
  constructor({ parent, props, presenceContext, reducedMotionConfig, blockInitialAnimation, visualState }, options = {}) {
    this.applyWillChange = false;
    this.current = null;
    this.children = /* @__PURE__ */ new Set();
    this.isVariantNode = false;
    this.isControllingVariants = false;
    this.shouldReduceMotion = null;
    this.values = /* @__PURE__ */ new Map();
    this.KeyframeResolver = KeyframeResolver;
    this.features = {};
    this.valueSubscriptions = /* @__PURE__ */ new Map();
    this.prevMotionValues = {};
    this.events = {};
    this.propEventSubscriptions = {};
    this.notifyUpdate = () => this.notify("Update", this.latestValues);
    this.render = () => {
      if (!this.current)
        return;
      this.triggerBuild();
      this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
    };
    this.renderScheduledAt = 0;
    this.scheduleRender = () => {
      const now2 = time.now();
      if (this.renderScheduledAt < now2) {
        this.renderScheduledAt = now2;
        frame.render(this.render, false, true);
      }
    };
    const { latestValues, renderState } = visualState;
    this.latestValues = latestValues;
    this.baseTarget = __spreadValues({}, latestValues);
    this.initialValues = props.initial ? __spreadValues({}, latestValues) : {};
    this.renderState = renderState;
    this.parent = parent;
    this.props = props;
    this.presenceContext = presenceContext;
    this.depth = parent ? parent.depth + 1 : 0;
    this.reducedMotionConfig = reducedMotionConfig;
    this.options = options;
    this.blockInitialAnimation = Boolean(blockInitialAnimation);
    this.isControllingVariants = isControllingVariants(props);
    this.isVariantNode = isVariantNode(props);
    if (this.isVariantNode) {
      this.variantChildren = /* @__PURE__ */ new Set();
    }
    this.manuallyAnimateOnMount = Boolean(parent && parent.current);
    const _a = this.scrapeMotionValuesFromProps(props, {}, this), { willChange } = _a, initialMotionValues = __objRest(_a, ["willChange"]);
    for (const key in initialMotionValues) {
      const value = initialMotionValues[key];
      if (latestValues[key] !== void 0 && isMotionValue(value)) {
        value.set(latestValues[key], false);
      }
    }
  }
  mount(instance) {
    this.current = instance;
    visualElementStore.set(instance, this);
    if (this.projection && !this.projection.instance) {
      this.projection.mount(instance);
    }
    if (this.parent && this.isVariantNode && !this.isControllingVariants) {
      this.removeFromVariantTree = this.parent.addVariantChild(this);
    }
    this.values.forEach((value, key) => this.bindToMotionValue(key, value));
    if (!hasReducedMotionListener.current) {
      initPrefersReducedMotion();
    }
    this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : prefersReducedMotion.current;
    if (process.env.NODE_ENV !== "production") {
      warnOnce(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
    }
    if (this.parent)
      this.parent.children.add(this);
    this.update(this.props, this.presenceContext);
  }
  unmount() {
    visualElementStore.delete(this.current);
    this.projection && this.projection.unmount();
    cancelFrame(this.notifyUpdate);
    cancelFrame(this.render);
    this.valueSubscriptions.forEach((remove) => remove());
    this.valueSubscriptions.clear();
    this.removeFromVariantTree && this.removeFromVariantTree();
    this.parent && this.parent.children.delete(this);
    for (const key in this.events) {
      this.events[key].clear();
    }
    for (const key in this.features) {
      const feature = this.features[key];
      if (feature) {
        feature.unmount();
        feature.isMounted = false;
      }
    }
    this.current = null;
  }
  bindToMotionValue(key, value) {
    if (this.valueSubscriptions.has(key)) {
      this.valueSubscriptions.get(key)();
    }
    const valueIsTransform = transformProps.has(key);
    const removeOnChange = value.on("change", (latestValue) => {
      this.latestValues[key] = latestValue;
      this.props.onUpdate && frame.preRender(this.notifyUpdate);
      if (valueIsTransform && this.projection) {
        this.projection.isTransformDirty = true;
      }
    });
    const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
    let removeSyncCheck;
    if (window.MotionCheckAppearSync) {
      removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
    }
    this.valueSubscriptions.set(key, () => {
      removeOnChange();
      removeOnRenderRequest();
      if (removeSyncCheck)
        removeSyncCheck();
      if (value.owner)
        value.stop();
    });
  }
  sortNodePosition(other) {
    if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) {
      return 0;
    }
    return this.sortInstanceNodePosition(this.current, other.current);
  }
  updateFeatures() {
    let key = "animation";
    for (key in featureDefinitions) {
      const featureDefinition = featureDefinitions[key];
      if (!featureDefinition)
        continue;
      const { isEnabled, Feature: FeatureConstructor } = featureDefinition;
      if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) {
        this.features[key] = new FeatureConstructor(this);
      }
      if (this.features[key]) {
        const feature = this.features[key];
        if (feature.isMounted) {
          feature.update();
        } else {
          feature.mount();
          feature.isMounted = true;
        }
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
  }
  getStaticValue(key) {
    return this.latestValues[key];
  }
  setStaticValue(key, value) {
    this.latestValues[key] = value;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(props, presenceContext) {
    if (props.transformTemplate || this.props.transformTemplate) {
      this.scheduleRender();
    }
    this.prevProps = this.props;
    this.props = props;
    this.prevPresenceContext = this.presenceContext;
    this.presenceContext = presenceContext;
    for (let i = 0; i < propEventHandlers.length; i++) {
      const key = propEventHandlers[i];
      if (this.propEventSubscriptions[key]) {
        this.propEventSubscriptions[key]();
        delete this.propEventSubscriptions[key];
      }
      const listenerName = "on" + key;
      const listener = props[listenerName];
      if (listener) {
        this.propEventSubscriptions[key] = this.on(key, listener);
      }
    }
    this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
    if (this.handleChildMotionValue) {
      this.handleChildMotionValue();
    }
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(name) {
    return this.props.variants ? this.props.variants[name] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(child) {
    const closestVariantNode = this.getClosestVariantNode();
    if (closestVariantNode) {
      closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
      return () => closestVariantNode.variantChildren.delete(child);
    }
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(key, value) {
    const existingValue = this.values.get(key);
    if (value !== existingValue) {
      if (existingValue)
        this.removeValue(key);
      this.bindToMotionValue(key, value);
      this.values.set(key, value);
      this.latestValues[key] = value.get();
    }
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(key) {
    this.values.delete(key);
    const unsubscribe = this.valueSubscriptions.get(key);
    if (unsubscribe) {
      unsubscribe();
      this.valueSubscriptions.delete(key);
    }
    delete this.latestValues[key];
    this.removeValueFromRenderState(key, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(key) {
    return this.values.has(key);
  }
  getValue(key, defaultValue2) {
    if (this.props.values && this.props.values[key]) {
      return this.props.values[key];
    }
    let value = this.values.get(key);
    if (value === void 0 && defaultValue2 !== void 0) {
      value = motionValue(defaultValue2 === null ? void 0 : defaultValue2, { owner: this });
      this.addValue(key, value);
    }
    return value;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(key, target) {
    var _a;
    let value = this.latestValues[key] !== void 0 || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    if (value !== void 0 && value !== null) {
      if (typeof value === "string" && (isNumericalString(value) || isZeroValueString(value))) {
        value = parseFloat(value);
      } else if (!findValueType(value) && complex.test(target)) {
        value = getAnimatableNone(key, target);
      }
      this.setBaseTarget(key, isMotionValue(value) ? value.get() : value);
    }
    return isMotionValue(value) ? value.get() : value;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(key, value) {
    this.baseTarget[key] = value;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(key) {
    var _a;
    const { initial } = this.props;
    let valueFromInitial;
    if (typeof initial === "string" || typeof initial === "object") {
      const variant = resolveVariantFromProps(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
      if (variant) {
        valueFromInitial = variant[key];
      }
    }
    if (initial && valueFromInitial !== void 0) {
      return valueFromInitial;
    }
    const target = this.getBaseTargetFromProps(this.props, key);
    if (target !== void 0 && !isMotionValue(target))
      return target;
    return this.initialValues[key] !== void 0 && valueFromInitial === void 0 ? void 0 : this.baseTarget[key];
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager2();
    }
    return this.events[eventName].add(callback);
  }
  notify(eventName, ...args) {
    if (this.events[eventName]) {
      this.events[eventName].notify(...args);
    }
  }
}
class DOMVisualElement2 extends VisualElement2 {
  constructor() {
    super(...arguments);
    this.KeyframeResolver = DOMKeyframesResolver;
  }
  sortInstanceNodePosition(a2, b) {
    return a2.compareDocumentPosition(b) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(props, key) {
    return props.style ? props.style[key] : void 0;
  }
  removeValueFromRenderState(key, { vars, style: style2 }) {
    delete vars[key];
    delete style2[key];
  }
}
function getComputedStyle$1(element) {
  return window.getComputedStyle(element);
}
class HTMLVisualElement2 extends DOMVisualElement2 {
  constructor() {
    super(...arguments);
    this.type = "html";
    this.applyWillChange = true;
    this.renderInstance = renderHTML;
  }
  readValueFromInstance(instance, key) {
    if (transformProps.has(key)) {
      const defaultType = getDefaultValueType(key);
      return defaultType ? defaultType.default || 0 : 0;
    } else {
      const computedStyle = getComputedStyle$1(instance);
      const value = (isCSSVariableName(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
      return typeof value === "string" ? value.trim() : value;
    }
  }
  measureInstanceViewportBox(instance, { transformPagePoint }) {
    return measureViewportBox(instance, transformPagePoint);
  }
  build(renderState, latestValues, props) {
    buildHTMLStyles(renderState, latestValues, props.transformTemplate);
  }
  scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    return scrapeMotionValuesFromProps$1(props, prevProps, visualElement);
  }
  handleChildMotionValue() {
    if (this.childSubscription) {
      this.childSubscription();
      delete this.childSubscription;
    }
    const { children } = this.props;
    if (isMotionValue(children)) {
      this.childSubscription = children.on("change", (latest) => {
        if (this.current)
          this.current.textContent = `${latest}`;
      });
    }
  }
}
class SVGVisualElement2 extends DOMVisualElement2 {
  constructor() {
    super(...arguments);
    this.type = "svg";
    this.isSVGTag = false;
    this.measureInstanceViewportBox = createBox;
  }
  getBaseTargetFromProps(props, key) {
    return props[key];
  }
  readValueFromInstance(instance, key) {
    if (transformProps.has(key)) {
      const defaultType = getDefaultValueType(key);
      return defaultType ? defaultType.default || 0 : 0;
    }
    key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
    return instance.getAttribute(key);
  }
  scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    return scrapeMotionValuesFromProps(props, prevProps, visualElement);
  }
  build(renderState, latestValues, props) {
    buildSVGAttrs(renderState, latestValues, this.isSVGTag, props.transformTemplate);
  }
  renderInstance(instance, renderState, styleProp, projection) {
    renderSVG(instance, renderState, styleProp, projection);
  }
  mount(instance) {
    this.isSVGTag = isSVGTag(instance.tagName);
    super.mount(instance);
  }
}
const createDomVisualElement = (Component2, options) => {
  return isSVGComponent(Component2) ? new SVGVisualElement2(options) : new HTMLVisualElement2(options, {
    allowProjection: Component2 !== Fragment$1
  });
};
const createMotionComponent = /* @__PURE__ */ createMotionComponentFactory(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, animations), gestureAnimations), drag), layout), createDomVisualElement);
const motion = /* @__PURE__ */ createDOMMotionComponentProxy(createMotionComponent);
const CardContainer = forwardRef((_va, ref) => {
  var _wa = _va, {
    className,
    children,
    onClick,
    rightCol,
    hasExtraPadding,
    hasBorder = true,
    hasAnimation
  } = _wa, rest = __objRest(_wa, [
    "className",
    "children",
    "onClick",
    "rightCol",
    "hasExtraPadding",
    "hasBorder",
    "hasAnimation"
  ]);
  const [isInitialLoad, setIsInitialLoad] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setIsInitialLoad(true);
    }, 500);
  }, []);
  const commonProps = __spreadValues(__spreadProps(__spreadValues({
    ref
  }, onClick ? {
    role: "button",
    onClick
  } : {}), {
    className: `relative overflow-hidden rounded-2xl p-4 flex items-start gap-6 w-full CardContainer-container bg-white justify-between ${hasExtraPadding ? "p-8" : ""} ${hasBorder ? " border-2 border-gray-200" : ""} ${className}`
  }), rest);
  const animateProps = hasAnimation ? {
    animate: {
      scale: 1,
      transition: {
        delay: 0.3,
        type: "spring"
      }
    },
    exit: {
      opacity: 0,
      transition: {
        delay: 0.5
      }
    },
    layout: true
  } : {};
  const Tag = isInitialLoad && hasAnimation ? motion.div : "div";
  return (
    // @ts-expect-error
    /* @__PURE__ */ jsxs(Tag, __spreadProps(__spreadValues(__spreadValues({}, commonProps), animateProps), { children: [
      /* @__PURE__ */ jsx("div", { className: "flex flex-col items-start gap-4 w-full justify-between flex-1 self-stretch", children }),
      rightCol && /* @__PURE__ */ jsx("div", { className: `hidden sm:block self-center`, children: rightCol })
    ] }))
  );
});
CardContainer.displayName = "CardContainer";
const AnimatedButton = (_xa) => {
  var _ya = _xa, {
    children,
    isLoading,
    className,
    disabled
  } = _ya, rest = __objRest(_ya, [
    "children",
    "isLoading",
    "className",
    "disabled"
  ]);
  const buttonRef = useRef(null);
  const handleMouseMove = (e2) => {
    var _a, _b, _c;
    const rect = (_a = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _a.getBoundingClientRect();
    if (rect) {
      const x2 = e2.clientX - rect.left;
      const y = e2.clientY - rect.top;
      (_b = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _b.style.setProperty("--x", x2 + "px");
      (_c = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _c.style.setProperty("--y", y + "px");
    }
  };
  return /* @__PURE__ */ jsx(Button, __spreadProps(__spreadValues({ onMouseMove: handleMouseMove, ref: buttonRef, style: {
    backgroundImage: "none"
  }, className: `focus:text-white transition relative rounded-3xl text-base font-bold w-full outline-0 ${disabled || isLoading ? "" : "bg-black text-white hover:text-white animate-button claim-button"} ${className} `, disabled: disabled || isLoading }, rest), { children }));
};
const CardButton = (_za) => {
  var props = __objRest(_za, []);
  return /* @__PURE__ */ jsx(AnimatedButton, __spreadValues({}, props));
};
const LearnMoreModal = ({
  onClose,
  isOpen,
  children
}) => {
  return /* @__PURE__ */ jsx(Modal2, { showCloseIcon: true, onClose, isOpen, children });
};
const CardHeader = ({
  title,
  text,
  remainingDays,
  isClaimable,
  isFeatured,
  showLearnMoreText
}) => {
  const [isLearnMoreOpen, setIsLearnMoreOpen] = useState(false);
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1 w-full flex-1", children: [
    showLearnMoreText && /* @__PURE__ */ jsx(LearnMoreModal, { isOpen: isLearnMoreOpen, onClose: () => {
      setIsLearnMoreOpen(false);
    }, children: /* @__PURE__ */ jsx("div", { className: "gap-4 flex flex-col text-disabledGray mb-6 mt-6", dangerouslySetInnerHTML: {
      __html: showLearnMoreText
    } }) }),
    remainingDays ? /* @__PURE__ */ jsx(CardTimer, { isClaimable, remainingDays }) : null,
    /* @__PURE__ */ jsx("h3", { className: `${isFeatured ? "text-3xl" : "text-xl"} font-medium text-black`, children: title }),
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("p", { className: `inline ${isFeatured ? "text-xl" : "text-base"} text-disabledGray show-html`, dangerouslySetInnerHTML: {
        __html: text
      } }),
      showLearnMoreText ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("button", { onClick: () => {
        setIsLearnMoreOpen(true);
      }, className: `shadow-none	ml-1 gap-1 text-left items-center inline-flex ${isFeatured ? "text-xl" : "text-base"} text-disabledGray `, children: [
        "Learn more ",
        /* @__PURE__ */ jsx(Info, { className: "inline" })
      ] }) }) : ""
    ] })
  ] });
};
const CardProgress = ({
  progress: progress2,
  total
}) => {
  const widthPercentage = `${progress2 / total * 100}%`;
  return /* @__PURE__ */ jsx("div", { className: "flex flex-col w-full gap-y-2", children: /* @__PURE__ */ jsx("div", { className: "w-full bg-gray-200 rounded-full h-3 mb-1 shadow-inner", children: /* @__PURE__ */ jsx("div", { className: "bg-black h-3 rounded-full", style: {
    width: widthPercentage
  } }) }) });
};
const CardTimer = ({
  remainingDays,
  isClaimable
}) => {
  return /* @__PURE__ */ jsx("div", { className: "absolute py-1.5 px-3 right-0 top-0 bg-amber-500 rounded-bl-2xl cursor-pointer", children: /* @__PURE__ */ jsx(Popper2, { placement: "top", popperStyle: "mb-2", content: /* @__PURE__ */ jsx("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx("label", { className: "text-sm", children: isClaimable ? `This Karma expires in ${remainingDays} days if not claimed` : `This event ends in ${remainingDays} days` }) }), isDark: true, children: /* @__PURE__ */ jsxs("div", { className: "flex gap-1.5 items-center", children: [
    /* @__PURE__ */ jsx(Clock, {}),
    /* @__PURE__ */ jsxs("label", { className: "text-white text-sm cursor-pointer", children: [
      remainingDays,
      " days"
    ] }),
    " "
  ] }) }) });
};
const CardInfoLine = ({
  date: date2,
  karma,
  isExpired = false
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex justify-between text-disabledGray", children: [
    /* @__PURE__ */ jsx("label", { className: "text-black", children: date2 }),
    isExpired ? /* @__PURE__ */ jsxs("div", { className: "flex gap-1.5", children: [
      /* @__PURE__ */ jsxs("span", { className: "text-black line-through opacity-35", children: [
        karma,
        " Karma"
      ] }),
      /* @__PURE__ */ jsx("span", { className: "text-orange-300", children: "Expired" })
    ] }) : /* @__PURE__ */ jsxs("span", { className: "text-black", children: [
      "+ ",
      karma,
      " Karma"
    ] })
  ] });
};
const SidebarProgress = ({
  user,
  dataTiers,
  titleSize = "text-xl",
  numClaims,
  hasBorder = true,
  onClick
}) => {
  const {
    isRefetched
  } = useContext(Context);
  const hasClaims = numClaims && numClaims > 0;
  const showButton = user.karma_points === 0 && numClaims != null;
  return /* @__PURE__ */ jsx(Popper2, { isActive: !showButton, isDark: true, popperStyle: " -mt-6", content: /* @__PURE__ */ jsx("div", { className: "flex flex-col max-w-64", children: /* @__PURE__ */ jsxs("div", { className: "text-xs leading-5", children: [
    /* @__PURE__ */ jsx("span", { children: "This is your position within your Tier." }),
    /* @__PURE__ */ jsx("br", {}),
    /* @__PURE__ */ jsx("div", { className: "bg-red-600 w-3.5 h-3.5 align-middle rounded-full inline-flex justify-center items-center", children: /* @__PURE__ */ jsx("div", { className: "rounded-full bg-white w-2 h-2" }) }),
    " ",
    /* @__PURE__ */ jsx("span", { children: "means you are close to losing your Tier." }),
    /* @__PURE__ */ jsx("br", {}),
    /* @__PURE__ */ jsx("div", { className: "bg-green-600 w-3.5 h-3.5 align-middle rounded-full inline-flex justify-center items-center", children: /* @__PURE__ */ jsx("div", { className: "rounded-full bg-white w-2 h-2" }) }),
    " ",
    /* @__PURE__ */ jsx("span", { children: "means you are close to advancing to the next Tier" })
  ] }) }), className: "w-full", children: /* @__PURE__ */ jsxs(CardContainer, { hasBorder, hasExtraPadding: hasBorder, onClick, children: [
    /* @__PURE__ */ jsx("h2", { className: `font-medium text-disabledGray ${titleSize}`, children: "Karma Score" }),
    showButton ? /* @__PURE__ */ jsx(CardButton, { children: "Claim the New Karma" }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(AnimatedNumbers, { user, isAnimated: !!isRefetched }),
      dataTiers && /* @__PURE__ */ jsx(KarmaProgress, { user, dataTiers }),
      hasClaims ? /* @__PURE__ */ jsxs("a", { href: "/karma", className: "flex items-center w-full text-black hover:text-black", children: [
        /* @__PURE__ */ jsxs("span", { className: "font-medium flex-1 text-left", children: [
          numClaims,
          " claims available"
        ] }),
        /* @__PURE__ */ jsx(RightArrow, {})
      ] }) : null
    ] })
  ] }) });
};
const SidebarProgressEmpty = ({
  hasBorder = true,
  onClick
}) => {
  return /* @__PURE__ */ jsxs(CardContainer, { onClick, hasBorder, hasExtraPadding: hasBorder, children: [
    /* @__PURE__ */ jsx("h2", { className: "text-xl font-medium text-disabledGray", children: "Karma Score" }),
    /* @__PURE__ */ jsx("p", { className: "text-5xl font-bold text-black", children: "0" })
  ] });
};
const Dashboard = ({
  entityId = "",
  apiUrl = "",
  amplitudeEvent
}) => {
  const {
    data: dataTiers
  } = useQuery({
    queryFn: () => getTiers(apiUrl),
    queryKey: `tiers`
  });
  const {
    data: dataUser,
    isLoading: isLoadingUser
  } = useQuery({
    queryFn: () => getUser(entityId, apiUrl),
    isEnabled: !!entityId,
    queryKey: `user_${entityId}`
  });
  const {
    data: dataEvent
  } = useQuery({
    queryFn: () => getEvents(entityId, apiUrl),
    isEnabled: !!entityId,
    queryKey: `event_${entityId}`
  });
  const {
    data: dataAchievement
  } = useQuery({
    queryFn: () => getAchievements(entityId, apiUrl),
    isEnabled: !!entityId,
    queryKey: `achievement_${entityId}`
  });
  const numClaims = [...dataEvent ? dataEvent.filter((event) => event.status === "claimable") : [], ...dataAchievement ? dataAchievement.filter((achievement) => achievement.status === "claimable") : []].length;
  const handleClick = () => {
    window.location.href = "/karma";
    amplitudeEvent("dash-karma");
  };
  return /* @__PURE__ */ jsx(Context.Provider, { value: {
    entityId,
    apiUrl,
    amplitudeEvent
  }, children: dataUser ? /* @__PURE__ */ jsx(SidebarProgress, { titleSize: "text-base", user: dataUser, dataTiers, numClaims, hasBorder: false, onClick: handleClick }) : isLoadingUser ? null : /* @__PURE__ */ jsx(SidebarProgressEmpty, { hasBorder: false, onClick: handleClick }) });
};
const EmptyHistory = () => {
  return /* @__PURE__ */ jsx("div", { className: "bg-zinc-50 py-12 flex flex-col items-center justify-items-center w-full gap-1.5 border border-smokeWhite-200 rounded-2xl", children: /* @__PURE__ */ jsx("p", { className: "text-quickSilver max-w-96 text-center", children: "No Karma History" }) });
};
const HistoryCard = ({
  history
}) => {
  var _a;
  const date2 = (_a = history.claimed_at) != null ? _a : history.expired_at;
  const isExpired = !!history.expired_at;
  return /* @__PURE__ */ jsxs(CardContainer, { children: [
    /* @__PURE__ */ jsx(CardHeader, { showLearnMoreText: history.learn_more_text, title: history.name, text: history.description }),
    /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-y-2 w-full", children: date2 && /* @__PURE__ */ jsx(CardInfoLine, { date: new Date(date2).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    }), karma: history.points, isExpired }) })
  ] }, `history_${history.id}`);
};
const Spinner = () => {
  return /* @__PURE__ */ jsx("div", { className: "w-full justify-center flex", children: /* @__PURE__ */ jsx("div", { className: " text-disabledGray inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]", role: "status", children: /* @__PURE__ */ jsx("span", { className: "!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]", children: "Loading..." }) }) });
};
const ViewAllButton = ({
  children,
  href,
  onClick
}) => {
  const className = "transition gap-1.5 outline-none py-1.5 px-3 items-center text-black border-gray-200 border flex justify-center bg-white rounded-3xl hover:bg-gray-100";
  return href ? /* @__PURE__ */ jsx("a", { href, className: `${className} no-underline`, children }) : /* @__PURE__ */ jsx("button", { onClick, className: `${className} button-border`, children });
};
const TOTAL_RESULTS = 9;
const HistoryLogs = ({
  entityId = "",
  apiUrl = "",
  amplitudeEvent
}) => {
  const [lastClaimedOrExpiredAt, setLastClaimedOrExpiredAt] = useState("");
  const [lastId, setLastId] = useState(null);
  const [results, setResults] = useState([]);
  const {
    data: dataHistory,
    isLoading: isLoadingHistory
  } = useQuery({
    queryFn: () => getHistory(entityId, apiUrl, TOTAL_RESULTS + 1, lastClaimedOrExpiredAt, lastId),
    isEnabled: !!entityId,
    queryKey: `history_${entityId}_${lastClaimedOrExpiredAt}_${lastId}`
  });
  useEffect(() => {
    if (dataHistory) {
      const data = dataHistory.length === TOTAL_RESULTS + 1 ? dataHistory.slice(0, dataHistory.length - 1) : dataHistory;
      const setObj = new Set([...results, ...data].map(JSON.stringify));
      const outputArray = Array.from(setObj).map(JSON.parse);
      setResults(outputArray);
    }
  }, [dataHistory]);
  const handleBackButton = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = "/";
    }
  };
  const handleOnClick = () => {
    const newLastClaimedOrExpiredAt = results[(results == null ? void 0 : results.length) - 1].claimed_or_expired_at;
    setLastClaimedOrExpiredAt(newLastClaimedOrExpiredAt);
    const newLastId = results[(results == null ? void 0 : results.length) - 1].id;
    setLastId(newLastId);
  };
  const hasMore = (dataHistory == null ? void 0 : dataHistory.length) === TOTAL_RESULTS + 1;
  return /* @__PURE__ */ jsx(Context.Provider, { value: {
    entityId,
    apiUrl,
    amplitudeEvent
  }, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-6 items-start", children: [
    /* @__PURE__ */ jsxs(ViewAllButton, { onClick: handleBackButton, children: [
      /* @__PURE__ */ jsx(RightArrow, { className: "rotate-180" }),
      " Back"
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-6 flex-1 w-full", children: [
      /* @__PURE__ */ jsx(CardHeader, { title: "History", text: "See all the Karma you’ve claimed and missed" }),
      isLoadingHistory && results.length === 0 ? /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ jsx(Spinner, {}) }) : (results == null ? void 0 : results.length) === 0 ? /* @__PURE__ */ jsx(EmptyHistory, {}) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("div", { className: "grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3", children: results == null ? void 0 : results.map((history) => {
          return /* @__PURE__ */ jsx(HistoryCard, { history }, `history_log_${history.id}`);
        }) }),
        hasMore && /* @__PURE__ */ jsx("button", { className: "text-disabledGray", onClick: handleOnClick, children: isLoadingHistory ? /* @__PURE__ */ jsx(Spinner, {}) : "Load more" })
      ] })
    ] })
  ] }) });
};
const Skeleton = ({
  className,
  number: number2 = 1
}) => {
  return number2 > 0 ? /* @__PURE__ */ jsx(Fragment, { children: Array.from(Array(number2).keys()).map((_, key) => /* @__PURE__ */ jsx("div", { className: `animate-pulse w-full bg-smokeWhite rounded-2xl ${className || ""}` }, `skeleton_${key}`)) }) : null;
};
const Milestone = ({
  title,
  subtitle,
  children,
  isLoading = false,
  rightAction,
  isEmptyState
}) => {
  const [isInitialLoad, setIsInitialLoad] = useState(false);
  useEffect(() => {
    if (!isLoading) {
      setTimeout(() => {
        setIsInitialLoad(true);
      }, 500);
    }
  }, [isLoading]);
  const Tag = isInitialLoad ? motion.div : "div";
  return /* @__PURE__ */ jsxs(Tag, { layout: true, className: "flex flex-col gap-6", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex justify-between w-full items-center", children: [
      /* @__PURE__ */ jsxs(Container, { gap: "xxs", children: [
        /* @__PURE__ */ jsx(Title, { fontSize: "md", className: "text-black", children: title }),
        /* @__PURE__ */ jsx(Subitle, { fontSize: "xs", children: subtitle })
      ] }),
      rightAction
    ] }),
    /* @__PURE__ */ jsx("div", { className: `grid gap-6 grid-cols-1 ${!isEmptyState ? "sm:grid-cols-2" : ""}`, children: isLoading ? /* @__PURE__ */ jsx(Skeleton, { number: 2, className: "h-[180px]" }) : children })
  ] });
};
const CompletedAchievements = () => {
  return /* @__PURE__ */ jsxs("div", { className: "bg-zinc-50 py-12 flex flex-col items-center justify-items-center w-full gap-1.5 border border-smokeWhite-200 rounded-2xl", children: [
    /* @__PURE__ */ jsx("div", { className: "flex gap-1.5 items-center", children: /* @__PURE__ */ jsx("label", { className: "text-base font-medium text-disabledGray", children: "Achievements Completed" }) }),
    /* @__PURE__ */ jsx("p", { className: "text-quickSilver max-w-96 text-center", children: "Continue to earn Karma for events and check back weekly so you don’t miss the next drop" })
  ] });
};
const MilestoneProgressList = ({
  maxPoints,
  points
}) => {
  return /* @__PURE__ */ jsx("div", { className: "w-full gap-y-3 flex flex-col", children: /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(CardProgress, { total: maxPoints, progress: points }),
    /* @__PURE__ */ jsxs("p", { className: "text-base text-disabledGray", children: [
      points,
      "/",
      maxPoints
    ] })
  ] }) });
};
const MilestoneCard = ({
  milestone,
  showRules = false,
  hasAnimation,
  className,
  isFeatured
}) => {
  const {
    entityId,
    apiUrl,
    csrfToken,
    refreshKarma,
    amplitudeEvent
  } = useContext(Context);
  const isClaimable = milestone.status === "claimable";
  const [isDisabled, setIsDisabled] = useState(!isClaimable);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isScaled, setIsScaled] = useState(false);
  const isTotalKarma = milestone.milestone_type === "milestone" && milestone.status === "eligible";
  const {
    mutate,
    isLoading
  } = useMutation({
    queryFn: () => claimMilestone({
      entityId,
      milestoneId: milestone.id,
      apiUrl,
      csrfToken
    }),
    onSuccess: () => {
      setIsDisabled(true);
      setIsSuccess(true);
      refreshKarma == null ? void 0 : refreshKarma({
        type: "success",
        points: milestone.points
      });
    },
    onError: () => {
      refreshKarma == null ? void 0 : refreshKarma({
        type: "error"
      });
      setIsSubmitted(false);
    }
  });
  useEffect(() => {
    setIsDisabled(!isClaimable);
  }, [milestone, isClaimable]);
  let diffInDays = 0;
  const dateField = isClaimable ? "expire_at" : "end_at";
  if (milestone[dateField]) {
    const expireAt = new Date(milestone[dateField]);
    const today = /* @__PURE__ */ new Date();
    const diffInTime = expireAt.getTime() - today.getTime();
    diffInDays = Math.ceil(diffInTime / (1e3 * 3600 * 24));
  }
  const claimPoints = isTotalKarma ? milestone.max_points : milestone.points;
  const isNotClaimableEvent = milestone.milestone_type === "time_bounded" && !isClaimable;
  const handleOnClick = () => {
    setIsSubmitted(true);
    setIsScaled(true);
    setTimeout(() => {
      setIsScaled(false);
    }, 100);
    mutate();
    amplitudeEvent("karma-claim", {
      "claimed-amount": claimPoints,
      "milestone-ID": milestone.id,
      "milestone-name": milestone.name,
      "milestone-type": milestone.milestone_type
    });
  };
  const buttonText = isNotClaimableEvent ? `Claim in ${diffInDays} days` : isSubmitted ? `+${claimPoints}` : `Claim ${claimPoints} Karma`;
  const renderCardHeader = (isFeatured2 = false) => /* @__PURE__ */ jsx(CardHeader, { isFeatured: isFeatured2, remainingDays: diffInDays, title: milestone.name, text: milestone.description, isClaimable, showLearnMoreText: milestone.learn_more_text });
  const renderCardButton = () => /* @__PURE__ */ jsx(CardButton, { isLoading: isLoading || isSuccess, disabled: isDisabled, onClick: handleOnClick, className: `transition-transform ${isScaled ? "scale-90" : "scale-100"}`, children: buttonText });
  return isFeatured ? /* @__PURE__ */ jsx(CardContainer, __spreadProps(__spreadValues({ hasAnimation, className: "min-h-60 sm:col-span-2 " }, milestone.featured_image ? {
    style: {
      backgroundImage: `url(${milestone.featured_image})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center"
    }
  } : {}), { children: /* @__PURE__ */ jsxs("div", { className: "w-full sm:w-[46%] flex flex-col items-start flex-1", children: [
    renderCardHeader(true),
    renderCardButton()
  ] }) })) : /* @__PURE__ */ jsxs(CardContainer, { hasAnimation, className, children: [
    renderCardHeader(),
    showRules && /* @__PURE__ */ jsx(MilestoneProgressList, { maxPoints: milestone.max_points, points: milestone.points }),
    renderCardButton()
  ] });
};
const Achievements = ({
  data = [],
  isLoading
}) => {
  const isEmptyState = !isLoading && (data == null ? void 0 : data.length) === 0;
  return /* @__PURE__ */ jsx(Milestone, { title: "Achievements", subtitle: "Earn Karma for completing achievements", isLoading, isEmptyState, children: isEmptyState ? /* @__PURE__ */ jsx(CompletedAchievements, {}) : /* @__PURE__ */ jsx(Fragment, { children: data == null ? void 0 : data.map((achievement) => /* @__PURE__ */ jsx(MilestoneCard, { milestone: achievement }, `achievement_${achievement.id}`)) }) });
};
const ClaimSection = ({
  data = [],
  isLoading,
  featuredData = []
}) => {
  return (data == null ? void 0 : data.length) > 0 || (featuredData == null ? void 0 : featuredData.length) > 0 ? /* @__PURE__ */ jsx(Milestone, { title: "Claims", subtitle: "Claim your Karma to increase your score", isLoading, children: /* @__PURE__ */ jsxs(Fragment, { children: [
    featuredData == null ? void 0 : featuredData.map((event) => /* @__PURE__ */ jsx(MilestoneCard, { isFeatured: true, hasAnimation: true, milestone: event }, `claims_${event.id}`)),
    data == null ? void 0 : data.map((event, key) => /* @__PURE__ */ jsx(MilestoneCard, __spreadValues({ hasAnimation: true, milestone: event }, featuredData && (featuredData == null ? void 0 : featuredData.length) > 0 && key === 0 ? {
      className: "col-start-1"
    } : {}), `claims_${event.id}`))
  ] }) }) : null;
};
const EmptyEvent = () => {
  return /* @__PURE__ */ jsxs("div", { className: "bg-zinc-50 py-12 flex flex-col items-center justify-items-center w-full gap-1.5 border border-smokeWhite-200 rounded-2xl", children: [
    /* @__PURE__ */ jsx("div", { className: "flex gap-1.5 items-center", children: /* @__PURE__ */ jsx("label", { className: "text-base font-medium text-disabledGray", children: "Events Coming Soon" }) }),
    /* @__PURE__ */ jsx("p", { className: "text-quickSilver max-w-96 text-center", children: "More Events are coming soon to Karma." })
  ] });
};
const Events = ({
  data = [],
  isLoading,
  featuredData
}) => {
  const isEmptyState = !isLoading && (data == null ? void 0 : data.length) === 0 && ((featuredData == null ? void 0 : featuredData.length) === 0 || !featuredData);
  return /* @__PURE__ */ jsx(Milestone, { title: "Events", subtitle: "Earn Karma for events happening now", isLoading, isEmptyState, children: isEmptyState ? /* @__PURE__ */ jsx(EmptyEvent, {}) : /* @__PURE__ */ jsxs(Fragment, { children: [
    featuredData == null ? void 0 : featuredData.map((event) => /* @__PURE__ */ jsx(MilestoneCard, { milestone: event, isFeatured: true }, `event_${event.id}`)),
    data == null ? void 0 : data.map((event, key) => /* @__PURE__ */ jsx(MilestoneCard, __spreadValues({ milestone: event, showRules: true }, featuredData && (featuredData == null ? void 0 : featuredData.length) > 0 && key === 0 ? {
      className: "col-start-1"
    } : {}), `event_${event.id}`))
  ] }) });
};
const HistoryPage = ({
  data,
  isLoading
}) => {
  const {
    amplitudeEvent
  } = useContext(Context);
  const isEmptyState = !isLoading && (data == null ? void 0 : data.length) === 0;
  return /* @__PURE__ */ jsx("div", { className: "gap-6 flex flex-col", children: /* @__PURE__ */ jsx(Milestone, { isEmptyState, title: "History", subtitle: "See all the Karma you’ve claimed and missed", isLoading, rightAction: data && data.length > 4 && /* @__PURE__ */ jsx(ViewAllButton, { onClick: () => {
    amplitudeEvent("karma-history-load");
  }, href: "/karma/history", children: "View all" }), children: isEmptyState ? /* @__PURE__ */ jsx(EmptyHistory, {}) : data == null ? void 0 : data.filter((_, key) => key < 4).map((history) => {
    return /* @__PURE__ */ jsx(HistoryCard, { history }, `history_${history.id}`);
  }) }) });
};
const MilestonesSnackbars = ({
  isError,
  isSuccess,
  points,
  onClose
}) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isError && /* @__PURE__ */ jsx(Snackbar2, { onClose, isOpen: true, content: /* @__PURE__ */ jsxs("div", { className: "flex-1 max-w-full", children: [
      /* @__PURE__ */ jsx("p", { className: "m-0 leading-normal mr-2 font-medium text-white", children: "Woops" }),
      /* @__PURE__ */ jsx("p", { className: "m-0 leading-normal font-normal text-white", children: "It seems there was an internal error" })
    ] }) }),
    isSuccess && /* @__PURE__ */ jsx(Snackbar2, { onClose, isOpen: true, content: /* @__PURE__ */ jsx("div", { className: "flex-1 max-w-full", children: /* @__PURE__ */ jsxs("p", { className: "m-0 leading-normal font-normal text-white flex gap-1.5 justify-center items-center", children: [
      "Claimed ",
      points,
      " Karma"
    ] }) }) })
  ] });
};
const COOKIE_KEY$1 = "karmalearnMoreHideButton";
const ShowLearnMoreBlock = () => {
  const {
    amplitudeEvent
  } = useContext(Context);
  return /* @__PURE__ */ jsx(LearnMoreBlock, { cookieKey: COOKIE_KEY$1, modalContent: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("h2", { className: "learn-more-modal-title", children: "How we calculate Staking Activity" }),
    /* @__PURE__ */ jsx("p", { children: "By staking on CoinList, you can earn 0.05 Karma on your average staking balance in USD up to 250 Karma." }),
    /* @__PURE__ */ jsx("p", { children: "Your average staking balance is the sum of your staking balance at the end of each day divided by the number of days in the Event." }),
    /* @__PURE__ */ jsx("p", { children: "If you stake 5,000 USD worth on day 1 and maintain that balance through day 7, your average staking balance will be 5,000. Earning you 250 Karma." })
  ] }), title: "Earn Karma for Staking", text: "We updated how Karma from staking is calculated", learnMoreText: "Learn more", onClick: () => amplitudeEvent("karma-learnmore") });
};
const defaultImage = "https://cdn.coinlist.co/karma/rust.png";
const SidebarTier = ({
  dataTiers,
  user,
  onClick,
  isDashboard
}) => {
  var _a;
  const containerRef = useRef(null);
  const userTierId = useRef(user.tier_id);
  const [changeTier, setChangeTier] = useState(false);
  const tierColor = getColor({
    tierColor: user.tier_color
  });
  const handleHover = useCallback(() => {
    var _a2, _b;
    (_a2 = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _a2.style.setProperty("box-shadow", `0px 0px 12px 0px ${tierColor}`);
    (_b = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _b.style.setProperty("border", `2px solid ${hexToRGB(tierColor, "0.2")}`);
    if (containerRef == null ? void 0 : containerRef.current) {
      containerRef.current.classList.remove("border-gray-200");
    }
  }, [tierColor]);
  const handleBlur2 = useCallback(() => {
    var _a2;
    (_a2 = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _a2.style.setProperty("box-shadow", `unset`);
    if (containerRef == null ? void 0 : containerRef.current) {
      containerRef.current.classList.add("border-gray-200");
    }
  }, []);
  useEffect(() => {
    var _a2, _b, _c, _d, _e, _f;
    if (user.tier_id !== userTierId.current) {
      userTierId.current = user.tier_id;
      setChangeTier(true);
      const rect = (_a2 = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _a2.getBoundingClientRect();
      if (rect) {
        (_b = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _b.style.setProperty("--hover-background", hexToRGB(tierColor, "0.2"));
        (_c = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _c.style.setProperty("--x", "-38px");
        (_d = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _d.style.setProperty("--y", "-38px");
        handleHover();
        (_e = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _e.style.setProperty("--x", `${rect.width + 40}px`);
        (_f = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _f.style.setProperty("--y", "50px");
        setTimeout(() => {
          var _a3;
          setChangeTier(false);
          (_a3 = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _a3.style.setProperty("box-shadow", `unset`);
        }, 1e3);
      }
    }
  }, [user.tier_id, tierColor, handleHover]);
  const userTier = getUserTier({
    user,
    tiers: dataTiers || []
  });
  const handleMouseMove = (e2) => {
    var _a2, _b, _c, _d;
    const rect = (_a2 = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _a2.getBoundingClientRect();
    if (!changeTier && rect) {
      (_b = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _b.style.setProperty("--hover-background", hexToRGB(tierColor, "0.2"));
      const x2 = e2.clientX - rect.left;
      const y = e2.clientY - rect.top;
      (_c = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _c.style.setProperty("--x", x2 + "px");
      (_d = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _d.style.setProperty("--y", y + "px");
    }
  };
  if (!(userTier == null ? void 0 : userTier.images) || ((_a = userTier == null ? void 0 : userTier.images) == null ? void 0 : _a.length) === 0) {
    return null;
  }
  const tierPosition = dataTiers.findIndex((tier2) => {
    return tier2.id === user.tier_id;
  });
  const tier = dataTiers.find((tier2) => {
    return tier2.id === user.tier_id;
  });
  return /* @__PURE__ */ jsx(CardContainer, { rightCol: onClick && /* @__PURE__ */ jsx(RightChevron, {}), ref: containerRef, onMouseMove: handleMouseMove, onClick: () => {
    onClick == null ? void 0 : onClick();
  }, onMouseEnter: () => {
    handleHover();
  }, onMouseLeave: () => {
    handleBlur2();
  }, className: `animate-button ${changeTier ? "animate-tier" : ""}`, children: /* @__PURE__ */ jsxs("div", { className: "flex gap-4 w-full", children: [
    /* @__PURE__ */ jsx("button", { className: "relative overflow-hidden", children: /* @__PURE__ */ jsx("img", { src: getTierImage({
      userTier
    }) || defaultImage, className: "w-16 h-16" }) }),
    dataTiers && /* @__PURE__ */ jsx(CardHeader, { title: user.tier_description, text: isDashboard ? `${user.karma_points} Karma` : getTierText({
      dataTiers,
      position: tierPosition,
      tier
    }) })
  ] }) });
};
const TierColors = ({
  user,
  dataTiers
}) => {
  if (!dataTiers) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: "flex px-3 gap-1.5 items-center", children: dataTiers.map((tier, key) => {
    const tierImage = getTierImage({
      userTier: tier
    });
    const {
      fromColor,
      toColor
    } = get3dColor({
      tierColor: tier.color
    });
    const isSelected = user.tier_id === tier.id;
    return /* @__PURE__ */ jsx("div", { className: `flex ${isSelected ? "h-4" : "h-3"} relative`, style: {
      width: `${getPercentile({
        tier,
        position: key,
        dataTiers
      })}%`
    }, children: /* @__PURE__ */ jsx(Popper2, { content: /* @__PURE__ */ jsxs("div", { className: "flex gap-2.5", children: [
      /* @__PURE__ */ jsx("img", { src: tierImage, className: "w-10 h-10" }),
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ jsx("label", { className: "text-sm", children: tier.name }),
        /* @__PURE__ */ jsx("label", { className: "text-xs opacity-50", children: getTierText({
          tier,
          position: key,
          dataTiers
        }) })
      ] })
    ] }), className: "w-full", popperStyle: "mt-1", children: /* @__PURE__ */ jsx("div", { className: `h-full rounded-full w-full  ${isSelected ? "" : "opacity-30"} `, style: {
      background: `linear-gradient(0deg, ${fromColor} 0%, ${toColor} 100%)`
    } }) }) }, `tier_${tier.id}`);
  }) });
};
const TiersModalContent = ({
  onClose,
  isOpen,
  dataTiers,
  user
}) => {
  const getTierText2 = ({
    user: user2,
    dataTiers: dataTiers2
  }) => {
    const tierPosition = dataTiers2.findIndex((tier) => {
      return tier.id === user2.tier_id;
    });
    if (tierPosition === dataTiers2.length - 1) {
      return `${Math.round((1 - user2.tier_percentile) * 100)}%`;
    }
    return `${Math.round((dataTiers2[tierPosition + 1].percentile - user2.tier_percentile) * 100)}%`;
  };
  const fromColorModal = hexToRGB(getSpecificColor({
    tierColor: user.tier_color
  }), "0.7");
  const userTier = getUserTier({
    user,
    tiers: dataTiers
  });
  const tokenImage = getTierImage({
    userTier
  });
  const getTweetImage = () => {
    switch (user.tier_name.toLowerCase()) {
      case "rust":
        return "https://pic.twitter.com/r13OPfjJH0";
      case "bronze":
        return "https://pic.twitter.com/aoYHuySFOt";
      case "silver":
        return "https://pic.twitter.com/aEt5Y4eqbT";
      case "gold":
        return "https://pic.twitter.com/UWx3zcKlgU";
      case "platinum":
        return "https://pic.twitter.com/yw29j3ZRzx";
      default:
        return "https://pic.twitter.com/r13OPfjJH0";
    }
  };
  return /* @__PURE__ */ jsxs(Modal2, { showCloseIcon: true, onClose, isOpen, style: {
    backgroundImage: `linear-gradient(to bottom, ${fromColorModal} 1%, #fff, #fff 98%)`,
    maxHeight: 720
  }, children: [
    /* @__PURE__ */ jsxs("div", { className: "gap-7 flex flex-col pb-5", children: [
      /* @__PURE__ */ jsx("div", { className: "flex flex-col justify-center items-center relative", children: /* @__PURE__ */ jsx("div", { className: "flex justify-center items-center", children: /* @__PURE__ */ jsx("img", { className: "w-60 h-60 mt-10", src: tokenImage }) }) }),
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1.5", children: [
        /* @__PURE__ */ jsx("p", { className: "text-center m-auto font-extrabold text-3xl", children: user.tier_description }),
        /* @__PURE__ */ jsxs("p", { className: "text-center m-auto text-xl opacity-50", children: [
          user.tier_percentile === 1 || user.tier_percentile === 0 ? "You are in the" : "You are with",
          user.tier_percentile === 1 ? ` top ${getTierText2({
            dataTiers,
            user
          })} ` : user.tier_percentile === 0 ? ` bottom ${getTierText2({
            dataTiers,
            user
          })} ` : ` ${getTierText2({
            dataTiers,
            user
          })} `,
          "of earners"
        ] })
      ] }),
      /* @__PURE__ */ jsx(TierColors, { dataTiers, user }),
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col sm:flex-row gap-8 bg-offWhite rounded-2xl px-6 py-8", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ jsx(Point, {}),
          /* @__PURE__ */ jsx("p", { className: "opacity-50 text-sm", children: "Your Tier is determined by your Karma Score compared to other earners." })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ jsx(Graphic, {}),
          /* @__PURE__ */ jsxs("p", { className: "opacity-50 text-sm", children: [
            "Your chances of getting into Token Sales increase the higher your Tier.",
            /* @__PURE__ */ jsx("a", { target: "_blank", href: "https://coinlist.co/help/what-are-tiers", className: `ml-1 gap-1 text-left items-center underline inline-flex`, children: "Learn more" })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "bg-white sticky bottom-0 py-5", children: /* @__PURE__ */ jsxs(CardButton, { onClick: () => {
      window.open(`https://twitter.com/intent/tweet?text=I’m in the ${user.tier_description} with ${user.karma_points} Karma on %40CoinList %23tierUP&url=https%3A%2F%2Fcoinlist.co%2Fkarma ${getTweetImage()}`, "shareWindow", "width=900,height=600");
    }, className: "flex justify-center items-center gap-1", children: [
      /* @__PURE__ */ jsx(Twitter, {}),
      "Share"
    ] }) })
  ] });
};
const RightCol = ({
  user
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    apiUrl,
    amplitudeEvent
  } = useContext(Context);
  const {
    data: dataTiers
  } = useQuery({
    queryFn: () => getTiers(apiUrl),
    queryKey: `tiers`
  });
  const amplitudeData = {
    "current-karma-point": user == null ? void 0 : user.karma_points,
    "current-tier": user == null ? void 0 : user.tier
  };
  return /* @__PURE__ */ jsxs("div", { className: "text-black sticky top-12 gap-4 flex flex-col", children: [
    user && dataTiers && /* @__PURE__ */ jsx(TiersModalContent, { dataTiers, user, isOpen, onClose: () => {
      setIsOpen(false);
    } }),
    user ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(SidebarProgress, { onClick: () => {
        setIsOpen(true);
        amplitudeEvent("karma-tiercard", amplitudeData);
      }, user, dataTiers }),
      dataTiers && /* @__PURE__ */ jsx(SidebarTier, { onClick: () => {
        setIsOpen(true);
        amplitudeEvent("karma-tiercard", amplitudeData);
      }, dataTiers, user })
    ] }) : /* @__PURE__ */ jsx(SidebarProgressEmpty, {}),
    /* @__PURE__ */ jsx(ShowLearnMoreBlock, {})
  ] });
};
const Home = ({
  entityId = "",
  apiUrl = "",
  csrfToken,
  amplitudeEvent
}) => {
  const [snackbar, setSnackbar] = useState({});
  const [isRefetched, setIsRefetched] = useState(false);
  const {
    data: dataFeaturedMilestones,
    isLoading: isLoadingFeaturedMilestones,
    refetch: refetchFeaturedMilestones
  } = useQuery({
    queryFn: () => getFeaturedMilestone(entityId, apiUrl),
    isEnabled: !!entityId,
    queryKey: `featured_event_${entityId}`
  });
  const {
    data: dataEvent,
    isLoading: isLoadingEvents,
    refetch: refetchEvents
  } = useQuery({
    queryFn: () => getEvents(entityId, apiUrl),
    isEnabled: !!entityId,
    queryKey: `event_${entityId}`
  });
  const {
    data: dataAchievement,
    isLoading: isLoadingAchievements,
    refetch: refetchAchievements
  } = useQuery({
    queryFn: () => getAchievements(entityId, apiUrl),
    isEnabled: !!entityId,
    queryKey: `achievement_${entityId}`
  });
  const {
    data: dataHistory,
    isLoading: isLoadingHistory,
    refetch: refetchHistory
  } = useQuery({
    queryFn: () => getHistory(entityId, apiUrl, 5),
    isEnabled: !!entityId,
    queryKey: `history_${entityId}`
  });
  const {
    data: dataUser,
    isLoading: isLoadingUser,
    refetch: refetchUser
  } = useQuery({
    queryFn: () => getUser(entityId, apiUrl),
    isEnabled: !!entityId,
    queryKey: `user_${entityId}`
  });
  const handleUpdateKarma = ({
    type,
    points
  }) => {
    setSnackbar({
      type,
      points
    });
    if (type === "success") {
      setIsRefetched(true);
      refetchUser();
      setTimeout(() => {
        refetchHistory();
        refetchAchievements();
        refetchEvents();
        refetchFeaturedMilestones();
      }, 700);
    }
  };
  return /* @__PURE__ */ jsxs(Context.Provider, { value: {
    entityId,
    apiUrl,
    csrfToken,
    refreshKarma: handleUpdateKarma,
    isRefetched,
    amplitudeEvent
  }, children: [
    snackbar.type && /* @__PURE__ */ jsx(MilestonesSnackbars, { onClose: () => setSnackbar({}), isError: snackbar.type === "error", isSuccess: snackbar.type === "success", points: snackbar.points }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col-reverse xl:flex-row gap-12 max-w-7xl m-auto", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-24 flex-1", children: [
        (dataEvent || dataAchievement || dataFeaturedMilestones) && /* @__PURE__ */ jsx(ClaimSection, { data: [...dataEvent ? dataEvent.filter((event) => event.status === "claimable") : [], ...dataAchievement ? dataAchievement.filter((achievement) => achievement.status === "claimable") : []], isLoading: isLoadingFeaturedMilestones && !dataFeaturedMilestones, featuredData: dataFeaturedMilestones && (dataFeaturedMilestones == null ? void 0 : dataFeaturedMilestones.filter((event) => event.status === "claimable")) }),
        /* @__PURE__ */ jsx(Events, { data: dataEvent && (dataEvent == null ? void 0 : dataEvent.filter((event) => event.status !== "claimable")), isLoading: isLoadingEvents && !dataEvent, featuredData: dataFeaturedMilestones && (dataFeaturedMilestones == null ? void 0 : dataFeaturedMilestones.filter((event) => event.status !== "claimable")) }),
        /* @__PURE__ */ jsx(Achievements, { data: dataAchievement && (dataAchievement == null ? void 0 : dataAchievement.filter((achievement) => achievement.status !== "claimable")), isLoading: isLoadingAchievements && !dataAchievement }),
        /* @__PURE__ */ jsx(HistoryPage, { data: dataHistory, isLoading: isLoadingHistory })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "xl:w-1/4 xl:max-w-xs", children: dataUser ? /* @__PURE__ */ jsx(RightCol, { user: dataUser }) : isLoadingUser ? /* @__PURE__ */ jsxs("div", { className: "gap-4 flex flex-col", children: [
        /* @__PURE__ */ jsx(Skeleton, { className: "h-[200px]" }),
        /* @__PURE__ */ jsx(Skeleton, { className: "h-[100px]" })
      ] }) : /* @__PURE__ */ jsx(RightCol, {}) })
    ] })
  ] });
};
const Sidebar = ({
  entityId = "",
  apiUrl = "",
  amplitudeEvent
}) => {
  const {
    data: dataTiers,
    isLoading
  } = useQuery({
    queryFn: () => getTiers(apiUrl),
    queryKey: `tiers`
  });
  const {
    data: dataUser
  } = useQuery({
    queryFn: () => getUser(entityId, apiUrl),
    isEnabled: !!entityId,
    queryKey: `user_${entityId}`
  });
  if (isLoading) {
    return /* @__PURE__ */ jsx(Skeleton, { className: "h-[109px]" });
  }
  return /* @__PURE__ */ jsx(Context.Provider, { value: {
    entityId,
    apiUrl,
    amplitudeEvent
  }, children: dataUser && dataTiers && dataUser.karma_points > 0 ? /* @__PURE__ */ jsx(SidebarTier, { onClick: () => {
    amplitudeEvent("dash-karma");
    window.location.href = "/karma";
  }, dataTiers, user: dataUser, isDashboard: true }) : !isLoading && /* @__PURE__ */ jsx(CardContainer$1, { onClick: () => {
    amplitudeEvent("dash-karma");
    window.location.href = "/karma";
  }, rightCol: /* @__PURE__ */ jsx(RightChevron, {}), children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-4", children: [
    /* @__PURE__ */ jsx("img", { src: "https://cdn.coinlist.co/home/claim-your-tier-icon.png", className: "h-[73px]" }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ jsx(Title, { fontSize: "xxs", children: "Claim your Karma Tier" }),
      /* @__PURE__ */ jsx(Subitle, { fontSize: "xs", children: "Increase your chance of joining the next Token Launch" })
    ] })
  ] }) }) });
};
const Consent = ({
  handleOnClick,
  locale
}) => {
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-8 max-w-lg m-auto", children: [
    /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-5", children: /* @__PURE__ */ jsxs(Container, { children: [
      /* @__PURE__ */ jsx(Title, { children: /* @__PURE__ */ jsx(Trans, { id: "+yVK40" }) }),
      /* @__PURE__ */ jsx(Subitle, { children: /* @__PURE__ */ jsx(Trans, { id: "+G7dyH" }) })
    ] }) }),
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("ul", { className: "gap-6 flex flex-col", children: [
      /* @__PURE__ */ jsxs("li", { className: "text-black/[.5] flex items-center gap-3", children: [
        /* @__PURE__ */ jsx(Check, { className: "w-[14px] min-w-[14px] fill-black/[.5]" }),
        /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx(Trans, { id: "Su17Hs", components: {
          0: /* @__PURE__ */ jsx("a", { target: "_blank", className: "text-black underline", href: "/terms" }),
          1: /* @__PURE__ */ jsx("a", { target: "_blank", className: "text-black underline", href: "/privacy" })
        } }) })
      ] }),
      /* @__PURE__ */ jsxs("li", { className: "text-black/[.5] flex items-center gap-3", children: [
        /* @__PURE__ */ jsx(Check, { className: "w-[14px] min-w-[14px] fill-black/[.5]" }),
        /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx(Trans, { id: "6DJL5w", components: {
          0: /* @__PURE__ */ jsx("a", { target: "_blank", className: "text-black underline", href: "/help/what-is-a-foreign-financial-institution" }),
          1: /* @__PURE__ */ jsx("a", { target: "_blank", className: "text-black underline", href: "/help/what-is-a-foreign-shell-bank" })
        } }) })
      ] }),
      /* @__PURE__ */ jsxs("li", { className: "text-black/[.5] flex items-center gap-3", children: [
        /* @__PURE__ */ jsx(Check, { className: "w-[14px] min-w-[14px] fill-black/[.5]" }),
        /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx(Trans, { id: "jcBGHt", components: {
          0: /* @__PURE__ */ jsx("a", { target: "_blank", className: "text-black underline", href: "/help/what-is-a-private-banking-account" })
        } }) })
      ] }),
      /* @__PURE__ */ jsxs("li", { className: "text-black/[.5] flex items-center gap-3", children: [
        /* @__PURE__ */ jsx(Check, { className: "w-[14px] min-w-[14px] fill-black/[.5]" }),
        /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx(Trans, { id: "Ip9uRS", components: {
          0: /* @__PURE__ */ jsx("a", { className: "text-black underline", target: "_blank", href: "http://www.fatf-gafi.org/publications/fatfrecommendations/documents/peps-r12-r22.html" })
        } }) })
      ] }),
      /* @__PURE__ */ jsxs("li", { className: "text-black/[.5] flex items-center gap-3", children: [
        /* @__PURE__ */ jsx(Check, { className: "w-[14px] min-w-[14px] fill-black/[.5]" }),
        /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx(Trans, { id: "bTmKqi" }) })
      ] })
    ] }) }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-5", children: [
      /* @__PURE__ */ jsx(Button, { isDark: true, onClick: handleOnClick, children: /* @__PURE__ */ jsx(Trans, { id: "rI7mWy" }) }),
      /* @__PURE__ */ jsx(Button, { onClick: () => window.location.href = "/logout", className: "text-black/[.5] font-normal", children: /* @__PURE__ */ jsx(Trans, { id: "S56gjX" }) })
    ] })
  ] }) });
};
const Reverification = ({
  locale,
  handleOnClick,
  canViewWallet
}) => {
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-8 max-w-lg m-auto", children: [
    /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-5", children: /* @__PURE__ */ jsxs(Container, { children: [
      /* @__PURE__ */ jsx(Title, { children: /* @__PURE__ */ jsx(Trans, { id: "VWStic" }) }),
      /* @__PURE__ */ jsx(Subitle, { children: canViewWallet ? /* @__PURE__ */ jsx(Trans, { id: "X79s1a" }) : /* @__PURE__ */ jsx(Trans, { id: "AunxeR" }) })
    ] }) }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-5", children: [
      /* @__PURE__ */ jsx(Button, { isDark: true, onClick: handleOnClick, children: /* @__PURE__ */ jsx(Trans, { id: "tXkhj/" }) }),
      canViewWallet && /* @__PURE__ */ jsx(Button, { onClick: () => window.location.href = "/wallets", className: "text-black/[.5] font-normal", children: /* @__PURE__ */ jsx(Trans, { id: "TZsuwl" }) })
    ] })
  ] }) });
};
const SumSubStatus = ({
  status,
  locale,
  canViewWallet,
  country
}) => {
  const getVerifiedRedirectUrl = () => {
    const referralSource = api.get("referral_source");
    if (referralSource === "alpha") {
      api.remove("referral_source");
      return "https://alpha.coinlist.co";
    }
    return country === "US" ? "/accreditation" : "/";
  };
  const data = {
    verified: {
      action: /* @__PURE__ */ jsx(Button, { isDark: true, onClick: () => {
        window.location.href = getVerifiedRedirectUrl();
      }, children: /* @__PURE__ */ jsx(Trans, { id: "xGVfLh" }) }),
      icon: /* @__PURE__ */ jsx(SumSubVerified, {}),
      title: /* @__PURE__ */ jsx(Trans, { id: "eMvjNv" }),
      text: /* @__PURE__ */ jsx(Trans, { id: "Ubswu3" }),
      subText: null
    },
    pending: {
      action: canViewWallet ? /* @__PURE__ */ jsx(Button, { className: `bg-smokeWhite`, onClick: () => {
        window.location.href = "/wallets";
      }, children: /* @__PURE__ */ jsx(Trans, { id: "oarJCB" }) }) : null,
      icon: /* @__PURE__ */ jsx(SumSubPending, {}),
      title: /* @__PURE__ */ jsx(Trans, { id: "nass+x" }),
      text: canViewWallet ? /* @__PURE__ */ jsx(Trans, { id: "3Iqf7D" }) : /* @__PURE__ */ jsx(Trans, { id: "Hq8OI1" }),
      subText: null
    },
    error: {
      action: canViewWallet ? /* @__PURE__ */ jsx(Button, { className: `bg-smokeWhite`, onClick: () => {
        window.location.href = "/wallets";
      }, children: /* @__PURE__ */ jsx(Trans, { id: "oarJCB" }) }) : null,
      icon: /* @__PURE__ */ jsx(SumSubFail, {}),
      title: /* @__PURE__ */ jsx(Trans, { id: "qt4J8t" }),
      text: canViewWallet ? /* @__PURE__ */ jsx(Trans, { id: "7TVyuz" }) : /* @__PURE__ */ jsx(Trans, { id: "8vxXyH", components: {
        0: /* @__PURE__ */ jsx("a", { className: "underline", href: "https://coinlist.co/help/verify-your-identity" })
      } }),
      subText: null
    },
    unSupportedRegion: {
      action: canViewWallet ? /* @__PURE__ */ jsx(Button, { className: `bg-smokeWhite`, onClick: () => {
        window.location.href = "/wallets";
      }, children: /* @__PURE__ */ jsx(Trans, { id: "oarJCB" }) }) : null,
      icon: /* @__PURE__ */ jsx(SumSubFail, { fill: "rgba(245, 158, 11, 1)" }),
      title: /* @__PURE__ */ jsx(Trans, { id: "dCdZS6" }),
      text: canViewWallet ? /* @__PURE__ */ jsx(Trans, { id: "48SoOT", components: {
        0: /* @__PURE__ */ jsx("a", { className: "underline", href: "https://coinlist.co/legal#location" })
      } }) : /* @__PURE__ */ jsx(Trans, { id: "kwH6Rr", components: {
        0: /* @__PURE__ */ jsx("a", { className: "underline", href: "https://coinlist.co/legal#location" })
      } }),
      subText: null
    },
    offBoarded: {
      action: canViewWallet ? /* @__PURE__ */ jsx(Button, { className: `bg-smokeWhite`, onClick: () => {
        window.location.href = "/wallets";
      }, children: /* @__PURE__ */ jsx(Trans, { id: "oarJCB" }) }) : null,
      icon: /* @__PURE__ */ jsx(SumSubFail, { fill: "rgba(245, 158, 11, 1)" }),
      title: /* @__PURE__ */ jsx(Trans, { id: "Xarf4G" }),
      text: canViewWallet ? /* @__PURE__ */ jsx(Trans, { id: "2A9Wbg" }) : /* @__PURE__ */ jsx(Trans, { id: "WXVVKP" }),
      subText: null
    }
  };
  const {
    icon,
    title,
    text,
    action,
    subText
  } = data[status];
  return /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-6 text-center items-center", children: [
    icon,
    /* @__PURE__ */ jsx("h1", { className: "text-4xl font-semibold", children: title }),
    /* @__PURE__ */ jsx("p", { className: "text-xl text-black/[.5]", children: text }),
    action,
    subText && /* @__PURE__ */ jsx("p", { className: "text-black/[.5]", children: subText })
  ] }) });
};
const sumsubSchema = z.object({
  accessToken: z.string().optional(),
  entityId: z.string(),
  country: z.string().optional(),
  // this is optional for the sumsub sdk but required for the status component
  locale: z.string(),
  email: z.string(),
  initialStatus: z.enum(["error", "pending", "verified", "unSupportedRegion", "offBoarded", "showSumsubIframe", "reverification"]).optional(),
  canViewWallet: z.string().optional()
});
const COOKIE_KEY = "showConsent";
const COOKIE_KEY_REVERIFICATION = "reverification_cookie";
const SumSub = (props) => {
  const {
    accessToken,
    locale = "en",
    email,
    country = "",
    initialStatus: initialStatusValue,
    canViewWallet
  } = props;
  const isReverification = initialStatusValue === "reverification";
  const initialStatus = initialStatusValue === "showSumsubIframe" || isReverification ? void 0 : initialStatusValue;
  const customStatus = initialStatus !== void 0 && initialStatusValue !== "showSumsubIframe" && !isReverification || !accessToken;
  const timeout2 = useRef();
  const isInit = useRef(false);
  const [screen, setScreen] = useState(!api.get(COOKIE_KEY) && !customStatus ? "consent" : "sumsub");
  const [status, setStatus] = useState(initialStatus);
  useEffect(() => {
    if (screen === "sumsub" && (status === "unSupportedRegion" || status === "offBoarded")) {
      setScreen("status");
    }
    if (isReverification && (!api.get(COOKIE_KEY_REVERIFICATION) || api.get(COOKIE_KEY_REVERIFICATION) === "true")) {
      api.set(COOKIE_KEY_REVERIFICATION, "true");
      setScreen("reverification");
    }
  }, [screen]);
  useComponentValidation({
    props,
    schema: sumsubSchema
  });
  const AcceptConsent = () => {
    setScreen("sumsub");
    api.set(COOKIE_KEY, "true");
  };
  const AcceptReverification = () => {
    setScreen("sumsub");
    api.set(COOKIE_KEY_REVERIFICATION, "false");
  };
  if (screen === "consent") {
    return /* @__PURE__ */ jsx(Consent, { locale, handleOnClick: AcceptConsent });
  }
  if (screen === "reverification") {
    return /* @__PURE__ */ jsx(Reverification, { locale, handleOnClick: AcceptReverification, canViewWallet });
  }
  if (customStatus) {
    return /* @__PURE__ */ jsx("div", { className: "w-full sm:w-[525px] m-auto", children: /* @__PURE__ */ jsx(SumSubStatus, { locale, status: initialStatus || "error", canViewWallet, country }) });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    status && /* @__PURE__ */ jsx("div", { className: "w-full sm:w-[525px] m-auto", children: /* @__PURE__ */ jsx(SumSubStatus, { locale, status, canViewWallet, country }) }),
    /* @__PURE__ */ jsx("div", { className: `App ${screen !== "sumsub" ? "hidden" : ""}`, children: /* @__PURE__ */ jsx(SumsubWebSdk, { accessToken, expirationHandler: () => Promise.resolve(accessToken), config: {
      lang: locale,
      email
    }, onMessage: (data, payload) => {
      var _a, _b, _c;
      if (["idCheck.onApplicantStatusChanged", "idCheck.onStepInitiated"].includes(data)) {
        if (timeout2.current) {
          clearTimeout(timeout2.current);
        }
      }
      if (data === "idCheck.onApplicantStatusChanged") {
        if ((payload == null ? void 0 : payload.reviewStatus) === "completed" && ((_a = payload == null ? void 0 : payload.reviewResult) == null ? void 0 : _a.reviewAnswer) === "RED" && ((_b = payload == null ? void 0 : payload.reviewResult) == null ? void 0 : _b.reviewRejectType) !== "RETRY") {
          setStatus("error");
          setScreen("status");
        } else if ((payload == null ? void 0 : payload.reviewStatus) === "completed" && ((_c = payload == null ? void 0 : payload.reviewResult) == null ? void 0 : _c.reviewAnswer) === "GREEN") {
          if (isInit.current) {
            timeout2.current = setTimeout(() => {
              setStatus("verified");
              setScreen("status");
            }, 4e3);
          } else {
            setStatus("verified");
            setScreen("status");
          }
        } else if ((payload == null ? void 0 : payload.reviewStatus) === "pending" || (payload == null ? void 0 : payload.reviewStatus) === "onHold") {
          if (isInit.current) {
            timeout2.current = setTimeout(() => {
              setStatus("pending");
              setScreen("status");
            }, 8e3);
          } else {
            setStatus("pending");
            setScreen("status");
          }
        }
      } else if (data === "idCheck.onStepInitiated") {
        setScreen("sumsub");
        setStatus(void 0);
      } else if (data === "idCheck.onInitialized") {
        isInit.current = true;
      }
    } }) }),
    canViewWallet && /* @__PURE__ */ jsx("div", { className: "flex flex-col items-center gap-5 m-auto mt-5", children: /* @__PURE__ */ jsx(TranslationContext, { locale, children: /* @__PURE__ */ jsx(Button, { onClick: () => window.location.href = "/wallets", className: "text-black/[.5] font-normal inline-flex w-max px-12 py-2", children: /* @__PURE__ */ jsx(Trans, { id: "EncOi3" }) }) }) })
  ] });
};
const createEntity = (_0) => __async(void 0, [_0], function* ({
  kind,
  csrfToken
}) {
  const data = {
    kind
  };
  const response = yield fetch(!window.isStorybook ? "/user/create_entity" : "http://localhost:8081/test", {
    method: "POST",
    cache: "no-cache",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken
    },
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const returnData = yield response.json();
  const responseCurrentEntity = yield fetch(!window.isStorybook ? "/user/set_application_current_entity" : "http://localhost:8081/test", {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken
    },
    body: JSON.stringify({
      entity: returnData.entity_id
    })
  });
  if (!responseCurrentEntity.ok) {
    throw new Error("Failed to fetch data");
  }
  return returnData;
});
z.object({
  csrfToken: z.string(),
  locale: z.string(),
  kind: z.enum(["person", "company"]).optional().optional()
});
const CreateEntity = ({
  locale,
  csrfToken,
  kind = "person"
}) => {
  const [showError, setShowError] = useState(false);
  const {
    mutate,
    isLoading
  } = useMutation({
    queryFn: () => createEntity({
      kind,
      csrfToken
    }),
    onSuccess: (data) => {
      window.location.href = `/kyc/organization/${data.entity_id}`;
    },
    onError: () => {
      setShowError(true);
    }
  });
  return /* @__PURE__ */ jsxs(TranslationContext, { locale, children: [
    /* @__PURE__ */ jsx(Snackbar2, { isOpen: showError, onClose: () => setShowError(false), content: i18n._(
      /*i18n*/
      {
        id: "qsWho/"
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-8 max-w-lg m-auto", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ jsx(Title, { children: /* @__PURE__ */ jsx(Trans, { id: "5K91US" }) }),
        /* @__PURE__ */ jsx("p", { className: "text-black/[.5] text-xl", children: /* @__PURE__ */ jsx(Trans, { id: "QBkNUx" }) })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-5", children: [
        /* @__PURE__ */ jsx(Button, { isLoading, isDark: true, onClick: () => !isLoading && mutate(), children: /* @__PURE__ */ jsx(Trans, { id: "xGVfLh" }) }),
        /* @__PURE__ */ jsx(Button, { onClick: () => window.location.href = "/dashboard", className: "text-black/[.5] font-normal", children: /* @__PURE__ */ jsx(Trans, { id: "tS8BaO" }) })
      ] })
    ] })
  ] });
};
export {
  Accreditation,
  AccreditationStatus,
  Alert,
  AlertList,
  AnimatedButton,
  Button,
  CardContainer$1 as CardContainer,
  CreateEntity,
  DashboardBlock,
  Section as DashboardSection,
  DistributionSection as Distribution,
  Featured,
  FeaturedEmpty,
  FeaturedList,
  ForgotPasswordParent as ForgotPassword,
  Container as Heading,
  index$1 as Icons,
  Dashboard as KarmaDashboard,
  HistoryLogs as KarmaHistoryLog,
  Home as KarmaHome,
  Sidebar as KarmaSidebar,
  LanguageSelector,
  LearnMoreBlock,
  LoginParent as Login,
  MfaParent as LoginMfa,
  HeaderMenu as Menu,
  Mfa,
  Modal2 as Modal,
  PasswordInput,
  Popper2 as Popper,
  PortfolioValue,
  RegisterParent as Register,
  ResetPasswordParent as ResetPassword,
  Snackbar2 as Snackbar,
  StartAccreditation,
  Stepper,
  Subitle as Subtitle,
  SumSub,
  SumSubStatus,
  Title,
  VerifyEmail
};
//# sourceMappingURL=index.es.js.map
